// Slovak translations — UI shell. Falls back to Czech for content (calculator/series details).
const sk = {
  /* Zájemci, prohlídky a předání financím
     (pages/RealityZajemciPage.js + pages/ProhlidkaPrihlaskaPage.js).
     Klíče `ver*` mluví na ZÁJEMCE — bez odborných slov, krátké věty.
     Zbytek mluví na makléře. Znění samotných souhlasů tu NENÍ: chodí ze
     serveru (backend/lib/reality_souhlas.py), protože se ukládá jeho otisk
     a ten musí sedět s tím, co člověk doopravdy viděl. */
  realZaj: {
    nadpis: "Záujemcovia a obhliadky",
    nacitam: "Načítavam…",
    chyba: "Nepodarilo sa to. Skúste to prosím znova.",
    terminy: "Termíny obhliadok",
    terminyPopis: "Vypíšte jeden termín a pošlite odkaz. Záujemcovia sa prihlásia sami.",
    vypsatTermin: "Vypísať termín",
    termin: "Termín",
    delka: "Minút",
    kapacita: "Koľko ľudí",
    ulozit: "Uložiť",
    zadneTerminy: "Zatiaľ ste nevypísali žiadny termín.",
    volno: "Voľné {n} z {z}",
    neplatny: "Odkaz už neplatí",
    vDiari: "V diári",
    kopirovat: "Kopírovať odkaz",
    zkopirovano: "Skopírované",
    zneplatnit: "Zneplatniť",
    zajemci: "Záujemcovia",
    pridatZajemce: "Pridať záujemcu",
    rozesilka: "Ďalšie ponuky môže dostať {n} z {z} záujemcov.",
    jmeno: "Meno",
    telefon: "Telefón",
    email: "E-mail",
    rucneBezSouhlasu: "Ručne zapísaný záujemca nemá súhlas — ten dá len sám na prihláške.",
    nikdoTu: "Tu zatiaľ nikto nie je.",
    bezJmena: "Bez mena",
    stav: "Krok",
    financovani: "Financovanie",
    okamzik: "Kedy odovzdať",
    predatPoradci: "Odovzdať poradcovi",
    predanoPoradci: "Odovzdané poradcovi",
    bezSouhlasuNejde: "Bez súhlasu záujemcu to nejde. Pošlite mu odkaz na prihlášku, kde si o to povie sám.",
    odvolat: "Odvolať súhlas",
    smazatPotvrzeni: "Zmazať záujemcu aj jeho údaje? Odovzdania zostanú, ale bez osobných údajov.",
    souhlasPoradci: "Súhlas s poradcom",
    souhlasAno: "Súhlas s ponukami",
    souhlasNe: "Bez súhlasu",
    souhlasNezeptano: "Neopýtané",
    souhlasOdvolan: "Súhlas odvolaný",
    souhlasImport: "Zo starej databázy",
    predani: "Odovzdanie financiám",
    zadnePredavky: "Zatiaľ ste nikoho neodovzdali.",
    odmenaNenastavena: "Odmena nenastavená",
    odmenaVysvetleni: "Kým nie je vybrané, z čoho sa podiel počíta, systém sumu nedopočíta.",
    zpetNaNemovitost: "Späť na nehnuteľnosť",
    smlouvaZalozit: "Rezervačná zmluva",
    smlouvaOtevrit: "Otvoriť rezervačnú zmluvu",
    smlouvaPodepsana: "Rezervačná zmluva podpísaná",
    fin: {
      neptal_jsem_se: "Neopýtal som sa",
      hotovost: "Hotovosť",
      hypoteka: "Hypotéka",
      nevim: "Nevie",
    },
    predavkaStav: {
      navrzena: "Čaká na poradcu",
      odeslana: "Odoslané",
      prijata: "Poradca prevzal",
      odmitnuta: "Poradca odmietol",
      propadla: "Prepadlo",
    },
    verNadpis: "Prihláška na obhliadku",
    verNacitam: "Načítavam…",
    verNeplatnyNadpis: "Odkaz neplatí",
    verNeplatny: "Termín už neplatí alebo je preč. Ozvite sa prosím maklérovi.",
    verJazyk: "Jazyk",
    verJmeno: "Meno a priezvisko",
    verTelefon: "Telefón",
    verEmail: "E-mail",
    verPlno: "Tento termín je už plný. Ozvite sa maklérovi.",
    verOdeslat: "Prihlásiť sa na obhliadku",
    verOdesilam: "Odosielam…",
    verPovinne: "Bez prvého zaškrtnutia prihlášku uložiť nemôžeme.",
    verChybiKontakt: "Nechajte prosím telefón alebo e-mail, nech sa vám máme ako ozvať.",
    verChyba: "Nepodarilo sa to odoslať. Skúste to prosím znova.",
    verHotovo: "Máte to.",
    verHotovoPoradce: "Ozve sa vám aj hypotekárny špecialista.",
  },
  /* Kalkulačka na veřejné stránce nemovitosti
     (components/nemovitost/KalkulackaNemovitosti.js). Mluví na KLIENTA,
     ne na poradce — krátké věty, žádný odborný slovník. */
  nemKalk: {
    otazka: "Kupujete pre seba, alebo ako investíciu?",
    proSebe: "Pre seba",
    jakoInvestici: "Ako investíciu",
    vlastni: "Vlastné zdroje",
    sazba: "Úroková sadzba",
    splatnost: "Splatnosť",
    najem: "Očakávaný mesačný nájom",
    splatkaPopis: "mesačná splátka",
    vetaSplatka: "Pri {podil} vlastných potrebujete {vlastni} a splátka bude {splatka} mesačne.",
    hruby: "Hrubý výnos",
    cisty: "Čistý výnos",
    cashflow: "Mesačný cashflow",
    vetaMinus: "Nájom nepokryje splátku ani náklady — každý mesiac doplatíte {castka}.",
    vetaPlus: "Po splátke a nákladoch vám z nájmu každý mesiac zostane {castka}.",
    vetaNajem: "Zadajte očakávaný nájom — bez neho sa výnos vypočítať nedá.",
    predpoklady: "Počítané s prevádzkovými nákladmi {naklady} mesačne, obsadenosťou {mesicu} z 12 mesiacov a s daňou z nájmu 15 % zo 70 % príjmu.",
    orientacni: "Orientačný prepočet, nie ponuka ani záruka. Skutočnú sadzbu určí banka podľa vašej bonity.",
    zaM2: "{cena} za m²",
    rokOne: "{n} rok",
    rokFew: "{n} roky",
    rokMany: "{n} rokov",
  },
  /* Realitni zakazky (/zakazky). Klice musi byt ve VSECH peti slovnicich —
     t() na chybejicim klici tise vrati klic a na obrazovce sviti `zakazky.nazev`.
     Hlida to frontend/src/__tests__/klicVeSlovniku.test.js. */
  poptavka: {
    prohlidka: 'Obhliadka',
    dorazil: 'prišiel',
    nedorazil: 'neprišiel',
    teplotaVlazno: 'Stojí dlho — ozvi sa kupujúcemu',
    teplotaHorko: 'Stojí príliš dlho — kupujúci sa neozýva',
    stitek: 'Dopyt na nákup',
    zpetNaPipeline: 'Späť na realitnú pipeline',
    otevritObchod: 'História prípadu',
    otevritKlienta: 'Zložka klienta',
    followUp: 'Follow-up',
    nenalezena: 'Tento dopyt neexistuje alebo nie je tvoj.',
    faze0: 'Ozval sa',
    faze1: 'Obhliadka dohodnutá',
    faze2: 'Bol na obhliadke',
    faze3: 'Vážny záujem',
    faze4: 'Rezervácia',
    faze5: 'Kúpna zmluva',
    faze6: 'Odovzdanie',
    ukol0: 'Zavolať a zistiť, čo presne hľadá a z čoho to zaplatí.',
    ukol1: 'Potvrdiť termín a poslať adresu.',
    ukol2: 'Spýtať sa na financovanie a ozvať sa do troch dní.',
    ukol3: 'Skôr než pôjde rezervácia, nech financovanie niekto rieši.',
    ukol4: 'Spísať rezervačnú zmluvu k vybranej nehnuteľnosti.',
    ukol5: 'Odovzdať podklady advokátovi a strážiť termíny.',
    ukol6: 'Odovzdať kľúče a uzavrieť prípad.',
    akce0: 'Ponúknuť nehnuteľnosť',
    akce1: 'Potvrdiť termín obhliadky',
    akce2: 'Zapísať, z čoho to zaplatí',
    akce3: 'Zariadiť hypotéku',
    akce4: 'Spísať rezervačnú zmluvu',
    akce5: 'Poslať zmluvu advokátovi',
    akce6: 'Odovzdať kľúče',
    coHleda: 'Čo hľadá',
    doptatSe: 'Ešte sa spýtať na:',
    typ: 'Druh nehnuteľnosti',
    typNevybrano: 'Neurčené',
    lokalita: 'Lokalita',
    lokalitaPlaceholder: 'Bratislava-Staré Mesto, do 20 minút od centra…',
    rozpocet: 'Najviac chce dať',
    dispozice: 'Dispozícia',
    dispoziceAtypicke: 'Atypické',
    nabidnoutPoradce: 'Hypotéku bude pravdepodobne potrebovať — dohodni mu poradcu skôr, než príde na rezerváciu.',
    nabidky: 'Čo sme mu ponúkli',
    nabidnuto: 'Ponúknuté: {n}',
    zadneNabidky: 'Zatiaľ sme mu nič neponúkli.',
    coJesteMuzeme: 'Čo mu ešte môžeme ponúknuť',
    zadneDoporucene: 'Všetky tvoje nehnuteľnosti už pozná.',
    nabidnout: 'Ponúknuť',
    stahnout: 'Stiahnuť',
    nemovitostPryc: 'Nehnuteľnosť už nie je v systéme',
    nabidkaStazena: 'Ponuka stiahnutá.',
    ulozeno: 'Uložené.',
    chybaUlozeni: 'Uložiť sa to nepodarilo.',
    chybaFaze: 'Fázu sa nepodarilo posunúť.',
    chybaNabidky: 'S ponukou sa niečo nepodarilo.',
    chybaSeznamu: 'Dopyty na nákup sa nepodarilo načítať.',
  },
  zakazky: {
    novaPoptavka: 'Nový kupujúci',
    filtrProdej: 'Predaj',
    filtrNakup: 'Nákup',
    nabidnutoKupujicim: 'Ponúknuté kupujúcim',
    otevritPoptavku: 'Otvoriť dopyt',
    poptavkaPryc: 'Dopyt už neexistuje',
    neaktivni: 'Predaj zastavený',
    tymUlozit: 'Uložiť tím',
    neulozeno: 'Neuložené',
    tymZavolat: 'Zavolať',
    osaOdkaz: 'Odkaz pre záujemcov',
    historieVse: 'Zobraziť celú históriu',
    historieMene: 'Zobraziť len posledné',
    /* Realitni pipeline (/reality) + prokliky z karty. */
    /* Souhrnne dlazdice nad realitni pipeline (vzor: hypotecni pipeline). */
    bezNemovitosti: "K tomuto obchodu nie je naviazaná žiadna nehnuteľnosť. Adresu, záujemcov ani inzerát preto nemá odkiaľ vziať — založ nehnuteľnosť v realitnom prehľade.",
    souhrnProdej: "V predaji",
    souhrnProdejSub: "celkový objem {v}",
    souhrnNakup: "Kupujúci",
    souhrnNakupSub: "hľadajú nehnuteľnosť",
    souhrnStoji: "Stojí dlho",
    souhrnStojiSub: "ozvi sa skôr, než sa ozvú oni",
    souhrnHotovo: "Dokončené",
    souhrnHotovoSub: "odovzdané a uzavreté",
    souhrnNic: "—",
    pipelineNazev: 'Realitná pipeline',
    pipelinePodnadpis: 'Kde stojí každá nehnuteľnosť a ako dlho už tam stojí',
    pipelineSeznam: 'Zoznam a nová zákazka',
    pipelineOtevrit: 'Otvoriť pipeline',
    prodatNechat: 'Predať, alebo nechať?',
    prodatNechatSub: 'Orientačný prepočet pre majiteľa — predať teraz, alebo prenajímať',
    sloupecNemovitost: 'Nehnuteľnosť',
    sloupecFaze: 'Fáza',
    sloupecStani: 'Vo fáze',
    sloupecDalsiKrok: 'Ďalší krok',
    sloupecCena: 'Cena',
    denOne: '{n} deň',
    denFew: '{n} dni',
    denMany: '{n} dní',
    teplotaVlazno: 'Stojí dlho — ozvi sa majiteľovi',
    teplotaHorko: 'Stojí príliš dlho — majiteľ nevie, čo sa deje',
    filtrVse: 'Všetko',
    filtrStoji: 'Stojí dlho',
    stojiPocet: 'Stojí dlho: {n}',
    coTed: 'Čo teraz urobiť',
    akce0: 'Vyžiadať od majiteľa podklady',
    akce1: 'Dohodnúť fotografa',
    akce2: 'Zverejniť inzerciu',
    akce3: 'Vypísať termín obhliadky',
    akce4: 'Spísať rezervačnú zmluvu',
    akce5: 'Odovzdať zmluvu advokátovi',
    akce6: 'Odovzdať kupujúceho poradcovi',
    zajemci: 'Záujemcovia a obhliadky',
    smlouvy: 'Rezervačná zmluva',
    tym: 'Kto na tom robí',
    tymSub: 'Fotograf, poradca, advokát. Nech vieš, komu volať, keď sa to zasekne.',
    tymPrazdno: 'Zatiaľ nikto.',
    tymPridat: 'Pridať človeka',
    tymRole: 'Rola',
    tymJmeno: 'Meno',
    tymTelefon: 'Telefón',
    tymOdebrat: 'Odobrať',
    tymUlozeno: 'Tím uložený',
    tymBezObchodu: 'Tím sa ukladá k obchodu a ten tejto zákazke chýba.',
    roleMakler: 'Maklér',
    roleFotograf: 'Fotograf',
    rolePoradce: 'Finančný poradca',
    roleAdvokat: 'Advokát',
    roleJine: 'Iná rola',
    osa: 'Časová os',
    osaSub: 'Kedy fotenie, kedy inzercia, kedy ktoré obhliadky. Toto odpovedá majiteľovi na otázku, čo sa deje.',
    osaHotovo: 'Hotovo',
    osaNestalo: 'Zatiaľ sa nestalo',
    osaUlozit: 'Uložiť os',
    osaProhlidky: 'Obhliadky',
    osaProhlidkyPrazdno: 'Zatiaľ nie je vypísaný žiadny termín.',
    osaPrihlaseno: 'prihlásené',
    osaVypsat: 'Vypísať obhliadku',
    mkPriprava: 'Príprava a fotenie',
    mkInzerce: 'Inzercia na portáloch',
    mkSite: 'Sociálne siete',
    mkPlacenaReklama: 'Platená reklama',
    mkPr: 'Offline PR',
    historie: 'Čo komu odišlo',
    historieSub: 'Zápisy z obchodu — e-maily majiteľovi, posuny fáz, tvoje poznámky.',
    historiePrazdno: 'Zatiaľ nič.',
    historiePridat: 'Zapísať hovor alebo správu',
    historieUlozit: 'Zapísať',
    historieZapsano: 'Zapísané do obchodu',
    nazev: 'Zákazky',
    podnadpis: 'Nehnuteľnosti, ktoré predávaš, a kde v procese sú',
    nova: 'Nová zákazka',
    nacitam: 'Načítavam…',
    chyba: 'Nepodarilo sa načítať zákazky.',
    zadne: 'Zatiaľ žiadna zákazka',
    zadneSub: 'Založ prvú nehnuteľnosť — adresa, majiteľ, cena. Zvyšok doplníš za pochodu.',
    hledat: 'Hľadať adresu alebo majiteľa',
    typ: 'Typ nehnuteľnosti',
    typByt: 'Byt',
    typDum: 'Dom',
    typPozemek: 'Pozemok',
    typKomercni: 'Komerčný',
    vlastnictvi: 'Vlastníctvo',
    vlastnictviOsobni: 'Osobné',
    vlastnictviDruzstevni: 'Družstevné',
    vlastnictviHint: 'Družstevné bývanie má iný vzor rezervačnej zmluvy.',
    adresa: 'Adresa',
    adresaHint: 'Ulica, súpisné číslo a mesto. Toto potom čerpá zmluva aj inzerát.',
    majitel: 'Majiteľ',
    vyberMajitele: 'Vyber majiteľa z kontaktov',
    majitelHint: 'Predávajúci. Musí byť v kontaktoch — zákazka sa naňho viaže.',
    cenaNabidkova: 'Ponuková cena',
    cenaOdhad: 'Trhový odhad',
    cenaHint: 'Prázdne pole znamená nenacenené, nie nula.',
    lvCislo: 'Číslo listu vlastníctva',
    katUzemi: 'Katastrálne územie',
    podepsano: 'Sprostredkovateľská podpísaná',
    exkluzivitaDo: 'Exkluzivita do',
    exkluzivitaHint: 'So spotrebiteľom najviac 6 mesiacov (§ 17 z. 39/2020).',
    provizePct: 'Provízia (%)',
    stitek: 'Energetický štítok',
    stitekMa: 'Má ho',
    stitekChybi: 'Chýba',
    stitekObjednano: 'Objednaný',
    poznamka: 'Poznámka',
    nezadano: 'Nezadané',
    zalozit: 'Založiť zákazku',
    zrusit: 'Zrušiť',
    ulozit: 'Uložiť',
    ulozeno: 'Uložené',
    krok: 'Krok',
    dalsiKrok: 'Ďalší krok',
    hotovoKrok: 'Hotovo, ďalší krok',
    zpetKrok: 'O krok späť',
    dokonceno: 'Zákazka dokončená',
    hotovoStav: 'hotovo',
    cekaStav: 'čaká',
    tedStav: 'teraz',
    bezObchodu: 'Táto zákazka nemá obchod, takže sa fáza nemá kam zapísať. Založ ju znovu.',
    kdeJsme: 'Kde v procese sme',
    faze0: 'Nábor',
    faze1: 'Príprava',
    faze2: 'Inzercia',
    faze3: 'Obhliadky',
    faze4: 'Rezervácia',
    faze5: 'Kúpna zmluva',
    faze6: 'Odovzdanie',
    ukol0: 'Podpísať sprostredkovateľskú zmluvu, skontrolovať kataster a vyžiadať si od majiteľa podklady.',
    ukol1: 'Dohodnúť fotografa, pripraviť pôdorys a home staging, zariadiť energetický štítok.',
    ukol2: 'Zverejniť ponuku na portáloch a sieťach. Odkazy si ulož k zákazke.',
    ukol3: 'Dohadovať obhliadky, pýtať sa na spôsob financovania a zapisovať záujemcov.',
    ukol4: 'Spísať rezervačnú zmluvu, vybrať blokačný poplatok a poslať ju advokátovi.',
    ukol5: 'Advokát pripravuje kúpnu zmluvu. Sleduj fázu a priebežne informuj majiteľa.',
    ukol6: 'Zapísať stavy meradiel, podpísať odovzdávací protokol a prepísať zmluvy na nového vlastníka.',
    komunikace: 'Čo pošleme majiteľovi',
    komunikaceSub: 'Text zloží systém. Odoslať ho môžeš odtiaľto, alebo si ho skopíruj a pošli po svojom.',
    podklady: 'Vyžiadať podklady',
    podkladySub: 'Jeden odkaz, v ktorom majiteľ vyplní údaje z občianskeho preukazu, e-mail a telefón. Fotku dokladu od neho nechceme.',
    uvitani: 'Privítanie a plán',
    uvitaniSub: 'Majiteľ hneď prvý deň vie, čo sa bude diať — fotenie, inzercia, siete, platená reklama, PR.',
    nahled: 'Náhľad správy',
    kopirovat: 'Skopírovať text',
    zkopirovano: 'Skopírované',
    vEmailu: 'Otvoriť v e-maile',
    odeslatJmenem: 'Odoslať mojím menom',
    odesilam: 'Odosielam…',
    odeslanoNa: 'Odoslané na',
    neodeslano: 'Neodoslané — nemáš pripojený e-mail. Text si skopíruj a pošli po svojom.',
    bezEmailu: 'Majiteľ nemá v kontakte e-mail. Doplň ho a skús to znovu.',
    odkazProMajitele: 'Odkaz pre majiteľa',
    platiDo: 'Platí do',
    udaje: 'Údaje o zákazke',
    zpetNaSeznam: 'Späť na zákazky',
    smazat: 'Zmazať zákazku',
    smazatPotvrd: 'Zmazať zákazku? Obchod s históriou rokovaní zostane.',
    smazano: 'Zákazka zmazaná',
    nenalezena: 'Zákazka nenájdená.',
  },
  /* Tri odkazy pro klienty (web nemovitosti /n/:slug, stav prodeje pro
     majitele /z/:token, podklady /f/:token) + obe verejne stranky. */
  nemWeb: {
    sekce: 'Odkazy pre klientov',
    sekceSub: 'Tri stránky, ktoré si klient otvorí bez prihlásenia. Vyrobíš ich jedným kliknutím.',
    nenacetlo: 'Odkazy sa nepodarilo načítať. Skús obnoviť stránku.',
    webNazev: 'Web nehnuteľnosti',
    webSub: 'Fotky, popis a prepočet pre kupujúcich. Adresu sa dá nadiktovať do telefónu.',
    majitelNazev: 'Stav predaja pre majiteľa',
    majitelSub: 'Súkromná stránka, kde majiteľ vidí, čo sa deje. Píše sa sama z toho, čo odklikáš.',
    podkladyNazev: 'Podklady od majiteľa',
    podkladyZnovu: 'Ukázať znova',
    zatimNevyrobeno: 'Zatiaľ nevyrobené',
    vyrobit: 'Vyrobiť odkaz',
    vyrobeno: 'Vyrobené',
    otevrit: 'Otvoriť',
    kopirovat: 'Skopírovať odkaz',
    odeslatMajiteli: 'Poslať majiteľovi',
    odeslano: 'Odoslané',
    zatimNeodeslano: 'Zatiaľ neodoslané',
    zverejneno: 'Zverejnené',
    jenProTebe: 'Zatiaľ len pre teba',
    zverejnit: 'Zverejniť',
    skryt: 'Skryť',
    platny: 'Platný',
    propadly: 'Prepadnutý',
    obnovit: 'Vyrobiť nový',
    obnovitPotvrd: 'Vyrobiť nový odkaz? Ten starý prestane platiť a majiteľovi sa stránka z e-mailu už neotvorí.',
    fotky: 'Fotky',
    fotkyPrazdno: 'Zatiaľ žiadna fotka.',
    fotkyPridat: 'Pridať fotky',
    fotkyOdebrat: 'Odobrať',
    fotkyOdmitnuto: 'Nenahralo sa:',
    dotaznikNadpis: 'Krátky dotazník',
    dotaznikSub: 'Odpovedz krátko na osem otázok. Systém z nich zloží nadpis aj popis — a ty ho potom môžeš prepísať.',
    oDispozice: 'Dispozícia',
    oDispoziceHint: 'napr. 3+1, 2+kk, garsónka',
    oPlochaM2: 'Plocha (m²)',
    oPlochaM2Hint: 'napr. 78',
    oPatro: 'Poschodie',
    oPatroHint: 'napr. 2. poschodie z 5, výťah',
    oStav: 'Stav',
    oStavHint: 'napr. po rekonštrukcii 2023 / pôvodný, na nasťahovanie',
    oNejlepsi: 'Čo je na tom najlepšie?',
    oNejlepsiHint: 'napr. veľký balkón s výhľadom do parku',
    oProKoho: 'Pre koho sa to hodí?',
    oProKohoHint: 'napr. rodina s jedným až dvoma deťmi',
    oOkoli: 'Čo je v okolí?',
    oOkoliHint: 'napr. škôlka 200 m, električka, park',
    oProcProdava: 'Prečo majiteľ predáva?',
    oProcProdavaHint: 'napr. sťahujú sa za prácou',
    oProcProdavaVarovani: 'Píše sa to do inzerátu. Citlivý dôvod (rozvod, dlhy) sem nepíš — zráža cenu a je to údaj o majiteľovi, nie o nehnuteľnosti.',
    slozit: 'Zložiť text z odpovedí',
    slozeno: 'Text zložil systém',
    slozenoRucne: 'Text si písal(a) ty',
    slozitPotvrd: 'Prepísať text, ktorý si písal(a) ručne? Zloží sa znovu z odpovedí.',
    chybi: 'V texte chýba — doplň a zlož znovu:',
    nadpisPole: 'Nadpis inzerátu',
    lokalita: 'Lokalita',
    fotkyPoradi: 'Prvá fotka je hlavná. Presuň ju na začiatok, alebo použi Dať ako hlavnú.',
    fotkyHlavni: 'Hlavná',
    fotkyDatHlavni: 'Dať ako hlavnú',
    cena: 'Cena',
    najem: 'Nájom v okolí',
    najemHint: 'Nájom sa ukazuje len v prepočte pre kupujúceho. Keď ho nepoznáš, nechaj pole prázdne.',
    popis: 'Popis nehnuteľnosti',
    ulozitText: 'Uložiť text inzerátu',
    nacitam: 'Načítavam…',
    neplatny: 'Táto ponuka nie je dostupná. Požiadajte makléra o nový odkaz.',
    neplatnyMajitel: 'Táto stránka nie je dostupná. Požiadajte makléra o nový odkaz.',
    propocet: 'Čo to znamená mesačne',
    zajemNadpis: 'Chcem na obhliadku',
    zajemSub: 'Nechajte kontakt a maklér sa vám ozve s termínom.',
    zajemHotovo: 'Ďakujeme, maklér sa vám ozve.',
    zajemOdeslat: 'Odoslať',
    odesilam: 'Odosielam…',
    jmeno: 'Meno',
    telefon: 'Telefón',
    email: 'E-mail',
    vzkaz: 'Odkaz (nepovinné)',
    chybiJmeno: 'Napíšte prosím meno.',
    chybiKontakt: 'Nechajte prosím telefón alebo e-mail, aby sme sa vám mali ako ozvať.',
    chybaOdeslani: 'Odoslanie sa nepodarilo. Skúste to prosím znova.',
    kontaktNadpis: 'Ponuku vedie',
    zavrit: 'Zavrieť',
    majitelNadpis: 'Predaj vašej nehnuteľnosti',
    majitelPata: 'Stránka sa aktualizuje sama. Pozrite sa, kedykoľvek budete chcieť.',
    zatimNic: 'Zatiaľ tu nie je čo ukázať. Len čo sa niečo stane, uvidíte to tu.',
    veFazi: 'v tejto fáze',
    zajemceOne: 'záujemca',
    zajemceFew: 'záujemcovia',
    zajemceMany: 'záujemcov',
    prohlidkaOne: 'uskutočnená obhliadka',
    prohlidkaFew: 'uskutočnené obhliadky',
    prohlidkaMany: 'uskutočnených obhliadok',
    prohlidkyChystane: 'chystané:',
    prohlidkyNadpis: 'Obhliadky',
    prohlidkaChysta: 'chystá sa',
    krokyNadpis: 'Čo pre predaj robíme',
    krokChysta: 'chystá sa',
    tymNadpis: 'Kto sa o predaj stará',
    inzeratOtevrit: 'Otvoriť inzerát',
    inzeratPopis: 'Takto nehnuteľnosť vidia záujemcovia',
  },
  webui: {
    bookNow: "Rezervovať",
    bookFree: "Dohodnúť stretnutie zadarmo",
    bookMeeting: "Dohodnúť stretnutie",
    advisorRole: "Váš finančný sprostredkovateľ",
    freeSlots: "Voľné termíny tento týždeň",
    downloadFree: "Stiahnuť zadarmo",
    services: "Služby",
    scroll: "scroll",
    readyToTalk: "Pripravený sa porozprávať?",
    firstMeetingFree: "Prvé stretnutie je zadarmo · 30 minút online",
    webNotFound: "Web sa nenašiel alebo nie je zverejnený.",
    loadingError: "Chyba načítania",
    backHome: "Späť na beplan University",
    retry: "Skúsiť znova",
    webLoadFailed: "Web sa teraz nepodarilo načítať. Skontrolujte pripojenie a skúste to znova.",
    lmEmailLabel: "E-mail",
    bookingMeta: "Online cez Google Meet · Zadarmo a nezáväzne · Trvá zhruba 30 minút",
    bookingHint: "Prvé stretnutie zadarmo. Stačí vybrať termín a pripraviť si otázky.",
    bookSlotBtn: "Rezervovať termín",
    // ovládacie prvky (a11y)
    musicPlay: "Pustiť hudbu",
    musicMute: "Stlmiť hudbu",
    themeToDark: "Prepnúť na tmavý",
    themeToLight: "Prepnúť na svetlý",
    playIntroVideo: "Pustiť intro video",
    whatsappWrite: "Napísať cez WhatsApp",
    // sekcie
    servicesHeading: "S čím ti viem pomôcť",
    aboutEyebrow: "O mne",
    dayEyebrow: "Deň so mnou",
    dayHeading: "Takto vyzerá môj deň",
    testimonialsEyebrow: "Referencie",
    testimonialsHeading: "Čo hovoria klienti",
    testimonialItem: "Referencia",
    testimonialPrev: "Predchádzajúca referencia",
    testimonialNext: "Ďalšia referencia",
    quoteOpen: "„",
    quoteClose: "“",
    bookingEyebrow: "Rezervácia",
    bookingHeading: "Vyber si termín stretnutia",
    bookingInactive: "Online rezervácia zatiaľ nie je aktívna. Kontaktuj poradcu priamo:",
    faqHeading: "Najčastejšie otázky",
    partnersLabel: "Spolupracujem s",
    finalCtaHeading: "Poďme sa porozprávať",
    writeEmail: "Napísať e-mail",
    // pätička
    digitalCard: "Digitálna vizitka",
    privacy: "Súkromie",
    madeIn: "Vytvorené v beplan University",
    // galéria / príbehy klientov (a11y)
    prev: "Predchádzajúci",
    next: "Ďalší",
    close: "Zavrieť",
    storyPrev: "Predchádzajúci príbeh",
    storyNext: "Ďalší príbeh",
    storyItem: "Príbeh",
    // proces (horizontálna sekcia)
    processEyebrow: "Ako spolupráca prebieha",
    processHeadingSuffix: "k jasným financiám",
    processScrollHint: "Skroluj nadol – karty plynú doprava",
    processNextStep: "Ďalší krok",
    stepOne: "krok",
    stepFew: "kroky",
    stepMany: "krokov",
    // predvolené kroky procesu (poradca si ich môže prepísať v nastaveniach webu)
    step1Title: "Prvý kontakt",
    step1Desc: "Stačí kliknúť na rezerváciu alebo zavolať. Povieme si, čo riešiš.",
    step2Title: "Analýza tvojej situácie",
    step2Desc: "Zadarmo ti zostavím prehľad – kde si, čo máš, čo ti chýba.",
    step3Title: "Návrh plánu",
    step3Desc: "Dostaneš konkrétne kroky na mieru – hypotéka, poistenie, investície.",
    step4Title: "Implementácia",
    step4Desc: "Vybavím za teba papiere, banky aj poisťovne. Ty sa venuješ svojej práci.",
    step5Title: "Ročný review",
    step5Desc: "Raz za rok spolu prejdeme, ako sa plánu darí a čo upraviť.",
    // príbehy klientov
    storiesEyebrow: "Príbehy klientov",
    storiesHeading: "Ako som im pomohol",
    storiesSubtitle: "Konkrétne situácie. Konkrétne riešenia. Konkrétne výsledky.",
    storyClient: "Klient",
    storyProblem: "Situácia",
    storySolution: "Čo sme urobili",
    storyResult: "Výsledok",
    storyCta: "Chcem podobný výsledok pre seba",
    // galéria
    galleryEyebrow: "Galéria",
    galleryHeading: "Zo zákulisia",
    galleryPhotoAlt: "Foto {n}",
    // blog
    blogEyebrow: "Blog",
    blogHeading: "Tipy a myšlienky",
    blogRead: "Čítať článok",
    blogLoading: "Načítavam…",
    blogLoadError: "Článok sa nepodarilo načítať.",
    // lead magnet (PDF za e-mail)
    lmBadge: "Stiahni zadarmo",
    lmInstant: "Okamžite na stiahnutie",
    lmNoSpam: "Žiadny spam",
    lmDone: "Hotovo",
    lmDoneDesc: "PDF je stiahnuté. Skontroluj si aj e-mail.",
    lmNamePh: "Tvoje meno (nepovinné)",
    lmEmailPh: "tvoj@email.sk",
    lmDownloading: "Sťahujem…",
    lmDownload: "Stiahnuť PDF zadarmo",
    lmPrivacy: "Tvoje údaje používam len na poslanie PDF. Nikdy nespamujem.",
    lmInvalidEmail: "Zadaj platný e-mail",
    lmSuccess: "PDF je stiahnuté + poslali sme ti ho na e-mail",
    lmError: "Nepodarilo sa stiahnuť",
    // kalkulačky — spoločné
    calcEyebrow: "Vypočítaj si nezáväzne",
    calcHeading: "Vyskúšaj moje kalkulačky",
    calcSubtitle: "Jednoduché, rýchle, bez registrácie. Získaj prvé odpovede za minútu.",
    calcCompare: "Porovnanie",
    calcBookCta: "Chcem to vypočítať presne na stretnutí",
    calcReset: "Skúsiť iné hodnoty",
    calcDisclaimer: "Orientačný výpočet. Presné čísla počítam na stretnutí – zadarmo a nezáväzne.",
    calcUnitBn: "mld",
    calcUnitM: "mil",
    calcUnitK: "tis",
    calcUnitYears: "rokov",
    calcUnitPa: "% p.a.",
    calcUnitCount: "",
    // kalkulačka: hypotéka
    calcHypoTitle: "Hypotekárna kalkulačka",
    calcHypoTagline: "Vypočítaj si mesačnú splátku",
    calcHypoHint: "Za 60 sekúnd vieš, koľko zaplatíš",
    calcHypoAmount: "Výška úveru",
    calcHypoRate: "Úroková sadzba",
    calcHypoYears: "Doba splácania",
    calcHypoSubmit: "Vypočítať mesačnú splátku",
    calcHypoResult: "Tvoja mesačná splátka bude",
    calcHypoSubtitle: "Celkovo za {years} {yearsUnit} zaplatíš {total}",
    calcHypoContext: "Orientačný výpočet pri rovnomernej anuite. Presný úrok sa líši podľa LTV, bonity a aktuálnych sadzieb.",
    calcHypoBank: "Priemerná banka ({rate} %)",
    calcHypoMine: "S mojou pomocou ({rate} %)",
    calcHypoSavings: "Úspora {amount}",
    // kalkulačka: investície
    calcInvestTitle: "Investície",
    calcInvestTagline: "Koľko zarobíš dlhodobo?",
    calcInvestHint: "Zložené úročenie ťa prekvapí",
    calcInvestMonthly: "Mesačne si odložím",
    calcInvestYears: "Investičný horizont",
    calcInvestRate: "Očakávané zhodnotenie",
    calcInvestSubmit: "Vypočítať budúcu hodnotu",
    calcInvestResult: "Za {years} {yearsUnit} budeš mať",
    calcInvestSubtitle: "Z toho tvoje vklady: {deposited}",
    calcInvestContext: "Výpočet počíta so stabilným priemerným zhodnotením – v skutočnosti sa bude líšiť rok od roka.",
    calcInvestBank: "Sporiaci účet v banke (2 %)",
    calcInvestInvested: "Investície ({rate} %)",
    calcInvestDelta: "O {amount} viac",
    // kalkulačka: životné poistenie
    calcLifeTitle: "Životné poistenie",
    calcLifeTagline: "Koľko krytia naozaj potrebuješ",
    calcLifeHint: "Bez preplácania zbytočností",
    calcLifeIncome: "Mesačný čistý príjem",
    calcLifeLoans: "Hypotéka + úvery spolu",
    calcLifeKids: "Počet detí",
    calcLifeSubmit: "Vypočítať potrebnú poistnú sumu",
    calcLifeResult: "Ty by si mal mať krytú poistnú sumu",
    calcLifeSubtitle: "V prípade úmrtia alebo trvalej invalidity",
    calcLifeContext: "Tvoja rodina by mala splatené záväzky ({loans}), deti by mali na vzdelanie ({kids}) a 10 rokov by prežila z úspor ({savings}). Väčšina ľudí má kryté 10× menej – platí za poistku, ktorá nič nezachráni.",
    // kalkulačka: finančná nezávislosť
    calcFiTitle: "Finančná nezávislosť",
    calcFiTagline: "Kedy už môžeš do dôchodku?",
    calcFiHint: "Pravidlo 4 % ti to ukáže",
    calcFiTarget: "Chcem mesačný pasívny príjem",
    calcFiCurrent: "Súčasné úspory / investície",
    calcFiYears: "Chcem to dosiahnuť za",
    calcFiRate: "Očakávané zhodnotenie",
    calcFiSubmit: "Vypočítať moju cestu k nezávislosti",
    calcFiResult: "Na finančnú nezávislosť potrebuješ nasporiť",
    calcFiSubtitle: "Stačí si mesačne dávať {monthly} po dobu {years} {yearsUnit}",
    calcFiSubtitleDone: "Gratulujem – tvoje súčasné úspory to už samy zvládnu za {years} {yearsUnit} 🎉",
    calcFiContext: "Pri pravidle 4 % ročného čerpania ti tento kapitál bude generovať {annual} ročne ({monthly} mesačne) prakticky navždy – bez toho, aby si uberal z istiny.",
  },
  webtpl: {
    universal: {
      headline: "Tvoje financie, pod kontrolou.",
      subheadline: "Pomáham klientom nastaviť financie tak, aby sa už nikdy nemuseli báť budúcnosti – hypotéky, investície, poistenie aj dôchodok.",
      s1Title: "Hypotéka", s1Desc: "Nájdem ti najvýhodnejšiu hypotéku zo všetkých bánk a prevediem ťa celým procesom.",
      s2Title: "Investície", s2Desc: "Zostavím portfólio šité na mieru tvojim cieľom a rizikovému profilu.",
      s3Title: "Poistenie", s3Desc: "Ochrana pre rodinu, majetok aj príjem. Bez zbytočných zmlúv.",
      s4Title: "Dôchodok", s4Desc: "Ukážem ti, koľko si musíš odkladať, aby si mal pohodlný dôchodok.",
    },
    family: {
      headline: "Financie pre rodinu, ktorá chce pokoj.",
      subheadline: "Starám sa o rodiny, aby mali jasno – čo je poistené, kam sporia deťom a ako si užiť dôchodok bez starostí.",
      s1Title: "Ochrana rodiny", s1Desc: "Životné a úrazové poistenia, ktoré naozaj chránia – nielen vyberajú peniaze.",
      s2Title: "Sporenie pre deti", s2Desc: "Ako začať – a koľko stačí – aby mali deti v 18 istotu.",
      s3Title: "Bývanie", s3Desc: "Hypotéka, poistenie nehnuteľnosti, refinancovanie.",
      s4Title: "Zdravie", s4Desc: "Súkromné zdravotné poistenie, ak chcete rýchlejšiu starostlivosť.",
    },
    mortgage: {
      headline: "Hypotéka bez stresu. Za teba urobím všetko.",
      subheadline: "13+ rokov skúseností. Porovnám ti ponuky zo všetkých bánk, vyjednám úrok a prevediem podaním žiadosti až k čerpaniu.",
      s1Title: "Nová hypotéka", s1Desc: "Od bytu po rodinný dom. Vybavím za teba papiere.",
      s2Title: "Refinancovanie", s2Desc: "Ušetri stovky mesačne presunom do banky s lepšími podmienkami.",
      s3Title: "Kalkulačka", s3Desc: "Vypočítame, koľko si môžeš požičať a za aký úrok.",
      s4Title: "Konzultácia zadarmo", s4Desc: "Prvé stretnutie nič nestojí – posúdime tvoju situáciu.",
    },
    corporate: {
      headline: "Firemné financie bez zbytočnej zložitosti.",
      subheadline: "Pomáham majiteľom firiem a manažérom štruktúrovať odmeny, benefity pre zamestnancov a vlastné investície.",
      s1Title: "Benefity pre zamestnancov", s1Desc: "Doplnkové dôchodkové sporenie, životné poistenie, stravné – daňovo efektívne.",
      s2Title: "Odmeňovanie majiteľa", s2Desc: "Optimálny mix mzda/dividenda/benefit pre majiteľa s.r.o.",
      s3Title: "Firemné investície", s3Desc: "Ako zhodnotiť voľné peniaze vo firme.",
      s4Title: "Poistenie zodpovednosti", s4Desc: "D&O, kybernetické poistenie, poistenie firemného majetku.",
    },
    investments: {
      headline: "Budovanie majetku. Dlhodobo. Disciplinovane.",
      subheadline: "Investičné portfólio postavené na dátach, nízkych nákladoch a tvojich cieľoch – nie na sľuboch o istých 20 % ročne.",
      s1Title: "Globálne portfólio", s1Desc: "Diverzifikácia naprieč trhmi, menami a triedami aktív.",
      s2Title: "Cieľové investovanie", s2Desc: "Byt, dôchodok, vzdelanie detí – pre každý cieľ vlastná stratégia.",
      s3Title: "Rebalansovanie", s3Desc: "Pravidelná údržba portfólia, aby pracovalo pre teba.",
      s4Title: "Finančný koučing", s4Desc: "Naučím ťa, ako o peniazoch premýšľať systematicky.",
    },
  },
  klienti: {
    srcDoporuceni: 'Odporúčanie',
    srcInzerat: 'Inzerát',
    srcJine: 'Iné',
    srcNabor: 'Nábor',
    srcNavolavka: 'Navolávka cez Beplan',
    srcTipar: 'Cez tipára',
    srcVlastni: 'Vlastný okruh',
    crm: "CRM",
    title: "Klienti",
    segmentace: "Segmentácia",
    segmDesc: "zlato, platina, bronz, štandard.",
    pipelineView: "Pipeline view",
    smartOnboarding: "Smart Onboarding",
    manual: "Pridať nového klienta",
    advanced: "Pokročilé",
    search: "Vyhľadaj klienta podľa mena, telefónu, e-mailu alebo mesta…",
    totalClients: "klientov celkom",
    active: "aktívnych",
    signedMonth: "podpísaných tento mesiac",
    pipelineFull: "Pipeline view (KPI, lievik, fázy)",
    noContact: "Bez kontaktu",
    fAll: "Všetko",
    fActive: "Aktívni",
    fStagnation: "Stagnácia 14+",
    fSigned: "Podpis tento mesiac",
    fNoContact: "Bez kontaktu 30+",
    fParked: "Bez záujmu",
    colClient: "Klient",
    colPhase: "Fáza",
    colDays: "Dní",
    colBj: "BJ",
    colAction: "AKCIA",
    loading: "Načítavam…",
    noClients: "Žiadni klienti",
    mNew: "Nový klient",
    mSmartAdd: "Duplicity strážim za pochodu — podľa mena, telefónu, e-mailu aj IČO.",
    mIdent: "Identifikácia",
    mName: "Meno *", mSurname: "Priezvisko", mPhone: "Telefón", mEmail: "Email",
    mCity: "Mesto", mAge: "Vek", mIco: "IČO (voliteľné)", mCompany: "Firma / SZČO",
    mCheckingDup: "Hľadám duplicity…",
    mSegSource: "Segmentácia a zdroj",
    mDisc: "DISC typológia (Pavel Procházka)",
    mRecruit: "Kandidát na nábor (do tímu poradcov)",
    mNotePh: "Kontext, kde ste sa stretli, kľúčové info…",
    mCancel: "Zrušiť",
  },
  obchody: {
    addDealToPhase: 'Pridať obchod do fázy',
    addToPhase: 'Pridať do fázy',
    awaitingPayout: 'čaká na výplatu',
    dealFew: 'obchody',
    dealMany: 'obchodov',
    dealOne: 'obchod',
    phaseOfTotal: 'Fáza {poradi} zo {celkem}',
    progressLeftRight: 'Postup obchodu zľava doprava',
    weighted: 'vážená',
    label: "Obchody",
    caseOne: "prípad", caseFew: "prípady", caseMany: "prípadov",
    boardPre: "Obchodná", boardEm: "nástenka",
    subtitle: "BJ v pipeline · farba karty = typ produktu · ťahaj kartou na Výhru/Prehru/Zrušené",
    newDeal: "Nový obchod",
    search: "Hľadať obchod, klienta…",
    fAll: "Všetko", fHypo: "Hypotéka", fLoans: "Úvery", fInsur: "Poistenie", fInv: "Investície", fPension: "Dôchodok",
    fReality: "Nehnuteľnosti",
    kanban: "Kanban", table: "Tabuľka",
    loading: "Načítavam obchody…",
    unknownClient: "Neznámy klient",
    stale: "bez aktivity", activeDeal: "aktívny",
    modalTitle: "Nový obchodný prípad", whatAbout: "Čoho sa to týka", clientFromCard: "Klient z karty",
    clientSearchPh: "Napíš meno klienta, telefón alebo e-mail…", productType: "Typ produktu *", provider: "Poskytovateľ",
    dealName: "Názov obchodu *", dealNamePh: "Zadaj názov obchodu", phase: "Fáza", estBj: "Odhad BJ", valueCur: "Hodnota",
    note: "Poznámka", cancel: "Zrušiť", create: "Vytvoriť obchod", selectClient: "Vyber klienta", cantCreate: "Nepodarilo sa vytvoriť obchod",
  },
  /* Realitni obchod ve slozce klienta (components/crm/RealityVeSlozce.js
     + realitni rezim v NewDealModal). Prodavajici a kupujici maji jiny obsah,
     proto jsou popisky oddelene od `zakazky`, ktere mluvi na kartu zakazky. */
  realSlozka: {
    kterouNemovitostVolitelne: 'Ktorú nehnuteľnosť (nepovinné)',
    zatimNevybrano: 'Zatiaľ nevybrané',
    otevritPoptavku: 'Otvoriť dopyt',
    prodejNem: "Predaj nehnuteľnosti",
    koupeNem: "Kúpa nehnuteľnosti",
    nadpisProdej: "Predáva",
    nadpisKoupe: "Kupuje",
    bezAdresy: "Bez adresy",
    cenaChybi: "cena nezadaná",
    veFaziNeznamo: "Vo fáze — nevieme odkedy",
    bezObchodu: "Táto zákazka nemá obchod, fáza sa nedá určiť.",
    koupeBezObchodu: "Bez obchodu — je tu len rezervačná zmluva.",
    zajemcu: "Záujemcovia",
    pristiProhlidka: "Najbližšia obhliadka",
    zadnaProhlidka: "Zatiaľ žiadny termín",
    prihlaseno: "prihlásených",
    majitelOdkaz: "Stránka pre majiteľa",
    majitelOdkazSub: "Sám sa pozrie, v akej sme fáze a čo pre predaj robíme.",
    majitelChybi: "Zatiaľ nevyrobená — vyrob ju na karte zákazky.",
    odkazPropadly: "prepadnutý",
    otevrit: "Otvoriť",
    kopirovat: "Skopírovať odkaz",
    zkopirovano: "Odkaz skopírovaný",
    nezkopirovano: "Skopírovať sa nepodarilo — vyber odkaz ručne.",
    otevritZakazku: "Otvoriť zákazku",
    otevritObchod: "Otvoriť obchod",
    zajemciAProhlidky: "Záujemcovia a obhliadky",
    inzeratOtevrit: "Otvoriť inzerát",
    inzeratSkryty: "Inzerát (zatiaľ len pre teba)",
    provize: "Provízia z predaja",
    provizeNenastavena: "nenastavená",
    postupZajemce: "Postup",
    rezervace: "Rezervačná zmluva",
    rezervacePodepsana: "Podpísaná",
    rezervaceRozepsana: "Rozpísaná, nepodpísaná",
    rezervaceZadna: "Zatiaľ žiadna",
    rezervaceSepsat: "Spísať rezervačnú zmluvu",
    rezervaceOtevrit: "Otvoriť rezervačnú zmluvu",
    hypoteka: "Hypotéka",
    hypotekaZadna: "Žiadny hypotekárny prípad",
    hypotekaZalozit: "Založiť hypotéku",
    nemovitostNeznama: "Nehnuteľnosť už v systéme nie je",
    predani: "Odovzdanie kontaktu",
    predaniSub: "Odovzdanie kontaktu inému správcovi je spracovanie osobných údajov. Vzniká len so súhlasom a zostáva tu zapísané.",
    predaniTy: "Ty",
    predaniNekdo: "Niekto z tímu",
    predaniPoradce: "Poradca",
    souhlasDan: "Súhlas daný",
    souhlasNeznamy: "Súhlas bez záznamu času",
    vzniklObchod: "Vznikol obchod",
    vzniklObchodJinde: "Poradca si prípad založil",
    vzniklObchodNe: "Obchod z toho zatiaľ nevznikol",
    odmena: "Podiel",
    odmenaNenastavena: "Odmena nenastavená — kým nevyberieš základ a sadzbu, nikto nevie, koľko to je.",
    chyba: "Realitnú časť sa nepodarilo načítať. Obchody nižšie sú v poriadku.",
    adresa: "Adresa nehnuteľnosti",
    adresaPlaceholder: "Adresa nehnuteľnosti — Hlavná 12, Košice",
    adresaChybi: "Napíš adresu nehnuteľnosti",
    typNemovitosti: "Druh nehnuteľnosti",
    cenaNabidkova: "Ponuková cena",
    kterouNemovitost: "Ktorú nehnuteľnosť",
    vyberNemovitost: "Vyber nehnuteľnosť",
    zadnaNemovitost: "Nemáš žiadnu zákazku",
    nacitamNemovitosti: "Načítavam…",
    nemovitostiChyba: "Nehnuteľnosti sa nenačítali",
    koupePrefix: "Kúpa —",
    koupeFaze0: "Ozval sa",
    koupeFaze1: "Obhliadka dohodnutá",
    koupeFaze2: "Bol na obhliadke",
    koupeFaze3: "Vážny záujem",
    koupeFaze4: "Rezervácia",
    koupeFaze5: "Kúpna zmluva",
    koupeFaze6: "Odovzdanie",
    predavkaStav: {
      navrzena: "Navrhnutá",
      odeslana: "Odoslaná",
      prijata: "Prijatá",
      odmitnuta: "Odmietnutá",
      propadla: "Prepadnutá",
    },
  },
  dealmeta: {
    board: {
      analyza: "Fin. analýza / Ponúknuté",
      proces: "Žiadosť / V procese",
      podpis: "Schválenie / Podpis",
      cerpani: "Čerpanie / Čakám na províziu",
    },
    products: {
      hypoteka: "Hypotéka", refinancovani: "Refinancovanie", podnikatelsky_uver: "Podnikateľský úver",
      spotrebitelsky_uver: "Spotrebný úver", uver: "Úver", pojisteni_zivot: "Životné", pojisteni_auta: "Auto",
      pojisteni_majetek: "Majetok", investice: "Investícia", penzijko: "Dôchodok", stavebni: "Stavebné", jine: "Iné",
      prodej_nemovitosti: "Predaj nehnuteľnosti", koupe_nemovitosti: "Kúpa nehnuteľnosti",
    },
  },
  /* BLOK:bilanceFlag START — generuje scratchpad/slovnik.py, ručně needitovat */
  bilanceFlag: {
    cfNegative: 'Výdavky a splátky prevyšujú príjmy o {castka}/mes',
    dstiHigh: 'Vysoká zadlženosť — splátky {pct} % príjmov (odporúčanie ČNB do {max} %)',
    dstiHighBezRegulatora: 'Vysoká zadlženosť — splátky {pct} % príjmov',
    kidsNoLife: 'Rodina s deťmi — over životné poistenie (krytie príjmu)',
    reserveLow: 'Likvidná rezerva len na {n} mes. — ideál 6× výdavkov',
    reserveMid: 'Rezerva na {n} mes. — doplniť do 6×',
    reserveOk: 'Rezerva na {n} mes. ✓',
  },
  /* BLOK:bilanceFlag END */
  bilancePanel: {
    title: "Živá bilancia",
    close: "Zavrieť",
    netWorth: "Čisté imanie",
    assets: "Majetok",
    debts: "Dlhy",
    zTohoFinNefin: "z toho finančný {fin} · nefinančný {nefin}",
    month: "Každý mesiac",
    income: "Príjmy",
    expenses: "Výdavky",
    repayments: "Splátky",
    free: "Voľné",
    deficit: "Schodok",
    notEntered: "nezadané",
    perMonth: "/mes",
    reserve: "Likvidná rezerva",
    reserveUnit: "× výdavkov",
    dsti: "Zadlženosť (DSTI)",
    /* Země bez závazného verdiktu DSTI (SK): jiná definice než NBS — AP-08, 19. 10. 2026. */
    dstiBezRegulatora: "Splátky / čistý príjem",
    savingRate: "Miera odkladania",
    cil: {
      reserve: "odporúčané {cil}×",
      dsti: "odporúčanie ČNB do {max} %",
      saving: "ideál {ideal} %",
    },
    stav: {
      reserveLow: "nízka rezerva",
      reserveMid: "doplniť do {cil}×",
      reserveOk: "splnené",
      dstiOk: "v poriadku",
      dstiHigh: "nad odporúčaním",
      dstiHighBezRegulatora: "vysoká zadlženosť",
    },
    aria: {
      jmeni: "Čisté imanie {ciste}: majetok {majetek}, dlhy {dluhy}",
      mesic: "Mesačne príjmy {prijmy}: výdavky {vydaje}, splátky {splatky}, voľné peniaze {volne}",
      mesicSchodek: "Mesačne príjmy {prijmy}: výdavky {vydaje} a splátky {splatky} ich prevyšujú o {schodek}",
    },
    chipNetWorth: "Čisté imanie",
    chipFreeCf: "Voľné CF",
  },
  kompletnost: {
    jmeno: "Meno a priezvisko klienta",
    narozeni: "Dátum narodenia (vek)",
    kontakt: "Kontakt (telefón / e-mail)",
    cil: "Aspoň jeden cieľ so sumou",
    prijmy: "Príjmy domácnosti",
    vydaje: "Obvyklé mesačné výdavky",
    rezerva: "Likvidná rezerva (účty / hotovosť)",
    investice: "Investície / sporenie",
    rizika: "Poistenie / rizká",
  },
  crmdash: {
    greetMorning: "Dobré ráno", greetAfternoon: "Dobré popoludnie", greetEvening: "Dobrý večer",
    kObvolani: "{n} na obvolanie",
    poTerminuOne: "{n} úloha po termíne", poTerminuFew: "{n} úlohy po termíne", poTerminuMany: "{n} úloh po termíne",
    otevrenychUkoluOne: "{n} otvorená úloha", otevrenychUkoluFew: "{n} otvorené úlohy", otevrenychUkoluMany: "{n} otvorených úloh",
    podpisuOne: "{n} podpis tento mesiac", podpisuFew: "{n} podpisy tento mesiac", podpisuMany: "{n} podpisov tento mesiac",
    bezPodpisu: "zatiaľ bez podpisu tento mesiac", cistyStul: "Dnes nič nečaká — čistý stôl.",
    cipSplneno: "Plán splnený", cipVTempu: "V tempe", cipZbyvaBj: "Zostáva {n} BJ", cipBezPlanu: "Bez plánu",
    cipPrazdnaPipeline: "Nič rozpracované", cipPoTerminu: "{n} po termíne", cipNicPoTerminu: "Nič po termíne", cipVolno: "Žiadne úlohy",
    metrPlneni: "Plnenie mesačného plánu BJ", metrMesic: "Uplynutá časť mesiaca",
    rozvrzeni: "Rozloženie", rozvrzeniKlasicke: "Klasické", rozvrzeniDenMesic: "Deň → Mesiac", sekceDnes: "Dnes", sekceMesic: "Mesiac",
    monthProgress: "Postup mesiaca", day: "deň", of: "z",
    kpiBj: "BJ tento mesiac", planNotSet: "Plán nenastavený", plan: "Plán",
    kpiProvize: "Provízia mesiac", coef: "Koef.",
    kpiPipeline: "Aktívna pipeline", openDeals: "otvorených obchodov", contactsTotal: "kontaktov celkom",
    kpiTasks: "Úlohy na riešenie", noTasks: "Žiadne úlohy", doneOf: "hotových z",
    dealsPipeline: "Obchodná pipeline", openBoard: "Otvoriť nástenku", loadingDeals: "Načítavam obchody…", noDeals: "Žiadne obchody", more: "ďalších",
    todayCalls: "Dnes na volanie", upcomingTasks: "Nadchádzajúce úlohy", stageDistribution: "Rozloženie fáz",
    leadSources: "Zdroje leadov", noData: "Žiadne dáta", pipelineByStage: "Pipeline po fázach", recentActivity: "Posledná aktivita",
    callAction: "Volať", meetingAction: "Stretnutie", noInterestAction: "Nemá záujem",
    funnelCalling: "Volania", funnelSigned: "Podpis",
    saved: "Uložené", saveFailed: "Nepodarilo sa uložiť", loadFailed: "Nepodarilo sa načítať dáta CRM",
    noTasksYet: "Žiadne úlohy", noCallsToday: "Dnes nikto na volanie", inPipeline: "V pipeline",
    subtitle: "Prehľad portfólia, diára a klientov — na jednom mieste.",
    openDiary: "Otvoriť diár", adviser: "Poradca", adviserRole: "Poradca",
    topClients: "Top klienti podľa AUM", topClientsSub: "Vaše najsilnejšie portfóliá", allClients: "Všetci",
    kpiClients: "Klienti", kpiClientsHint: "Aktívne portfólio", kpiVip: "VIP", kpiVipHint: "Zlatý tier",
    kpiWeek: "Tento týždeň", kpiWeekHint: "Naplánovaných stretnutí", kpiAum: "AUM / BJ", kpiAumHint: "Pod správou",
    noTopClients: "Zatiaľ žiadni klienti",
    bulkToday: "Na dnes",
    bulkWeek: "O týždeň",
    bulkTodayHint: "Presunúť všetky úlohy po termíne na dnes",
    bulkWeekHint: "Odložiť všetky úlohy po termíne o týždeň",
    bulkConfirmToday: "Presunúť {n} úloh po termíne na dnes?",
    bulkConfirmWeek: "Odložiť {n} úloh po termíne o týždeň?",
    bulkRunning: "Presúvam…",
    bulkDoneOne: "Presunutá {n} úloha",
    bulkDoneFew: "Presunuté {n} úlohy",
    bulkDoneMany: "Presunutých {n} úloh",
    bulkPartial: "{ok} presunutých, {err} sa nepodarilo",
    bulkFailed: "Presun sa nepodaril",
  /* PANELY NÁSTĚNKY — dřív mapy PANEL_*_SK v pages/crm/CRMDashboardPage.js,
     které uměly jen cs+sk (Vietnamec i Ukrajinec dostal češtinu). */
  panelKat: {
    vse: 'Všetko',
    prehledy: 'Rýchle prehľady',
    obchod: 'Obchodné prípady',
    klienti: 'Klienti & servis',
    nastroje: 'Nástroje',
  },
  panel: {
    zrcadlo: {
      title: 'Zrkadlo volania — koho dnes obvolať',
      desc: 'Poradie volania: kto čaká najdlhšie, odkiaľ je, zavolať na jedno kliknutie.',
      helpLabel: 'Zrkadlo volania',
      helpText: 'Kto čaká na obvolanie — rovnaké poradie ako stránka Zrkadlo volania, len skrátené. Hore koľko ľudí čaká, pod tým päť najdlhšie čakajúcich (kto čaká najdlhšie, je prvý), pri každom odkiaľ lead je a telefón. Zavolať otvorí telefón, Dohodnuté posunie kontakt do fázy Predstavenie a z poradia zmizne.',
    },
    brifink: {
      title: 'Ranný brífing',
      desc: 'Čo dnes · čo mešká · čo je hotové · čo príde.',
      helpLabel: 'Ranný brífing',
      helpText: 'Štyri otázky na jednom mieste: čo dnes, čo mešká, čo je hotové, čo príde. Pri položke vidíte klienta a obchod, ktorého sa týka. Všetko z diára, klientov a obchodov — keď nič nie je, sekcia to povie. Pri položke: + pridať do plánu, hodiny odložiť na neskôr, × zmazať z dnešného brífingu.',
    },
    diar: {
      title: 'Diár — týždeň',
      desc: 'Stretnutia a úlohy na celý týždeň pohromade.',
      helpLabel: 'Diár — týždeň',
      helpText: 'Stretnutia a úlohy celého týždňa. Číslo pri dni = počet úloh; klik otvorí diár.',
    },
    radar: {
      title: 'Servisný radar',
      desc: 'Klienti, u ktorých sa blíži servisné stretnutie.',
      helpLabel: 'Servisný radar',
      helpText: 'Klienti, u ktorých sa blíži koniec fixácie, výročie alebo dožitie — komu sa ozvať kvôli servisu.',
    },
    prilezitosti: {
      title: 'Radar príležitostí',
      desc: 'Medzery v portfóliu a príležitosti na oslovenie.',
      helpLabel: 'Radar príležitostí',
      helpText: 'Medzery v portfóliu klientov zoradené podľa skóre — kde je najväčšia príležitosť na oslovenie.',
    },
    kpi: {
      title: 'KPI dlaždice',
      desc: 'Kľúčové čísla mesiaca: BJ, provízia, pipeline, úlohy.',
      helpLabel: 'KPI dlaždice',
      helpText: 'Kľúčové čísla mesiaca (BJ, provízia, pipeline, úlohy). Klik na dlaždicu otvorí detail v Obchodoch alebo Diári.',
    },
    pipeline: {
      title: 'Obchodná pipeline',
      desc: 'Obchody rozdelené podľa fáz pipeline.',
      helpLabel: 'Obchodná pipeline',
      helpText: 'Otvorené obchody podľa fáz (analýza → čerpanie) vrátane váženej prognózy provízií. Klik → Obchody.',
    },
    akce: {
      title: 'Vyžaduje akciu dnes',
      desc: 'Čo dnes horí a čaká na vašu akciu.',
      helpLabel: 'Vyžaduje akciu dnes',
      helpText: 'Fronta na dnes: úlohy po termíne aj obchody bez naplánovaného ďalšieho kroku. Klik → detail.',
    },
    volani: {
      title: 'Dnes na volanie',
      desc: 'Kontakty, ktoré treba dnes obvolať.',
      helpLabel: 'Dnes na volanie',
      helpText: 'Kontakty na obvolanie podľa priority VIP → A → B → C. Tlačidlá: telefón = zavolať · ✓ dohodnuté stretnutie · ✗ nemá záujem.',
    },
    ukoly: {
      title: 'Nadchádzajúce úlohy',
      desc: 'Najbližšie úlohy zoradené podľa termínu.',
      helpLabel: 'Nadchádzajúce úlohy',
      helpText: 'Najbližšie nesplnené úlohy podľa termínu. Klik → Diár.',
    },
    emaily: {
      title: 'E-maily',
      desc: 'Neprečítané e-maily rovno na nástenke.',
      helpLabel: 'E-maily',
      helpText: 'Posledné neprečítané e-maily z pripojeného Gmailu. Klik → Pošta.',
    },
    klienti: {
      title: 'Posledná aktivita klientov',
      desc: 'Posledný pohyb u vašich klientov.',
      helpLabel: 'Klienti',
      helpText: 'Naposledy upravení klienti — rýchly prístup k zložke. Klik → Klienti.',
    },
    topklienti: {
      title: 'Top klienti podľa AUM',
      desc: 'Najhodnotnejší klienti podľa objemu majetku.',
      helpLabel: 'Top klienti podľa AUM',
      helpText: 'Najhodnotnejší klienti podľa objemu majetku (BJ). Klik → Klienti.',
    },
    faze: {
      title: 'Rozloženie fáz',
      desc: 'Rozloženie kontaktov podľa fázy obchodu.',
      helpLabel: 'Rozloženie fáz',
      helpText: 'Počet kontaktov v jednotlivých fázach obchodu — kde sa hromadí práca.',
    },
    zdroje: {
      title: 'Zdroje leadov',
      desc: 'Odkiaľ vám chodí najviac leadov.',
      helpLabel: 'Zdroje leadov',
      helpText: 'Odkiaľ vám chodí najviac kontaktov (leadovač, odporúčania, web…).',
    },
    nastroje: {
      title: 'Rýchle nástroje',
      desc: 'Rýchle skratky na kalkulačky a nástroje.',
      helpLabel: 'Rýchle nástroje',
      helpText: 'Skratky na kalkulačky a nástroje rozdelené do kategórií.',
    },
    poznamky: {
      title: 'Poznámky',
      desc: 'Prázdny papier na rýchle poznámky so štítkami.',
      helpLabel: 'Poznámky',
      helpText: 'Prázdny papier na čokoľvek — text sa ukladá sám. Štítkom si poznámky roztriedite a hore podľa neho filtrujete.',
    },
    vyvoj: {
      title: 'Vývoj obchodov',
      desc: 'Vývoj uzavretých obchodov v čase.',
      helpLabel: 'Vývoj obchodov',
      helpText: 'Uzavreté obchody v čase — trend podpísaných BJ po mesiacoch. Obdobie prepnete tlačidlami.',
    },
    plan: {
      title: 'Plnenie plánu',
      desc: 'Ako sa blížite k mesačnému plánu BJ.',
      helpLabel: 'Plnenie plánu',
      helpText: 'Ako sa blížite k mesačnému plánu BJ; ručička ukazuje % splnenia a odhad provízie.',
    },
    trychtyr: {
      title: 'Predajný lievik',
      desc: 'Koľko máte rozobchodované v jednotlivých fázach.',
      helpLabel: 'Predajný lievik',
      helpText: 'Koľko obchodov a BJ máte v jednotlivých fázach a ako dlho v nich priemerne ležia.',
    },
  },
  },
  /* BLOK:diar START — generuje scratchpad/slovnik.py, ručně needitovat */
  diar: {
    activity: 'Aktivita',
    agenda: 'Zoznam',
    agendaSub: 'Zoznam aktivít',
    agendaTitle: 'Nadchádzajúce',
    allDay: 'Celodenné',
    calls: 'hovorov',
    dFri: 'Pi',
    dMon: 'Po',
    dSat: 'So',
    dSun: 'Ne',
    dThu: 'Št',
    dTue: 'Ut',
    dWed: 'St',
    day: 'Deň',
    days: 'dní',
    editActivity: 'Úprava aktivity',
    filters: 'Filtre',
    hintKlik: 'Klikni do mriežky',
    hintKlikZbytek: 'pre rýchlu udalosť.',
    hintTah: 'Potiahnutím',
    hintTahZbytek: 'presunieš, ťahaním za spodný okraj zmeníš dĺžku.',
    m01: 'január',
    m02: 'február',
    m03: 'marec',
    m04: 'apríl',
    m05: 'máj',
    m06: 'jún',
    m07: 'júl',
    m08: 'august',
    m09: 'september',
    m10: 'október',
    m11: 'november',
    m12: 'december',
    meetings: 'stretnutí',
    month: 'Mesiac',
    monthOverview: 'Mesačný prehľad',
    newActivity: 'Nová aktivita',
    nextWeek: 'Ďalší týždeň',
    prevWeek: 'Predchádzajúci týždeň',
    refreshed: 'Diár obnovený',
    sync: 'Synchronizácia',
    tDopis: 'List',
    tEmail: 'Email',
    tSchuzka: 'Stretnutie',
    tTelefonat: 'Telefonát',
    tUdalost: 'Udalosť',
    tUkol: 'Úloha',
    tasks: 'úlohy',
    tip: 'Tip',
    today: 'Dnes',
    week: 'Týždeň',
    weekNo: 'týždeň',
  },
  /* BLOK:diar END */
  hypo: {
    active: "Aktívnych", waitOdhad: "Čaká na odhad", naKatastru: "Na katastri", blizkoCerpani: "Blízko čerpania", cerpanoMesic: "Čerpané (mesiac)",
    search: "Hľadať hypotéku…", colClient: "Klient", colBank: "Banka", colPhase: "Fáza procesu", colWaiting: "Čaká na", colNextStep: "Ďalší krok", aiWatch: "AI STRÁŽI", colAmount: "Výška / LTV", loading: "Načítavam hypotéky…", shown: "Zobrazené", activeMortgages: "aktívnych hypoték",
  },
  deal: {
    notFound: "Obchod nenájdený", dealValue: "Hodnota obchodu", caseProgress: "Postup prípadu",
    save: "Uložiť", edit: "Upraviť", nextStep: "Ďalší krok prípadu",
    subject: "Predmet", price: "Cena", ownFunds: "Vlastný vklad", note: "Poznámka",
    purchasePrice: "Kúpna cena", ownResources: "Vlastné zdroje", monthlyPayment: "Mesačná splátka",
    keyParam: "Kľúčový parameter", keyPh: "Kľúč (napr. LTV)", valuePh: "Hodnota",
    people: "Ľudia v prípade", addRole: "Rýchlo pridať rolu",
    resWon: "Výhra", resLost: "Prehra", resCancelled: "Zrušené", resOpen: "V procese",
    cantSave: "Nepodarilo sa uložiť", cantChangeStage: "Nepodarilo sa zmeniť fázu", cantAddNote: "Nepodarilo sa pridať poznámku",
    cantWin: "Nepodarilo sa potvrdiť výhru", error: "Chyba", cancelled: "Zrušené", deleted: "Zmazané",
    roleRealitni: "Realitný maklér", roleProdejce: "Predajca", roleKupujici: "Kupujúci", roleOdhadce: "Odhadca",
    roleBanker: "Bankár", rolePravnik: "Právnik / notár", roleDruhyKlient: "Druhý klient", roleDeveloper: "Developer", roleHlavniKlient: "Hlavný klient", rolePlaceholder: "Rola (napr. Bankár)", roleSystemovaHint: "Túto rolu drží systém — prepísať sa nedá.",
  },
  /* Levá lišta + chrome aplikace. Dřív to byl SK-only overlay `SK_NAV`,
   * takže vietnamec i ukrajinec viděli českou navigaci na KAŽDÉ obrazovce. */
  /* Uvítací modal po prvním přihlášení (components/FirstLoginWizard.js).
   * {jmeno} se dosazuje v komponentě — nesmí se z překladu vypustit. */
  wizard: {
    /* Zástupné slovo, když poradce nemá vyplněné jméno. Do 23. 8. 2026
       bylo v FirstLoginWizard.js natvrdo české „svoji“, takže Vietnamec
       četl „danh thiếp số của svoji“. */
    zastupneJmeno: 'svoju',
    vitej: 'Vitaj v BEplan University',
    nadpis: 'Nastav si {jmeno} digitálnu vizitku',
    popisA: 'Vizitka je tvoja verejná stránka — klienti odtiaľ zarezervujú stretnutie, zavolajú, nájdu ťa na LinkedIn.',
    popisZvyraznene: 'Zaberie to 30 sekúnd',
    popisB: 'a potom ti začnú fungovať všetky Leadovač odkazy aj karta odporúčaní.',
    slugLabel: 'Tvoja URL adresa (slug)',
    nahled: 'Náhľad:',
    nastavitVizitku: 'Nastaviť vizitku',
    preskocit: 'Zatiaľ preskočiť',
    pozdejiA: 'Ak teraz preskočíš, vizitku si môžeš nastaviť kedykoľvek v',
    pozdejiKde: 'Nastavenia → Vizitka',
    pozdejiB: 'Ale odporúčame to urobiť hneď — bez slugu ti nepobeží Leadovač.',
    hotovo: 'Hotovo!',
    vrhnemeSe: 'Vrhneme sa na CRM…',
    ulozeno: 'Vizitka uložená!',
    chyba: 'Uloženie slugu zlyhalo. Môžeš to skúsiť znova v Nastaveniach → Vizitka.',
  },
  lista: {
    nastenka: 'Nástenka',
    klienti: 'Klienti',
    obchody: 'Obchody',
    diar: 'Diár',
    posta: 'Pošta',
    manazer: 'Manažér',
    vzdelavani: 'Vzdelávanie',
    nastroje: 'Nástroje',
    adresar: 'Adresár',
    zrcadloVolani: 'Zrkadlo volaní',
    pipelineKlientu: 'Pipeline klientov',
    radarPrilezitosti: 'Radar príležitostí',
    mapaKlientu: 'Mapa klientov',
    leadyProjekt100: 'Leady (Projekt 100)',
    obchodniNastenka: 'Obchodná nástenka',
    hypotecniPipeline: 'Hypotekárna pipeline',
    naborovaPipeline: 'Náborová pipeline',
    naborovyRadar: 'Náborový radar',
    zakazkyReality: 'Zákazky (reality)',
    realitniPipeline: 'Realitná pipeline',
    rezervacniSmlouva: 'Rezervačná zmluva',
    prehledTymu: 'Prehľad tímu',
    ikKonzultace: 'IK konzultácie',
    mojiPoradci: 'Moji poradcovia',
    vyhlaseniVysledku: 'Vyhlásenie výsledkov',
    tymoveAkce: 'Tímové akcie',
    diarTymu: 'Diár tímu',
    startNovacka: 'Štart nováčika (Cesta 90 dní)',
    adaptace7: '7-dňová adaptácia',
    adaptaceTymu: 'Adaptácia tímu',
    akademieModuly: 'Akadémia — moduly a infografiky',
    metodikaPlan: 'Metodika: Zostavenie plánu',
    zkouskaCertifikat: 'Skúška a certifikát',
    skriptyNamitky: 'Skripty a námietky',
    kdeShanetKlienty: 'Kde zháňať klientov',
    videaKurzy: 'Videá a kurzy',
    rozcestnikNastroju: 'Rozcestník nástrojov',
    financniMatematika: 'Finančná matematika',
    kalkulacky21: 'Kalkulačky (20)',
    penzijniKalkulacka: 'Dôchodková kalkulačka',
    zivotniPojisteni: 'Životné poistenie',
    historickaKalkulacka: 'Historická kalkulačka',
    investicniStrategie: 'Investičné stratégie',
    srovnavacFondu: 'Porovnávač fondov',
    nemovitostPronajem: 'Nehnuteľnosť na prenájom',
    provizniKalkulacka: 'Provízna kalkulačka',
    hledat: 'Hľadať',
    hledatVCeleAplikaci: 'Hľadať v celej aplikácii',
    naNastenku: 'Na nástenku',
    profilPoradce: 'Profil poradcu (fotku nastavíš v Nastaveniach)',
    zavritMenu: 'Zatvoriť menu',
    sbalit: 'Zbaliť',
    pripnout: 'Pripnúť',
    sbalitListu: 'Zbaliť lištu',
    pripnoutRozbalene: 'Pripnúť rozbalené',
    novyZaznam: 'Nový záznam — klient, lead, obchod, úloha…',
    novyZaznamTlacitko: 'Nový záznam',
    ucet: 'Účet',
    novyKlient: 'Nový klient',
    novyKlientSub: 'Pridať do pipeline',
    novyLead: 'Nový lead',
    novyLeadSub: 'Príležitosť / vlažný kontakt',
    obchodniPripad: 'Obchodný prípad',
    obchodniPripadSub: 'Rovno založiť obchod',
    naborKandidat: 'Nábor — kandidát',
    naborKandidatSub: 'Rovno založiť kandidáta',
    ukolSchuzka: 'Úloha / Schôdzka',
    ukolSchuzkaSub: 'Otvoriť Diár',
    leadZDoporuceni: 'Lead z odporúčania',
    leadZDoporuceniSub: 'Odkaz pre klienta',
    // horní lišta záložek (GlobalTabBar) — zbylých 28; ostatní sdílí klíče výše
    tabLeady: 'Leady',
    tabServisRadar: 'Servisný radar',
    tabKomunikace: 'Komunikácia',
    tabDoporuceni: 'Odporúčania',
    tabCile: 'Ciele',
    tabVyhlaseni: 'Vyhlásenie',
    tabSmlouva: 'Zmluva',
    tabHypoteky: 'Hypotéky',
    tabNabor: 'Nábor',
    tabHlasovyRezim: 'Hlasový režim',
    tabRezervace: 'Rezervácie',
    tabTrychtyre: 'Lieviky',
    tabHistoricka: 'Historická',
    tabFinMatematika: 'Fin. matematika',
    tabInvesticniStudio: 'Investičné štúdio',
    tabStrategie: 'Stratégie',
    tabPenze: 'Dôchodok',
    tabIzp: 'Analýza pre Vietnamcov',
    tabRentaPorovnavac: "Renta — porovnávač",
    tabAnalyza: "Analýza",
    tabFixace: "Fixácia pod kontrolou",
    tabSvoboda: "Kedy budeš voľný",
    tabHypotekaRozhodnuti: "Hypotéka — rozhodnutia",
    tabPortfolioDoktor: 'Portfólio doktor',
    tabReality: 'Reality',
    tabZakazky: 'Zákazky',
    tabRezervacniSmlouva: 'Rezervačná zmluva',
    tabNemovitost: 'Nehnuteľnosť',
    tabKalkulackaVizual: 'Kalkulačka vizuál',
    tabProvize: 'Provízie',
    tabDesignLab: 'Design Lab',
    tabAdmin: 'Admin',
    tabAiKnowledge: 'AI Knowledge',
    tabHlasovky: 'Hlasovky',
    tabHromadnyEmail: 'Hromadný e-mail',
    tabPortfolioAdmin: 'Portfólio (admin)',
    tabTrzniData: 'Trhové dáta',
    tabMesicnikAdmin: 'Mesačník (admin)',
    tabMesicnik: 'Mesačník',
    tabDataHygiena: 'Hygiena dát',
    tabNastaveni: 'Nastavenia',
    tabNovinky: 'Čo je nové',
  },
  nav: { dashboard: "Nástenka", calculators: "Kalkulačky", tools: "Nástroje", admin: "Admin", logout: "Odhlásiť sa", theme: "Zmeniť motív" },
  login: {
    subtitle: "Vzdelávací systém pre finančných poradcov",
    welcomePre: "Vitaj na",
    welcomeEm: "univerzite",
    name: "Meno a priezvisko",
    accessCode: "Prístupový kód",
    registerClosed: "Registrácia je momentálne zatvorená. Požiadaj správcu o pozvánku alebo o zapnutie registrácie.",
    email: "Email",
    password: "Heslo",
    submit: "Prihlásiť sa",
    register: "Registrovať",
    loading: "Načítava sa…",
    loginOk: "Prihlásenie úspešné!",
    registerOk: "Registrácia úspešná!",
    loginErr: "Chyba prihlásenia",
    hasAccount: "Už máte účet? Prihlásiť sa",
    noAccount: "Nemáte účet? Registrovať sa",
    forgot: "Zabudli ste heslo?", forgotTitle: "Obnovenie hesla", sendCode: "Poslať kód na e-mail", codeSent: "Ak e-mail existuje, poslali sme naň kód.", codeLabel: "Obnovovací kód z e-mailu", newPass: "Nové heslo (min. 8 znakov)", resetBtn: "Nastaviť nové heslo", resetOk: "Heslo obnovené — prihláste sa", backToLogin: "Späť na prihlásenie",
  },
  dash: {
    welcome: "Vitajte v beplan University",
    subtitle: "Váš vzdelávací systém pre finančné poradenstvo",
    progress: "Celkový postup",
    completedVids: "Dokončené videá",
    activeSeries: "Aktívne série",
    totalProgress: "Celkový postup",
    series: "Vzdelávacie série",
    done: "DOKONČENÉ",
    inProgress: "PREBIEHA",
    vidsDone: "videí dokončených",
    lastWatch: "Naposledy sledované",
  },
  detail: {
    notFound: "Séria nenájdená",
    locked: "Séria zamknutá",
    lockedDesc: "Dokončite predchádzajúcu sériu pre odomknutie.",
    back: "Späť na Dashboard",
    seriesLabel: "Séria",
    markDone: "Označiť ako dokončené",
    isDone: "Dokončené",
    download: "Stiahnuť materiály",
    noMaterial: "Materiály nedostupné",
    comments: "Komentáre",
    writeComment: "Napíšte komentár alebo spätnú väzbu…",
    send: "Odoslať",
    sending: "Odosielam…",
    noComments: "Zatiaľ žiadne komentáre. Buďte prvý!",
    reply: "Odpovedať",
    del: "Zmazať",
    writeReply: "Napíšte odpoveď…",
    vidDone: "Video označené ako dokončené!",
    saveErr: "Chyba pri ukladaní",
    commentOk: "Komentár pridaný!",
    commentErr: "Chyba pri pridávaní komentára",
    replyOk: "Odpoveď pridaná!",
    delOk: "Komentár zmazaný",
    delErr: "Chyba pri mazaní",
  },
  calcPage: { title: "Finančné kalkulačky", subtitle: "Profesionálne nástroje pre finančné plánovanie a poradenstvo", all: "Všetko", realestate: "Nehnuteľnosti", investment: "Investície", insurance: "Poistenie & Dôchodok", personal: "Osobné financie", open: "Otvoriť kalkulačku" },
  toolsPage: { title: "Nástroje pre finančných poradcov", subtitle: "Profesionálne nástroje pre efektívnu prácu", open: "Otvoriť", catObchod: "Obchod & provízie", catKalkulacky: "Kalkulačky & výpočty", catVzdelavani: "Vzdelávanie", tileObchod: "Obchod", tileKalkulacka: "Kalkulačka", tileVzdelavani: "Vzdelávanie", },
  admin: { loading: "Načítavam…", title: "Administrácia", codeTitle: "Prístupový kód", codeDesc: "Tento kód potrebujú noví používatelia pre registráciu.", save: "Uložiť", curCode: "Aktuálny kód:", users: "Používatelia", videoTitle: "Správa videí", videoDesc: "Vložte YouTube odkazy a materiály.", vids: "videí", ytUrl: "YouTube URL", matUrl: "Materiály (Google Drive)", saving: "Ukladám…", saved: "Video aktualizované!", saveErr: "Chyba pri ukladaní", loadErr: "Chyba pri načítaní", codeOk: "Prístupový kód aktualizovaný!", codeErr: "Chyba pri aktualizácii", noName: "Bez mena", confirmDelete: "Naozaj zmazať tohto používateľa?", userDeleted: "Používateľ zmazaný", deleteErr: "Chyba pri mazaní", deleteUser: "Zmazať používateľa" },
  common: { reset: "Reset", start: "Štart", pause: "Pauza", min: "min", progress: "Postup", phase: "Fáza", search: "Hľadať…", noResults: "Žiadne výsledky", example: "Príklad", save: "Uložiť", saving: "Ukladám…", cancel: "Zrušiť", delete: "Zmazať", edit: "Upraviť", add: "Pridať", close: "Zavrieť", back: "Späť", next: "Ďalej", yes: "Áno", no: "Nie", confirm: "Potvrdiť", loading: "Načítam…", copy: "Kopírovať", copied: "Skopírované", open: "Otvoriť", new: "Nové", today: "dnes", week: "týždeň", total: "celkom", name: "Meno", phone: "Telefón", email: "Email", note: "Poznámka", required: "Povinné", optional: "Voliteľné", submit: "Odoslať", submitting: "Odosielam…", detail: "Detail", settings: "Nastavenia", backToSettings: "Späť do nastavení" },
  crm: {
    title: "CRM Poradca",
    advisorWord: "Poradca",
    subtitle: "Kontakty, pipeline, volania a IK — všetko na jednom mieste.",
    beginner: "Začiatočník",
    overview: "Prehľad",
    p100: "Projekt 100",
    calls: "Zrkadlo volaní",
    pipeline: "Pipeline",
    ik: "IK konzultácia",
    goals: "Ciele & Rocks",
    team: "Moji poradcovia",
    leadovac: "Leadovač",
    stages: { lead: "Lead", calling: "K obvolaniu", meeting: "Schôdzka dohodnutá", onboarding: "Onboarding", proposal: "Návrh", contract: "Zmluva", active: "Aktívny klient", lost: "Stratený" },
    actions: { call: "Zavolať", schedule: "Schôdzka", callback: "Spätné volanie", later: "Neskôr", noInterest: "Nezáujem", addContact: "Pridať kontakt", newLead: "Nový lead" },
  },
  leadovac: {
    title: "Leadovač",
    subtitle: "Predajný lievik pre získavanie leadov. Pošli klientovi odkaz na WhatsApp — prejde si tému, spočíta benefit kalkulačkou a nechá dopyt. Máš nový lead.",
    latestLeads: "Posledné leady",
    latestLeadsSub: "Aktualizuje sa každých 20 s · prichádzajúce dopyty",
    live: "live",
    today: "dnes",
    week: "týždeň",
    total: "celkom",
    filter: { all: "Všetko" },
    tools: "Tvoje leadovač nástroje",
    toolsSub: "4 hotové prémiové lieviky — klikni a zdieľaj s klientom.",
    setSlugFirst: "Najprv si nastav slug v profile →",
    open: "Otvoriť",
    detail: "Detail & zdieľať →",
    detailRef: "Vytvoriť odkaz pre klienta →",
    noLeads: "Zatiaľ žiadne leady. Pošli klientovi odkaz a uvidíš.",
    moreLeads: "ďalších — otvor kartu témy",
    badgeLead: "lead",
    badgeLeads: "leadov",
    badgeLink: "odkaz",
    badgeLinks: "odkazov",
  },
  leadForm: {
    eyebrowConsult: "30 minút zadarmo",
    yourName: "Vaše meno",
    yourNamePh: "Ján Novák",
    yourPhone: "Telefón",
    yourPhonePh: "+421 900 000 000",
    yourEmail: "E-mail (voliteľné)",
    yourEmailPh: "meno@example.sk",
    note: "Krátka správa (voliteľné)",
    notePh: "Čo je pre Vás najdôležitejšie, kedy zavolať atď.",
    preferredTime: "Preferovaný čas schôdzky",
    preferredTimePh: "napr. všedný deň poobede",
    consent: "Odoslaním súhlasím so spracovaním údajov na účel kontaktu.",
    successTitle: "Ďakujem!",
    successSubtitle: "Ozvem sa Vám do 24 hodín.",
    successHint: "Majte pri sebe telefón — obvykle volám späť ten istý deň.",
    bookHeading: "Alebo si rovno vyberte termín",
    bookSubtitle: "Vyberte si deň a čas, ktorý Vám vyhovuje. Bez záväzkov, bez tlaku.",
    bookCta: "Vybrať termín konzultácie",
    ctaTryCalc: "Vyskúšať kalkulačku",
    ctaWantConsult: "Chcem konzultáciu",
    notFound: "Stránka nenájdená",
    unknownTopic: "Neznáma téma",
    errName: "Zadajte celé meno",
    errPhone: "Zadajte platné telefónne číslo",
    errSend: "Odoslanie zlyhalo, skúste to znovu.",
    calcEyebrow: "Vyskúšajte si sami",
    calcTitle: "Kalkulačka — {tema}",
    calcSub: "Posuňte parametre a uvidíte čísla v reálnom čase. Nie je to vedecký výpočet, ale dostatočne presný odhad pre orientáciu.",
    howEyebrow: "Ako to funguje",
    howTitle: "Štyri kroky od otázky k riešeniu",
    examplesEyebrow: "Modelové príklady",
    examplesTitle: "Ako to môže vyzerať vo Vašej situácii",
    examplesNote: "Ilustratívne scenáre — pre predstavu, čo konkrétne sa dá riešiť. Reálny výsledok vždy závisí od Vašej konkrétnej situácie.",
    exSituation: "Situácia:",
    exSolution: "Riešenie:",
    preparedBy: "Túto stránku Vám pripravil",
    bookPoint1: "30–45 minút, online cez Google Meet alebo osobne",
    bookPoint2: "Žiadny tlak na uzavretie zmluvy",
    bookPoint3: "Po stretnutí máte písomný prehľad do 48 hodín",
    nextWeek: "Budúci týždeň",
    freeEyebrow: "Bez záväzkov · Zadarmo",
    getTitle: "Čo získate",
    get1: "Výpočet na mieru z Vašich čísel — zadarmo",
    get2: "Ozvem sa do 24 hodín, v čase, ktorý Vám vyhovuje",
    get3: "Nezáväzne — rozhodnutie je vždy na Vás",
    timeMorning: "Dopoludnia (11–13)",
    timeAfternoon: "Popoludní (13–17)",
    timeEvening: "Večer (17–20)",
    timeAnytime: "Kedykoľvek",
    privacy: "Ochrana osobných údajov",
    weekdayShort: "Po,Ut,St,Št,Pi,So,Ne",
    midCtaHeading: "Stačí Vám 30 minút. Bez straty.",
    midCtaSub: "Bez tlaku, bez sľubov. Iba čísla a jasná hlava.",
    whatToExpect: "Čo od spolupráce čakať",
    wantToDiscuss: "Chcete to prebrať?",
    freeConsult30: "30 min konzultácia zadarmo · bez záväzku",
    term: "Termín",
    inquiry: "Dopyt",
  },
  vizitka: { title: "Digitálna vizitka", subtitle: "URL slug, QR kód, farby a tlač fyzickej vizitky.", slug: "URL slug", slugHelp: "3–40 znakov, malé písmená, čísla, pomlčka.", qrTitle: "URL slug & QR kód", qrSaveHint: "Ulož QR do podpisu emailu, na vizitku, web…", print: "Vygenerovať tlačovú vizitku (A4)", colors: "Farby vizitky", custom: "Vlastné", bg: "Pozadie", accent: "Akcent", save: "Uložiť vizitku" },
  booking: { pub: { inactive: "Tento poradca zatiaľ neaktivoval online rezervácie.", notFound: "Poradca nenájdený alebo odkaz neplatný.", loading: "Načítavam…", notAvailable: "Rezervácia nie je dostupná", meeting: "Stretnutie", chooseService: "Vyber typ stretnutia", changeService: "Zmeniť typ stretnutia", pickHeading: "Vyber dátum a čas", pickDate: "Vyber dátum v kalendári", loadingSlots: "Načítavam voľné časy…", noSlots: "Tento deň nemá voľné termíny.", prevMonth: "Predchádzajúci mesiac", nextMonth: "Ďalší mesiac", tzLabel: "Časové pásmo", reservingFor: "Rezervuješ termín", changeTime: "Zmeniť čas", detailsHeading: "Tvoje údaje", nameLabel: "Meno a priezvisko", emailLabel: "E-mail", phoneLabel: "Telefón", noteLabel: "Čo chceš riešiť?", submitBtn: "Potvrdiť rezerváciu", submitting: "Rezervujem…", fillRequired: "Vyplň meno a e-mail", badEmail: "Zadaj platný e-mail", bookingFailed: "Rezervácia zlyhala", gdprInfo: "Odoslaním rezervácie odovzdávaš svoje meno, e-mail, telefón a poznámku poradcovi, ktorý si ich uloží do svojej klientskej evidencie, aby sa na stretnutie pripravil a mohol ťa kontaktovať. Kedykoľvek môžeš požiadať o výmaz.", confirmedTitle: "Schôdzka potvrdená", date: "Termín", sentTo: "Potvrdenie odoslané na", sentNone: "E-mailové potvrdenie sme teraz odoslať nemohli — poznač si prosím termín. Poradca sa ti ozve.", advisorContact: "V prípade potreby napíš poradcovi na", meetLink: "Odkaz na Google Meet" }, svc: { uvod15: "Úvodné predstavenie", uvod15d: "Rýchle nezáväzné zoznámenie — kto som, ako pracujem a či si sadneme.", analyza45: "Finančná analýza", analyza45d: "Prejdeme vaše ciele, príjmy a výdavky — základ pre finančný plán.", hypoteka: "Hypotekárna konzultácia", hypotekad: "Spočítame hypotéku a porovnáme ponuky viacerých bánk.", servis60: "Servisné stretnutie", servis60d: "Revízia existujúcich zmlúv a aktualizácia vášho plánu." }, title: "Online rezervácie — nastavenia", subtitle: "Prepoj Google Calendar, nastav pracovné hodiny.", enable: "Zapnúť online rezervácie", embedTitle: "Zobraziť Cal.com embed na vizitke", embedSub: "Klient si rezervuje priamo na vizitke (vyžaduje Calendar URL v profile).", googleConnected: "Google Calendar prepojený", connectGoogle: "Prepojiť Google Calendar", workHours: "Pracovné hodiny", meetingLength: "Dĺžka schôdzky (min)", buffer: "Pauza medzi schôdzkami (min)", save: "Uložiť nastavenia", publicLink: "Verejný rezervačný odkaz", upcoming: "Nadchádzajúce schôdzky" },
  settings: {
    jazykAplikace: 'Jazyk aplikácie',
    jazykNeniMena: 'Jazyk mení len texty. Mena sa riadi krajinou (Česko → Kč, Slovensko → €), nie jazykom.',
    menaAplikace: 'Mena celej aplikácie: {kod} ({symbol}). Prepnutie jazyka menu NEMENÍ a sumy sa neprepočítavajú — aplikácia nepozná kurz. Zmena krajiny prepíše len označenie novo zadávaných súm, staré dáta ostávajú v pôvodnej mene.',
    motivAktivni: 'Aktívny motív: ',
    motivJenHotove: 'V ponuke sú len dokončené motívy. Elite Light bol odobraný a tmavý motív nikdy nebol dotiahnutý, preto ich tu nenájdeš.',
    motivPoznamka: ' · Motív je tvoje osobné nastavenie v tomto prehliadači, klientom sa neposiela. Farby klientskej vizitky sa ním NEMENIA — tie nájdeš v Digitálnej vizitke.',
    oMne: 'O mne (zobrazí sa na vizitke)',
    oMnePlaceholder: 'Pomáham ľuďom dosiahnuť finančnú slobodu...',
    vzhledSub: 'Vyber motív aplikácie — farby sa prepíšu okamžite a voľba ti zostane aj po obnovení stránky.',
    zeme: 'Krajina (určuje menu)',
    zemeCZ: 'Česko',
    zemeSK: 'Slovensko',
    title: "Nastavenia", profile: "Profil", web: "Moja web stránka", webSub: "Profi mini-web s rezerváciou.", booking: "Rezervácie schôdzok", bookingSub: "Google Calendar, pracovné hodiny.", vizitka: "Digitálna vizitka", vizitkaSub: "URL slug, QR kód, farby, tlač A4.", active: "AKTÍVNE", saveProfile: "Uložiť profil", tabZakladni: "Základné údaje", tabVzhled: "Vzhľad aplikácie", tabManazer: "Môj manažér", tabSocialni: "Sociálne siete", tabModelace: "Modelácie", tabVideo: "Video intro", tabStatistiky: "Štatistiky", tabHeslo: "Zmena hesla", tabRezervace: "Rezervácie stretnutí", fJmeno: "Meno *", fTelefon: "Telefón", fEmail: "Verejný email", fSpolecnost: "Spoločnosť", stareHeslo: "Staré heslo", noveHeslo: "Nové heslo", potvrditHeslo: "Potvrdiť nové", zmenitHeslo: "Zmeniť heslo", fFotka: "Fotka poradcu", fLogo: "Logo spoločnosti (voliteľné)", fEmailManazera: "Email manažéra" },
  c: [
    { t: "Hypotekárna kalkulačka", s: "Výpočet mesačnej splátky a celkového preplatku.", d: "Zistite výšku mesačnej splátky, celkový preplatok a rozloženie istiny a úrokov v čase.", i: ["Výška úveru", "Úroková sadzba", "Doba splatnosti"], o: ["Mesačná splátka", "Celkom zaplatené", "Celkový preplatok", "Preplatok %"], ds: ["Istina", "Úroky"] },
    { t: "Kalkulačka refinancovania", s: "Porovnajte starú a novú hypotéku.", d: "Porovnajte súčasnú a novú hypotéku. Zistite mesačnú a celkovú úsporu.", i: ["Zostávajúca istina", "Súčasná sadzba", "Nová sadzba", "Zostávajúca splatnosť"], o: ["Mesačná úspora", "Celková úspora", "Stará splátka", "Nová splátka"], ds: ["Stará hypotéka", "Nová hypotéka"] },
    { t: "Predčasné splatenie hypotéky", s: "Úspora pri mimoriadnych splátkach.", d: "Zistite, o koľko rokov skrátite hypotéku vďaka mimoriadnym splátkam.", i: ["Výška hypotéky", "Úroková sadzba", "Doba splatnosti", "Mimoriadna splátka ročne"], o: ["Skrátenie o", "Úspora na úrokoch", "Pôvodná doba", "Nová doba"], ds: ["Bez mimoriadnych splátok", "S mimoriadnymi splátkami"] },
    { t: "Kalkulačka LTV", s: "Pomer úveru k hodnote nehnuteľnosti.", d: "LTV ukazuje pomer úveru k hodnote nehnuteľnosti.", i: ["Hodnota nehnuteľnosti", "Výška úveru"], o: ["LTV", "Vlastné prostriedky", "Hodnotenie sadzby"], ds: ["Vlastné prostriedky", "Úver"] },
    { t: "Nájom vs kúpa", s: "Porovnanie celkových nákladov.", d: "Porovnajte celkové náklady na nájom a kúpu nehnuteľnosti.", i: ["Cena nehnuteľnosti", "Mesačný nájom", "Sadzba hypotéky", "Horizont", "Rast ceny ročne"], o: ["Celkové náklady nájmu", "Čisté náklady kúpy", "Mesačná splátka", "Hodnota nehnuteľnosti"], ds: ["Nájom (kumulatívne)", "Kúpa (čisté)"] },
    { t: "Investičná kalkulačka — pravidelná", s: "Rast portfólia pri pravidelnom investovaní.", d: "Pravidelné investovanie je najdostupnejšia cesta k budovaniu majetku.", i: ["Mesačná investícia", "Ročný výnos", "Horizont", "Počiatočný vklad"], o: ["Výsledná hodnota", "Celkom vložené", "Zhodnotenie", "Zhodnotenie %"], ds: ["Vložené", "Hodnota portfólia"] },
    { t: "Zložené úročenie", s: "Sila zloženého úročenia v čase.", d: "Zložené úročenie je ôsmy div sveta.", i: ["Jednorázová investícia", "Ročný výnos", "Horizont"], o: ["Výsledná hodnota", "Počiatočný vklad", "Celkový výnos", "Výnos %"], ds: ["Hodnota investície"] },
    { t: "DCA vs jednorázová", s: "Porovnanie stratégií investovania.", d: "DCA znamená pravidelné investovanie bez ohľadu na trh.", i: ["Mesačná čiastka DCA", "Horizont", "Priemerný výnos", "Výnos sporiaci účet"], o: ["DCA výsledok", "Jednorázová", "Sporiaci účet", "Celkom vložené"], ds: ["DCA", "Jednorázová", "Sporiaci účet"] },
    { t: "Inflačná kalkulačka", s: "Ako inflácia znižuje hodnotu peňazí.", d: "Inflácia každý rok znižuje reálnu hodnotu peňazí.", i: ["Súčasná čiastka", "Priemerná inflácia", "Horizont"], o: ["Reálna hodnota", "Strata kúpnej sily", "Strata v %"], ds: ["Nominálna hodnota", "Reálna hodnota"] },
    { t: "FIRE kalkulačka", s: "Koľko potrebujete pre finančnú nezávislosť.", d: "FIRE — koľko kapitálu pre finančnú nezávislosť. Pravidlo 4%.", i: ["Mesačné výdavky v dôchodku", "Súčasný vek", "Cieľový vek FIRE", "Výnos portfólia"], o: ["Potrebný FIRE kapitál", "Mesačná úspora", "Roky do FIRE"], ds: ["Akumulácia kapitálu", "Cieľ"] },
    { t: "Sporenie na cieľ", s: "Ako dlho budete sporiť na cieľ.", d: "Máte konkrétny cieľ? Zistite, ako dlho budete sporiť.", i: ["Cieľová čiastka", "Počiatočný vklad", "Ročný výnos", "Mesačná úspora"], o: ["Dosiahnutie cieľa za", "Celkom vložené", "Výnos navyše"], ds: ["Úspory", "Cieľ"] },
    { t: "Penzijná kalkulačka", s: "Koľko nasporíte v III. pilieri.", d: "Priemerný štátny dôchodok nahradí len 40–54% mzdy.", i: ["Vek", "Vek odchodu do dôchodku", "Mesačný príspevok", "Príspevok zamestnávateľa", "Výnos fondu"], o: ["Nasporená čiastka", "Štátne príspevky", "Mesačná renta (20 r)"], ds: ["Vlastné", "Zamestnávateľ", "Štát", "Výnosy"] },
    { t: "Penzijná medzera", s: "Zistite svoju penzijnú medzeru.", d: "Štátny dôchodok nestačí na udržanie životnej úrovne.", i: ["Súčasný čistý príjem", "Štátny dôchodok", "Vek odchodu", "Dĺžka dôchodku"], o: ["Mesačná medzera", "Celková medzera", "Potrebný kapitál"], ds: ["Súčasný príjem (70%)", "Štátny dôchodok", "Medzera"] },
    { t: "Životné poistenie", s: "Odporúčané krytie.", d: "Správne nastavená pojistná suma kryje výpadok príjmu.", i: ["Mesačný príjem", "Mesačné výdavky rodiny", "Výška hypotéky", "Počet rokov krytia"], o: ["Krytie pri smrti", "Invalidita 3. stupňa", "Pracovná neschopnosť/mes"], ds: ["Odporúčané krytie"] },
    { t: "Stavebné sporenie", s: "Štátna podpora.", d: "Stavebné sporenie — jediný produkt s garantovanou štátnou podporou.", i: ["Mesačný vklad", "Doba sporenia", "Úroková sadzba"], o: ["Výsledná suma", "Vlastné vklady", "Štátne príspevky", "Efektívny výnos p.a."], ds: ["Vklady", "Štátne príspevky", "Úroky"] },
    { t: "Investičná kalkulačka — DIP", s: "Dlhodobý investičný produkt.", d: "DIP — dlhodobý investičný produkt s daňovým odpočtom až 48 000 Kč ročne. Pravidlo 120/60: výber po 10 rokoch A v 60 rokoch veku.", i: ["Mesačný vklad", "Príspevok zamestnávateľa", "Doba investície", "Výnos", "Sadzba dane"], o: ["Hodnota portfólia", "Ročná daňová úspora", "Daň. úspora celkom", "Príspevok zamestnávateľa"], ds: ["Portfólio"] },
    { t: "Cash flow", s: "Zdravie vášho mesačného cash flow.", d: "Zdravé cash flow je základ finančného plánu.", i: ["Čistá mzda", "Ostatné príjmy", "Bývanie", "Jedlo a domácnosť", "Doprava", "Poistky", "Zábava", "Sporenie a investície", "Ostatné výdavky"], o: ["Voľné cash flow", "Celkové príjmy", "Celkové výdavky", "Hodnotenie"], ds: ["Bývanie", "Jedlo", "Doprava", "Poistky", "Zábava", "Sporenie", "Ostatné", "Voľné"] },
    { t: "Čistá hodnota majetku", s: "Najdôležitejšie číslo finančného zdravia.", d: "Čistá hodnota = aktíva mínus pasíva.", i: ["Nehnuteľnosti", "Investície a fondy", "Penzijné sporenie", "Hotovosť a sporiace účty", "Auto a ostatné", "Hypotéka (zostatok)", "Spotrebiteľské úvery", "Ostatné záväzky"], o: ["Čistá hodnota", "Celkové aktíva", "Celkové pasíva"], ds: ["Aktíva", "Pasíva"] },
    { t: "Daňová úspora", s: "Maximálna daňová úspora.", d: "Správne nastavené finančné produkty môžu ušetriť tisíce ročne.", i: ["Hrubá mzda mesačne", "Životné poistenie/mes", "Penzijné sporenie/mes", "Úroky z hypotéky ročne", "Dary a ostatné odpočty"], o: ["Daňová úspora ročne", "Odpočty celkom", "Daň bez odpočtov", "Daň s odpočtami"], ds: ["Životné", "Penzijné", "Hypotéka", "Dary"] },
    { t: "Úvery — RPMN", s: "Skutočná cena úveru.", d: "RPMN ukazuje skutočnú cenu úveru. Vždy porovnávajte RPMN.", i: ["Výška úveru", "Úroková sadzba", "Mesačný poplatok", "Splatnosť"], o: ["Mesačná splátka", "Celkový preplatok", "RPMN", "Celkom zaplatené"], ds: ["Istina", "Úroky", "Poplatky"] },
    { t: "Finančné zdravotné skóre", s: "Komplexné hodnotenie financií.", d: "Komplexné hodnotenie finančnej situácie v 5 dimenziách.", i: ["Likvidná rezerva (mesiace výdavkov)", "Zadlženie (% príjmu)", "Miera sporenia (% príjmu)", "Poistenie", "Investície"], o: ["Celkové skóre", "Kategória", "Odporúčanie"], ds: ["Vaše skóre"] },
  ],
  s: [null,
    { t: "Mindset & Štart", st: "Základy podnikania a hodnoty beplan" },
    { t: "Finančný plán & Systém", st: "Základy finančného plánovania a CRM" },
    { t: "Obchodný proces & Zručnosti", st: "Od prvého telefónu po uzavretie zmluvy" },
    { t: "Produkty", st: "Prehľad finančných produktov" },
    { t: "Prípadové štúdie", st: "Reálne príklady z praxe" },
    { t: "Pokročilé", st: "Expertné témy a vedenie tímu" },
  ],
  cui: {
    mortgageModeling: "Hypotekárna modelácia",
    loanSummary: "Súhrn úveru",
    amortTableTitle: "Splátkový kalendár (po rokoch)",
    tableYear: "Rok",
    remaining: "Zostáva doplatiť",
    interestOfWhich: "Z toho na úrokoch",
    disclaimerMortgagePdf: "Prepočet je orientačný. Skutočná ponuka banky sa môže líšiť podľa bonity klienta, LTV a aktuálnych podmienok trhu. Modelácia nenahrádza záväznú ponuku úveru.",
    modelReady: "Modelácia pripravená",
    pdfFailed: "Nepodarilo sa vygenerovať PDF. Skús to prosím znova.",
    narrativeRate: "Výšku splátky aj celkové náklady úveru zásadne určuje úroková sadzba a dĺžka fixácie — oplatí sa ich pravidelne porovnávať.",
    narrativeInterest: "Za celú dobu splácania zaplatíte na úrokoch výrazne viac, než je samotná výška úveru; kratšia doba splácania preplatok znižuje.",
    live: "Živý výpočet",
    exportPdf: "Export PDF pre klienta",
    mortgageHeadline: "Koľko ťa bude stáť <em>vlastné</em> bývanie?",
    propertyPrice: "Cena nehnuteľnosti",
    downPayment: "Vlastné zdroje",
    rate: "Úroková sadzba",
    years: "Doba splácania",
    yearsUnit: "rokov",
    monthsUnit: "mesiacov",
    monthlyPayment: "Mesačná splátka",
    annuitySub: "Anuitná splátka pri pevnej sadzbe",
    overpayment: "Preplatenie",
    overPrincipal: "cez istinu",
    times: "×",
    loanAmount: "Výška úveru",
    totalPaid: "Celkom zaplatíte",
    interestPaid: "Z toho úrok",
    ltvLow: "Nízke LTV — vyjednáš lepší úrok.",
    ltvStd: "Štandardné LTV — bez problémov u väčšiny bánk.",
    ltvHigh: "Nad záväzným limitom {limit} — vlastných zdrojov treba aspoň {castka}.",
    applicantAge: "Vek žiadateľa",
    ltvLimit: "Záväzný limit {regulator}: {limit}.",
    ltvBezVeku: "Bez veku platí prísnejší limit {limit} (mladší ako 36 rokov: {mladi}).",
    principal: "Istina",
    interest: "Úrok",
    investmentHeadline: "Kde by mohli byť tvoje peniaze za <em>X</em> rokov?",
    monthlyDeposit: "Mesačný vklad",
    initialAmount: "Počiatočná čiastka",
    horizon: "Investičný horizont",
    expectedReturn: "Očakávaný výnos",
    portfolioValue: "Hodnota portfólia",
    deposited: "Vložené",
    earned: "Zarobené úrokom",
    chartLegendDeposit: "Vklady",
    chartLegendValue: "Hodnota portfólia",
    disclaimer: "Prepočet je orientačný. Skutočná ponuka banky sa môže líšiť podľa bonity klienta, LTV a aktuálnych podmienok trhu.",
    disclaimerInv: "Minulé výnosy negarantujú budúce. Prepočet je orientačný.",
    investmentModeling: "Investičná modelácia",
    oneTimeInvest: "Jednorázová investícia",
    monthlyInvest: "Mesačná investícia",
    investHorizon: "Plánovaná dĺžka investovania",
    riskProfile: "Rizikový profil",
    expectedValue: "Očakávaná hodnota",
    expectedValueSub: "Očakávaná hodnota na konci investovania",
    optimistic: "Optimistický scenár",
    pessimistic: "Pesimistický scenár",
    totalDeposited: "Celkom vložené",
    today: "Dnes",
    yearN: "rok",
    deposit: "Vklad",
    zhodnoceni: "Zhodnotenie",
    poslatKlientovi: "Poslať klientovi",
    rizikoPopis: "Vyšší rizikový profil môže priniesť vyšší výnos, ale aj väčšie kolísanie hodnoty. Hodnoty vychádzajú z historických výnosov globálnych akciových trhov.",
    narrativeInv1: "Pravidelné investovanie využíva silu zloženého úročenia — čím skôr začnete, tým viac za vás pracuje čas.",
    narrativeInv2: "Ide o modelový odhad podľa zvoleného rizikového profilu; výnosy nie sú zaručené a hodnota investície v čase kolíše.",
  },
  tools: {
    /* Nástroje ke schůzce — dlaždice na /nastroje. Bez těchhle klíčů by
       titulek i popis zůstaly česky ve všech jazycích (fallback). */
    "kalk-zlato": { t: "Zlato — koľko klientovi zostane", d: "Kedy padne prvý gram, koľko zje poplatok a rozdiel nákup/výkup, menové riziko dolára zvlášť a porovnanie s inými aktívami. Gramy aj v chỉ a lượng.", short: "Gramy, poplatok a kurz dolára" },
    "kalk-konsolidace": { t: "Konsolidácia úverov", d: "Spolu teraz vs. spolu potom — nie dve splátky. Dopočíta sadzbu každého úveru a vie ukázať aj prípad, keď sa konsolidácia NEOPLATÍ.", short: "Spolu teraz vs. spolu potom" },
    "kalk-podpojisteni": { t: "Podpoistenie prevádzky", d: "Koľko poisťovňa naozaj vyplatí, keď je poistná suma nižšia než hodnota majetku (§ 2854). So sezónnou špičkou zásob pred Tết a Vianocami.", short: "Koľko poisťovňa naozaj vyplatí" },
    "kalk-doplaceni": { t: "Doplatenie hypotéky skôr", d: "Mimoriadne splátky vs. investícia na rovnakom cashflow. Graf dvoch kriviek a ich priesečník, tri čísla pre klienta, scenár „trh nedá nič“ a klesajúce krytie. Prezentačný režim na stretnutie.", short: "Splácať navyše, alebo investovať?" },
    provize: { t: "Provízna kalkulačka", d: "201 produktov z katalógu BJ. Zadaj pozíciu + produkty → provízia za 1. rok aj opakovane. Pre poradcu aj nábor.", short: "201 produktov z katalógu BJ" },
    analyza: { t: "Finančná analýza", d: "Riadené 45min stretnutie — hodnoty, ciele, zdroje, riziká. Skripty vedú aj nováčika. Vyber klienta alebo založ nového.", short: "Riadené 45min stretnutie od A po Z" },
    posta: { t: "Pošta + AI Email", d: "Tvoj Gmail v CRM. Hlas/text príkaz → AI vygeneruje email + odošle. Hromadné AI kampane.", short: "Gmail v CRM + AI e-maily" },
    leadgen: { t: "Leadovač", d: "15 leadgen funnelov — Hypotéka, Investícia, SZČO, Rodina a ďalšie. Zdieľaj link, dostávaj leady do CRM.", short: "15 leadgen funnelov → CRM" },
    trychtyre: { t: "Lieviky", d: "15 hotových funnel landingov v štýle Konverzky (hodnota zadarmo → kontakt). Daj Náhľad, skopíruj svoj odkaz, zdieľaj. Lead padne do CRM.", short: "15 funnel landingov na zdieľanie" },
    "funnel-knihovna": { t: "Knižnica funnelov", d: "53 hotových funnelov kompletne: landing texty, e-mailové sekvencie, reklamy, ebooky, scenáre webinárov aj hovorov. Plus formulár, ktorý z tvojich odpovedí zloží zadanie na nový funnel.", short: "53 funnelov + skladač zadania" },
    mesicnik: { t: "Mesačník pre klientov", d: "Vydané číslo mesačníka pošleš klientom so súhlasom s marketingom: náhľad e-mailu aj webovej verzie, odhlásenie jedným klikom. Dáta z verejných zdrojov (ECB, centrálne banky a ďalšie).", short: "Číslo mesačníka klientom" },
    "byznys-plan": { t: "Môj biznis plán", d: "Ročný plán poradcu podľa vzoru z kurzu Ako budovať poradenský biznis: vlaňajšie čísla z CRM, vízia, podnikateľské a osobné ciele, marketing, mesačné ciele s odmenou, denné návyky, termíny revízie. Ukladá sa na server, tlač na A4.", short: "Vízia, ciele, marketing, mesačný plán" },
    trychtyrBuilder: { t: "Lievik od A do Z", d: "Sprievodca 7 krokmi podľa metodiky Konverzky: magnet, stránka, ďakovačka, telefonický skript, mini-webinár, e-mailová sekvencia, reklama a meranie (pixel). Šablóny na vyplnenie bez AI, uložené pre teba; hotové leadovače, lieviky a web len zapojíš.", short: "7 krokov od magnetu po pixel" },
    "fin-matematika": { t: "Finančná matematika", d: "Úver / Hypotéka, Investícia a Renta. Vlajka = dopočítaj čokoľvek. Veľký graf, validácia, frekvencia úroku.", short: "Úver, investícia, renta — dopočet" },
    penze: { t: "Penzijná kalkulačka (DPS/DIP)", d: "Penzijko a DIP: modelácia do budúcnosti so štátnou podporou a daňami, historická kalkulačka na skutočných výnosoch fondov, porovnanie fondov a plán renty.", short: "DPS + DIP, história, fondy, renta" },
    izp: { t: "Analýza pre Vietnamcov", d: "Vysvetlí klientovi, prečo má mať životné poistenie: príjem, balíček 10/20/30 %, riziká, graf do 60/65/70 rokov, čo dostane rodina a čo zostane.", short: "Poistenie a investície krok za krokom" },
    "zivotni-pojisteni": { t: "Životné poistenie", d: "Odporúčané krytie za pár sekúnd: smrť, invalidita, pracovná neschopnosť (PN), trvalé následky, vážne ochorenia. Pre ľahký predaj aj nováčikom.", short: "Odporúčané krytie za pár sekúnd" },
    "rodinny-plan": { t: "Rodinný finančný plán (CZ/VI)", d: "Pätnásť minút s klientom: príjem → výdavky → čo zostáva → čo sa stane pri výpadku → koľko ochrany a koľko na majetok. Dvojjazyčne česky a vietnamsky, režim pre klienta. Nezačína produktom.", short: "Pätnásť minút s klientom" },
    historicka: { t: "Historická kalkulačka", d: "Na reálnych dátach 1926–2026 ukáž klientovi, ako by investícia dopadla. S&P 500, dlhopisy, zlato, inflácia.", short: "Reálne dáta 1926–2026" },
    "svoboda": { t: 'Kedy budeš voľný', d: 'Peniaze preložené na čas. Namiesto piatich percent nad infláciou počuje klient, o koľko rokov skôr prestane musieť chodiť do práce. Posuvník navyše → značka na osi sa rozbehne doľava. Plus cena za čakanie.', short: 'Peniaze preložené na čas' },
    "hypoteka-rozhodnuti": { t: 'Hypotéka — štyri rozhodnutia', d: 'Koniec fixácie, 20 vs. 30 rokov, koľko dať vlastných, vplyv času. Porovnáva celé mesačné zaťaženie, nie len splátku — preto to často vyjde opačne, než klient čaká. Každá záložka končí jednou vetou.', short: 'Fixácia, splatnosť, vlastné, čas' },
    fixace: { t: 'Fixácia pod kontrolou', d: 'Čo sa stane PO fixácii. Krátka fixácia vs. dlhá na jednej osi, splátka proti rozpočtu domácnosti a jedno číslo: sadzba, nad ktorou to praskne. Na reálnych sadzbách ČNB 2006–2026 — vrátane toho, ako často v Česku sadzba po refixácii vyskočila.', short: 'Čo sa stane PO fixácii' },
    "renta-porovnavac": { t: "Čerpanie renty — tri spôsoby", d: "Koľko klient dostane mesačne pri pevnom %, kĺzavom priemere a mantineloch. Vidí aj cenu: kedy a o koľko by sa muselo znížiť. Portfólio poučené Nobelovou nadáciou, doložené rokmi 1966 a 2000.", short: "Pevné % vs. priemer vs. mantinely" },
    "investicni-strategie": { t: "Investičné stratégie", d: "Ako investujú najväčšie fondy a najbohatší — Nórsky fond, Nobelova nadácia, Ray Dalio, Core-Satellite. Pre klientov + zložené úročenie a nekonečná renta.", short: "Ako investujú najväčšie fondy" },
    "srovnavac-fondu": { t: "Porovnávač fondov", d: "Porovnaj dva fondy/ETF — koľko z výnosu si vezmú poplatky. Katalóg ETF + českých fondov, graf, rozdiel v sume. Pre klienta, bez AI.", short: "Dva fondy a čo vezmú poplatky" },
    "portfolio-doktor": { t: "Portfólio doktor", d: "Celé portfólio klienta naraz: vážená nákladovosť (a z koľkých % majetku je spočítaná), koľko urobí rozdiel za horizont, rozloženie, verdikt pri každej položke — vrátane „ponechať“. Nákladovosť zadávaš z KID, aplikácia si nič nevymýšľa.", short: "Nákladovosť celého portfólia" },
    "investicni-studio": { t: "Investičné štúdio (DEMO)", d: "Školiaca prezentácia pre klienta: HWM Lab (poplatok za výkon), Dnes vs. návrh, Portfolio Composer, historické krízy, rozklad nákladov. Modelový klient, nie osobné odporúčanie.", short: "Školiaca prezentácia pre klienta" },
    "nemovitost-pronajem": { t: "Nehnuteľnosť na prenájom", d: "Koľko byt na prenájom SKUTOČNE vynáša — cash flow v čase, koľko rokov ho dotuješ, efektívny výnos, stress test. Rozbije ružové predstavy klienta.", short: "Koľko byt na prenájom vynáša" },
    calculators: { t: "Kalkulačky", d: "20 finančných kalkulačiek — hypotéka, investície, poistenie, dôchodok, osobné financie.", short: "20 finančných kalkulačiek" },
    "portfolio-doctor": { t: "Portfolio Doctor", d: "Diagnostika klientskeho portfólia — ISIN → ETF alternatíva + AI brief.", short: "ISIN → ETF alternatíva + AI brief" },
    "akademie-produkty": { t: "Produktová akadémia pre nováčikov", d: "10 modulov: produkty, navolávanie, argumentácia, uzatváranie — s kvízmi a skriptmi. Z nováčika profík.", short: "10 modulov s kvízmi a skriptmi" },
    akademie: { t: "Akadémia poradcu (videá)", d: "Vzdelávacia séria videí — Mindset, Finančný plán, Obchodný proces a ďalšie.", short: "Vzdelávacia séria videí" },
    income: { t: "Cieľový príjem", d: "Spätný výpočet od požadovaného príjmu k počtu stretnutí a telefonátov.", labels: ["Požadovaný mesačný príjem", "Priemerná provízia/zmluva", "Konverzia stretnutie → zmluva", "Konverzia telefón → stretnutie"], funnel: ["Telefonátov za deň", "Telefonátov za mesiac", "Stretnutí za mesiac", "Zmlúv za mesiac"] },
    objections: { t: "Námietky & odpovede", d: "Kliknite na kartu pre zobrazenie odporúčanej odpovede.", q: ["Nemám záujem", "Mám poradcu", "Nemám čas", "Nemám peniaze", "Pošlite email", "Musím sa poradiť s manželom/kou", "Skúsim to sám", "Mám zmluvy v poriadku", "Teraz nie je dobrý čas", "Ako viete, že ste lepší?"], a: ["Chápem. Môžem sa spýtať, čo presne vám príde nezaujímavé?", "To je skvelé! Ako často vám váš poradca robí revíziu finančného plánu?", "Rozumiem, čas je vzácny. Ponúkam efektívne stretnutie na 45 minút.", "Práve preto je dôležité sa stretnúť. Pomáhame nájsť úspory v existujúcich zmluvách.", "Rád pošlem. Avšak každá situácia je jedinečná. Môžeme sa stretnúť na 30 minút?", "Samozrejme! Budete na stretnutí obaja — je dôležité, aby rozhodovanie bolo spoločné.", "Rešpektujem to. Viete, že priemerný človek bez poradcu stráca ročne 15–30 tisíc?", "To je skvelé! Kedy ste ich naposledy revidovali? Trh sa mení.", "Rozumiem. Kedy by to bolo lepšie? Rád sa ozvem.", "Nerobíme si nárok na to, že sme najlepší. Naša sila je v komplexnom prístupe."] },
    checklist: { t: "Kontrolný zoznam stretnutia A1", d: "Kompletný checklist pre prvé stretnutie.", cols: ["Pred stretnutím", "Počas stretnutia", "Po stretnutí"], before: ["Pripraviť prezentáciu", "Skontrolovať CRM údaje", "Pripraviť zmluvy na podpis", "Overiť dostupnosť klienta", "Pripraviť vizitky a materiály", "Nastaviť budík/pripomienku"], during: ["Ice break a budovanie vzťahu", "Zistenie očakávaní klienta", "Predstavenie beplan", "Finančná analýza (7 oblastí)", "Prezentácia riešenia", "Dohodnutie ďalšieho kroku", "Požiadať o odporúčanie"], after: ["Zapísať poznámky do CRM", "Odoslať zhrnutie emailom", "Pripraviť návrh zmlúv", "Naplánovať follow-up", "Aktualizovať pipeline"] },
    timer: { t: "Časovač stretnutia", d: "Časovač s 5 fázami pre štruktúrované stretnutie.", phases: ["Ice break", "Zistenie očakávaní", "Predstavenie", "Princíp komplexnosti", "Záver a termín"] },
    pyramid: { t: "Pyramída osobných financií", d: "Kliknite na vrstvu pre zobrazenie detailu.", layers: [{ n: "Investovanie", d: "Aktívne budovanie majetku — akcie, fondy, nehnuteľnosti." }, { n: "Ostatné potreby", d: "Sporiace účty, stavebné sporenie, účelové sporenie." }, { n: "Bývanie", d: "Vlastné bývanie alebo investícia do nehnuteľnosti." }, { n: "Budúce príjmy (penzijné)", d: "III. pilier penzijného sporenia so štátnymi príspevkami." }, { n: "Zabezpečenie príjmov", d: "Životné poistenie, úrazové poistenie, nemocenská." }] },
    compare: { t: "Porovnanie produktov", d: "Porovnanie finančných produktov vedľa seba." },
    glossary: { t: "Slovník pojmov", d: "Prehľadávateľný slovník finančných pojmov." },
  },
  g: [
    { t: "RPSN", d: "Ročná percentuálna sadzba nákladov — ukazuje skutočnú cenu úveru vrátane všetkých poplatkov.", e: "Banka ponúka úver so sadzbou 5 %, ale RPSN je 6,2 % kvôli poplatkom." },
    { t: "LTV", d: "Loan to Value — pomer výšky úveru k hodnote nehnuteľnosti.", e: "Pri kúpe bytu za 5 mil. Kč s hypotékou 4 mil. Kč je LTV 80 %." },
    { t: "Invalidita 1. stupňa", d: "Pokles pracovnej schopnosti o 35–49 %. Nárok na čiastočný invalidný dôchodok.", e: "Klient s chronickým ochorením, ktorý môže pracovať na čiastočný úväzok." },
    { t: "Invalidita 2. stupňa", d: "Pokles pracovnej schopnosti o 50–69 %.", e: "Klient po vážnom úraze, ktorý môže vykonávať iba ľahkú prácu." },
    { t: "Invalidita 3. stupňa", d: "Pokles pracovnej schopnosti o 70 % a viac. Plný invalidný dôchodok.", e: "Klient, ktorý nie je schopný žiadnej práce." },
    { t: "DPS", d: "Doplnkové penzijné sporenie — III. pilier penzijného systému so štátnymi príspevkami.", e: "Pri sporení 1 000 Kč mesačne získate štátny príspevok 230 Kč." },
    { t: "Transformovaný fond", d: "Pôvodné penzijné fondy s garanciou nezáporného zhodnotenia.", e: "Staré penzijné pripoistenie pred rokom 2013." },
    { t: "Volatilita", d: "Miera kolísania hodnoty investície v čase.", e: "Akcie majú vyššiu volatilitu než dlhopisy." },
    { t: "Diverzifikácia", d: "Rozloženie investície do viacerých aktív pre zníženie rizika.", e: "Investovať do akcií, dlhopisov aj nehnuteľností súčasne." },
    { t: "Zložené úročenie", d: "Úroky sa pripočítavajú k istine a ďalej zarábajú ďalšie úroky.", e: "100 000 Kč pri 7 % p.a. za 20 rokov = 386 968 Kč." },
    { t: "Cash flow", d: "Tok peňazí — rozdiel medzi príjmami a výdavkami za určité obdobie.", e: "Mesačný príjem 55 000 Kč mínus výdavky 42 000 Kč = voľné cash flow 13 000 Kč." },
    { t: "Finančný plán", d: "Komplexný dokument mapujúci finančnú situáciu klienta a navrhujúci optimálne riešenie.", e: "Plán zahŕňa poistenie, investície, sporenie a dôchodok." },
    { t: "Poistná udalosť", d: "Náhodná udalosť, na ktorú sa poistenie vzťahuje.", e: "Úraz, choroba, poškodenie majetku živelnou pohromou." },
    { t: "Poistné plnenie", d: "Suma vyplatená poisťovňou pri poistnej udalosti.", e: "Pri úraze s trvalými následkami poisťovňa vyplatila 500 000 Kč." },
    { t: "Fixácia", d: "Obdobie, počas ktorého je úroková sadzba hypotéky nemenná.", e: "Fixácia na 5 rokov znamená, že sadzba sa 5 rokov nezmení." },
    { t: "Anuitná splátka", d: "Rovnaká mesačná splátka počas celej doby úveru.", e: "Splátka 15 000 Kč mesačne počas celej doby hypotéky." },
    { t: "Bonita", d: "Schopnosť klienta splácať úver, hodnotená bankou.", e: "Banka posudzuje príjem, výdavky a existujúce záväzky." },
    { t: "ETF", d: "Exchange Traded Fund — fond obchodovaný na burze, sledujúci index.", e: "S&P 500 ETF sleduje 500 najväčších amerických firiem." },
    { t: "Dlhopis", d: "Cenný papier, ktorým emitent sľubuje splatenie istiny a úrokov.", e: "Štátne dlhopisy sú považované za bezpečnú investíciu." },
    { t: "Portfólio", d: "Súhrn všetkých investícií a aktív klienta.", e: "Portfólio zložené zo 60 % akcií a 40 % dlhopisov." },
    { t: "Rebalancing", d: "Pravidelné prispôsobenie zloženia portfólia cieľovej alokácii.", e: "Ak akcie vyrástli na 70 %, predať časť a dokúpiť dlhopisy." },
    { t: "TER", d: "Total Expense Ratio — celkové náklady fondu v percentách.", e: "Fond s TER 0,5 % si ročne strhne 0,5 % z investície." },
    { t: "Štátny príspevok", d: "Príspevok štátu k penzijnému alebo stavebnému sporeniu.", e: "Max. 230 Kč mesačne k penzijnému sporeniu pri vklade 1 700 Kč." },
    { t: "Vinkulácia", d: "Obmedzenie nakladania s finančnými prostriedkami v prospech tretej strany.", e: "Vinkulácia poistky v prospech banky pri hypotéke." },
    { t: "Odkladná doba", d: "Obdobie od vzniku poistnej udalosti do začiatku výplaty.", e: "Odkladná doba 28 dní pri pracovnej neschopnosti." },
    { t: "Konsolidácia dlhov", d: "Zlúčenie viacerých úverov do jedného s výhodnejšími podmienkami.", e: "Nahradenie 3 spotrebiteľských úverov jedným s nižšou splátkou." },
    { t: "FIRE", d: "Financial Independence, Retire Early — hnutie za finančnú nezávislosť.", e: "Cieľ: nasporiť 25-násobok ročných výdavkov a žiť zo 4% výberu." },
    { t: "Compliance", d: "Súlad s právnymi a regulačnými požiadavkami v odbore.", e: "Dodržiavanie pravidiel ČNB pre finančných poradcov." },
  ],
  // Poznámkový blok na nástenke (panel „Poznámky") — prázdny papier + štítky.
  poznamky: {
    title: "Poznámky",
    new: "Nová poznámka",
    placeholder: "Píšte…",
    emptyTitle: "Zatiaľ žiadna poznámka",
    emptyDesc: "Kliknite a píšte — prázdny papier, ktorý sa uloží sám.",
    allTags: "Všetky",
    addTag: "Pridať štítok",
    removeTag: "Odobrať štítok",
    tagPlaceholder: "štítok",
    filterEmpty: "So štítkom nič nie je.",
    clearFilter: "Zrušiť filter",
    delete: "Zmazať poznámku",
    deleteConfirm: "Naozaj zmazať?",
    saving: "Ukladám…",
    saved: "Uložené",
    saveFailed: "Neuložené — úložisko prehliadača je plné",
  },
  /* === NASTROJE: ruční převod jazykových ternárů (dávka „nastroje") === */
  nastroje: {
    /* === RÝCHLE NÁSTROJE V LIŠTE ANALÝZY (bočný pruh ikon) ===
     * Kalkulačky, ktoré poradcovi vyjdú PREZ rozrobenú analýzu, predvyplnené
     * číslami toho klienta. Modelácia sa NEUKLADÁ (pätka panela) a hlášky
     * enginu doplatenia idú na už preložených klíčoch
     * `nastroje.schuzka.doplaceni.hlaska*`. */
    pruh: {
      nadpis: "Rýchle nástroje",
      otevrit: "Otvoriť rýchle nástroje",
      zavrit: "Zavrieť",
      tabHypo: "Hypotéka",
      tabDoplaceni: "Hypotéka s investíciou",
      tabZivot: "Životné poistenie",
      tabInvestice: "Investícia",
      znovuZAnalyzy: "Načítať čísla znovu z analýzy",
      neukladaSeTuk: "Modelácia sa neukladá.",
      neukladaSeText: "Čísla z tohto panela nejdú do analýzy ani do plánu a po obnovení stránky sú preč. Čo chceš klientovi nechať, prepíš do analýzy alebo do návrhu riešenia.",
      padTuk: "Nástroj sa nepodarilo zobraziť.",
      padText: "Analýza je v poriadku a zostala otvorená. Skús iný nástroj a chybu nahlás — podrobnosť je v konzole prehliadača.",
      zAnalyzy: "z analýzy",
      zPrebytku: "z prebytku v analýze",
      bezPrijmu: "Bez čistého príjmu v analýze sa zadlženosť spočítať nedá.",
      chybiNadpis: "Chýba údaj",
      chybiObecne: "Niektorý vstup chýba alebo je mimo rozsahu — skontroluj zadanie.",
      skriptNadpis: "Čo povedať klientovi",
      hypo: {
        zadani: "Nehnuteľnosť a úver",
        cena: "Cena nehnuteľnosti",
        vlastni: "Vlastné zdroje",
        sazba: "Úroková sadzba",
        splatnost: "Splatnosť",
        dosaditPrumer: "Doplniť priemer trhu {sazba} ({obdobi})",
        prumerNeniNabidka: "Priemerná ponuková sadzba trhu, nie ponuka konkrétnej banky.",
        vysledek: "Splátka a limity",
        splatka: "Mesačná splátka",
        splatkaNote: "Rovnaká splátka po celú splatnosť pri zadanej sadzbe.",
        uver: "Výška úveru",
        ltv: "LTV — úver k cene",
        ltvLimit: "Záväzný limit {limit}.",
        bezVeku: "vek v analýze chýba, počíta sa s prísnejším limitom {limit}",
        ltvNad: "Nad limitom — vlastných zdrojov je potrebných aspoň {castka}.",
        dsti: "DSTI — splátky k príjmu",
        dstiLimit: "Odporúčaný limit {limit} čistého príjmu, započítané sú aj existujúce splátky.",
        dti: "DTI — dlh k príjmu",
        dtiLimit: "Odporúčaný limit {limit}× čistý ročný príjem.",
        celkemZaplaceno: "Celkom zaplatené banke",
        zTohoUroky: "Z toho úroky",
        stavajiciSplatky: "Existujúce splátky z analýzy",
        skript: "Banka sa pozerá na tri čísla: koľko si beriete oproti cene nehnuteľnosti, koľko vám splátky odkroja z príjmu a koľko dlžíte oproti ročnému príjmu. Pozrime sa, ako na tom ste — a kde by bolo treba pridať vlastné zdroje.",
        chybiCena: "Doplň cenu nehnuteľnosti.",
        chybiSazba: "Doplň úrokovú sadzbu — bez nej splátka nevznikne.",
        chybiSplatnost: "Doplň splatnosť v rokoch.",
        chybiVlastni: "Doplň vlastné zdroje — bez nich sa nedá vypočítať výška úveru.",
        bezVlastnich: "Klient nemá vlastné zdroje",
        chybiVlastniNadCenu: "Vlastné zdroje sú vyššie než cena nehnuteľnosti — na úver potom nezostáva nič.",
      },
      doplaceni: {
        zadani: "Hypotéka a peniaze navyše",
        jistina: "Zvyšná istina",
        sazba: "Úrok hypotéky",
        splatnost: "Splatnosť",
        volnaCastka: "Voľné peniaze mesačne",
        vynos: "Očakávaný výnos investície",
        horizont: "Chce doplatiť za",
        predpoklad: "predpoklad poradcu",
        neniVAnalyze: "v analýze nie je — doplň",
        predpokladyPoznamka: "Počíta sa s poplatkom fondu {ter} ročne a s daňou z predaja pri doplatení. Výnos zadávaj nominálne, teda rovnako ako úrok hypotéky — inak by investícia dostala zadarmo celú infláciu.",
        stitkyPoznamka: "Štítky pri poliach hovoria, odkiaľ číslo prišlo, keď sa panel otvoril. Čo prepíšeš, je tvoj predpoklad.",
        chybiJistina: "Doplň zvyšnú istinu hypotéky.",
        chybiSazba: "Doplň úrokovú sadzbu hypotéky. Nula nie je sadzba, a bez sadzby by investícia vyhrala vždy.",
        vysledek: "Za {roky}: čo klientovi zostane",
        cestaSplaceni: "Splácať navyše",
        cestaSplaceniNote: "Hypotéka doplatená za {kdy}, potom sa tá istá suma investuje.",
        cestaInvestice: "Investovať a doplatiť naraz",
        cestaInvesticeNote: "Portfólio po dani {portfolio} mínus zvyšný dlh {dluh}.",
        vitezInvestice: "Lepšie vychádza investovať",
        vitezInvesticeText: "Za {roky} zostane klientovi o {castka} viac než pri splácaní navyše. Platí to len vtedy, keď trh výnos naozaj dodá.",
        vitezSplaceni: "Lepšie vychádza splácať navyše",
        vitezSplaceniText: "Za {roky} zostane klientovi o {castka} viac, keď peniaze pošle do hypotéky. Splátka je istá, výnos nie.",
        remiza: "Obe cesty vyjdú narovnako",
        remizaText: "Za {roky} je rozdiel medzi cestami zanedbateľný. Rozhoduje teda istota, nie výnos — a istá je mimoriadna splátka.",
        splatka: "Splátka hypotéky",
        vydajObe: "Z rozpočtu odíde v oboch cestách",
        usporaSplaceni: "Úspora na úrokoch — splácať navyše",
        usporaInvestice: "Úspora na úrokoch — investovať",
        danPriDoplaceni: "Daň z predaja pri doplatení",
        poplatky: "Poplatky investície spolu",
        hranice: "Hraničný výnos investície",
        hraniceNote: "Pod týmto výnosom investícia prehráva — už po dani a poplatkoch. Nad ním zarobí.",
        hraniceNikdy: "Investícia mimoriadnu splátku neprekoná ani pri veľmi vysokom výnose — typicky pre krátky horizont, poplatky alebo daň.",
        prusecikText: "Portfólio prvýkrát pokryje zvyšný dlh za {roky}. Doplácalo by sa {castka} — od tej chvíle sa klient môže rozhodnúť.",
        prusecikNikdy: "Portfólio na pokrytie dlhu v zadanom horizonte nedosiahne.",
        urokyPoznamka: "Úspora na úrokoch sa porovnáva až do úplného splatenia, nie len k dátumu doplatenia — inak by cesta, ktorá ešte dlží, vypadala úspornejšie, než je.",
        orientacniNadpis: "Orientačná modelácia",
        orientacni: "Nie je to ponuka úveru ani prísľub plnenia a nepočíta s podmienkami konkrétnej zmluvy. Limit bezplatnej mimoriadnej splátky, poplatky banky a sadzbu po fixácii over v zmluve; daňové pravidlá sa do dátumu doplatenia môžu zmeniť.",
        plnaKalkulacka: "Scenáre prepadu trhu, fixáciu a klesajúce krytie spočíta plná kalkulačka v Nástrojoch.",
        skript: "Máte dve možnosti, ako sa hypotéky zbaviť. Buď do nej posielate navyše, alebo tie peniaze investujete a doplatíte ju naraz. Spočítajme oboje — a hlavne to, čo sa stane, keď trh nezarobí toľko, koľko čakáme.",
      },
      zivot: {
        zadani: "Rodina a záväzky",
        nezbytne: "Nevyhnutné výdavky domácnosti",
        horizont: "Na koľko rokov kryť",
        dluhy: "Dlhy spolu",
        rezerva: "Likvidná rezerva",
        vdovsky: "Vdovský dôchodok",
        sirotci: "Sirotský dôchodok celkom",
        davkaSablona: "šablóna krajiny — prepíš podľa klienta",
        varianta: "Variant krytia",
        smrt: "Poistná suma — smrť",
        invalidita: "Poistná suma — invalidita",
        zavazne: "Závažné ochorenia",
        tnu: "Trvalé následky úrazu",
        pn: "Pracovná neschopnosť",
        denne: " / deň",
        rozpad: "Z toho dlhy {dluhy}, ciele {cile} a výdavky domácnosti {vydaje}.",
        chybiPrijem: "V analýze nemá príjem nikto — kapitálová metóda potom nemá z čoho počítať.",
        chybiVydaje: "Doplň nevyhnutné výdavky domácnosti.",
        chybiHorizont: "Doplň, na koľko rokov má krytie vystačiť.",
        chybiPozustalostni: "Pre túto krajinu nemáme overenú pozostalostnú dávku — bez nej by krytie smrti vyšlo podstrelené. Doplň ju do poistných limitov.",
        skript: "Spočítam vám to naopak, než to robí poisťovňa. Nie koľko si môžete dovoliť platiť, ale koľko by rodina potrebovala, aby žila ďalej rovnako a dokončila to, čo ste si naplánovali. Až od toho čísla sa bavíme o cene.",
      },
      invest: {
        zadani: "Vklady a horizont",
        mesicne: "Mesačne",
        jednorazove: "Jednorazovo dnes",
        rezervaNeni: "likvidná rezerva sa sem nedopĺňa",
        roky: "Doba investovania",
        vynos: "Očakávaný výnos",
        vynosPredpoklad: "predpoklad poradcu",
        vysledek: "Koľko z toho bude",
        konecnaHodnota: "Hodnota na konci",
        vDnesnichCenach: "Nominálne, bez prepočtu na dnešné ceny — inflácia kúpnu silu zníži.",
        vlozeno: "Vložené spolu",
        vynosCelkem: "Z toho výnos",
        neniGaranceNadpis: "Výnos nie je garantovaný.",
        neniGarance: "Je to predpoklad, nie prísľub. Trh môže niekoľko rokov klesať a hodnota môže byť aj nižšia než vložená suma. Povedz to klientovi skôr, než mu ukážeš konečné číslo.",
        skript: "Toto je to, čo vám každý mesiac zostáva. Nechajte to ležať na účte a za desať rokov to bude tá istá suma, len si za ňu kúpite menej. Tu je druhá možnosť — a hneď pri nej aj veta, ktorú vám musím povedať: výnos je predpoklad, nie prísľub.",
        chybiVklad: "Doplň mesačný vklad alebo jednorazovú sumu.",
        chybiRoky: "Doplň dobu investovania v rokoch.",
        chybiVynos: "Doplň očakávaný výnos.",
      },
    },
    /* === NÁSTROJE KE SCHŮZCE (zlato / konsolidace / podpojištění) ===
     * Klientské kalkulačky na /kalkulacka/:nastroj. Texty jsou psané tak, aby
     * je poradce mohl na schůzce ŘÍCT NAHLAS — proto tu jsou celé věty, ne
     * jen štítky. Vietnamská verze nese české odborné termíny v závorce,
     * protože klient i úřad je uvidí na smlouvě.
     * ⚠️ Čísla v kalkulačkách jsou ŠABLONA, ne nabídka — viz `sablonaText`. */
    schuzka: {
      sekce: "Nástroje na stretnutie",
      titulek: "Kalkulačky, ktoré klient vidí na stole",
      podtitulek: "Štyri výpočty, na ktorých sa stretnutie láme: koľko zlata klientovi naozaj zostane, či sa konsolidácia vyplatí — aj keď sa nevyplatí — koľko poisťovňa naozaj vyplatí, a či hypotéku splácať navyše, alebo investovať a doplatiť ju naraz. Mena sa berie z krajiny tvojho tenanta, nie z jazyka.",
      zpet: "Späť na Nástroje",
      tabZlato: "Zlato",
      tabKonsolidace: "Konsolidácia úverov",
      tabPodpojisteni: "Podpoistenie",
      tabDoplaceni: "Doplatenie hypotéky",
      zadani: "Zadanie",
      vysledek: "Výsledok",
      vetaNaSchuzku: "Veta na stretnutie — povedz ju doslova",
      kdyNedoporucit: "Kedy toto NEODPORÚČAJ",
      postup: "Krok za krokom",
      orientacniTuk: "Orientačný výpočet, nie ponuka.",
      orientacniText: "Modelácia slúži na vysvetlenie, ako produkt funguje. Nie je to ponuka, prísľub plnenia ani individuálne odporúčanie. Záväzné čísla dá až zmluva, cenník a poistné podmienky.",
      sablonaTuk: "Čísla sú šablóna — over ich pred stretnutím.",
      sablonaText: "Ceny, sadzby aj poplatky sa menia. Vytiahni si aktuálne hodnoty z partnerského portálu alebo zo sadzobníka ku dňu stretnutia a prepíš ich sem.",
      mesicOne: "mesiac",
      mesicFew: "mesiace",
      mesicMany: "mesiacov",
      rokOne: "rok",
      rokFew: "roky",
      rokMany: "rokov",
      zlato: {
        popis: "Klient nekupuje len zlato — kupuje zlato, poplatok, rozdiel medzi nákupnou a výkupnou cenou a k tomu cudziu menu. Ukáž mu to všetko naraz, nech o dva roky nemá prekvapenie.",
        jednorazove: "Jednorazový vklad",
        mesicne: "Mesačná platba",
        roky: "Horizont",
        typ: "Typ zmluvy — koľko z platby ide na poplatok",
        typJednorazovy: "Jednorazový nákup",
        typPopis100: "100/0 — kým nie je poplatok splatený, klient nekupuje ani gram. Toto mu povedz ako prvé.",
        typPopis7030: "70/30 — sedemdesiat percent platby ide na poplatok, tridsať na kov. Gram pribúda od začiatku, poplatok je však vyšší.",
        typPopis5050: "50/50 — polovica na poplatok, polovica na kov. Najrýchlejší štart, najdrahší poplatok.",
        typPopisJednorazovy: "Jednorazový nákup — z platieb sa nestrháva žiadny poplatok, klient platí len cenu kovu a rozdiel nákup/výkup.",
        vstupniPoplatek: "Vstupný poplatok",
        vstupniPoplatekHint: "Pri programoch, kde sa poplatok platí za každý kus zvlášť, spočítaj všetky kusy.",
        cenaNakup: "Nákupná cena za gram",
        cenaVykup: "Výkupná cena za gram",
        cenyHint: "Obe ceny vytiahni z portálu ku dňu stretnutia. Rozdiel medzi nimi je náklad, ktorý v žiadnom cenníku poplatkov nenájdeš.",
        rustKov: "Rast ceny kovu (v USD) % p.a.",
        zmenaKurzu: "Zmena kurzu USD/{mena} % p.a.",
        kurzHint: "Zlato sa kótuje v dolároch, klient žije v domácej mene. Keď domáca mena posilní, dolárový zisk sa cestou stratí. Preto sú tu dva posuvníky, nie jeden.",
        gramy: "Koľko zlata bude mať",
        jednotky: "{chi} chỉ · {luong} lượng (vietnamské jednotky hmotnosti)",
        vlozeno: "Vložené spolu",
        hodnota: "Hodnota pri výkupe",
        rozdil: "Rozdiel: {castka}",
        naklady: "Zaplatené na poplatku a rozdiele cien",
        spread: "Rozdiel nákup / výkup",
        vynosPa: "Výnos p.a. (vnútorné výnosové percento)",
        nedoplaceno: "Vstupný poplatok zostane nedoplatený",
        prvniGramNadpis: "Prvý gram zlata",
        prvniGramHned: "Klient kupuje kov už z prvej platby.",
        prvniGramZa: "Klient kúpi prvý gram až v {mesic}. mesiaci. Dovtedy platí len poplatok.",
        prvniGramNikdy: "Za celý zvolený horizont klient nekúpi ani gram — poplatok sa nestihne splatiť. Skráť cieľ alebo zvýš platbu.",
        bodZvratuNadpis: "Kedy je klient na svojom",
        bodZvratu: "V {mesic}. mesiaci, teda zhruba o {roky} roka.",
        bodZvratuNikdy: "Za zvolený horizont sa klient k vloženým peniazom nedostane. Povedz mu to skôr, ako podpíše.",
        menoveRizikoNadpis: "Menové riziko — klient nekupuje len zlato",
        menoveRizikoText: "Cena zlata je v dolároch, klient ju však platí a inkasuje v {mena}. Kto kúpil zlato pri slabej domácej mene, o časť zisku prišiel, len čo mena posilnila. Toto číslo ukazuje, koľko z výsledku urobil kurz — nie kov.",
        kurzUdelal: "Z výsledku urobil kurz",
        kurzScenareNadpis: "Čo ak sa kurz pohne inak",
        kurzScenarLabel: "Kurz {proc} p.a.",
        grafNadpis: "Vložené peniaze proti hodnote kovu",
        grafVlozeno: "Vložené",
        grafHodnota: "Hodnota pri výkupe",
        grafRok: "Rok",
        porovnaniNadpis: "Rovnaké peniaze v iných aktívach",
        porovnaniText: "Dlhodobé nominálne priemery z verejných dát (1928 – 2024, v dolároch), bez poplatkov a daní na oboch stranách. Slúžia na porovnanie rádu, nie na výber produktu — a rozhodne nie ako sľub výnosu.",
        aktivumAkcie: "Široký akciový index",
        aktivumZlato: "Zlato (historický priemer)",
        aktivumDluhopisy: "Dlhopisy",
        aktivumNemovitosti: "Nehnuteľnosti",
        aktivumHotovost: "Hotovosť a sporiaci účet",
        aktivumTentoPlan: "Tento plán so zlatom",
        mesicuInfo: "Modelácia počíta po mesiacoch, spolu {mesicu}.",
        skript: "„Skôr než čokoľvek podpíšeme, ukážem vám tri čísla. Po prvé: prvý gram zlata kúpite až v mesiaci, ktorý vidíte tu na obrazovke — dovtedy platíte poplatok. Po druhé: medzi nákupnou a výkupnou cenou je rozdiel, takže hneď po nákupe má vaše zlato nižšiu hodnotu než to, čo ste zaplatili. A po tretie: zlato je v dolároch, vy žijete v domácej mene — keď mena posilní, časť zisku vám zoberie kurz. Ak vám to sedí, ideme ďalej. Ak nie, mám pre vás iné riešenie.“",
        kdyNe: [
          "Klient nemá likvidnú rezervu na tri až šesť mesiacov výdavkov. Zlato nie je rezerva — výkup trvá dni a cena môže byť práve dole.",
          "Klient má drahé dlhy. Kreditná karta za dvadsať percent ročne porazí akýkoľvek očakávaný výnos zlata. Najprv konsolidácia, potom kov.",
          "Horizont je kratší než päť až sedem rokov. Vstupný poplatok a rozdiel nákup/výkup sa za ten čas nestihnú umoriť.",
          "Klient nemá vyriešené zabezpečenie príjmu a bývania. Zlato nezaplatí hypotéku, keď po úraze nemôže pracovať.",
          "Klient chce dať do zlata väčšinu majetku alebo z toho chce žiť. Zlato nenesie žiadny úrok ani dividendu — renta zo zlata je rozpredávanie majetku.",
        ],
      },
      konsolidace: {
        popis: "Nižšia splátka nie je lacnejší úver. Porovnávajú sa dve celkové sumy, nie dve splátky. Kalkulačka vie ukázať aj prípad, keď sa konsolidácia neoplatí — a práve ten z teba urobí poradcu, ktorému klient verí.",
        predlohy: "Predvyplnené situácie",
        predlohaVyplati: "Ukážka: oplatí sa",
        predlohaNevyplati: "Ukážka: neoplatí sa",
        predlohyHint: "Modelové čísla na tréning, nie dáta reálneho klienta. Klikni a prepíš ich podľa toho, čo klient priniesol.",
        uveryNadpis: "Čo klient spláca dnes",
        pridat: "Pridať úver",
        smazat: "Odobrať úver",
        zustatek: "Zostatok",
        splatka: "Mesačná splátka",
        zbyva: "Zostáva splátok",
        poplatekPredcasne: "Poplatok za predčasné splatenie",
        dopoctenaSazba: "Dopočítaná sadzba",
        sazbaNelze: "nedá sa dopočítať",
        nazevKreditka: "Kreditná karta",
        nazevNebankovni: "Nebanková pôžička",
        nazevSplatkovyProdej: "Nákup na splátky",
        nazevBankovniPujcka: "Banková pôžička",
        nazevAutoUver: "Úver na auto",
        nazevNovy: "Ďalší záväzok",
        nabidkaNadpis: "Čo ponúka banka",
        novaSazba: "Nová sadzba",
        novaSplatnost: "Nová splatnosť",
        poplatekZaSjednani: "Poplatok za uzatvorenie",
        splatkaRucne: "Splátka od banky",
        splatkaRucneHint: "Nechaj nulu a splátka sa dopočíta. Ak ju banka povedala, napíš ju sem.",
        celkemTed: "Spolu zaplatí teraz",
        celkemTedNote: "Dnešné splátky: {splatka}",
        celkemPo: "Spolu zaplatí po konsolidácii",
        celkemPoNote: "Nová splátka: {splatka}",
        uspora: "Úspora",
        zaplatiNavic: "Zaplatí navyše",
        ulevaMesicne: "Úľava na splátke",
        prodlouzeni: "Predĺženie splácania",
        prodlouzeniZadne: "nepredlžuje sa",
        odsunuto: "Koľko z úľavy je len odsunuté",
        sazbaTed: "Dnešná vážená sadzba",
        novaJistina: "Nová istina vrátane poplatkov",
        poplatkyCelkem: "Poplatky spolu",
        verdiktVyhra: "Oplatí sa",
        verdiktVyhraText: "Klient platí menej mesačne aj spolu. Skontroluj poplatky za predčasné splatenie a nechaj si od každého veriteľa potvrdiť nulový zostatok.",
        verdiktLevnejsi: "Spolu lacnejšie, ale splátka bude vyššia",
        verdiktLevnejsiText: "Klient zaplatí menej, ale mesačne musí utiahnuť viac. Over, že mu to rozpočet dovolí — inak si ho posunul k omeškaniu.",
        verdiktUleva: "Nižšia splátka, ale zaplatí viac",
        verdiktUlevaText: "Môže to byť správne rozhodnutie, keď ide o to nespadnúť do omeškania a do registrov. Ale musí to zaznieť nahlas: klient si kupuje úľavu a platí za ňu. Nikdy to nepredávaj ako úsporu.",
        verdiktNevyplati: "Neoplatí sa",
        verdiktNevyplatiText: "Ani spolu, ani na splátke. Povedz to klientovi rovno a ponúkni niečo iné — mimoriadnu splátku, inú splatnosť alebo zlúčenie len tých najdrahších záväzkov.",
        hranice: "Aby konsolidácia vyšla nákladovo aspoň narovnako, splatnosť nesmie byť dlhšia ako {mesicu}.",
        hraniceNelze: "Pri tejto sadzbe nevyjde konsolidácia nákladovo lepšie pri žiadnej splatnosti. Vypýtaj si inú ponuku.",
        skript: "„Pozrite sa na tieto dve čísla. Vľavo je, koľko zaplatíte, ak necháte všetko tak, ako to je. Vpravo je, koľko zaplatíte po konsolidácii. Splátka vám klesne — to je pravda. Ale rozhodujeme sa podľa tých dvoch celkových čísel, nie podľa splátky. Ak vyjde vpravo viac, znamená to, že si kupujete pokoj a platíte zaň. To je legitímne rozhodnutie, len musíte vedieť, že ho robíte.“",
        kroky: [
          "Spíš každý záväzok: zostatok, splátku, počet zostávajúcich splátok, sadzbu a poplatok za predčasné splatenie.",
          "Nechaj si od klienta doniesť výpisy z registrov. Dva až tri záväzky si obyčajne nespomenie — bez nich počítaš zle.",
          "Spočítaj obe celkové sumy a až potom hovor o splátke.",
          "Podaj žiadosť s dokladmi: doklad totožnosti, zmluvy ku všetkým zlučovaným úverom, doloženie príjmu alebo výpisy z účtu.",
          "Po vyplatení si od každého pôvodného veriteľa vyžiadaj potvrdenie o nulovom zostatku. Toto je najčastejšia chyba celej konsolidácie.",
          "Zruš uvoľnené kreditné karty a povolené prečerpania. Inak sa klient do roka zadlží znova a ty si mu nepomohol.",
        ],
        kdyNe: [
          "Nová sadzba je rovnaká alebo vyššia a jediná zmena je dlhšia splatnosť.",
          "Klient by zlúčil aj záväzky, ktoré o pár mesiacov doplatí — pri nich už takmer žiadny úrok nezostáva.",
          "Poplatky za predčasné splatenie a za uzatvorenie zjedia celú úsporu.",
          "Klient si nechá kreditné karty a prečerpania otvorené.",
          "Časť dlhov je v exekúcii, po splatnosti, voči štátu alebo u súkromných osôb — tie banka do konsolidácie nezoberie, hoci rozpočet zaťažujú.",
        ],
      },
      podpojisteni: {
        popis: "Keď je poistná suma nižšia než skutočná hodnota majetku, poisťovňa kráti plnenie v rovnakom pomere — a kráti aj malú škodu. Pri obchode s potravinami to býva rozdiel státisícov.",
        polozkyNadpis: "Spočítaj, čo v prevádzke naozaj je",
        polozkyHint: "Väčšina podpoistenia vzniká tým, že sa na niečo zabudlo. Prejdite to spolu položku po položke.",
        stavebniUpravy: "Stavebné úpravy a vstavby",
        vybaveni: "Vybavenie a stroje",
        elektronika: "Elektronika a pokladnica",
        zasoby: "Zásoby tovaru",
        hotovost: "Hotovosť v prevádzke",
        veciKlientu: "Veci prevzaté od zákazníkov",
        polozkyCelkem: "Hodnota spolu",
        dosadit: "Dosadiť do výpočtu",
        hodnota: "Skutočná hodnota majetku",
        hodnotaHint: "Koľko by stálo obstarať to znova, nie koľko to stálo vtedy.",
        castka: "Poistná suma v zmluve",
        castkaHint: "Odpíš ju z poistky, nie z pamäti.",
        skoda: "Výška škody",
        spoluucast: "Spoluúčasť",
        sezonni: "Sezónna špička zásob",
        sezonniHint: "Pred Tết a pred Vianocami má obchod na sklade násobok bežných zásob. Poistná suma zostala z času uzatvorenia — a škoda vzniká práve vtedy.",
        podpojisteni: "Podpoistenie",
        pomerNote: "Krytých je {pomer} hodnoty",
        vyplati: "Poisťovňa vyplatí",
        doplaci: "Klient dopláca zo svojho",
        hodnotaVeSpicce: "Hodnota majetku v špičke",
        chybiVCastce: "O koľko zvýšiť poistnú sumu",
        ztrataProti: "Strata proti správne uzatvorenej zmluve",
        varovaniTuk: "Táto zmluva je podpoistená.",
        varovaniText: "Poisťovňa zníži plnenie v rovnakom pomere, v akom je poistná suma k hodnote majetku. Platí to aj pre malú škodu. Zvýš poistnú sumu, alebo klientovi rovno povedz, koľko bude doplácať.",
        vporadkuTuk: "Krytie zodpovedá hodnote majetku.",
        vporadkuText: "Plnenie sa krátiť nebude. Overuj to znova pri každom servisnom stretnutí — ceny stavby aj zásob rastú a poistná suma sama nenaskočí.",
        tabulkaNadpis: "Kráti sa aj malá škoda",
        tabSkoda: "Škoda",
        tabPlneni: "Vyplatí",
        tabDoplaci: "Doplatí klient",
        zakonNadpis: "Odkiaľ to plynie",
        zakonText: "Český občiansky zákonník (89/2012 Sb.), § 2854: ak je poistná suma v čase poistnej udalosti nižšia než poistná hodnota poisteného majetku, poistiteľ zníži poistné plnenie v rovnakom pomere — okrem prípadu, keď je v zmluve dojednané, že plnenie znížené nebude. Vždy over konkrétne poistné podmienky.",
        skript: "„Poistnú sumu máte nižšiu, než koľko ten obchod naozaj stojí. Neznamená to, že vám poisťovňa nezaplatí — znamená to, že vám z každej škody zaplatí len toľko percent, na koľko percent je obchod poistený. Ukážem vám to: tu je vaša škoda a tu je, čo naozaj príde na účet. A pred Tết, keď máte plný sklad, je ten rozdiel ešte väčší. Poďme to zrovnať teraz, kým sa nič nestalo.“",
        kdyNe: [
          "Klient nechce alebo nemôže doložiť hodnotu majetku — potom poistnú sumu nevymýšľaj, nechaj ju dopočítať z účtovníctva alebo od znalca.",
          "V zmluve je dojednané, že sa plnenie nekráti. Potom tento výpočet neplatí a musíš vychádzať z konkrétnych poistných podmienok.",
          "Klient chce zvýšiť poistnú sumu, ale nemá splnené zabezpečenie, revízie alebo hygienické povinnosti — poisťovňa môže krátiť z iného dôvodu a vyššia suma mu nepomôže.",
          "Ide o veci osobitnej hodnoty, napríklad cennosti a drahé kovy — tie majú v poistení vlastné podlimity a tento výpočet ich nepokrýva.",
        ],
      },
      /* === DOPLACENÍ HYPOTÉKY (mimořádné splátky vs. investice) ===
       * Nástroj, kterým se klient přemlouvá, aby NESPLÁCEL dluh. Texty proto
       * musí unést i opačný závěr: `verdiktSplaceni`, `rizikoText`, scénáře
       * a `kdyNe` nejsou zdvořilostní vata — bez nich je to slib výnosu.
       * Odborné termíny nechávej v závorce česky, klient je uvidí na smlouvě. */
      doplaceni: {
        popis: "Klient má hypotéku a pár stoviek mesačne navyše. Buď ich pošle do hypotéky, alebo ich investuje a po dohodnutom čase dlh jednorazovo doplatí. Obe cesty minú z rozpočtu úplne rovnako — líšia sa len tým, čo klientovi na konci zostane. A hlavne je vidieť okamih, keď investícia zvyšný dlh prvýkrát pokryje.",
        prezentace: "Spustiť prezentáciu",
        zadaniHypoteka: "Hypotéka",
        jistina: "Koľko zostáva doplatiť",
        jistinaHint: "Zvyšná istina, nie pôvodná výška úveru. Vytiahni ju z výpisu, nie z pamäti klienta.",
        sazba: "Úroková sadzba",
        splatnost: "Splatnosť",
        horizont: "Za koľko rokov chce doplatiť",
        horizontHint: "Dátum doplatenia je pevný. Trh sa ho nepýta — preto je vedľa úspory aj panel rizika.",
        fixace: "Fixácia",
        fixaceHint: "Nula = jedna sadzba po celý čas. Inak sa po fixácii prepočíta aj splátka, rovnako ako v banke.",
        sazbaPoFixaci: "Sadzba po fixácii",
        splatkaInfo: "Mesačná splátka {splatka} · hypotéka dobehne sama za {splatnost}.",
        zadaniInvestice: "Peniaze navyše a investícia",
        volnaCastka: "Voľná suma mesačne",
        volnaCastkaHint: "Tie isté peniaze idú v oboch cestách — raz do hypotéky, druhý raz do investície. Bez toho by porovnanie nebolo férové.",
        jednorazovyVklad: "Jednorazovo dnes",
        vynos: "Očakávaný výnos",
        rezim: "Zadaný výnos je",
        rezimNominalni: "Nominálny (ako úrok)",
        rezimRealny: "Reálny (nad infláciou)",
        rezimHint: "Úrok hypotéky je nominálny. Postaviť reálnych 6 % proti nominálnym 4,9 % znamená dať investícii zadarmo celú infláciu — preto sa tu musí vybrať, nie odhadnúť.",
        poplatekVstupni: "Vstupný poplatok z každého vkladu",
        poplatekRocni: "Priebežný poplatok (TER)",
        poplatkyHint: "Reálny fond stojí 1–2 % ročne. Nula je najrýchlejší spôsob, ako výsledok investície nadhodnotiť.",
        trojiceNadpis: "Čo klientovi zostane za {roky}",
        cestaSplaceni: "Splácam navyše",
        cestaSplaceniNote: "Hypotéka je preč za {kdy}, potom sa investuje uvoľnená splátka.",
        cestaInvestice: "Investujem a potom doplatím",
        cestaInvesticeNote: "Portfólio po zdanení {portfolio} mínus zvyšný dlh {dluh}.",
        rozdilZisk: "Investíciou navyše",
        rozdilZtrata: "Investíciou menej",
        rozdilNote: "Rozdiel čistého majetku oboch ciest.",
        vydajObe: "Z rozpočtu odíde v oboch cestách",
        urokyBezZasahu: "Úroky, keď sa nerobí nič",
        urokySplaceni: "Úroky pri mimoriadnych splátkach",
        urokyInvestice: "Úroky pri investícii",
        usporaSplaceni: "Ušetrené na úrokoch — splácanie navyše",
        usporaInvestice: "Ušetrené na úrokoch — investícia",
        danPriDoplaceni: "Daň pri predaji na doplatenie",
        poplatkyCelkem: "Poplatky investície spolu",
        urokyPoznamka: "Úroky sa počítajú, kým hypotéka naozaj neskončí — nie len do zvoleného roka. Cesta, ktorá v cieľovom roku ešte dlží, by sa inak chválila úsporou, ktorú iba ešte nezaplatila.",
        verdiktInvestice: "Investícia vychádza lepšie — a klient musí vedieť prečo",
        verdiktInvesticeText: "Rozdiel robí výnos nad úrokom hypotéky, a ten nie je zaručený. Prejdi s klientom panel rizika hneď pod tým a povedz mu aj hraničný výnos.",
        verdiktSplaceni: "Mimoriadna splátka vychádza lepšie",
        verdiktSplaceniText: "Úspora úroku je istá a nezdanená, výnos investície ani jedno. Tu nie je čo vysvetľovať — odporuč splácanie.",
        verdiktRemiza: "Obe cesty vychádzajú narovnako",
        verdiktRemizaText: "Keď je rozdiel v desiatkach eur, rozhoduje istota a pokoj klienta, nie tabuľka. Splátka je istá, výnos nie.",
        grafNadpis: "Dlh klesá, investícia rastie",
        grafDluh: "Zvyšný dlh",
        grafPortfolio: "Hodnota investície po zdanení",
        grafRok: "Rok",
        grafJednotka: "Zvislá os je v tisícoch {mena}. Presnú sumu ukáže bublina po nabehnutí na krivku.",
        prusecikNadpis: "Okamih, keď je na doplatenie",
        prusecikText: "Zhruba za {rok} investícia prvýkrát pokryje zvyšný dlh ({castka}). Od tej chvíle si klient môže vybrať, či doplatí, alebo nechá peniaze pracovať ďalej.",
        prusecikNikdy: "Za zvolený horizont investícia zvyšný dlh nepokryje. Zvýš voľnú sumu alebo posuň dátum doplatenia — a povedz to klientovi skôr, než sa rozhodne.",
        rizikoNadpis: "A čo keď trh nedá nič",
        rizikoText: "Splátka hypotéky je istá, výnos investície nie. Ukáž klientovi obe strany — poradca, ktorý prinesie aj zlý scenár, je ten, ktorému sa verí. Kladné číslo znamená, že vychádza lepšie investícia, záporné mimoriadna splátka.",
        scenarBezVynosu: "Trh nedá nič",
        scenarPesimisticky: "Pesimistický výnos",
        scenarZadani: "Podľa zadania",
        scenarPropad: "Prepad trhu v roku doplatenia",
        hraniceNadpis: "Hraničný výnos",
        hraniceText: "Pod {nominalni} nominálne (teda {realni} nad infláciou) je mimoriadna splátka výhodnejšia. Všimni si, že hranica leží NAD úrokom hypotéky — rozdiel si berú daň a poplatky.",
        hraniceNelze: "Hraničný výnos sa pri tomto zadaní spočítať nedá — investícia mimoriadnu splátku neprekoná ani pri extrémnom výnose.",
        pojNadpis: "Klesajúce krytie",
        pojPopis: "Keby klient zomrel alebo zostal invalidný, poistka dorovná zvyšok dlhu. Suma klesá spolu s dlhom — je to plocha pod krivkou. Poistná suma sa počíta kapitálovou metódou z príjmu a výdavkov domácnosti; hypotéka je len jej klesajúca časť.",
        pojZapnout: "Počítať",
        pojVypnout: "Vynechať",
        pojPrijem: "Čistý mesačný príjem",
        pojVydaje: "Nevyhnutné výdavky domácnosti",
        pojVydajeHint: "Koľko musí domácnosť minúť každý mesiac, aby fungovala — bez sporenia a bez cieľov.",
        pojDeti: "Počet detí",
        pojSmrt: "Poistná suma — smrť",
        pojInvalidita: "Poistná suma — invalidita",
        pojZToho: "Z toho hypotéka {hypoteka} (klesá) a domácnosť {domacnost} (zostáva).",
        pojCena: "Orientačné poistné",
        pojCenaNote: "Mesačne, šablóna sadzieb. Nie je to ponuka.",
        pojGrafKryti: "Poistná suma",
        pojPrumerSplaceni: "Priemerný nesplatený dlh — splácanie navyše",
        pojPrumerInvestice: "Priemerný nesplatený dlh — investícia",
        pojRozdilText: "Toto je cena stratégie, ktorú nikto nehovorí nahlas: investičná cesta drží dlh vysoko celý čas, takže klesajúca poistka musí bežať dlhšie a vyjde drahšie. Skutočná diera pre pozostalých je pri nej naopak menšia, lebo portfólio je majetok. Poradca potrebuje obe čísla, nie to priaznivejšie.",
        pojSablona: "Poistné sumy aj sadzby sú šablóna z praxe poradcu, nie ponuka ani garancia. Konkrétne limity a cenu over v poisťovni.",
        pojBezPrijmu: "Bez zadaného príjmu nemá kapitálová metóda z čoho počítať, takže sa ukazuje len klesajúce krytie na hypotéku. Doplň čistý príjem a nevyhnutné výdavky a spočíta sa aj časť, ktorá drží domácnosť v chode.",
        skript: "„Vy dnes posielate navyše {volna} do hypotéky. Ukážem vám druhú možnosť: tie isté peniaze necháte pracovať a hypotéku doplatíte naraz. Pozrite sa na graf — tu dlh klesá, tu investícia rastie a tu sa pretnú. To je okamih, keď si môžete vybrať. A hneď vám ukážem aj druhú stranu: keby trh nedal nič, dopadnete takto. Preto k tomu patrí poistka, ktorá ten dlh dorovná, keby sa vám niečo stalo.“",
        kroky: [
          "Vytiahni z výpisu zvyšnú istinu, sadzbu, splátku a koniec fixácie. Nie z pamäti klienta — rozdiel býva tisíce.",
          "Opýtaj sa, koľko má mesačne navyše a či to vydrží posielať aj o päť rokov. Nestabilná suma celý výpočet búra.",
          "Nastav, za koľko rokov chce mať hypotéku preč. Tento dátum sa už potom nemení.",
          "Povedz nahlas, či je zadaný výnos nominálny, alebo nad infláciou. Je to najčastejšia chyba v tomto type výpočtu.",
          "Doplň poplatky fondu z dokumentu KID. Bez nich je výsledok investície nadhodnotený.",
          "Ukáž graf a priesečník. Až potom čísla.",
          "Prejdi panel rizika vrátane scenára, kde trh nedá nič. Nepreskakuj ho.",
          "Zapni klesajúce krytie a spočítaj, čo sa stane, keby klient vypadol. Bez toho je celá stratégia nekrytá.",
          "Over v zmluve limit bezplatného predčasného splatenia a poplatky za mimoriadnu splátku.",
        ],
        kdyNe: [
          "Klient nemá rezervu na tri až šesť mesiacov výdavkov. Najprv rezerva, až potom toto.",
          "Očakávaný výnos je nižší alebo blízko úroku hypotéky. Potom nemá investícia ako vyhrať a mimoriadna splátka je jasne lepšia.",
          "Klient by nezaspal, keby portfólio spadlo o tridsať percent. Dátum doplatenia je pevný a trh sa ho nepýta.",
          "Voľná suma je neistá — premenlivý príjem, živnostník v sezóne, čerstvá rodičovská. Splácanie navyše výpadok prežije, investícia s pevným dátumom horšie.",
          "Fixácia končí o rok alebo dva a nová sadzba nie je známa. Najprv si zožeň sadzbu, potom počítaj.",
          "Klient nemá krytie pre prípad smrti a invalidity. Bez neho stratégia stojí na tom, že sa nič nestane.",
          "Banka za mimoriadnu splátku účtuje náhradu nad zákonný limit. Over to v zmluve — výpočet ju nemodeluje.",
        ],
        metodika: "Daň z predaja sa počíta po jednotlivých nákupoch podľa práva platného dnes. Predaj v roku {rok} sa teda posudzuje podľa dnešných pravidiel a zákon sa dovtedy môže niekoľkokrát zmeniť. Výsledok je orientačný, nie je to ponuka ani individuálne odporúčanie.",
        hlaskaJistina: "Zadaj zvyšnú istinu hypotéky.",
        hlaskaSazbaChybi: "Zadaj úrokovú sadzbu hypotéky.",
        hlaskaHorizontChybi: "Zadaj, za koľko rokov chce klient hypotéku doplatiť.",
        hlaskaHorizontNekladny: "Horizont doplatenia musí byť aspoň jeden rok.",
        hlaskaSplatnost: "Zadaj splatnosť hypotéky v rokoch.",
        hlaskaNicNavic: "Klient nemá nič navyše — nie je čo porovnávať. Zadaj mesačnú voľnú sumu alebo jednorazový vklad.",
        hlaskaZapornaAmortizace: "Splátka nepokryje ani mesačný úrok — dlh by rástol a hypotéka by sa nikdy nesplatila. Skontroluj istinu, sadzbu a splatnosť.",
        hlaskaVynosPodUrokem: "Očakávaný výnos {vynos} je nižší alebo rovný úroku hypotéky {sazba}. Investícia nemá ako vyhrať ani pred zdanením a poplatkami — odporuč mimoriadnu splátku.",
        hlaskaDoplaceniNevyslo: "Portfólio na doplatenie nestačí. Po predaji a zdanení chýba {castka} a klientovi zostáva dlh. Zvýš voľnú sumu alebo posuň dátum doplatenia.",
        hlaskaHorizontZaSplatnosti: "Hypotéka dobehne sama za {roky}, teda skôr, než chce klient doplácať. Nie je čo doplácať.",
        hlaskaSplatnostNedosazena: "Pri zadanej splátke sa hypotéka nesplatí ani za celý modelovaný horizont. Skontroluj zadanie.",
        hlaskaNad25: "Ročný objem mimoriadnych splátok presahuje štvrtinu pôvodnej istiny. Bez náhrady je zo zákona len splatenie do 25 % ročne v mesiaci pred výročím zmluvy; nad to môže banka účtovať náhradu nákladov. Over to v zmluve.",
        hlaskaPrepocetNaNominalni: "Zadaný reálny výnos sa na porovnanie s hypotékou prepočítal na {vynos} nominálne (inflácia {inflace}). Úrok hypotéky je nominálny.",
        hlaskaPoplatkyNezadany: "Poplatky investície nie sú zadané — počíta sa s nulou. Reálny fond stojí 1–2 % ročne a výsledok investície je tým nadhodnotený.",
        hlaskaFixaceBezDelky: "Zadal si sadzbu po fixácii, ale nie dĺžku fixácie — iná sadzba sa preto nikdy neuplatní.",
        hlaskaSok: "Modeluje sa prepad trhu o {propad} v {rok}. roku.",
        hlaskaObecna: "Výpočet narazil na hodnotu, ktorú nevie spracovať. Skontroluj zadanie.",
        krokDluh: "DLH",
        krokCesta: "CESTA",
        krokVysledek: "VÝSLEDOK",
        krokRiziko: "RIZIKO",
        krokOchrana: "OCHRANA",
        prezRok: "Rok",
        prezZavrit: "Zavrieť prezentáciu",
        prezNapoveda: "klik / → ďalej · Esc koniec",
        prezKonec: "Poďme to spočítať na mieru",
        prezDisclaimer: "Orientačná modelácia, nie ponuka ani prísľub plnenia. Záväzné čísla dá až zmluva, cenník a poistné podmienky.",
        prezDluhStitek: "Dnes dlžíte",
        prezDluhVeta: "Splátka {splatka} mesačne pri sadzbe {sazba}.",
        prezDluhUroky: "Na úrokoch zaplatíte {castka}, ak sa nič nezmení",
        prezProtnutoTuk: "Tu už na doplatenie máte",
        prezProtnutoText: "Investícia prvýkrát pokryla zvyšný dlh — zhruba v {rok}. roku.",
        prezCestaBezi: "Sledujte — dlh dole, investícia hore…",
        prezCestaHotovo: "Zhruba v {rok}. roku sa krivky pretnú. Tam si môžete vybrať. Kliknite na výsledok →",
        prezCestaNikdy: "Za zvolený čas sa krivky nepretnú — na doplatenie to zatiaľ nestačí. Kliknite ďalej →",
        prezVysledekStitek: "Čo vám zostane za {roky}",
        prezVysledekVeta: "Obe cesty minú z rozpočtu úplne rovnako. Líšia sa len tým, kde tie peniaze medzitým boli.",
        prezRizikoStitek: "A čo keď trh nedá nič",
        prezRizikoVeta: "Najhorší z prepočítaných scenárov: {scenar}. Záporné číslo znamená, že by investícia dopadla horšie než mimoriadna splátka.",
        prezRizikoNeznamo: "Scenáre sa pre toto zadanie nepodarilo spočítať.",
        prezOchranaStitek: "Keby sa vám niečo stalo",
        prezOchranaRozpad: "Z toho hypotéka {hypoteka} — tá klesá spolu s dlhom. Zvyšok {domacnost} drží rodinu v chode.",
        prezOchranaVeta: "Orientačne {cena} mesačne. Šablóna sadzieb, nie ponuka.",
        prezOchranaVypnuto: "Klesajúce krytie nie je zapnuté. Zapnite ho v kalkulačke a prejdite s klientom aj túto časť — bez nej stojí celá stratégia na tom, že sa nič nestane.",
      },
    },
    finMat: {
      freqCtvrtletni: 'Štvrťročné',
      freqDenni: 'Denné',
      freqMesicni: 'Mesačné',
      freqRocni: 'Ročné',
      rokFew: 'roky',
      rokMany: 'rokov',
      rokOne: 'rok',
      tabInvestice: 'Investícia',
      tabRenta: 'Renta',
      tabUver: 'Úver / Hypotéka',
      varovaniNekonecnaRenta: 'Renta je nižšia/rovná výnosu → kapitál sa nikdy nevyčerpá (nekonečná renta). 🎉',
      varovaniZapornaAmortizace: 'Splátka je nižšia než mesačný úrok → úver sa nikdy nesplatí (záporná amortizácia). Zvýš splátku.',
    },
    investStrategie: {
      aktivaAkcie: 'Akcie (S&P 500)',
      aktivaBtc: 'Bitcoin',
      aktivaDluhopisy: 'Dlhopisy',
      aktivaMsci: 'MSCI World',
      aktivaPt: 'Hotovosť / PT',
      aktivaReit: 'Nehnuteľnosti',
      aktivaZlato: 'Zlato',
      akumulacniInsight: 'Čas maznie riziko. Na 15+ rokov akcie historicky vždy porazili všetko ostatné.',
      akumulacniKdo: 'Pre mladých a dlhý horizont',
      akumulacniName: 'Akumulačná (100 % akcie)',
      akumulacniStory: '100 % akcie v akumulačných ETF — dividendy sa automaticky reinvestujú (daňovo efektívne). Čím dlhší horizont, tým viac akcií.',
      coreInsight: 'Lacno a pasívne to hlavné, štipka na vyšší výnos. Najlepší pomer nákladov a výsledku.',
      coreKdo: 'Štandard profesionálov a fondov',
      coreName: 'Core–Satellite',
      coreStory: 'Jadro (80 %) = lacný globálny index, ktorý nuda-spoľahlivo rastie. Satelity (20 %) = korenie — témy, zlato, krypto.',
      dalioInsight: 'Keď príde kríza, spíš pokojne. Menšie výkyvy = menej panických chýb.',
      dalioKdo: 'Bridgewater, najväčší hedžový fond sveta',
      dalioName: 'Ray Dalio — All Weather',
      dalioStory: 'Portfólio „pre každé počasie“ — vyvážené tak, aby prežilo rast, recesiu, infláciu aj defláciu. Vyvážené na riziko, nie na peniaze.',
      milionariInsight: 'Bohatstvo nevzniká sporením, ale vlastníctvom aktív, ktoré rastú a vyplácajú.',
      milionariKdo: 'UBS / Knight Frank Wealth Report',
      milionariName: 'Ako investujú dolároví milionári',
      milionariStory: 'Bohatí nedržia hromady hotovosti — vlastnia aktíva: akcie, nehnuteľnosti, biznis, zlato. Široká diverzifikácia naprieč všetkým.',
      nobelInsight: 'Toto je rentiérske portfólio: vyplácaš a kapitál neklesá. Presne ako vaša budúca renta.',
      nobelKdo: 'Vypláca Nobelove ceny 120+ rokov',
      nobelName: 'Nobelova nadácia',
      nobelStory: 'Každý rok rozdá milióny na Nobelove ceny — a kapitál má dnes väčší než na začiatku. Pretože peniaze investuje, nenechá ich ležať.',
      norskyInsight: 'Štát, ktorý má z čoho rozhadzovať, miesto toho globálne investuje. Diverzifikácia a trpezlivosť.',
      norskyKdo: 'Najväčší štátny fond sveta (1,8 bil. $)',
      norskyName: 'Nórsky ropný fond',
      norskyStory: 'Nórsko neutráca peniaze z ropy — investuje ich pre budúce generácie do ~9 000 firiem po celom svete. Vyše 70 % v akciách.',
      rokFew: 'roky',
      rokMany: 'rokov',
      rokOne: 'rok',
    },
    pdDisclaimer: {
      titulek: 'Čo musí klient vedieť',
    },
    pdGraf: {
      let: 'rokov',
      popisGrafu: 'Vývoj hodnoty oboch variantov v čase',
      zdroj: 'Zdroj: modelový výpočet zo vstupov poradcu — nejde o historický vývoj ani predpoveď.',
    },
    pdModel: {
      horizont: 'Horizont (roky)',
      horizontAria: 'Horizont v rokoch',
      jenPorovnatelna: '— len tá časť portfólia, ktorú vieme porovnať s našou variantou v rovnakej kategórii.',
      kurzPouzit: 'Cudzie meny prepočítané kurzom z {datum} ({seznam}). Zdroj: {zdroj}.',
      kurzNepouzit: 'Cudzie meny sa neprepočítavajú — {duvod} Sumy v rôznych menách sa preto nesčítavajú.',
      kurzStary: 'kurzový lístok z {datum} je starší ako 30 dní.',
      kurzChybi: 'chýba kurz pre {meny}.',
      kurzBezListku: 'chýba platný kurzový lístok.',
      tisk: 'Tlač / PDF',
      tiskTitle: 'Vytlačí stránku alebo ju uloží ako PDF',
      smazat: 'Vymazať zadanie',
      smazatTitle: 'Vymaže tabuľky aj nastavenie modelu',
      mena: 'Domáca mena',
      menaNapoveda: 'podľa krajiny organizácie, nie podľa jazyka',
      nepocitaSe: 'nepočíta sa',
      pocatecniHodnota: 'Počiatočná hodnota modelu',
      popis: 'Modelový výnos je TVOJ vstupný predpoklad, nie predpoveď. Aplikácia žiadny výnos nenavrhuje — bez vyplnenia sa modelácia nepočíta.',
      titulek: '3 · Nastavenie modelu',
      vklad: 'Mesačný vklad',
      vkladNapoveda: 'prázdne = žiadne pravidelné vklady',
      vstupni: 'Vstupný poplatok súčasného portfólia %',
      vstupniAria: 'Vstupný poplatok súčasného portfólia',
      vstupniNapoveda: 'platí len pre BUDÚCE vklady — z už investovaných peňazí sa neúčtuje znova',
      vynos: 'Modelový hrubý výnos % p. a.',
      vynosAria: 'Modelový hrubý výnos',
      vynosNapoveda: 'vyplň ty — aplikácia nič nenavrhuje',
    },
    pdPrazdny: {
      krok1Nadpis: 'Odpíš položky klienta',
      krok1Popis: 'Z výpisu z účtu alebo z portálu distribútora. ISIN je voliteľný — keď ho zadáš, skontroluje sa kontrolná číslica.',
      krok2Nadpis: 'Doplň nákladovosť z KID',
      krok2Popis: 'Ku každému fondu existuje KID (Oznámenie kľúčových informácií). Priebežné poplatky a náklady na vstupe sú v sekcii Náklady, rizikový stupeň 1–7 v sekcii Súhrnný ukazovateľ rizika.',
      krok3Nadpis: 'Zadaj našu variantu a model',
      krok3Popis: 'Nákladovosť našej stratégie zadávaš ty — aplikácia ju nepozná. Potom nastav horizont a modelový hrubý výnos.',
      pridatPrvni: 'Pridať prvú položku',
      proc: 'Aplikácia nepozná nákladovosť žiadneho fondu — nedohľadá ju podľa ISINu ani neodhadne podľa kategórie. Všetky čísla zadávaš ty z doložiteľného zdroja. Vďaka tomu je výstup obhájiteľný pred klientom aj pred dohľadom.',
      titulek: 'Zatiaľ nie je čo počítať',
    },
    pdRozlozeni: {
      bezKategorie: 'Bez určenej kategórie',
      bezMeny: 'Bez vyplnenej meny',
      kategoriePopis: 'Podľa kategórií, ktoré si zadal. Prekryv konkrétnych akcií vo fondoch nepočítame — bez skutočného zloženia fondov by to bolo vymyslené číslo.',
      kategorieTitulek: 'Rozloženie podľa kategórií',
      menyPopis: 'Len z vyplneného. Chýbajúca mena sa nedopĺňa na koruny — ide do „neurčeno“.',
      menyTitulek: 'Menové rozloženie',
    },
    pdTabulka: {
      hodnota: 'Hodnota',
      hodnotaNapoveda: 'koľko v tom klient má',
      isin: 'ISIN',
      isinNapoveda: 'voliteľné — z výpisu alebo z KID',
      kategorie: 'Kategória',
      kategorieNapoveda: 'porovnáva sa len v rámci rovnakej',
      mena: 'Mena',
      menaNapoveda: 'mena pozície',
      nazev: 'Názov fondu',
      nazevNapoveda: 'presne ako je na výpise',
      neuveden: 'neuvedený',
      prazdno: 'Zatiaľ nič — pridaj prvý riadok.',
      pridatRadek: 'Pridať riadok',
      smazatRadek: 'Zmazať riadok',
      sri: 'Riziko 1–7',
      sriNapoveda: 'KID, súhrnný ukazovateľ rizika',
      ter: 'TER % p. a.',
      terNapoveda: 'KID, sekcia Náklady — priebežné poplatky',
      vstupni: 'Vstupný %',
      vstupniNapoveda: 'KID, sekcia Náklady — náklady na vstupe',
      zdroj: 'Zdroj čísla',
      zdrojEmt: 'EMT (doložené)',
      zdrojKatalog: 'katalóg — orientačný',
      zdrojKid: 'KID (doložené)',
      zdrojNapoveda: 'doložiteľné je len KID alebo EMT',
      zdrojPoradce: 'zadal poradca',
    },
    pdVerdikt: {
      hodnota: 'hodnota',
      hodnotaPonechat: 'Hodnota s verdiktom ponechať',
      keZvazeni: 'na zváženie',
      nakladovostPolozky: 'Nákladovosť položky',
      naseVarianta: 'naša varianta',
      nescitaSe: 'nesčíta sa (viac mien)',
      popis: 'Podklad na rozhovor s klientom, nie investičné odporúčanie ani pokyn na predaj. Porovnáva sa len v rámci rovnakej kategórie.',
      rozdil: 'rozdiel',
      stitekNelze: 'Nedá sa posúdiť',
      stitekPonechat: 'Ponechať',
      stitekZvazit: 'Zvážiť zmenu',
      stretZajmu: 'Stret záujmov: porovnávame s produktom, ktorý sprostredkúvame a za ktorého dojednanie dostávame odmenu.',
      titulek: 'Verdikt po položkách',
    },
    pdVety: {
      aDalsi: 'a ďalšie {n}',
      bezHodnoty: 'Pri {n} {polozek} nie je vyplnená hodnota.',
      bezKategorie: 'Pri {n} {polozek} nie je určená kategória.',
      bezMeny: 'Pri {n} {polozek} nie je vyplnená mena.',
      bezTer: 'Pri {n} {polozek} nákladovosť nepoznáme.',
      duvodBezReference: 'Nemáme našu variantu s vyplnenou nákladovosťou — bez nej sa neporovnáva. Doplň ju z KID.',
      duvodMichaneMeny: 'Porovnateľné položky sú vo viacerých menách bez prepočtu. Kurzy jadro nepozná, takže sa nesčítajú — zjednoť menu, alebo modeluj každú zvlášť.',
      duvodNulovaHodnota: 'Všetky porovnateľné položky majú nulovú hodnotu a nákladovosti sa líšia — vážiť sa nedá.',
      duvodPrazdno: 'Portfólio je prázdne — modelácia sa nepočíta.',
      duvodZadnaShoda: 'Žiadna položka klienta nemá našu variantu v rovnakej kategórii so známou nákladovosťou. Naprieč kategóriami sa neporovnáva — pridaj našu variantu do tej kategórie, ktorú chceš posudzovať.',
      koncentrace: 'Je to koncentrácia — nie je to chyba, ale opýtaj sa na ňu.',
      menySeznam: 'Meny: {seznam}. Podiely sa nedajú spočítať — chýbajú hodnoty.',
      modelujeCast: 'Modeluje sa len porovnateľná časť portfólia — {z} % jeho hodnoty.',
      modelujeVse: 'Modeluje sa celé portfólio.',
      nakladovostNejde: 'Nákladovosť portfólia sa nedá spočítať — nemáme ju ani pri jednej položke.',
      nakladovostNulaHodnot: 'Nákladovosť sa nedá zvážiť — všetky položky majú nulovú hodnotu.',
      nejvetsiKategorie: 'Najväčšia kategória „{kategorie}“ tvorí {podil} portfólia.',
      nevstupujeFew: 'nevstupujú',
      nevstupujeMany: 'nevstupujú',
      nevstupujeOne: 'nevstupuje',
      orientacniHlavniCislo: 'Časť nákladovostí nie je doložená z KID ani EMT — hlavné číslo je preto len orientačné.',
      orientacniTer: 'Pri {n} {polozek} je nákladovosť orientačná — over ju v KID.',
      podilyNejdou: 'Podiely sa nedajú spočítať — chýbajú hodnoty.',
      polozkaBezNazvu: 'položka bez názvu',
      polozkaBezNazvuCislo: 'Položka bez názvu{cislo}',
      polozkaFew: 'položky',
      polozkaMany: 'položiek',
      polozkaOne: 'položka',
      porovnaniVKategorii: 'Každá položka sa porovnáva s našou variantou vo svojej kategórii — naprieč kategóriami sa neporovnáva.',
      prazdnePortfolio: 'Portfólio je prázdne.',
      rokFew: 'roky',
      rokMany: 'rokov',
      rokOne: 'rok',
      rozdilZa: 'Rozdiel za {roky} {rok}',
      souhrnNelze: '{n}× sa nedá posúdiť',
      souhrnPonechat: '{n}× ponechať',
      souhrnZvazit: '{n}× zvážiť zmenu',
      spocitanoZ: 'Spočítané z {z} % hodnoty portfólia.',
      uPolozkyFew: 'položkách',
      uPolozkyMany: 'položkách',
      uPolozkyOne: 'položke',
      vazenaNakladovostVeta: 'Vážená nákladovosť portfólia {pct} % p. a.',
      viceMenHodnoty: 'Hodnoty sú vo viacerých menách bez prepočtu — podiely sú orientačné.',
      viceMenPodily: 'Portfólio je vo viacerých menách bez prepočtu — podiely sú orientačné.',
      viceMenVahy: 'Portfólio je vo viacerých menách bez prepočtu — váhy sú len orientačné.',
      vynechaneVeta: '{n} {polozek} do modelácie {nevstupuje}: {vypis}.',
      vynechanoBezHodnoty: 'nie je vyplnená hodnota',
      vynechanoBezKategorie: 'bez určenej kategórie',
      vynechanoBezReference: 'v jej kategórii nemáme variantu na porovnanie',
      vynechanoBezTer: 'nepoznáme nákladovosť',
      vynechanoBezTerReference: 'nepoznáme nákladovosť našej varianty',
      vynechanoJineRiziko: 'výrazne iný rizikový stupeň',
      zadnaMena: 'Mena nie je vyplnená ani pri jednej položke.',
    },
    pdVysledek: {
      doModelaceVstupuje: 'Do modelácie vstupuje',
      doplnVstupy: 'Doplň vstupy modelu.',
      hodnotaNaKonci: 'hodnota na konci',
      hodnotyPortfolia: 'hodnoty portfólia',
      klientVyhral: 'Súčasné portfólio je v nákladoch lacnejšie. Nákladovosť teda dôvod na presun nedáva.',
      lepeVychazi: 'Lepšie vychádza: {popis}',
      nepocitaSe: 'Modelácia sa zatiaľ nepočíta',
      neuvedeno: 'neuvedené',
      porovnatelnaNase: 'Porovnateľná časť — naše varianty',
      porovnatelnaSoucasne: 'Porovnateľná časť — súčasné portfólio',
      referenceBezNakladu: 'Referencia bez akýchkoľvek nákladov',
      rozdilPorovnatelne: 'Rozdiel v porovnateľnej časti',
      rozpadModelace: 'Rozpad modelácie',
      rozpadPopis: 'Zaplatené poplatky a ušlý výnos sú DVE RÔZNE čísla. Ušlý výnos obsahuje aj to, čo by zaplatené peniaze ďalej zarobili — nehovor o ňom ako o poplatku. Vstupný poplatok, ktorý klient zaplatil kedysi pri vstupe, sa do súčasného portfólia NEPOČÍTA znova — je to utopený náklad.',
      spocitanoZ: 'spočítané z',
      stejnyVynosPoznamka: 'Obe varianty počítame s rovnakým hrubým výnosom {vynos} p. a. Model teda porovnáva NÁKLADY, nie schopnosť fondov zarobiť. Modelová kalkulácia, nie prísľub výnosu.',
      uslyVynos: 'ušlý výnos (vrátane zloženého úročenia)',
      vazenaNakladovost: 'Vážená nákladovosť portfólia',
      vazenaPopis: 'Váži sa hodnotou pozície. Položka bez známej nákladovosti sa do priemeru NEZAPOČÍTA — nedosadzuje sa nula.',
      vlozenoCelkem: 'Vložené spolu',
      vyvojVCase: 'Vývoj hodnoty v čase',
      zanedbatelny: 'Rozdiel je zanedbateľný',
      zaplacenePoplatky: 'skutočne zaplatené poplatky',
    },
    portfolioDoktor: {
      karta1: '1 · Portfólio klienta',
      karta1Popis: 'Píše sa rovno do tabuľky — žiadne modály, žiadne klikanie na detail. Prázdne pole znamená „nevieme“, nie nulu.',
      karta2: '2 · Naša stratégia na porovnanie',
      karta2Popis: 'Nákladovosť našej varianty zadávaš ty — nie je nikde natvrdo. Porovnáva sa vždy len v rámci rovnakej kategórie, preto pridaj riadok pre každú kategóriu, ktorú chceš posudzovať.',
      kteraVarianta: 'Ktorá varianta ide do modelácie',
      nadrazenaSekce: 'Nástroje',
      naseVarianty: 'Naše varianty (podľa kategórií)',
      porovnatelnaCast: 'Porovnateľná časť súčasného portfólia',
      pridejVariantu: 'Pridaj našu variantu, inak sa nedá porovnávať.',
      soucasnePortfolio: 'Súčasné portfólio',
      stretZajmu: 'Stret záujmov: porovnávame s produktom, ktorý sprostredkúvame a za ktorého dojednanie dostávame odmenu. Nástroj preto smie skončiť verdiktom „ponechať“ — a keď vyjde, tak to aj napíše.',
      titulek: 'Portfólio doktor',
      uvod1: 'Opíš, čo klient drží, doplň nákladovosť z KID a uvidíš, koľko ho portfólio stojí a koľko z toho urobí rozdiel za horizont.',
      uvod2: 'Aplikácia nepozná nákladovosť žiadneho fondu',
      uvod3: '— čísla zadávaš ty z doložiteľného zdroja.',
      vseZKid: 'Všetko z KID',
      vseZKidTitle: 'Označí vyplnené nákladovosti ako doložené z KID',
    },
    provize: {
      add: 'Pridať produkt',
      amount: 'suma',
      koef: 'Koeficient',
      kpi1: 'Provízia 1. rok',
      kpi5: 'Za 5 rokov spolu',
      kpi5Sub: '1. rok + 4× opakovane',
      kpiRep: 'Opakovane / rok',
      kpiRepSub: 'starostlivosť + fee',
      notFound: 'Nič sa nenašlo',
      note: '💡 Orientačný výpočet podľa katalógu. Presné podmienky podľa províznych dodatkov na portáli. „Opakovane“ = starostlivostné BJ (auto/majetok od 2. roku, investície management fee, ŽP od 6. roku).',
      pick: '— vyber produkt —',
      pos: 'Tvoja pozícia',
      repeat: 'opakovane',
      sample: 'vzor',
      sub: 'Zadaj pozíciu a produkty → uvidíš províziu za 1. rok aj opakovane. 201 produktov z katalógu BJ · provízia = BJ × koeficient.',
      title: 'Provízna kalkulačka',
      tools: 'Nástroje',
      year1: '1. rok',
    },
    srovnavacFondu: {
      coSniPoplatky: 'Čo zjedia poplatky',
      disclaimer: 'Sadzby TER a vstupné poplatky sú orientačné — over ich v aktuálnom KIID / sadzobníku. Rovnaký hrubý výnos pre oba slúži na izoláciu nákladov; reálne fondy môžu sledovať rôzne indexy. Minulá výkonnosť nie je zárukou budúcej.',
      disclaimerTuk: 'Modelová kalkulácia, nie sľub výnosu.',
      hintA: 'náš fond / ETF',
      hintB: 'fond klienta',
      hledatPlaceholder: 'Napíš fond klienta… (napr. „dynamický“)',
      hrubyVynos: 'Hrubý výnos',
      nadrazenaSekce: 'Nástroje',
      nicNenalezeno: 'Nič sa nenašlo — zvoľ vlastný fond a zadaj TER ručne.',
      rok: 'Rok',
      ter: 'TER (ročný náklad)',
      uvod1: 'Nájdi fond klienta v našepkávači (stačí napísať časť názvu, aj bez diakritiky) a porovnaj ho s naším fondom — koľko z výnosu si vezmú poplatky. Rovnaký predpokladaný hrubý výnos pre oba, takže vidíš čisto',
      uvod2: 'rozdiel v nákladoch',
      uvod3: '. Bez AI, počíta sa rovno tu.',
      vicNaKonci: 'VIAC NA KONCI',
      vlastniFond: 'Vlastný fond',
      vlastniFondRucne: 'Vlastný fond (zadať TER ručne)',
      vlozenoCelkem: 'Vložené spolu',
      vstupni: 'vstupný',
      vstupniPoplatek: 'Vstupný poplatok',
      vstupniProc: 'Vstupný %',
      vyvojHodnoty: 'Vývoj hodnoty',
      zisk: 'Zisk',
    },
  },
  /* === /NASTROJE === */
  /* === ANALÝZA V2+ — stavová lišta ukladania (lib/analyzaV2/stavUkladani.js) === */
  /* BLOK:analyza START — generuje scratchpad/slovnik.py, ručně needitovat */
  analyza: {
    instituceVyber: {
      nabidka: 'Ponuka inštitúcií',
      sipka: 'Zobraziť celý zoznam',
    },
    propis: {
      ceka: 'Čaká na prepísanie do zložky: {n}',
      chyba: 'Do zložky sa teraz nepodarilo prepísať, skúsim to znova',
      hotovo: 'Prenesené do zložky',
      hotovoNove: 'nové: {n}',
      hotovoUpravene: 'upravené: {n}',
      klid: 'Zložka klienta je zladená s analýzou',
      nehotove: 'Rozpísané riadky čakajú na doplnenie: {n}',
      nepropisovane: 'Účty a hotovosť sa zatiaľ do zložky neprepisujú: {n}',
      probiha: 'Prepisujem do zložky klienta…',
      smazane: 'Riadok zmazaný z analýzy zostáva v zložke: {n}',
    },
    uklad: {
      ceka: 'Čaká na uloženie',
      cekaDetail: 'Posledná zmena ešte nie je na serveri.',
      nepovedlo: 'Neuložené — skúšam znova',
      nepovedloDetail: '{n}. pokus, ďalší o {s} s',
      nepovedloPokus: '{n}. pokus',
      obnova: 'Našli sme neuložené zmeny — obnoviť?',
      obnovaAno: 'Obnoviť',
      obnovaNe: 'Zahodiť',
      obnovaSCasem: 'Našli sme neuložené zmeny z {cas} — obnoviť?',
      uklada: 'Ukladám…',
      ulozeno: 'Uložené',
      zastaveno: 'Neukladám — analýza sa nenačítala',
      zastavenoDetail: 'Načítaj stránku znova, aby sa neprepísali dáta.',
    },
  },
  /* BLOK:analyza END */
  /* KRÍZOVÝ PLÁN — pozri komentár v cs.js. Nič tu nesmie sľubovať správanie poisťovne. */
  krize: {
    nadpis: 'Krízový plán',
    podnadpis: 'Čo robiť, keď sa niečo stane',
    uvod1: 'Túto časť si odložte. Nie je na dnes — je na deň, keď ju budete potrebovať.',
    uvod2: 'Nie je tu nič, čo musíte stihnúť hneď. Poradie je vždy rovnaké: postarať sa o seba, ozvať sa mne, nahlásiť to poisťovni.',
    proKoho: 'Krízový plán pre {jmeno}',
    platnost: 'Zostavené {datum} podľa zmlúv, ktoré vtedy boli v podkladoch.',

    kontaktNadpis: 'Najskôr zavolajte mne',
    kontaktText: 'Nemusíte vedieť, čo kde máte dojednané, ani čo komu písať. Na to som tu ja.',
    kontaktRole: 'Váš poradca',
    kontaktFirma: 'Spoločnosť',
    kontaktTelefon: 'Telefón',
    kontaktEmail: 'E-mail',
    kontaktWeb: 'Web',
    kontaktRezervace: 'Dohodnúť stretnutie',

    krokyNadpis: 'Postup',
    podkladyNadpis: 'Čo si pripraviť',
    pozorNadpis: 'Na čo si dať pozor',
    smlouvyNadpis: 'Zmluvy, ktoré sa na to môžu vzťahovať',
    smlouvaBezCisla: 'číslo zmluvy zatiaľ nemám',
    smlouvaBezInstituce: 'inštitúciu zatiaľ nemám',
    bezSmluv: 'K tomuto riziku nemám vo vašich podkladoch evidovanú žiadnu zmluvu. Neznamená to, že žiadnu nemáte — znamená to, že ju spolu musíme dohľadať.',
    bezSmluvVse: 'V podkladoch nemám evidovanú ani jednu poistnú zmluvu. Postup nižšie platí aj tak; len si najskôr spolu prejdeme, čo máte dojednané.',
    navrhNavic: 'Návrh navyše',

    pravniNadpis: 'Odkiaľ to vieme',
    pravniOvereno: 'overené',
    disclaimer1: 'Tento prehľad hovorí, ČO urobiť. Nehovorí, či a koľko poisťovňa vyplatí — to sa riadi znením vašej zmluvy a jej výlukami. Prejdeme ich spolu.',
    disclaimer2: 'Uvedené paragrafy sú všeobecné pravidlá, nie prísľub plnenia. Lehoty aj podmienky má každá zmluva vlastné.',
    disclaimer3: 'Postup vychádza z českej právnej úpravy. Pre zmluvy dojednané v inej krajine platia tamojšie pravidlá.',

    chybiNadpis: 'Skôr než to pošlete klientovi',
    chybiKontaktVse: 'V profile poradcu nie je telefón ani verejný e-mail. Krízový plán bez kontaktu nedáva zmysel — doplňte ich v Nastaveniach.',
    chybiJmeno: 'Chýba meno poradcu.',
    chybiTelefon: 'Chýba telefón poradcu.',
    chybiEmail: 'Chýba verejný e-mail poradcu.',
    chybiWeb: 'Chýba web poradcu.',
    chybiRezervace: 'Chýba odkaz na rezerváciu stretnutia — doplňte vizitku alebo kalendár.',
    chybiSmlouvy: 'V podkladoch nie sú evidované žiadne poistné zmluvy.',
    chybiCislaSmluv: 'Pri niektorých zmluvách chýba číslo. Klient ho v kríze hľadať nebude.',

    pravni: {
      oznameni: 'Poistnú udalosť treba oznámiť poistiteľovi bez zbytočného odkladu.',
      setreni: 'Poistiteľ po oznámení začne bez zbytočného odkladu šetrenie. Výsledok aj odôvodnenie výšky plnenia, prípadne dôvod zamietnutia, oznamuje v textovej podobe.',
      splatnost: 'Ak splatnosť nie je dojednaná v zmluve, poistné plnenie je splatné do pätnástich dní odo dňa SKONČENIA šetrenia. Nie je to lehota na vybavenie celej udalosti.',
      zaloha: 'Ak sa šetrenie nedá ukončiť do troch mesiacov od oznámenia, poistiteľ oznámi dôvody v textovej podobe a na žiadosť poskytne primeraný preddavok.',
      stupne: 'Stupne invalidity sa určujú podľa poklesu pracovnej schopnosti: I. stupeň 35–49 %, II. stupeň 50–69 %, III. stupeň najmenej 70 %.',
      nahradaMzdy: 'Za prvých 14 kalendárnych dní dočasnej pracovnej neschopnosti patrí zamestnancovi náhrada mzdy od zamestnávateľa.',
      zadostID: 'Žiadosť o invalidný dôchodok sa spisuje na územnej správe sociálneho zabezpečenia alebo sa podáva elektronicky. Zdravotný stav posudzuje posudkový lekár, spravidla z dokumentácie. Zákonná lehota na rozhodnutie je 90 dní.',
    },

    uraz_nemoc: {
      nadpis: 'Úraz alebo choroba — krátka pracovná neschopnosť',
      kdy: 'Ste doma na péenke a počítate s tým, že sa o pár týždňov vrátite.',
      kroky: [
        { n: 'Nechajte si vystaviť péenku', d: 'Vystaví ju ošetrujúci lekár elektronicky. Papier zamestnávateľovi nenosíte.' },
        { n: 'Dajte vedieť zamestnávateľovi', d: 'Stačí správa, od ktorého dňa ste v pracovnej neschopnosti.' },
        { n: 'Ozvite sa mne', d: 'Prejdeme spolu vaše zmluvy a povieme si, ktoré z nich sa na to vzťahujú.' },
        { n: 'Nahláste to poisťovni', d: 'Hlásiť bez zbytočného odkladu ukladá § 2796 občianskeho zákonníka. Ak neviete ako, nahlásime to spolu.' },
        { n: 'Odkladajte si doklady', d: 'Správy od lekára, bločky za lieky, potvrdenie o dĺžke neschopnosti. Spätne sa zháňajú horšie.' },
      ],
      podklady: [
        'Číslo poistnej zmluvy',
        'Doklad totožnosti',
        'Číslo účtu, kam poslať plnenie',
        'Potvrdenie o pracovnej neschopnosti — odkedy dokedy',
        'Lekárske správy k úrazu alebo chorobe',
      ],
      pozor: 'Prvých 14 kalendárnych dní hradí náhradu mzdy zamestnávateľ, od 15. dňa vypláca nemocenské správa sociálneho zabezpečenia. Samostatne zárobkovo činná osoba dostane nemocenské len vtedy, ak si platí dobrovoľné nemocenské poistenie. Karenčná doba pri poistke je niečo iné — má ju každá zmluva vlastnú a nájdeme ju vo vašej.',
    },

    dlouhodoba_pn: {
      nadpis: 'Dlhodobá pracovná neschopnosť',
      kdy: 'Neschopnosť sa ťahá mesiace a je jasné, že to nebude na dva týždne.',
      kroky: [
        { n: 'Ozvite sa mi skôr, než dôjdu peniaze', d: 'Čím skôr to vieme, tým viac sa dá s rozpočtom a so splátkami urobiť.' },
        { n: 'Spočítame, koľko mesačne chýba', d: 'Nemocenské nahrádza len časť čistého príjmu. Rozdiel je presne to, čo musíme pokryť.' },
        { n: 'Uplatnite dennú dávku z poistky', d: 'Pracovná neschopnosť aj denné odškodné sa hlásia zvlášť — aj keď ste raz hlásili úraz.' },
        { n: 'Povedzte to banke včas', d: 'O odklad splátok sa žiada skôr, než splátka prepadne. Po nezaplatenej splátke je to výrazne ťažšie.' },
        { n: 'Dohodneme si kontrolné stretnutie', d: 'Pri dlhej neschopnosti sa situácia mení každý mesiac. Nechcem, aby ste to sledovali sami.' },
      ],
      podklady: [
        'Rozhodnutie o dočasnej pracovnej neschopnosti',
        'Priebežné lekárske správy',
        'Čísla poistných zmlúv',
        'Prehľad splátok a trvalých príkazov',
        'Výpisy z účtu za posledné mesiace',
      ],
      pozor: 'Nemocenské sa nevypláca donekonečna — podporná doba je obmedzená a jej dĺžku aj prípadné predĺženie posudzuje správa sociálneho zabezpečenia podľa vašej situácie. Zistíme ju spolu, aby sme vedeli, kedy začať riešiť ďalší krok.',
    },

    zavazne_onemocneni: {
      nadpis: 'Závažné ochorenie',
      kdy: 'Padla diagnóza typu nádorové ochorenie, infarkt alebo porážka. Také bývajú v poistkách vymenované.',
      kroky: [
        { n: 'Najskôr sa liečte', d: 'Nič z toho, čo je nižšie, nie je na dnešné popoludnie. Papiere pár dní počkajú.' },
        { n: 'Zavolajte mi', d: 'Pozrieme sa, či je vaša diagnóza medzi krytými. Zoznam je v každej zmluve iný.' },
        { n: 'Vyžiadajte si lekársku správu s diagnózou', d: 'Vrátane dátumu, kedy bola stanovená. Bez nej sa poistná udalosť nedá doložiť.' },
        { n: 'Nahláste to poisťovni', d: 'Bez zbytočného odkladu, § 2796 občianskeho zákonníka. Formulár vyplníme spolu.' },
        { n: 'Riešte aj výpadok príjmu', d: 'Závažné ochorenie býva aj dlhá pracovná neschopnosť. Uplatňujeme oboje, nielen jedno.' },
      ],
      podklady: [
        'Lekárska správa s diagnózou a dátumom',
        'Prepúšťacia správa z nemocnice',
        'Výsledky vyšetrení, na ktoré sa správa odvoláva',
        'Číslo poistnej zmluvy a doklad totožnosti',
        'Číslo účtu, kam poslať plnenie',
      ],
      pozor: 'Každá zmluva má vlastný zoznam diagnóz, vlastné definície a vlastnú čakaciu dobu. Čo platí u vás, prečítame priamo vo vašej zmluve — všeobecne sa to povedať nedá.',
    },

    invalidita: {
      nadpis: 'Invalidita',
      kdy: 'Zdravotný stav je dlhodobo zlý a návrat do práce v pôvodnom rozsahu nie je reálny.',
      kroky: [
        { n: 'Zavolajte mi hneď na začiatku, nie až na konci', d: 'Kým príde rozhodnutie, ubehnú mesiace. Počas nich sa dá so splátkami a rozpočtom urobiť veľa.' },
        { n: 'Podajte žiadosť o invalidný dôchodok', d: 'Spisuje sa na územnej správe sociálneho zabezpečenia, alebo sa podáva elektronicky.' },
        { n: 'Pripravte lekárske správy dopredu', d: 'Zdravotný stav posudzuje posudkový lekár, spravidla z dokumentácie. Čím úplnejšie podklady, tým plynulejšie konanie.' },
        { n: 'Vedzte, o čom sa rozhoduje', d: 'O stupni invalidity podľa poklesu pracovnej schopnosti: I. stupeň 35–49 %, II. stupeň 50–69 %, III. stupeň najmenej 70 %. Zákonná lehota na rozhodnutie je 90 dní.' },
        { n: 'Rozhodnutie odneste poisťovni', d: 'Väčšina zmlúv sa na priznaný stupeň invalidity odvoláva. Rozhodnutie si odložte, je to kľúčový dokument.' },
      ],
      podklady: [
        'Doklad totožnosti',
        'Kompletné lekárske správy',
        'Doklady o vzdelaní a prehľad doterajšej práce',
        'Profesijný dotazník, ktorý pošle správa sociálneho zabezpečenia',
        'Rozhodnutie o invalidite a číslo poistnej zmluvy',
      ],
      pozor: 'Priznanie invalidity od štátu a plnenie z poistky sú dve samostatné konania. Poisťovňa posudzuje podľa znenia vašej zmluvy a môže dôjsť k inému záveru než štát. Práve preto to nenechávajte na sebe.',
    },

    umrti: {
      nadpis: 'Úmrtie',
      kdy: 'Túto časť číta niekto blízky. Nie je tu nič, čo treba stihnúť dnes.',
      kroky: [
        { n: 'Zariaďte len to nutné', d: 'Úmrtný list vydá matrika, obvykle to zariadi pohrebná služba. Vyžiadajte si viac rovnopisov, budú potrebné na viacerých miestach.' },
        { n: 'Zavolajte mi', d: 'Nemusíte vedieť, čo kde bolo dojednané. Mám prehľad zmlúv, ktoré sme robili, a prejdem ich s vami.' },
        { n: 'Nahláste to poisťovniam', d: 'Ohlásiť bez zbytočného odkladu ukladá § 2796 občianskeho zákonníka. Nahlásime to spolu, aj pri zmluvách u iných inštitúcií.' },
        { n: 'Požiadajte o pozostalostné dôchodky', d: 'Vdovský, vdovecký ani sirotský dôchodok nevzniká sám — o všetky sa žiada na správe sociálneho zabezpečenia.' },
        { n: 'Neponáhľajte sa s veľkými rozhodnutiami', d: 'Predaj bytu, výpovede zmlúv, splatenie úveru. Nič z toho nie je na prvé týždne.' },
      ],
      podklady: [
        'Úmrtný list — radšej viac rovnopisov',
        'Doklad totožnosti pozostalého',
        'Čísla poistných a úverových zmlúv',
        'Sobášny list, rodné listy detí',
        'Číslo účtu, kam poslať plnenie',
      ],
      pozor: 'Záväzky úmrtím samy nezanikajú, riešia sa v dedičskom konaní. Pri niektorých úveroch býva poistenie schopnosti splácať dojednané priamo v úverovej zmluve, nie v životnej poistke. Preto sa ozveme aj banke.',
    },

    skoda_na_majetku: {
      nadpis: 'Škoda na majetku',
      kdy: 'Vytopenie, požiar, víchrica, vlámanie — alebo škoda, ktorú ste spôsobili niekomu inému.',
      kroky: [
        { n: 'Zastavte škodu, ak sa to dá bezpečne', d: 'Zavrieť vodu, vypnúť elektrinu. Ak hrozí nebezpečenstvo, volajte 112.' },
        { n: 'Odfoťte všetko skôr, než začnete upratovať', d: 'Fotky a video sú najsilnejší dôkaz. Poškodené veci nevyhadzujte, kým ich poisťovňa nevidela.' },
        { n: 'Pri vlámaní a pri nehode volajte políciu', d: 'Bez policajného záznamu sa taká škoda dokladá ťažko.' },
        { n: 'Nahláste to poisťovni a ozvite sa mne', d: 'Bez zbytočného odkladu, § 2796 občianskeho zákonníka. So súpisom škody aj s formulárom pomôžem.' },
        { n: 'Spíšte škodu položku po položke', d: 'Čo to bolo, kedy obstarané, za koľko. Bločky, faktúry, záručné listy — čokoľvek máte.' },
      ],
      podklady: [
        'Fotografie a video poškodenia',
        'Súpis poškodených vecí s cenami',
        'Bločky, faktúry, záručné listy',
        'Číslo poistnej zmluvy a doklad totožnosti',
        'Policajný protokol pri vlámaní alebo nehode',
      ],
      pozor: 'Nezačínajte s opravou skôr, než sa dohodnete s poisťovňou — mnohé zmluvy majú obhliadku technikom ako podmienku. A ak ste škodu spôsobili niekomu inému, nič neuznávajte ani neplaťte skôr, než si to spolu prejdeme.',
    },
  },

  /* === AUTO: klíče vytažené z jazykových ternárů (scripts/i18n-ternary-codemod.js) === */
  /* BLOK:auto START — generuje scratchpad/slovnik.py, ručně needitovat */
  auto: {
    aIEmailBulkModal: {
      aiFiltrujePise: 'AI filtruje + píše…',
      cileni: 'Cielenie:',
      hromadnyAiMailSmartemailing: 'Hromadný AI mail (Smartemailing zadarmo)',
      jmeno: 'Meno',
      klientu: 'klientov',
      klientuOdpovidaFiltru: 'klientov zodpovedá filtru',
      klientumOtazka: 'klientom?',
      n2NahledEmailuPlaceholders: '2. Náhľad e-mailu (placeholdery nahradené pri odoslaní)',
      odeslano: 'Odoslané:',
      opravduOdeslatEmail: 'Naozaj odoslať e-mail',
      osloveni: 'Oslovenie',
      poradce: 'Poradca',
      posliVsemCoNemaji: 'Pošli všetkým čo nemajú penzijko že je akcia + CTA na hovor…',
      prepsano: 'Prepísané',
      prijemci: 'Príjemcovia',
      prijmeni: 'Priezvisko',
      prikladyPosliVipKlientum: 'Príklady: „pošli VIP klientom newsletter o NBS“ · „pošli všetkým čo podpísali ŽP info o životnom poistení partner“ · „všetkým aktívnym tip k daniam 2026“',
      selhalo: 'zlyhalo',
      skrytSeznamPrijemcu: 'Skryť zoznam príjemcov',
      spustitKampan: 'Spustiť kampaň →',
      teloTemplate: 'Telo (šablóna):',
      uspesne: 'úspešne',
      vybratVse: 'Vybrať všetkých',
      vyfiltrovatKlientyNapsatEmail: 'Vyfiltrovať klientov + Napísať e-mail',
      zadniKlientiNeodpovidajiFiltru: 'Žiadni klienti nezodpovedajú filtru',
      zadny: 'Žiadny',
      zobrazitUpravitSeznam: 'Zobraziť / upraviť zoznam',
    },
    aIEmailDraftModal: {
      aiEmailKlientovi: 'AI e-mail klientovi',
      aiPise: 'AI píše…',
      aiVygenerujEmail: 'AI vygeneruj e-mail',
      emailOdeslanSipka: 'E-mail odoslaný',
      emailOhledne: 'e-mail ohľadom...',
      klientNemaEmailVCrm: '(klient nemá e-mail v CRM)',
      klienta: 'klienta',
      komu: 'Komu:',
      komuKlientACeho: 'Komu (klient) a čoho sa týka (obchod)',
      n2NahledEmailu: '2. Náhľad e-mailu',
      obchod: 'obchod',
      odeslatNa: 'Odoslať na',
      odeslatZMehoGmailu: 'Odoslať z môjho Gmailu',
      odpovezNaEmailOd: 'Odpovedz na e-mail od',
      posliPavloviInfoO: 'Pošli Pavlovi info o servisnom stretnutí v utorok 14:00…',
      posliPredJmenem: 'Pošli',
      prepsanoKlikniAiVygeneruj: 'Prepísané — klikni AI vygeneruj',
      sPredmetem: 's predmetom',
      spustitNahravani: 'Spustiť nahrávanie',
      telo: 'Telo:',
      volitelneObchod: 'Voliteľne: obchod…',
      zastavitNahravani: 'Zastaviť nahrávanie',
    },
    academyLayout: {
    },
    analyzaTiskPage: {
      analyza: 'Analýza',
      castka: 'Suma',
      celkem: 'Spolu',
      cisteJmeni: 'Čisté imanie',
      coBudemeResit: 'Čo spolu budeme riešiť',
      coBudemeResitUvod: 'Z čísel, ktoré sme spolu prešli, vyplývajú tieto témy. Prejdeme ich pri príprave vášho plánu.',
      coJeProVasDulezite: 'Čo je pre vás dôležité',
      coOcekavate: 'Čo od spolupráce očakávate',
      coOdVasPotrebuji: 'Čo od vás potrebujem',
      coZnamenajiPenize: 'Čo pre vás znamenajú peniaze',
      dalsiKrok: 'Ďalší krok',
      dedictviBudouciProdej: 'Dedičstvo / budúci predaj',
      dluhy: 'Dlhy',
      dobryDenPosilamShrnuti: 'Dobrý deň, posielam zhrnutie našej finančnej analýzy. Pozrite a kľudne sa ozvite.',
      financniAnalyza: 'Finančná analýza',
      financniMajetek: 'Finančný majetok',
      firmaPodnikani: 'Firma / podnikanie',
      investiceOpfEtfAkcie: 'Investície (podielové fondy/ETF, akcie)',
      majetekCelkem: 'Majetok spolu',
      naZakladeTechtoCisel: 'Na základe týchto čísel navrhneme ďalšie kroky vo finančnom pláne — ozvite sa a prejdeme ich spoločne.',
      nasobekVydaju: '{n}× výdavkov',
      nemovitostiAutoCennosti: 'Nehnuteľnosti / auto / cennosti',
      nezavazne: 'Tento prehľad je nezáväzný. Slúži ako podklad na prípravu finančného plánu. Konkrétne riešenia, produkty a ich podmienky prejdeme a odsúhlasíme až pri realizácii.',
      penzijniDip: 'Dôchodkové sporenie',
      pocetCilu: 'Počet cieľov',
      prijmyMes: 'Príjmy / mes',
      pripravujiAnalyzu: 'Pripravujem analýzu…',
      registrace: 'Registrácia {regulator}: {cislo}',
      rezerva: 'Rezerva',
      schuzkaDne: 'Stretnutie dňa {datum}',
      shrnutiNasiAnalyzy: 'Zhrnutie našej analýzy: čisté imanie {jmeni}, finančná rezerva {rezerva}× mesačných výdavkov a voľný cash-flow {cf} mesačne.',
      shrnutiSchuzky: 'Zhrnutie stretnutia',
      splatkaMes: 'Splátka/mes',
      stavebniSporeni: 'Stavebné sporenie',
      strucneOSituaci: 'Stručne o vašej situácii',
      terminDomluvime: 'Termín ďalšieho stretnutia spolu dohodneme.',
      uctyAHotovost: 'Účty a hotovosť',
      vaseCile: 'Vaše ciele',
      volnyCashFlowMes: 'Voľný cash-flow / mes',
      vydajeMes: 'Výdavky / mes',
      zavazkyCelkem: 'Záväzky spolu',
      zaznamZAnalyzy: 'Záznam z analýzy zo dňa {datum} v dnešných cenách. Slúži ako podklad pre finančný plán; aktualizujeme pri zmene situácie.',
      /* Vzhled zeleného PDF (25. 10. 2026): podnadpisy, velká karta volných peněz, pata listu. */
      dulezitUpozorneni: 'Dôležité upozornenie',
      majetekAZavazky: 'Majetok a záväzky',
      prijmyAVydaje: 'Príjmy a výdavky',
      volneProstredky: 'Voľné prostriedky',
      volneProstredkyPopis: 'Koľko vám každý mesiac zostane po výdavkoch a splátkach.',
      vydajePodleKategorii: 'Výdavky podľa kategórií',
      vytvoreno: 'Vytvorené {datum}',
    },
    businessCharts: {
      celkemBj: 'Spolu BJ',
      cil: 'cieľ',
      nastavMesicniPlanBj: 'Nastav mesačný plán BJ v Ciele & Rocks.',
      plneniPlanuBj: 'Plnenie plánu (BJ)',
      provize: 'Provízia',
    },
    cashflowGraf: {
      cashflowVCaseMesicni: 'Cashflow v čase — mesačný prebytok',
      naKonci: 'na konci',
      nastupHypoteky: 'štart hypotéky',
      poNastupuHypoteky: 'po štarte hypotéky',
      prebytekKlesneJenO: '). Prebytok klesne len o rozdiel splátka − odpadajúci nájom, nie o celú splátku.',
      splatkaHypotekySeV: 'Splátka hypotéky sa v cashflow prejaví až od čerpania (r. ',
      start: 'štart',
    },
    casovaOsaCilu: {
      casovaOsa: 'Časová os',
      casovaOsaCiluOd: 'Časová os cieľov od dnes do roku',
      chybi: 'chýba',
      dnes: 'dnes',
      dosahne: 'dosiahne',
      kdySeKteryCil: 'Kedy sa ktorý cieľ splní',
      let: 'rokov',
      letech: 'rokoch',
      letos: 'tento rok',
      seNesplniChybiCelkem: 'sa nesplní — chýba spolu',
      ve: 'v',
      vekKlientaUMilniku: 'Vek klienta pri míľnikoch chýba — v analýze nie je dátum narodenia.',
      zatimZadnyCilOsa: 'Zatiaľ žiadny cieľ — os sa naplní, len čo pridáš prvý.',
    },
    cilCinema: {
      dalsi: 'Ďalej',
      poznamkaPoradce: 'Poznámka poradcu ',
      poznamkaPoradceN: 'Poznámka poradcu (N)',
      prehrat: 'Prehrať',
      proKlientskyRezimTu: 'Pre klientsky režim tu zatiaľ nie je schválený obsah',
      scenyTohotoCileCekaji: 'Scény tohto cieľa čakajú na schválenie metodiky. V poradenskom režime sa dajú prehrať aj tak — klientovi ich zatiaľ neukazujeme.',
      zavrit: 'Zatvoriť',
      zpet: 'Späť',
    },
    clientDealsTab: {
      archiv: 'Archív',
      archivovane: 'Archivované',
      klikniNovyObchodPro: 'Klikni „Nový obchod“ pre založenie.',
      nacitam: 'Načítavam…',
      nelzeNacistObchodyKlienta: 'Nemožno načítať obchody klienta',
      obchodySeNepodariloNacist: 'Obchody sa nepodarilo načítať',
      otevritDetail: 'Otvoriť detail',
      prohraZruseno: 'Prehra/Zrušené',
      rozjednane: 'Rozjednané',
      rozjednaneObchody: 'Rozjednané obchody',
      vProcesu: 'v procese',
      vyhrane: 'Vyhrané',
      vyhraneSmlouvy: 'Vyhrané → zmluvy',
      zadneObchodyVTeto: 'Žiadne obchody v tejto kategórii',
      zkusToZnovuNejde: 'Skús to znova — nejde o prázdny zoznam, ale o chybu spojenia.',
    },
    clientMapPage: {
      kratkyServis: 'Krátky servis',
      seznamKlientu: 'Zoznam klientov ({n})',
      vTrase: 'v trase {n}',
      zavritSeznam: 'Zavrieť zoznam',
      shlukKlientuOne: '{n} klient',
      shlukKlientuFew: '{n} klienti',
      shlukKlientuMany: '{n} klientov',
      shlukAOkoli: '{mesto} a okolie',
      shlukStejneMisto: 'Na rovnakom mieste',
      shlukPriblizit: 'Priblížiť na všetkých',
      shlukZavrit: 'Zavrieť zoznam zhluku',
      shlukTip: '{pocet} — kliknite pre zoznam',
      shlukZpet: 'Späť na zoznam ({n})',
      shlukSeznam: 'Klienti v zhluku',
      typKlient: 'Klient',
      typNabor: 'Nábor',
      typLead: 'Lead',
      typOstatni: 'Ostatné',
    },
    composeEmailModal: {
      dobryDen: 'Dobrý deň,…',
      eMailOdeslan: 'E-mail odoslaný',
      komuNapisJakykolivE: 'Komu * — napíš akýkoľvek e-mail (klienta vyberať nemusíš)',
      neboVyberKlientaVolitelne: '…alebo vyber klienta (voliteľné — doplní e-mail + uloží do jeho histórie)',
      nelzeOdeslat: 'Nedá sa odoslať',
      novyEMail: 'Nový e-mail',
      obchodniPripadVolitelneVazba: 'Obchodný prípad (voliteľne — väzba pre neskoršie dohľadanie)',
      odeslat: 'Odoslať',
      predmet: 'Predmet *',
      predmetEMailu: 'Predmet e-mailu',
      teloZpravy: 'Telo správy *',
      zadejPredmet: 'Zadaj predmet',
      zadejPrijemce: 'Zadaj príjemcu',
      zadejTextEMailu: 'Zadaj text e-mailu',
      zavrit: 'Zavrieť',
      zrusit: 'Zrušiť',
    },
    dashboardPage: {
      akademieProNovackyKlikaci: 'Akadémia pre nováčikov · klikací sprievodca',
      coJePoradenstviEtika: 'Čo je poradenstvo, etika, proces, produkty, volanie, argumentácia, uzatváranie + kvízy.',
      vitejteVBeplan: 'Vitajte v beplan ',
      zNovackaProfikKrok: 'Z nováčika profík — krok za krokom',
    },
    dealAutocomplete: {
      najdiObchodniPripadKlienta: 'Nájdi obchodný prípad klienta…',
      nejprveVyberKlienta: 'Najskôr vyber klienta…',
      obchodniPripad: 'Obchodný prípad',
      vymazat: 'Vymazať',
      zadnyOtevrenyObchodniPripad: 'Žiadny otvorený obchodný prípad klienta.',
    },
    dealResultModal: {
      datumUzavreni: 'Dátum uzavretia',
      duvodVolitelneZapiseSe: 'Dôvod (voliteľné — zapíše sa do histórie)',
      konecnaCenaBj: 'Konečná cena (BJ)',
      naprKlientZustalU: 'Napr. klient zostal pri súčasnej banke…',
      zpet: 'Späť',
    },
    diarPageV3: {
      adresatJmenoAdresa: 'Adresát (meno + adresa)',
      aktivitaUlozena: 'Aktivita uložená',
      aktivitaVytvorena: 'Aktivita vytvorená',
      aktualizovano: 'aktualizované',
      bezKlienta: 'Bez klienta?',
      cehoSeToTyka: 'Čoho sa to týka',
      celodenni: 'Celodenné',
      celyDen: ' · celý deň',
      dalsiMesic: 'Ďalší mesiac',
      dalsiUcastniciVolitelneOddelene: 'Ďalší účastníci (voliteľne, oddelené čiarkou)',
      dalsich: 'ďalších',
      datum: 'Dátum *',
      delkaUpravena: 'Dĺžka upravená',
      diarVeTvemKalendari: 'Diár v tvojom kalendári',
      dnesVelke: 'Dnes',
      doba: 'Trvanie',
      doplnitKlienta: 'Doplniť klienta',
      editaceAktivity: 'Úprava aktivity',
      editovat: 'Upraviť',
      importZGoogleCalendar: 'Import z Google Calendar do Diára',
      importovano: 'Importované',
      jindeOnline: 'Inde / online',
      kalendar: 'Kalendár',
      kalendarSeAktualizujeKazdou: 'Kalendár sa aktualizuje ~každú hodinu.',
      kdeSeSchuzkaKona: 'Kde sa stretnutie koná',
      klient: 'Klient',
      klientNemaVyplnenouAdresu: 'Klient nemá vyplnenú adresu — napíš ju a vyber z našepkávača.',
      kopirovat: 'Kopírovať',
      mistoAdresa: 'Miesto / adresa',
      mistoVolitelne: 'Miesto (voliteľne)',
      nacitam: 'Načítavam…',
      nacitamOdkaz: 'Načítavam odkaz…',
      nacitamStav: 'Načítavam stav…',
      nacteSchuzkyAUdalosti: 'Načíta stretnutia a udalosti z tvojho Google kalendára (-7 dní až +6 mesiacov) a zobrazí ich v Diári ako aktivity. Stretnutia vytvorené cez beplan sa nedublujú.',
      napisAdresuMestoMisto: 'napíš adresu / mesto / miesto…',
      nastaveni: 'Nastavenie',
      nastaveniKalendare: 'Nastavenie kalendára',
      neboJenExportApple: 'Alebo len export (Apple / Outlook)',
      nelzeNacistUkoly: 'Nedajú sa načítať úlohy',
      nelzePresunoutUkol: 'Úlohu sa nedá presunúť',
      nelzeUlozit: 'Nedá sa uložiť',
      nelzeVratit: 'Nedá sa vrátiť',
      nenaplanovano: 'Nenaplánované',
      nepodariloSeNacistOdkaz: 'Odkaz sa nepodarilo načítať',
      nepodariloSeVytvoritKlienta: 'Klienta sa nepodarilo vytvoriť',
      nepovedloSe: 'Nepodarilo sa',
      nizka: 'Nízka',
      nova: 'Nová',
      novaAktivita: 'Nová aktivita',
      novouPridasTlacitkemAktivita: 'Novú pridáš tlačidlom „Aktivita“.',
      novyBezpecnostniKodVytvoren: 'Nový bezpečnostný kód vytvorený',
      obchodniPripadVolitelne: 'Obchodný prípad (voliteľne)',
      obnovit: 'Obnoviť',
      odchozi: 'Odchádzajúci',
      odkazNaTvujKalendar: 'Odkaz na tvoj kalendár',
      polozkaUzNeniDostupna: 'Položka už nie je dostupná',
      pracovniDobaDo: 'Pracovný čas do',
      pracovniDobaOd: 'Pracovný čas od',
      predchoziMesic: 'Predchádzajúci mesiac',
      preskoceno: 'preskočené',
      presunuto: 'Presunuté',
      presunutoDoCasu: 'Presunuté do času',
      prichozi: 'Prichádzajúci',
      pridatDoAppleOutlook: 'Pridať do Apple / Outlook',
      pridatDoGoogle: 'Pridať do Google',
      priorita: 'Priorita',
      resitel: 'Riešiteľ',
      schovatRealizovane: 'Skryť realizované',
      smerHovoru: 'Smer hovoru',
      soukromaAktivita: '(súkromná aktivita)',
      soukromaAktivita2: 'Súkromná aktivita',
      stavPropojeniSeNepodarilo: 'Stav prepojenia sa nepodarilo zistiť.',
      stredni: 'Stredná',
      synchronizace: 'Synchronizácia',
      synchronizaceSelhala: 'Synchronizácia zlyhala',
      synchronizovatDoGoogleApple: 'Synchronizovať do Google / Apple / Outlook',
      synchronizovatTed: 'Synchronizovať teraz',
      synchronizuji: 'Synchronizujem…',
      tahniProCas: '⇅ ťahaj pre čas',
      telefonniCislo: 'Telefónne číslo',
      tentoDen: 'Tento deň',
      typAktivity: 'Typ aktivity',
      uKlienta: 'U klienta',
      uKlientaProste: 'U klienta',
      uNas: 'U nás',
      uNasVKancelari: 'U nás v kancelárii',
      ucet: 'Účet',
      ukladam: 'Ukladám…',
      ukolNaplanovan: 'Úloha naplánovaná',
      uloziSeDoDiare: 'Uloží sa do diára',
      ulozitJakoSoukromou: 'Uložiť ako súkromnú',
      ulozitZmeny: 'Uložiť zmeny',
      vice: 'Viac',
      volnoAiZavolejA: 'Voľno · zavolaj A-leadom',
      vraceno: 'Vrátené',
      vratit: 'Vrátiť',
      vseNaplanovano: 'Všetko naplánované.',
      vychoziDelkaAktivity: 'Predvolená dĺžka aktivity',
      vychoziTypNoveAktivity: 'Predvolený typ novej aktivity',
      vychoziZobrazeni: 'Predvolené zobrazenie',
      vysledekHovoruPoDokonceni: 'Výsledok hovoru (po dokončení)',
      vysoka: 'Vysoká',
      vytvorit: 'Vytvoriť',
      zacatek: 'Začiatok *',
      zadejDatumACas: 'Zadaj dátum a čas',
      zadejNazevPredmet: 'Zadaj názov / predmet',
      zadneNadchazejiciAktivity: 'Žiadne nadchádzajúce aktivity',
      zavritFiltry: 'Zavrieť filtre',
      zitra: 'Zajtra',
      zkopirovano: 'Skopírované',
      zkopirujOdkazRucne: 'Skopíruj odkaz ručne',
      zkusitZnovu: 'Skúsiť znova',
      zmenitBezpecnostniKod: 'Zmeniť bezpečnostný kód',
      zmenitBezpecnostniKodStary: 'Zmeniť bezpečnostný kód? Starý odkaz prestane fungovať a kalendáre bude nutné pridať znova.',
      zmeskany: 'Zmeškaný',
      zobrazeni: 'Zobrazenie',
      zobrazitZrusene: 'Zobraziť zrušené',
      zrusit: 'Zrušiť',
    },
    dotaznikCteni: {
      definiceDotaznikuSeNenacetla: 'Definícia dotazníka sa nenačítala.',
      hodnotuSeNepodariloNacist: 'Hodnotu sa nepodarilo načítať.',
      rodneCisloACislaDokladu: 'Rodné číslo a čísla dokladov sú skryté. Zobrazenie je vedomý krok a po 20 sekundách sa hodnota schová.',
      skryt: 'Skryť',
      zobraziSeNa20Sekund: 'Zobrazí sa na 20 sekúnd',
      zobrazit: 'Zobraziť',
    },
    editableGoals: {
      akontace: 'Akontácia %',
      akontace2: 'Akontácia',
      akontaceSplnenaNa: 'Akontácia splnená na',
      budouciNavyseniVkladu: 'Budúce navýšenie vkladov',
      castJeVProduktech: 'časť je v produktoch',
      cil: 'Cieľ',
      cilSplnen: 'cieľ splnený',
      dleProfiluVolnaHotovost: '(podľa profilu). Voľná hotovosť',
      dobaSplaceniLet: 'Doba splácania (rokov)',
      financniNezavislostRenta: 'Finančná nezávislosť — renta',
      horizont: 'horizont',
      horizontLet: 'Horizont (rokov)',
      hypotecniCil: 'Hypotečný cieľ',
      jakNasetritAkontaci: 'Ako našetriť akontáciu',
      jednorazove: 'Jednorazovo',
      jednorazoveDnes: 'Jednorazovo dnes',
      kombinace: 'Kombinácia',
      ktereSeMusiZrusit: 'ktoré sa musia zrušiť (často nevýhodné). Lepšie investovať',
      let: 'rokov',
      letDosahnes: 'rokov dosiahneš',
      letDriv: 'rokov skôr!',
      letDvojtecka: 'rokov:',
      letPrida: 'rokov pridá',
      mesicne: 'Mesačne',
      navrhniPravidelne: 'Navrhni pravidelne',
      navrhniZMajetku: 'Navrhni z majetku',
      nutnoRusitZvazPravidelne: 'nutno rušiť. Zváž pravidelne.',
      o: 'o',
      pocitanoSVynosem: 'Počítané s výnosom',
      potrebnyKapital: 'Potrebný kapitál',
      pravidelne: 'Pravidelne',
      pravidelne2: 'pravidelne',
      pridatNavyseniNapr: 'Pridať navýšenie (napr. po zvýšení platu)',
      realne: '% reálne',
      renta: 'renta',
      splatka: 'splátka',
      splneni: 'Splnenie',
      splneni2: 'splnenie',
      tolikVolneHotovostiKlient: 'Toľko voľnej hotovosti klient nemá',
      uver: 'úver',
      volneMaKlientJen: 'Voľne má klient len',
      za: 'za',
      zaLet: 'Za (rokov)',
      zaVelke: 'Za',
      zadneCileZAnalyzy: 'Žiadne ciele z analýzy. Doplň ciele v analýze a vráť sa sem doladiť, ako sa splnia.',
      zamcenoVProduktech: 'zamknuté v produktoch',
      zbytekJeVeStavebku: '— zvyšok je v stavebku/penzijku',
    },
    finMatematikaPage: {
      cerpaniNekonecna: '♾️ nekonečná',
      chartRok: 'Rok',
      dobaCerpani: 'Doba čerpania',
      dobaCerpaniRenty: 'Doba čerpania renty',
      dobaSplaceni: 'Doba splácania',
      dopocitatPole: 'Dopočítať toto pole',
      financniMatematika: 'Finančná matematika',
      frekvenceUroku: 'Frekvencia pripisovania úroku',
      hodnotaInvestice: 'Hodnota investície',
      jednorazovyVklad: 'Jednorazový vklad',
      jednotkaLet: 'rokov',
      kartaCelkemVlozite: 'Spolu vložíte',
      vstupniPoplatek: 'Vstupný poplatok z cieľovej sumy',
      kartaPoplatek: 'Poplatok',
      kartaCilovaCastka: 'Cieľová suma',
      vetaPoplatek: 'Z cieľovej sumy {cilova} je vstupný poplatok {poplatek} ({pct} %), strhne sa hneď na začiatku.',
      dipPrepinac: 'Daňový odpočet DIP',
      dipBez: 'Bez DIP',
      dipS: 'S DIP',
      kartaStatDip: 'Štát vráti (DIP)',
      kartaSDip: 'S DIP spolu',
      vetaDip: 'S DIP štát za {roky} rokov vráti na dani {stat} (15 % z vkladov, max 7 200 Kč ročne). Reinvestované narastie na {hodnota}, z toho {vynos} výnos. Podmienka: výber najskôr v 60 rokoch a po 10 rokoch zmluvy, inak sa odpočet dodaní.',
      rozpisPoLetech: 'Rozpis po rokoch',
      thSplaceno: 'Splatené',
      thUrok: 'Úrok',
      thJistina: 'Istina',
      thZustatek: 'Zostatok',
      thVlozeno: 'Vložené spolu',
      thVynos: 'Výnos spolu',
      thHodnota: 'Hodnota',
      thVyplaceno: 'Vyplatené spolu',
      thCelkem: 'Spolu',
      tiskZadani: 'Zadanie',
      tiskVysledek: 'Výsledok',
      tiskPripraveno: 'Pripravené {datum}',
      upozorneniUver: 'Modelový výpočet anuitnej splátky pri nemennej sadzbe počas celej doby. Skutočnú splátku, RPMN a poplatky určí ponuka banky.',
      upozorneniInvestice: 'Modelácia s pevným ročným zhodnotením, nie záruka. Skutočné výnosy kolíšu a môžu byť aj záporné; minulé ani modelové výnosy nezaručujú budúce.',
      upozorneniRenta: 'Modelácia čerpania s pevným zhodnotením, nie záruka. Skutočné výnosy kolíšu, renta môže vydržať kratšie.',
      kartaCelkemZaplatite: 'Spolu zaplatíte',
      kartaDoba: 'Doba',
      kartaDobaCerpani: 'Doba čerpania',
      kartaJednorazovyVklad: 'Jednorazový vklad',
      kartaKonecnaHodnota: 'Konečná hodnota',
      kartaMesicniRenta: 'Mesačná renta',
      kartaMesicniSplatka: 'Mesačná splátka',
      kartaPocatecniHodnota: 'Počiatočná hodnota',
      kartaPravidelnaMes: 'Pravidelná mes.',
      kartaRentaCelkem: 'Renta spolu',
      kartaSplatnost: 'Splatnosť',
      kartaUrokPa: 'Úrok p.a.',
      kartaVyseUveru: 'Výška úveru',
      kartaZTohoUroky: 'Z toho úroky',
      kartaZhodnoceniPa: 'Zhodnotenie p.a.',
      konecnaHodnotaInvestice: 'Konečná hodnota investície',
      mesZkratka: 'mes',
      mesicniSplatka: 'Mesačná splátka',
      pocatecniHodnota: 'Počiatočná hodnota',
      pravidelnaMesInvestice: 'Pravidelná mes. investícia',
      splatnost: 'Splatnosť',
      urokovaSazba: 'Úroková sadzba',
      vetaInvestice: 'Z {vlozeno} vložených urobíte {konec} — to je {navic} navyše vďaka zloženému úročeniu. Čas robí prácu za vás.',
      vetaRenta: '{kapital} vám vypláca {renta}/{mes} po {roky} {rok} (spolu {celkem}).',
      vetaRentaNekonecna: '{kapital} pri {sazba} % vynáša viac, než koľko čerpáte — renta je NEKONEČNÁ. To je finančná nezávislosť. 🎉',
      vetaUver: 'Úver {castka} na {roky} {rok} pri {sazba} % — spolu zaplatíte {celkem}, z toho {uroky} sú úroky.',
      vlozenoCelkem: 'Vložené spolu',
      vyseMesicniRenty: 'Výška mesačnej renty',
      vyseUveru: 'Výška úveru',
      vyvojHodnotyInvestice: 'Vývoj hodnoty investície',
      vyvojRentyCerpaniKapitalu: 'Vývoj renty (čerpanie kapitálu)',
      vyvojZustatkuUveru: 'Vývoj zostatku úveru',
      zhodnoceniPA: 'Zhodnotenie p.a.',
      zhodnoceniRentyPA: 'Zhodnotenie renty p.a.',
      zustatek: 'Zostatok',
      zustatekUveru: 'Zostatok úveru',
    },
    funnelCalc: {
      casPrida: 'Čas pridá ',
      cil: 'cieľ',
      coJsiVlozil: 'Čo si vložil',
      investiceNeseRizikoHodnota: 'Investícia nesie riziko — hodnota kolíše a môže klesnúť; minulé výnosy nezaručujú budúce.',
      jakByToRostlo: 'Ako by to rástlo v čase',
      mesicnePotrebujesOdkladat: 'Mesačne potrebuješ odkladať',
      orientacniVypocetZeSlozeneho: 'Orientačný výpočet zo zloženého úročenia.',
      potrebnyKapitalNaRentu: 'Potrebný kapitál na rentu: ',
      spocitejSiToNazivo: 'Spočítaj si to — naživo',
    },
    globalSearch: {
      beplanGlobalniHledani: 'Beplan · globálne hľadanie',
      chytreHledani: 'Inteligentné hľadanie',
      hledat: 'Hľadať…',
      hledatCmdCtrlK: 'Hľadať (Cmd/Ctrl + K)',
      hledatKlientaUkolHashtag: 'Hľadať klienta, úlohu, #hashtag, telefón…',
      navigaceOtevritEscZavrit: '↑↓ navigácia · ↵ otvoriť · ESC zavrieť',
      otevrit: 'Otvoriť',
      ukoly: 'Úlohy',
      zadneVysledkyPro: 'Žiadne výsledky pre',
      zavrit: 'Zavrieť',
    },
    globalTabBar: {
      hledat: 'Hľadať',
      nastaveni: 'Nastavenia',
      odhlasit: 'Odhlásiť',
      zavritVse: 'Zatvoriť všetko',
      zavritVsechnyZalozky: 'Zatvoriť všetky záložky',
    },
    gmailConnectCard: {
      gmailOdpojen: 'Gmail odpojený',
      gmailPropojen: 'Gmail prepojený',
      nacitamStavGmailPropojeni: 'Načítavam stav Gmail prepojenia…',
      odpojeniSelhalo: 'Odpojenie zlyhalo',
      odpojit: 'Odpojiť',
      opravduOdpojitGmailNebudes: 'Naozaj odpojiť Gmail? Nebudeš môcť posielať emaily priamo z CRM.',
      pripojSvujGmail: 'Prepoj svoj Gmail',
      pripojitGmail: 'Pripojiť Gmail',
      propojeniGmailuZatimNeni: 'Prepojenie Gmailu zatiaľ nie je zapnuté',
      serverNeodpovedelNevimeJestli: 'Server neodpovedal. Nevieme povedať, či je Gmail pripojený — skús obnoviť stránku.',
      stavEMailuSe: 'Stav e-mailu sa nepodarilo zistiť',
    },
    gmailMessageDetail: {
      komu: 'Komu',
      kopie: 'Kópia',
      nepodariloSeNacistEmail: 'E-mail sa nepodarilo načítať',
      odpovedetAi: 'Odpovedať AI',
      otevritVGmailu: 'Otvoriť v Gmaile',
      textZpravyTadyNezobrazime: 'Text správy tu nezobrazíme',
    },
    hypotecniPipelinePage: {
      excelLikePrehledVsech: 'Excel-like prehľad všetkých otvorených hypoték a refinancovania · klik na riadok otvorí obchodný prípad',
      hypotekaZalozena: 'Hypotéka založená',
      kanbanPohledPouzivaObchodni: 'Kanban pohľad používa Obchodná nástenka — pre hypotéky odporúčame Tabuľkový pohľad. ',
      klikNaRadekDetail: 'Klik na riadok → detail obchodného prípadu',
      nelzeNacistHypoteky: 'Nemožno načítať hypotéky',
      otevritObchodniNastenku: 'Otvoriť Obchodnú nástenku ›',
      pripraveno: 'pripravené',
      tabulka: 'Tabuľka',
      tentoTyden: 'Tento týždeň',
      urgentni: 'urgentné',
      uverovaPipeline: 'Úverová pipeline',
      vLimitu: 'v limite',
      vReseni: 'v riešení',
      vse: 'Všetko',
      vyzadujeAkci: 'Vyžaduje akciu',
      zadneHypotekyNeodpovidajiFiltru: 'Žiadne hypotéky nezodpovedajú filtru.',
    },
    investicniStrategiePage: {
      celkemVlozi: 'Celkovo vloží',
      cenaNecinnosti: 'Cena nečinnosti',
      citat: '„Koľko je dosť? Toľko, aby výnos pokryl vaše výdavky. Potom ste finančne nezávislí — peniaze pracujú za vás.“',
      coSiKlientOdnese: 'Čo si klient odnesie',
      doba: 'Doba',
      hodnotaLegenda: 'Hodnota',
      inflaceNiciHotovost: 'Inflácia ničí hotovosť',
      inflaceText: 'Peniaze v hotovosti ticho strácajú hodnotu. Za {roky} {rok} pri 3 % inflácii z {vlozeno} zostane kúpna sila len ~{realne}. Nerobiť nič je tiež rozhodnutie — to najdrahšie.',
      investicniStrategie: 'Investičné stratégie',
      kapital: 'Kapitál',
      kapitalZustava: '…a kapitál {kapital} zostáva nedotknutý pre deti.',
      kino: 'Kino',
      kinoTooltip: 'Spustiť kino prezentáciu',
      klientTip: 'Nezáleží ani tak na tom „koľko“ — dôležité je začať a nechať čas pracovať.',
      mes: 'mes',
      mesSlash: '/mes',
      mesicniVklad: 'Mesačný vklad',
      naKonciMa: 'Na konci má',
      nekonecnaMesicniRenta: 'Nekonečná mesačná renta ({sazba} p.a.)',
      nekonecnaRentaSazba: 'Nekonečná renta ({sazba} p.a.)',
      nevymyslimeNicNovehoKopirujeme: 'Nevymýšľame nič nové — kopírujeme najlepších',
      odklada: 'Odkladá',
      odkladaHodnota: '{castka}/{mes} × {roky} {rok}',
      podnadpisA: 'Ukážte klientovi, že jeho plán stojí na stratégiách, ktoré roky fungujú najväčším fondom sveta. Klik na stratégiu → spočítate ju na 100 rokoch reálnych dát. Alebo spustite ',
      podnadpisB: ' s interaktívnou mapou sveta.',
      podnadpisTucne: 'kino prezentáciu',
      prezentovatKlientovi: 'Prezentovať klientovi',
      procInvestovat: 'Prečo investovať',
      procNedojde: 'Prečo renta nikdy nedôjde',
      rentaMilion: 'každý milión = ~{naMilion} {symbol} mesačne navždy',
      rentaNavzdy: 'Renta navždy',
      rentaText: 'Z {kapital} pri {sazba} ročne máte rentu {renta}/{mes} — navždy a kapitál zostáva. To je finančná nezávislosť.',
      rentaVetaA: 'Keď si vyberáte len ',
      rentaVetaB: ' (nie podstatu), kapitál sa nikdy nevyčerpá. Pri {sazba} ročne ',
      rentaVetaC: ' — a milión vám stále zostáva.',
      rentaVynos: 'výnos',
      silaSlozeneho: 'Sila zloženého úročenia',
      spocitat: 'Spočítať na 100 rokoch',
      svoboda: 'Sloboda',
      urokText: 'Za {roky} {rok} vaše peniaze samy zarobia {rust}. Čím skôr začnete, tým dlhšie pracuje zložené úročenie za vás.',
      urokZUroku: 'Úrok z úroku',
      vlozenoLegenda: 'Vložené',
      vynosPa: 'Výnos p.a.',
      zTohoVydelaly: 'Z toho zarobili samy peniaze',
      zadejteVklad: 'Zadajte vklad — ukážte klientovi jeho rast',
    },
    klientiPage: {
      aresNapoviADoplni: 'ARES napovie a doplní',
      chybaPriUkladani: 'Chyba pri ukladaní: ',
      coMaUMe: 'Čo má u mňa',
      coVlastni: 'Čo vlastní',
      dnes: 'dnes',
      jmeno: 'Meno',
      jmenoJePovinne: 'Meno je povinné',
      jmenoNazev: 'Meno / názov',
      karty: 'Karty',
      kategorie: 'Kategória',
      kategorieKlienta: 'Kategória klienta',
      klientPridan: 'Klient pridaný',
      klientTrvaleSmazan: 'Klient natrvalo zmazaný',
      klientVracenDoPipeline: 'Klient vrátený do pipeline',
      kos: 'Kôš',
      kosJePrazdny: 'Kôš je prázdny',
      kosOdstraneniKlientiKdykoli: 'Kôš — odstránení klienti; kedykoľvek ich možno obnoviť',
      kosSeNepodariloNacist: 'Kôš sa nepodarilo načítať',
      moznaDuplicita: 'Možná duplicita',
      moznaDuplicitaPotvrdZe: 'Možná duplicita — potvrď, že chceš aj tak pridať',
      naborKandidat: 'Nábor — kandidát',
      nacitamKos: 'Načítavam kôš…',
      nactenoZAres: 'Načítané z ARES',
      napisteJmenoNeboNazev: 'Napíšte meno alebo názov klienta…',
      nepovedloSeUlozit: 'Nepodarilo sa uložiť',
      neznamaChyba: 'neznáma chyba',
      obnoveniSeNezdarilo: 'Obnovenie sa nepodarilo',
      obnovit: 'Obnoviť',
      odlozenDoSkupinyBez: 'odložený do skupiny bez záujmu',
      odlozitZatimBezZajmu: 'Odložiť — zatiaľ bez záujmu',
      odstraneniKlientiSeObjevi: 'Odstránení klienti sa objavia tu — kedykoľvek ich môžeš obnoviť späť do pipeline.',
      otevrit: '→ otvoriť',
      poznamkaPriZakladani: 'Poznámka pri zakladaní',
      pridejKlientaVCrm: 'Pridaj klienta v CRM Pipeline.',
      prijmeni: 'Priezvisko',
      resetovatFiltry: 'Resetovať filtre',
      smazaniSeNezdarilo: 'Zmazanie sa nepodarilo: ',
      smazatNavzdy: 'Zmazať navždy',
      tabulka: 'Tabuľka',
      telefon: 'Telefón',
      titoKlientiSeVelmi: 'Títo klienti sa veľmi podobajú — otvor niektorého z nich, alebo potvrď, že naozaj chceš vytvoriť nový záznam.',
      trvaToDlouhoKlikni: 'Trvá to dlho? Klikni pre obnovu',
      trvaleSmazatNevratne: 'Natrvalo zmazať — nevratné',
      typologie: 'Typológia',
      ukladam: 'Ukladám…',
      ulozit: 'Uložiť',
      ulozitAOtevrit: 'Uložiť a otvoriť',
      vKosiKlientiNejsou: 'v koši · klienti nie sú zmazaní — kedykoľvek ich obnovíš',
      vKosiOd: 'v koši od',
      vimZeToNeni: 'Viem, že to nie je duplicita — chcem založiť nový záznam',
      volat: 'Volať',
      vratitDoPipeline: 'Vrátiť do pipeline',
      vratitKlientaZpetDo: 'Vrátiť klienta späť do pipeline',
      vse: 'Všetko',
      vymazat: 'Vymazať',
      vymazatVsechnyPokrocileFiltry: '× Vymazať všetky pokročilé filtre',
      zadniKlienti: 'Žiadni klienti.',
      zadnyKlientNeodpovidaHledani: 'Žiadny klient nezodpovedá hľadaniu.',
      zadnyKlientNeodpovidaKombinaci: 'Žiadny klient nezodpovedá kombinácii filtrov. Skús zúžiť výber alebo filtre resetovať.',
      zdroj: 'Zdroj',
      zpetNaKlienty: 'Späť na klientov',
    },
    leadgenCalculatorPremium: {
      orientacniVypocetPresnouNabidku: '* Orientačný výpočet. Presnú ponuku vám pripravím po krátkej konzultácii.',
    },
    newDealModal: {
      klientaSeNepodariloZalozit: 'Klienta sa nepodarilo založiť',
      krokAnalyza: 'Analýza',
      krokCerpani: 'Čerpanie',
      krokPodpis: 'Podpis',
      krokProces: 'Proces',
      napisNejdrivJmenoNoveho: 'Napíš najskôr meno nového klienta do vyhľadávania',
      pravdepodobnostUzavreni: 'Pravdepodobnosť uzavretia',
      ulozitAOtevrit: 'Uložiť a otvoriť',
      zadejNazevObchodnihoPripadu: 'Zadaj názov obchodného prípadu',
    },
    notFoundPage: {
      strankaNenalezena: 'Stránka sa nenašla',
      tatoAdresaNeexistujeNebo: 'Táto adresa neexistuje alebo sa presunula.',
      zpetNaHlavniStranku: 'Späť na hlavnú stránku',
    },
    notesPanel: {
      klikneteAPistePrazdny: 'Kliknite a píšte — prázdny papier, ktorý sa uloží sám.',
      neulozenoUlozisteProhlizeceJe: 'Neuložené — úložisko prehliadača je plné',
      sTimtoStitkemNic: 'So štítkom nič nie je.',
      ulozeno: 'Uložené',
      vse: 'Všetky',
      zatimZadnaPoznamka: 'Zatiaľ žiadna poznámka',
    },
    notificationCenter: {
      celyDen: 'celý deň',
      pripominkySeNepodariloNacist: 'Pripomienky sa nepodarilo načítať.',
      tohleNeniStavMas: 'Toto NIE JE stav „máš čisto“ — dáta sa nenačítali.',
    },
    obchodyPage: {
      akce: 'Akcia',
      akciSeNepodariloDokoncit: 'Akciu sa nepodarilo dokončiť',
      archivSoftDelete: 'Archív · Soft-delete',
      cekaNaVyplatu: 'čaká na výplatu',
      cekamNaProvizi: 'Čakám na províziu',
      duvod: 'Dôvod',
      faze: 'Fáza',
      kategorieKlienta: 'Kategória klienta',
      klient: 'Klient',
      klientObchod: 'Klient · Obchod',
      n1SchuzkaPredstaveni: '1. stretnutie — predstavenie',
      nacitamOdlozeneObchody: 'Načítavam odložené obchody…',
      nelzeNacistArchiv: 'Nemožno načítať archív',
      nelzePresunoutObchod: 'Nemožno presunúť obchod',
      nelzeReaktivovat: 'Nemožno reaktivovať',
      nelzeSmazat: 'Nemožno zmazať',
      obchod: 'Obchod',
      obchodVytvoren: 'Obchod vytvorený',
      odlozene: 'Odložené',
      odlozeneObchodySoftDelete: 'Odložené obchody — soft-delete archív, z ktorého sa dajú obchody znovu reaktivovať',
      odlozeno: 'Odložené',
      odlozenychObchoduMuzesKdykoliv: 'odložených obchodov — môžeš kedykoľvek reaktivovať',
      otevritSlozku: 'Otvoriť zložku',
      otevritSlozkuKlienta: 'Otvoriť zložku klienta',
      planUzavreni: 'Plán — uzavretie',
      prejitNaSloupec: 'Prejsť na stĺpec',
      presunutoDo: 'Presunuté do',
      pretahnoutObchodSem: 'Presuňte obchod sem',
      pridatAktivitu: 'Pridať aktivitu',
      produkt: 'Produkt',
      prohra: 'Prehra',
      prohraUzavrenoK: 'Prehra — uzavreté k',
      reaktivovat: 'Reaktivovať',
      spustitPrezentaciFinancnihoPlanu: 'Spustiť prezentáciu finančného plánu — vedie klienta k podpisu',
      spustitPrezentaciPro1: 'Spustiť prezentáciu pre 1. stretnutie — vedie klienta k finančnej analýze',
      trvaleSmazatZDatabaze: 'Trvalo zmazať z databázy (nevratné)',
      typ: 'Typ',
      vazena: 'Vážená:',
      vratitObchodDoAktivni: 'Vrátiť obchod do aktívnej pipeline',
      vyhraSmlouva: 'Výhra → Zmluva',
      vyhraUzavrenoK: 'Výhra — uzavreté k',
      zadneObchody: 'Žiadne obchody',
      zadneOdlozeneObchody: 'Žiadne odložené obchody',
      zruseno: 'Zrušené',
      zrusenoK: 'Zrušené k',
    },
    onePagePlanPage: {
      dnesSPlanemAz: 'dnes · s plánom až',
      dobryDenPosilamVas: 'Dobrý deň, posielam váš finančný plán. Pozrite a kľudne sa ozvite.',
      financniNezavislost: 'Finančná nezávislosť',
      financniPlan: 'Finančný plán',
      financniPlanNaJedne: 'Finančný plán na jednej strane',
      financniZdravi: 'Finančné zdravie',
      financniZdraviDnesS: 'Finančné zdravie (dnes → s plánom)',
      hypotekouSplatka: 'hypotékou · splátka',
      jednorazove: 'jednorazovo',
      kapital: 'kapitál',
      kapitalProRentu: 'Kapitál pre rentu',
      klesajiciCastkyKryjeDeficit: 'klesajúce sumy · kryje deficit rodiny, dlhy aj ciele',
      mesicneNaCileA: 'Mesačne na ciele a rentu',
      mesicneProCile: 'Mesačne na ciele (odsúhlasené)',
      naAnalyzu: 'Na analýzu',
      naplneniFinancniNezavislosti: 'Naplnenie finančnej nezávislosti',
      naplneno: 'naplnené',
      narativCislaVDnesnichCenach: 'Čísla sú v dnešných cenách. Reálne výnosy nad infláciou: akcie {akcie} %, dlhopisy {dluhopisy} %, hotovosť {cash} %; priemerný výnos akumulácie ≈ {prumer} % ročne. Rentu čerpáme {renta} % ročne z kapitálu. Minulé výnosy nezaručujú budúce.',
      narativPlanNaJednuStranu: 'Finančný plán na jednu stranu — vaše prečo, tri kroky na najbližších 90 dní a ako naplníte ciele aj rentu.',
      navrhReseni: 'Návrh riešenia',
      nepodariloSeNacistData: 'Nepodarilo sa načítať dáta',
      oLetDrive: ' · o {n} rokov skôr',
      ochranaPrijmuVarianta: 'Ochrana príjmov ({varianta})',
      planJeVDnesnich: 'Plán je v dnešných cenách. Reálne výnosy nad infláciou: akcie {akcie} %, dlhopisy {dluhopisy} %, hotovosť {cash} %; priemerný výnos akumulácie ≈ {prumer} % ročne. Renta sa čerpá {renta} % ročne z kapitálu. Odporúčania závisia od poskytnutých údajov; aktualizujeme každé ~3 roky alebo pri zmene situácie. Minulé výnosy nezaručujú budúce.',
      prijmyRodiny: 'Príjmy rodiny',
      pripravujiPlan: 'Pripravujem plán…',
      procToVsechnoDelame: 'Prečo to všetko robíme — vaše slová',
      rentaFinancniNezavislost: 'Renta (finančná nezávislosť)',
      vDnesnichCenachRealne: 'v dnešných cenách (reálne, nad infláciou)',
      vasPoradce: 'Váš finančný sprostredkovateľ',
      vaseBilance: 'Vaša bilancia',
      vaseCileAJak: 'Vaše ciele a ako ich naplníme',
      volnyCashFlow: 'Voľný cash-flow',
      vydajeSplatky: 'Výdavky + splátky',
      zkontrolujtePripojeni: 'Skontrolujte pripojenie a skúste to znova.',
      zkusitZnovu: 'Skúsiť znova',
    },
    pipelineFunnelCompact: {
      bjVPipeline: 'BJ v pipeline',
      pipelinePoFazich: 'Pipeline po fázach',
      vymazatFiltr: 'Vymazať filter',
    },
    planPrehled: {
      azPoCilovemDatu: ' — až po cieľovom dátume',
      rentaOdVekuPenzijka: ' — do renty od {vek} rokov: renta +{castka}',
      bezCerpaniZdroju: 'bez čerpania zdrojov',
      cerpani: 'Čerpanie',
      doraziV: 'dorazí v ',
      finMajetek: 'Fin. majetok',
      investice: 'Investície',
      jednorazove: 'jednorazovo',
      let: 'rokov',
      letech: ' rokoch',
      likvidni: 'Likvidné',
      likvidni2: 'likvidné',
      mesice: 'mesiaca',
      nefinancni: 'Nefinančný',
      nezapojeno: 'Nezapojené',
      od: 'od',
      ostatniUcty: 'Ostatné účty',
      penzijkoRenta: 'Penzijné → renta',
      poPlanu: 'Po pláne:',
      pravidelne: 'pravidelne',
      prebytek: 'Prebytok',
      precerpanoO: 'prečerpané o',
      precerpanoTolikKlient: '— prečerpané, toľko klient nemá',
      prubeznyPrehled: 'Priebežný prehľad',
      stavebko: 'Stavebko',
      stavebko2: 'stavebko',
      volnyPrebytek: 'voľný prebytok',
      za: 'za',
      zbyva: 'zostáva',
      zbyvaLikvidni: 'zostáva likvidné',
    },
    planPrezentacePage: {
      abysteDosahliSvychCilu: '„…aby ste dosiahli svoje ciele **čo najbezpečnejšou cestou**.“',
      abysteNemuselRusit: '„Aby ste nemuseli rušiť strategické investície so stratou kvôli nečakaným výdavkom. Ide na sporiaci účet (~3 %) — tu **nejde o zbohatnutie, ide o pokoj**. Šesť výplat v zálohe = nič vám nesiahne na plán.“',
      akcie: 'akcie',
      akciePodilyVNejvetsich: '„Akcie = podiely v najväčších firmách sveta. Krátkodobo kolíšu, ale sú **jediné, čo dlhodobo spoľahlivo poráža infláciu** — a peniaze na účte medzitým isto strácajú kúpnu silu.“',
      aleJePotrebaPro: '„…ale je potrebné pre to niečo urobiť.“',
      anoCimZacneme: 'Áno — čím začneme?',
      barva: 'farba',
      bezJednorazovehoVkladu: 'bez jednorazového vkladu',
      bezPlanuUcetInflace: 'Bez plánu (účet + inflácia)',
      chtelJsteVeta: 'Chceli ste **{castka}** za **{roky}**.',
      chtelJsteVetaBezTerminu: 'Chceli ste **{castka}**. Termín sme si zatiaľ nepovedali.',
      chtelJsteVetaHned: 'Chceli ste **{castka}** — a to **hneď**.',
      chybi: 'chýba',
      chybiCastka: 'chýba {castka}',
      cilPokryt: '✓ cieľ pokrytý',
      ciluFinancnePodlozeno: 'cieľov finančne podložených',
      coDnesPlanOhrozuje: 'Čo dnes plán ohrozuje',
      coToCelkemStoji: 'Čo to celkom stojí',
      coZaToMate: 'Čo za to máte',
      dalsiZpetNamitkyEsc: '→ ďalej · ← späť · ? námietky · Esc koniec',
      davaVamToSmysl: 'Dáva vám to **zmysel?**',
      deficitBezOchrany: 'Deficit bez ochrany',
      den: '/deň',
      dluhopisy: 'dlhopisy',
      dnesSiVymenimeRole: 'Dnes si vymeníme úlohy.',
      doRokaBudeteMit: 'Do roka budete mať',
      dobraZpravaMatePlan: 'Dobrá správa: **máte plán.**',
      dobreALevneZajistit: 'Dobre a lacno zabezpečiť majetok a budúce príjmy',
      domluvenoCoKdoPripravi: 'Dohodnuté — čo kto pripraví',
      doplnitLikvidniRezervu: 'Doplniť likvidnú rezervu',
      dotazySiProsimNechte: '„Otázky si prosím nechajte na záver — najprv chcem, aby ste videli celkový obraz, celú stratégiu.“',
      druhaBezpecnejsiCesta: 'A druhá je ešte lepšia: **pôjdeme bezpečnejšou cestou.**',
      druhaNezavislostDrive: 'A druhá je ešte lepšia: **nezávislosť o {roky} skôr.**',
      dveBudoucnostiVyberteSi: 'Dve budúcnosti — vyberte si',
      financniMajetekCelkem: 'Finančný majetok celkom',
      glideRokTooltip: 'rok {rok}: akcie {akcie} % · dlhopisy {dluhopisy} % · hotovosť {hotovost} %',
      hotovost: 'hotovosť',
      iVNejhorsimObdobi: 'Aj v **najhoršom** z {pocet} historických období skončil plán na **{vysledek}** — stále {kde} vloženými {vlozeno}. __Čas rozhoduje, nie odhad trhu.__',
      invalidita: 'invalidita',
      investice: 'investície',
      jaPoradce: 'Ja (sprostredkovateľ)',
      jedenZOsmiInvalidita: 'Dlhodobá invalidita — kryjeme **výplatu, nie smrť**',
      jednorazoveOdkud: 'Jednorazovo — odkiaľ',
      jenVicNavic: 'Len **{vklad}** navyše → za {roky} **{kdobru}** k dobru. To robí čas, nie vy.',
      kazdyCilSiVezme: 'Každý cieľ si vezme svoj diel — a **vidíte, čo zostane**.',
      kazdyMilionRentaMesicne: '„každý milión = {naMilion} mesačne, navždy“',
      kdeJsteDnesStartovni: 'Kde ste dnes — štartovacia čiara',
      kdybysteInvestovalPred20: '„Keby ste investovali pred 20 rokmi…“ — 100 rokov histórie',
      kdybysteTenhlePlanJel: 'Keby ste tento plán išli **{roky}** kedykoľvek za posledných 100 rokov…',
      kdybysteTohleInvestoval: 'Keby ste toto investovali posledných **{roky}**, podľa **reálnych dát** dnes máte:',
      krok_bezVsSPlanem: 'BEZ vs. S PLÁNOM',
      krok_cile: 'CIELE',
      krok_coDelateDobre: 'ČO ROBÍTE DOBRE',
      krok_dveZpravy: 'DVE SPRÁVY',
      krok_kdeJsteDnes: 'KDE STE DNES',
      krok_kroky: 'KROKY',
      krok_motivace: 'MOTIVÁCIA',
      krok_proc: 'PREČO',
      krok_rezerva: 'REZERVA',
      krok_rizika: 'RIZIKÁ',
      krok_rozpocet: 'ROZPOČET',
      krok_silaCasu: 'SILA ČASU',
      krok_souhrn: 'ZHRNUTIE',
      krok_uvod: 'ÚVOD',
      krok_vaseCesta: 'VAŠA CESTA',
      krok_zaver: 'ZÁVER',
      krytiInvalidita: 'Invalidita',
      krytiInvaliditaProc: 'dlhodobý výpadok príjmu, ktorý rezerva nepokryje — a výdavky navyše rastú',
      krytiOdskodne: 'Denné odškodné za úraz',
      krytiOdskodneProc: 'úraz zastaví príjem od 1. dňa — bez karencie',
      krytiPn: 'Pracovná neschopnosť',
      krytiPnProc: 'nemocenská kryje len časť príjmu; dávka dorovná rozpočet od {mesic}. mesiaca',
      krytiSmrt: 'Smrť',
      krytiSmrtProc: 'nahradí príjem rodine — výdavky, splátky aj ciele; klesajúca suma = lacnejšie',
      krytiTrvaleHodnota: '{castka} s progresiou',
      krytiTrvaleNasledky: 'Trvalé následky úrazu',
      krytiTrvaleProc: 'vážnejšie následky = vyššie plnenie (v našom modeli najviac 2,8× sumy — v poisťovniach sa líši)',
      mamProVasDve: 'Mám pre vás dve správy',
      mate: 'Máte:',
      mateZCehoStavet: 'máte z čoho stavať — to je obrovská výhoda',
      mesicneNaStejnouRentu: 'mesačne na rovnakú rentu',
      mezernik: 'MEDZERNÍK',
      minuleJsemSePtal: '„Minule som sa pýtal ja a vy ste rozprávali — dnes budem hovoriť ja.“',
      motivAplikace: 'Motív aplikácie',
      motorPlanu: 'To je motor plánu — **{rok}/rok**, s ktorým budeme ďalej pracovať. Nič navyše.',
      moznaJeTechCisel: 'Možno je tých čísel veľa — ale je to jednoduché',
      naCileARentu: ' na ciele a rentu',
      naNavrh: 'Na návrh',
      naZacatkuJsteRekl: '„Na začiatku ste povedali, že najdôležitejšia je pre vás **„{hodnota}“** — a presne toto je plán, ako to splniť. Ak to dáva zmysel, poďme sa dohodnúť, čím začneme.“',
      nadPrebytek: 'Voľné cash flow máte {prebytek} mesačne — plán je o {rozdil} vyšší. Prejdeme spolu, odkiaľ ten rozdiel vziať.',
      nadVlozenymi: 'nad',
      namitka1: '„Musím si to rozmyslieť.“',
      namitka1Odpoved: '„Rozumiem — čo konkrétne vám v hlave leží? Čísla, poistenie, alebo suma? Poďme to vyriešiť teraz, aby ste nemuseli premýšľať sám.“ (Zisti SKUTOČNÚ námietku — „rozmyslieť“ je zástierka.)',
      namitka2: '„Preberiem to s manželkou/manželom.“',
      namitka2Odpoved: '„Úplne správne — toto je rodinné rozhodnutie. Poďme rovno dohodnúť stretnutie vo trojici, aby som to partnerovi vysvetlil ja a vy nemuseli obhajovať čísla, ktoré nie sú vaše.“ (Nikdy nenechaj klienta predávať za teba.)',
      namitka3: '„Teraz na to nemám peniaze.“',
      namitka3Odpoved: '„Plán nestojí nič navyše — pracuje len s prebytkom, ktorý ste mi sám odsúhlasili. A ak je menší, začneme menšou sumou. Kedy je lepšie začať: dnes, alebo o 5 rokov o 40 % drahšie?“ (Ukáž slide Cena za čakanie.)',
      namitka4: '„Poistenie je vyhadzovanie peňazí.“',
      namitka4Odpoved: '„Súhlasím — zlé poistenie áno. Preto rušíme drahé zmluvy a necháváme len ochranu výplaty, aby deficit v rozpočte nikdy nenastal. Je to padák — neplatíte za pád, platíte za prežitie.“ (Vráť sa na slide Riziká.)',
      namitka5: '„Akcie sú hazard / bojím sa krízy.“',
      namitka5Odpoved: '„Krátkodobo máte pravdu — preto má plán rezervu a brzdu. Ale ukážem vám 100 rokov dát: každá kríza skončila a trh sa vrátil. Hazard je nechať peniaze ležať a isto ich dať inflácii.“ (Otvor historickú kalkulačku — let krízami.)',
      nasporenoZaLet: 'Nasporené za {roky}',
      navrhKrytiJeV: 'návrh krytia je v analýze',
      nejdrivToCoUz: 'Najprv to, čo už robíte dobre',
      nejdrivVyplnAnalyzu: 'Najprv vyplň analýzu',
      nemateZadneSpatneDluhy: 'Nemáte žiadne zlé dlhy',
      nepojisteno: 'Nepoistené: {co}',
      nesplaceneZavazky: 'Nesplatené záväzky',
      neuplnaRezerva: 'Neúplná rezerva',
      nezSePustimeDo: '„Než sa pustíme do zaisťovania cieľov, odporúčam ochrániť váš **majetok** a predovšetkým **budúce príjmy**.“',
      nezUkazuPlan: 'Než ukážem plán, ukážem **odkiaľ štartujeme**.',
      nezZacnemeInvestovatOchranime: 'Než začneme investovať — ochránime vás',
      nicJsmeSiNevymysleli: '„Nič sme si nevymysleli — začali sme s tým, čo máte dnes, a rozdelili to medzi vaše ciele. Keď na poslednom riadku svieti nula, znamená to, že každé vaše euro aj každý mesačný prebytok majú svoju úlohu.“',
      nikdyNebudeteMitVice: '„Nikdy nebudete mať **viac času než práve dnes**. Každé odkladanie je finančne nevýhodné.“',
      oMinMene: 'O **{vklad}** menej → za {roky} **{mene}** menej. Vidíte ten rozdiel?',
      ochrana: 'ochrana',
      osvc: ' · SZČO',
      pilirMajetek: 'majetok a zodpovednosť',
      pilirPrace: 'práca',
      pilirPrijem: 'váš príjem (životné poistenie)',
      poKazdemCiliVidite: 'Po každom cieli vidíte, **koľko vám zostáva**.',
      poblizVlozenym: 'blízko',
      pochvalaMajetek: 'Vybudovali ste finančný majetok {castka}',
      pochvalaOdkladate: 'Odkladáte {pct} % príjmov ({castka})',
      pochvalaRezerva: 'Máte rezervu na {pct} %',
      posunteSiSamiMesicni: 'Posuňte si sami — mesačná investícia:',
      povinne: 'povinné',
      pravidelne: 'pravidelne',
      pravidelneInvestovatVolneCash: 'Pravidelne investovať voľný cash flow',
      prebytekNeznamy: 'Voľné cash flow zatiaľ nemáme spočítané — doplníme výdavky a sumu porovnáme.',
      prezentaceFinancnihoPlanu: 'Prezentácia finančného plánu',
      prijem: 'príjem',
      pripravujiPrezentaci: 'Pripravujem prezentáciu…',
      proTentoHorizontA: 'Pre tento horizont a vklady zatiaľ nemáme dosť historických okien.',
      projitZnovu: 'Prejsť znova',
      protiPlanu: 'oproti plánu',
      prvniJeDobra: 'Prvá je dobrá: **vaše ciele sa podarí naplniť.**',
      realneVynosyNadInflaci: 'Reálne výnosy nad infláciu (SBBI 1926–2026). Minulé výnosy nie sú zárukou budúcich — ide o rozpätie, nie o garanciu.',
      renta: 'renta',
      rentaJeZatimNa: 'Renta je zatiaľ na **{pct} %** — a presne vieme, čo s tým.',
      rentierskePortfolio5035: 'rentierske portfólio 50 / 35 / 15',
      rentierskePortfolioDrziSe: 'Rentierske portfólio (drží sa aj v čerpaní)',
      rizikoDluhy: '{castka} — v prípade udalosti zostávajú rodine',
      rizikoInvalidita: 'pri invalidite chýba {castka}',
      rizikoRezerva: 'krytá na {pct} % zo 6 výplat',
      rocneRealne: 'ročne reálne',
      rodinaZajistenaAtSe: 'ochrana príjmu rodiny',
      rozdilProtiPlanu: 'Rozdiel oproti plánu',
      rozdilZaLet: 'Rozdiel za {roky}: {castka}',
      rozkliknoutNa100Letech: 'Rozkliknúť na 100 rokoch histórie + stratégia',
      rozlozeniVCaseGlide: 'Rozloženie v čase — ku koncu menej akcií',
      rozlozitSoucasneUsporyNa: 'Rozložiť súčasné úspory na ciele',
      rozpocetPlanuKamJdou: 'Rozpočet plánu — kam idú vaše peniaze',
      sNefinancnim: 's nefinančným',
      sPlanem: 'S plánom',
      scenarOptimisticky: 'Optimistický scenár',
      scenarOptimistickyPozn: 'najlepších 5 % období',
      scenarPesimisticky: 'Pesimistický scenár',
      scenarPesimistickyPozn: 'najhorších 5 % období (aj veľké krízy)',
      scenarRealisticky: 'Realistický scenár',
      scenarRealistickyPozn: 'medián — polovica období dopadla lepšie',
      silaCasuCoRika: 'Sila času — čo hovorí 100 rokov histórie',
      silaSlozenehoUroceniRoste: 'Sila zloženého úročenia rastie s časom',
      smrt: 'smrť',
      souhrnDoporuceniCelehoPlanu: 'Zhrnutie odporúčaní celého plánu',
      splneno: 'splnené',
      spravneZajisteniJeZaklad: '„Správne zaistenie je základ plánu — nechránime poistku, chránime to, čo ste označili za najdôležitejšie: **„{hodnota}“**.“',
      stavimeNaDobrychZakladech: '„Staviame na dobrých základoch — teraz ich poďme dotiahnuť.“',
      stejnePenizeStejnyClovek: '„Rovnaké peniaze, rovnaký človek — iné rozhodnutia.“',
      styl: 'štýl',
      tahakNaNamitkyJen: 'Ťahák na námietky (len pre teba)',
      tahakNaNamitkyKlient: 'Ťahák na námietky (klient nevidí)',
      takhleToDopadneKdyz: '„Takto to dopadne, keď neurobíme nič…“ — kliknite',
      toNedela8Z: 'pravidelné odkladanie je základ všetkého ďalšieho',
      tohleJeVaseCestaRok: 'Toto je vaša cesta — **rok po roku**.',
      tohleJeVychoziBod: '„Toto je východiskový bod. Teraz vám ukážem, ako z neho postavíme celý plán.“',
      tohleNejsouStatistiky: '„Toto nie sú štatistiky — toto je **váš rozpočet**. V deň, keď nepríde výplata, chýba rodine __{castka}__. Každý mesiac.“',
      uCileBezTrzniho: 'pri cieli bez trhového rizika',
      udelJstePrvniKrok: 'Urobili ste prvý krok — necháte si urobiť plán',
      ukazuVamCoUz: 'Ukážem vám **čo už robíte dobre**, **kde možno prichádzate o peniaze** — a hlavne __na koľko percent sa podarí dosiahnuť vaše ciele__ a čo je pre to potrebné urobiť.',
      ukolKlient1: 'naskenovať existujúce zmluvy (do piatku)',
      ukolKlient2: 'vyplniť investičný dotazník',
      ukolKlient3: 'otázky k plánu poslať mailom',
      ukolPoradce1: 'poistné zmluvy v súlade s plánom',
      ukolPoradce2: 'komisionárska zmluva (cesta k investovaniu)',
      ukolPoradce3: 'nastavenie portfólií podľa plánu',
      vasMajetek: 'Váš majetok',
      vaseCestaKamTecou: 'Vaša cesta — kam tečú vaše peniaze',
      vaseCestaKdySe: 'Vaša cesta — kedy sa ktorý cieľ splní',
      vaseCileJedenPo: 'Vaše ciele — jeden po druhom',
      vaseCileStojiNa: '▲ vaše ciele stoja na…',
      ve25MajiLide: '„V 25 majú ľudia pocit, že si majú užívať. V 35 ide príjem na hypotéku. V 45 platia deťom školy. A v 60 zistia, že **už je neskoro**. Vy začínate dnes.“',
      vejdeSeDoPrebytku: '= zmestí sa do voľného cash flow {prebytek} mesačne, ktoré sme si spočítali.',
      vetsinaLidiFinanceOdklada: 'prvý krok býva ten najťažší',
      vetsinaRodinNemaAni: 'rezerva je základ, na ktorom stojí celý plán',
      vkladNavicNeZ: 'vklad navyše, nie z dnešných úspor',
      vlozenoCelkem: 'Vložené celkom **{celkem}** ({jedn} jednorazovo + {mes}) · stratégia {akcie} % akcie / {dluhopisy} % dlhopisy',
      volneCashFlow: 'Voľný cash flow',
      volnyPrebytekKazdyMesic: 'Voľný prebytok každý mesiac',
      vy: 'Vy',
      vyhovujeVamSchuzkaZase: '„Vyhovuje vám stretnutie zase v stredu v rovnakom čase?“',
      vypadekPrijmu: 'Výpadok príjmu',
      vzacnostGratuluji: 'vzácnosť — gratulujem',
      zPrebytkuDokudNedoplnime: 'z prebytku, kým nedoplníme',
      zToho: 'z toho',
      zaLet: ' (za {roky} rokov)',
      zaLetBudeteMit: 'Za {roky} budete mať',
      zaLetProste: 'za {roky} rokov',
      zacnuDnes: 'začnem DNES',
      zadneZasadniRizikoZ: 'Žiadne zásadné riziko z analýzy — skvelý východiskový stav.',
      zdrojInvestice: 'Investície a sporenie',
      zdrojInvesticePozn: 'pracuje pre vás',
      zdrojLikvidni: 'Likvidné (účty, hotovosť)',
      zdrojLikvidniPozn: 'hneď k dispozícii',
      zdrojNefinancni: 'Nefinančný majetok',
      zdrojNefinancniPozn: 'nehnuteľnosti, firma, dedičstvo',
      zivotniStyl: 'životný štýl',
      zmeniloSeZaTen: '„Zmenilo sa za ten týždeň niečo dôležité?“',
    },
    planVystupPage: {
      akceKoupit: 'Kúpiť',
      akceNavysit: 'Navýšiť',
      akcePonechat: 'Ponechať',
      akceProdat: 'Predať',
      akcie2: 'Akcie',
      alokaceDela92Vysledku: 'alokácia robí ~92 % výsledku',
      alokaceRadek: 'akcie {akcie} % · dlhopisy {dluhopisy} % · hotovosť {penize} %',
      alokaceStartGlide: 'Rozloženie na štarte. Čím bližšie je cieľ, tým viac plán presúva z akcií do dlhopisov a hotovosti — posledný rok pred cieľom je celý v hotovosti.',
      casuDost: 'Času dosť…',
      co: 'Čo',
      coKdyProc: 'čo / kedy / prečo',
      davkyOdhadPozn: 'Invalidný dôchodok je orientačný odhad podľa príjmu; skutočnú výšku určuje Sociálna poisťovňa podľa doby poistenia.',
      dluhopisy: 'Dlhopisy',
      dnes: 'dnes',
      doporucenaAlokace: 'Odporúčaná alokácia',
      doporucenePortfolio: 'Odporúčané portfólio',
      doporuceniProVas: 'Odporúčania pre Vás',
      doporuceniVychazejiZPoskytnutych: 'Odporúčania vychádzajú z poskytnutých údajov. Reálne výnosy nad infláciou: akcie {akcie} %, dlhopisy {dluhopisy} %, hotovosť {cash} %; priemerný výnos akumulácie ≈ {prumer} % ročne. Renta sa čerpá {renta} % ročne z kapitálu. Dokument slúži ako podklad; je nutné ho pravidelne aktualizovať. Minulé výnosy nezaručujú budúce.',
      doporucujemeDiverzifikovatMenove: 'Odporúčame diverzifikovať menovo aj regionálne (svet ~72 % USA), fondy veľkých správcov s ratingom Morningstar. Inšpirácia: Nórsky fond, Nobelova nadácia.',
      financniNezavislost: 'Finančná nezávislosť',
      financniNezavislostPoRealizaci: 'Finančná nezávislosť po realizácii',
      horizont: 'Horizont',
      hotovost2: 'Hotovosť',
      invalidita: 'Invalidita',
      kapitalovaMetodaKlesajiciPojistn: 'Kapitálová metóda (klesajúce poistné sumy): kryje deficit príjmu, dlhy a ciele po odčítaní majetku a prebytku pozostalej domácnosti. Kapitál renty sa počíta len pri invalidite — po úmrtí ju už nikto nečerpá.',
      kdy: 'Kedy',
      klient: 'Klient',
      klient1: 'Klient 1',
      klient2: 'Klient 2',
      konkretniProdukty: 'konkrétne produkty',
      likvidniRezerva: 'Likvidná rezerva',
      mesicneInvestovatNaCile: 'Mesačne investovať na ciele a rentu',
      narativ1: 'Toto je váš finančný plán — koľko mesačne odkladať a ako rozložiť investície, aby ste dosiahli finančnú nezávislosť a ďalšie ciele.',
      narativ2: 'Čísla sú v dnešných cenách. Reálne výnosy nad infláciou: akcie {akcie} %, dlhopisy {dluhopisy} %, hotovosť {cash} %; priemerný výnos akumulácie ≈ {prumer} % ročne. Rentu čerpáme {renta} % ročne z kapitálu; plán spolu pravidelne aktualizujeme. Minulé výnosy nezaručujú budúce.',
      naseDoporuceni: 'Naše odporúčania',
      nehledejteVymluvy: 'NEHĽADAJTE VÝHOVORKY',
      nejdrivVyplnAnalyzu: 'Najprv vyplň analýzu',
      nepodariloSeNacistData: 'Nepodarilo sa načítať dáta',
      oSveBudoucnostiRozhodnete: 'O svojej budúcnosti rozhodnite už DNES.',
      planProDosazeniFinancni: 'Plán na dosiahnutie finančnej nezávislosti a ďalších cieľov',
      planVytvorenDne: 'Plán vytvorený dňa',
      poRealizaci: 'po realizácii',
      poznamka: 'Poznámka:',
      prijmyCelkem: 'Príjmy spolu',
      proc: 'Prečo',
      produkt: 'Produkt',
      profilDynamicky: 'Dynamický',
      profilKonzervativni: 'Konzervatívny',
      profilVychozi: 'predvolený — iný profil nebol zvolený',
      profilVyvazeny: 'Vyvážený',
      riziko: 'Riziko',
      rizikovyProfil: 'Rizikový profil',
      rizikovyProfil2: 'rizikový profil',
      skorePlanuDnesS: 'Skóre plánu (dnes → s plánom)',
      smrt: 'Smrť',
      socialniDavky: ' Sociálne dávky: invalidný dôchodok {inval}/mes{davka}.',
      socialniDavkyStarobni: ', starobný {starobni}/mes',
      soucasnePortfolio: 'Súčasné portfólio',
      souhrnMajetkuADluhu: 'Súhrn majetku a dlhov',
      splatkyUveru: 'Splátky úverov',
      vaseHodnoty: 'Vaše hodnoty',
      vaseStrategickeCile: 'Vaše strategické ciele',
      vasichHodnotACilu: 'vašich hodnôt a cieľov',
      vekNejlepsiCas: 'Máte dnes {vek} — najlepší čas začať je teraz.',
      vstupniInformace: 'vstupné informácie',
      vydajeSpotreba: 'Výdavky (spotreba)',
      vymluva25: 'Sme mladí a začíname. Ešte si veľa nezarábame. Nie je z čoho sporiť.',
      vymluva35: 'Na splátku hypotéky a výdavky padnú všetky príjmy. A na dovolenku máme predsa tiež nárok!',
      vymluva45: 'Nemôžeme si dovoliť sporiť. Deti sú v škole — najlepšie zahraničnej.',
      vymluva55: 'Nie je jednoduché začať v tomto veku.',
      vymluva65: 'Mali sme začať pred mnohými rokmi. Dnes už je neskoro.',
      zajisteniPrijmuVPripade: 'zabezpečenie príjmu v prípade nečakanej udalosti',
      zivotniPojisteni: 'Životné poistenie',
    },
    popisZdroje: {
      jednorazovyVklad: 'jednorazový vklad',
    },
    portfolioDoctorPage: {
      aktualniTerAVstupni: '— aktuálne TER a vstupné z webov správcov',
      bezJmena: '(bez mena)',
      briefProSchuzkuClaude: 'Brief pre schôdzku · Claude Haiku 4.5',
      briefSCnbCompliant: 'Brief s ČNB-compliant slovníkom',
      celkovyModelovyRozdilVe: 'Celkový modelový rozdiel v prospech ETF · ',
      coDoctorUmi: 'Čo Doctor vie',
      diagnostikaSelhalaZkusTo: 'Diagnostika zlyhala. Skús to znova.',
      doporuceni: 'Odporúčanie',
      etfAlternativa: 'ETF alternatíva:',
      fondIsinNeboNazev: 'Fond — ISIN alebo názov',
      hledamFondyNaWebu: 'Hľadám fondy na webe… (15–30 s)',
      ie00b4l5y983NeboConseqActive: 'IE00B4L5Y983 alebo „Conseq Active Invest Dynamický“',
      investovanaCastkaKc: 'Investovaná suma (Kč)',
      janNovak: 'Ján Novák',
      kategorieFonduUrcujeEtf: 'Kategória fondu (určuje ETF náhradu)',
      klientJmeno: 'Klient (meno)',
      klientovyPoziceIsinCastky: 'Klientove pozície (ISIN + sumy)',
      knihovna35NejcastejsichCz: 'Knižnica 35+ najčastejších CZ fondov s reálnymi parametrami',
      knihovnaFondu: 'knižnica fondov',
      marketingoveSdeleniCnbEsma: 'Marketingové oznámenie · ČNB / ESMA disclaimer',
      mesicneDaleKc: 'Mesačne ďalej (Kč)',
      modelovaKalkulaceMinulaVykonnost: 'Modelová kalkulácia. Minulá výkonnosť nie je zárukou budúcej výkonnosti.',
      modelovyRozdilVeProspech: 'Modelový rozdiel v prospech ETF:',
      naprConseqActiveInvest: 'Napr. „Conseq Active Invest Dynamický“',
      naprKlientSeBoji: 'Napr. „Klient sa bojí volatility, manželka chce penziu v 60.“',
      nazevFondu: 'Názov fondu',
      nepodariloSeNacistDiagnostiku: 'Nepodarilo sa načítať diagnostiku.',
      odebratFond: 'Odobrať fond',
      otevritZdroj: 'Otvoriť zdroj ↗',
      overenoNaWebu: 'Overené na webe:',
      posledniDiagnostiky: 'Posledné diagnostiky',
      pozice: 'Pozícia',
      poznamkaProAiBrief: 'Poznámka pre AI brief (voliteľné)',
      prepocitanoSTvymiHodnotami: 'Prepočítané s tvojimi hodnotami',
      prepocitatSMymiHodnotami: 'Prepočítať s mojimi hodnotami',
      pridatIsin: 'Pridať ISIN',
      pridejAlesponJednuPozici: 'Pridaj aspoň jednu pozíciu.',
      rozpoznaUcitsEtfPres: 'Rozpozná UCITS ETF cez justETF (~2 800 fondov)',
      rucniZadani: 'ručné zadanie',
      smazaniSelhalo: 'Zmazanie zlyhalo.',
      smazano: 'Zmazané',
      smazat: 'Zmazať',
      smazatTutoDiagnostiku: 'Zmazať túto diagnostiku?',
      spocita20LetyDopad: 'Spočíta 20-ročný dopad poplatkov v Kč',
      spustitDiagnostikuPortfolia: 'Spustiť diagnostiku portfólia',
      tentoFondJeUz: 'Tento fond je už kvalitný.',
      terEtfCelkem: 'TER ETF spolu',
      terFondCelkem: 'TER fond spolu',
      terMusiByt0: 'TER musí byť 0–10 %',
      terPod05: 'TER pod 0,5 % a akumulačné ETF — meniť neodporúčame.',
      tvojeKnihovna: 'tvoja knižnica',
      ulozeniSelhalo: 'Uloženie zlyhalo',
      uloziFondDoKnihovny: 'Uloží fond do knižnice — nabudúce ho Doctor spozná automaticky',
      ulozitDoKnihovny: 'Uložiť do knižnice',
      upravit: 'Upraviť',
      upravitParametryFondu: 'Upraviť parametre fondu',
      upravitRucne: 'Upraviť ručne',
      veProspechEtf: 'v prospech ETF',
      vek: 'Vek',
      vlozenoCelkem: 'Vložené spolu:',
      vstupni: 'Vstupný (%)',
      vstupni010: 'Vstupný 0–10 %',
      vstupni2: 'Vstupný',
      vstupniPop: 'Vstupný popl.',
      vyberKategorii: 'Vyber kategóriu',
      vyplnNazevTerA: 'Vyplň názov, TER a vstupný',
      zadejteFondIsinNebo: 'Zadajte fond (ISIN alebo názov), koľko klient drží a horizont. Do 30 sekúnd získate modelovú diagnostiku poplatkov, porovnanie s UCITS ETF alternatívou a 3-odsekový brief na schôdzku.',
      zatimZadneUlozeneDiagnostiky: 'Zatiaľ žiadne uložené diagnostiky.',
      zavrit: 'Zavrieť',
      zrusit: 'Zrušiť',
    },
    postaPage: {
      aHlasTextPrikazem: 'a hlasovým/textovým príkazom vygeneruj nový mail.',
      aiEmailKlientovi: 'AI e-mail klientovi',
      bezPristupuKeGoogle: 'Aplikácia nemá od správcu prístup ku Google — na Gmail sa čakať nedá.',
      firemniEmailSmtp: 'firemný e-mail (SMTP)',
      gmailPrepojenyPredek: 'Tvoj Gmail je síce prepojený, ale na',
      gmailPrepojenyTucne: 'čítanie pošty v CRM',
      gmailPrepojenyZadek: 'potrebujeme rozšíriť oprávnenie. Stačí znova prejsť OAuth obrazovku — trvá to 10 sekúnd.',
      gmailZatimPripojitNejde: 'Gmail sa zatiaľ pripojiť nedá',
      hledatVGmailu: 'Hľadať v Gmaile…',
      klikneTeToNa: 'Preklikne ťa to na Google obrazovku, kde len odsúhlasíš „Čítať poštu“.',
      nacteniEmailuSelhalo: 'Načítanie e-mailov zlyhalo',
      neboKlikniNa: 'Alebo klikni na',
      neboSpojka: ', alebo',
      nepodariloSeOveritGmail: 'Nepodarilo sa overiť Gmail',
      nepodariloSeSpustitReconnect: 'Nepodarilo sa spustiť opätovné pripojenie',
      noveOpravneniPosta: 'Nové oprávnenie Pošta',
      obnovit: 'Obnoviť',
      otevritNastaveni: 'Otvoriť Nastavenia',
      postaSeObjeviZde: 'Pošta sa objaví tu, hneď ako si v Nastaveniach pripojíš e-mail. Máš dve možnosti:',
      pripojSiEMail: 'Pripoj si e-mail',
      pripojitFiremniEMail: 'Pripojiť firemný e-mail',
      sLibovolnouAdresou: 'a s ľubovoľnou adresou (Seznam, Microsoft 365, @beplan.cz…). Pripojíš ho za pár minút a budeš odtiaľto písať aj čítať.',
      slozkaDorucene: 'Doručené',
      slozkaHvezdickovane: 'S hviezdičkou',
      slozkaKoncepty: 'Koncepty',
      slozkaKos: 'Kôš',
      slozkaOdeslane: 'Odoslané',
      slozkaVse: 'Všetko',
      slozky: 'Priečinky',
      smtpFungujeHned: 'Firemný e-mail (SMTP) funguje hneď',
      spojeniNaChviliSelhalo: 'Spojenie chvíľu zlyhalo. Skús to znova — tvoj Gmail je pravdepodobne stále pripojený.',
      tenFungujeSLibovolnou: '— ten funguje s ľubovoľnou adresou a nečaká na Google.',
      vyberEmail: 'Vyber e-mail',
      zadneEmailyVeSlozce: 'Žiadne e-maily v priečinku',
      zkusitZnovu: 'Skúsiť znova',
      znovuPripojitGmail1: 'Znova pripojiť Gmail (1-klik)',
      zpetNaSeznam: 'Späť na zoznam',
    },
    publicBookingPage: {
      vybratTermin: 'Vybrať termín',
    },
    radarPrilezitostiPage: {
      dalsi: 'ďalšie',
      detailMezer: 'Detail medzier',
      kdeMaKlientMezeru: 'Kde má klient medzeru — vyber, napíš, dorieš.',
      klientuKOsloveni: 'klientov na oslovenie',
      kritickychMezer: 'kritických medzier',
      napsatEMail: 'Napísať e-mail',
      napsatNaWhatsapp: 'Napísať na WhatsApp',
      obchodSeNepodariloZalozit: 'Obchod sa nepodarilo založiť.',
      obchodniPripadZalozen: 'Obchodný prípad založený.',
      obnovit: 'Obnoviť',
      odlozenoO30Dni: 'Odložené o 30 dní.',
      odlozitNa30Dni: 'Odložiť na 30 dní',
      otevritSlozkuKlienta: 'Otvoriť zložku klienta',
      prilezitostiCelkem: 'príležitostí celkom',
      radarPrilezitosti: 'Radar príležitostí',
      radarSeNepodariloNacist: 'Radar sa nepodarilo načítať. Skús to o chvíľu.',
      radarSeNepodariloNacist2: 'Radar sa nepodarilo načítať',
      sbalit: 'Zbaliť',
      skenujiSmlouvyAAnalyzy: 'Skenujem zmluvy a analýzy…',
      skorePrilezitostiKlikniPro: 'Skóre príležitosti — klikni pre detail',
      terminyFixaceVyrociHlida: 'Termíny (fixácia, výročie) stráži Servisný radar. Odložené medzery sa vrátia o 30 dní.',
      tohleNeniZadnePrilezitosti: 'Toto NIE JE „žiadne príležitosti“ — dáta sa nenačítali.',
      ukol: 'Úloha',
      ukolSeNepodariloVytvorit: 'Úlohu sa nepodarilo vytvoriť.',
      ukolVytvorenZa3: 'Úloha vytvorená (o 3 dni).',
      vse: 'Všetko',
      zadneOtevrenePrilezitosti: 'Žiadne otvorené príležitosti.',
      zkusitZnovu: 'Skúsiť znova',
    },
    reseniCilu: {
      akcie: 'akcie',
      akontacePct: 'akontácia {pct} %',
      bezRustuNeboKroku: 'Bez rastu alebo bez krokov — šablóna nič nepredvyplní.',
      bezpecneCerpani4: 'bezpečné čerpanie 4 %',
      castka: 'Suma',
      chybi: 'Chýba',
      chybiProkazatelnyPrijem: 'V analýze nie je preukázateľný príjem — z čoho má mzda rásť, appka nevie.',
      cil: 'cieľ',
      cilJeVTomhle: 'Cieľ je v tomto nastavení nedosiahnuteľný — číslo je len orientačný strop.',
      cilKrytyJednorazoveBez: 'Cieľ krytý jednorazovo — bez pravidelnej investície.',
      cilVelke: 'Cieľ',
      cilovaCastka: 'Cieľová suma',
      cimSeCilPoridi: 'Čím sa cieľ obstará',
      cnbDo36Let: 'ČNB: do 36 rokov stačí 10 % vlastných zdrojov (LTV 90 %), inak 20 %. 100% financovanie je rozhodnutie poradcu — 10 % ceny kryje úver zo stavebného sporenia. Splátka sa v cashflow prejaví až od čerpania úveru',
      dluhopisy: 'dlhopisy',
      dopocitat: 'dopočítať',
      dopocteno: 'dopočítané',
      dynamicky: 'Dynamický',
      glidePathAlokaceV: 'Postupné znižovanie rizika v čase',
      horizontVLetech: 'Horizont v rokoch',
      hotovost: 'hotovosť',
      hypotekou: 'hypotékou',
      inflacePct: 'Inflácia (%)',
      jakToVyresit: 'Ako to vyriešiť',
      jeNadVolnymPrebytkem: 'je nad voľným prebytkom domácnosti',
      jednorazove: 'Jednorazovo',
      jednorazoveDnesNavic: 'Jednorazovo dnes (navyše)',
      jednorazovy: 'jednorazový',
      kCili: 'K cieľu',
      kapital: 'kapitál',
      kazdychLet: 'Každých (rokov)',
      konzervativni: 'Konzervatívny',
      krokuRustu: 'krokov',
      ktereSeTuNezapocitava: ', ktoré sa tu nezapočítava.',
      let: 'rokov',
      mesice: 'mesiaca',
      mesicne: 'Mesačne',
      mesicniRentaKlienta: 'Mesačná renta klienta',
      mimoradnyPrijem: 'mimoriadny príjem',
      navrh: 'návrh',
      nbsAkontace: 'NBS: bežne 20 % vlastných zdrojov (LTV 80 %), 10 % len výnimočne. 100% financovanie je rozhodnutie poradcu — 10 % ceny kryje úver zo stavebného sporenia. Splátka sa v cashflow prejaví až od čerpania úveru',
      neresiSe: 'nerieši sa',
      nominalne: 'nominálne',
      nominalneMinusInflace: 'nominálne − inflácia',
      nominalneNeprekonaInflaci: 'nominálne neprekoná infláciu',
      oboji: 'Oboje',
      od: 'od',
      odR: 'od r.',
      odebratPritok: 'Odobrať prítok',
      planSlibujeVicNez: '— plán sľubuje viac, než na čo klient dnes má.',
      pocetKroku: 'Počet krokov',
      pocitaSeJakoSporeni: 'Počíta sa ako SPORENIE: klient má našetriť celú sumu {castka}. S úverom sporí len akontáciu.',
      polovina: 'polovica',
      posledni: 'posledný',
      posledniRok100Hotovost: '— posledný rok 100 % hotovosť: žiadne trhové riziko',
      pravidelnaInvestice: 'Pravidelná investícia',
      pridat: 'Pridať',
      pridatBudouciPritok: 'Pridať budúci prítok',
      pripadnyKoncikiNajem: '; prípadný končiaci nájom splátku čiastočne vykryje.',
      realneNadInflaci: 'reálne (nad infláciou)',
      realneTempoDoKroku: 'reálne — toto tempo ide do krokov rastu mzdy.',
      renta: 'renta',
      rentaDrziRentierskePortfolio: '— renta drží rentiérske portfólio 50/35/15 aj pri čerpaní',
      rentaVCerpaniPortfolio: '— pri čerpaní renta drží portfólio {a}/{d}/{c}',
      posledniRokTabulka: '— posledný rok {c} % hotovosť a {d} % dlhopisy',
      rentierskePortfolio: 'rentiérske portfólio',
      resiSeUverem: 'Sporí sa len akontácia, zvyšok rieši úver — splátka nastupuje od čerpania.',
      resimeJenZeZdroju: 'Riešime len zo zdrojov a mesačne.',
      rocniRustPct: 'Rast (%)',
      rok: 'rok',
      rustMzdy: 'rast mzdy',
      rustVkladuNastaveni: 'Rast vkladu — nastavenie',
      sablonaNicNepredvyplni: 'Šablóna teraz nič nepredvyplní.',
      sablonaPredvyplniPritoky: 'Šablóna predvyplní budúce prítoky mzdy naprieč plánom — poradca ich potom upraví.',
      splatka: 'splátka',
      splatnost: 'splatnosť',
      splatnostHypotekyLet: 'Splatnosť hypotéky v rokoch',
      typ: 'Typ',
      urok: 'úrok',
      urokHypotekyPa: 'Úrok hypotéky v % p. a.',
      uverZeStavebka: 'úver zo stavebka',
      uverem: 'úverom',
      vR: 'v r.',
      vkladNadRamecZdroju: 'Vklad nad rámec zdrojov — mesačná platba sa dopočíta.',
      vlastniZdroje: 'vlastné zdroje',
      vlozenoCelkem: '— vložené celkom',
      vybrano: 'vybrané',
      vychazi: 'vychádza',
      vychozi: 'predvolené',
      vychoziHodnoty: 'predvolené hodnoty',
      vychoziParametryHypo: 'Nevyplnené = plán počíta s predvolenými {sazba} % p. a. na {roky} rokov, nie s ponukou banky. Úver zo stavebného sporenia vo variante 100 % má vlastnú sadzbu a tieto polia s ňou nehýbu.',
      vyvazeny: 'Vyvážený',
      zAnalyzy: 'z analýzy',
      zTohoVlastni: 'z toho vlastné zdroje',
      zTohoVyjde: 'Z toho vyjde',
      zVlastnichPenez: 'z vlastných peňazí',
      za: 'za',
      zaLet: 'Za (rokov)',
      zadanePctJe: 'Zadané % je',
      zadano: 'zadané',
      zadat: 'zadať',
      zadneCilSeResi: 'Žiadne — cieľ sa rieši pravidelnou investíciou z prebytku.',
      zadnyRealnyRust: 'reálny rast je nula, šablóna nič nepredvyplní.',
      zahoditKroky: 'Zahodiť kroky rastu mzdy',
      zpetNaHodnotuZ: 'Späť na hodnotu z analýzy',
      zpetNaVychozi: 'späť na predvolené',
      zpetNaVychoziRust: 'späť na predvolené',
      zrusit: 'Zrušiť',
    },
    rezerva: {
      poznKlientuvCilNezbytne: 'Metodika odporúča 6× nevyhnutné výdavky a splátky, teda {metodika}. Váš cieľ je {nasobek}× tohto základu.',
      poznKlientuvCilObvykle: 'Metodika odporúča 6× nevyhnutné výdavky a splátky. Nevyhnutné výdavky v analýze nie sú, takže z bežných výdavkov a splátok vychádza {metodika} — váš cieľ je {nasobek}× tohto základu.',
      poznNeznamy: 'Cieľ rezervy zatiaľ nemáme z čoho vypočítať — chýbajú výdavky.',
      poznObvykle: 'Nevyhnutné výdavky nie sú v analýze zadané — počítané z bežných výdavkov. Doplňte ich a suma sa spresní.',
      titulKlientuvCil: 'Rezerva — váš cieľ',
      titulNezbytne: 'Rezerva (6× nevyhnutné výdavky + splátky)',
      titulNeznamy: 'Rezerva',
      titulObvykle: 'Rezerva (6× bežné výdavky + splátky)',
    },
    rozpocetPlanu: {
      aniTakToAleNa: 'Ale ani tak to na všetky ciele nestačí —',
      cekaNaCil: ' čaká na cieľ.',
      chybiCelkem: 'chýba spolu',
      doraziAzPoCilovem: 'dorazí až PO cieľovom dátume — na cieľovú sumu nemá vplyv',
      financniMajetekJednorazove: 'Finančný majetok — jednorazovo',
      hned: 'hneď',
      jePenzijniSporeniDps: ' je doplnkové dôchodkové sporenie (III. pilier) — je to majetok klienta a plán ho celý počíta na rentu, len do cieľa dorazí ',
      jePenzijniSporeniDps2: ' je doplnkové dôchodkové sporenie (III. pilier). Je to majetok klienta, ale zatiaľ ho nečerpá žiadny cieľ — patrí do renty a klient cieľ finančnej nezávislosti nemá. Ostáva v „zostáva“.',
      jednorazove: 'jednorazovo',
      jednorazoveA: ' jednorazovo a ',
      jednorazoveO: 'jednorazovo o',
      jesteNeniRozdelenoVsechno: 'Ešte nie je rozdelené všetko: ',
      kolikZbyvaPoKazdem: 'Koľko zostáva po každom cieli',
      let: 'rokov',
      letech: 'rokoch',
      mesicneO: 'mesačne o',
      mesicniPrebytekPravidelne: 'Mesačný prebytok — pravidelne',
      mesicu: 'mesiacov',
      miraUspor: 'Miera úspor',
      necerpaZRozpoctu: 'nečerpá z rozpočtu',
      planJeHotovy: ' Plán je hotový.',
      planJednorazovePrerozdeluje: 'Plán jednorazovo prerozdeľuje likvidné účty, stavebné sporenie a dôchodkové. Mimo zostáva ',
      planNemaZCeho: 'plán nemá z čoho platiť. Najprv rozpočet domácnosti.',
      podiloveFondyKzpOstatni: ' (podielové fondy, KŽP, ostatné účty) — celý finančný majetok ',
      povinneVydaje: 'Povinné výdavky',
      pravidelne: 'pravidelne',
      prebytek: 'Prebytok',
      prebytekJeVAnalyze: 'Prebytok je v analýze zadaný ručne — nesedí presne na príjmy mínus výdavky.',
      prebytekNesediNaRozpad: 'Prebytok nesedí na príjmy mínus výdavky a splátky — skontrolujte rozpočet v analýze.',
      prebytekNulaKlientskyVystup: 'Mesačný prebytok je nula — klientský plán sa z nuly nezostaví. Doplňte v analýze sumu, ktorú ste si s klientom odsúhlasili.',
      precerpano: 'Prečerpané',
      precerpanoPlanNevychazi: 'Prečerpané — plán nevychádza',
      prideleno: 'Pridelené',
      prijmy: 'Príjmy',
      rozpocetPlanu: 'Rozpočet plánu',
      tolikKlientNema: ' — toľko klient nemá.',
      v: 'v',
      vydajeASplatkyPrevysuji: 'Výdavky a splátky prevyšujú príjmy o ',
      vyrovnanoVsePrideleno: 'Vyrovnané — všetko pridelené',
      zBudoucihoPritoku: 'z budúceho prítoku (mimo rozpočet)',
      zPenzijkaDpsDip: 'z dôchodkového (III. pilier) · dorazí ',
      zToho: 'Z toho ',
      za: 'za',
      zatimNeniCoRozdelovat: 'Zatiaľ nie je čo rozdeľovať — klient nemá voľný finančný majetok ani mesačný prebytok. Plán začína rozpočtom domácnosti, nie produktom.',
      zatimZadnyCilRozpocet: 'Zatiaľ žiadny cieľ — rozpočet sa naplní, len čo pridáš prvý.',
      zbyva: 'Zostáva',
      zbyva0A0: 'Zostáva 0 a 0 — každé euro aj každý mesačný prebytok má svoju úlohu.',
    },
    sekceCinema: {
      dalsi: 'Ďalej',
      prehrat: 'Prehrať',
      tvojeVeta: 'Vaša veta ',
      zavrit: 'Zatvoriť',
      zpet: 'Späť',
    },
    spolecne: {
      aiGeneraceSelhala: 'AI generovanie zlyhalo',
      chybaPrepisu: 'Chyba prepisu',
      chybaSite: 'Chyba siete',
      cil: 'Cieľ',
      jedMes: '/mes',
      klient: 'klient',
      klientu: 'klientov',
      let: ' rokov',
      mikrofonNeniDostupny: 'Mikrofón nie je dostupný',
      n1HlasovyNeboTextovy: '1. Hlasový alebo textový príkaz',
      napisNeboNahrajPrikaz: 'Napíš alebo nahraj príkaz',
      napsatEMail: 'Napísať e-mail',
      nevimeCile: 'V analýze zatiaľ nie sú žiadne ciele so sumou — preto tu nie je percento.',
      nevimeHorizont: 'Pri cieli chýba horizont — doplňte, o koľko rokov ho chcete.',
      nevimeRenta: 'Cieľ renty nie je zadaný — doplňte, koľko chce klient mesačne a odkedy.',
      nevimeRezerva: 'Cieľ rezervy nepoznáme — v analýze chýbajú výdavky domácnosti.',
      nevimeSkore: 'Skóre sa nedá vypočítať — v analýze chýbajú základné údaje.',
      nevimeVydaje: 'Výdavky domácnosti nie sú v analýze zadané — voľné cashflow sa nedá vypočítať.',
      odesilam: 'Odosielam…',
      odeslaniSelhalo: 'Odoslanie zlyhalo',
      /* Jen podpisová čára klientského jednostránkového plánu — SK neutrálne (zákon 186/2009 Z. z., SOUHRN-SK bod 14). */
      poradce: 'sprostredkovateľ',
      poslatKlientovi: 'Poslať klientovi',
      prazdnaAnalyzaText: 'V analýze zatiaľ nie sú príjmy, výdavky, majetok ani ciele. Doplňte ich a plán sa vypočíta z dát klienta — vymyslené čísla do klientského výstupu nepatria.',
      prazdnaAnalyzaTitul: 'Z tejto analýzy sa plán zostaviť nedá',
      prebytekChybiTextDopocet: 'Z príjmov, výdavkov a splátok vychádza mesačný prebytok nula. Plán z nuly nezostavíme. Skontrolujte v analýze rozpočet domácnosti — alebo doplňte prebytok, ktorý ste si s klientom odsúhlasili.',
      prebytekChybiTextNezadano: 'Mesačný prebytok zatiaľ nevieme — v analýze chýbajú výdavky, z ktorých by sa dal vypočítať. Doplňte ich, alebo rovno zapíšte sumu, ktorú ste si s klientom odsúhlasili.',
      prebytekChybiTextNula: 'Odsúhlasený mesačný prebytok je nula. Plán z nuly nezostavíme — nekreslíme grafy z peňazí, ktoré nie sú, a klientovi nebudeme tvrdiť, že mu mesačné riešenie sedí na prebytok. Doplňte v analýze sumu, na ktorej ste sa s klientom zhodli, alebo najprv preberte rozpočet domácnosti.',
      prebytekChybiTitul: 'Koľko mesačne sme si odsúhlasili?',
      predmet: 'Predmet:',
      prepisSeNezdarilNapis: 'Prepis sa nepodaril — napíš príkaz ručne',
      rentaOdvozena: 'Cieľ renty nie je zadaný — počítame s dnešnými výdavkami klienta.',
      ukladam: 'Ukladám…',
      ulozit: 'Uložiť',
      vytisknoutUlozitPdf: 'Vytlačiť / uložiť PDF',
      zavrit: 'Zavrieť',
      zkusitZnovu: 'Skúsiť znova',
      zmenitPrikaz: 'Zmeniť príkaz',
      zrusitFiltr: 'Zrušiť filter',
    },
    srovnavacFonduPage: {
      horizont: 'Horizont: {roky} {rok}',
      jednorazoveKc: 'Jednorazovo ({mena})',
      mesicneKc: 'Mesačne ({mena})',
      rozdilVeProspech: 'Rozdiel za {roky} {rok} v prospech:',
      srovnavacFondu: 'Porovnávač fondov',
      vlastniA: 'Vlastný A',
      vlastniB: 'Vlastný B',
    },
    tokPenez: {
      beznyUcet: 'Bežný účet',
      budouciPritok: 'Budúci prítok',
      chybi: 'chýba',
      chybiPrecerpano: 'chýba / prečerpané',
      coKlientDnesNema: 'čo klient dnes nemá',
      dnesniMajetek: 'dnešný majetok',
      doraziAzPoCilovem: 'dorazí až PO cieľovom dátume',
      doraziAzPoCilovem2: 'dorazí až PO cieľovom dátume — na cieľovú sumu nemá vplyv',
      doraziV: 'dorazí v',
      hotovost: 'Hotovosť',
      jednorazoveZFinancniho: 'Jednorazovo — z finančného majetku',
      klikniZnovuZpetNa: 'Klikni znova = späť na vypočítaný návrh',
      letech: 'rokoch',
      mesicneZPrebytku: 'Mesačne — z prebytku',
      mesicniPrebytek: 'Mesačný prebytok',
      mesicniPrebytek2: 'mesačný prebytok',
      najedteNaProudUkaze: 'Prejdite na prúd — ukáže sa odkiaľ, kam a koľko.',
      nezarazenyZdroj: 'Nezaradený zdroj',
      odkudKamTecouVase: 'Odkiaľ kam tečú vaše peniaze',
      penzijkoAzPozdeji: 'dôchodkové — až neskôr',
      penzijkoDpsDip: 'Dôchodkové (DDS)',
      posliCelyTenhleZdroj: 'Pošli celý tento zdroj na tento cieľ',
      posliSem: 'pošli sem',
      precerpanoTolikKlient: 'Prečerpané — toľko klient nemá',
      splneno: 'splnené',
      sporiciUcet: 'Sporiaci účet',
      stavebniSporeni: 'Stavebné sporenie',
      tokPenez: 'Tok peňazí',
      uvolnenePenizeARustMzdy: 'Uvoľnené peniaze a rast mzdy',
      vkladNavic: 'Vklad navyše',
      zatimNeniCoRozdelovat: 'Zatiaľ nie je čo rozdeľovať — klient nemá voľný finančný majetok ani mesačný prebytok.',
    },
    whatsAppSender: {
      klientNemaTelefonDopln: 'Klient nemá telefón — doplň ho v kontakte.',
      navrhDleFazeKlienta: 'Návrh podľa fázy klienta',
      otevreWhatsappSTimto: 'Otvorí WhatsApp s týmto textom — ešte dáš odoslať ručne (zdarma, žiadne API).',
      otevritWhatsapp: 'Otvoriť WhatsApp',
      sablona: 'Šablóna',
      zpravaUpravPodlePotreby: 'Správa (uprav podľa potreby)',
      zrusit: 'Zrušiť',
    },
  },
  /* BLOK:auto END */
  /* === /AUTO === */
  /* Klientské „prečo“ pri životnom poistení — pozri cs.js. */
  /* VEŘEJNÁ SDÍLENÁ MODELACE /m/:token — čte to KLIENT, ne poradce.
   * Snapshot je uložený natrvalo, ale texty jsou KLÍČE, takže se přeloží do
   * jazyka toho, KDO SE DÍVÁ — ne toho, kdo modelaci vytvořil. */
  modelace: {
    nacitam: 'Načítavam modeláciu…',
    neplatnyOdkaz: 'Tento odkaz je neplatný alebo vypršal.',
    proVas: 'Modelácia pre vás',
    vaseModelace: 'Vaša modelácia',
    pripravenoPro: 'Pripravené pre',
    jakRozumet: 'Ako tomu rozumieť',
    vasPoradce: 'Váš finančný sprostredkovateľ',
    paticka: 'Orientačná modelácia. Minulé výnosy nie sú zárukou budúcich.',
    ctaSchuzka: 'Dohodnúť stretnutie',
    ctaWhatsApp: 'Napísať na WhatsApp',
    ctaSpojit: 'Spojiť sa',
    chybaNacteni: 'Modeláciu sa teraz nepodarilo načítať. Skontrolujte pripojenie a skúste to znova.',
    zkusitZnovu: 'Skúsiť znova',
    prehrat: 'Prehrať',
    zastavit: 'Zastaviť',
    nahledKlient: 'Čo klient uvidí',
  },
  /* Popisky snapshotu životní kalkulačky pro /m/:token (a PDF).
   * ⚠️ Placeholder {castka} musí být ve všech pěti jazycích STEJNÝ. */
  zivotkoModelace: {
    heroSmrt: 'Koľko rodina potrebuje (smrť živiteľa)',
    pocetOsob: 'Počet osôb',
    nezbytneVydaje: 'Nevyhnutné výdavky',
    zaMesic: '{castka}/mes',
    zaDen: '{castka}/deň',
    variantaKryti: 'Variant krytia',
    varianta_narocna: 'Pre náročných',
    varianta_stredni: 'Zlatá stredná',
    varianta_uskromnit: 'Uskromniť sa',
    varianta_cena: 'Riešim len cenu',
    krytiSmrt: 'Krytie pre prípad smrti',
    krytiInvalidita: 'Krytie pre prípad invalidity',
    pnRodina: 'Práceneschopnosť (rodina)',
    narativ1: 'Čísla hovoria, koľko by rodina dostala, keby sa stalo to najhoršie — aby mohla ďalej bývať, žiť vo svojom štandarde a deti dokončili školu.',
    narativ2: 'Invalidita má vyššiu sumu než smrť, pretože chorý človek doma potrebuje navyše starostlivosť a úpravy. Práceneschopnosť dorovnáva výpadok príjmu pri krátkej chorobe alebo úraze.',
    narativ3: 'Nezáväzný orientačný návrh. Konkrétne podmienky a ceny upresníme spoločne.',
  },
  zivotkoProc: {
    nadpis: 'Prečo je invalidita najdôležitejšia',
    podnadpis: 'Krok za krokom, z vašich vlastných čísel',
    osloveni: '{kdo}, toto je vaša modelácia — a hlavne to, PREČO práve tieto čísla.',
    proOsobu: 'Počítané pre: {kdo}.',
    proOsobuVice: 'Počítané pre: {kdo} — z rodiny má najvyšší príjem. Ostatní majú svoj vlastný výpočet.',
    proOsobuViceBezJmena: 'Počítané pre člena rodiny s najvyšším príjmom. Ostatní majú svoj vlastný výpočet.',
    k1Nadpis: 'Dnes',
    k1Popis: 'Rodina má {prijem} mesačne a na nevyhnutné veci z toho potrebuje {vydaje}.',
    k1PopisBezVydaju: 'Rodina má dnes {prijem} mesačne.',
    k2Nadpis: 'Príjem vypadne',
    k2Popis: '{kdo} už nemôže pracovať. Z príjmov rodiny zostane {zbytek} mesačne.',
    k2PopisBezJmena: 'Tento príjem už nepríde. Z príjmov rodiny zostane {zbytek} mesačne.',
    k2PopisNic: '{kdo} už nemôže pracovať. Žiadny ďalší pracovný príjem rodine nezostane.',
    k2PopisNicBezJmena: 'Tento príjem už nepríde. Žiadny ďalší pracovný príjem rodine nezostane.',
    k3Nadpis: 'Výdavky ale NARASTÚ',
    k3Popis: 'Účty nezmiznú — naopak pribudne starostlivosť, lieky, doprava k lekárovi, úpravy bývania. Model počíta s nárastom o {pct} %, teda {vydaje} mesačne. To je ten rozdiel oproti smrti: človek žije ďalej a jeho život niečo stojí.',
    k3PopisBezNarustu: 'Účty nezmiznú. Rodina ďalej potrebuje {vydaje} mesačne.',
    k4Nadpis: 'Štát pokryje len časť',
    k4Popis: 'Invalidný dôchodok je {duchod} mesačne. Keď sa spočítajú všetky zvyšné príjmy a dávky, každý mesiac stále chýba {chybi}.',
    k4PopisBezDiry: 'Invalidný dôchodok je {duchod} mesačne. Bežné výdavky by rodina zo zvyšných príjmov a dávok pokryla — potreba vzniká až pri dlhoch a cieľoch.',
    k5Nadpis: 'A chýba to každý mesiac, {roky} rokov',
    k5Popis: 'Aby bola diera zaplátaná celých {roky} rokov, je potrebný kapitál {kapital}. Nie je to jednoduchý súčet {naivne} — peniaze sa medzitým zhodnocujú, takže stačí menej. Počíta sa s {sazba} % ročne nad infláciu.',
    k5PopisBezSazby: 'Aby bola diera zaplátaná celých {roky} rokov, je potrebný kapitál {kapital}.',
    k6Nadpis: 'K tomu dlhy a ciele',
    k6NadpisDluhy: 'K tomu dlhy',
    k6NadpisCile: 'K tomu ciele rodiny',
    k6Popis: 'Kapitál na výdavky je jedna časť. Druhá sú záväzky a plány. Dlhy sa pritom nekrátia nikdy — hypotéku nejde doplatiť na 80 %.',
    k6PopisBezDluhu: 'Kapitál na výdavky je jedna časť. Druhá sú plány rodiny, ktoré sa nemajú zastaviť.',
    k6Dluhy: 'Dlhy na doplatenie: {castka}',
    k6Cile: 'Ciele rodiny: {castka}',
    souhrnNadpis: 'Spolu na invaliditu',
    souhrnNadpisOsoba: 'Na invaliditu — {kdo}',
    souhrnNadpisJedna: 'Na invaliditu — táto osoba',
    souhrnPopis: 'Toľko má byť na zmluve, aby rodina zvládla ďalších {roky} rokov žiť ďalej a neprišla o bývanie.',
    souhrnPopisBezLet: 'Toľko má byť na zmluve, aby rodina zvládla žiť ďalej a neprišla o bývanie.',
    srovnaniVyssi: 'Pre prípad smrti vychádza {smrt}. Invalidita je o {rozdil} vyššia — a to je celý dôvod, prečo je prvá. Mŕtvy človek neje, nebýva a nepotrebuje starostlivosť. Živý áno.',
    srovnaniStejne: 'Pre prípad smrti vychádza {smrt}. U vás sú obe čísla blízko seba — rozhoduje potom to, čo sa stane skôr.',
    pausalNadpis: 'Prečo nie „päťnásobok ročného príjmu“',
    pausalMene: 'Pravidlo z príručiek — päťnásobok ročného príjmu — by u vás dalo {pausal}. To je o {rozdil} menej, než vychádza z vašich vlastných výdavkov, dávok a rokov. Paušál nepozná vašu hypotéku ani vaše deti, preto tu žiadny nie je.',
    pausalVice: 'Pravidlo z príručiek — päťnásobok ročného príjmu — by u vás dalo {pausal}, teda o {rozdil} viac, než vychádza z vašich čísel. Paušál nepozná vaše výdavky ani vaše dávky, preto tu žiadny nie je.',
    rizikaNadpis: 'Ostatné riziká — a čo riešia',
    rizikaNadpisOsoba: 'Ostatné riziká — {kdo}',
    rizikaNadpisJedna: 'Ostatné riziká — a čo riešia u tej istej osoby',
    coJe: 'Čo to je',
    bez: 'Čo sa stane bez poistenia',
    resi: 'Koľko to rieši',
    smrtNazev: 'Smrť',
    smrtCoJe: 'Živiteľ zomrie — úrazom alebo chorobou.',
    smrtBez: 'Výdavky a dlhy zostanú, jeden príjem zmizne. Rodina potom rieši predaj bývania práve v roku, keď na to má najmenej síl.',
    trvNazev: 'Trvalé následky úrazu',
    trvCoJe: 'Úraz, po ktorom zostane trvalé obmedzenie — ruka, noha, zrak, chrbtica.',
    trvBez: 'Jednorazové náklady (rehabilitácia, bezbariérové úpravy, iné auto) idú z rezervy. Keď nestačí, z úveru.',
    trvResiPopisek: 'Progresívne plnenie: čím vážnejší následok, tým vyššia výplata — v našom modeli až {nasobek}× dohodnutá suma, v poisťovniach sa líši.',
    pnNazev: 'Práceneschopnosť',
    pnCoJe: 'Choroba alebo úraz na týždne až mesiace. Potom sa človek vráti do práce.',
    pnBez: 'Príjem spadne na nemocenskú, výdavky zostanú rovnaké. Rezerva sa rozpustí počas pár mesiacov.',
    pnBezOsvc: 'SZČO bez nemocenského poistenia nedostane od štátu nič. Výdavky bežia ďalej a rezerva sa rozpustí počas pár mesiacov.',
    pnResiDen: '{castka} / deň',
    pnKarenceOd: 'Rezerva pokryje prvé mesiace, dávka je navrhnutá od {od}. mesiaca.',
    pnKarenceHned: 'Navrhnuté od prvého dňa.',
    zavNazev: 'Závažné ochorenie',
    zavCoJe: 'Rakovina, infarkt, mŕtvica a ďalšie diagnózy zo zoznamu poisťovne.',
    zavBez: 'Liečba a doliečenie trvá mesiace až roky. Človek pracuje menej, platí viac — a nemá čas riešiť peniaze.',
    zavResiPopisek: 'Jednorazovo, vo výške {nasobek}násobku ročného príjmu.',
    ditNazev: 'Vážna udalosť u dieťaťa',
    ditCoJe: 'Dieťa zostane po úraze alebo chorobe trvale závislé na starostlivosti.',
    ditBez: 'Najväčšia diera nie je liečba — je to rodič, ktorý kvôli starostlivosti natrvalo vypadne z práce.',
    ditResiPopisek: 'Suma na zmluve každého dieťaťa. Počíta sa z výpadku príjmu rodiča, ktorý by sa o dieťa staral.',
    ditResiStrop: 'Suma na zmluve každého dieťaťa. Časť potreby ({castka}) neupíše na dieťa žiadna poisťovňa — tá patrí do rezervy a do investícií.',
    cenaNadpis: 'Cena',
    cenaZadana: 'Ochrana vychádza na {cena} mesačne. Je to suma z ponuky, ktorú zadal poradca — konečnú cenu potvrdí poisťovňa v zmluve, až posúdi zdravotný stav. Dovtedy je to odhad, nie ponuka.',
    cenaChybi: 'Cena v tomto dokumente zámerne nie je. Doplní ju poradca podľa konkrétnej poisťovne — kým nie je podpísaná zmluva, žiadne číslo tu nie je ponuka.',
    cenaDen: 'Na deň to robí {denne}.',
    cenaPct: 'Z čistého príjmu rodiny je to {pct} %.',
    poznamkaModelace: 'Toto je modelácia, nie poistná zmluva ani osobné odporúčanie. Čísla vychádzajú z toho, čo ste uviedli — keď sa zmení príjem, výdavky alebo ciele, zmení sa aj výsledok.',
    poznamkaSablona: 'Sumy pri trvalých následkoch, závažných ochoreniach a riziku dieťaťa sú orientačný vzor z praxe poradcu. Konkrétne limity, výluky a čakacie doby určuje poisťovňa.',
    poznamkaDavky: 'Invalidný dôchodok a nemocenská sú odhad podľa českých pravidiel. Skutočnú výšku určuje ČSSZ.',
    poznamkaMetodika: 'Metodika {verze}.',
  },

  /* Klientské formuláře (/f/:token) — JEDINÁ obrazovka appky, kterou otvírá
   * klient, ne poradce. Otevře ji v telefonu, bez přihlášení, a může to být
   * Vietnamec nebo Ukrajinec — proto tu nesmí být ani jeden dvoujazyčný ternár.
   *
   * ZNĚNÍ OTÁZEK TU NENÍ. Popisky polí, nápovědy i texty souhlasu chodí ze
   * serveru přeložené (backend/lib/formulare/*). Backend je jediný zdroj pravdy
   * o tom, jaká pole formulář má a která z nich jsou citlivá; kdyby si seznam
   * držel frontend, stačila by jedna překlepnutá klíčovka a rodné číslo by
   * skončilo v nešifrované části dokumentu.
   */
  formKlient: {
    castZ: "Časť {n} z {celkem}",
    /* Příjmy a výdaje — obrazovka skupiny výdajů a „Váš přehled“ (26. 10. 2026). */
    pv: {
      prehledNadpis: "Váš prehľad",
      prehledPodnadpis: "Skontrolujte čísla a pošlite ich poradcovi. Čo nesedí, upravte.",
      prijmy: "Príjmy",
      vydaje: "Výdavky",
      mesicne: "mesačne",
      zbyva: "Zostáva mesačne",
      zbyvaPopis: "príjmy − výdavky − splátky",
      zbyvaZaporne: "Výdavky a splátky sú vyššie ako príjmy.",
      bezPrijmu: "Bez príjmov sa nedá spočítať, koľko zostáva.",
      rozpad: "Kam peniaze odchádzajú",
      rozpadPrazdno: "Výdavky ste zatiaľ nevyplnili.",
      rozpadAria: "Mesačné výdavky po skupinách, najväčšia je {skupina}: {castka}",
      porovnaniAria: "Príjmy {prijmy}, výdavky {vydaje}",
      splatky: "Splátky úverov",
      sporeni: "Sporenie a investície",
      neniVydaj: "nepočíta sa do výdavkov",
      firma: "Podnikanie (vedie sa zvlášť, mimo domácnosti)",
      minimum: "nevyhnutné minimum",
      minimumCelkem: "Nevyhnutné minimum spolu",
      osoba1: "Vy",
      osoba2: "Partner / partnerka",
      dalsiPrijmy: "Nájom, výnosy, bonusy",
      pravidlo: "Orientačné pravidlo 50 / 30 / 20",
      pravidloPopis: "Povinné výdavky a splátky 50–60 %, život 20–30 %, budúcnosť ideálne 20 % z príjmov. Je to orientácia, nie hodnotenie.",
      povinne: "Povinné",
      zivot: "Život",
      budoucnost: "Budúcnosť",
      cil: "cieľ {rozsah}",
      skupinaCelkem: "Spolu za skupinu",
      vydajeZatim: "Výdavky zatiaľ",
      podrobnosti: "Podrobnosti: nevyhnutné minimum",
      podrobnostiSkryt: "Skryť podrobnosti",
      minimumPopis: "Koľko z toho je nevyhnutné minimum — suma, bez ktorej sa v mesiaci bez príjmu nezaobídete.",
    },
    nacitam: "Načítavam formulár…",
    neplatnyNadpis: "Odkaz už neplatí",
    neplatnyText: "Odkazy na formulár majú obmedzenú platnosť. Napíšte svojmu poradcovi a pošle vám nový.",
    chybaNadpis: "Formulár sa nepodarilo načítať",
    chybaText: "Skúste stránku načítať znova. Ak to nepomôže, ozvite sa svojmu poradcovi.",
    hotovoNadpis: "Odoslané, ďakujeme",
    hotovoText: "{poradce} sa vám ozve. Čo ste nevyplnili, doplníte spolu.",
    hotovoTextBezJmena: "Váš poradca sa vám ozve. Čo ste nevyplnili, doplníte spolu.",
    jazyk: "Jazyk",
    krokZ: "Otázka {n} z {celkem}",
    sekceOtazek: "Otázok v tejto časti: {n}",
    zacit: "Začať",
    pokracovat: "Pokračovať",
    zpet: "Späť",
    dale: "Ďalej",
    preskocit: "Preskočiť",
    nepovinne: "Nepovinné",
    ukladam: "Ukladám…",
    ulozeno: "Uložené — môžete zavrieť a vrátiť sa neskôr.",
    chybaUlozeni: "Posledné zmeny sa nepodarilo uložiť. Skúsime to znova pri ďalšej úprave.",
    chybaUlozeniOdkaz: "Odkaz už neplatí — ozvite sa prosím svojmu poradcovi.",
    zamek: "Ukladáme zašifrovane",
    ulozenoZasifrovane: "Uložené zašifrovane: {maska}. Nechajte prázdne, ak sa nemá meniť.",
    platiDo: "Odkaz platí do {datum}.",
    vyberte: "Vyberte",
    nevyplneno: "Nevyplnené",
    pridatRadek: "Pridať riadok",
    smazatRadek: "Zmazať riadok",
    zvlastniKategorie: "Osobitná kategória údajov",
    souhlasNadpis: "Než začneme",
    souhlasPokracovat: "Súhlasím a chcem pokračovať",
    souhlasOdmitnout: "Nesúhlasím",
    souhlasNutny: "Bez súhlasu formulár vypĺňať nemožno.",
    souhlasOdmitnutoNadpis: "Rozumieme",
    souhlasOdmitnutoText: "Nič sme neuložili a odkaz sme zatvorili. Ak si to rozmyslíte, poradca vám pošle nový.",
    odvolatSouhlas: "Odvolať súhlas a zavrieť odkaz",
    rekapitulaceNadpis: "Skontrolujte a odošlite",
    rekapitulacePodnadpis: "Čo ste nevyplnili, doplníte s poradcom. Nemusí tu byť všetko.",
    upravit: "Upraviť",
    prazdno: "Zatiaľ ste nič nevyplnili.",
    odeslat: "Odoslať poradcovi",
    odesilam: "Odosielam…",
    chybiPovinne: "Na odoslanie ešte chýba: {pole}.",
    chybaOdeslani: "Odoslanie sa nepodarilo. Skúste to prosím ešte raz.",
    poradce: {
      /* Příjmy a výdaje — banner v analýze a složka (26. 10. 2026). */
      pv: {
        banner: "Klient poslal príjmy a výdavky ({datum})",
        prevzit: "Prevziať do analýzy",
        prevzato: "Prevzaté do analýzy",
        zobrazit: "Zobraziť",
        skryt: "Skryť",
        coSeZapise: "Čo sa zapíše do analýzy",
        drivTed: "predtým {pred} → teraz {po}",
        partnerChybi: "Klient vyplnil aj partnera, ale v analýze druhá osoba nie je. Zapíše sa len osoba 1 — doplňte partnera a prevezmite znova.",
        splatkySporeni: "Splátky a sporenie klient uviedol len pre prehľad — do výdavkov sa nezapisujú (patria do Záväzkov a Zdrojov).",
        nicKPrevzeti: "Formulár je prázdny — nie je čo prevziať.",
        hotovo: "Príjmy a výdavky prevzaté do analýzy.",
        chybaRazitka: "Čísla sú v analýze, ale označenie „prevzaté“ sa neuložilo — upozornenie sa môže ukázať znova.",
        chyba: "Prevzatie sa nepodarilo.",
        chybaNacteni: "Odpovede klienta sa nepodarilo načítať.",
        pole: {
          prokaz1: "Osoba 1 — preukázateľný príjem",
          ostatni1: "Osoba 1 — podnikanie / ostatné",
          prokaz2: "Osoba 2 — preukázateľný príjem",
          ostatni2: "Osoba 2 — podnikanie / ostatné",
          pasivni: "Pasívne príjmy",
          bonusyRok: "Bonusy za rok",
          obvykle: "Obvyklé výdavky (vrátane poistného z analýzy)",
          minimalni: "Nevyhnutné výdavky",
          rozpis: "Položiek v rozpise výdavkov",
        },
      },
      nadpis: "Formuláre pre klienta",
      popis: "Vyberte typ, vygenerujte odkaz a pošlite ho klientovi svojím kanálom. Aplikácia nič neodosiela sama.",
      typ: "Typ formulára",
      platnost: "Platnosť odkazu",
      dnu: "{n} dní",
      vytvorit: "Vytvoriť odkaz",
      vytvarim: "Vytváram…",
      zkopirovat: "Skopírovať odkaz",
      zkopirovano: "Skopírované",
      zkopirovatZpravu: "Skopírovať správu klientovi",
      zneplatnit: "Zneplatniť",
      zneplatnitPotvrzeni: "Naozaj zneplatniť? Klient odkaz už neotvorí.",
      stavCeka: "Čaká na klienta",
      stavRozpracovano: "Rozpracované",
      stavVyplneno: "Vyplnené",
      stavVyprselo: "Odkaz vypršal",
      stavZneplatneno: "Zneplatnené",
      stavOdvolano: "Klient odvolal súhlas",
      zobrazit: "Zobraziť odpovede",
      skryt: "Skryť odpovede",
      zvlastniKategorie: "Osobitná kategória — údaje o zdraví",
      zvlastniHint: "Odpovede sú šifrované celé a v náhľade sa nezobrazujú. Každé otvorenie sa zapíše do auditu.",
      kUklidu: "Údaje tu ležia dlhšie ako {n} dní. Zvážte, či ich ešte potrebujete.",
      bezFormularu: "Zatiaľ ste klientovi žiadny formulár neposlali.",
      chybaNacteni: "Formuláre sa nepodarilo načítať.",
      chybaVytvoreni: "Odkaz sa nepodarilo vytvoriť.",
      chybaOdpovedi: "Odpovede sa nepodarilo načítať.",
      odhalit: "Odhaliť",
      platiDo: "Platí do {datum}",
      vyplneno: "Vyplnené {n} z {celkem} polí",
      jazykOdkazu: "Jazyk pre klienta",
      nicNeodesilame: "Odkaz sa len vyrobí. Správu pošlite svojím kanálom, nech viete, komu ide.",
    },
  },
  /* Porovnávač tří způsobů čerpání renty (/renta-porovnavac).
   * 🔴 PRÁVNÍ: „poučené Nobelovou nadací“ NIKDY ne „portfolio Nobelovy nadace“;
   * modelace ≠ investiční doporučení; historie ≠ příslib budoucího výnosu. */
  /* Kdy budeš volný (KFP 20) — peníze přeložené na čas.
   * 🔴 PRÁVNÍ: modelace ≠ investiční doporučení; výnos je NAD inflací,
   * takže renta je v dnešních penězích. Nesmí se to podat jako příslib. */
  /* Hypotéka — čtyři rozhodnutí (KFP 02, 10, 11, 13).
   * 🔴 PRÁVNÍ: modelace, NE úvěrová ani investiční nabídka. Sazby zadává
   * poradce. Porovnává se celé měsíční zatížení, ne jen splátka. */
  hypoR: {
    zalRefixace: 'Koniec fixácie',
    zalSplatnost: '20 alebo 30 rokov',
    zalVyse: 'Koľko vlastných',
    zalCas: 'Vplyv času',
    vyseMeneVlastnich: 'Menej vlastných, viac investovať',
    vyseVicVlastnich: 'Viac vlastných, menší úver',
    chybiVstupy: 'Doplň vstupy vľavo. Kým nie sú vyplnené, nič sa nedopočítava — prázdne pole nie je nula.',
    zpet: 'Nástroje',
    nadpis: 'Hypotéka — štyri rozhodnutia',
    podnadpis: 'Štyri otázky, ktoré klient pri hypotéke naozaj položí. Každá končí jednou vetou, nie tabuľkou. Porovnáva sa celé mesačné zaťaženie — inak by to bolo porovnávanie jabĺk s hruškami.',
    vstupyLabel: 'Hypotéka klienta',
    cena: 'Cena nehnuteľnosti',
    vlastniA: 'Variant A — vlastné peniaze',
    sazbaA: 'Variant A — sadzba',
    vlastniB: 'Variant B — vlastné peniaze',
    sazbaB: 'Variant B — sadzba',
    sazbaBHint: 'Banka dáva lepšiu sadzbu pri nižšom LTV. Práve o tento rozdiel tu ide — bez neho by výpočet nemal zmysel.',
    jistina: 'Výška úveru',
    sazba: 'Sadzba',
    splatnost: 'Splatnosť',
    let: 'rokov',
    fixace: 'Fixácia',
    kratsi: 'Kratší variant',
    kratsiHint: 'Dlhší variant = pole Splatnosť vyššie. Rozdiel v splátke sa pri ňom investuje od prvého mesiaca.',
    prijem: 'Čistý príjem mesačne',
    vydaje: 'Ostatné výdavky mesačne',
    zaLet: 'Pozrieť sa o',
    rustPrijmu: 'Rast príjmu',
    vynos: 'Výnos investície',
    inflace: 'Inflácia',
    inflaceHint: 'Každý rozdiel sa ukazuje dvakrát: v budúcich peniazoch (veľké číslo) a v dnešných (čo si za to klient naozaj kúpi).',
    refVerdiktLabel: 'Keď skončí fixácia',
    refVerdiktVeta: 'mesačne navyše, keby sadzba stúpla o 1 p.b. Za zvyšných {roky} rokov je to {celkem}.',
    refTabulka: 'Splátka podľa novej sadzby',
    refDnes: 'Dnes',
    refPoznamka: 'Za {roky} rokov fixácie klient splatí {splaceno} z istiny ({pct} %). Zvyšok sa preúveruje novou sadzbou — preto skok v splátke.',
    splVerdiktLabel: 'Pri rovnakom mesačnom zaťažení vyhráva',
    splRemiza: 'zhoda',
    splRemizaVeta: 'Oba varianty vychádzajú prakticky rovnako. Rozhodne, čo je klientovi príjemnejšie.',
    splVerdiktVeta: 'O {rozdil} v budúcich peniazoch — to je {dnes} v dnešných. Oba varianty stoja klienta rovnako {zatizeni} mesačne.',
    splMajetek: 'Majetok na konci',
    splRadek: '{let} rokov · splátka {splatka}',
    splPoznamka: 'Pri dlhšom variante sa rozdiel v splátke ({rozdil} mesačne) investuje od prvého mesiaca. Pri kratšom sa po doplatení začne investovať celá splátka. Preto oba stoja rovnako a rozdiel je len vo výsledku.',
    vyseVerdiktLabel: 'Za {roky} rokov vyjde lepšie',
    vyseVerdiktVeta: 'O {rozdil}, čo je {dnes} v dnešných peniazoch.',
    vyseTabulka: 'Oba varianty vedľa seba',
    vyseVlastni: 'Vlastné',
    vyseUver: 'Úver',
    vyseSazba: 'Sadzba',
    vyseSplatka: 'Splátka',
    vyseVolne: 'Voľné na investície',
    vyseMajetek: 'Majetok na konci',
    casVerdiktLabel: 'Splátka sa nemení, všetko ostatné áno',
    casVerdiktVeta: 'Podiel splátky na príjme za {roky} rokov. Z dlhu pritom {umazala} zmaže samotná inflácia — bez jedinej splátky navyše.',
    casRozpocet: 'Mesačný rozpočet',
    casDnes: 'Dnes',
    casPozdeji: 'O {roky} rokov',
    casPrijem: 'Príjem',
    casSplatka: 'Splátka',
    casVydaje: 'Ostatné výdavky',
    casZbyva: 'Zostane',
    casZatizeni: 'Splátka zaberá z príjmu',
    casPoznamka: 'Zostávajúci dlh o {roky} rokov: {nom} nominálne, ale len {real} v dnešných peniazoch. Rozdiel {umazala} je práca inflácie, nie klienta.',
    disclaimer: 'Modelácia, nie úverová ani investičná ponuka. Sadzby zadáva poradca — aplikácia netvrdí, že ich klient dostane. Výnos investície nie je zaručený a skutočný výsledok závisí od trhov, daní a poplatkov.',
  },

  svoboda: {
    rok: 'rok',
    roky: 'roky',
    let: 'rokov',
    mesic: 'mesiac',
    mesice: 'mesiace',
    mesicu: 'mesiacov',
    hned: 'hneď teraz',
    zpet: 'Nástroje',
    nadpis: 'Kedy budeš voľný',
    podnadpis: 'Peniaze preložené na čas. Pridaj čokoľvek navyše a uvidíš, o koľko skôr ti majetok začne platiť účty namiesto práce.',
    nedosazitelneNadpis: 'Takto sa tam nedostaneš.',
    zNedosazitelnehoNadpis: 'Teraz sa tam už dostať dá.',
    nedosazitelneText: 'Z toho, čo sa dnes odkladá, cieľ nevyjde ani za celý život. Nie je to chyba výpočtu — je to správa. Skús zvýšiť mesačné odkladanie alebo znížiť cieľovú rentu.',
    zNedosazitelnehoText: 'Pôvodne cieľ nevychádzal vôbec. Po tomto navýšení už áno — o koľko skôr sa však povedať nedá, pretože predtým nebol žiadny termín.',
    ziskLabel: 'Toto navýšenie ti prinesie',
    zatimNic: 'zatiaľ nič',
    ziskDovetek: 'skôr, než keby všetko zostalo, ako je',
    ziskVyzva: 'posuň posuvníky dole a uvidíš, čo to urobí',
    dnesPlan: 'Dnešný plán',
    sNavysenim: 'S navýšením',
    osaLabel: 'Cesta k nezávislosti',
    zaStropem: 'Termín je za koncom osi — značka stojí na hrane.',
    dnes: 'dnes',
    cilKapital: 'Cieľ',
    cilVysvetleni: '= renta {renta} mesačne v dnešných peniazoch',
    vstupyLabel: 'Ako to má dnes',
    renta: 'Renta, ktorú chce mesačne',
    rentaHint: 'V dnešných peniazoch. Koľko by musel dostávať, aby nemusel chodiť do práce.',
    majetek: 'Čo na to už má',
    majetekHint: 'Investície a úspory, ktoré sú naozaj na tento cieľ — nie rezerva a nie peniaze na auto.',
    mesicne: 'Koľko odkladá mesačne',
    vynos: 'Výnos nad infláciou',
    vynosHint: 'NAD infláciou, nie celkový. Preto sú čísla nižšie, než klient čaká — a preto je renta v dnešných peniazoch.',
    coKdyby: 'A čo keby pridal',
    jednorazove: 'Jednorazovo teraz',
    skokNula: 'nič',
    navic: 'Mesačne navyše',
    pomerLabel: 'Čo za to',
    pomerText: 'Za {penize} navyše dostane {cas} života, v ktorom nemusí.',
    cokdybyPrazdno: 'Posuvníky sú na nule. Zdvihni jeden a sleduj, ako sa akcentová značka na osi rozbehne doľava.',
    cekaniLabel: 'Cena za čakanie',
    cekaniText: 'Keby sa začalo až neskôr. Peniaze zatiaľ ležia na účte — nominálne rovnaké, reálne ich užiera inflácia. Práve preto je strata väčšia než samotné čakanie.',
    inflace: 'Inflácia',
    cekaniOdklad: 'Začne o {doba} neskôr',
    cekaniNedosazitelne: 'už to nevyjde',
    cekaniDovetek: 'dlhšie než dnes',
    disclaimer: 'Modelácia, nie investičné odporúčanie a nie prísľub výnosu. Počíta sa v dnešných peniazoch (výnos je zadaný nad infláciou). Skutočný výsledok závisí od vývoja trhov, daní a poplatkov.',
  },

  rentaPorov: {
    zPlanuOdkaz: "Porovnať tri spôsoby čerpania",
    zaMesic: "/mes",
    zpusobPevne: "Pevné percento",
    zpusobKlouzavy: "Kĺzavý priemer",
    zpusobMantinely: "Mantinely",
    jakPevne: "{pct} z hodnoty, aká práve je",
    jakKlouzavy: "{pct} z priemeru za {let} rokov",
    jakMantinely: "štart {pct}, potom úprava podľa pravidiel",
    vyhodaPevne: "Kapitál teoreticky nikdy nedôjde — berie sa vždy len časť.",
    vyhodaKlouzavy: "Renta je pokojnejšia, jeden zlý rok ju nestrhne celú.",
    vyhodaMantinely: "Najvyššia renta na začiatku.",
    presetPoucene: "Poučené Nobelom",
    presetOpatrne: "Opatrné",
    presetDynamicke: "Dynamické",
    cenaPevne: "Renta kolíše s trhom naplno a hneď.",
    cenaKlouzavy: "Po prepade vypláca viac, než zodpovedá hodnote portfólia.",
    cenaMantinely: "Škrty, keď trh nevyjde. Nie je to lepšie pravidlo — je to iné riziko.",
    rok: "Rok",
    mil: "mil.",
    tis: "tis.",
    zpet: "Späť na Nástroje",
    kicker: "Čerpanie renty",
    title: "Tri spôsoby čerpania vedľa seba",
    subtitle: "Rovnaký kapitál, tri pravidlá výberu. Koľko klient dostane mesačne, čo mu zostane — a čo ho to bude stáť.",
    zPlanu: "Kapitál prevzatý z plánu klienta",
    pouceneTitul: "Portfólio poučené Nobelovou nadáciou",
    pouceneText: "Nobelova nadácia cieli na 3 % reálneho výnosu ročne a popri akciách, dlhopisoch a hotovosti drží zhruba pätinu v alternatívach a desatinu v nehnuteľnostiach a infraštruktúre. Tie tu nemodelujeme. Alokácia nižšie je naše zjednodušenie pre klienta, ktorý ich nemá — nie je to portfólio Nobelovej nadácie.",
    jenModelace: "Je to modelácia, nie investičné odporúčanie.",
    vstupyTitul: "Z čoho sa čerpá",
    vstupyPopis: "Všetky sumy sú reálne, v dnešných cenách — výnosy sú už nad infláciou a renta sa nevalorizuje.",
    kapital: "Kapitál na čerpanie",
    roky: "Ako dlho čerpať",
    letPocet: "{n} rokov",
    alokace: "Alokácia portfólia",
    vynosPortfolia: "Reálny výnos portfólia",
    paNadInflaci: "p.a. nad infláciou",
    akcie: "Akcie",
    dluhopisy: "Dlhopisy",
    penezniTrh: "Peňažný trh",
    scenar: "Scenár výnosov",
    scenarModel: "Modelový výnos",
    scenarHistorie: "Skutočná história",
    scenarPoradi: "Tie isté roky odzadu",
    scenarModelHint: "Každý rok rovnako: {pct}. Ukazuje princíp, nie realitu — trh takto nikdy nejde.",
    scenarHistorieHint: "Roky {od}–{do} tak, ako naozaj prebehli. Reálne, po inflácii. Nie je to predpoveď, len odpoveď na otázku „čo keby sa to zopakovalo“.",
    scenarPoradiHint: "Rovnaká množina výnosov, rovnaký priemer — len obrátené poradie. Ukazuje riziko poradia výnosov.",
    startRok: "Štart v roku",
    historieKratsi: "Od roku {rok} má história len {let} rokov. Počíta sa kratší beh — nič sa nedopočítava modelom.",
    cpiNespolehliva: "Dáta o inflácii sú v rokoch 1927–1946 ploché. Reálne výnosy z takto starého štartu preto nie sú spoľahlivé.",
    pokrocile: "Pokročilé nastavenie",
    sazbaCerpani: "Sadzba čerpania",
    startMantinelu: "Štart mantinelov",
    oknoLet: "Okno kĺzavého priemeru",
    naStartuMes: "Na štarte mesačne",
    rozpetiRenty: "Rozpätie renty",
    zbudePo: "Zostane po {let} rokoch",
    celkemVyplaceno: "Celkovo vyplatené",
    nejhlubsiPropad: "Najhlbší prepad renty",
    vRoce: "{rok}. rok",
    bezPropadu: "renta neklesla",
    kapitalDosel: "Kapitál došiel v {rok}. roku",
    pocetSkrtu: "{n}× škrt",
    pocetZvyseni: "{n}× zvýšenie",
    nadvyplata: "Za celý horizont je to {castka} navyše oproti pevnému percentu.",
    cenaTitul: "Čo stojí vyššia renta na začiatku",
    cenaPopis: "Mantinely nie sú „lepšie 4% pravidlo“. Vymieňate menšie riziko, že peniaze dôjdu, za stredné riziko veľkých škrtov na mnoho rokov.",
    cenaPridano: "Na štarte navyše",
    cenaOprotiPevnemu: "oproti pevnému percentu",
    cenaSkrtStitek: "Cena, ktorú to má",
    cenaSkrtVeta: "V {rok}. roku by sa renta musela znížiť o {pct}",
    cenaSkrtZNa: "z {z} na {na} mesačne",
    cenaSkrtuCelkem: "za celý horizont {n} škrtov",
    cenaDno: "Najhlbšie: {pct} pod najvyššou rentou ({rok}. rok) — {castka} mesačne",
    cenaBezSkrtuStitek: "V tomto scenári sa neškrtá",
    cenaBezSkrtu: "To ale neznamená, že by sa nemuselo škrtať nikdy. Pozrite sa na doložené roky nižšie — v nich sa škrtať muselo.",
    cenaVycerpano: "V tomto scenári by kapitál došiel v {rok}. roku.",
    dolozenoTitul: "Doložené na skutočných rokoch",
    dolozenoKdo: "Kto začal čerpať v roku {rok}",
    dolozenoKratsi: "toľko dát história má",
    dolozenoDno: "dno renty −{pct}",
    dolozenoSkrty: "{n} škrtov, prvý v {rok}. roku, dno −{pct}",
    dolozenoBezSkrtu: "bez škrtov",
    dolozeno1966: "V sedemdesiatych rokoch nestrácali len akcie — inflácia zjedla aj dlhopisy a peňažný trh. Diverzifikácia vtedy nepomohla.",
    dolozeno2000: "Rok 2000 bol problém akcií. Dlhopisy a peňažný trh vtedy zarábali, takže portfólio s ich podielom držalo lepšie.",
    dolozenoObecne: "Historický rad z tohto štartu, reálne po inflácii.",
    grafRenta: "Mesačná renta v čase",
    grafRentaPopis: "Toto klient naozaj dostane na účet. V dnešných cenách.",
    grafKapital: "Kapitál v čase",
    grafKapitalPopis: "Čo zostáva na účte. Nula znamená, že peniaze došli.",
    poradiTitul: "Riziko poradia výnosov",
    poradiPopis: "Rovnaké roky, rovnaký priemerný výnos — len v inom poradí. Prepad na začiatku čerpania je zabijak, pretože sa predáva dole.",
    poradiVpred: "Ako roky {od}–{do} naozaj prebehli",
    poradiVzad: "Tie isté roky odzadu",
    poradiVyplaceno: "Klient dostal celkovo",
    poradiKapital: "Na konci zostalo",
    poradiDno: "Dno renty",
    poradiSkrtu: "Škrtov pri mantineloch",
    poradiZaverShoda: "Na konci zostane úplne rovnaký kapitál, ale do ruky klient dostal {pomer}× iné peniaze. Celé to riziko sedí v príjme, nie na výpise z účtu.",
    poradiZaverObecne: "Poradie rokov zmenilo výplatu {pomer}×.",
    prehledTitul: "Všetky historické štarty",
    prehledPopis: "{n} behov dlhých {let} rokov, roky {od}–{do}. Reálne, po inflácii.",
    prehledSelhani: "Skončilo bez peňazí",
    prehledSelhaniPocet: "{n} z {celkem}",
    prehledZadne: "žiadny",
    prehledMedianDno: "Obvyklý prepad renty",
    prehledNejhorsiDno: "Najhlbší prepad",
    prehledNejhorsiStart: "Najhorší štart",
    prehledDoslo: "{rok} — došlo v {kdy}. roku",
    prehledPozor: "Nula zlyhaní nie je dôkaz bezpečnosti. Pri pevnom percente sa berie vždy len časť toho, čo zostalo — účet nedôjde, ani keby renta spadla takmer na nulu. Preto popri počte zlyhaní čítajte prepad renty.",
    pravniTitul: "Čo táto stránka je a čo nie je",
    pravni1: "Modelácia, nie investičné odporúčanie. Neposudzuje situáciu, znalosti ani ciele konkrétneho klienta.",
    pravni2: "Historické dáta nie sú prísľubom budúceho výnosu. Trhy môžu klesnúť a klesať budú.",
    pravni3: "Portfólio poučené Nobelovou nadáciou — nie portfólio Nobelovej nadácie. Nobel drží aj alternatívy (~20 %) a nehnuteľnosti (~9 %), ktoré tu nie sú, a cieli na 3 % reálne.",
    pravni4: "Všetky sumy sú reálne, v dnešných cenách. Výnosy sú už nad infláciou, renta sa nevalorizuje.",
    pravni5: "Historický rad sú americké dáta (akcie, štátne dlhopisy, pokladničné poukážky) prepočítané na reálne výnosy americkou infláciou. České portfólio sa správa inak.",
  },
  manazerUi: {
    obnovit: 'Obnoviť',
    pozvankyDole: 'Vytvorené pozvánky nájdeš dole medzi kartami poradcov — aj s odkazom a hotovým textom správy.',
    pridatPoradce: 'Pridať poradcu do tímu',
    pridatPoradceHint: 'Zadaj email poradcu. Vytvorí sa pozvánka, ktorú musí sám prijať v Nastavení — až potom uvidíš jeho klientov, pipeline, diár a ciele. E-mail zatiaľ neposielame, povedz mu to.',
    vytvoritPozvanku: 'Vytvoriť pozvánku',
    zadnyTym: 'Zatiaľ žiadny tím',
    zadnyTymHint: 'Pozvi poradcu tlačidlom vyššie. Objaví sa tu, hneď ako pozvánku vo svojom Nastavení prijme — dovtedy jeho dáta nevidíš. Potom uvidíš jeho výkon a budeš mu môcť zadávať úlohy.',
  },
  naborUi: {
    hledatKandidata: 'Hľadať kandidáta…',
    nikdoSeNenasel: 'Nikto sa nenašiel',
    klikniAUvidis: 'Klikni a uvidíš, o koho ide',
    coJeNabor: '📣 Čo je nábor:',
    coJeNaborText: 'lákaš skúsených poradcov z konkurencie.',
    eyebrow: 'Náborová pipeline',
    inProc: 'v procese',
    kpiPipe: 'V nábore',
    krok1: 'pridaj kandidáta',
    krok2: 'vyplň jeho čísla (produkcia, sieť, kmeň) — spočítame skóre 🔥',
    krok3: 'pošleš mu neodmietnuteľnú ponuku na jeho čísla',
    krok4: 'ťaháš kartu pipelinou až po „aktívny“.',
    prvniKandidat: 'Pridaj prvého kandidáta',
    sub: 'Nábor poradcov z konkurencie · skóre = produkcia × sieť × kmeň · ťahaj kartou medzi fázami',
    title: 'Nábor',
    zadnyKandidat: 'Zatiaľ žiadny kandidát',
    zadnyKandidatHint: 'Začni s jedným menom z konkurencie, koho by si chcel v tíme. Pridáš ho, vyplníš jeho čísla a spočítame, ako veľmi sa mu oplatí ísť k tebe.',
  },
  motivApp: {
    aktivni: 'Aktívna',
    midnight: 'Tmavý — na večernú prácu',
    violet: 'Výrazné, mladistvé, iné',
    lime: 'Technické, kontrastné, ostré',
    cobalt: 'Chladný akcent, teplá plocha',
    indigo: 'Čisté, dátové, fintech',
    legenda: 'Motív aplikácie',
    sage: 'Teplé, organické, istota',
    vybrat: 'Prepnúť motív aplikácie na',
  },
  pojVar: {
    cena: 'Riešim len cenu',
    cenaPopis: 'nevyhnutné výdavky, ciele −60 %',
    narocna: 'Pre náročných',
    narocnaPopis: 'ciele aj výdavky v plnej výške',
    sablonaUpozorneni: 'Šablónové sumy z praxe poradcu — orientačný vzor, nie ponuka ani garancia. Konkrétne limity a ceny overí poradca v poisťovni.',
    stredni: 'Zlatá stredná',
    stredniPopis: 'ciele −30 %, výdavky bez zmeny',
    uskromnit: 'Uskromniť sa',
    uskromnitPopis: 'nevyhnutné výdavky, ciele −50 %',
    variantaBezKratceni: 'variant škrtá CIELE, nie životnú úroveň. Dlhy sa nekrátia nikdy.',
  },
  davkyUi: {
    invalidI: 'Invalidný dôchodok I. stupňa',
    invalidIHint: 'čiastočné obmedzenie práce',
    invalidII: 'Invalidný dôchodok II. stupňa',
    invalidIIHint: 'vážne obmedzenie práce',
    invalidIII: 'Invalidný dôchodok III. stupňa',
    invalidIIIHint: 'úplná invalidita — nemôžete pracovať',
    nemocenska: 'Nemocenské (od 15. dňa)',
    nemocenskaHint: 'krátka choroba / úraz — 60 % redukovaného základu',
    poznamka: 'Orientačný odhad podľa pravidiel platných od 1. 1. 2025. Hodnoty sa každý január menia — poradca overí aktuálne čísla. Nie je garancia ani ponuka.',
    starobni: 'Starobný dôchodok',
    starobniHint: 'odhad, keby ste šli do penzie s dnešným príjmom (bez valorizácie)',
  },
  duchodCil: {
    nazev: 'Do dôchodku — udržať štandard',
  },
  zdrojAnalyza: {
    naposledy: 'Naposledy aktualizované',
    vysvetleni: 'Prepísané z finančnej analýzy. Sumy a názov prepisuje analýza, poznámky a adresu si drží poradca.',
    zaklad: 'z analýzy',
  },
  osaObchodu: {
    bezData: 'bez dátumu',
    bezDataHlavicka: 'Bez dátumu',
    diar: 'diár',
    dnes: 'Dnes',
    faze: 'fáza',
    naplanovano: 'naplánované',
    poznamkaChyba: 'Úpravu sa nepodarilo uložiť',
    poznamkaDlouha: 'Poznámka je príliš dlhá ({delka} z max {max} znakov).',
    poznamkaPrazdna: 'Poznámka nemôže byť prázdna.',
    poznamkaUlozena: 'Poznámka upravená',
    prazdna: 'Zatiaľ žiadna aktivita. Pridaj prvú poznámku nižšie.',
    stav: { deleted: 'zrušené', detached: 'odpojené', done: 'splnené', planned: 'čaká' },
    typ: { call: 'hovor', email: 'e-mail', note: 'poznámka', sms: 'SMS', system: 'systém' },
    ulozit: 'Uložiť',
    upraveno: 'upravené',
    upravenoTitul: 'Upravené',
    upravitPoznamku: 'Upraviť poznámku',
    zaznamu: 'záznamov',
    zeZalozeni: 'zo založenia',
    zobrazitStarsi: 'Zobraziť staršie ({pocet})',
    zrusit: 'Zrušiť',
  },
  /* M13 · rizika samotného dítěte v Návrhu řešení — components/plan/DetskaRizikaBlok.js */
  /* BLOK:detiRizika START — generuje scratchpad/slovnik.py, ručně needitovat */
  detiRizika: {
    deti: 'Deti ({n}×)',
    dite: 'Dieťa',
    hlavicka: 'detská zmluva',
    hlavickaKazde: 'sumy na každé dieťa',
    hospitalizace: 'Hospitalizácia',
    hospitalizacePozn: 'za každú noc v nemocnici — rodič je pri dieťati a nepracuje, ošetrovné kryje len časť',
    kojenec: 'do 1 roka',
    naDite: ' / dieťa',
    nadpis: 'Poistná ochrana dieťaťa ({n}×)',
    odskodne: 'Denné odškodné za čas liečenia úrazu',
    odskodnePozn: 'od prvého dňa liečenia, bez karencie — doliečenie doma stojí rodiča ďalšie dni v práci',
    odskodneStrop: 'Denné dávky sú nad čistým denným príjmom opatrujúceho rodiča ({strop}) — nad upisovacím limitom, overte v poisťovni.',
    pc: 'Poistná suma na zmluve dieťaťa',
    pcPozn: 'súčet oboch položiek vyššie, orezaný stropom poistiteľnosti',
    radekTrvale: 'Trvalé následky a starostlivosť',
    rodic: 'rodič',
    sablona: 'ŠABLÓNA',
    sablonaPozn: 'Sumy sú vzor z praxe poradcu, nie ponuka ani garancia. Konkrétne limity, výluky a cenu overí poradca v poisťovni.',
    sekceTrvale: 'Keď dieťa zostane trvale závislé na starostlivosti',
    sekceVlastni: 'Riziká samotného dieťaťa — samostatné pripoistenia',
    stitekNadStropem: 'nad stropom',
    stitekSablona: 'šablóna',
    strop: 'Celá potreba je {potreba}; poisťovne na detskej zmluve upíšu rádovo do {strop}. Zvyšok {zbytek} patrí do rezervy a investičného plánu, nie do poistky.',
    tnu: 'Trvalé následky úrazu dieťaťa',
    tnuPozn: 'progresívne plnenie po pásmach — v našom modeli najviac 2,8× sumy, v poisťovniach sa líši',
    uvod: 'U dieťaťa sa nepoisťuje jeho príjem — ten zatiaľ žiadny nemá. Poisťuje sa to, čo rodinu reálne stojí peniaze: rodič, ktorý kvôli starostlivosti alebo liečbe vypadne z práce, a náklady liečby.',
    vekFew: '{n} roky',
    vekMany: '{n} rokov',
    vekOne: '{n} rok',
    vypadekRodice: 'Výpadok príjmu opatrujúceho rodiča',
    vypadl: 'vypadol by {kdo}',
    vypadlAuto: 'vypadol by {kdo} — predpoklad, počíta sa rodič s nižším príjmom',
    zaDen: '/deň',
    zaNoc: '/noc',
    zavazne: 'Závažné ochorenia',
    zavazneBezZakladu: 'Opatrujúci rodič nemá v analýze vyplnený príjem — sumu doplní poradca, systém si ju nevymýšľa.',
    zavaznePozn: 'leukémia, nádory, cukrovka I. typu, epilepsia — jednorazová výplata na liečbu a na to, aby rodič mohol zostať s dieťaťom doma',
    zavazneStrop: 'Vypočítaná potreba z príjmu opatrujúceho rodiča je {potreba}; detské zmluvy kryjú rádovo do {strop}. Zvyšok {zbytek} patrí do rezervy.',
  },
  /* BLOK:detiRizika END */

  /* BLOK:zivotkoKalk START — generuje scratchpad/slovnik.py, ručně needitovat */
  zivotkoKalk: {
    celkemMesicne: 'Celkom mesačne',
    cenaNadpis: 'Cena krytia (poistné)',
    cenaPopis: 'Zadaj reálne mesačné poistné z vybranej poisťovne — spočíta sa celková cena ochrany.',
    cil: 'Cieľ',
    cilBydleni: 'Doplatiť bývanie',
    cilDuchod: 'Dôchodok',
    cilVzdelani: 'Vzdelanie detí',
    cileMale: 'ciele',
    cilePlanNadpis: 'Ciele — koľko mesačne investovať',
    cilePlanPopis: 'Pri výnose {vynos} % ročne. Renta sa prepočíta na kapitál koeficientom ×{nasobek} — to je {pct} % bezpečného čerpania ročne (1 mil. = {koef}).',
    cilePripocet: 'Suma sa pripočíta ku krytiu (smrť/invalidita). Fin. nezávislosť = renta → investičný plán nižšie (koľko mesačne investovať).',
    cileRodiny: 'Ciele rodiny',
    cileZadanych: 'Ciele: zadaných',
    cilovaCastka: 'Cieľová suma',
    cistyPrijem: 'Čistý mesačný príjem',
    cistyPrijemMaly: 'čistý príjem',
    davkyNadpis: 'Prehľad štátnych dávok a výpadky príjmu',
    davkyPopis: 'Koľko klient reálne dostane od štátu — a koľko mu každý mesiac chýba. Orientačný odhad z príjmu a veku.',
    davkyPoznamka: 'Orientačný odhad (skutočnosť podľa Sociálnej poisťovne sa môže líšiť). Doplň vek u osoby pre presnejší odhad.',
    davkyPoznamkaKratka: 'Orientačný odhad (skutočnosť podľa Sociálnej poisťovne sa môže líšiť).',
    den: 'deň',
    denNaHlavu: 'deň na hlavu',
    denniDavkyPn: 'Denné dávky (PN)',
    dluhy: 'Dlhy (na doplatenie)',
    dluhyMale: 'dlhy',
    dnesniHodnota: 'dnešná hodnota',
    do1Roku: 'do 1 roka',
    grafNadpis: 'Čo zostane, keď ubudne príjem',
    grafPopis: 'Zelené je vankúš — čo zostane, keď sa zaplatí to, čo sa zaplatiť musí.',
    hned: 'hneď',
    invDuchodPodleZakona: 'podľa zákona',
    invalidita: 'Invalidita',
    invalidniDuchodMaly: 'invalidný dôchodok',
    invalidniDuchodMes: 'Invalidný dôchodok / mes',
    jehoPodil: 'jeho podiel',
    klient: 'Klient',
    likvidniRezerva: 'Likvidná rezerva',
    mesTecka: 'mes.',
    mesZkratka: 'mes',
    mesicneInvestovat: 'Mesačne investovať',
    naXLet: 'na {roky} rokov',
    navrhOchrany: 'Návrh ochrany rodiny',
    nazevCile: 'Názov cieľa',
    nejvetsiDopad: 'Najväčší dopad',
    nemocenska: 'nemocenská',
    nezbytneVydaje: 'Nevyhnutné výdavky / mes',
    odMesice: 'od {n}. mesiaca',
    odPrvnihoDne: 'od 1. dňa',
    odkazTitle: 'Poslať klientovi odkaz na túto modeláciu',
    osoba: 'Osoba',
    osobaN: 'Osoba {n}',
    osobaPlaceholder: 'Osoba {n} — meno',
    osvc: 'SZČO',
    osvcPlne: 'SZČO (bez nemocenskej)',
    osvcVarovani: 'Pri práceneschopnosti nedostane od štátu nič → vyššia potreba PN.',
    paramKoefRenty: 'Koeficient renty',
    paramKoefRentyHint: '= {pct} % bezpečného čerpania ročne · renta → kapitál ×{nasobek} (nižšia suma = vyšší násobok)',
    paramNarust: 'Nárast výdavkov pri invalidite',
    paramNarustHint: 'starostlivosť, úpravy bytu, lieky',
    paramPokles: 'Pokles výdavkov pri úmrtí',
    paramPoklesHint: 'rodina po strate člena minie menej',
    paramTnPrah: 'TN prah (od koľkých % plní)',
    paramTnPrahHint: 'pod prahom sa neplní; plné krytie cca pri 60 %',
    paramVynos: 'Výnos investície (p. a.)',
    paramVynosHint: 'pre výpočet mesačnej investície na ciele',
    parametryMetodiky: 'Parametre metodiky',
    patickaDavky: 'Sociálne dávky (vdovský {vdovsky}{sirotci}, invalidný dôchodok) sú ORIENTAČNÝ ODHAD z príjmu — nie prísľub štátu. Skutočnú výšku overí poradca.',
    patickaMetodika: 'Orientačné odporúčané krytie podľa metodiky beplan (metodika {verze}): invalidita/smrť kapitálovou metódou @ 4 % reálne — výdavky domácnosti po udalosti mínus príjmy, ktoré rodine zostanú, mínus štátne dávky. PN = čistý príjem − nemocenská. Konkrétne poistné a podmienky podľa vybranej poisťovne. Poradca má posledné slovo.',
    patickaSirotci: ', sirotský spolu {castka}',
    pdfInvaliditaPopis: 'keď už nemôžete pracovať',
    pdfJakRozumet: '<b>Ako tomu rozumieť:</b> Čísla hovoria, koľko by rodina dostala, keby sa stalo to najhoršie — aby mohla ďalej bývať, žiť vo svojom štandarde a deti dokončili školu. <b>Invalidita</b> má vyššiu sumu než smrť, pretože chorý človek doma potrebuje navyše starostlivosť a úpravy. <b>Práceneschopnosť</b> dorovnáva výpadok príjmu pri krátkej chorobe alebo úraze.',
    pdfPaticka: 'Nezáväzný orientačný návrh. Konkrétne podmienky a ceny upresníme spoločne.',
    pdfPnPopis: 'krátka choroba alebo úraz',
    pdfSmrtPopis: 'aby sa rodina o nič nemusela báť',
    pdfTitle: 'Stiahnuť / vytlačiť PDF pre klienta',
    pdfTnuPopis: 'vážnejší úraz = vyššia výplata',
    pdfZavaznePopis: 'rakovina, infarkt, mŕtvica…',
    perex: 'Zadaj príjmy a výdavky rodiny → spočítam odporúčané krytie: invalidita, smrť, práceneschopnosť, trvalé následky a závažné ochorenia.',
    pnCelkem: 'Rodina potrebuje PN celkovo',
    pnUraz: 'Práceneschopnosť / úraz',
    pocetDeti: 'Počet detí',
    podPrahem: '→ pod prahom',
    podilDluhu: 'podiel dlhov',
    podilNezbytnych: 'podiel nevyhnutných',
    pojistnaCastka: 'Poistná suma:',
    poskozeni: 'poškodenie',
    poslatKlientovi: 'Poslať klientovi',
    potrebnyKapital: 'Potrebný kapitál',
    pozustalostniDavky: 'pozostalostné dávky',
    pracNeschopnost: 'Práceneschopnosť',
    pracovniNeschopnost: 'Práceneschopnosť',
    prezentovat: 'Prezentovať',
    pridatCil: 'Pridať cieľ',
    pridatOsobu: 'Pridať osobu',
    prijemMaly: 'príjem',
    prijmyOstatnich: 'príjmy ostatných',
    procInvalidita: 'Príjem zmizne navždy a výdavky NARASTÚ (opatrovateľ, úpravy). Často zničí rodinu rýchlejšie než smrť — preto je č. 1.',
    procNadpis: 'Prečo je táto ochrana dôležitá',
    procPn: 'Choroba či úraz na pár mesiacov: štát dá málo (SZČO nič). Denná dávka dorovná výpadok — doma riešite uzdravenie, nie účty.',
    procSmrt: 'Aby po živiteľovi zostala rodine istota, nie dlhy a hypotéka. Deti dokončia školu, partner nemusí meniť život.',
    procTnu: 'Vážny úraz = trvalé obmedzenie. Progresívne plnenie: čím vážnejšie, tým vyššia jednorazová výplata na úpravy a život.',
    progresivni: 'progresívne',
    renta: 'renta',
    rentaMes: 'Renta / mes',
    rezervaHint: 'vydrží ~{mes} mes.',
    rezervaPokryje: 'rezerva pokryje prvých {mes} mes., dávka navrhnutá od {odMes}. mesiaca',
    rodina: 'Rodina',
    sloupecChybi: 'Chýba /mes',
    sloupecChybiMes: 'Chýba / mes',
    sloupecDokryt: 'Dokryť poistkou',
    sloupecDostane: 'Dostane od štátu',
    sloupecSituace: 'Situácia',
    sloupecStat: 'Štát /mes',
    sloupecStupen: 'Stupeň',
    smrt: 'Smrť',
    stupneNadpis: 'Invalidita podľa stupňa',
    stupneNota: 'Stĺpec dokryť poistkou = kapitál, aby výpadok pokryl na {roky} rokov.',
    stupnePopis: 'Vyšší stupeň = vyššia dávka od štátu, ale aj vyššia strata príjmu → viac dokryť poistkou. III. = úplná invalidita (nemôže pracovať), I. = čiastočné obmedzenie.',
    tela: 'tela',
    titul: 'Kalkulačka životného poistenia',
    tnuNadpis: 'Trvalé následky — progresívne plnenie',
    tnuPrah: 'Plní sa od {prah} % poškodenia, plné potrebné krytie cca pri 60 %.',
    tnuVzorec: 'Výplata = suma × násobok × %.',
    tnuZeCastky: 'Z poistnej sumy',
    toJePctPrijmu: 'to je {pct} % čistého príjmu rodiny',
    trvaleNasledky: 'Trvalé následky',
    trvaleNasledkyUrazu: 'Trvalé následky úrazu',
    typCastka: 'Suma',
    typRenta: 'Fin. nezávislosť',
    uvodniZprava: 'Dobrý deň, posielam návrh ochrany vašej rodiny — koľko by rodina potrebovala, keby sa niečo stalo. Pozrite a kľudne sa ozvite.',
    variantaKryti: 'Variant krytia (smrť + invalidita)',
    variantaKrytiKratce: 'Variant krytia',
    variantaSlovo: 'variant',
    vek: 'Vek (rokov)',
    vekHint: 'pre orientačný prehľad',
    vekPrijem: '{vek} rokov · príjem {castka}',
    vydajeRodiny: 'výdavky rodiny',
    vyssiVydaje: 'o {pct} % vyššie výdavky (starostlivosť, úpravy)',
    waTitle: 'Poslať návrh klientovi cez WhatsApp',
    xLet: '{n} rokov',
    xOsob: '{n} osôb',
    xRocniPrijem: '{n}× ročný príjem',
    zaKolikLet: 'Za koľko rokov',
    zadejPrijem: 'Zadaj aspoň jeden príjem.',
    zajistitNa: 'Zabezpečiť na (rokov)',
    zamestnanec: 'Zamestnanec',
    zavazneOnemocneni: 'Závažné ochorenia',
  },
  /* BLOK:zivotkoKalk END */
  rozvahaGraf: {
    bezOceneni: 'Bez ocenenia zostáva {pocet} {polozka} — do súčtu sa nepočítajú.',
    cisteJmeni: 'Čisté imanie',
    cisteJmeniPod: 'čo vlastní mínus čo dlží',
    coDluzi: 'Čo dlží',
    coVlastni: 'Čo vlastní',
    financni: 'Finančný majetok',
    nefinancni: 'Nehnuteľnosti a veci',
    podilDluhu: 'Dlh tvorí {pct} % majetku — zvyšok je naozaj jeho.',
    vecnyMajetek: 'Z toho vecný majetok',
    zavazky: 'Záväzky',
  },
  menaAnalyzy: {
    bezRazitka: 'Táto analýza je z čias, keď sa mena do dát neukladala — čítame ju ako {mena}. Účet dnes pracuje v {ucet}.',
    neprepocitava: 'Sumy sa NEPREPOČÍTAVAJÚ — ostávajú tak, ako boli zadané, aplikácia nepozná kurz. Popisky nižšie ukazujú {symbol}. Než čísla ukážete klientovi, overte ich.',
    pozor: 'Pozor na menu.',
    ulozena: 'Analýza je uložená v {mena}, účet dnes pracuje v {ucet}.',
  },
  zivotkoGraf: {
    celyPrijem: '— celý príjem',
    cenaDenne: '{castka} na deň na každého z {hlav} členov rodiny.',
    cenaInvalidita: 'invalidita',
    cenaPctPrijmu: 'To je {pct} % vášho príjmu.',
    cenaPresahuje: 'Presahuje ho — a schovávať sa to nebude.',
    cenaSablona: 'Rádový odhad z nášho vzorníka sadzieb — ŠABLÓNA, nie ponuka. Presnú cenu dá poisťovňa podľa veku a zdravotného dotazníka.',
    cenaSmrt: 'smrť',
    cenaStrop: 'Strop {pct} % príjmu = {castka}.',
    cenaVejde: 'Zmestí sa doň.',
    cenaZavira: 'Zatvára to dieru, ktorú ste videli:',
    davkaInvalidIII: 'Invalidný dôchodok',
    davkaNemocenska: 'Nemocenské',
    davkaObecna: 'Dávka',
    davkaPozustalostni: 'Vdovský + sirotský',
    mesZkr: 'mes.',
    mesZkratka: 'mes',
    nazevDnes: 'Dnes',
    nazevInvalidita3: 'Invalidita III. stupňa',
    nazevMzda5: 'Šéf uberie 5 %',
    nazevPn: 'Dlhá choroba',
    nazevSmrt: 'Smrť živiteľa',
    popisChybi: 'Chýba každý mesiac.',
    popisDnes: 'Toľko vám zostáva, keď je všetko v poriadku.',
    popisDnesNapjato: 'Rozpočet je napnutý už dnes — vankúš žiadny nie je.',
    popisNastve: 'Nahnevá vás to. Ale vyriešite to sami.',
    popisRezervaMesice: 'Rezerva to utiahne {mes} mesiaca.',
    popisRezervaZadna: 'Rezerva na to nie je žiadna.',
    popisZvladnete: 'Zvládnete to. Skončí sporenie a dovolenka.',
    proporceNecerpa: 'Rezerva sa nečerpá — príjem a dávky výdavky pokryjú.',
    proporceRezerva: 'Vaša rezerva',
    proporceSchodek: 'Pri schodku {castka} mesačne pokryje rezerva {pct} % tej doby.',
    proporceStat: 'Štát pri chorobe — podporná doba',
    proporceStrop: 'Nemocenské má strop {dni} dní.',
    proporceTrvani: 'Do dôchodku zostáva',
    proporceVek: '{vek} rokov, do dôchodku ({duchodVek}) zostáva {roky} rokov.',
    vynechanoCena: 'Krok s cenou je vynechaný: cena krytia nie je zadaná ani ju nejde odhadnúť.',
    vynechanoHlavy: 'Denný rozklad ceny sa neukáže: nie je z čoho spočítať počet osôb v rodine.',
    vynechanoMena: 'Graf sa nezobrazí: štátne dávky vie appka zatiaľ len pre ČR. České dávky vydelené kurzom nie sú slovenské dávky.',
    vynechanoPoDuchodu: 'Krok „ako dlho to trvá“ je vynechaný: hlavná osoba je v dôchodkovom veku.',
    vynechanoPrijem: 'Graf sa nezobrazí: nie je zadaný ani jeden príjem. Bez príjmu by všetky schody boli nula.',
    vynechanoVek: 'Krok „ako dlho to trvá“ je vynechaný: u hlavnej osoby chýba vek.',
    vynechanoVydaje: 'Graf sa nezobrazí: nie sú zadané nevyhnutné výdavky. Bez nich nie je proti čomu príjem merať.',
  },
  navrhVystupy: {
    jednaStrana: '1 strana',
    jednaStranaTitul: 'Plán na jednu stranu',
    plnyPlan: 'Plný plán',
    plnyPlanTitul: 'Plný finančný plán',
    poznamka: 'Poznámka k návrhu',
  },
  slozkaKlienta: {
    adresyKontakty: 'Adresy a kontakty',
    aktivita: 'Aktivita',
    analyza: 'Analýza',
    kraj: 'Kraj',
    mobil: 'mobil',
    nabor: 'NÁBOR',
    odhadPotencialu: 'Odhad potenciálu klienta',
    prijmeniPriklad: 'Novák',
    sidloKlienta: 'Sídlo klienta',
    stitky: 'Štítky',
    vlastnik: 'Vlastník',
    vztahKlient: 'Klient',
    vztahPartner: 'Partner',
    zalozkyKlienta: 'Záložky klienta',
    zdrojKontaktu: 'Zdroj kontaktu',
    zdrojLeadovac: 'Leadovač',
    zdrojReklama: 'Reklama',
  },
  duchodKarta: {
    aktualizovatCil: 'Aktualizovať cieľ',
    bezVeku: 'doplň vek, inak sa horizont sporenia nedá spočítať (a hádať ho nebudeme).',
    chceMitMesicne: 'Chce mať mesačne',
    chybi: 'Chýba',
    cilovyStandard: 'Cieľový štandard v dôchodku',
    daStat: 'Dá štát',
    disclaimer: 'Štátny dôchodok je ORIENTAČNÝ ODHAD z príjmu a veku, bez valorizácie — nie prísľub štátu. Cieľový štandard je voľba poradcu, nie meranie. Sumy sú v dnešných peniazoch.',
    doDuchodu: '· do dôchodku {roky} rokov',
    duchodovyVek: 'Dôchodkový vek',
    kapitalRadek: 'kapitál {castka} · {roky} rokov · {vynos} % p. a.',
    mesicneOdkladat: 'Mesačne odkladať',
    nadpis: 'Do dôchodku — udržať životný štandard',
    nahradiPct: 'nahradí {pct} % čistého príjmu',
    odPoradce: 'od poradcu',
    osoba: 'Osoba',
    poDuchodovemVeku: 'Vek je už za dôchodkovým — na sporenie nezostáva čas, suma je potrebná hneď.',
    popis: 'Koľko z príjmu nahradí štát a koľko si treba doplniť sám. Tlačidlom sa z toho stane cieľ typu Fin. nezávislosť.',
    prepsatDuchod: 'Prepísať štátny dôchodok',
    pridatJakoCil: 'Pridať ako cieľ',
    radekVek: '{vek} rokov · {castka}/mes',
    sablona: 'Šablóna',
    standardHint: '% dnešného čistého príjmu. Menej než 100 %, lebo v dôchodku odpadá to, čo klient platí PRETO, že pracuje a sporí si na penziu.',
    statNeodhadujeme: 'Štátny dôchodok tu neodhadujeme',
    statNeodhadujemeHint: 'odhad platí len pre ČR. Zadaj sumu a dopočítam zvyšok.',
    statPokryjeCely: 'štát pokryje celý cieľ',
    statPokryvaPct: 'štát pokryje {pct} % cieľa',
    vekHint: 'odhad, prepíš',
  },
  /* Srovnávač fondů (/srovnavac-fondu). Doplněno 23. 8. 2026 — klíče se
     volaly, ale nebyly v žádném slovníku, takže vietnamský i ukrajinský
     poradce viděl český fallback. */
  fondy: {
    export: {
      chyba: "Graf sa nepodarilo pripraviť.",
      hotovo: "Stiahnuté.",
      pngChyba: "PNG sa nepodarilo vyrobiť. Skús SVG — to sa dá otvoriť v prehliadači.",
      nese: "Obrázok si nesie zdroj, dátum aj upozornenie.",
      csvSrovnani: "Stiahnuť CSV s porovnaním",
      csvRady: "Stiahnuť CSV s radmi",
    },
    tabulka: {
      popisek: "Šesť kritérií vedľa seba. Aplikácia fondy neradí podľa kvality a žiadny z nich neodporúča — výber je na poradcovi.",
    },
    prazdno: {
      nadpis: "V katalógu zatiaľ nie sú žiadne dáta o fondoch",
      veta: "Porovnávač je pripravený — čaká len na dodané dáta. Historické hodnoty sa sem neopisujú z grafov, nahrávajú sa importom troch CSV súborov podľa návodu v docs/penze/JAK-DODAT-DATA.md. Prázdna obrazovka je poctivejšia než vymyslené čísla.",
      demo: "Ukázať na demo dátach",
    },
    srovnavac: {
      nadpis: "Historický porovnávač fondov",
      kotva: "Obdobie sa počíta späť od posledného dňa dodaných dát, nie od dneška — inak by v päťročnom okne boli len štyri roky.",
    },
    filtr: {
      obdobi: "Obdobie",
      zobrazeni: "Zobraziť",
      jednotlive: "Jednotlivé fondy",
      prumeryNapoveda: "Priemer sa počíta len z fondov, ktoré pokrývajú celé obdobie.",
      prumery: "Priemery stratégií",
      strategie: "Stratégia",
      skupiny: "Investičné skupiny",
      spolecnost: "Dôchodková spoločnosť",
      historie: "Kratšia história",
      jenPlna: "Vylúčiť fondy bez celej histórie",
      zrusit: "Zrušiť filtre",
      prazdno: {
        nadpis: "Filtru nevyhovuje žiadny fond",
        veta: "Skús odobrať niektoré z obmedzení — alebo sa v katalógu taký fond zatiaľ nenachádza.",
      },
    },
    vyloucene: "Z porovnania si vylúčil:",
    varianty: {
      metrika: "POROVNAŤ PODĽA",
    },
    vyber: {
      nadpis: "Ako vybrať fond",
      veta: "Najvyšší historický výnos nie je kritérium. Vedľa seba patrí horizont klienta, kolísanie, akú dlhú históriu fond vôbec má, jeho veľkosť, zákonná rizikovosť SRI a náklady. Aplikácia ukazuje čísla; posúdiť, čo z toho sedí na konkrétneho klienta, vie iba poradca.",
    },
    prumery: {
      nadpis: "Z čoho sú priemery vypočítané",
    },
    demo: {
      odznak: "DEMO DÁTA",
      veta: "Ukážkové vymyslené čísla. Nepoužívať s klientom.",
      vysvetleni: "Tieto rady nikto nezverejnil — sú vymyslené, aby sa dali vyvíjať obrazovky. Rastú každý rok o rovnaké percento, čo sa v realite nestáva. Skutočné dáta sa dodávajú importom, návod je v docs/penze/JAK-DODAT-DATA.md.",
    },
  },

  penzeUi: {
    zaklad: { nominalne: "Nominálne", dnesniCeny: "V dnešných cenách", nominalneKratce: "nominálne", dnesniCenyKratce: "v dnešných cenách" },
    rada: { vlastni: "Vlastné vklady", zamestnavatel: "Zamestnávateľ", stat: "Štátny príspevok", zhodnoceni: "Zhodnotenie" },
    most: { vklad: "Vlastný vklad", zamestnavatel: "Zamestnávateľ", strategie: "Stratégia" },
    strategie: { konzervativni: "Konzervatívna", vyvazena: "Vyvážená", dynamicka: "Dynamická", stare: "Staré penzijko" },
    cesta: { dnes: "Dnešný stav", kombinace: "Kombinácia DPS + DIP", zamestnavatel: "So zamestnávateľom" },
  },
  /* Poistenie osôb (Návrh riešenia + prezentácia plánu). */
  /* BLOK:pojisteniOsob START — generuje scratchpad/slovnik.py, ručně needitovat */
  pojisteniOsob: {
    bezPrijmu: 'Bez závislého príjmu — výpadok kryje prebytok domácnosti.',
    cena: '≈ Orientačné poistné',
    cenaCelkem: '≈ Orientačné poistné osôb celkom',
    denni: '/deň',
    diteRozporText: 'V analýze je riadok dieťaťa, kde chýba meno aj dátum narodenia. Sirotský dôchodok za dieťa, ktoré v analýze nie je, by poistné sumy znížil — preto sa taký riadok nezapočítal. Doplňte dieťa do analýzy, alebo prázdny riadok zmažte.',
    diteRozporTitul: 'Dieťa bez mena sa nepočíta',
    doplnitNarozeni: 'Doplniť dátum narodenia',
    invalidita: 'Invalidita (2.–3. st.)',
    klient1: 'Klient 1',
    klient2: 'Klient 2',
    mesicni: '/mes',
    metodika: 'Kapitálová metóda @ 4 % reálne: výdavky domácnosti po udalosti − príjmy, ktoré rodine zostanú − štátne dávky, na {roky} rokov + dlhy ({dluhy}) + ciele − likvidný majetok. Variant {varianta} počíta ciele ×{kCile} a {vydaje}; dlhy sa nekrátia nikdy. Sumy sú návrh — poradca má posledné slovo.',
    odskodne: 'Denné odškodné úrazom',
    osvc: 'SZČO',
    partnerNespocteno: '{jmeno}: zabezpečenie nespočítané — chýba dátum narodenia',
    partnerNespoctenoText: 'Plán partnera nepoisťuje ani nepočíta cenu jeho poistenia.',
    pn: 'Pracovná neschopnosť',
    pnPozn: 'od {mesic}. mesiaca — dovtedy drží rezerva',
    pnPoznNic: 'rezerva + nemocenská výpadok pokryjú',
    pnPoznOsvc: 'od {mesic}. mesiaca — dovtedy drží rezerva',
    popisInvalidita: 'Invalidita = dlhodobý výpadok príjmu, ktorý rezerva nepokryje — a výdavky navyše rastú (starostlivosť, úpravy bývania). Finančne väčšie riziko než smrť.',
    popisOdskodne: 'Úraz zastaví príjem od prvého dňa — bez karencie. Denná dávka dorovnáva výpadok príjmu počas liečenia.',
    popisPn: 'Krátkodobý výpadok príjmu nad rámec rezervy: nemocenská kryje len časť čistého príjmu, dávka dorovnáva rozpočet. Prvých pár mesiacov drží rezerva → dlhšia karencia = nižšie poistné.',
    popisSmrt: 'Nahrádza príjem rodine: pokryje bežné výdavky, splátky aj rozbehnuté ciele, aby rodina nemusela meniť život zo dňa na deň. Len do finančnej nezávislosti, klesajúca suma = lacnejšie.',
    popisTnu: 'Trvalé poškodenie po úraze = trvalo vyššie výdavky. Progresívne plnenie po pásmach: čím vážnejšie následky, tým vyššia výplata (v našom modeli najviac 2,8× sumy — v poisťovniach sa líši).',
    popisZavazne: 'Rakovina, infarkt, mozgová príhoda: liečba trvá mesiace, príjem klesne a výdavky narastú. Jednorazová výplata dovolí prestať pracovať a liečiť sa bez toho, aby rodina rozpustila rezervu alebo investície.',
    prijem: 'príjem',
    rozporText: 'Pri druhej osobe je vyplnený príjem {castka}, ale chýba meno aj dátum narodenia. Krytie pre človeka, ktorý v analýze nie je, by pred klientom neobstálo. Doplňte partnera do analýzy, alebo príjem opravte.',
    rozporTitul: 'Druhá osoba sa nepočíta — v analýze nie je',
    smrt: 'Smrť',
    titul: 'Poistenie osôb — dimenzované na splnenie všetkých cieľov',
    tnu: 'Trvalé následky úrazu',
    tnuPozn: 'progresívne plnenie po pásmach — v našom modeli najviac 2,8× sumy, v poisťovniach sa líši',
    tnuPrilepek: ' s progresiou',
    zavazne: 'Závažné choroby',
    zavaznePozn: '{nasobek}× ročný príjem',
    zavaznePoznVyplata: 'Jednorazová výplata na liečbu a na obdobie, keď klient nemôže pracovať.',
  },
  /* BLOK:pojisteniOsob END */
  /* RUČNÉ HODNOTY PORADCU — prepis poistných súm a cien v Návrhu riešenia. */
  rucniPojisteni: {
    chip: "ručne",
    upravit: "Upraviť ručne",
    hotovo: "Hotovo",
    vratit: "Vrátiť na vypočítané",
    system: "Systém počíta {castka}",
    titul: "Ceny a sumy prepíšete podľa skutočnej ponuky",
    vysvetleni: "Kliknite na ceruzku pri ktorejkoľvek sume alebo cene a zadajte, čo má klient reálne dojednané. Ručná hodnota je označená a vypočítaná zostáva vedľa nej, takže rozdiel sa dá kedykoľvek ukázať aj vrátiť späť.",
    pocet: "{n}× ručne",
    vratitVse: "Vrátiť všetko na vypočítané",
    cenaOsoby: "Orientačné poistné",
    nezadanaVarianta: "Pre túto variantu cena zadaná nie je",
    perVarianta: "Limity aj ceny sa ukladajú KU KAŽDEJ VARIANTE ZVLÁŠŤ (teraz {varianta}). Namodelujte varianty v poisťovni a ku každej zadajte jej limity a cenu — u klienta potom prepínate a ukazujete limit aj cenu vedľa seba.",
    odhadSablona: "odhad zo šablóny sadzieb, nie ponuka poisťovne",
    ukladam: "Ukladám ručné hodnoty…",
    ulozeno: "Ručné hodnoty uložené",
    chyba: "Ručné hodnoty sa nepodarilo uložiť — skúste tlačidlo Uložiť návrh",
  },
  /* BLOK:srovnaniPojisteni START — generuje scratchpad/slovnik.py, ručně needitovat */
  srovnaniPojisteni: {
    aspon: 'min.',
    celkem: 'Celkom',
    chybi: {
      cena: '{kdo}: pre variant {varianta} nie je zadaná cena. Namodelujte ju v poisťovni a zapíšte ceruzkou v karte Poistenie osôb — cena sa ukladá ku každému variantu zvlášť.',
      cenaBezVarianty: '{kdo}: pre zvolený variant nie je zadaná cena. Namodelujte ju v poisťovni a zapíšte ceruzkou v karte Poistenie osôb — cena sa ukladá ku každému variantu zvlášť.',
      cenaCastecna: 'Cena je zadaná len pri časti osôb, takže celok je dopočítaný odhadom. Doplňte ju ceruzkou aj pri ostatných osobách v karte Poistenie osôb.',
      cenaDetske: 'V návrhu je aj detská zmluva a jej poistné vie appka len odhadnúť — súčet cien dospelých preto nie je cena celého návrhu. Zadajte celkovú cenu z ponuky poisťovne.',
      limitRizika: '{kdo}: pri existujúcej zmluve chýba poistná suma — {riziko}. Doplňte ju v analýze pri poistke.',
      platba: '{kdo}: pri existujúcej zmluve chýba mesačná platba — bez nej sa nedá povedať, koľko platí dnes.',
      platbaCastecna: '{kdo}: pri zmluvách {smlouvy} chýba mesačná platba, takže „platí dnes“ je nižšie než skutočnosť.',
      prirazeni: 'Zmluvy {smlouvy} majú riziká zapísané bez osoby, preto sa počítajú živiteľovi. Po osobách sa rozdelia, až v analýze pri zmluve vyberiete, komu riziká patria (Poistné zmluvy → Riziká v zmluvách).',
      smlouvaPartnera: 'Zmluvy {smlouvy} sú priradené partnerovi, ktorý v analýze nie je — do porovnania sa nepočítajú.',
      smlouvaPartneraNespocteno: 'Zmluvy {smlouvy} patria partnerovi, ktorého zabezpečenie plán nespočítal (chýba dátum narodenia) — do porovnania sa nepočítajú a plán ich neruší.',
      smlouvaSpolecnaBezPartnera: 'Zo spoločných zmlúv {smlouvy} sa počíta len časť klienta — partner v analýze nie je.',
      smlouvaSpolecnaNespocteno: 'Zmluvy {smlouvy} môžu kryť aj partnera, ktorého zabezpečenie plán nespočítal (chýba dátum narodenia) — plán ich preto neruší. Doplňte v analýze dátum narodenia partnera.',
      zadneSmlouvy: 'V analýze nie je žiadna poistná zmluva s poistnou sumou.',
    },
    dnesNekryty: 'dnes nekrytý',
    dnesNeplati: 'dnes neplatí',
    domacnost: 'Domácnosť (obe osoby)',
    doplnKde: 'Doplňte ju v analýze: Záväzky a zmluvy → Poistné zmluvy → Riziká v zmluvách → invalidita / smrť pri osobe. Až potom sa dá klientovi ukázať, že nový limit je násobne vyšší a cena nie.',
    doplnTitul: 'Bez poistnej sumy starej zmluvy to nie je porovnanie, ale zdraženie',
    doplnTlacitko: 'Doplniť v analýze',
    hlavicka: {
      budePlatit: 'Bude platiť',
      nasobekCeny: 'Cena',
      nasobekKryti: 'Krytie',
      novy: 'Nový limit',
      platil: 'Platí dnes',
      puvodni: 'Limit dnes',
      riziko: 'Riziko',
    },
    nezadano: 'nezadané',
    novyNula: 'krytie sa nenavrhuje',
    podtitul: 'variant {varianta}',
    poznamka: '„Bude platiť“ je cena z ponuky poisťovne, ktorú ste zadali ručne k tomuto variantu — appka ju nedopĺňa zo šablóny sadzieb. Prázdne pole znamená zatiaľ nezadané, nie nulu.',
    prirazenoZiviteli: 'riziká bez osoby — počítajú sa živiteľovi, upresnite v analýze',
    riziko: {
      invalidita: 'Invalidita',
      smrt: 'Smrť',
    },
    titul: 'Predtým a potom — čo má dnes a čo bude mať',
    vyhra: '{kdo}: krytie rastie {pomer}× rýchlejšie ako cena.',
    zivitel: 'živiteľ rodiny',
  },
  /* BLOK:srovnaniPojisteni END */
  /* POJIŠTĚNÍ MAJETKU A ODPOVĚDNOSTI (karta v Návrhu řešení).
     Násobek u odpovědnosti vůči zaměstnavateli je ZÁKONNÝ STROP a v každé zemi
     jiný (CZ 4,5× / SK 4×) — do vět chodí parametrem `{nasobek}`, NIKDY ho sem
     nepiš natvrdo. Zdroj předpisu drží lib/odpovednostZamestnavateli.js. */
  pojisteniMajetku: {
    titul: "Poistenie majetku a zodpovednosti",
    nemovitost: "Nehnuteľnosť",
    nemovitostPopis: "Na plnú hodnotu z analýzy — poistná suma = cena obstarania nanovo (pozor na podpoistenie).",
    domacnost: "Domácnosť",
    domacnostPopis: "Vybavenie — nábytok, elektronika, cennosti. Odhad podľa vybavenia, uprav podľa klienta.",
    odpovednost: "Zodpovednosť občianska",
    odpovednostPopis: "Škoda spôsobená iným nemá strop (zdravie, vytopenie, zrazený cyklista) — limit čo najvyšší.",
    zamestnavatel: "Zodpovednosť voči zamestnávateľovi",
    zamestnavatelOsoba: "Zodpovednosť voči zamestnávateľovi — {jmeno}",
    zamestnavatelPopis: "Zamestnávateľ od vás môže žiadať náhradu škody až do {nasobek}-násobku priemerného mesačného zárobku — limit sa počíta z hrubej mzdy. Pri škode spôsobenej úmyselne alebo pod vplyvom alkoholu strop neplatí.",
    zamestnavatelPopis2: "Vlastná zmluva pre druhú osobu — limit sa počíta z JEJ hrubej mzdy, nie z príjmu domácnosti. Aj tu platí {nasobek}-násobok priemerného mesačného zárobku.",
    hrubaMzda: "Hrubá mzda",
    limit: "Limit {nasobek}×",
    zdrojLimitu: "Násobok je zákonný strop, nie náš odhad: {predpis}. Overené {datum}. Základom je priemerný mesačný zárobok — s prémiami býva vyšší než hrubá mzda, limit preto ber ako spodnú hranicu.",
    pravni: "Právna ochrana",
    pravniPopis: "Právnik a súdne výdavky pri sporoch — pracovné, susedské, spotrebiteľské.",
    nabidnout: "ponúknuť",
    nenabizet: "neponúkať",
    osvcTitul: "Podnikanie — SZČO a firma",
    osvcPodtitul: "V analýze je príjem z podnikania alebo firma v majetku. Prejdite s klientom, čo naozaj má a čo by ho položilo.",
    podnikatelske: "Podnikateľské poistenie",
    podnikatelskePopis: "Profesijná zodpovednosť, majetok firmy, prerušenie prevádzky. Poistka domácnosti toto nekryje — škoda na zákazke sa z nej neplatí.",
    resit: "riešiť",
    neresit: "neriešiť",
    zasoby: "Zásoby",
    zasobyPopis: "Materiál, tovar a rozpracovaná zákazka na sklade aj v aute. Keď sklad zhorí, bez tejto položky klient nedostane ani cent.",
    moviteVeci: "Hnuteľné veci a vybavenie",
    moviteVeciPopis: "Náradie, stroje, technika, vybavenie prevádzky. Spočítajte, čo by musel klient kúpiť znova, aby mohol zajtra pracovať.",
    odpovednostPodnikatele: "Zodpovednosť podnikateľa",
    odpovednostPodnikatelePopis: "Škoda spôsobená pri podnikaní zákazníkovi alebo tretej osobe. Odporúčané minimum {limit} — jedna vytopená prevádzka alebo úraz zákazníka ide ľahko cez milión.",
    bezLimitu: "neriešiť",
    mil: "mil.",
    odhadTitul: "Orientačné poistné majetku celkom",
    disclaimer: "Orientačný odhad zo šablóny sadzieb — nie je ponuka ani garancia ceny. Konkrétne poistné upresní poradca podľa veku, zdravotného stavu, tarify, spoluúčasti a výluk vybranej poisťovne.",
    mesic: "/mes",
    patka: "Vždy so spoluúčasťou — malé škody kryje rezerva, poistka je lacnejšia. Konkrétne tarify a výluky vyberá poradca.",
  },
  /* Odporúčanie ku každému cieľu — návrh systému z čísel plánu + text poradcu. */
  /* HORIZONT CILE — jedno misto pro "hned" a pro sklonovani let (audit R13).
   * Do 25. 8. 2026 si horizont dopocitavalo osm mist a kazde jinak: rezerva
   * "hned" (roky = 0) byla na karte "za 1 let", v tisku "—" a na slajdu
   * "za 0 let". Sklonovani dela t.plural (Intl.PluralRules podle jazyka),
   * ne ceske pravidlo 1 / 2-4 / 5+ — jinak ukrajinstina cte "za 21 rokiv".
   * Trojice One/Few/Many musi byt ve vsech peti slovnicich. */
  /* SHRNUTI — ROZDELOVNIK PLANU (predloha majitele, obrazovka „Shrnutí“ z FIP).
   * Tri pocitadla nahore, radek na cil. Texty NIKDY netvrdi nulu tam, kde je
   * neznamo: „bez vkladu“ / „doplň termín cíle“ misto „0“ a misto „0 %“.
   * Presplneny cil se rika slovem („splněno · přebývá X“), ne minusem —
   * predloha psala −749 471 a majitel si to sam vytkl. */
  /* BLOK:shrnutiPlan START — generuje scratchpad/slovnik.py, ručně needitovat */
  shrnutiPlan: {
    azPoCilovemDatu: 'až po cieľovom dátume — do cieľovej sumy sa nepočíta',
    bezCiluKde: 'Doplň ich v analýze v sekcii Ciele — bez cieľovej sumy sa cieľ do plánu vôbec nedostane.',
    bezCiluTitul: 'Plán zatiaľ nemá ani jeden cieľ.',
    bezVkladu: 'bez vkladu',
    dnesPosle: 'dnes klient pošle {kc}',
    doplnCastku: 'doplň cieľovú sumu',
    doplnTermin: 'doplň termín cieľa',
    doplnenoEnginem: 'doplnené výpočtom',
    doraziPozdeji: 'z toho {kc} dorazí neskôr',
    doraziVeVeku: 'z toho {kc} dorazí v {vek} rokoch',
    dorovnat: 'dorovnať',
    dorovnatJednJak: 'Pribije mesačnú platbu a jednorazový vklad k nej dopočíta aplikácia, aby cieľ vyšiel celý.',
    dorovnatPravJak: 'Pribije jednorazový vklad a mesačnú platbu k nemu dopočíta aplikácia, aby cieľ vyšiel celý.',
    editaceJak: 'Čísla v stĺpcoch „Jednorazový vklad“ a „Pravidelný vklad“ sa dajú prepísať priamo v riadku — prepísané číslo sa odčíta z hrnca navrchu a to druhé k nemu dopočíta aplikácia. ↺ vráti vypočítaný návrh.',
    financni: 'Finančný majetok',
    kapital: 'kapitál',
    mesicne: '/mes',
    nadKapacitu: 'nad kapacitu domácnosti',
    neboJednorazove: 'alebo {kc} jednorazovo',
    neboPravidelne: 'alebo {kc} mesačne',
    nedosazitelne: 'cieľ sa nedá dorovnať',
    nefinancni: 'Nefinančný majetok',
    nefinancniJak: 'Nehnuteľnosti a firma. Dedičstvo sa do čísla nezapočítava — je zvlášť ako budúci majetok. Do cieľov sa dostanú až ako budúci prítok (predaj) — ten sa zadáva v Návrhu riešenia pri Riešení cieľov.',
    nelzeInvestovat: 'Nie je možné využiť na investíciu.',
    nezapojeno: 'Nezapojené',
    nezapojenoJak: 'Podielové fondy, KŽP, termínovaný vklad a cudzie meny. Plán ich jednorazovo neprerozdeľuje, preto nie sú ani v „Pridelené“, ani v „Zostáva“.',
    nicNeni: 'nič navyše',
    plusKroky: '+ stupňovité navýšenie ({n})',
    pocitam: 'Počítam súhrn…',
    podtitul: 'Tri hrnce navrchu, riadok na cieľ. Rozdávaj zo zdrojov, kým pri oboch nesvieti „Zostáva 0“. Čísla sú tie isté ako v Návrhu riešenia — táto obrazovka je druhý pohľad na ne a rozdáva sa priamo v nej.',
    poradce: 'Poradca',
    poznPlaceholder: 'Poznámka k cieľu pre klienta…',
    poznPrebiji: 'prebíja návrh systému vo výstupoch',
    poznZpet: 'späť na návrh',
    prebytek: 'Mesačný prebytok',
    prebytekNeznamy: 'Prebytok nepoznáme — doplň výdavky v analýze',
    prebyva: 'prebýva {kc}',
    precerpano: 'Prečerpané — toľko klient nemá',
    pridatJenJedn: '← rieši sa jednorazovo',
    pridatJenPrav: 'rieši sa pravidelne →',
    prideleno: 'Pridelené',
    rezervaJednNelze: 'Rezervu plán rieši zo zdrojov a z prebytku — jednorazový vklad sa pri nej nepribíja.',
    rezimJednorazove: 'Jednorazovo',
    rezimMesicne: 'Mesačne',
    rezimOboji: 'Oboje',
    rezimZpet: 'vypočítaný návrh',
    rozdano: 'Rozdané — zostáva 0',
    schodek: 'Výdavky a splátky prevyšujú príjmy — plán sa nedá platiť',
    splneno: 'splnené',
    systemBezVkladu: 'Systém sám žiadny vklad navyše nepočíta.',
    thCil: 'Popis cieľa (čo?)',
    thDosazeno: 'Dosiahnutá hodnota',
    thJedn: 'Jednorazový vklad',
    thKdy: 'Za koľko rokov? (kedy?)',
    thKolik: 'Hodnota (koľko?)',
    thPozn: 'Poznámka',
    thPrav: 'Pravidelný vklad',
    thPridatJedn: 'Pridať jednorazovo',
    thPridatPrav: 'Pridať pravidelne',
    titul: 'Tabuľka — rozdeľovník plánu',
    tlacitko: 'Tabuľka',
    uklada: 'Ukladám…',
    ulozeniJak: 'Čísla sa ukladajú samé — po chvíľke ticha a pri odchode zo stránky. „Uložené“ svieti až vtedy, keď ich má server. Návrh riešenia zostáva vedľa: ukazuje ten istý plán, len v kartách.',
    ulozeniSelhalo: 'Uloženie zlyhalo — zmena zostala len na obrazovke.',
    ulozeno: 'Uložené',
    vkladNavic: 'navyše nad zdroje',
    vysvetlivka: '„Pridať“ = koľko by ešte bolo potrebné, aby cieľ vyšiel celý — nad tým, čo mu plán už pridelil. Nie je to platba, je to chýbajúca časť. Splnený cieľ tu nemá číslo, ale slovo.',
    vysvetlivkaRezim: '„Pridať“ nesie len ten stĺpec, ktorý odpovedá tomu, ako sa cieľ rieši: jednorazový vklad, alebo pravidelný. Keď sa rieši oboje, sú obe čísla ALTERNATÍVA — buď jednorazovo, ALEBO mesačne. Nesčítavaj ich: každé z nich platí len tak, že ten druhý vklad zostane, ako je.',
    zPritoku: '+ {kc} z budúceho prítoku',
    zadneZdroje: 'Nie je čo rozdeľovať — klient nemá voľný finančný majetok',
    zbyva: 'Zostáva',
    zdrojeDoRentyJak: 'Dôchodkové sporenie sa dá zrušiť, ale väčšinou mieri na dlhý cieľ. „Do renty“ ho pošle na rentu — a keď klient rentu nemá, na cieľ s najdlhším horizontom.',
    zdrojeDoRentyTitul: 'Stavebné a dôchodkové',
    zdrojeDoRentyVyp: 'na najbližší cieľ',
    zdrojeDoRentyZap: 'do renty',
    zpetNaNavrh: 'Späť na návrh riešenia',
  },
  /* BLOK:shrnutiPlan END */
  /* POŘADÍ KROKŮ — JEDNO PRO CELOU APPKU (diktát majitele 24. 9. 2026).
     Kroky i jejich stavy drží lib/poradiKroku.js; tady jsou jen jejich názvy
     a věty. Čísla kroků se do textů NEPÍŠÍ — dopočítá je `poradiKroku(id)`,
     jinak by text po přeskládání lhal. Věty `chybi*` vidí JEN PORADCE na své
     obrazovce: je to jeho domácí úkol, ne text pro klienta. */
  /* BLOK:poradiKroku START — generuje scratchpad/slovnik.py, ručně needitovat */
  poradiKroku: {
    chybiMajetkove: 'Krok {cislo} — majetkové poistenie: vyplňte a uložte kartu Poistenie majetku vyššie.',
    chybiRezerva: 'Krok {cislo} — rezerva: doplňte v analýze nevyhnutné výdavky. Bez nich cieľ rezervy nevznikne a riadok by klamal nulou.',
    chybiTitulek: 'Do tabuľky sa nedostali kroky, na ktoré chýba podklad:',
    chybiZivotni: 'Krok {cislo} — životné poistenie: bez príjmov a výdavkov v analýze nie je z čoho spočítať poistné sumy.',
    cile: 'Ciele',
    cilePozn: 'pravidelne investovať voľné zdroje na ciele a na rentu',
    dluhy: 'Zbaviť sa zlých dlhov',
    dluhyPozn: 'drahé úvery a kreditky zmazať ako prvé — úrok platíte isto, výnos investícií istý nie je',
    majetkove: 'Majetkové poistenie',
    majetkovePozn: 'nehnuteľnosť, domácnosť, auto, zodpovednosť a u podnikateľa aj firemný majetok',
    na90Dni: 'Kroky na najbližších 90 dní',
    rezerva: 'Vytvoriť rezervu',
    rezervaPozn: '3–6 mesiacov nevyhnutných výdavkov po ruke, aby plán nezastavila prvá nečakaná oprava',
    slideZaver: '„K vašej rente a finančnej nezávislosti vedú tieto kroky — a v tomto poradí.“',
    tabMajetekCo: 'Poistiť majetok a zodpovednosť ({kryti}) — orientačne {cena} mesačne.',
    tabMajetekKdy: 'Ihneď',
    tabMajetekProc: 'Jedna škoda na nehnuteľnosti alebo spôsobená inému stiahne celý plán ku dnu.',
    tabRezervaCo: 'Doplniť likvidnú rezervu na {cil} — dnes chýba {gap}.',
    tabRezervaCoFondy: 'Doplniť likvidnú rezervu na {cil} — dnes chýba {gap}, z toho {fondy} sa doplní z fondov (predaj podielových fondov, ETF alebo akcií).',
    tabRezervaHotovo: 'Rezervu {cil} držať naplnenú — hotovo.',
    tabRezervaKdy: 'Pred investovaním',
    tabRezervaProc: 'Vankúš na nečakané výdavky. Bez neho sa prvá porucha rieši dlhom alebo rozpustením investície.',
    ukolCile: 'Spustiť pravidelné investície {castka} na ciele a rentu',
    ukolDluhy: 'Zbaviť sa zlých dlhov — dnes {castka}',
    ukolMajetkove: 'Zjednať poistenie majetku a zodpovednosti — orientačne {cena}',
    ukolOsoba: '{jmeno}: invalidita {invalidita}, smrť {smrt}',
    ukolOsobaBezInvalidity: '{jmeno}: smrť {smrt}',
    ukolRezerva: 'Doplniť rezervu na {cil} (chýba {gap})',
    ukolRezervaFondy: 'Doplniť rezervu na {cil} (chýba {gap} — {fondy} sa doplní z fondov)',
    ukolRezervaHotovo: 'Rezerva {cil} je naplnená — držať ju',
    ukolZivotni: 'Zjednať rizikové poistenie — invalidita {invalidita}, smrť {smrt}',
    ukolZivotniBezInvalidity: 'Zjednať rizikové poistenie — smrť {smrt}; krytie invalidity bez príjmu nepočítame',
    ukolZivotniOsoby: 'Zjednať rizikové poistenie — {osoby}',
    ukolZivotniOsobyBezInvalidity: 'Zjednať rizikové poistenie — {osoby}; krytie invalidity bez príjmu nepočítame',
    uvod: '…ale je potrebné pre to niečo urobiť. V tomto poradí:',
    zivotni: 'Životné poistenie',
    zivotniPozn: 'dobre a lacno poistiť invaliditu a smrť — výpadok príjmu nesmie položiť rodinu',
  },
  /* BLOK:poradiKroku END */
  cilHorizont: {
    hned: "hneď",
    bezTerminu: "termín zatiaľ nie je stanovený",
    zaOne: "o {n} rok",
    zaFew: "o {n} roky",
    zaMany: "o {n} rokov",
    rokOne: "rok",
    rokFew: "roky",
    rokMany: "rokov",
  },
  /* NAVRH — TABULKY „NASE DOPORUCENI" A „PRODUKTY" (audit R11).
   * Skladaji se ZIVE z aktualnich cisel planu; ukladaji se jen prepisy poradce.
   * Radky jednotlivych cilu tu nejsou schvalne — ty ma plan ve vlastni, taky
   * zive pocitane sekci (dopCil.*). Viz lib/navrhTabulky.js. */
  /* BLOK:navrhTabulky START — generuje scratchpad/slovnik.py, ručně needitovat */
  navrhTabulky: {
    alokaceCo: 'Investovať podľa profilu: akcie {akcie} %, dlhopisy {dluhopisy} %, hotovosť {penize} %.',
    alokaceKdy: 'Ihneď',
    alokaceProc: 'Alokácia robí ~92 % výsledku; inšpirácia Nórskym fondom / Nobelovou nadáciou.',
    alokaceZProfilu: 'Rozloženie na štarte podľa zvoleného profilu (Riešenie cieľov vyššie). K cieľu sa samo postupne presúva do bezpečia.',
    davkyOdhadPodlePrijmu: 'Orientačný odhad podľa príjmu — to isté číslo, z ktorého vychádzajú poistné sumy.',
    diverzifikaceCo: 'Diverzifikovať menovo a regionálne (svet ~72 % USA, …).',
    diverzifikaceKdy: 'Ihneď',
    diverzifikaceProc: 'Väčšia stabilita portfólia, ochrana pred lokálnym prepadom.',
    dluhyCo: 'Zbaviť sa drahých dlhov (dnes {castka}).',
    dluhyKdy: 'Čo najskôr',
    dluhyProc: 'Úrok platíte isto, výnos investícií istý nie je.',
    pojisteniCo: 'Zabezpečiť príjem poistením — invalidita {invalidita}, smrť {smrt} (klesajúce sumy).',
    pojisteniCoBezInvalidity: 'Zabezpečiť poistením — smrť {smrt} (klesajúce sumy). Krytie invalidity bez príjmu nepočítame, doplňte príjem.',
    pojisteniCoOsoby: 'Zabezpečiť príjem poistením — {osoby} (klesajúce sumy).',
    pojisteniCoOsobyBezInvalidity: 'Zabezpečiť poistením — {osoby} (klesajúce sumy). Krytie invalidity bez príjmu nepočítame, doplňte príjem.',
    pojisteniKdy: 'Ihneď',
    pojisteniProc: 'Pri výpadku príjmu nesmie rodina spadnúť zo životnej úrovne ani prísť o ciele.',
    produktAkcie: 'Akciové ETF (svet, MSCI World)',
    produktDluhopisy: 'Dlhopisové ETF (svet)',
    produktPenize: 'Peňažný trh / sporiaci (rezerva + hotovosť)',
    upravenoPoradcem: 'upravené poradcom',
    zivyNavrh: 'návrh systému — prepočítava sa z aktuálnych čísel plánu',
    zpetNaNavrh: 'Späť na návrh systému',
  },
  /* BLOK:navrhTabulky END */
  /* RESENI U POJISTKY — navrh systemu + text poradce (lib/doporuceniPojisteni.js).
   * Sklada se ZIVE z cisel srovnani „pred a po“; uklada se jen prepis poradce
   * (navrh.solver.doporuceniPojisteni). Zadny produkt ani pojistovna — je to
   * regulovany vystup (IDD), navrh rika CO chybi, ne u koho to sjednat. */
  dopPoj: {
    titul: "Riešenie pri poistke",
    podtitul: "Systém navrhne z čísel porovnania, poradca má posledné slovo.",
    domacnost: "Celá domácnosť",
    titulVystup: "Čo odporúčame k poisteniu",
    odSystemu: "návrh systému",
    odPoradce: "text poradcu",
    upravit: "Upraviť text",
    zpetNaNavrh: "Späť na návrh systému",
    placeholder: "Čo klientovi pri poistení odporúčame…",
    hint: "Návrh systému je poskladaný z čísel tohto porovnania. Poradca má posledné slovo — jeho text sa tlačí do plánu aj do prezentácie pre klienta.",
    prazdneVarovani: "Prázdne odporúčanie sa klientovi nevytlačí. Vráťte sa na návrh systému, alebo napíšte vlastný text.",
    nicKRict: "Zatiaľ nie je z čoho odporúčanie poskladať — doplňte dnešné poistné sumy a cenu variantu.",
    rizikoSmrt: "Smrť",
    rizikoInvalidita: "Invalidita",
    bezSmlouvy: "Klient dnes nemá žiadnu zmluvu s poistnou sumou — zabezpečenie príjmu treba postaviť od nuly.",
    nekrytyRiziko: "{riziko}: dnes bez krytia, potreba {novy}.",
    nekrytyRizikoBezCastky: "{riziko}: dnes bez krytia.",
    nizkyLimit: "{riziko}: dnešných {puvodni} je pod potrebou {novy} — chýba {rozdil}.",
    pokrytoRiziko: "{riziko}: dnešných {puvodni} potrebu {novy} pokrýva.",
    argument: "Krytie rastie ×{kryti}, cena ×{cena}.",
    argumentVyhra: "Krytie rastie ×{kryti}, cena len ×{cena} — za neporovnateľne menej peňazí neporovnateľne viac krytia.",
    brzdaLimit: "{riziko}: doplňte do analýzy dnešnú poistnú sumu — bez nej sa nedá povedať, čo klientovi chýba.",
    brzdaNovy: "{riziko}: vo zvolenom variante zatiaľ nie je vypočítaná poistná suma.",
    brzdaPlatba: "Doplňte, koľko klient za súčasné zmluvy platí dnes — bez toho sa cena nedá porovnať.",
    brzdaPlatbaCastecna: "Pri niektorej súčasnej zmluve chýba platba — porovnanie ceny je preto len čiastočné.",
    brzdaCena: "Doplňte cenu zvoleného variantu — bez nej nemožno povedať, čo klient bude platiť.",
  },
  /* REZERVA — na kolik mesicu (majitel 25. 9. 2026: „rezerva bud 3 - 6 - 12
   * mesicu, no to je jedno“). Jeden prepinac, tri volby: pocet mesicu plati na
   * CELY zaklad, tedy nezbytne vydaje i splatky. Prepinac stoji u cile rezervy,
   * ne v nastaveni; volby 18 / 24 / 36 se zrusily i s rozdelenym zakladem. */
  rezervaMesicu: {
    titul: "Rezerva na",
    m3: "3 mesiace",
    m6: "6 mesiacov",
    m12: "12 mesiacov",
    hint: "Koľko mesiacov rezerva vydrží. Počíta sa z nevyhnutných výdavkov aj splátok — v kríze bežia oboje ďalej.",
  },
  /* ZTRATA Z PREDCASNEHO ZRUSENI PENZIJKA (planSolver, ztrata.kody).
   * ZADNE CISLO — engine nezna sazbu ani kolik uz klient dostal, takze veta
   * mluvi o tom, CO se vraci, nikdy o kolik. */
  ztrataPenzijka: {
    titul: "Čo stojí vziať si to skôr",
    statniPrispevek: "Predčasné zrušenie znamená vrátiť štátne príspevky.",
    danovaVyhoda: "Predčasné zrušenie znamená dodaniť skôr uplatnenú daňovú výhodu.",
    druhNeznamy: "Pri niektorej zmluve nie je vybraný druh (DPS / DIP) — doplňte ho, aby bolo jasné, o čo presne klient príde.",
  },
  /* BLOK:dopCil START — generuje scratchpad/slovnik.py, ručně needitovat */
  dopCil: {
    brzdaBezCastky: 'Cieľ nemá zadanú sumu — doplňte ju v analýze.',
    brzdaBezHorizontu: 'Cieľ nemá horizont — doplňte, za koľko rokov ho klient chce. Bez toho sa nedá rozpočítať ani zaradiť do plánu.',
    brzdaKapacita: 'Pozor: {prav} mesačne je nad voľným prebytkom domácnosti ({kapacita} mesačne) — buď dlhší horizont, nižší cieľ, alebo miesto v rozpočte.',
    brzdaNedosazitelne: 'V tomto nastavení cieľ nevychádza ani pri maximálnom vklade — je potrebný dlhší horizont alebo nižšia suma.',
    hint: 'Návrh systému je poskladaný z čísel tohto plánu. Poradca má posledné slovo — jeho text sa tlačí do plánu, jednostranového plánu aj do prezentácie pre klienta.',
    jakGlide: 'Investične: prvý rok {start}, posledný rok {konec} (akcie/dlhopisy/hotovosť) — riziko sa ku koncu vypína.',
    jakJedn: 'Riešenie: {jedn} jednorazovo, mesačne nič navyše.',
    jakNic: 'Riešenie: z peňazí, ktoré máte dnes, cieľ vychádza aj bez ďalších vkladov.',
    jakNicNevychazi: 'Riešenie: na tento cieľ zatiaľ nie je z čoho platiť — plán mu nevyčlenil ani jednorazový vklad, ani mesačnú sumu.',
    jakOboji: 'Riešenie: {jedn} jednorazovo a {prav} mesačne.',
    jakPrav: 'Riešenie: {prav} mesačne.',
    jakRenta: 'Rentiérske portfólio {alokace} (akcie/dlhopisy/hotovosť) sa drží aj v čerpaní — renta ide z výnosov.',
    jakRezerva: 'Rezerva sa neinvestuje — patrí na sporiaci účet, aby bola k dispozícii zo dňa na deň.',
    jakStabilni: 'Investične {start} (akcie/dlhopisy/hotovosť) po celý horizont.',
    nicKRict: 'Zatiaľ nie je z čoho odporúčanie poskladať — doplňte sumu a horizont cieľa.',
    odPoradce: 'text poradcu',
    odSystemu: 'návrh systému',
    placeholder: 'Čo klientovi pri tomto cieli odporúčame…',
    prazdneVarovani: 'Prázdne odporúčanie sa klientovi nevytlačí. Vráťte sa na návrh systému, alebo napíšte vlastný text.',
    titul: 'Odporúčanie k cieľu',
    titulVystup: 'Čo odporúčame k jednotlivým cieľom',
    upravit: 'Upraviť text',
    vysledekChybi: 'Za {roky} rokov z toho vychádza {konec} — chýba {chybi} ({pct} % cieľa).',
    vysledekChybiHned: 'Do roka z toho vychádza {konec} — chýba {chybi} ({pct} % cieľa).',
    vysledekOk: 'Za {roky} rokov z toho vychádza {konec} — cieľ pokrytý na {pct} %.',
    vysledekOkHned: 'Do roka z toho vychádza {konec} — cieľ pokrytý na {pct} %.',
    zadaniBezne: 'Cieľ {cil} za {roky} rokov.',
    zadaniBezneBezLet: 'Cieľ {cil}.',
    zadaniHypo: 'Vlastné zdroje {cil} za {roky} rokov (variant {varianta}). Splátka potom {splatka} mesačne.',
    zadaniHypoBezLet: 'Vlastné zdroje {cil} (variant {varianta}). Splátka potom {splatka} mesačne.',
    zadaniRenta: 'Renta {renta} mesačne znamená kapitál {cil} — z neho sa dá trvalo čerpať 4 % ročne. Horizont {roky} rokov.',
    zadaniRentaBezLet: 'Renta {renta} mesačne znamená kapitál {cil} — z neho sa dá trvalo čerpať 4 % ročne.',
    zadaniRezerva: 'Likvidná rezerva {cil} — vankúš na nečakané výdavky. Má prednosť pred investovaním.',
    zdroje: 'Jednorazovo z: {zdroje}.',
    zdrojeFondyRezerva: 'Chýbajúcich {fondy} sa doplní z fondov — predaj podielových fondov, ETF alebo akcií, ktoré klient už má.',
    zpetNaNavrh: 'Späť na návrh systému',
  },
  /* BLOK:dopCil END */
  /* ── boLab — NÁHLED MOTIVU „beplan“ (design-lab/beplan-orange) ───────────
   * Texty interní náhledové stránky /design-lab/beplan-orange. NENÍ v produkční
   * navigaci a NEPŘEBARVUJE aplikaci — tokeny motivu jsou zavřené v `.bo-scope`
   * (frontend/src/design-lab/brand-orange/motiv.css).
   * Klíč po klíči shodné ve všech pěti jazycích (214 klíčů) — hlídá
   * design-lab/brand-orange/__tests__/klicePetJazyku.test.js.
   * ⚠️ Barva se jmenuje neutrálně „brand oranžová“. Pracovní název ze zadání se
   * nepoužívá: koliduje s historickým pojmem z války ve Vietnamu a aplikaci
   * používají vietnamští poradci i klienti.
   * ──────────────────────────────────────────────────────────────────────── */
  boLab: {
    boLab: {
      cil: {
        brzda: "Brzda plánu",
        brzdaText: "Ciele si žiadajú",
        brzdaText2: "ale voľný prebytok je len",
        brzdaText3: "Chýba",
        bydleniText: "ČNB: do 36 rokov stačí 10 % vlastných zdrojov (LTV 90 %). Z ceny 4 500 000 Kč to je 450 000 Kč.",
        chybi: "Chýba",
        cilova: "Cieľová suma",
        cilu: "ciele",
        dnes: "Dnes",
        historie: "História zmien",
        hned: "hneď",
        let: "rokov",
        mesicne: "Mesačne",
        plneni: "Plnenie",
        prebytek: "Voľný prebytok",
        prepocitat: "Prepočítať plán",
        prijem: "Čistý príjem",
        rezervaText: "Rezerva vydrží necelé 2 mesiace výdavkov namiesto odporúčaných 6. Do vytvorenia rezervy nemá zmysel navyšovať investície.",
        rozdeleno: "Rozdelené",
        srovnat: "Zrovnať priority",
        stavNevime: "Nevieme",
        stavNevychazi: "Nevychádza",
        stavSplneno: "Vychádza",
        stavTesne: "Tesne",
        titul: "Plán — ciele",
        upravit: "Upraviť cieľ",
        zaHorizont: "Za horizont",
        zbyva: "Zostáva",
      },
      jedMes: "/mes",
      klient: {
        bezneVydaje: "Bežné výdavky",
        chybiPrijemPartnera: "Chýba príjem partnera",
        chybiUdaje: "Chýbajú 3 údaje",
        cistyPrijem: "Čistý príjem",
        deti: "Deti",
        domacnost: "Domácnosť",
        dopad: "Čo to znamená",
        dopadHorniOdhad: "horný odhad, štátnu dávku zatiaľ nikto nedohľadal.",
        dopadText: "Pri invalidite 3. stupňa vypadne celý príjem. Chýba krytie zhruba",
        dps: "Penzijné sporenie",
        fazeRealizace: "Fáza: Realizácia",
        hotovo: "Hotovo",
        invalidita: "Invalidita 3. stupňa",
        investice: "Investície",
        jmeno: "Meno",
        kOvereni: "Na overenie",
        klientOd: "klient od",
        let: "rokov",
        majetekZavazky: "Majetok a záväzky",
        mezera: "Medzera",
        narozeni: "Narodenie",
        nekryto: "nekryté",
        overeno: "overené",
        partner: "Partner",
        pn: "Práceneschopnosť",
        pojisteni: "Poistenie",
        prijemPartnera: "Príjem partnera",
        prijmyVydaje: "Príjmy a výdavky",
        rezerva: "Likvidná rezerva",
        roky: "roky",
        sdeleno: "oznámené",
        sekce: "Sekcie klienta",
        servis: "Servis 14. 11. 2026",
        smrt: "Smrť",
        splatkyUveru: "Splátky úverov",
        spotrebitelsky: "Spotrebiteľský úver",
        statniDavka: "Invalidný dôchodok od štátu",
        stavSmlouva: "V zmluve",
        telefon: "Telefón",
        telefonPartner: "Telefón partnera",
        tisk: "Tlač",
        ulozit: "Uložiť",
        zalozkaAnalyza: "Analýza",
        zalozkaDokumenty: "Dokumenty",
        zalozkaHistorie: "História",
        zalozkaObchody: "Obchody",
        zalozkaPlan: "Plán",
      },
      lab: {
        coJeVidet: "Čo je na tejto obrazovke vidieť",
        dnes: "Dnešok",
        dnesBezTmave: "Dnešok tmavú variantu NEMÁ — aplikácia žiadnu nemá, takže vľavo zostáva svetlá. Nie je to chyba náhľadu.",
        dnesPopis: "Sage & Clay — čo poradca vidí teraz",
        jenDnes: "Len dnešok",
        jenNavrh: "Len návrh",
        miraTitul: "Šírka obsahu vs šírka rámu. Keď obsah pretečie, stránka ide do vodorovného scrollu.",
        motiv: "Motív",
        navrh: "Návrh",
        navrhPopis: "brand oranžová + navy — svetlá",
        navrhPopisTmava: "brand oranžová + navy — tmavá",
        notebook: "Notebook 1440",
        obrazovky: "Obrazovky",
        odznak: "Náhľad — aplikácia sa nemení",
        preteka: "preteká",
        sedi: "sedí",
        sirka: "Šírka",
        svetla: "Svetlá",
        telefon: "Telefón 390",
        titul: "Design Lab · motív beplan",
        tmava: "Tmavá",
        vedleSebe: "Vedľa seba",
        zobrazeni: "Zobrazenie",
        zpet: "Späť",
      },
      login: {
        claim: "Finančný plán, ktorému klient rozumie.",
        claimSub: "Analýza, plán a servis na jednom mieste — pre poradcu aj pre klienta.",
        email: "E-mail",
        heslo: "Heslo",
        prihlasit: "Prihlásiť sa",
        sso: "alebo cez firemný účet",
        zalozkaPrihlaseni: "Prihlásenie",
        zalozkaRegistrace: "Registrácia",
        zapomenute: "Zabudnuté heslo",
        zpusob: "Spôsob prihlásenia",
      },
      mesic: {
        cerven: "J",
        cervenec: "J",
        kveten: "M",
        rijen: "O",
        srpen: "A",
        zari: "S",
      },
      nastenka: {
        bj: "Body (BJ)",
        bjZPlanu: "BJ z mesačného plánu",
        diar: "Diár — dnes",
        dnesUkoly: "dnes 5 úloh",
        kpi: "Kľúčové čísla mesiaca",
        mezera: "Medzera",
        mezeraText: "Hájek — invalidita 3. stupňa nekrytá.",
        mezeraText2: "Dvořáková — rezerva pod 2 mesiace výdavkov.",
        nadKapacitu: "Plán je nad kapacitou domácnosti.",
        novyKlient: "Nový klient",
        obchodu: "9 obchodov",
        pipeline: "Pipeline",
        plneniPlanu: "Plnenie plánu",
        poTerminu: "po termíne 11 dní",
        podtitul: "Utorok 25. augusta · 3 stretnutia · 2 úlohy po termíne",
        prebytek: "Rozpracovaný plán — Hájek",
        prilezitosti: "Radar príležitostí",
        provize: "Provízie",
        radar: "Servisný radar",
        rozdeleno: "Rozdelené do cieľov",
        rust: "+18 %",
        titul: "Dobré ráno, pán Čung",
        typPlan: "Plán",
        typPrvni: "Prvé stretnutie",
        typServis: "Servis",
        ukoly: "Po termíne",
        vejdeSe: "Zmestí sa do prebytku.",
        volnyPrebytek: "Voľný prebytok",
        vyplaceno: "vyplatené 15. 8.",
        vyvoj: "Vývoj obchodov",
        zPlanu: "68 % plánu",
        za2mesice: "servis o 2 mesiace",
        za3tydny: "servis o 3 týždne",
        zbyva: "Do konca mesiaca zostáva 6 pracovných dní.",
      },
      nav: {
        diar: "Diár",
        hlavni: "Hlavná navigácia",
        klienti: "Klienti",
        nastenka: "Nástenka",
        nastroje: "Nástroje",
        obchody: "Obchody",
        plan: "Plán",
        poradce: "Pán Čung",
      },
      nevyplneno: "nevyplnené",
      neznamo: "neznáme",
      obrazovka: {
        cil: "Karta cieľa",
        klient: "Karta klienta",
        nastenka: "Nástenka",
        prihlaseni: "Prihlásenie",
        verejna: "Verejná stránka",
        vystup: "Klientsky výstup",
      },
      pozn: {
        cil: "Najzložitejšia obrazovka. Štyri ciele vzorového klienta, kapacitná brzda hore (plán je o 5 300 Kč mesačne nad možnosťami domácnosti) a problém, dopad, krok pod číslami.",
        cilSazba: "Jediné miesto náhľadu, kde sa líši aj sadzba, nielen farby. Prepni šírku na Telefón 390 a porovnaj meradlá nad panelmi.",
        klient: "Formulárová hustota. Hranice polí, čitateľnosť malých popiskov a hlavne rozdiel medzi nevyplnené a nula: prázdne polia sú čiarkované a jantárové, nie nulové.",
        nastenka: "Koľko oranžovej obrazovka unesie. Pravidlo: jedna sýta oranžová plocha na obrazovku (tlačidlo Nový klient). Stavy sú zelená, jantárová, červená a modrá ako tmavý text na svetlom tóne — akcia a stav sa potom nepletú už tvarom.",
        prihlaseni: "Prvý dojem. Logo, oranžové tlačidlo, podčiarknutá aktívna záložka. Fotka pláže z predlohy je nahradená navy plochou so šípkou z loga — text na fotke má neznámu svetlosť, takže kontrast sa nedá zaručiť.",
        verejna: "To, čo klient vidí ako prvé. Jediná obrazovka, kde smie byť oranžová veľká — je to plocha značky, nie ovládací prvok. Text na nej je navy, nie biely.",
        vystup: "Najprísnejšie miesto motívu. Papier zostáva biely aj v tmavom režime, oranžová je na ňom vždy tmavší odtieň a každý pruh má vedľa seba číslo aj slovo, aby čiernobiela tlač neprišla o informáciu.",
      },
      vystup: {
        castka: "Suma",
        chybi: "chýba",
        cil: "Cieľ",
        disclaimer: "Odporúčania vychádzajú z údajov poskytnutých klientom k dátumu spracovania. Nejde o investičné odporúčanie ani o prísľub výnosu. Uvedené modelácie sú orientačné.",
        eyebrow: "Finančný plán",
        kdeJsteDnes: "Kde ste dnes",
        mesice: "mesiaca",
        mesicneCelkem: "Mesačne celkom",
        pokryto: "pokryté",
        poslat: "Poslať klientovi",
        prebytek: "Voľný prebytok",
        prijem: "Čistý príjem",
        prvniKrok: "Prvý krok",
        prvniKrokText: "Dorovnať likvidnú rezervu na 168 000 Kč. Dovtedy má rezerva prednosť pred investovaním — bez nej by každý nečakaný výdavok rozbil zvyšok plánu.",
        rezervaMa: "Rezerva vydrží",
        splneniCilu: "Splnenie vašich cieľov",
        tisk: "Vytlačiť / uložiť PDF",
        vaseCile: "Vaše ciele",
        vytvoreno: "Spracoval pán Čung · 25. augusta 2026",
      },
      web: {
        claim: "Nech vaše peniaze majú plán, nie náhodu.",
        claimSub: "Prvé stretnutie je zadarmo a nezáväzne. Trvá zhruba 30 minút, online cez Google Meet.",
        oMne: "O mne",
        online: "Online, 30 minút",
        otazky: "Otázky",
        reference: "Referencie",
        referenceSablona: "Miesto na referencie, ktoré si poradca vyplní sám. Náhľad ich schválne nevypĺňa — vymyslená referencia s menom je právne riziko.",
        rezervace: "Rezervácia",
        rezervovat: "Dohodnúť stretnutie",
        role: "Tvoj finančný poradca",
        sCimPomuzu: "S čím ti viem pomôcť",
        sluzba1: "Rezerva a rozpočet",
        sluzba1Sub: "Aby vás nečakaný výdavok nepoložil.",
        sluzba2: "Vlastné bývanie",
        sluzba2Sub: "Koľko potrebujete a kedy to vyjde.",
        sluzba3: "Renta a nezávislosť",
        sluzba3Sub: "Koľko odkladať, aby to raz stačilo.",
        sluzby: "Služby",
        volneTerminy: "Voľné termíny tento týždeň",
        vyberTermin: "Vyber si termín stretnutia",
        vybratTermin: "Vybrať termín",
        zdarma: "Zadarmo",
      },
    },
  },
  rezSmlouva: {
    nazev: 'Rezervačná zmluva',
    podnadpis: 'Vyplň hlavičku, cenu a blokačný poplatok. Zvyšok sa doplní a systém zmluvu skontroluje skôr, než ju vytlačíš.',
    zpetNaZakazku: 'Späť na zákazku',
    jizRozepsane: 'Na tejto nehnuteľnosti už je rozpísaná zmluva:',
    bezKupujiciho: 'bez kupujúceho',
    vzorLabel: 'Vzor zmluvy',
    pracovniVzor: 'Pracovný vzor — text zatiaľ neschválil advokát. U klienta ho zatiaľ nepoužívaj.',
    skupina_penize: 'Peniaze a doba',
    skupina_hlavicka: 'Hlavička',
    skupina_strany: 'Zmluvné strany',
    skupina_nemovitost: 'Nehnuteľnosť',
    skupina_kancelar: 'Realitná kancelária',
    skupina_ostatni: 'Ďalšie údaje',
    doplneno: 'doplnené',
    vyber: '— vyber —',
    ano: 'Áno',
    ne: 'Nie',
    neniVyplneno: 'nevyplnené',
    odvozeneNadpis: 'Vypočíta systém',
    slovyPopis: 'Sumu slovom, doplatok aj koniec rezervácie píše systém. Preto sa nemôžu rozísť s číslom.',
    odvozene_kupni_cena_slovy: 'Kúpna cena slovom',
    odvozene_blokacni_poplatek_slovy: 'Blokačný poplatok slovom',
    odvozene_doplatek: 'Doplatok kúpnej ceny',
    odvozene_doplatek_slovy: 'Doplatok slovom',
    odvozene_rezervace_do: 'Rezervácia platí do',
    kontrolaNadpis: 'Kontrola pred tlačou',
    kontrolaCisto: 'Bez nálezu. Môžeš tlačiť.',
    kontrolaBlokuje: 'Kým toto neopravíš, tlač je zavretá.',
    pocitam: 'Počítam…',
    nahledNadpis: 'Náhľad zmluvy',
    ulozit: 'Uložiť',
    ulozeno: 'Uložené',
    vytisknout: 'Vytlačiť',
    podepsano: 'Označiť za podpísanú',
    jePodepsana: 'Podpísané',
    podepsanaZamek: 'podpísanú zmluvu už nejde meniť',
    advokat: 'E-mail advokátovi',
    advokatHotovo: 'Správa je len pripravená. Odošli ju zo svojho e-mailu aj s prílohou.',
    zkopirovat: 'Skopírovať',
    zkopirovano: 'Skopírované',
    nejdrivUloz: 'Najprv zmluvu ulož.',
    tiskZablokovan: 'Prehliadač zablokoval tlačové okno. Povoľ vyskakovacie okná a skús to znova.',
    chybaNacteni: 'Nepodarilo sa načítať. Skús to znova.',
    chybaUlozeni: 'Neuložilo sa.',
    chybaKopie: 'Skopírovať sa nepodarilo.',
  },
  /* BLOK:izp START — generuje scratchpad/slovnik.py, ručně needitovat */
  izp: {
    argumenty: {
      jak1: 'Platí sa jedna mesačná suma. Jej časť ide na krytie rizík, zvyšok do investičnej zložky.',
      jak2: 'Rozsah krytia sa dá počas trvania meniť — pridať riziko, zvýšiť alebo znížiť sumu.',
      jak3: 'Z investičnej časti sa obvykle dá vybrať alebo ju znížiť. Lehoty a podmienky sa pri zmluvách líšia.',
      jak4: 'Zmluvu je možné ukončiť. Čo presne sa v takom prípade vypláca, určujú jej podmienky.',
      jak5: 'Keď sa zmení príjem, dá sa upraviť aj to, koľko ide na ochranu a koľko na investíciu.',
      jakNadpis: 'Ako to vo všeobecnosti funguje',
      nadpis: 'Prečo to mať a ako to vo všeobecnosti funguje',
      nasobekCeny: 'cena ×{x}',
      nasobekKryti: 'krytie ×{x}',
      oci: 'Argumenty',
      pomerChybi: 'Doplňte pri rizikách, čo klient má dnes — krytie a cenu. Bez toho sa pomer krytia a ceny vypočítať nedá.',
      pomerNadpis: 'Krytie proti cene',
      pomerNejslabsi: 'Berie sa najslabšie z porovnaných rizík (počet: {pocet}).',
      pomerVyhra: 'Krytie rastie rýchlejšie ako cena.',
      pomerZdroj: 'Počítané z rizík, kde je zadané dnešné aj nové krytie (počet: {pocet}). Berie sa najslabšie riziko, nie to najlepšie.',
      popis: 'Všeobecný princíp, nie podmienky konkrétnej zmluvy.',
      potvrdiKratce: 'Všeobecný princíp, nie podmienky konkrétnej zmluvy. Čo zmluva dovolí, potvrdí poradca podľa ponuky.',
      potvrdiText: 'Toto je všeobecný princíp, nie podmienky konkrétnej zmluvy. Čo presne zmluva dovolí — zmeny, výbery, ukončenie a ich podmienky — potvrdí poradca podľa konkrétnej ponuky.',
      potvrdiTuk: 'Čo potvrdí poradca',
      proc1: 'Príjem je motor rodiny. Keď prestane chodiť, výdavky zostanú a niektoré ešte narastú.',
      proc2: 'Štát dáva len časť, a nie hneď. Zvyšok rieši rodina sama.',
      proc3: 'Záväzky sa neplatia z odhodlania, ale z peňazí. Hypotéka beží ďalej, aj keď príjem nie.',
      proc4: 'Ochranu aj odkladanie riešite jednou sumou, ktorú si sami rozdelíte.',
      procNadpis: 'Prečo to mať',
    },
    davka: {
      pozustalostni: 'Pozostalostné dôchodky — vdovský a sirotský',
    },
    diagnoza: {
      detskeChronicke: 'Chronické ochorenia vzniknuté v detstve, napríklad cukrovka prvého typu alebo epilepsia',
      detskeNadory: 'Detské nádorové ochorenia, napríklad leukémia',
      infarkt: 'Infarkt myokardu',
      mozkovaPrihoda: 'Cievna mozgová príhoda (porážka)',
      nadory: 'Nádorové ochorenia',
      neurologicka: 'Neurologické ochorenia — skleróza multiplex, Parkinsonova a Alzheimerova choroba',
      ochrnuti: 'Ochrnutie po úraze alebo chorobe',
      operaceSrdce: 'Operácie srdca a veľkých tepien',
      selhaniOrganu: 'Zlyhanie orgánov — obličiek, pečene, dýchacej sústavy',
      smysly: 'Strata zraku, sluchu alebo reči',
      transplantace: 'Transplantácia životne dôležitého orgánu',
      zenska: 'Ochorenia, ktoré sa týkajú len žien, a komplikácie v tehotenstve',
    },
    diagnozy: {
      deti: 'Pri detskej zmluve je zoznam iný — sú v ňom diagnózy, ktoré sa objavujú v detstve.',
      nadpis: 'Aké choroby sa kryjú',
      smlouva: 'Presný zoznam diagnóz, ich definície, štádiá aj čakacie doby určuje poistná zmluva a v každej poisťovni sa líši. Čo je poistené u vás, prejdeme v poistných podmienkach.',
      uvod: 'Toto sú skupiny diagnóz, o ktorých sa pri závažných chorobách hovorí najčastejšie.',
    },
    graf: {
      aria: 'Graf: zaplatíte celkom {zaplaceno}, z toho do investícií {investice}. Hodnota investícií v modeli o {roky}: {hodnota}. Model, nie záruka.',
      celkemVlozeno: 'Celkom vložené',
      dnesnimiOcima: 'Dnešnými očami {hodnota} (inflácia {inflace})',
      hodnotaVModelu: 'Hodnota investícií v modeli',
      horizonty: {
        d: {
          hodnota: 'Hodnota v modeli',
          nasobek: 'Násobok vkladov',
          vlozeno: 'Vložené',
          vlozenoPoplatek: 'z toho poplatok {poplatek}',
          vynos: 'Z toho výnos',
        },
        detailNadpis: 'Za {roky}',
        maStitek: 'má',
        nadpis: 'Čím dlhšie, tým viac',
        oci: 'Čas',
        poPoplatkuStitek: 'vložené po poplatku',
        predpoklad: 'Pri modelovom výnose {vynos} ročne',
        sloupec: '{roky}: modelová hodnota {hodnota}, vložené {vlozeno}',
        vlozenoStitek: 'vložené',
        vrstvy: {
          nadpis: 'Sila zloženého úročenia',
          vklady: 'Vklady',
          vkladyPoPoplatku: 'Vklady po poplatku',
          zVkladu: 'Výnos z vkladov',
          zVynosu: 'Výnos z výnosov',
        },
        vyber: 'Vyberte, o koľko rokov',
      },
      konec: {
        hodnota: 'Model',
        investice: 'Investície',
        zaplaceno: 'Zaplatené',
      },
      krivka: {
        hodnota: 'Hodnota v modeli',
        investice: 'Do investícií',
        ochrana: 'Ochrana (nevracia sa)',
        zaplaceno: 'Zaplatené celkom',
      },
      legendaHodnota: 'Modelová hodnota',
      legendaVlozeno: 'Vložené',
      milnik: {
        kratce: {
          plnoletost: '18',
          vysoka: 'VŠ',
        },
        plnoletost: '{jmeno}: 18 rokov',
        vysoka: '{jmeno}: vysoká škola',
      },
      modelText: 'Graf je modelový výpočet zo zadanej sumy a zvoleného výnosu. Budúci výnos nie je garantovaný, skutočný vývoj môže byť nižší aj vyšší. Konkrétne riešenie potvrdí poradca.',
      modelTuk: 'Modelový scenár, nie garancia',
      modelovaHodnota: 'Modelová hodnota',
      modeloveZhodnoceni: 'Modelové zhodnotenie',
      nadpis: 'Čo s investičnou časťou do vybraného veku',
      oci: 'Graf',
      osaRok: 'Rok {rok}',
      osaVekKonec: '{vek} r.',
      popis: 'Vyberte vek a očakávaný výnos. Graf ukazuje modelový priebeh, nie zaručený výsledok.',
      poplatek: {
        naKonci: 'Na konci',
        naKorunu: 'Na 1 {symbol} poslaných peňazí',
        nadpis: 'Tri spôsoby, ako zaplatiť poplatok',
        navic: 'z toho {poplatek} poplatok hneď navyše',
        oci: 'Vstupný poplatok',
        pole: 'Vstupný poplatok (% z cieľovej sumy)',
        poleHint: 'zvyčajne {min}–{max} %',
        poslano: 'Poslané peniaze spolu',
        radek: {
          expres: 'Poplatok {poplatek} · z platieb ({mesicu} mes.)',
          expresHned: 'Poplatok {poplatek} · zaplatíte navyše hneď',
          pulNaPul: 'Poplatok {poplatek} · napoly z platieb ({mesicu} mes.)',
        },
        souhrn: '{pct} z cieľovej sumy {cilova} je {poplatek}',
        varianta: {
          expres: {
            nazev: 'Expres z platieb',
            popis: 'Celá platba ide na poplatok, kým nie je splatený ({mesicu} mes.).',
          },
          expresHned: {
            nazev: 'Zaplatí hneď',
            popis: 'Poplatok zvlášť, investuje sa celá platba od prvého mesiaca.',
          },
          pulNaPul: {
            nazev: '50/50 z platieb',
            popis: 'Polovica platby na poplatok, polovica sa hneď investuje ({mesicu} mes.).',
          },
        },
        zToho: 'z toho {poplatek} na poplatok',
      },
      poradcePozn: 'Prepnite vek aj výnos pred klientom — nech vidí, ako sa číslo mení.',
      priVynosu: 'Pri výnose {vynos}',
      rizika: {
        deti: 'Deti',
        doplnte: 'doplňte v Rizikách',
        doporucene: 'Odporúčané krytie vypočítané z údajov rodiny. Výber rizík a presné sumy upraví poradca v Rizikách.',
        klient: 'Klient',
        nadpis: 'Za ochranu {cena} mesačne rodina dostane, keď sa niečo stane',
        nadpisBezCeny: 'Čo rodina dostane, keď sa niečo stane',
        podminky: 'Plnenie podľa poistných podmienok. Sumy sa nesčítajú.',
        zadna: 'Riziká zatiaľ nie sú vybrané — doplňte v Rizikách.',
      },
      tooltip: {
        dnes: 'Dnes · vek {vek}',
        vek: 'Vek {vek} · o {roky}',
        vynos: 'Výnos v modeli {castka}',
      },
      vek60: '60 rokov',
      vek65: '65 rokov',
      vek70: '70 rokov',
      vekLabel: 'Do koľkých rokov',
      vekVlastni: 'do {vek} rokov',
      vekVlastniLabel: 'Alebo zadaj vek',
      vynos4: '4 % ročne',
      vynos7: '7 % ročne',
      vynos9: '9 % ročne',
      vynosLabel: 'Očakávaný výnos',
      vynosProti: 'oproti {investice} do investícií · {vynos} ročne',
      vynosVModelu: 'Výnos v modeli',
      zaplaceno: {
        investice: 'Z toho do investícií',
        investicePopis: '{mesicne} mesačne',
        ochrana: 'Z toho ochrana',
        ochranaPopis: 'cena krytia, nevracia sa',
        popis: '{mesicne} mesačne × 12 × {roky}',
        popisPoplatek: '{mesicne} mesačne × 12 × {roky} + poplatok {poplatek}',
        stitek: 'Zaplatíte celkom',
      },
    },
    hadani: {
      odkryt: 'Odkryť skutočnosť',
      pole: 'Váš tip (mesačne)',
      rozdil: 'Rozdiel proti vášmu tipu',
      skutecnost: 'Štát dá mesačne',
      vyzva: 'Koľko si myslíte, že vám štát dá? Tipnite si, než to odkryjeme.',
    },
    hranice: {
      davkyOdhad: 'Štátne dávky sú orientačný odhad. Skutočnú výšku určuje úrad.',
      modelace: 'Toto je modelový scenár, nie poistná zmluva ani osobné odporúčanie.',
      odhadKlienta: 'Váš tip je len na porovnanie. Do výpočtu ani do tlače nevstupuje.',
      potvrdiPoradce: 'Konkrétne riešenie, limity aj cenu potvrdí poradca v poisťovni.',
      sablona: 'Označené sumy sú orientačný vzor z praxe poradcu, nie ponuka ani garancia.',
      vynosNeniGarantovan: 'Budúci výnos nie je garantovaný. Skutočný vývoj môže byť iný, aj výrazne.',
    },
    jednotka: {
      denni: 'denná dávka',
      jednorazova: 'jednorazová suma',
      renta: 'mesačná renta',
      zaDen: 'na deň',
      zaMesic: 'za mesiac',
    },
    karta: {
      cenaHint: 'Prepíšte z modelácie poisťovne. Ak ju ešte nemáte, nechajte prázdne.',
      cenaNezadana: 'Cena nezadaná — toto riziko sa do súčtu nepočíta.',
      cenaPole: 'Cena za mesiac',
      dnesCenaPole: 'Platí dnes',
      dnesHint: 'Prepíšte z jeho súčasnej zmluvy. Bez toho sa pomer nespočíta.',
      dnesKrytiPole: 'Krytie dnes',
      dnesNadpis: 'Čo má dnes',
      formaNezadana: 'Forma príjmu nezadaná — nemocenské je vypočítané ako u zamestnanca.',
      jakSePocita: 'Ako sa to počíta',
      jenZeny: 'len ženy',
      krytiPole: 'Krytie',
      nezadano: 'nezadané',
      osvcBezNemocenske: 'Ako SZČO bez dobrovoľného nemocenského poistenia nemocenské nedostávate.',
      otazka: 'Otázka na klienta',
      oznacProbrano: 'Označiť ako prebrané',
      poOsobach: 'Po osobách',
      pomerCena: 'cena',
      pomerKryti: 'krytie',
      pomerNadpis: 'Pomer proti dnešnému stavu',
      potreba: 'Koľko je potrebné',
      preskoceno: 'Preskočené',
      preskocit: 'Preskočiť',
      proDeti: 'aj pre deti',
      probrano: 'Prebrané',
      radekPotreba: 'potreba',
      sbalit: 'Zbaliť',
      statDa: 'Čo dá štát',
      tvar: 'Tvar plnenia',
      vCene: 'v cene',
      varianty: 'Varianty krytia',
      vratit: 'Vrátiť',
      vyradit: 'Vyradiť',
      zapsat: 'Zapísať čísla',
      zaradit: 'Zaradiť',
    },
    neznamo: 'Nezadané',
    poznamka: {
      cenaOdPoradce: 'Cenu a konkrétne riešenie potvrdí poradca podľa ponuky poisťovne.',
      hodnotaDnesnimaOcima: 'Dnešnými očami pri inflácii {inflace} % ročne to je',
      investiceVynesla: 'Investičná časť podľa modelu vynesla',
      modelovyScenar: 'Modelový scenár, nie poistná zmluva ani osobné odporúčanie.',
      nezbytneJsouCeleVydaje: 'Potreba krytia sa počíta z celých výdavkov domácnosti. Nevyhnutné výdavky bývajú nižšie — presné číslo spočíta plná kalkulačka životného poistenia.',
      odhadKlientaNeniUdaj: 'Váš tip je len na porovnanie — do výpočtu ani na papier nevstupuje.',
      vlozenoDoOchrany: 'Za {roky} rokov ste do ochrany vložili',
      vynosNeniGarantovan: 'Budúci výnos nie je garantovaný. Hodnota investície môže klesať aj stúpať.',
    },
    prehled: {
      balicekVysvetleni: 'Balíček je percento z príjmu, nie zo zvyšku. Preto je vidieť, či sa do voľných peňazí vojde. Modelový scenár, konkrétne riešenie potvrdí poradca.',
      balicky: 'Koľko by sa dalo odkladať',
      balickyPodnadpis: 'Kliknite na balíček. Časť ide do ochrany, zvyšok sa investuje — rozdelenie nastavíte hneď pod tým.',
      chybi: 'Chýba',
      doporuceno: 'Najvyšší, čo sa vojde',
      nadVolnymi: 'Nie je to zákaz — klient si smie vybrať viac. Znamená to len, že spolu musíme nájsť, odkiaľ tie peniaze vziať.',
      nadpis: 'Koľko prejde rukami',
      podnadpis: 'Dve čísla, ktoré o sebe klient vie. A jedno, ktoré obvykle nepozná.',
      prijem: 'Čistý príjem domácnosti',
      prijemNotePar: 'Manžel a manželka spolu.',
      vejdeSe: 'Vojde sa do voľných peňazí.',
      vlastni: 'Vlastná suma',
      vlastniHint: 'Zapíšte číslo, ktoré klient povedal.',
      vlastniLabel: 'Koľko chce odkladať',
      vlastniPopis: 'koľko povie klient',
      vlastniPrazdna: 'Napíšte sumu, ktorú klient povedal — inak nie je z čoho počítať.',
      volne: 'Zostáva voľných',
      volneKratce: 'Príjem mínus výdavky.',
      volneNote: 'Príjem mínus výdavky. Z tohto sa dá odkladať.',
      volneZaporne: 'Domácnosť utratí viac, než zarobí. Skôr než sa budeme rozprávať o poistke, musíme nájsť, kde peniaze unikajú.',
      vybrano: 'Vybrané',
      vydaje: 'Výdavky domácnosti',
      vydajeNote: 'Vrátane splátok úverov.',
      zPrijmu: 'z príjmu',
      zTohoRodine: 'z toho rodičom / rodine {castka}',
    },
    prezentace: {
      dal: 'Ďalej: {nazev}',
      krok: {
        cas: {
          nadpis: 'Ako platiť poplatok a čo urobí čas',
          otazka: 'Čo sa stane, keď necháte peniaze pracovať dlhšie?',
          say: 'Vyberte si stĺpec. Uvidíte, koľko ste vložili a koľko z toho urobil čas.',
          stitek: 'Poplatok a čas',
          tip: 'Nech klikne klient sám. Model, nie sľub.',
        },
        cisla: {
          nadpis: 'Vaše čísla',
          otazka: 'Koľko vám doma mesačne príde a koľko z toho zase odíde?',
          say: 'Stačí zhruba, presne to doladíme spolu.',
          stitek: 'Čísla',
          tip: 'Voľné peniaze klient väčšinou nepozná — nechajte ho, nech si ich prečíta sám.',
        },
        investice: {
          nadpis: 'Zvyšok balíčka pracuje',
          otazka: 'Koľko rokov by tie peniaze mohli pracovať?',
          say: 'Graf je model, nie sľub. Ukazuje, čo urobí čas.',
          stitek: 'Investícia',
          tip: 'Vek nech si vyberie klient sám.',
        },
        konecne: {
          brana: 'Najprv zapíšte rozhodnutie klienta: Áno, chcem, Upraviť alebo Zatiaľ nie.',
          nadpis: 'Konečné rozhodnutie',
          otazka: 'Teraz poznáte cenu aj podmienky. Chcete túto ochranu?',
          say: 'Áno, úprava aj zatiaľ nie sú v poriadku.',
          stitek: 'Potvrdenie',
          tip: 'Pri „Upraviť“ sa opýtajte, čo zmeniť.',
          volba: {
            ano: 'Áno, chcem',
            upravit: 'Upraviť',
            zatimNe: 'Zatiaľ nie',
          },
        },
        potvrzeni: {
          celkem: 'Ochrana spolu',
          cena: 'Cena',
          cenaUTemat: 'Cena je zatiaľ pri {n} z {celkem} tém.',
          kryti: 'Krytie',
          nadpis: 'Vaša ochrana',
          otazka: 'Sedí vám táto ochrana, alebo chcete niečo upraviť?',
          riziko: 'Riziko',
          rucne: 'V rozdelení balíka je ochrana upravená ručne na {castka}.',
          say: 'Krytie aj cenu ešte potvrdí ponuka poisťovne.',
          stitek: 'Ochrana',
          tip: 'Keď je to drahé, znížte poistné sumy a povedzte nahlas, o aké krytie klient príde.',
        },
        predstaveni: {
          say: 'Predstavím sa a poviem, ako pracujem.',
          tip: 'Register si klient môže overiť hneď v telefóne.',
        },
        rizika: {
          dalsi: 'Ďalšie riziko',
          nadpis: 'Čo by sa mohlo stať',
          otazkaSmrtBezUveru: 'Z čoho by rodina žila, keby ste sa jedného dňa nevrátili domov?',
          otazkaZavazkyBezCastky: 'Máte úver, ktorý by po vás niekto musel splácať?',
          poradi: 'Riziko {n} / {celkem}',
          predchozi: 'Predchádzajúce riziko',
          say: 'Tipnite si a potom sa pozrieme, ako to je naozaj.',
          smysl: 'Dáva vám to zmysel?',
          stitek: 'Riziká',
          tip: 'Po odkrytí sa opýtajte, či to dáva zmysel.',
          vsePreskoceno: 'Žiadne riziko na prebratie — všetky sú preskočené.',
        },
        smlouva: {
          nadpis: 'Ako funguje zmluva',
          otazka: 'Čo vás na zmluve zaujíma, kým sa rozhodnete?',
          say: 'Hovorím to dopredu, aby vás neskôr nič neprekvapilo.',
          stitek: 'Zmluva',
          tip: 'Zdravotný dotazník čítajte s klientom otázku po otázke.',
        },
        souhlas: {
          brana: 'Najprv zapíšte odpoveď klienta: Áno, Neskôr, alebo Nie.',
          nadpis: 'Rozhodnutie je na vás',
          otazka: 'Chcete si príjem rodiny poistiť?',
          say: 'Áno, neskôr aj nie sú v poriadku.',
          stitek: 'Rozhodnutie',
          tip: 'Po otázke mlčte a nechajte klienta odpovedať.',
        },
        svoleni: {
          nadpis: 'Čo dnes preberieme',
          otazka: 'Môžem sa opýtať na pár vecí, aby som vám ukázal, ako je na tom vaša rodina?',
          say: 'Zaberie to pár minút a rozhodnutie je vždy na vás.',
          stitek: 'Úvod',
          tip: 'Počkajte na odpoveď, neponáhľajte sa.',
        },
        zaver: {
          balicek: 'Koľko mesačne',
          dalsiKrok: 'Ďalší krok',
          dalsiKrokText: {
            ano: 'Pripravíme návrh na mieru a prejdeme ho spolu. Krytie a cenu potvrdí poisťovňa.',
            ne: 'Rozhodnutie je vaše. Kedykoľvek sa k tomu môžeme vrátiť.',
            nezadano: 'Ďalší krok dohodneme spolu.',
            pozdeji: 'Dohodneme sa, kedy sa k tomu vrátime.',
            upravit: 'Upravíme návrh podľa vás a prejdeme ho spolu znova. Krytie a cenu potvrdí poisťovňa.',
            zatimNe: 'Rozhodnutie je vaše. Kedykoľvek sa k tomu môžeme vrátiť.',
          },
          nadpis: 'Na záver',
          otazka: 'Aký ďalší krok vám dáva zmysel?',
          poznamka: 'Poznámka',
          rozhodnuti: 'Vaša odpoveď',
          say: 'Tu sú dve čísla. Záver je na vás.',
          sayBez: 'Ďakujem za váš čas. Rozhodnutie je vaše a platí.',
          stitek: 'Záver',
          termin: 'Termín',
          terminKlient: 'Dohodnutý termín: {kdy}',
          tip: 'Čísla nespájajte do jednej vety.',
          tipBez: 'Nepresviedčajte — len sa dohodnite, kedy sa ozvete.',
        },
      },
      predstaveni: {
        jakText: 'Ukážem vám, ako je na tom vaša rodina. Či a ako sa poistiť, rozhodnete vy.',
        odmenaText: 'Ako som za svoju prácu odmeňovaný, vám poviem a pred podpisom to dostanete písomne.',
      },
      uvod: {
        nadpis: 'Ako je na tom vaša rodina',
        rodina: 'Vaša rodina',
        slib: 'Ukážeme si to, opýtate sa a rozhodnete sa sami.',
      },
    },
    rizika: {
      nadpis: 'Riziká',
    },
    riziko: {
      bezmocnost: {
        coJe: 'Stav, keď sa sám neobslúžite — nenajete sa, neumyjete sa, nedôjdete si. Niekto pri vás musí byť každý deň.',
        nazev: 'Úplná odkázanosť na starostlivosť',
        pozn: 'V modeláciách sa tomu hovorí najvyšší stupeň. Čo presne plnenie spustí, určuje poistná zmluva.',
      },
      denniOdskodne: {
        coJe: 'Dávka za každý deň liečenia po úraze. Kryje okno, keď dávka za pracovnú neschopnosť ešte neplní.',
        nazev: 'Denné odškodné za čas liečenia úrazu',
      },
      detiHospitalizace: {
        coJe: 'Dávka za každú noc, ktorú dieťa leží v nemocnici. Rodič je pri ňom a nepracuje.',
        nazev: 'Pobyt dieťaťa v nemocnici',
      },
      detiOdskodne: {
        coJe: 'Dávka za každý deň liečenia dieťaťa po úraze — ten istý výpadok rodiča, len doma.',
        nazev: 'Denné odškodné dieťaťa za čas liečenia',
      },
      detiPeceRodice: {
        coJe: 'Dieťa zostane po úraze alebo chorobe trvalo odkázané na starostlivosť. Najväčšia diera nie je liečba — je to rodič, ktorý kvôli starostlivosti natrvalo vypadne z práce.',
        nazev: 'Vážna udalosť u dieťaťa — výpadok príjmu rodiča',
        pozn: 'Suma stojí na zmluve každého dieťaťa. Časť potreby na dieťa neupíše žiadna poisťovňa — tá patrí do rezervy a do investícií.',
      },
      detiTrvale: {
        coJe: 'Jednorazová suma na rehabilitáciu, pomôcky a úpravy bývania, keď dieťaťu po úraze zostane trvalé obmedzenie.',
        nazev: 'Trvalé následky úrazu u dieťaťa',
      },
      detiZavazne: {
        coJe: 'Jednorazová výplata pri vymenovanej diagnóze u dieťaťa — na liečbu a na to, aby rodič mohol zostať doma.',
        nazev: 'Kritické choroby dieťaťa',
        pozn: 'Koľko na dieťa poisťovňa upíše, je obmedzené. Zvyšok potreby patrí do rezervy a do investícií.',
      },
      hospitalizace: {
        coJe: 'Dávka za každú noc v nemocnici. Krátkodobá vec — u dospelého ju obvykle zastúpi rezerva.',
        nazev: 'Pobyt v nemocnici',
      },
      invalidita1Klesajici: {
        coJe: 'Čiastočné obmedzenie práce s dohodnutou poistnou sumou, ktorá sa v čase znižuje.',
        nazev: 'Invalidita 1. stupňa — klesajúca suma',
      },
      invalidita1Konstantni: {
        coJe: 'Čiastočné obmedzenie práce. Príjem klesne, výdavky zostanú.',
        nazev: 'Invalidita 1. stupňa — konštantná suma',
      },
      invalidita2Klesajici: {
        coJe: 'Vážne obmedzenie práce s dohodnutou poistnou sumou, ktorá sa v čase znižuje.',
        nazev: 'Invalidita 2. stupňa — klesajúca suma',
      },
      invalidita2Konstantni: {
        coJe: 'Vážne obmedzenie práce: niečo zvládnete, svoju profesiu na plný úväzok už nie. Na Slovensku ide stále o čiastočnú invaliditu.',
        nazev: 'Invalidita 2. stupňa — konštantná suma',
      },
      invalidita3Klesajici: {
        coJe: 'Úplná invalidita, ale poistná suma rok po roku klesá.',
        nazev: 'Invalidita 3. stupňa — klesajúca suma',
        pozn: 'Lacnejšia varianta. Má zmysel len vtedy, keď naozaj investujete a majetok dieru postupne zaplní — inak krytie klesá a potreba nie.',
      },
      invalidita3Konstantni: {
        coJe: 'Úplná invalidita: pracovať nemôžete vôbec. Dohodnutá poistná suma zostáva celý čas rovnaká.',
        nazev: 'Invalidita 3. stupňa — konštantná suma',
      },
      pece12: {
        coJe: 'Denná dávka na čas, keď väčšinu vecí zvládnete sám, ale pri niektorých potrebujete pomoc.',
        nazev: 'Dlhodobá starostlivosť — nižšie stupne odkázanosti',
      },
      pece34: {
        coJe: 'Mesačná renta po celý čas, keď potrebujete každodennú starostlivosť inej osoby.',
        nazev: 'Dlhodobá starostlivosť — vyššie stupne odkázanosti',
        pozn: 'Potrebnú výšku renty táto appka nepočíta — sumu doplní poradca z modelácie.',
      },
      pnOd29: {
        coJe: 'Denná dávka, ktorá začne po štyroch týždňoch neschopnosti. Prvý mesiac pokryje rezerva.',
        nazev: 'Pracovná neschopnosť od 29. dňa',
      },
      pnOd61: {
        coJe: 'Denná dávka až po dvoch mesiacoch. Najlacnejšia varianta — má zmysel, keď rezerva dva mesiace utiahne.',
        nazev: 'Pracovná neschopnosť od 61. dňa',
      },
      pnPlus: {
        coJe: 'Denná dávka s miernejšími podmienkami — plní aj v situáciách, ktoré základná varianta vylučuje.',
        nazev: 'Pracovná neschopnosť s rozšíreným plnením',
        pozn: 'Čo presne je zahrnuté a čo vylúčené, stojí v poistných podmienkach. Prejdite si ich s poradcom.',
      },
      smrtInvaliditaKombinace: {
        coJe: 'Jedna poistná suma, ktorá sa vyplatí podľa toho, čo príde skôr — úmrtie, alebo invalidita.',
        nazev: 'Smrť alebo invalidita v jednej sume',
        pozn: 'Kombinácia plní raz. Kto chce pokryť obe situácie v plnej výške, potrebuje dve sumy, nie jednu.',
      },
      smrtKlesajici: {
        coJe: 'Poistná suma rok po roku klesá, pretože klesá aj zostatok hypotéky a rastie váš majetok.',
        nazev: 'Smrť — klesajúca suma',
        pozn: 'Lacnejšia varianta. Sedí na dlh, ktorý splácate — nie na životnú úroveň rodiny, tá neklesá.',
      },
      smrtKonstantni: {
        coJe: 'Poistná suma zostáva rovnaká celý čas. Rodina dostane to isté v prvom aj v poslednom roku.',
        nazev: 'Smrť — konštantná suma',
      },
      smrtKratsiDoba: {
        coJe: 'Krytie na kratší čas, než je celá zmluva. Typicky do splatenia úveru alebo do dospelosti detí.',
        nazev: 'Smrť — krytie len na niekoľko rokov',
        pozn: 'Vlastný kratší čas appka nepočíta — pracuje s jedným horizontom pre celú analýzu. Sumu aj dobu doplní poradca.',
      },
      smrtUraz: {
        coJe: 'Plní len vtedy, keď je príčinou úraz. Preto je lacná — a preto to nesmie byť hlavné krytie: smrť z choroby z nej neplní vôbec.',
        nazev: 'Smrť následkom úrazu',
      },
      trvaleOd1: {
        coJe: 'Plní aj pri malom trvalom poškodení. Drahšia varianta, ale má najširší rozsah plnenia.',
        nazev: 'Trvalé následky úrazu od najnižších percent',
      },
      trvaleOd10: {
        coJe: 'Drobné poškodenia vynechá a plní až pri tých, ktoré vám naozaj zmenia život.',
        nazev: 'Trvalé následky úrazu od desiatich percent',
      },
      trvalePremium: {
        coJe: 'Čím vážnejší následok, tým vyššia výplata — pri ťažkých poškodeniach niekoľkonásobok dohodnutej poistnej sumy.',
        nazev: 'Trvalé následky úrazu s vyššou progresiou',
        pozn: 'Ako rýchlo progresia rastie a kde má strop, určuje poistná zmluva.',
      },
      zavazkyDluh: {
        coJe: 'Podiel na hypotéke a ostatných splátkach, ktoré nezmiznú. Je to zložka poistnej sumy pri smrti a pri invalidite, nie krytie navyše.',
        nazev: 'Záväzky — kto ich doplatí',
        pozn: 'Dlhy sa nekrátia v žiadnej variante krytia. Hypotéku nie je možné doplatiť na osemdesiat percent.',
      },
      zavazneKlesajici: {
        coJe: 'To isté krytie so sumou, ktorá sa rok po roku znižuje. Lacnejšie, ak zároveň rastie váš majetok.',
        nazev: 'Kritické choroby — klesajúca suma',
      },
      zavazneOpakovane: {
        coJe: 'Plní viac než raz — keď po vyliečení príde iná vymenovaná diagnóza, vyplatí sa znova.',
        nazev: 'Kritické choroby s opakovaným plnením',
        pozn: 'Celkový strop opakovaného plnenia určuje poistná zmluva.',
      },
      zavazneRozsirene: {
        coJe: 'To isté krytie, len s dlhším zoznamom diagnóz a miernejšími podmienkami plnenia. Čo presne je zahrnuté, stojí v zmluve.',
        nazev: 'Kritické choroby — rozšírený rozsah',
      },
      zavazneZakladni: {
        coJe: 'Jednorazová výplata pri diagnóze zo zoznamu v zmluve. Tie peniaze nie sú na účty — sú na to, aby ste mohli prestať pracovať a liečiť sa.',
        nazev: 'Kritické choroby — základný rozsah',
      },
      zavazneZeny: {
        coJe: 'Doplnok zameraný na choroby, ktoré sa týkajú len žien, a na komplikácie v tehotenstve.',
        nazev: 'Kritické choroby pre ženy',
      },
    },
    rokFew: '{n} roky',
    rokMany: '{n} rokov',
    rokOne: '{n} rok',
    rozdeleni: {
      balicek: 'Mesačný balíček:',
      chybiBalicekTuk: 'Balíček zatiaľ nie je vybraný',
      investice: 'Investícia',
      nadpis: 'Koľko na ochranu a koľko na investíciu',
      ochrana: 'Ochrana',
      podilOchrany: 'Na ochranu ide {pct} balíčka',
      popis: 'Balíček sa delí na dve časti. Posuvníkom si to môžete vyskúšať sami.',
      posuvnik: 'Koľko z balíčka ide na ochranu',
      prekrocenoText: 'Na investíciu by nezostalo nič a do balíčka chýba {chybi}. Buď sa zníži krytie, alebo sa zvýši suma, ktorú si klient odkladá.',
      prekrocenoTuk: 'Ochrana je drahšia ako balíček',
      skript: 'Máte {balicek} mesačne. Koľko z toho chcete dať na ochranu rodiny a koľko nechať investovať? Skúste to posunúť sami.',
      skriptNadpis: 'Veta na stretnutie',
      zdrojNeznamy: 'Cena ochrany zatiaľ nie je zadaná pri žiadnom riziku.',
      zdrojPosuvnik: 'Sumu ste nastavili posuvníkom.',
      zdrojSoucet: 'Zo súčtu cien pri rizikách: {soucet} · rizík s cenou: {pocet}',
      zpetNaSoucet: 'Späť na súčet cien',
    },
    rozpad: {
      cile: 'Ciele',
      deficitMes: 'Chýba mesačne',
      detiCelkem: 'Potreba rodiny',
      detiNepojistitelne: 'Z toho nepoistiteľné',
      detiSoucet: 'Súčet zmlúv',
      detiZavazne: 'Závažné choroby dieťaťa',
      diskont: 'Prepočítané na dnešok sadzbou',
      dluhy: 'Dlhy',
      karence: 'Rezerva pokryje (mesiacov)',
      naDite: 'Na jedno dieťa',
      nasobekPrijmu: 'Násobok ročného príjmu',
      prijem: 'Príjem',
      statniDavka: 'Štátna dávka',
      tnuSablona: 'Trvalé následky — šablóna',
      vydaje: 'Kapitál na výdavky do konca horizontu',
      vydajePoUdalosti: 'Výdavky po udalosti',
    },
    skupina: {
      deti: {
        nazev: 'Deti',
        otazka: 'Kto z vás dvoch by zostal doma, keby dieťa ochorelo na celý rok?',
        podtitul: 'Choroba dieťaťa je výpadok príjmu rodiča',
      },
      invalidita: {
        nazev: 'Invalidita',
        otazka: 'Koľko si myslíte, že vám štát mesačne dá, keby ste už nemohli pracovať?',
        podtitul: 'Keď už nemôžete pracovať — a žijete ďalej',
      },
      neschopnost: {
        nazev: 'Dlhá pracovná neschopnosť',
        otazka: 'Koľko vám štát pošle za mesiac na nemocenskej? Tipnite si.',
        podtitul: 'Mesiace doma, výdavky bežia ďalej',
      },
      pece: {
        nazev: 'Dlhodobá starostlivosť',
        otazka: 'Kto by sa o vás staral — a z čoho by ste tú starostlivosť platili?',
        podtitul: 'Keď sa sami neobslúžite',
      },
      smrt: {
        nazev: 'Smrť',
        otazka: 'Kto doplatí hypotéku, keď sa nevrátite domov?',
        podtitul: 'Čo zostane rodine a čo zostane banke',
      },
      uraz: {
        nazev: 'Úraz',
        otazka: 'Čo by sa u vás doma zmenilo, keby ste po úraze nemohli robiť svoju prácu ako predtým?',
        podtitul: 'Trvalé následky a dni liečenia',
      },
      zavazky: {
        nazev: 'Záväzky',
        otazka: 'Kto doplatí tých {castka}?',
        podtitul: 'Splátky, ktoré nezmiznú',
      },
      zavazne: {
        nazev: 'Závažné choroby',
        otazka: 'Keby vám zajtra povedali diagnózu — z čoho by ste žili ten rok, keď sa chcete len liečiť?',
        podtitul: 'Diagnóza, po ktorej sa liečite mesiace až roky',
      },
    },
    smlouva: {
      dlouhodoba: {
        nadpis: 'Poistka je na roky',
        odstoupeni: 'Odstúpenie krátko po podpise',
        odstoupeniText: 'Krátko po uzavretí môžete od zmluvy odstúpiť aj bez udania dôvodu. Lehotu stanovuje zákon a nájdete ju v zmluve.',
        preruseni: 'Keď prestanete platiť',
        preruseniText: 'Čo sa stane, určujú poistné podmienky.',
        text: 'Zmysel dáva dlhodobo, nie na pár mesiacov.',
        ukonceni: 'Keď zmluvu ukončíte',
        ukonceniDusledek: 'V prvých rokoch, kým sa spláca vstupný poplatok, môžete pri ukončení dostať späť málo alebo nič.',
        ukonceniText: 'Môžete. Krytie končí dňom ukončenia. Čo dostanete späť, určujú poistné podmienky.',
        znovu: 'Nová zmluva neskôr znamená nový zdravotný dotazník — podľa veku a zdravia v tom čase.',
      },
      dotaznik: {
        nadpis: 'Zdravotný dotazník: pravdivo a úplne',
        podpis: 'Nepodpisujte nič, čomu nerozumiete.',
        spolu: 'Prejdeme ho spolu, otázku po otázke. Čomu nerozumiete — aj pre jazyk — na to sa opýtajte.',
        text: 'Nepravdivá alebo neúplná odpoveď môže znamenať, že poisťovňa nezaplatí alebo zaplatí menej — aj po rokoch platenia.',
      },
      investice: {
        dny: 'zvyčajne do {dny} dní',
        dnyPodleSmlouvy: 'Presnú lehotu nájdete v zmluve.',
        dostupne: 'Peniaze k dispozícii',
        nadpis: 'Investičná časť sa dá meniť',
        pozastavit: 'Pozastaviť',
        pozastavitText: 'na čas prestať investovať',
        pridat: 'Pridať',
        pridatText: 'vyššia platba alebo vklad navyše',
        ubrat: 'Ubrať',
        ubratText: 'výber časti peňazí',
      },
      nadpis: 'Ako funguje zmluva',
      oci: 'Zmluva',
      platba: {
        investice: 'Investícia',
        investiceText: 'Má hodnotu a dá sa z nej brať. Kedy a ako, určuje zmluva.',
        nadpis: 'Platba má dve časti',
        ochrana: 'Ochrana',
        ochranaText: 'Cena za krytie. Nevracia sa — ako povinné zmluvné poistenie auta.',
      },
      vyluky: {
        nadpis: 'Kedy poisťovňa neplatí',
        text: 'Každá zmluva má výluky — prípady, keď poisťovňa neplní. Sú v poistných podmienkach a prejdeme ich spolu.',
      },
    },
    souhrn: {
      cenaMesic: 'Cena za mesiac',
      cenaNezadana: 'Cenu zadá poradca z modelácie',
      cenaUTemat: 'Cena je zatiaľ pri {s} z {z} tém.',
      nadpis: 'Súhrn',
      osoba: 'Osoba',
      pozn: 'Cenu a konkrétne riešenie potvrdí poradca podľa ponuky poisťovne.',
      preskoceno: 'Preskočené',
      probrano: 'Prebrané',
      sCenou: 'S cenou',
      vybrano: 'Vybrané',
      zbyva: 'Zostáva',
    },
    spolecne: {
      let: 'rokov',
      nezadano: 'nezadané',
      podtitulek: 'Od príjmu cez riziká k dvom číslam: čo rodina dostane, keď sa niečo stane — a čo zostane, keď nie.',
      rezimKlient: 'Ukázať klientovi',
      rezimPoradce: 'Späť k poradcovi',
      sekce: 'Životné poistenie',
      titulek: 'Analýza pre Vietnamcov',
      ukazka: 'Ukážkový klient',
      ukazkaJmeno: 'Ukážka',
      ukazkaZnacka: 'Ukážkové čísla na nácvik schôdzky — nie sú to údaje klienta, ktorý tu sedí.',
      vycistit: 'Nový klient',
      zaDen: '/ deň',
      zaMesic: '/ mesiac',
      zpet: 'Späť na nástroje',
    },
    stav: {
      doplniPoradce: 'Chýba vstup. Doplní ho poradca — nedopočítavame.',
      jeSlozka: 'Je to zložka poistnej sumy pri smrti a pri invalidite, nie krytie navyše.',
      kombinace: 'Kombinácia plní raz. Skladá sa z: {rizika}',
      neumimeSpocitat: 'Toto krytie aplikácia nepočíta — sumu doplní poradca z modelácie.',
    },
    stop: {
      bezBalicku: 'Vyberte balíček, alebo napíšte vlastnú sumu.',
      bezCastky: 'Doplňte sumu.',
      bezCenyOchrany: 'Cena ochrany zatiaľ nie je známa — doplňte ju pri rizikách, alebo ju nastavte posuvníkom.',
      bezHorizontu: 'Vyberte, do koľkých rokov sa má počítať.',
      bezKapitalu: 'Bez modelovej hodnoty investície sa renta nepočíta.',
      bezKatalogu: 'Katalóg rizík sa nenačítal.',
      bezPoplatku: 'Vstupný poplatok investície nie je zadaný.',
      bezPrijmu: 'Doplňte čistý mesačný príjem — bez neho sa balíčky nedajú vypočítať.',
      bezRizik: 'Zatiaľ nie je vybrané žiadne riziko.',
      bezVeku: 'Doplňte vek klienta a cieľový vek.',
      bezVydaju: 'Doplňte mesačné výdavky — inak nevieme, koľko naozaj zostáva.',
      cilovyVekNizsi: 'Cieľový vek {vekCilovy} je nižší ako dnešný vek {vekDnes} — vyberte neskorší.',
      pctMimoRozsah: 'Odkladať sa dá {min} až {max} percent príjmu.',
      poplatekMimoRozsah: 'Vstupný poplatok mimo rozsahu — obvykle {min} až {max} % z cieľovej sumy.',
      rokyMimoRozsah: 'Počítať sa dá na {min} až {max} rokov.',
      vynosMimoRozsah: 'Očakávaný výnos musí byť medzi 0 a {max} percentami ročne.',
    },
    tvar: {
      klesajici: 'klesajúce',
      konstantni: 'konštantné',
    },
    varovani: {
      balicekNadVolne: 'Balíček {pct} % je o {chybi} vyšší ako to, čo dnes zostáva. Nie je to zákaz — hľadanie peňazí je práca poradcu.',
      cenaChybiUNekterych: 'Pri {pocet} vybraných rizikách nie je zadaná cena — v súčte chýba.',
      denniCenaJenPodPrahem: 'Denná cena na osobu je nad {prah} — ako predajná veta sa nezobrazuje, len ako informácia.',
      ochranaNadBalicek: 'Ochrana je o {chybi} drahšia ako celý balíček — na investíciu nezostáva nič.',
      poplatekNadObvykly: 'Poplatok {pct} % je mimo obvyklé pásmo {min}–{max} % z cieľovej sumy.',
      poplatekNesplacenyVHorizontu: 'V zadanom horizonte sa poplatok celý nesplatí.',
      poplatekNezadan: 'Vstupný poplatok nie je zadaný — číslo je hrubé, bez poplatku.',
      splatkyNadPolovinu: 'Splátky prerástli polovicu príjmu — čísla treba dotiahnuť ručne.',
      splatkyNadRozpocet: 'Splátky úverov spotrebujú viac, ako po odkladaní zostáva — pravidlo na túto domácnosť nesedí.',
      vlastniNadPrijem: 'Zadaná suma je vyššia ako celý mesačný príjem — nie je to preklep?',
      vynosMimoScenare: 'Výnos {vynos} % nie je jeden z troch modelových scenárov (4 / 7 / 9 %).',
      zadnaCenaZadana: 'Cena nie je zadaná ani pri jednom vybranom riziku — cenu doplní poradca.',
    },
    vstupy: {
      bezJmena: 'Klient',
      bezPartnera: 'Bez partnera',
      deti: 'Počet detí',
      detiHint: 'Deti, ktoré domácnosť živí.',
      diteJmeno: 'Meno dieťaťa',
      diteN: '{n}. dieťa',
      diteVek: 'Vek dieťaťa',
      domacnost: 'Domácnosť',
      dvojice: '{a} a {b}',
      forma: 'Forma príjmu',
      formaOsvc: 'SZČO',
      formaZamestnanec: 'Zamestnanec',
      jistina: 'Istina záväzkov',
      jistinaHint: 'Koľko ešte zostáva doplatiť — hypotéka a ďalšie úvery spolu.',
      jistinaZbyva: 'Zostávajúca istina všetkých úverov',
      jmenoOsoby: 'Meno',
      klient: 'Klient',
      klientka: 'Klientka',
      manzel: 'Manžel',
      manzelka: 'Manželka',
      muz: 'Muž',
      nadpis: 'Koho modelujeme',
      oci: 'Vstupy',
      partnerHint: 'Partnera robí meno, nie príjem. Bez mena sa s jeho príjmom nepočíta.',
      podnadpis: 'Osem údajov a ide sa na vec. Zvyšok doplníme, až na to príde reč.',
      podporaRodine: 'Posiela rodičom / rodine mesačne',
      pohlavi: 'Pohlavie',
      pohlaviHint: 'Ovplyvňuje rizikovú sadzbu, nie oslovenie.',
      prijem: 'Čistý príjem mesačne',
      prijemHint: 'Koľko naozaj príde na účet.',
      souhrnNadpis: 'Modelácia pre',
      vek: 'Vek',
      vekCil: 'Vek finančnej nezávislosti',
      vekCilHint: 'Dokedy sa odkladá. Od tej chvíle má zarábať portfólio, nie klient.',
      vydaje: 'Výdavky domácnosti mesačne',
      vydajeHint: 'Vrátane splátok úverov — všetko, čo z účtu odíde.',
      vydajeVcSplatek: 'Výdavky domácnosti mesačne vrátane splátok úverov',
      zena: 'Žena',
    },
    vysledek: {
      bezKrytiStitek: 'Bez zadaného krytia: {pocet}',
      chybiKryti: 'Pri preberaných rizikách chýba krytie (počet: {pocet}). Kým tam suma nie je, riziko sa v plnení neukáže.',
      hodnotaInvestice: 'Hodnota investičnej časti v modeli',
      hodnotaPopis: 'vložené do investícií {castka}',
      iddKratce: 'Modelový výnos nie je garantovaný a nejde o prísľub návratnosti zaplateného poistného.',
      iddText: 'Vľavo je krytie, ktoré poradca zadal, vpravo modelový vývoj investičnej časti. Obe čísla stoja samostatne: modelový výnos nie je garantovaný a nejde o prísľub návratnosti zaplateného poistného. Záver je na klientovi, konkrétne riešenie potvrdí poradca.',
      iddTuk: 'Dve samostatné čísla',
      nescitajiSe: 'Riziká sa neplnia spoločne, preto sa sumy nesčítajú.',
      nestaloNadpis: 'Čo zostane na konci',
      nestaloOci: 'Keby sa nič nestalo',
      ochranaZaplatite: 'Za ochranu zaplatíte za {roky}',
      ochranaZaplatiteBezRoku: 'Za ochranu zaplatíte celkom',
      poradceNadpis: 'Pre poradcu',
      poradcePozn: 'Čísla nespájajte do jednej vety. Nechajte klienta, aby si záver urobil sám.',
      renta: 'Modelová mesačná renta z tejto sumy',
      rentaPozn: 'Renta pri bezpečnom čerpaní {sazba} ročne. Modelový výpočet, nie garantovaná výplata.',
      rizikoBezNazvu: 'Riziko bez názvu',
      staloNadpis: 'Čo rodina dostane',
      staloOci: 'Keby sa niečo stalo',
      staloPodnadpis: 'Po jednotlivých rizikách, ktoré ste vybrali:',
      staloZdroj: 'Sumy sú z krytia, ktoré ste zadali pri rizikách. Riziká sa neplnia spoločne, preto sa nesčítajú.',
      zadnaRizika: 'Zatiaľ nie je vybrané žiadne riziko so zadaným krytím.',
    },
    zaRokFew: 'za {n} roky',
    zaRokMany: 'za {n} rokov',
    zaRokOne: 'za {n} rok',
  },
  /* BLOK:izp END */
  /* BLOK:prodejKit START — generuje scratchpad/slovnik.py, ručně needitovat */
  prodejKit: {
    namitky: {
      analyza: {
        mamPoradce: {
          n: 'Už mám svojho poradcu.',
          o: 'To je dobre, nič meniť nemusíte. Analýza vám ukáže, ako na tom dnes ste, a s výsledkom môžete pokojne zájsť aj za ním.',
        },
        nechciNicKupovat: {
          n: 'Nechcem si nič kupovať.',
          o: 'Rozumiem. Dnes nič nepodpisujete — ukážem vám čísla, a či s nimi niečo urobíte, rozhodnete len vy.',
        },
        nemamCas: {
          n: 'Nemám na to čas.',
          o: 'Rozumiem, čas je vzácny — koľko ho dnes máte? Prejdeme len to podstatné a zvyšok dohodneme inokedy.',
        },
        partner: {
          n: 'Musím to prebrať s partnerom.',
          o: 'Určite, týka sa to vás oboch. Stretneme sa nabudúce spolu, nech partner počuje to isté čo vy?',
        },
        prijmyNereknu: {
          n: 'Príjmy vám hovoriť nebudem.',
          o: 'Chápem, je to vaše rozhodnutie. Stačí približný rozsah — a čo nevyplníme, zostane prázdne, nič si nedomýšľam.',
        },
        procToChcete: {
          n: 'Prečo to všetko potrebujete vedieť?',
          o: 'Bez vašich čísel by som vám radil naslepo. Na čo odpovedať nechcete, to preskočíme.',
        },
      },
      jenPoradce: 'vidí len poradca',
      kontext: {
        analyza: 'Analýza',
        pojisteni: 'Poistenie',
      },
      pojisteni: {
        drahe: {
          n: 'Je to drahé.',
          o: 'Chápem, rozpočet poznáte najlepšie vy. Môžeme znížiť poistné sumy tam, kde výpadok ustojíte z rezervy — a nahlas si povieme, o aké krytie tým prídete.',
        },
        mamPojisteni: {
          n: 'Poistenie už mám.',
          o: 'To je dobre — započítame ho, nech neplatíte dvakrát za to isté. Pozrieme sa do zmluvy, koľko vyplatí a či kryje aj invaliditu, nielen úmrtie?',
        },
        manzel: {
          n: 'Musím sa poradiť s manželom / manželkou.',
          o: 'Určite, je to rozhodnutie vás oboch. Stretneme sa nabudúce spolu, nech vidí rovnaké čísla ako vy — kedy by vám to vyhovovalo?',
        },
        nechciSeVazat: {
          n: 'Nechcem sa viazať na dlho.',
          o: 'Rozumiem — zmluvu môžete ukončiť, len v prvých rokoch, kým sa spláca vstupný poplatok, môžete dostať späť málo alebo nič. Dlhodobo dáva zmysel preto, že cena aj prijatie sa riadia vekom a zdravím v deň uzavretia, a zdravie sa spätne dokúpiť nedá.',
        },
        nicSeMiNestane: {
          n: 'Mne sa nič nestane.',
          o: 'Prajem vám to a najskôr máte pravdu. Nepoisťujem to, čo je pravdepodobné, poisťujem to, čo by bolo nezvratné — koľko mesiacov by rodina vydržala, keby sa to predsa len stalo?',
        },
        rozmyslim: {
          n: 'Rozmyslím si to.',
          o: 'Jasné, je to rozhodnutie na roky a nikam sa neponáhľame. Len nech viem, čo vám poslať — chcete si rozmyslieť, či to riziko riešiť, alebo koľko doň dať?',
        },
      },
      titul: 'Námietky',
    },
    ram: {
      brana: 'Tento krok ešte nie je hotový.',
      dalsi: 'Ďalej',
      hotovo: 'Hotovo',
      hotovyKrok: 'hotovo',
      klavesy: '→ alebo medzerník: ďalej · ←: späť · Esc: koniec',
      klient: 'Klient',
      krok: 'Krok {n} / {celkem}',
      poradce: 'Poradca',
      prejitNa: 'Krok {n}: {nazev}',
      prezentace: 'Prezentácia',
      rozbalit: 'Rozbaliť',
      skryt: 'Skryť',
      tahak: 'Ťahák',
      tip: 'Tip',
      zavrit: 'Zavrieť prezentáciu',
      zpet: 'Späť',
    },
    souhlas: {
      ano: 'Áno',
      ne: 'Nie',
      nezadano: 'Nezadané',
      pozdeji: 'Neskôr',
      poznamka: 'Poznámka (nepovinná)',
      vymazat: 'Vymazať odpoveď',
      zapsano: 'Zapísané {kdy}',
    },
  },
  /* BLOK:prodejKit END */
  /* BLOK:planPojistne START — generuje scratchpad/slovnik.py, ručně needitovat */
  planPojistne: {
    budouci: 'v budúcnosti {castka} — zatiaľ sa nepočíta',
    driveNe: 'Klient skôr povedal, že zabezpečenie riešiť nechce — plán poistné neodpočítava.',
    nadPrebytek: 'Poistenie {cena} stojí viac ako mesačný prebytok {prebytek} — na ciele nezostáva nič.',
    nezadana: 'Cena poistenia nezadaná — plán s ňou nepočíta.',
    nula: 'Cena poistenia 0 — z prebytku sa nič neodpočítava.',
    odmitnuto: 'Klient zabezpečenie príjmu zatiaľ nechce.',
    prebytekBezPrijmu: 'Mesačný prebytok zatiaľ nevieme — v analýze chýbajú príjmy. Doplňte ich, alebo rovno zapíšte sumu, ktorú ste si s klientom odsúhlasili.',
    segment: 'Poistenie',
    tokPrebytek: 'Prebytok po poistení',
    zToho: 'z toho poistenie {pojisteni} · na ciele {naCile}',
  },
  /* BLOK:planPojistne END */
  /* BLOK:analyzaProdej START — generuje scratchpad/slovnik.py, ručně needitovat */
  analyzaProdej: {
    cas: {
      ano: 'Áno, má čas',
      drivejsiZapis: 'Skorší zápis',
      potvrzeno: 'Klient potvrdil 45 minút',
    },
    cesta: {
      dnes: 'DNES',
      popis: 'Ciele naskočia postupne, ako bude plynúť čas',
      prehrat: 'Prehrať',
      preskocit: 'Preskočiť',
      vek: '{n} rokov',
      za: 'o {n} rokov',
      znovu: 'Prehrať znova',
    },
    dedictvi: {
      druh: 'Typ',
      druhJine: 'Iné',
      druhNemovitost: 'Nehnuteľnosť po rodičoch',
      nadpis: 'Budúci majetok (dedičstvo)',
      nepocita: 'v budúcnosti — zatiaľ sa nepočíta',
      panel: 'Budúci majetok',
    },
    forma: {
      jiny: 'Iný zdroj',
      majitel: 'Majiteľ firmy',
      osvc: 'SZČO',
      zamestnanec: 'Zamestnanec',
    },
    majetek: {
      nefinPod: 'nehnuteľnosti, firma',
    },
    oceneni: {
      do: 'do',
      ebitda: 'Ročný prevádzkový zisk (EBITDA)',
      ebitdaPopis: 'Zisk pred úrokmi, daňami a odpismi — nie zisk pred zdanením.',
      horni: 'Horná hranica',
      majetkove: 'Majetkovo',
      nasobek: 'Násobok',
      nezadano: 'nezadané',
      od: 'od',
      otevrit: 'Pomocník ocenenia',
      pouzit: 'Použiť ako hodnotu',
      spodni: 'Spodná hranica',
      stred: 'Stred',
      substance: 'Koľko by stálo firmu celú vybaviť',
      upozorneni: 'Orientačný odhad, nie znalecký posudok.',
      vynosove: 'Výnosovo',
      ztrata: 'Pri nulovom alebo zápornom zisku sa výnosovo neoceňuje.',
    },
    podklady: {
      dotaznik: 'Investičný dotazník',
      investicni: 'Investičné zmluvy',
      pojistne: 'Poistné zmluvy',
      uverove: 'Úverové zmluvy',
      vypisy: 'Výpisy z účtov',
    },
    prebytek: {
      nicNezbyva: 'Z príjmov dnes nič nezostáva — voľné cash flow je {castka}.',
    },
    predstaveni: {
      jakText: 'Dnes len spoznám vašu situáciu a ciele. Návrh prinesiem nabudúce — rozhodnutie je vždy na vás.',
      jakTitul: 'Ako pracujem',
      kdoText: 'Moju registráciu v registri {dohled} si môžete verejne overiť.',
      kdoTitul: 'Kto som',
      kicker: 'Kým začneme',
      odmenaText: 'Za uzatvorenú zmluvu mi províziu platí finančná inštitúcia. Podrobnosti dostanete písomne pred podpisom.',
      odmenaTitul: 'Moja odmena',
    },
    prez: {
      dialog: 'Prezentácia analýzy',
      predstaveni: {
        q: 'Kým začneme: kto som a ako pracujem',
        tab: 'Predstavenie',
        tahak: 'Čo je pre vás dôležité vedieť o tom, ako pracujem?',
        tip: 'Register si klient môže overiť hneď v telefóne.',
      },
    },
    reference: {
      gdprPotvrzeno: '✓ Potvrdené {datum}',
      gdprText: 'Klient potvrdzuje, že kontakty odovzdáva so súhlasom odporúčaných osôb, alebo berie na vedomie, že ich poradca pri prvom oslovení informuje o zdroji a spracovaní osobných údajov podľa čl. 14 GDPR.',
      gdprTitul: 'GDPR súhlas:',
      tahak: '„Mám jednu prosbu. Ak Vám dnešné stretnutie dávalo zmysel, pošlete mi tip na dvoch-troch ľudí, ktorí teraz niečo riešia: bývanie, rodinu, prácu? Nemusíte ich presviedčať. Stačí meno a telefón a zavolám len raz.“',
    },
    rizika: {
      chybi: 'Chýba',
      chybiHorizont: 'roky pri cieľoch',
      chybiPozustalostni: 'pozostalostná dávka pre túto krajinu',
      chybiPrijem: 'príjem',
      chybiUdaje: 'Na výpočet chýba',
      chybiVydaje: 'nevyhnutné výdavky',
      kicker: 'Keby sa nedalo pracovať',
      krytiInvalidita: 'Krytie invalidity',
      krytiSmrt: 'Krytie úmrtia',
      mesicne: 'za mesiac',
      potrebujete: 'Potrebujete',
      poznamka: 'Model z vašich čísel, nie garancia. Štátne dávky sú odhad.',
      statDa: 'Štát dá',
      stavajici: 'Existujúce poistky · invalidita',
      zustane: 'Zostane príjem',
    },
    tabulky: {
      budouciPrijmyPopis: 'Príjem, ktorý pribudne o dva, tri alebo päť rokov. Plán s ním počíta pri rente.',
      zatimNic: 'Zatiaľ nič.',
    },
    tisk: {
      dalsiSchuzka: 'Ďalšie stretnutie',
      nadpis: 'Záver stretnutia',
      nezadano: 'nezadané',
      podklady: 'Podklady na doloženie',
      prebytek: 'Odsúhlasený mesačný prebytok',
      shrnutiJenJmeni: 'Zhrnutie našej analýzy: čisté imanie {jmeni}.',
    },
    vydaje: {
      podpora: 'Podpora rodičom / rodine',
    },
    zastava: {
      popis: 'Nehnuteľnosť po rodičoch môže zabezpečiť úver — len so súhlasom vlastníka. Nič sa tým neprepočítava.',
      titul: 'Možné zabezpečenie úveru',
      zvoleno: 'zvolené ako zabezpečenie',
      zvolit: 'zvoliť ako zabezpečenie',
    },
    zaver: {
      bezDat: 'Keď doplníme čísla, ukáže sa tu, čo riešiť.',
      diarPoPrezentaci: 'Zapísať termín do diára po prezentácii',
      diarPoPrezentaciAno: '✓ Diár sa otvorí po skončení prezentácie',
      model: 'Model z vašich čísel, nie garancia.',
      nadpis: 'Čo spolu riešime',
      rizikaNadpis: 'Zabezpečenie príjmu',
      rizikaText: '{jmeno}: pri invalidite chýba {castka} za mesiac.',
      terminOtevrit: 'Otvoriť stretnutie v diári',
      terminRadek: 'Ďalšie stretnutie: {kdy}',
      terminVAnalyze: 'zapísané v analýze',
      terminVDiari: 'v diári',
      vseOk: 'Z čísel teraz nič na riešenie nevyplýva.',
    },
  },
  /* BLOK:analyzaProdej END */
  /* BLOK:nastenkaGrafy START — generuje scratchpad/slovnik.py, ručně needitovat */
  nastenkaGrafy: {
    trychtyr: {
      otevrenychFew: 'otvorené',
      otevrenychMany: 'otvorených',
      otevrenychOne: 'otvorený',
      prumerDniFew: 'Ø {n} dni vo fáze',
      prumerDniMany: 'Ø {n} dní vo fáze',
      prumerDniOne: 'Ø {n} deň vo fáze',
    },
    vyvoj: {
      mesiceFew: '{n} mesiace',
      mesiceMany: '{n} mesiacov',
      mesiceOne: '{n} mesiac',
      obchodyFew: '{n} obchody',
      obchodyMany: '{n} obchodov',
      obchodyOne: '{n} obchod',
      popisGrafu: 'Vývoj obchodov: za {obdobi} {obchody}, {bj}, najviac v mesiaci {mesic}',
      slovoObchoduFew: 'obchody',
      slovoObchoduMany: 'obchodov',
      slovoObchoduOne: 'obchod',
    },
  },
  /* BLOK:nastenkaGrafy END */
  /* BLOK:analyzaPrezentace START — generuje scratchpad/slovnik.py, ručně needitovat */
  analyzaPrezentace: {
    chip: {
      bydleni: 'Bývanie',
      deti: 'Deti',
      dluhy: 'Dlhy',
      duchod: 'Dôchodok',
      investice: 'Investície',
      plan: 'Celkový plán',
      pojisteni: 'Poistenie',
      rezerva: 'Rezerva',
    },
    chybi: {
      a: 'a',
      castka: 'suma',
      castka4: 'sumu',
      horizont: 'horizont',
      horizont4: 'horizont',
      limity4: 'limity krytia',
      platba4: 'mesačnú platbu',
      pojistovna4: 'poisťovňu',
    },
    cislo: {
      mil: '{n} mil.',
      tis: '{n} tis.',
    },
    hlaska: {
      cashflowIncomplete: 'Voľné cashflow sa zatiaľ nedá vypočítať.',
      cashflowNic: 'Zatiaľ nie sú zadané príjmy ani výdavky.',
      cashflowPrijmy: 'Doplňte príjmy domácnosti.',
      cashflowVydaje: 'Doplňte bežné výdavky, aby sme mohli vypočítať voľné cashflow.',
      cilIncomplete: 'Cieľ je rozpracovaný. Doplňte {chybi}.',
      hypotekaIncomplete: 'Hypotéka je evidovaná. Doplňte zostatok a mesačnú splátku.',
      investiceIncomplete: 'Zmluva je evidovaná. Doplňte aktuálnu hodnotu alebo pravidelný vklad.',
      investiceIncompleteVice: 'Zmluvy sú evidované. Doplňte aktuálnu hodnotu alebo pravidelný vklad.',
      majetekNeuplny: 'Zatiaľ nie sú zadané: {chybi}. Čisté imanie je preto len orientačné a neúplné.',
      pojistkaIncomplete: 'Poistná zmluva je evidovaná. Doplňte {chybi}.',
      pojistkaIncompleteVice: 'Poistné zmluvy sú evidované. Doplňte {chybi}.',
      rezervaIncomplete: 'Pre výpočet rezervy doplňte: {chybi}.',
      rizikoOrientacni: 'Orientačný mesačný rozdiel medzi výdavkami rodiny a príjmom, ktorý by po výpadku zostal. Nie je to poistná potreba — tú dopočítame po započítaní rezerv, sociálnych dávok a existujúceho poistenia.',
      zavazkyEmpty: 'Nie sú evidované žiadne záväzky.',
      zavazkyIncomplete: 'Záväzok je evidovaný. Doplňte zostatok a mesačnú splátku.',
      zavazkyIncompleteVice: 'Záväzky sú evidované. Doplňte zostatky a mesačné splátky.',
    },
    horizont: {
      bezTerminu: 'Termín zatiaľ nie je stanovený',
    },
    krok: {
      cile: {
        q: 'Čo chcete dokázať? ČO / KEDY / KOĽKO',
        tab: 'Ciele',
      },
      hodnoty: {
        q: 'Čím sú pre vás peniaze dôležité?',
        tab: 'Hodnoty',
      },
      ocekavani: {
        q: 'Čo očakávate od dnešného stretnutia?',
        tab: 'Očakávania',
      },
      prijmy: {
        q: 'Koľko zarobíte a koľko zostane?',
        tab: 'Príjmy a výdavky',
      },
      rizika: {
        q: 'Čo môže plán ohroziť?',
        tab: 'Riziká',
      },
      rodina: {
        q: 'Koho dnes plánujeme?',
        tab: 'Rodina',
      },
      zavazky: {
        q: 'Čo dnes splácate a aké máte zmluvy?',
        tab: 'Záväzky a zmluvy',
      },
      zaver: {
        q: 'Poďme si to zhrnúť.',
        tab: 'Záver',
      },
      zdroje: {
        q: 'Aké máte zdroje pre svoje ciele?',
        tab: 'Zdroje',
      },
    },
    pasmo: {
      dlouhodoby: 'Dlhodobý',
      kratkodoby: 'Krátkodobý',
      strednedoby: 'Strednodobý',
    },
    pasmoPopis: {
      dlouhodoby: '10 rokov a viac',
      kratkodoby: 'do 3 rokov',
      strednedoby: '4–9 rokov',
    },
    platno: {
      cesta: {
        nadpis: 'Cesta života',
        orientacniPozn: 'Finančná nezávislosť je prepočítaná na kapitál cez 4 % pravidlo — metodika nie je schválená, číslo berte ako orientačné.',
        orientacniTitul: 'Prepočet renty na kapitál (4 % pravidlo) nie je schválená metodika — číslo je orientačné.',
      },
      citat: '„{text}“',
      hodnoty: {
        nadpis: 'Čo je pre vás dôležité',
        prazdno: 'Napíšte vľavo, čo pre klienta znamenajú peniaze…',
      },
      ocekavani: {
        cil: 'Mojím cieľom je overiť, **čo už dnes robíte dobre**, kde možno **prichádzate o peniaze** a čo prípadne **môžete robiť lepšie**.',
        nadpis: 'Čo od dneška očakávate',
        prazdno: 'Zapíšte vľavo klientove slová…',
      },
      prijmy: {
        poznamka503020: '50 / 30 / 20 je orientácia, nie záväzné pravidlo — reálne rozdelenie závisí od života rodiny.',
        rozdilNezadano: 'Rozdiel ukážeme, keď budeme mať vypočítaný prebytok aj sumu, ktorú klient odsúhlasil.',
      },
      rizika: {
        kino: 'Spustiť kino: Zabezpečenie rizík',
      },
      rodina: {
        cilKicker: 'Čo je dnes cieľom',
        cilText: 'Poďme spoločne **overiť, čo už robíte dobre** — a kde sa vo financiách dá **niečo zlepšiť**. Žiadne predávanie, len jasný obraz a odporúčanie.',
        nadpis: 'Rodina, pre ktorú plánujeme',
        prazdno: 'Vyplňte vľavo mená klientov a detí…',
      },
      zavazky: {
        dodaPozdeji: 'klient dodá neskôr: {n}',
        fixace: 'najbližšia fixácia {datum}',
        konec: 'koniec splácania {datum}',
        splatka: 'splátka {castka}',
      },
      zdroje: {
        bezKurzu: 'V súhrne nie je {n} položiek v cudzej mene — chýba k nim použiteľný kurz. Radšej ich neuvádzame, než by sme povedali číslo, ktoré nikto neoveril.',
        bezKurzuKat: '{n}× cudzia mena bez kurzu — nezapočítané',
      },
    },
    pole: {
      bonusy: 'Bonusy ročne',
      cas: 'Čas',
      cilCo: 'ČO — popis cieľa',
      cilCoPh: 'Napr. väčšie bývanie',
      cilKdy: 'KEDY — o koľko rokov',
      cilKolik: 'KOĽKO — cieľová suma',
      cilTyp: 'Typ cieľa',
      coDodat: 'Čo má dodať klient',
      dalsiSchuzka: 'Ďalšie stretnutie',
      datum: 'Dátum',
      doslovne: 'Doslovný zápis…',
      formaKlient: 'Forma príjmu — klient {n}',
      katOpf: 'Investície (PF / ETF / akcie)',
      klientEmail: 'Klient {n} — e-mail',
      klientJmeno: 'Klient {n} — meno',
      klientN: 'Klient {n}',
      klientTelefon: 'Klient {n} — telefón',
      mamDnes: 'Mám dnes',
      navrh: 'Návrh',
      nezbytne: 'Nevyhnutné mesačné výdavky',
      obvykle: 'Obvyklé mesačné výdavky',
      ocekavani: 'Čo klient očakáva (jeho slová)',
      pasivni: 'Pasívne príjmy',
      penize: 'Čo pre klienta znamenajú peniaze? (jeho slová)',
      penizePh: 'sloboda, istota, pokoj, čas s rodinou…',
      poznPrijmy: 'Poznámka k príjmom',
      predvyplnitZCrm: 'Kliknutím predvyplníte údaje z karty v CRM',
      refTelefon: 'Telefón / kontakt',
      refVztah: 'Vzťah / poznámka',
      vlastniPh: 'napr. výpis z dôchodkového sporenia',
      vlastniPolozka: 'Vlastná položka',
      vydajePozn: 'Splátky sú v záväzkoch — nezapočítavajte ich druhýkrát. Nevyhnutné výdavky sú minimum pre prípad výpadku príjmu.',
      zDomacnosti: 'Z domácnosti:',
    },
    riziko: {
      evidovano: 'Evidované',
      nezadano: 'Nezadané',
      proverit: 'Preveriť',
      vyreseno: 'Vyriešené',
    },
    role: {
      dite: {
        m: 'Syn',
        z: 'Dcéra',
      },
      klient: {
        m: 'Klient',
        z: 'Klientka',
      },
      manzel: {
        m: 'Manžel',
        z: 'Manželka',
      },
      partner: {
        m: 'Partner',
        z: 'Partnerka',
      },
    },
    sablona: {
      c1: 'Povinná likvidná rezerva',
      c2: 'Bývanie / rekonštrukcia',
      c3: 'Vzdelanie pre deti / štart do života',
      c4: 'Finančná nezávislosť',
      d1: 'Dedičstvo',
      f1: 'Firma / podnikanie',
      kz1: 'Kapitálové životné poistenie',
      kz2: 'Investičné životné poistenie',
      n1: 'Byt / rodinný dom',
      n2: 'Komerčné priestory',
      n3: 'Pozemky / lesy / polia',
      n4: 'Auto / vozidlá',
      n5: 'Cennosti (hodinky, umenie, zbierky…)',
      n6: 'Zlato a drahé kovy',
      o1: 'Fondy/ETF akciové',
      o2: 'Fondy/ETF dlhopisové',
      o3: 'Fondy/ETF peňažného trhu',
      o4: 'Fondy/ETF realitné a iné',
      o5: 'Jednotlivé akcie',
      o6: 'Korporátne dlhopisy',
      o8: 'Kryptomeny',
      pj1: 'Rizikové životné poistenie',
      pj2: 'Úrazové poistenie',
      pj3: 'Poistenie nehnuteľnosti / domácnosti',
      pj4: 'Poistenie zodpovednosti',
      pj5: 'Povinné zmluvné poistenie / havarijné',
      pj6: 'Poistenie právnej ochrany',
      pz1: 'Staré penzijné pripoistenie',
      pz2: 'Doplnkové penzijné sporenie',
      pz3: 'Dlhodobý investičný produkt',
      r1: 'Poistenie nehnuteľnosti / stavby',
      r2: 'Poistenie domácnosti',
      r3: 'Poistenie zodpovednosti',
      r4: 'Povinné zmluvné poistenie',
      r5: 'Havarijné poistenie',
      s1: 'Stavebné sporenie',
      u1: 'Termínovaný vklad',
      u2: 'Sporiaci účet',
      u3: 'Bežný účet',
      u4: 'Hotovosť pod vankúšom',
      u5: 'Cudzie meny',
      zb1: 'Hypotekárny úver / úver na bývanie',
      zb2: 'Spotrebiteľské úvery',
      zb3: 'Lízing',
      zb4: 'Kreditky',
      zo1: 'Podnikateľský úver',
      zo2: 'Revolvingový úver',
    },
    smluvFew: '{n} zmluvy',
    smluvMany: '{n} zmlúv',
    smluvOne: '{n} zmluva',
    tab: {
      bydleni: {
        celkem: 'Celkové záväzky',
        konec: 'Koniec splácania',
        mesicne: 'Mesačné splátky',
        nadpis: 'Bývanie',
        nejblizsi: 'Najbližšia fixácia',
        pocet: 'Úverov',
      },
      investicni: {
        celkem: 'Súčasná hodnota',
        mesicne: 'Pravidelné vklady',
        nadpis: 'Investičné zmluvy',
        nejblizsi: 'Najbližšie výročie',
        pocet: 'Produktov',
      },
      ostatni: {
        celkem: 'Ostatné úvery',
        mesicne: 'Mesačné splátky',
        nadpis: 'Ostatné úvery',
        nejblizsi: 'Najbližšia splatnosť',
        pocet: 'Úverov',
      },
      pojistky: {
        mesicne: 'Mesačné poistné',
        nadpis: 'Poistky',
        nejblizsi: 'Najbližšie výročie',
        pocet: 'Zmlúv',
      },
    },
    tahak: {
      cile: {
        say1: 'Pozrime sa na vaše strategické ciele v štruktúre ČO – KEDY – KOĽKO.',
        say2: 'Čo budete potrebovať financovať? Kedy peniaze potrebujete? Koľko bude cieľ stáť?',
        say3: 'Ak klient nespomenie sám, vždy overte: bývanie, budúcnosť detí a finančnú nezávislosť.',
        tip: 'Pri cieli, ktorý klient podceňuje, pustite Kino — ukáže mu to číslo namiesto presviedčania.',
      },
      hodnoty: {
        say1: 'Ak klient povie napríklad sloboda, opýtajte sa: Čo pre vás znamená sloboda?',
        say2: 'Čo ďalšie vám napadne? Prečo je to pre vás dôležité práve teraz?',
        say3: 'Mostík: Ak vám finančný plán zaistí {slovaKlienta}, bude to pre vás správne riešenie?',
        tip: 'Nepýtajte sa na sumy. Tu ide o dôvod, nie o čísla.',
      },
      ocekavani: {
        say1: 'Čo očakávate od dnešného stretnutia?',
        say2: 'Zopakujte klientove slová a nadviažte: Mojím cieľom je overiť, čo už dnes robíte dobre, kde možno prichádzate o peniaze a čo prípadne môžete robiť lepšie.',
        tip: 'Zapisujte doslova. Klientove vlastné slová použijete v závere aj na ďalšom stretnutí.',
      },
      prijmy: {
        say1: 'Ďalším dôležitým zdrojom na naplnenie vašich cieľov sú vaše príjmy.',
        say2: 'Podľa zadaných čísel vám vychádza približne {castka}. Koľko ste skutočne a dlhodobo ochotní používať na váš finančný plán?',
        tip: 'Odsúhlasený prebytok je klientovo číslo, nie vaše. Radšej nižšie a udržateľné.',
      },
      rizika: {
        say1: 'V rámci finančného plánu sa pozrieme aj na vaše zaistenie — čo máte dnes, čo kryje a čo nie.',
        say2: 'Overíme, či sa dá ušetriť alebo poistiť múdrejšie, a ukážeme, ako bude zaistenie vyzerať v celom pláne: rodina, ciele, rezerva.',
        tip: 'Nehodnoťte a nestrašte. Len zaznamenajte stav a čo je potrebné preveriť.',
      },
      rodina: {
        say1: 'Po telefóne sme sa dohodli, že budeme mať 45 minút. U mňa sa nič nezmenilo. Len si chcem overiť, že aj vy počítate približne so 45 minútami.',
        say2: 'Najskôr si len overím základné údaje o vás a vašej rodine.',
        tip: 'Čas si potvrďte hneď na začiatku — potom sa nikto nepozerá na hodinky.',
      },
      zavazky: {
        say1: 'Dôležitou informáciou pre naplnenie vašich cieľov sú záväzky a zmluvy, ktoré už dnes máte.',
        say2: 'Najskôr sa pozrieme na hypotéky a ďalšie úvery, potom na existujúce investičné, penzijné a poistné zmluvy.',
        tip: 'Dátum konca fixácie a výročie zmluvy sú najcennejšie údaje celého stretnutia — bez nich sa návrh nedá načasovať.',
      },
      zaver: {
        say1: 'Napadá vám niečo dôležité, na čo som sa vás zabudol opýtať?',
        say2: 'Teraz máme potrebné údaje na spracovanie vašej finančnej stratégie a finančného plánu.',
        say3: 'Na ďalšom stretnutí vám ukážeme: čo odporúčame, koľko to bude stáť, v akom poradí jednotlivé kroky urobíme a ako plán povedie k vašim cieľom.',
        tip: 'Nekonkretizujte riešenie. Dnes sa dohaduje len termín a podklady.',
      },
      zdroje: {
        say1: 'Teraz už poznáme vaše ciele. Poďme sa pozrieť na zdroje, ktoré na ich naplnenie máte k dispozícii.',
        tip: 'Pýtajte sa po kategóriách, nie všeobecne — inak klient na polovicu zabudne.',
      },
    },
    typCile: {
      auto: 'Auto',
      bydleni: 'Bývanie',
      deti: 'Budúcnosť detí',
      investice: 'Investície',
      nezavislost: 'Finančná nezávislosť',
      ostatni: 'Ostatné ciele',
      podnikani: 'Podnikanie',
      podnikatelsky: 'Podnikateľský úver',
      rekonstrukce: 'Rekonštrukcia',
      rezerva: 'Rezerva',
      spotrebitelsky: 'Spotrebiteľský úver',
      uver: 'Úver',
    },
    vydajKat: {
      bydleni: 'Bývanie (nájom / SVB / fond opráv)',
      deti: 'Deti, škola, krúžky',
      doprava: 'Doprava / auto / MHD',
      dovolena: 'Dovolenka (mesačný priemer)',
      energie: 'Energie (elektrina, plyn, voda)',
      jidlo: 'Jedlo a domácnosť',
      ostatni: 'Ostatné',
      pojisteni: 'Poistenie (mimo splátok)',
      predplatne: 'Predplatné a služby',
      telekom: 'Telefón, internet, TV',
      volnyCas: 'Voľný čas, koníčky, reštaurácie',
      zdravi: 'Zdravie, lieky, drogéria',
    },
    zaver: {
      bezTerminu: 'Termín ďalšieho stretnutia zatiaľ nemáme dohodnutý. Hneď ako si ho dohodneme, prejdeme si pripravený plán spoločne.',
      sTerminem: 'Plán pripravím a prejdeme si ho spoločne na ďalšom stretnutí {kdy}.',
      vHodin: '{datum} o {cas}',
    },
  },
  /* BLOK:analyzaPrezentace END */
  /* BLOK:planKlient START — generuje scratchpad/slovnik.py, ručně needitovat */
  planKlient: {
    letFew: '{n} roky',
    letMany: '{n} rokov',
    letOne: '{n} rok',
    metodika: 'Riešenie cieľov: reálne výnosy nad infláciu podľa tried aktív (akcie {akcie} / dlhopisy {dluhopisy} / hotovosť {cash} % p.a., s postupným znižovaním rizika k cieľu). Poistné sumy: kapitálová metóda @ 4 % reálne. Sociálne dávky (vdovský, sirotský spolu za rodinu, invalidný dôchodok) sú ORIENTAČNÝ ODHAD zo šablóny — nie prísľub štátu; poradca ich overí. Poradca má posledné slovo.',
    shrnuti: {
      podtitul: 'Tri hrnce hore, riadok na cieľ. Čísla sú tie isté ako v Návrhu riešenia.',
      rozdavej: 'Rozdávaj zo zdrojov priamo v tabuľke, kým pri oboch hrncoch nesvieti „Zostáva 0“.',
    },
    tahak: 'Ťahák pre poradcu',
    uvod: {
      dobraCile: 'Prvá je dobrá: [[tvoje ciele sa podarí naplniť.]]',
      dobraPlan: 'Dobrá správa: [[máš plán.]]',
      lepsiCesta: 'Tá ešte lepšia: ideš k nim [[bezpečnejšou cestou]].',
      lepsiDrive: 'Tá ešte lepšia: rentier môžeš byť [[už za {za}]] — o {o} skôr.',
      rentaNa: 'Renta je zatiaľ na [[{pct} %]] — a presne vidíme, čo s tým urobiť.',
      rentaNezadana: 'Cieľ renty zatiaľ nie je zadaný.',
    },
  },
  /* BLOK:planKlient END */
  /* BLOK:denniCrm START — generuje scratchpad/slovnik.py, ručně needitovat */
  denniCrm: {
    chybaPopis: 'Dáta nezmizli — len sa teraz nepodarilo spojiť so serverom.',
    klientiNenacteno: 'Klientov sa nepodarilo načítať',
    nacitam: 'Načítavam…',
    obchodyNenacteno: 'Obchody sa nepodarilo načítať',
    offlineKopie: 'offline kópia z {cas}',
    offlineKopieBezCasu: 'offline kópia',
    zavritZalozku: 'Zavrieť záložku {nazev}',
    zkusitZnovu: 'Skúsiť znova',
  },
  /* BLOK:denniCrm END */
  /* BLOK:nastrojeBezSlibu START — generuje scratchpad/slovnik.py, ručně needitovat */
  nastrojeBezSlibu: {
    namitkaRizikoOdpoved: 'Úplne chápem. Riziko sa dá znížiť, ale výnos nad infláciou vám vopred nikto zaručiť nemôže. Ukážem vám konzervatívne možnosti — sporiaci účet, dlhopisové fondy, konzervatívny dôchodkový fond — a pri každej, čo od nej reálne čakať. Vyberiete si, čo je vám blízke.',
    pojisteniVkladu: 'Ochrana vkladov',
  },
  /* BLOK:nastrojeBezSlibu END */
  /* BLOK:penzeBezKavy START — generuje scratchpad/slovnik.py, ručně needitovat */
  penzeBezKavy: {
    aRentu: 'a rentu',
    podleModeluVDuchodu: 'Podľa modelu máte na dôchodok nasporené',
  },
  /* BLOK:penzeBezKavy END */
  /* BLOK:funnelReference START — generuje scratchpad/slovnik.py, ručně needitovat */
  funnelReference: {
    sablona: '[Sem vložte skutočnú referenciu so súhlasom klienta]',
    titul: 'Referencie (iba skutočné, so súhlasom klienta)',
  },
  /* BLOK:funnelReference END */
  /* BLOK:ikony START — generuje scratchpad/slovnik.py, ručně needitovat */
  ikony: {
    aktivita: {
      cesta: 'Cesta',
      dopis: 'List',
      email: 'E-mail',
      hotovo: 'Hotovo',
      misto: 'Miesto',
      narozeniny: 'Narodeniny',
      obchod: 'Obchod',
      pripominka: 'Pripomienka',
      radar: 'Radar príležitostí',
      schuzka: 'Stretnutie',
      servis: 'Servisný termín',
      sms: 'SMS',
      telefonat: 'Telefonát',
      udalost: 'Udalosť',
      ukol: 'Úloha',
      whatsapp: 'WhatsApp',
    },
    cil: {
      auto: 'Auto',
      budoucnostDeti: 'Budúcnosť detí',
      bydleni: 'Bývanie',
      investice: 'Investície',
      nezavislost: 'Finančná nezávislosť',
      obecny: 'Cieľ',
      ostatni: 'Ostatné ciele',
      podnikani: 'Podnikanie',
      podnikatelskyUver: 'Podnikateľský úver',
      rekonstrukce: 'Rekonštrukcia',
      rezerva: 'Rezerva',
      spotrebitelskyUver: 'Spotrebiteľský úver',
      uver: 'Úver',
    },
    produkt: {
      analyza: 'Analýza',
      hypoteka: 'Hypotéka',
      investice: 'Investície',
      jine: 'Iné',
      penzijko: 'Dôchodkové sporenie',
      pojisteni_auta: 'Poistenie auta',
      pojisteni_majetek: 'Poistenie majetku',
      pojisteni_odpovednost: 'Poistenie zodpovednosti',
      pojisteni_ostatni: 'Ostatné poistenie',
      pojisteni_zivot: 'Životné poistenie',
      rezerva: 'Rezerva',
      stavebni: 'Stavebné sporenie',
      uver: 'Úver',
      zdravotni: 'Zdravotné poistenie',
    },
    profil: {
      dynamicky: 'Dynamický',
      konzervativni: 'Konzervatívny',
      vyvazeny: 'Vyvážený',
    },
    riziko: {
      dite: 'Poistenie dieťaťa',
      hospitalizace: 'Hospitalizácia',
      invalidita: 'Invalidita',
      odskodne: 'Denné odškodné',
      pn: 'Pracovná neschopnosť',
      rodicovska: 'Rodičovská',
      smrt: 'Úmrtie',
      stari: 'Staroba',
      tnu: 'Trvalé následky úrazu',
      zavazne: 'Závažné ochorenia',
    },
    stav: {
      chyba: 'Chyba',
      info: 'Informácia',
      ok: 'V poriadku',
      pozor: 'Pozor',
    },
  },
  /* BLOK:ikony END */
  /* BLOK:vzorkovna START — generuje scratchpad/slovnik.py, ručně needitovat */
  vzorkovna: {
    ikony: {
      doplnky: 'Doplnkové kresby',
      doplnkyPopis: 'Čo lucide nemá. Prevzaté aj s licenciou.',
      mena: 'Mena podľa krajiny tenanta',
      velikosti: 'Veľkosť a vybraný stav',
      vybrany: 'Vybraný',
    },
    motivNahledu: 'Náhľad v motíve',
    motivy: {
      kino: 'Plátno prezentácie',
      popis: 'Prehľad cieľov a rezervy',
      titulek: 'Finančný plán',
      tlacitko: 'Uložiť',
    },
    nadpis: 'Vzorkovňa',
    obsah: 'Obsah vzorkovne',
    pismo: {
      cisla: 'Čísla pod sebou',
      jazyky: 'Päť jazykov, jedno písmo',
      nadpisUkazka: 'Finančný plán domácnosti',
      nadpisy: 'Nadpisy',
      stupnice: 'Stupnica veľkostí',
      ukazka: 'Rezerva pokrýva šesť mesiacov výdavkov domácnosti.',
    },
    prazdny: {
      akce: 'Naplánovať stretnutie',
      kratky: 'Zatiaľ žiadne úlohy.',
      text: 'Na dnes nemáte naplánované žiadne stretnutie.',
    },
    sekce: {
      ikony: 'Ikony v čipoch',
      motivy: 'Šesť motívov',
      pismo: 'Písmo',
      prazdny: 'Prázdny stav',
      stavy: 'Stavy',
      tokeny: 'Farby',
      vystup: 'Výstupná sada',
    },
    skupina: {
      aktivity: 'Aktivity',
      cile: 'Ciele',
      produkty: 'Produkty',
      profily: 'Investičný profil',
      rizika: 'Riziká',
      stavy: 'Stavy',
    },
    stavy: {
      bezTextu: 'Bez textu',
      chyba: 'Zmeny sa nepodarilo uložiť',
      ikona: 'Ikona',
      info: 'Údaje z minulého stretnutia',
      ok: 'Rezerva pokrýva 6 mesiacov výdavkov',
      pozor: 'Chýba krytie invalidity',
      stitek: 'Štítok',
      tecka: 'Bodka',
    },
    stitek: 'Design lab · interný náhľad',
    tokeny: {
      akcent: 'Akcent',
      kategorie: 'Kategórie',
      plochy: 'Plochy',
      stavy: 'Stavy',
      text: 'Text',
    },
    uvod: 'Písmo, farby, ikony a stavy na jednom mieste. Obrazovky si berú len to, čo je tu.',
    zpet: 'Späť',
  },
  /* BLOK:vzorkovna END */
  /* BLOK:novyCrm START — generuje scratchpad/slovnik.py, ručně needitovat */
  novyCrm: {
    akce: {
      otevrit: 'Otvoriť: {nazev}',
      otevritVAppce: 'Otvoriť v súčasnom CRM',
      vPrototypu: 'V prototype zatiaľ nejde',
      zkusitZnovu: 'Skúsiť znova',
      zobrazitDalsi: 'Zobraziť ďalších {n}',
      zrusitFiltr: 'Zrušiť filter',
    },
    aktivita: {
      dopis: 'List',
      email: 'E-mail',
      schuzka: 'Stretnutie',
      telefonat: 'Telefonát',
      udalost: 'Udalosť',
      ukol: 'Úloha',
    },
    analyza: {
      bezAnalyzy: 'Analýza zatiaľ nie je. Založte ju v súčasnej appke, tu sa potom ukáže celá.',
      chybaBloku: 'Túto časť analýzy sa nepodarilo spočítať',
      chybi: {
        cil: 'Cieľ „{nazev}“: doplňte {co}',
        dalsiNaRade: 'na rade',
        dalsichFew: 'a ďalšie {n} v appke',
        dalsichMany: 'a ďalších {n} v appke',
        dalsichOne: 'a ďalší {n} v appke',
        deti: 'Riadok dieťaťa bez mena a dátumu narodenia sa do výpočtov nepočíta',
        faze: 'Časti analýzy',
        fazeSouhrn: 'Hotovo {n} z {celkem} častí analýzy',
        hotovo: 'Analýza je vyplnená, nič nechýba',
        nadpis: 'Čo chýba vyplniť',
        nezbytne: 'Nevyhnutné výdavky — bez nich nie je rozdelenie 50 / 30 / 20 ani potreba zabezpečenia',
        partner: 'Príjem partnera je vyplnený, ale partner v analýze nie je (chýba meno alebo dátum narodenia)',
        rezerva: 'Účty a hotovosť — bez nich sa nedá spočítať rezerva',
        zadnaPolozka: 'Žiadny konkrétny údaj nechýba — dokončite zvyšné časti analýzy',
        zajisteni: 'Zabezpečenie príjmu sa nedá spočítať — chýba: {co}',
        zavaznost: {
          nizka: 'Drobnosť',
          stredni: 'Doplniť',
          vysoka: 'Dôležité',
        },
      },
      chybiUdajuFew: 'Chýbajú {n} údaje',
      chybiUdajuMany: 'Chýba {n} údajov',
      chybiUdajuOne: 'Chýba {n} údaj',
      cile: {
        chybi: 'chýba {co}',
        mesicne: '{mena}/mes.',
        pocetFew: '{n} ciele podľa termínu',
        pocetMany: '{n} cieľov podľa termínu',
        pocetOne: '{n} cieľ podľa termínu',
        uverem: 'úverom',
      },
      doplnitVAppce: 'Doplniť v appke',
      faze: {
        cile: 'Ciele',
        hodnoty: 'Hodnoty',
        prijmy: 'Príjmy a výdavky',
        rizika: 'Riziká',
        uvod: 'Úvod',
        zavazky: 'Záväzky',
        zdroje: 'Zdroje',
      },
      majetek: {
        budouci: 'Dedičstvo a budúci majetok',
        budouciStitek: 'v budúcnosti · zatiaľ sa nepočíta',
        cisteJmeni: 'čisté imanie (majetok dnes − dlhy)',
        dluhy: 'dlhy (zostatky)',
        dnes: 'majetok dnes',
        dsti: 'splátky sú {pct} % príjmov',
        fixace: 'najbližšia fixácia {datum}',
        nadpis: 'Majetok a dlhy',
        prazdno: 'Majetok ani dlhy zatiaľ nie sú zapísané',
        splatky: 'splátky {castka} mesačne',
        uveruFew: '{n} úvery',
        uveruMany: '{n} úverov',
        uveruOne: '{n} úver',
        vysokeZadluzeni: 'Vysoké zadlženie (nad 40 % príjmov)',
      },
      menaJina: 'Analýza je vedená v {mena}',
      menaStara: 'Staršia analýza bez meny — čísla sú v {mena}',
      nadpis: 'Analýza',
      penize: {
        chybiDo20: 'Do ideálu 20 % chýba {castka} mesačne',
        nadpis: 'Príjmy a výdavky',
        odklada: 'Odkladá {pct} % príjmov · ideál 20 % = {castka}',
        rozpadBezNezbytnych: 'Rozdelenie 50 / 30 / 20 sa ukáže, keď budú zadané nevyhnutné výdavky.',
        splneno: 'Odkladá ideálnych 20 % príjmov a viac',
      },
      rezerva: {
        bezVydaju: 'Bez nevyhnutných výdavkov sa nedá spočítať, na koľko mesiacov rezerva vystačí',
        castkaPopisek: 'na účtoch a v hotovosti',
        dnes: 'Rezerva dnes',
        doporuceno: 'Odporúčané {n} mesiacov',
        grafPopis: 'Rezerva vystačí na {n} mesiacov z odporúčaných {cil}',
        jednotka: 'mes.',
        mesicuPopisek: 'na toľko mesiacov nevyhnutných výdavkov a splátok vystačí',
        nadpis: 'Rezerva',
        nezapsana: 'Účty a hotovosť zatiaľ nie sú zapísané',
        stav: {
          reserve_low: 'Pod 3 mesiace',
          reserve_mid: 'Doplniť do 6 mesiacov',
          reserve_ok: 'Aspoň 6 mesiacov',
        },
      },
      rodina: {
        bezDeti: 'bez detí',
        detiFew: '{n} deti',
        detiMany: '{n} detí',
        detiOne: '{n} dieťa',
        dospelychFew: '{n} dospelí',
        dospelychMany: '{n} dospelých',
        dospelychOne: '{n} dospelý',
        nadpis: 'Rodina a profil',
        prazdno: 'Rodina v analýze zatiaľ nie je vyplnená',
        prijem: 'príjem {castka} mesačne',
        vekNezadany: 'vek nezadaný',
      },
      upraveno: 'Upravené {datum}',
      upravitVAppce: 'Upraviť v appke',
      zacit: 'Začať analýzu v appke',
      zajisteni: {
        bezDiry: 'Mesačný príjem je pokrytý',
        dira: 'Mesačne chýba {castka}',
        domacnost: 'Krytie za domácnosť',
        mesicne: 'Pri invalidite: rodina potrebuje {potreba} mesačne · zostane {zustane} · štát dá {stat}',
      },
      zpetNaKlienta: 'Späť na klienta',
    },
    cas: {
      dnes: 'dnes',
      predFew: 'pred {n} dňami',
      predMany: 'pred {n} dňami',
      predOne: 'pred {n} dňom',
      vcera: 'včera',
    },
    cesta: {
      hotovo: 'hotovo',
      krokZ: '{n} z {celkem}',
      kroky: {
        analyza: 'Analýza',
        plan: 'Plán',
        predstaveni: 'Predstavenie',
        realizace: 'Realizácia',
        servis: 'Servis',
      },
      nadpis: 'Cesta klienta',
      vseHotovo: 'Všetky kroky hotové',
      ziskani: 'Získanie · pred prvým stretnutím',
      ztraceno: 'Stratené',
    },
    chyba: {
      aktivity: 'Poznámky a úlohy sa nepodarilo načítať',
      analyza: 'Analýzu sa nepodarilo načítať',
      analyzaTvar: 'Údaje analýzy majú neočakávaný tvar',
      cile: 'Plán sa nepodarilo načítať',
      fixace: 'Fixácie sa nepodarilo načítať',
      klient: 'Klienta sa nepodarilo načítať',
      klienti: 'Klientov sa nepodarilo načítať',
      obchody: 'Obchody sa nepodarilo načítať',
      obecne: 'Dáta sa nepodarilo načítať',
      pipeline: 'Súhrn obchodov sa nepodarilo načítať',
      plan: 'Návrh riešenia sa nepodarilo načítať',
      radar: 'Radar príležitostí sa nepodarilo načítať',
      rizika: 'Potrebu krytia sa nepodarilo spočítať',
      ukoly: 'Diár sa nepodarilo načítať',
    },
    diar: {
      aDalsichFew: 'a ďalšie {n}',
      aDalsichMany: 'a ďalších {n}',
      aDalsichOne: 'a ďalšia {n}',
      agenda: 'Agenda dňa',
      akciFew: '{n} aktivity',
      akciMany: '{n} aktivít',
      akciOne: '{n} aktivita',
      bezCasu: 'Bez času',
      celyDen: 'celý deň',
      dalsiTyden: 'Ďalší týždeň',
      drive: 'Skôr',
      drivePocet: 'Skôr: {n}',
      hodiny: 'Hodiny dňa',
      hotovo: 'hotovo',
      minut: '{n} min',
      naDnes: 'Dnes',
      naplanovat: 'Naplánovať v diári',
      nejblizsi: 'najbližšie',
      nicPoTerminu: 'Nič po termíne',
      odskrtnout: 'Odškrtnúť ako hotové',
      otevrit: 'Otvoriť v diári',
      otevritPolozku: 'Otvoriť v diári',
      poTerminu: 'Po termíne',
      poTerminuPocetFew: '{n} po termíne',
      poTerminuPocetMany: '{n} po termíne',
      poTerminuPocetOne: '{n} po termíne',
      pozdeji: 'Neskôr',
      pozdejiPocet: 'Neskôr: {n}',
      prazdnoDen: 'Na tento deň nie je nič naplánované',
      prazdnoDnes: 'Dnes nemáte nič naplánované',
      predchoziTyden: 'Predchádzajúci týždeň',
      schuzekFew: '{n} stretnutia',
      schuzekMany: '{n} stretnutí',
      schuzekOne: '{n} stretnutie',
      souhrn: 'Súhrn dňa',
      souhrnPoTerminu: 'po termíne zo všetkých dní',
      souhrnSchuzky: 'stretnutia',
      souhrnUkoly: 'úlohy, hovory a e-maily',
      tyden: 'Týždeň',
      typ: {
        dopis: 'List',
        email: 'E-mail',
        poznamka: 'Poznámka',
        schuzka: 'Stretnutie',
        telefonat: 'Telefonát',
        udalost: 'Udalosť',
        ukol: 'Úloha',
      },
      ukoluFew: '{n} úlohy',
      ukoluMany: '{n} úloh',
      ukoluOne: '{n} úloha',
    },
    faze: {
      a1: 'Predstavenie',
      a2: 'Analýza',
      calling: 'Volanie',
      done: 'Dokončené',
      lead: 'Lead',
      lost: 'Stratené',
      p1: 'Finančný plán',
      p2: 'Prezentácia',
      servis: 'Servis',
      signed: 'Podpis',
    },
    fazeObchodu: {
      analyza: 'Analýza',
      cerpani: 'Čerpanie',
      podpis: 'Podpis',
      proces: 'V procese',
    },
    graf: {
      oblouk: {
        nastavit: 'Nastaviť plán v appke',
        nenastaveno: 'Plán nie je nastavený',
        popisek: 'Plnenie plánu BJ',
        zPlanu: '{bj} z {plan} BJ',
      },
      rozpad: {
        cile: 'Ciele',
        nezbytne: 'Nevyhnutné',
        zivotniStyl: 'Životný štýl',
      },
      trychtyr: {
        popis: 'Otvorené obchody podľa fázy',
      },
    },
    hlavicka: {
      hledat: 'Hľadať klienta ({zkratka})',
    },
    klient: {
      aktivity: {
        bezDalsiho: 'Ďalší krok nie je naplánovaný',
        dalsiKrok: 'Ďalší krok',
        diar: 'Otvoriť diár',
        nadpis: 'Poznámky a ďalší krok',
        naplanovat: 'Naplánovať v diári',
        napsat: 'Napísať poznámku',
        posledni: 'Posledné aktivity',
        zadne: 'Zatiaľ žiadne poznámky ani aktivity',
      },
      analyza: 'Analýza',
      bezAnalyzy: 'Analýza zatiaľ nie je. Bilancia, ciele a majetok sa ukážu, keď ju vyplníte.',
      bezUdaju: 'Vek ani mesto nie sú zadané',
      bilance: 'Bilancia',
      bilancePrazdna: 'Príjmy a výdavky zatiaľ nie sú vyplnené',
      cile: {
        bezCastkyFew: '{n} ciele bez sumy',
        bezCastkyMany: '{n} cieľov bez sumy',
        bezCastkyOne: '{n} cieľ bez sumy',
        bezNazvu: 'Cieľ bez názvu',
        bezTerminu: 'bez termínu',
        chybi: 'Chýba',
        cil: 'Cieľ',
        cilKlienta: 'cieľ {castka}',
        dalsichFew: 'a ďalšie {n} ciele v návrhu',
        dalsichMany: 'a ďalších {n} cieľov v návrhu',
        dalsichOne: 'a ďalší {n} cieľ v návrhu',
        definice: 'Už má = dnešné peniaze k termínu cieľa.',
        dnes: 'hneď',
        grafPopis: '{nazev}: už má {uzMa} z {cil}',
        jenBezCastkyFew: 'Ciele zatiaľ nemajú sumu ({n})',
        jenBezCastkyMany: 'Ciele zatiaľ nemajú sumu ({n})',
        jenBezCastkyOne: 'Cieľ zatiaľ nemá sumu ({n})',
        nadpis: 'Ciele',
        prazdno: 'Ciele zatiaľ nie sú zadané',
        regulace: 'Orientačný prehľad podľa plánu, nie ponuka.',
        renta: 'renta {castka} mesačne',
        uverem: 'vlastné zdroje k úveru',
        uzMa: 'Už má',
        vlastniZdroje: 'Vlastné zdroje',
        zaFew: 'o {n} roky',
        zaMany: 'o {n} rokov',
        zaOne: 'o {n} rok',
      },
      doplnitVAnalyze: 'Doplniť v analýze',
      kategorie: 'Kategória {k}',
      kontaktNezadany: 'Telefón ani e-mail nie sú zadané',
      krok: {
        analyza: 'Analýza',
        navrh: 'Návrh riešenia',
        plan: 'Plán',
        prezentace: 'Prezentácia',
      },
      majetek: {
        celkem: 'spolu',
        dluhy: 'Dlhy: {castka}',
        grafPopis: 'Majetok spolu {celkem}: {dily}',
        kategorie: {
          firma: 'Firma',
          kzp: 'Životné poistenie so sporením',
          nemovitosti: 'Nehnuteľnosti a autá',
          opf: 'Fondy a akcie',
          ostatni: 'Ostatné',
          penzijko: 'Dôchodkové sporenie',
          stavebko: 'Stavebné sporenie',
          ucty: 'Účty a hotovosť',
        },
        nadpis: 'Majetok',
        prazdno: 'Majetok zatiaľ nie je zapísaný',
      },
      nadpis: 'Klient',
      napsat: 'Napísať e-mail: {email}',
      nenalezen: 'Klient v CRM nie je — mohol byť zmazaný.',
      neuplnaData: 'Časť údajov analýzy má neočakávaný tvar',
      obchody: {
        bezBj: 'BJ nezadané',
        nadpis: 'Obchody klienta',
        novy: 'Nový obchod v appke',
        prazdno: 'Klient nemá otvorený obchod',
        vsechny: 'Všetky obchody',
      },
      otevritAnalyzu: 'Otvoriť analýzu',
      otevritNavrh: 'Otvoriť návrh riešenia',
      otevritPlan: 'Otvoriť plán',
      pokracovat: 'Pokračovať: {krok}',
      prijmy: 'príjmy mesačne',
      profil: 'Profil',
      regulace: 'Orientačný prehľad z analýzy, nie ponuka.',
      rizika: {
        chybi: {
          horizont: 'doba zabezpečenia',
          pozustalostni: 'dávky pre pozostalých',
          prijem: 'príjem',
          vydaje: 'nevyhnutné výdavky',
        },
        chybiCastka: 'do odporúčaného krytia chýba {castka}',
        domacnost: 'domácnosť',
        grafPopis: '{riziko}, {kdo}: dnešné zmluvy {kryti} z odporúčaného krytia {potreba}',
        invalidita: 'Invalidita',
        klient1: 'Klient',
        klient2: 'Partner',
        kryti: 'Dnešné zmluvy',
        krytiSpolecne: 'zmluva bez osoby — v analýze pri Rizikách v zmluvách vyberte, komu patrí',
        model: 'Odporúčané krytie vypočítala kalkulačka analýzy (kapitálová metóda) — model, nie ponuka. Plán ukazuje poistné sumy varianty zvolenej v Návrhu, preto sa môžu líšiť.',
        nadpis: 'Zabezpečenie príjmu',
        nelzeSpocitat: 'Potrebu krytia zatiaľ nejde spočítať. Chýba: {co}.',
        pokryto: 'pokryté',
        potreba: 'Odporúčané krytie',
        prazdno: 'Potreba krytia ani súčasné zmluvy zatiaľ v analýze nie sú',
        radek: 'Odporúčané krytie {potreba} · dnešné zmluvy {kryti}',
        smrt: 'Smrť',
      },
      splatky: 'splátky mesačne',
      vekFew: '{n} roky',
      vekMany: '{n} rokov',
      vekOne: '{n} rok',
      volneCf: 'voľné cash flow mesačne',
      vydaje: 'výdavky mesačne',
      zacitAnalyzu: 'Začať analýzu',
      zavolat: 'Zavolať: {cislo}',
      zpet: 'Späť na klientov',
    },
    klienti: {
      bezJmena: 'Bez mena',
      filtr: {
        faze: 'Fáza',
        kategorie: 'Kategória',
        produkt: 'Produkt',
        vse: 'Všetko',
      },
      hledat: 'Hľadať meno, telefón, e-mail…',
      hledatPopisek: 'Hľadať klienta',
      kpi: {
        bezKontaktu: 'Bez kontaktu 90+ dní',
        celkem: 'Spolu',
        podepsano: 'Podpísané tento mesiac',
        skupina: 'Rýchle filtre',
        vBehu: 'V behu',
      },
      nalezenoFew: 'Nájdení {n} klienti',
      nalezenoMany: 'Nájdených {n} klientov',
      nalezenoOne: 'Nájdený {n} klient',
      odebratFiltr: 'Zrušiť filter: {nazev}',
      odhad: 'odhad',
      otevrit: 'Otvoriť klienta: {jmeno}',
      popis: 'Zoznam klientov',
      prazdno: 'Zatiaľ tu nie sú žiadni klienti',
      pridat: 'Pridať v appke',
      seznam: 'Všetci klienti',
      skupina: {
        klient: 'Klient',
        proces: 'V procese',
        ziskani: 'Získavanie',
        ztraceno: 'Stratené',
      },
      sloupec: {
        akce: 'Otvoriť',
        bj: 'BJ',
        dalsiKrok: 'Ďalší krok',
        faze: 'Fáza',
        klient: 'Klient',
        kontakt: 'Posledný kontakt',
        produkty: 'Produkty',
      },
      vymazat: 'Vymazať hľadanie',
      zrusitVse: 'Zrušiť všetko',
    },
    legendaObchodu: {
      plna: 'Čerpá sa',
      srafa: 'Rozpracované',
      tecky: 'Záujem',
    },
    nastroje: {
      cekani: {
        cenaPopisek: 'o toľko menej bude mať v cieli, keď začne o {roky} neskôr',
        dohnat: 'Dohnať to znamená odkladať',
        grafPopis: 'Model: keď začne hneď, bude mať o {roky} {hned}; keď počká, {pozdeji}.',
        hned: 'Začne hneď',
        horizont: 'Cieľ je o',
        legendaModel: 'Bodkovane = modelový výpočet',
        letFew: '{n} roky',
        letMany: '{n} rokov',
        letOne: '{n} rok',
        mesicne: 'Mesačne investuje',
        mesicnePole: 'Mesačná suma',
        model: 'Model pri stálom výnose {pct} % ročne, bez poplatkov a daní — nie garancia. Pri výnose {od}–{do} % vychádza cena {nizsi} až {vyssi}.',
        nadpis: 'Cena za čakanie',
        neplatne: 'Odklad musí byť kratší ako doba do cieľa.',
        neposlano: 'Neposlané vklady',
        nominalne: 'Nominálne sumy, bez vplyvu inflácie',
        odklad: 'Začne neskôr o',
        otazka: 'Koľko klienta stojí, keď s pravidelným investovaním počká?',
        pasmo: 'Pásmo: výnos {od}–{do} %',
        pozdeji: 'Začne o {roky}',
        ukazka: 'Ukážka',
        uslyVynos: 'Ušlý výnos',
        vynos: 'Očakávaný výnos',
        vynosText: '{pct} % ročne',
        zaLetFew: 'o {n} roky',
        zaLetMany: 'o {n} rokov',
        zaLetOne: 'o {n} rok',
        zaMesic: 'mesačne',
      },
      dlazdice: {
        finMatematika: {
          nazev: 'Finančná matematika',
          popis: 'Úver, investícia a renta — dopočíta ktorúkoľvek hodnotu.',
        },
        funnely: {
          nazev: 'Knižnica funnelov',
          popis: 'Hotové funnely a skladač zadania.',
        },
        historicka: {
          nazev: 'Historická kalkulačka',
          popis: 'Ako by rástli peniaze klienta na skutočných trhoch od roku 1926.',
        },
        hypoteky: {
          nazev: 'Hypotéky',
          popis: 'Rozpracované hypotéky na jednom mieste.',
        },
        investicniStrategie: {
          nazev: 'Investičné stratégie',
          popis: 'Slávne stratégie a sila zloženého úročenia.',
        },
        investicniStudio: {
          nazev: 'Investičné štúdio',
          popis: 'Portfólio dnes a po návrhu, krízy a náklady.',
        },
        kalkulacky: {
          nazev: 'Kalkulačky',
          popis: 'Hypotéka, investícia a ďalšie rýchle výpočty.',
        },
        mapa: {
          nazev: 'Mapa klientov',
          popis: 'Klienti na mape a cesta na stretnutie.',
        },
        penze: {
          nazev: 'Dôchodková kalkulačka',
          popis: 'Koľko si klient nasporí na dôchodok a koľko pridá štát.',
        },
        provize: {
          nazev: 'Provízie',
          popis: 'Koľko BJ a peňazí prinesie obchod.',
        },
        radar: {
          nazev: 'Radar príležitostí',
          popis: 'Klienti s medzerou v zabezpečení alebo financiách.',
        },
      },
      novyStyl: 'Kalkulačka v novom štýle',
      proMe: 'Pre mňa',
      uStolu: 'Pre klienta pri stole',
    },
    nav: {
      diar: 'Diár',
      hlavni: 'Navigácia nového CRM',
      klienti: 'Klienti',
      nastroje: 'Nástroje',
      obchody: 'Obchody',
      poradce: 'Prihlásený poradca: {jmeno}',
      prehled: 'Prehľad',
      preskocit: 'Preskočiť na obsah',
      rezimSvetly: 'Prepnúť na svetlý režim',
      rezimTmavy: 'Prepnúť na tmavý režim',
      znacka: 'Nové CRM – prehľad',
      zpet: 'Späť do súčasného CRM',
      zpetKratce: 'Späť do CRM',
    },
    nazev: 'Nové CRM',
    nenalezeno: {
      akce: 'Späť na prehľad',
      nadpis: 'Stránka sa nenašla',
      text: 'Táto adresa v novom CRM nie je.',
    },
    obchody: {
      bezKlienta: 'Klient nezadaný',
      bezNazvu: 'Obchod bez názvu',
      dnyFew: 'Vo fáze {n} dni',
      dnyMany: 'Vo fáze {n} dní',
      dnyOne: 'Vo fáze {n} deň',
      dnyZkratka: '{n} d',
      fazeVyber: 'Fáza obchodu',
      kpi: {
        bjVBehu: 'BJ v behu',
        cekaPodpis: 'Čaká na podpis',
        pocetFew: '{n} obchody',
        pocetMany: '{n} obchodov',
        pocetOne: '{n} obchod',
        uzavreno: 'Uzavreté tento mesiac',
      },
      nicVeFazi: 'Nič v tejto fáze',
      novy: 'Nový obchod v appke',
      otevrit: 'Otvoriť obchod: {nazev}',
      prazdno: 'Zatiaľ tu nie sú žiadne rozpracované obchody',
      trychtyr: 'Obchody podľa fázy',
    },
    plan: {
      bezAnalyzy: 'Analýza zatiaľ nie je. Plán vznikne až z analýzy.',
      bezNavrhu: 'Návrh riešenia zatiaľ nie je uložený. Keď ho v appke uložíte, ukáže sa tu.',
      chybaBloku: 'Túto časť plánu sa nepodarilo vypočítať',
      chybaVypoctu: 'Plán sa nepodarilo vypočítať',
      cile: {
        bezCastky: 'Suma cieľa nie je zadaná — plnenie sa nedá vypočítať',
        bezHorizontu: 'Termín cieľa nie je zadaný — plnenie sa nedá vypočítať',
        chybi: 'chýba {castka}',
        dalsichFew: 'a ďalšie {n} ciele v Návrhu',
        dalsichMany: 'a ďalších {n} cieľov v Návrhu',
        dalsichOne: 'a ďalší {n} cieľ v Návrhu',
        dnes: 'dnes {pct}',
        grafPopis: '{nazev}: dnes {dnes}, s plánom {po} z cieľa {cil}',
        jednorazove: '{castka} jednorazovo',
        legendaChybi: 'chýba aj s plánom',
        legendaMa: 'má už dnes',
        legendaPlan: 'doplní plán',
        mesicne: '{castka} mesačne',
        nadpis: 'Plnenie cieľov',
        prazdno: 'V návrhu zatiaľ nie sú žiadne ciele',
        prepocetProfil: 'Vlastný profil cieľa — plnenie s ním vypočíta Návrh',
        prepocetRucni: 'Ručná mesačná suma — plnenie s ňou vypočíta Návrh',
        sPlanem: 's plánom {pct}',
        souhrn: 'S plánom splnené: {n} z {m}',
        splneno: 's plánom splnené',
        vlastniZdroje: 'z toho vlastné zdroje {castka}',
        zAnalyzy: 'upravené v Návrhu · z analýzy {castka} · {termin}',
      },
      kroky: {
        chybi: {
          majetkove: 'Majetkové poistenie — v Návrhu vyplňte a uložte kartu Poistenie majetku',
          rezerva: 'Rezerva — v analýze chýbajú nevyhnutné výdavky, cieľ rezervy bez nich nevznikne',
          zivotni: 'Životné poistenie — bez príjmov a výdavkov v analýze sa nedajú vypočítať poistné sumy',
        },
        chybiTitulek: 'Kroky, na ktoré chýba podklad:',
        hotovo: 'Hotovo',
        naRade: 'Na rade',
        nadpis: 'Najbližšie kroky realizácie',
        prazdno: 'Plán zatiaľ nemá kroky na realizáciu',
      },
      majetek: {
        grafPopis: 'Nasporené na ciele podľa plánu, v dnešných cenách: najviac {castka} v roku {rok}. Model, nie garancia.',
        legenda: 'bodky a prerušovane = model podľa plánu',
        model: 'Súčet nasporeného na ciele podľa plánu pri {vynos} výnose, v dnešných cenách (výnosy sú po odpočítaní inflácie) — model, nie garancia, výnos nie je zaručený. Keď cieľ dobehne, peniaze sa minú a krivka klesne.',
        nadpis: 'Vývoj majetku v čase',
        nula: 'Podľa plánu sa na ciele s termínom zatiaľ nič nesporí',
        prazdno: 'Plán zatiaľ nemá ciele s termínom',
        rada: 'Nasporené na ciele',
        rokVek: '{rok} · {vek}',
        vrchol: 'Najviac {castka} v roku {rok}',
      },
      nadpis: 'Plán',
      navrh: 'Návrh riešenia',
      ochrana: {
        bezCastek: 'Poistné sumy sa zatiaľ nedajú vypočítať — chýbajú príjmy alebo výdavky',
        castky: 'invalidita {invalidita} · smrť {smrt}',
        cenaDoplni: 'mesačne za domácnosť — cenu doplní poradca',
        cenaNeznama: 'Cena ochrany zatiaľ nie je známa',
        cenaNula: 'Cena od poradcu 0 — z prebytku sa nič neodpočítava',
        cenaPoradce: 'mesačne za domácnosť, cena od poradcu',
        cenaPoradceCast: 'mesačne, cena od poradcu — zatiaľ len časť ceny',
        nadpis: 'Ochrana rodiny',
        odhadOrientacne: '≈ {castka} mesačne — len orientačný odhad',
        odmitnuto: 'Klient zabezpečenie príjmu zatiaľ nechce',
        rozdil: 'Dnes platí {stara} → nové {nova} ({rozdil}). Stará zmluva sa ruší, plán odpočíta len rozdiel.',
        rucne: 'upravené poradcom',
        staraNeznama: 'Pri rušenej zmluve chýba platba — v rozdiele zatiaľ nie je odpočítaná.',
        varianta: 'Variant krytia v návrhu',
        zdroj: 'Poistné sumy varianty {varianta} z Návrhu. Odporúčané krytie v Analýze počíta kalkulačka analýzy, preto sa môže líšiť.',
      },
      otevritNavrh: 'Otvoriť Návrh v appke',
      prazdnaAnalyza: 'Analýza je prázdna — plán nemá z čoho počítať.',
      prezentace: 'Prezentácia',
      profil: 'Profil: {nazev}',
      regulace: 'Modelový plán z návrhu riešenia, nie ponuka. Výnos nie je zaručený.',
      rezerva: {
        bezCile: 'Cieľ rezervy sa nedá vypočítať — chýbajú výdavky',
        dopocetNezbytneFew: 'cieľ rezervy · {n} mesiace nevyhnutných výdavkov a splátok',
        dopocetNezbytneMany: 'cieľ rezervy · {n} mesiacov nevyhnutných výdavkov a splátok',
        dopocetNezbytneOne: 'cieľ rezervy · {n} mesiac nevyhnutných výdavkov a splátok',
        dopocetObvykleFew: 'cieľ rezervy · {n} mesiace bežných výdavkov a splátok',
        dopocetObvykleMany: 'cieľ rezervy · {n} mesiacov bežných výdavkov a splátok',
        dopocetObvykleOne: 'cieľ rezervy · {n} mesiac bežných výdavkov a splátok',
        jednorazove: 'doplní jednorazovo',
        mesicne: 'doplní mesačne',
        nadpis: 'Rezerva',
        plnaDnes: 'Naplnená už dnes',
        plnaSPlanem: 'S plánom naplnená',
        zadana: 'cieľ rezervy zadaný v analýze',
      },
      rozpocet: {
        cile: 'Ciele',
        jednorazove: 'Z úspor jednorazovo {prideleno} z {celkem}',
        legendaPlan: 'posiela plán',
        nadPrebytek: 'Poistné navyše je vyššie než prebytok — chýba {castka} mesačne',
        nadpis: 'Mesačný rozpočet plánu',
        ochranaNeznama: 'Cenu ochrany zatiaľ nezadal poradca — plán s ňou nepočíta',
        ochranaNula: 'Cena ochrany od poradcu je 0 — nič sa neodpočítava',
        ochranaOdmitnuta: 'Klient zabezpečenie príjmu zatiaľ nechce — neodpočítava sa',
        pojistneNove: 'Poistné {nova} je medzi povinnými platbami',
        pojistneZmena: 'Poistné medzi povinnými platbami: dnes {stara} → nové {nova} ({rozdil})',
        prebytek: 'prebytok mesačne — kam ide',
        prebytekNejisty: 'Z príjmov, výdavkov a splátok by vychádzalo {castka} mesačne — odsúhlasený prebytok overte v appke.',
        prebytekNezadany: 'Prebytok nie je zadaný',
        prebytekNula: 'Prebytok je nulový',
        prebytekPoPojistnem: 'prebytok po poistnom mesačne — kam ide',
        precerpano: 'Plán rozdeľuje viac, než je prebytok',
        renta: 'Investície na rentu',
        rezerva: 'Rezerva',
        vyrovnano: 'Všetky peniaze majú úlohu',
        zadneZdroje: 'Plán nemá z čoho rozdeľovať — chýba prebytok aj voľné úspory.',
        zbyva: 'Zatiaľ bez úlohy',
      },
      ulozeno: 'Uložené {datum}',
      vynos: {
        optimisticky: 'Optimistický výnos',
        pesimisticky: 'Pesimistický výnos',
        realisticky: 'Realistický výnos',
      },
      vynosVeVete: {
        optimisticky: 'optimistickom',
        pesimisticky: 'pesimistickom',
        realisticky: 'realistickom',
      },
    },
    prehled: {
      dnes: {
        bezCasuFew: '{n} úlohy bez času',
        bezCasuMany: '{n} úloh bez času',
        bezCasuOne: '{n} úloha bez času',
        dalsichFew: 'A ešte {n} aktivity dnes',
        dalsichMany: 'A ešte {n} aktivít dnes',
        dalsichOne: 'A ešte {n} aktivita dnes',
        nadpis: 'Dnes',
        nejblizsiCas: 'Najbližšia aktivita o {cas}',
        nejblizsiNadpis: 'Najbližšie v diári',
        nicDnes: 'Dnes vás v diári už nič nečaká',
        otevritDiar: 'Otvoriť diár',
        poTerminuFew: '{n} po termíne',
        poTerminuMany: '{n} po termíne',
        poTerminuOne: '{n} po termíne',
        seznam: 'Ďalšie aktivity dnes',
      },
      klienti: {
        nadpis: 'Poslední klienti',
      },
      obchody: {
        bjVBehu: 'BJ v behu celkom',
        nadpis: 'Obchody v behu',
        prazdno: 'Žiadne rozpracované obchody',
      },
      pece: {
        bezKontaktu: 'Bez kontaktu',
        dalsichFew: 'a ďalší {n}',
        dalsichMany: 'a ďalších {n}',
        dalsichOne: 'a ďalší {n}',
        dniFew: '{n} dni',
        dniMany: '{n} dní',
        dniOne: '{n} deň',
        fixace: 'Koniec fixácie',
        konecSmlouvy: 'Koniec zmluvy',
        nadpis: 'Klienti na starostlivosť',
        prazdno: 'Žiadna fixácia do 120 dní a nikto bez kontaktu viac ako 90 dní',
        vyroci: 'Výročie zmluvy',
      },
      plan: {
        nadpis: 'Plán mesiaca',
      },
      provize: {
        bezPozice: 'Pozícia nezadaná',
        koef: '{koef} {mena} za BJ · pozícia {pozice}',
        koefVychozi: '{koef} {mena} za BJ (predvolené)',
        nadpis: 'Odhad provízie',
      },
      radar: {
        dalsiMezeryFew: '+{n} ďalšie medzery',
        dalsiMezeryMany: '+{n} ďalších medzier',
        dalsiMezeryOne: '+{n} ďalšia medzera',
        dalsichKlientuFew: 'a ďalší {n} klienti s medzerou',
        dalsichKlientuMany: 'a ďalších {n} klientov s medzerou',
        dalsichKlientuOne: 'a ďalší {n} klient s medzerou',
        kriticka: 'Kritická medzera',
        krok: 'Odporúčaný krok',
        nadpis: 'Radar príležitostí',
        otevrit: 'Otvoriť Radar v súčasnom CRM',
        prazdno: 'Žiadne otvorené príležitosti',
        skore: 'skóre {n}',
      },
    },
    produkt: {
      hypoteka: 'Hypotéka',
      investice: 'Investície',
      majetek: 'Majetok',
      penze: 'Dôchodok',
      uver: 'Úver',
      zp: 'Životné poistenie',
    },
    produktObchodu: {
      hypoteka: 'Hypotéka',
      investice: 'Investície',
      jine: 'Iné',
      koupe_nemovitosti: 'Kúpa nehnuteľnosti',
      penzijko: 'Dôchodkové sporenie',
      podnikatelsky_uver: 'Podnikateľský úver',
      pojisteni_auta: 'Poistenie auta',
      pojisteni_majetek: 'Poistenie majetku',
      pojisteni_zivot: 'Životné poistenie',
      prodej_nemovitosti: 'Predaj nehnuteľnosti',
      refinancovani: 'Refinancovanie',
      spotrebitelsky_uver: 'Spotrebiteľský úver',
      stavebni: 'Stavebné sporenie',
      uver: 'Úver',
    },
    prototyp: 'Prototyp · len na čítanie',
    pruvodce: {
      nadpis: 'Toto je návrh nového CRM',
      rozumim: 'Rozumiem',
      text: 'Dáta sú skutočné, len na čítanie. Vzhľad a poradie obrazoviek sa ešte môžu zmeniť.',
      zapis: 'Upravovať a zapisovať môžete ďalej v súčasnom CRM.',
    },
    stav: {
      fazeNezadana: 'Fáza nezadaná',
      nacitam: 'Načítavam…',
      nezadano: 'nezadané',
      nicNeodpovida: 'Filtru nič nezodpovedá',
      prazdno: 'Zatiaľ tu nič nie je',
      starsiData: 'Staršie dáta · {cas}',
    },
    termin: {
      dnes: 'dnes',
      poFew: 'po termíne {n} dni',
      poMany: 'po termíne {n} dní',
      poOne: 'po termíne {n} deň',
      zaFew: 'o {n} dni',
      zaMany: 'o {n} dní',
      zaOne: 'o {n} deň',
      zitra: 'zajtra',
    },
    zalozky: {
      analyza: 'Analýza',
      klient: 'Klient',
      nadpis: 'Sekcie klienta',
      plan: 'Plán',
      prezentace: 'Prezentácia',
      vAppce: 'otvorí súčasné CRM',
    },
    zastupny: {
      nadpis: 'Obrazovka sa pripravuje',
      text: 'Táto časť nového CRM sa ešte stavia. Zatiaľ ju nájdete v súčasnom CRM.',
    },
  },
  /* BLOK:novyCrm END */
  /* BLOK:vystup START — generuje scratchpad/slovnik.py, ručně needitovat */
  vystup: {
    bullet: {
      aria: {
        chybi: '{popisek}: potreba {potreba}, kryté {kryto}, chýba {chybi}.',
        kryto: '{popisek}: potreba {potreba}, kryté {kryto}. Pokryté.',
        nezadano: '{popisek}: potreba nezadaná.',
        neznameKryti: '{popisek}: potreba {potreba}, dojednané krytie nezadané.',
      },
      chybi: 'Chýba {castka}',
      krytiNezadane: 'Krytie nezadané',
      kryto: 'Kryté',
      nadRamec: 'Kryté, navyše {castka}',
      potreba: 'Potreba {castka}',
      potrebaNezadana: 'Potreba nezadaná',
      sjednano: 'Dojednané {castka}',
      stat: 'Štát {castka}',
    },
    cara: {
      aria: 'Projekcia na {roky}: stredný scenár {stred}, pásmo {od} až {do}.',
      ariaSrovnani: 'Pre porovnanie {popisek}: {hodnota}.',
      pasmo: 'Horší až lepší scenár',
      prazdno: 'Projekcia nezadaná',
      stred: 'Stredný scenár',
    },
    kobliha: {
      aria: 'Rozloženie {celkem}: {dily}.',
      celkem: 'Spolu',
      nezadano: 'Bez sumy: {polozky}',
      ostatni: 'Ostatné',
      prazdno: 'Nie je čo rozložiť',
    },
    kroky: {
      aktivni: 'práve tu',
      aria: 'Postup: krok {n} z {celkem}, {popisek}',
      ceka: 'čaká',
      hotovo: 'hotovo',
    },
    letFew: '{n} roky',
    letMany: '{n} rokov',
    letOne: '{n} rok',
    mesicne: 'mesačne',
    modelNeniGarance: 'Model, nie záruka. Skutočný výsledok môže byť vyšší aj nižší.',
    nezadano: 'nezadané',
    rezim: {
      nazev: 'Režim náhľadu',
      obrazovka: 'Obrazovka',
      papir: 'Papier',
      prezentace: 'Prezentácia',
    },
    splatka: {
      aria: 'Splátka {splatka} mesačne, {roky}. Celkovo zaplatíte {celkem}, z toho úrok {urok}.',
      ariaUrokNejdriv: 'Na začiatku ide väčšina splátky na úrok, ku koncu na istinu.',
      jistina: 'Istina',
      popisek: 'Splátka',
      prazdno: 'Úver nezadaný',
      rok: '{n}. rok',
      souhrn: 'Celkovo zaplatíte {celkem}, z toho úrok {urok}.',
      urok: 'Úrok',
    },
    tok: {
      aria: 'Kam idú peniaze: {toky}.',
      krok: '{z} → {do}: {castka}',
      krokKam: '{z} → {do}: {castka}, {kam}',
      nezadano: 'Bez sumy: {toky}',
      ostatni: 'Ostatné',
      prazdno: 'Žiadny tok peňazí',
    },
    ukazka: {
      bullet: 'Potreba vs. dojednané',
      cara: 'Projekcia s pásmom',
      d: {
        akcie: 'Akcie',
        analyza: 'Analýza',
        bezPlanu: 'Bez plánu',
        deti: 'Investícia pre deti',
        dluhopisy: 'Dlhopisy',
        dps: 'doplnkové dôchodkové sporenie',
        fondy: 'podielové fondy',
        hotovost: 'Hotovosť',
        hotovostTrida: 'Hotovosť',
        hypoteka: 'Splátka hypotéky',
        invalidita: 'Invalidita',
        jednorazove: 'Jednorazovo',
        mesicne: 'Mesačne',
        nemovitosti: 'Realitné fondy',
        nezbytne: 'Nevyhnutné výdavky',
        plan: 'Plán',
        pn: 'Pracovná neschopnosť',
        podminkyUveru: '{castka} · {roky} · úrok {sazba}',
        pojisteni: 'Poistenie',
        prebytek: 'Mesačný prebytok',
        predstaveni: 'Predstavenie',
        prijem: 'Čistý príjem',
        realizace: 'Realizácia',
        renta: 'Renta',
        rezerva: 'Rezerva',
        sPlanem: 'S plánom',
        servis: 'Servis',
        smrt: 'Smrť',
        sporiciUcet: 'sporiaci účet',
        stavebko: 'Splátka úveru zo stavebného sporenia',
        styl: 'Životný štýl',
        volne: 'Voľné peniaze',
        zlato: 'Zlato',
      },
      kdeBullet: 'Riziká a rezerva v prezentácii plánu',
      kdeCara: 'S plánom vs. bez plánu',
      kdeKobliha: 'Portfólio najviac v piatich triedach',
      kdeKroky: 'Cesta klienta',
      kdeSplatka: 'Cieľ hypotéka — namiesto Historickej kalkulačky',
      kdeStavebko: 'Zvyšok cieľa ako úver zo stavebného sporenia',
      kdeTok: 'Kam idú peniaze — jednorazovo a mesačne zvlášť',
      kdeVelkeCislo: 'Hlavné číslo kalkulačky alebo snímky',
      kdeVlozeno: 'Investícia pre deti: jednorazovo aj pravidelne, potom fáza čerpania',
      kdeVodopad: 'Príjem → výdavky → voľné peniaze',
      kobliha: 'Prstencový graf',
      kroky: 'Krokový ukazovateľ',
      navrh: 'Náhľad na odsúhlasenie — v pláne, prezentácii ani tlači sa zatiaľ nič nevymenilo.',
      prehrat: 'Prehrať znova',
      splatka: 'Splátka a úrok',
      tok: 'Tok peňazí',
      ucebniCisla: 'Učebné čísla, žiadny klient.',
      velkeCislo: 'Veľké číslo',
      vlozeno: 'Vložené vs. zhodnotenie',
      vodopad: 'Vodopád',
    },
    vlozeno: {
      aria: 'Za {roky} nasporíte {hodnota}: vložené {vlozeno}, zhodnotenie {zhodnoceni}.',
      ariaCerpani: 'Potom {roky} čerpanie po {castka} mesačne.',
      cerpani: 'Čerpanie',
      cerpaniVeta: 'Potom {roky} čerpanie po {castka} mesačne',
      pasmo: 'Pásmo scenárov',
      pasmoVeta: 'Horší až lepší scenár: {od} – {do}',
      popisek: 'Za {roky}',
      prazdno: 'Vklad nezadaný',
      vlozeno: 'Vložené',
      zhodnoceni: 'Zhodnotenie',
    },
    vodopad: {
      aria: '{kroky}. Výsledok {vysledek}.',
      ariaNelze: '{kroky}. Výsledok nemožno spočítať.',
      nelze: 'Výsledok nemožno spočítať, chýba: {polozky}',
      vysledek: 'Výsledok',
    },
    zaMesic: '/ mes.',
  },
  /* BLOK:vystup END */
  /* BLOK:vnRodina START — generuje scratchpad/slovnik.py, ručně needitovat */
  vnRodina: {
    cile: {
      bydleni: {
        akontace: 'Vlastné zdroje {pct} %:',
        akontaceHned: 'Vlastné zdroje potrebujete hneď',
        cena: 'Bývanie za',
        cenaPole: 'Cena bývania',
        doRoku: 'do roku {rok}',
        dopocteno: 'splátka dopočítaná',
        letPole: 'Koľko rokov ešte splácať',
        na: 'na',
        nadpis: 'Bývanie',
        odkladatNaAkontaci: 'Na vlastné zdroje odkladať mesačne',
        otazka: 'Splácate úver, alebo chcete bývanie ešte len kúpiť?',
        pakSplatka: 'potom splátka asi',
        platite: 'Už teraz platíte mesačne',
        rezimDluh: 'Splácame úver',
        rezimKoupit: 'Chceme kúpiť',
        rezimNic: 'Vyriešené',
        uver: 'Úver',
        vyreseno: 'Bývanie máte vyriešené.',
        za: 'o',
        zaPole: 'O koľko rokov chcete kupovať',
        zbytekPole: 'Zostáva doplatiť na úvere',
        zbyva: 'Zostáva doplatiť',
      },
      deti: {
        bezDeti: 'Bez detí do 23 rokov.',
        naDiteMesicne: 'na jedno dieťa mesačne',
        nadpis: 'Deti do 23 rokov',
        nakladPole: 'Koľko mesačne stojí jedno dieťa',
        radek: '{n}. dieťa · {mesicu} mesiacov',
        samostatne: 'Samostatné deti sa nepočítajú: {pocet}',
        stoji: 'Do 23 rokov to stojí',
        zVyplaty: 'Dnes z výplaty mesačne',
      },
      duchod: {
        aria: 'Dôchodok, koľko dá štát a koľko chýba: {radky}',
        ariaRadek: '{kdo} štát {stat}, chýba {chybi}',
        chybi: 'chýba',
        chybiRadek: 'chýba',
        cilPole: 'Koľko chce mať každý v dôchodku mesačne',
        naOsobu: 'mesačne na každého',
        nadpis: 'Dôchodok',
        odchodV: 'Do dôchodku vo veku',
        odkladat: 'odkladať mesačne',
        rezimAria: 'Ako určiť cieľ dôchodku',
        rezimCastka: 'Suma',
        rezimStandard: 'Udržať štandard',
        standardText: 'Udržať dnešnú úroveň: 80 % dnešného čistého príjmu každého z vás.',
        stat: 'štát (odhad)',
        statRadek: 'štát odhadom',
        uzVDuchodu: 'už je v dôchodkovom veku',
        vekPole: 'Vek odchodu do dôchodku',
      },
      nadpis: 'Ciele rodiny',
      odkladatCelkem: 'Na ciele treba odkladať mesačne',
      odkladatModelove: '(modelovo, výnos nie je istý)',
      prijemRodiny: 'Príjem rodiny',
      uvod: 'Bývanie, deti do 23 rokov a dôchodok.',
    },
    hlavicka: {
      navAria: 'Časti analýzy',
      podtitul: 'Príbeh rodiny: ciele a čo ich udrží',
      poradce: 'Pre poradcu',
      priklad: 'Vyplniť príklad',
      promitani: 'Premietať klientovi',
      promitaniKonec: 'Ukončiť premietanie',
      zpet: 'Späť na Analýzu pre Vietnamcov',
    },
    investice: {
      ariaRozdeleni: 'Z balíčka {balicek} ide {ochrana} na ochranu a {investice} do investícií.',
      cenaOdPoradce: 'Cena ochrany od poradcu',
      dnesnimaOcima: 'v dnešných peniazoch {castka}',
      doInvestic: 'do investícií',
      doVeku: 'Do veku',
      dopadPoplatku: 'Oba poplatky spolu znížia modelovú hodnotu o {castka}.',
      grafAria: 'Do {vek} rokov zaplatíte celkom {zaplaceno}, z toho {ochrana} na ochranu, ktorá sa nevracia. Modelová hodnota investícií pri {vynos} % je {hodnota}, v rozpätí od {od} do {do}. Model, nie sľub.',
      hodnotaModel: 'hodnota · model {vynos} %',
      hodnotaPri: 'hodnota pri {vynos} %',
      hodnotaVeVeku: 'Hodnota v {vek} rokoch · model {vynos} %',
      investuje: 'investuje sa',
      naOchranu: 'na ochranu (nevracia sa)',
      nadpis: 'Keď sa nič nestane',
      nakladyNaKonci: 'v {vek} rokoch',
      nakladyNadpis: 'Náklady v čase',
      nakladyPoLetechFew: 'po {n} rokoch',
      nakladyPoLetechMany: 'po {n} rokoch',
      nakladyPoLetechOne: 'po {n} roku',
      nezadano: 'nezadané',
      ochranaPopisek: 'z toho na ochranu {castka}, nevracia sa',
      pasmo: 'rozpätie modelov',
      pasmoOdDo: 'pri {od}–{do} % od {hodnotaOd} do {hodnotaDo}',
      poplatkyDosud: 'poplatky do toho času',
      poplatkyNadpis: 'Koľko stoja poplatky',
      protiCili: 'Na dôchodok podľa vašich cieľov chýba {potreba} v dnešných peniazoch. Model investície vychádza na {pct} % tejto sumy.',
      prubezny: 'Priebežný poplatok',
      prubeznyRadek: '{pct} ročne zo zostatku investície, celkom za {roky}',
      uvod: 'Z balíčka sa zaplatí ochrana, zvyšok sa investuje až do zvoleného veku.',
      vekTooltip: '{vek} rokov',
      vstupni: 'Vstupný poplatok',
      vynos: 'Modelový výnos ročne',
      zBalicku: 'Z balíčka {balicek} mesačne:',
      zTohoOchrana: 'z toho na ochranu',
      zaplaceno: 'Celkom zaplatené',
      zaplacenoJak: 'celý balíček {balicek} × 12 mesiacov × {roky}',
    },
    jednotka: {
      rokFew: 'roky',
      rokMany: 'rokov',
      rokOne: 'rok',
      vekFew: 'roky',
      vekMany: 'rokov',
      vekOne: 'rok',
    },
    nav: {
      cile: 'Ciele',
      investice: 'Investície',
      ochrana: 'Ochrana',
      odkladat: 'Odkladanie',
      otazky: 'Otázky',
      prijmy: 'Príjmy',
      rodina: 'Rodina',
      srovnani: 'Porovnanie',
      vypadek: 'Keby príjem vypadol',
      zaver: 'Zhrnutie',
    },
    neuplne: {
      cilBydleni: 'cena alebo termín bývania',
      nadpis: 'Neúplné, chýba:',
      uver: 'zostatok alebo roky úveru',
      vekDitete: 'vek {n}. dieťaťa',
    },
    ochrana: {
      bezMesicne: 'Každý mesiac chýba {castka}. Táto časť nemá žiadny zdroj.',
      bezPn: 'Každý deň choroby chýba {castka}.',
      bezZo: 'Liečba trvá mesiace, výdavky bežia ďalej a príjem chýba.',
      detiCastka: 'Každé dieťa: {castka}.',
      dil: {
        bydleni: 'Bývanie',
        deti: 'Deti do 23 rokov',
        dluh: 'Diel úveru',
        duchod: 'Dôchodok',
        duchodPozustaleho: 'Dôchodok partnera',
        renta: 'Príjem pre rodinu',
        zivot: 'Bežný život do dôchodku',
      },
      doplniPoradce: 'doplní poradca',
      kazdeDite: 'Každé dieťa',
      kdoAria: 'Čí výpočet ukázať',
      krokMetodou: 'Podľa výpočtu (potreba − štát)',
      krokMinimum: 'Minimum = poistná suma',
      naDen: '/ deň',
      naDnesek: 'prepočítané na dnešné peniaze (4 % ročne)',
      naNoc: '/ noc',
      nadpis: 'Ochrana rodiny podľa rizík',
      nepojistujeSe: 'nepoisťuje sa',
      pnBezPrijmu: 'Bez príjmu. Krytie doplní poradca.',
      pnNicNechybi: 'Nemocenské od štátu pokryje váš príjem.',
      pnPotreba: 'Váš čistý príjem na deň',
      pnStat: 'Nemocenské od štátu',
      podRiziko: {
        dou: 'za deň liečenia úrazu',
        hosp: 'za noc v nemocnici',
        invalidita: 'pri plnej invalidite',
        pn: 'za deň choroby alebo úrazu',
        smrt: 'jednorazovo rodine',
        tnu: 'po úraze, podľa rozsahu',
        zo: 'jednorazovo pri diagnóze',
      },
      popis: {
        dou: 'Dávka za každý deň, keď sa liečite po úraze. Koľko dní sa za úraz platí, určuje tabuľka poisťovne.',
        hosp: 'Dávka za každú noc v nemocnici.',
        invalidita: 'Keď pre zdravie dlhodobo nemôžete pracovať. Štát to delí na stupne podľa toho, o koľko klesla pracovná schopnosť.',
        pn: 'Keď pre chorobu alebo úraz nejaký čas nemôžete pracovať. Nemocenské od štátu nahradí len časť príjmu.',
        smrt: 'Rodina dostane jednorazovú sumu: doplatí diel úveru a nákladov na deti do 23 rokov, ktorý niesol tento príjem, a doplní príjem, ktorý chýba.',
      },
      riziko: {
        dou: 'Denné odškodné',
        hosp: 'Hospitalizácia',
        invalidita: 'Invalidita',
        pn: 'Pracovná neschopnosť',
        smrt: 'Úmrtie',
        tnu: 'Trvalé následky úrazu',
        zo: 'Závažné ochorenia',
      },
      sJednorazove: 'Rodina dostane {castka} a ciele zostanú.',
      sPn: 'Denná dávka {pn}, pri úraze k tomu odškodné {dou}.',
      sPnBezDou: 'Denná dávka {pn}.',
      sZo: 'Jednorazovo {castka} pri diagnóze zo zoznamu v zmluve.',
      stat: {
        invalidita: 'Invalidný dôchodok (odhad)',
        smrt: 'Vdovský a sirotský dôchodok (odhad)',
      },
      statStupen: 'štát odhadom {castka} mesačne',
      stupen: {
        I: 'I. stupeň · 35–49 %',
        II: 'II. stupeň · 50–69 %',
        III: 'III. stupeň · 70 % a viac',
        nad40: 'pokles nad 40 %',
        nad70: 'pokles nad 70 %',
      },
      tabulkaAria: 'Ochrana podľa rizík a osôb',
      tnuPasma: 'Výplata po pásmach:',
      tnuPasmo: '{od}–{do} % ×{k}',
      tnuTabulka: 'Koľko sa vyplatí z {castka} podľa rozsahu poškodenia',
      uvod: 'Koľko by rodina dostala pri každej udalosti. Riziká sa neplnia spoločne, preto sa sumy nesčítavajú.',
      vodopadAria: 'Potreba {potreba}, štát odhadom {stat}, chýba {chybi}.',
      zoRokyFew: '{n} roky čistého príjmu',
      zoRokyMany: '{n} rokov čistého príjmu',
      zoRokyOne: '{n} rok čistého príjmu',
      zoRucne: 'Suma zadaná poradcom',
    },
    odkladat: {
      ariaVolne: 'Po výdavkoch a splátkach zostáva {volne}, balíček je {balicek}.',
      celyPlan: 'Balíček je celý plán rodiny: ochrana aj investícia. Koľko z neho stojí ochrana, vypočíta poradca z ponuky poisťovne.',
      doplnPrijmy: 'Balíčky sa ukážu po zadaní príjmov.',
      doporuceno: 'odporúčané',
      nadpis: 'Koľko si rodina môže odkladať',
      nevejdeSe: 'nezmestí sa, chýba',
      nevejdeSeKratce: 'nezmestí sa',
      odkladate: 'odkladáte',
      rozdeleniInvestice: 'a do investícií',
      rozdeleniOchrana: 'ide na ochranu',
      rozdeleniZ: 'Z',
      uvod: 'Na ciele rodiny: 10 až 30 % čistého príjmu.',
      uvodDoporuceni: 'Z {prijem} mesačne odporúčame odkladať {pct} %.',
      vlastni: 'Vlastná suma:',
      vyberAria: 'Koľko percent príjmu odkladať',
      zVolnych: 'z voľných peňazí',
      zbyvaVolne: 'zostáva voľné',
      zpetNaDoporuceni: 'späť na odporúčanie',
    },
    osa: {
      ariaDite: '{n}. dieťa samostatné v roku {rok}',
      ariaDospely: '{kdo} do dôchodku v roku {rok}',
      ariaUver: 'úver splatený v roku {rok}',
      diteZkratka: 'D{n}',
      dnes: 'dnes',
      duchod: 'dôchodok v {vek} · {rok}',
      prazdno: 'Časová os sa ukáže po zadaní veku.',
      samostatne: 'už samostatné',
      samostatneRok: '23 rokov · {rok}',
      uver: 'Úver',
      uverDo: 'splatené {rok}',
    },
    otazky: {
      faq: {
        dlouho: {
          odpoved: 'V prvých rokoch sa spláca vstupný poplatok, takže pri skorom ukončení dostanete späť málo alebo nič. Podľa zmluvy sa dá platba znížiť, investovanie na čas pozastaviť alebo z investičnej časti vybrať. Od zmluvy môžete odstúpiť do 30 dní po uzavretí.',
          otazka: 'Prečo na dlho? A čo ak budem potrebovať platbu pozastaviť, upraviť alebo vybrať?',
        },
        kamInvest: {
          odpoved: 'Do fondov, ktoré si vyberiete zo zoznamu poisťovne: akciových, dlhopisových alebo zmiešaných. Stratégiu možno počas zmluvy meniť. Hodnota môže klesnúť aj pod vložené peniaze.',
          otazka: 'Kam sa peniaze investujú?',
        },
        nemocny: {
          odpoved: 'Záleží na chorobe a na poisťovni. Môže vás prijať za bežnú cenu, s prirážkou, s výlukou tej choroby, alebo odmietnuť. Chorobu uveďte v dotazníku pravdivo, inak poisťovňa nemusí plniť.',
          otazka: 'Som chorý. Môžem sa poistiť?',
        },
        podvod: {
          odpoved: 'Poisťovňa aj poradca musia mať povolenie a byť zapísaní v registri centrálnej banky — overíte si to sami podľa mena. Pred podpisom dostanete písomne podmienky, prehľad nákladov a záznam z jednania. Nič nemusíte podpisovať hneď.',
          otazka: 'Nie je to podvod?',
        },
        poplatky: {
          odpoved: 'Vstupný poplatok je percento z cieľovej sumy, priebežný poplatok percento zo zostatku ročne. Pri grafe je oboje v peniazoch a všetky náklady nájdete aj v dokumentoch poisťovne.',
          odpovedCisla: 'Vstupný poplatok {pct} z cieľovej sumy je {vstupni}. Priebežný poplatok {prubeznyPct} ročne je za celý čas {prubezne}. Všetky náklady nájdete aj v dokumentoch poisťovne.',
          otazka: 'Koľko stoja poplatky?',
        },
        vratiSe: {
          odpoved: 'Celé nie. Časť, ktorá platí ochranu, je cena za to, že rodina bola celý čas krytá — tá sa nevracia, rovnako ako povinné zmluvné poistenie auta. Peniaze na starobu vznikajú len z investičnej časti a ich výška nie je istá.',
          otazka: 'Keď sa nič nestane, vráti sa mi, čo som zaplatil?',
        },
        vybrat: {
          odpoved: 'Z investičnej časti zvyčajne áno. Koľko, ako rýchlo a s akým poplatkom, určuje zmluva. Ochranná časť sa nevracia, a preto na rýchle peniaze patrí rezerva na účte vedľa zmluvy.',
          otazka: 'Keď nebudem mať peniaze, môžem si ich vybrať?',
        },
        vynos: {
          odpoved: 'Pretože peniaze pracujú dlho a pravidelne. 5, 7 a 9 % sú modelové sadzby, nie sľub — skutočný výnos môže byť nižší aj záporný. Preto graf vždy ukazuje aj to, koľko celkom zaplatíte.',
          otazka: 'Prečo to zarobí toľko?',
        },
      },
      nadpis: 'Vaše otázky',
      vedet: {
        dlouho: 'Je to na dlho. Pri ukončení v prvých rokoch dostanete späť málo alebo nič.',
        nadpis: 'Tri veci, ktoré musíte vedieť',
        poplatky: 'Poplatky vidíte vyššie v peniazoch, nie len v percentách.',
        vynos: 'Výnos nie je istý. Hodnota investície môže aj klesnúť.',
      },
    },
    pomocnik: {
      hledat: 'Hľadať otázku',
      nadpis: 'Na čo sa Vietnamci v Česku pýtajú',
      nicNenalezeno: 'Nič sa nenašlo.',
      otevrit: 'Pomocník pre poradcu · {pocet} otázok',
      pravo: 'Odpovede podľa českého práva, overené 30. 9. 2026.',
      zdroj: 'Zdroj: {zdroj}',
    },
    prijmy: {
      ariaPrijem: 'Príjem rodiny {celkem}: {dily}',
      ariaVydaje: 'Kam ide príjem: {dily}',
      chybi: 'chýba',
      doDuchodu: 'do dôchodku',
      doplnPrijmy: 'Pás príjmov sa ukáže po zadaní veku a príjmu.',
      mesicne: 'mesačne',
      nadpis: 'Koľko vám prejde rukami',
      rocne: 'ročne',
      splatky: 'splátky',
      uvod: 'Príjmy oboch spolu a kam idú.',
      volne: 'zostáva',
      vydaje: 'výdavky',
      vydajePole: 'Výdavky rodiny mesačne (bez splátok, vrátane detí)',
      vydajeUpresneni: 'bez splátok úverov, vrátane detí',
      vydajeVeta: 'Rodina mesačne minie',
    },
    rodina: {
      bezDeti: 'zatiaľ žiadne',
      bezPrijmu: 'bez príjmu',
      bezPrijmuPrepinac: 'Teraz bez príjmu (rodičovská, doma)',
      deti: 'Deti',
      diteCislo: '{n}. dieťa',
      mesicne: 'mesačne',
      nadpis: 'Vaša rodina',
      odebratDite: 'Odobrať {n}. dieťa',
      odebratPartnera: 'Odobrať druhého dospelého',
      osvc: 'SZČO',
      pridatDite: 'Pridať dieťa',
      pridatPartnera: 'Pridať partnera',
      prijem: 'čistý príjem',
      prijemKoho: '{kdo} · čistý príjem mesačne',
      uvod: 'Kto je v rodine, koľko má kto rokov a koľko kto zarobí.',
      vek: 'vek',
      vekDitete: '{n}. dieťa · vek',
      vekKoho: '{kdo} · vek',
    },
    role: {
      bo: 'Otec',
      boZkratka: 'O',
      me: 'Mama',
      meZkratka: 'M',
    },
    srovnani: {
      balicek: 'Balíček',
      cimDriv: 'Keby ste začali až v {vek} rokoch, zaplatíte o {mene} menej, ale modelovo budete mať o {cena} menej (v dnešných peniazoch).',
      legenda: 'V bunke modelová hodnota, pod ňou koľko celkom zaplatíte. Sumy v {symbol}.',
      mesicne: '{castka} mesačne',
      nadpis: 'Čím viac a čím skôr',
      ochranaStejna: 'ochrana {castka} mesačne pri každom balíčku',
      prazdno: 'Porovnanie sa ukáže po zadaní príjmov a ceny ochrany.',
      startDnes: 'Začať dnes',
      startZa: 'O {roky} rokov',
      tabulkaAria: 'Modelová hodnota v {vek} rokoch pri {vynos} % podľa balíčka a začiatku',
      uvod: 'Modelová hodnota v {vek} rokoch pri {vynos} %: podľa toho, koľko odkladáte a kedy začnete.',
    },
    stitek: {
      bezNarokuInv: 'bez nároku na invalidný dôchodok',
      bezPrijmuDoplniPoradce: 'bez príjmu, krytie doplní poradca',
      bezPrubeznehoPoplatku: 'bez priebežného poplatku, skutočnosť bude nižšia',
      bezRustuMzdy: 'v dnešných peniazoch, bez rastu mzdy',
      bezVstupnihoPoplatku: 'bez vstupného poplatku, skutočnosť bude nižšia',
      bezVynosuKratkyCil: 'krátky cieľ, počítané bez výnosu',
      dnesniPenize: 'v dnešných peniazoch (inflácia 2,5 %)',
      duchodBezNaroku: 'bez nároku: menej ako 5 rokov poistenia z 10',
      duchodMinimum: 'zákonné minimum',
      duchodOsvcMinimalni: 'SZČO: dôchodok z minimálnych preddavkov',
      duchodOveritNarok: 'nárok nevieme, počíta sa bez neho: overiť výpis ČSSZ',
      invaliditaBezPrijmuB: 'rodič bez príjmu: kryjú sa o 20 % vyššie výdavky mínus invalidný dôchodok',
      invaliditaPoOdchodu: 'po veku odchodu do dôchodku sa invalidita nepoisťuje',
      modelovyVynos: 'modelový výnos, nie sľub; hodnota môže aj klesnúť',
      narokNeovren: 'nárok neoverený',
      ochranaJeNaklad: 'ochrana je cena krytia, nevracia sa',
      osvcBezNemocenske: 'SZČO bez nemocenského poistenia: štát neplatí',
      osvcNeodecteno: 'SZČO: štátny dôchodok neodpočítaný, výšku pozná len úrad',
      overitUPojistovny: 'overiť v poisťovni (bežne do {strop})',
      podilNaPrijmu: 'diel cieľov podľa podielu na príjme rodiny',
      podlePodminekPojistovny: 'podľa poistných podmienok',
      pozustalostniBezNaroku: 'bez potrebnej doby poistenia: vdovský a sirotský dôchodok neodpočítaný',
      pozustalostniBezPrijmu: 'bez príjmu: vdovský a sirotský dôchodok neodpočítaný, doplní poradca',
      pozustalostniOsvc: 'SZČO: vdovský a sirotský dôchodok neodpočítaný, nárok pozná len úrad',
      sablona: 'šablóna, overí poradca',
      statOdhad: 'odhad, nárok až po 5 rokoch poistenia v posledných 10',
      statPoradce: 'zadal poradca',
      statSkDoplniPoradce: 'starobný dôchodok doplní poradca',
      statSkSablona: 'priemer Sociálnej poisťovne, overí poradca',
      vdovskyJenManzelum: 'vdovský dôchodok len manželom: neodpočítaný',
      vdovskyNevime: 'vdovský dôchodok neodpočítaný: sobáš nezadaný',
      zoBezOdectuStatu: 'nemocenské kryje len pracovnú neschopnosť, od závažných ochorení sa neodpočítava',
    },
    stop: {
      bezBalicku: 'Vyberte balíček alebo zadajte vlastnú sumu.',
      bezCenyZajisteni: 'Cenu ochrany zadá poradca z modelácie poisťovne.',
      bezCileDuchodu: 'Doplňte, koľko chce mať mesačne v dôchodku.',
      bezHorizontu: 'Cieľový vek musí byť vyšší ako dnešný vek.',
      bezNakladuNaDite: 'Doplňte, koľko mesačne stojí jedno dieťa.',
      bezOsob: 'Zadajte aspoň jedného dospelého.',
      bezPrijmu: 'Chýba čistý príjem. Ak je doma bez príjmu, zapnite „bez príjmu“.',
      bezVeku: 'Chýba vek.',
      bezVydaju: 'Chýbajú mesačné výdavky rodiny.',
      celyBalicekNaOchranu: 'Celý balíček ide na ochranu. Na starobu z neho nič nevznikne.',
      cilBydleniNeuplny: 'Pri bývaní chýba cena alebo o koľko rokov.',
      dluhNeuplny: 'Pri úvere chýba zostatok alebo počet rokov splácania.',
      nejdrivRozpocet: 'Výdavky sú vyššie ako príjmy. Najprv rozpočet, potom balíček.',
      nejmensiNevejde: 'Ani {pct} % ({balicek}) sa do voľných peňazí {volne} nezmestí. Zvoľte vlastnú sumu, alebo najprv rozpočet.',
      prubeznyMimoRozsah: 'Priebežný poplatok musí byť medzi 0 a {max} % ročne.',
      vekMimoRozsah: 'Vek musí byť medzi {min} a {max} rokmi.',
      vekOdchoduMimoRozsah: 'Vek odchodu do dôchodku musí byť medzi {min} a {max} rokmi.',
      vynosMimoRozsah: 'Výnos po poplatkoch vychádza mimo rozsahu, s ktorým počítame.',
    },
    suplik: {
      ano: 'Áno',
      balicek: 'Balíček',
      cenaOchrany: 'Cena ochrany mesačne',
      cenaOchranyNapoveda: 'Z modelácie poisťovne. Aplikácia cenu neodhaduje.',
      davkyNapoveda: 'Prázdne = odhad appky podľa zákona.',
      douDospely: 'Denné odškodné dospelého, za deň',
      invPodilNad40: 'Pokles nad 40 %: koľko % poistnej sumy',
      invalidniDuchod: 'Invalidný dôchodok pri plnej invalidite podľa výpisu, mesačne',
      manzelstvi: 'Manželstvo',
      nadpis: 'Pre poradcu',
      narok: 'Nárok na invalidný dôchodok (5 rokov poistenia z posledných 10)',
      ne: 'Nie',
      nevim: 'Neviem',
      ochranaInvestice: 'Ochrana a investícia',
      osvc: 'SZČO',
      prubeznyPoplatek: 'Priebežný poplatok (% ročne)',
      role: 'Kto to je',
      sazba: 'Úroková sadzba',
      sezdani: 'Sú zosobášení? Vdovský dôchodok patrí len manželom.',
      splatka: 'Mesačná splátka',
      splatkaNapoveda: 'Prázdne = splátka sa dopočíta.',
      statniDuchod: 'Starobný dôchodok podľa výpisu, mesačne',
      stavDat: 'Stav údajov',
      tnu: 'Trvalé následky úrazu: poistná suma',
      typ: 'Forma príjmu',
      uver: 'Úver zo zmluvy',
      varianta: 'Ako sa platí vstupný poplatok',
      vekCil: 'Investovať do veku',
      vlastniBalicek: 'Vlastná suma mesačne (namiesto 10–30 %)',
      volbyOchrany: 'Voľby ochrany',
      vseZadano: 'Nič nechýba.',
      vstupniPoplatek: 'Vstupný poplatok (% z cieľovej sumy)',
      vynos: 'Modelový výnos ročne',
      zamestnanec: 'Zamestnanec',
      zavrit: 'Zavrieť',
      zoRoky: 'Závažné ochorenia: koľko ročných príjmov',
      zoRokyVolbaFew: '{n} roky',
      zoRokyVolbaMany: '{n} rokov',
      zoRokyVolbaOne: '{n} rok',
      zoRucne: 'Závažné ochorenia ručne · {kdo}',
    },
    trapeni: {
      cesky: {
        odpoved: 'Dokumenty môžu byť v češtine alebo v inom dohodnutom jazyku. Všetko vám vysvetlím po vietnamsky, ale záväzné je znenie zmluvy a dostanete záznam z jednania. Nemusíte podpísať dnes — vezmite si dokumenty domov, prečítajte si ich s niekým, komu veríte, a nepodpisujte nič, čomu nerozumiete.',
        otazka: 'Zmluva je celá po česky a nerozumiem jej. Musím podpísať dnes?',
        otazkaVi: 'Hợp đồng toàn tiếng Séc, tôi đọc không hiểu thì ký thế nào? Có cần ký luôn hôm nay không?',
        zdroj: '§ 79, 90 českého zákona o distribúcii poistenia; § 2789 českého Občianskeho zákonníka; KID (nariadenie PRIIPs)',
      },
      dane: {
        odpoved: 'Poistné na daňovo podporované životné poistenie sa dá odpočítať zo základu dane, najviac 48 000 Kč ročne spolu s penzijným sporením a DIP. Podmienkou je výplata najskôr v roku 60 rokov (pri zmluvách od 2024 aj po 120 mesiacoch); pri skoršom výbere sa odpočítané sumy dodania až 10 rokov späť. Ušetríte len daň z odpočítanej sumy, pri 15 % sadzbe najviac 7 200 Kč ročne; paušálna daň ani nerezident mimo EÚ odpočet neuplatní.',
        otazka: 'Môžem si to odpočítať z daní? Koľko?',
        otazkaVi: 'Mua cái này có được khấu trừ thuế không? Được bao nhiêu?',
        zdroj: '§ 15, 15a, 15b českého zákona o daniach z príjmov; česká Finančná správa',
      },
      deti: {
        odpoved: 'Najprv chránime príjem rodičov, pretože z neho deti žijú. Poistenie dieťaťa kryje hlavne vážny úraz alebo chorobu, keď rodič zostane doma a náklady rastú; predvolené je závažné ochorenia 2 mil. Kč, trvalé následky 2 mil. Kč, denné odškodné 500 Kč a hospitalizácia 1 000 Kč za deň. Hranica 23 rokov je voľba plánu — český štát berie študujúce dieťa ako nezaopatrené najdlhšie do 26.',
        otazka: 'Deti sú malé. Mám poistiť aj ich? Do kedy budú potrebovať peniaze?',
        otazkaVi: 'Con còn nhỏ, có nên mua cho con không? Con đi học đại học thì cần tiền đến bao giờ?',
        zdroj: '§ 20, 52 českého zákona o dôchodkovom poistení; metodika tejto analýzy',
      },
      dotaznik: {
        odpoved: 'Áno — na každú otázku pravdivo a úplne, aj na drobnosti, na ktoré sa poisťovňa pýta. Ak sa zamlčanie preukáže, môže od zmluvy odstúpiť alebo odmietnuť plnenie práve vtedy, keď ho rodina potrebuje. Pravdivá odpoveď môže znamenať prirážku alebo výluku, ale zmluva potom drží.',
        otazka: 'Musím do dotazníka napísať všetko? Čo ak drobnosť nenapíšem?',
        otazkaVi: 'Khai sức khỏe có phải khai hết không? Bệnh vặt không khai có sao không?',
        zdroj: '§ 2788, 2808, 2809 českého Občianskeho zákonníka',
      },
      duchodOsvc: {
        odpoved: 'Starobný aj invalidný dôchodok sa počíta zo základov, z ktorých ste platili, takže pri minimálnych zálohách bude nízky. Invalidný dôchodok navyše vyžaduje dobu poistenia (nad 28 rokov veku 5 rokov v posledných 10). Presný prehľad rokov a platieb dá ČSSZ v informatívnom osobnom liste na ePortáli.',
        otazka: 'Platím sociálne len minimum. Aký budem mať dôchodok? A čo mi dá štát pri invalidite?',
        otazkaVi: 'Tôi chỉ đóng bảo hiểm xã hội mức thấp nhất, sau này lương hưu được bao nhiêu? Mất sức lao động thì nhà nước trả gì?',
        zdroj: '§ 16, 40 českého zákona o dôchodkovom poistení; ČSSZ (česká sociálna poisťovňa)',
      },
      invalidita: {
        odpoved: 'Invalidita je dlhodobý pokles schopnosti pracovať pre zdravie; český štát ju delí na tri stupne: 35–49 %, 50–69 % a 70 % a viac. Poistka plní podľa svojich podmienok — niektoré sa riadia rozhodnutím ČSSZ, iné vlastným posúdením, zvyčajne až po ustálení zdravotného stavu. Preto vždy ukážem, od ktorého stupňa a koľko vypláca.',
        otazka: 'Čo je invalidita? Kedy dostanem peniaze?',
        otazkaVi: 'Mất sức lao động là thế nào? Bao giờ thì được trả tiền?',
        zdroj: '§ 39 českého zákona o dôchodkovom poistení; poistné podmienky',
      },
      kamInvest: {
        odpoved: 'Investičná časť kupuje podiely vo fondoch, ktoré si vyberiete zo zoznamu poisťovne — akciové, dlhopisové, zmiešané alebo peňažné. Čím viac akcií, tým vyšší možný výnos aj väčšie výkyvy, a hodnota môže klesnúť aj pod vložené peniaze. Stratégiu možno zvyčajne meniť, podmienky a poplatky sú v sadzobníku.',
        otazka: 'Do čoho sa tie peniaze investujú? Môžem o všetko prísť?',
        otazkaVi: 'Tiền này đầu tư vào đâu? Có bị mất trắng không?',
        zdroj: '§ 86 českého zákona o distribúcii poistenia; KID (nariadenie PRIIPs)',
      },
      kolikStoji: {
        odpoved: 'Cenu ochrany pozná až poisťovňa — závisí od veku, zdravia, povolania a výšky krytia, preto je v analýze len cena z jej modelácie, žiadny odhad. Pred podpisom musí poisťovňa ukázať, koľko z platby ide na krytie rizík (to sa spotrebuje), koľko na náklady a koľko sa investuje. Balíček 10–30 % príjmu je rámec rozpočtu, nie cena.',
        otazka: 'Koľko budem platiť mesačne? A koľko z toho je poistenie a koľko sa investuje?',
        otazkaVi: 'Mỗi tháng phải đóng bao nhiêu? Trong đó bao nhiêu là tiền bảo hiểm, bao nhiêu được đầu tư?',
        zdroj: '§ 84, 86 českého zákona o distribúcii poistenia; KID (nariadenie PRIIPs); metodika tejto analýzy',
      },
      komu: {
        odpoved: 'Ten, koho zapíšete do zmluvy ako oprávnenú osobu — môže to byť aj rodič vo Vietname (meno, dátum narodenia, kontakt). Ak nikto určený nie je, zákon dáva prednosť manželovi, potom deťom, rodičom a dedičom. Oprávnenú osobu možno kedykoľvek písomne zmeniť; výplatu do zahraničia overíme v podmienkach.',
        otazka: 'Keď zomriem, kto dostane peniaze? Môžu ich dostať rodičia vo Vietname?',
        otazkaVi: 'Nếu tôi mất thì ai nhận tiền? Bố mẹ tôi ở Việt Nam có nhận được không?',
        zdroj: '§ 2829, 2831, 2832 českého Občianskeho zákonníka',
      },
      krach: {
        odpoved: 'Poisťovne v ČR sú pod dohľadom ČNB a musia držať kapitál a technické rezervy; pri likvidácii slúžia aktíva kryjúce záväzky prednostne na nároky z poistenia. Poistenie vkladov ako pri bankách sa na životné poistenie nevzťahuje. Investičná časť navyše kolíše s hodnotou fondov bez ohľadu na poisťovňu.',
        otazka: 'Čo ak poisťovňa skrachuje? Čo bude s mojimi peniazmi?',
        otazkaVi: 'Nếu công ty bảo hiểm phá sản thì tiền của tôi thế nào?',
        zdroj: '§ 123 českého zákona o poisťovníctve',
      },
      nemocny: {
        odpoved: 'Záleží na diagnóze, liečbe a poisťovni: prijatie za bežnú cenu, prirážka, výluka len pre túto chorobu, odklad alebo odmietnutie. Rozhoduje poisťovňa po dotazníku, prípadne po lekárskej správe, a niektoré pripoistenia majú čakaciu dobu. Chorobu preto uveďte hneď — vopred sa nedá nič sľúbiť.',
        otazka: 'Mám vysoký tlak, cukrovku… Môžem sa vôbec poistiť?',
        otazkaVi: 'Tôi đang bị cao huyết áp, tiểu đường… thì có mua bảo hiểm được không?',
        zdroj: '§ 2788 českého Občianskeho zákonníka; § 84 českého zákona o distribúcii poistenia; poistné podmienky',
      },
      nesezdani: {
        odpoved: 'Vdovský alebo vdovecký dôchodok od štátu patrí len manželovi alebo manželke. V poistke však môže byť oprávnenou osobou ktokoľvek, preto partnera zapíšte do zmluvy menom. Bez určenia zákon dáva peniaze manželovi, deťom, rodičom a dedičom — partner bez sobáša medzi nimi nie je.',
        otazka: 'Žijeme spolu, ale nie sme zosobášení. Keď zomriem, dostane partner niečo?',
        otazkaVi: 'Chúng tôi sống với nhau nhưng chưa đăng ký kết hôn. Nếu tôi mất thì người kia có được gì không?',
        zdroj: '§ 49, 50 českého zákona o dôchodkovom poistení; § 2829, 2831 českého Občianskeho zákonníka',
      },
      osvcPn: {
        odpoved: 'Živnostník (OSVČ) dostane nemocenské len vtedy, ak si aspoň 3 mesiace pred ochorením dobrovoľne platí nemocenské poistenie — a aj vtedy až od 15. dňa a z nízkeho základu. Bez neho nemocenské od štátu nedostane a výdavky bežia ďalej. Preto pri OSVČ počítame poistenie pracovnej neschopnosti; od ktorého dňa platí, určia podmienky.',
        otazka: 'Som živnostník. Keď budem mesiace chorý, zaplatí mi niečo štát?',
        otazkaVi: 'Tôi tự kinh doanh, nếu ốm phải nghỉ mấy tháng thì nhà nước có trả gì không?',
        zdroj: '§ 24, 26, 29 českého zákona o nemocenskom poistení; ČSSZ (česká sociálna poisťovňa)',
      },
      podvod: {
        odpoved: 'Poisťovňa musí mať povolenie ČNB a poradca musí byť zapísaný v jej registri — overíte si to sami podľa mena. Pred podpisom dostanete písomne poistné podmienky, dokument s kľúčovými informáciami (KID) s nákladmi a záznam z jednania vrátane rizík. Nič nemusíte podpísať hneď a pri spore sa môžete bez poplatku obrátiť na finančného arbitra.',
        otazka: 'Nie je to podvod? Vo Vietname ľudia kúpili poistenie cez banku a prišli o peniaze.',
        otazkaVi: 'Cái này có phải lừa đảo không? Ở Việt Nam người ta mua bảo hiểm qua ngân hàng rồi mất tiền đấy.',
        zdroj: 'register ČNB; § 79, 88 českého zákona o distribúcii poistenia; § 18 českého zákona o finančnom arbitrovi',
      },
      poplatky: {
        odpoved: 'Všetky náklady sú v dokumentoch: štruktúra poistného pred podpisom, náklady v čase v KID a jednotlivé poplatky v sadzobníku. Časť nákladov sa platí v prvých rokoch, preto vtedy investičný účet rastie pomaly; vstupný poplatok z cieľovej sumy vidíte v analýze zvlášť v peniazoch. Každý rok príde výpis s hodnotou účtu, odkupným a nákladmi.',
        otazka: 'Aké sú tam poplatky? Kam idú peniaze v prvých rokoch?',
        otazkaVi: 'Phí gì mà nhiều thế? Mấy năm đầu tiền của tôi đi đâu?',
        zdroj: '§ 84, 86, 89 českého zákona o distribúcii poistenia; KID (nariadenie PRIIPs)',
      },
      provize: {
        odpoved: 'Dostávam odmenu od poisťovne; jej druh vám musím oznámiť a nájdete ho v informáciách pred podpisom. Zákon ju rozkladá na 5 rokov — keď zmluva skončí skôr, časť odmeny vraciam. Preto mi ide o zmluvu, ktorú budete schopní platiť dlho.',
        otazka: 'Koľko na tom zarobíte vy?',
        otazkaVi: 'Anh/chị bán cái này được hoa hồng bao nhiêu?',
        zdroj: '§ 50, 88 českého zákona o distribúcii poistenia',
      },
      rodice: {
        odpoved: 'Podporu rodičov dáme do výdavkov rodiny, aby s ňou počítal aj výpočet potrebnej ochrany. Keď choroba alebo úraz vezme príjem, dávka z poistenia pomôže platiť aj túto položku. Pre prípad úmrtia môžete rodičov určiť ako oprávnené osoby; výplatu do Vietnamu overíme v podmienkach.',
        otazka: 'Každý mesiac posielam peniaze rodičom. Kto im bude posielať, keď ochoriem?',
        otazkaVi: 'Tháng nào tôi cũng gửi tiền về cho bố mẹ. Nếu tôi ốm hay có chuyện gì thì ai gửi?',
        zdroj: '§ 2829 českého Občianskeho zákonníka; metodika tejto analýzy',
      },
      rozvod: {
        odpoved: 'Po rozvode skontrolujte oprávnenú osobu: bývalý manžel zapísaný menom ňou zostáva, kým to písomne nezmeníte. Zmluvu riadi poistník, a keď je poistený iná osoba, na zmenu oprávnenej osoby a na odkupné treba aj jej súhlas. Ako sa delí investičná časť, rieši majetkové vyrovnanie — to nech posúdi advokát.',
        otazka: 'Keby sme sa rozviedli, komu patrí zmluva a peniaze v nej?',
        otazkaVi: 'Nếu sau này ly hôn thì hợp đồng và tiền trong đó thuộc về ai?',
        zdroj: '§ 2826, 2829, 2830, 2832 českého Občianskeho zákonníka',
      },
      sezona: {
        odpoved: 'Len ak to zmluva výslovne umožňuje — čo konkrétny produkt dovolí (znížiť, dočasne neplatiť, strhávať ochranu z investičného účtu), ukážem v podmienkach. Pri neplatení príde upomienka s dodatočnou lehotou aspoň mesiac, potom môže poistenie zaniknúť. Platbu preto nastavujeme podľa slabých mesiacov, nie podľa najlepších.',
        otazka: 'Niekedy sa darí, niekedy nie. Môžem v slabej sezóne platbu pozastaviť alebo znížiť?',
        otazkaVi: 'Làm ăn lúc được lúc không, mùa ế thì có tạm ngừng hoặc đóng ít đi được không?',
        zdroj: '§ 2804, 2838 českého Občianskeho zákonníka; poistné podmienky',
      },
      skoncit: {
        odpoved: 'Počiatočné náklady sa zvyčajne strhávajú v prvých rokoch, takže krátka zmluva je drahá a odkupné býva spočiatku nízke. Plánujeme ju podľa cieľa — na starobu a na roky detí. Skončiť sa však dá: do 30 dní od potvrdenia o uzavretí odstúpiť, do 2 mesiacov od uzavretia vypovedať a neskôr ukončiť s odkupným.',
        otazka: 'Prečo sa musí platiť tak dlho? Čo ak budem chcieť prestať?',
        otazkaVi: 'Sao phải đóng lâu thế? Nếu muốn dừng giữa chừng thì sao?',
        zdroj: '§ 2805, 2808, 2842 českého Občianskeho zákonníka; § 86 českého zákona o distribúcii poistenia',
      },
      staraSmlouva: {
        odpoved: 'Starú zmluvu kvôli novej nerušte, kým ich písomne neporovnáme: znova sa platia počiatočné náklady, nový dotazník posudzuje dnešný vek a zdravie a pri zmluve s daňovým odpočtom hrozí dodanenie. ČNB pred zbytočným rušením zmlúv výslovne varuje. Často stačí starú upraviť alebo doplniť len to, čo chýba.',
        otazka: 'Už mám zmluvu od iného poradcu. Mám ju zrušiť a urobiť novú?',
        otazkaVi: 'Tôi có hợp đồng cũ với người khác rồi, có nên hủy để làm cái mới không?',
        zdroj: 'upozornenie ČNB k rušeniu zmlúv; § 15b českého zákona o daniach z príjmov',
      },
      stari: {
        odpoved: 'Pomoc detí je krásna vec a cieľom je, aby bola darom, nie nutnosťou. Vlastné peniaze na starobu dávajú voľbu: kde bývať, či sa vrátiť do Vietnamu, ako pomáhať vnúčatám. Suma v grafe je modelová a bez záruky.',
        otazka: 'Máme deti, na starobu sa o nás postarajú. Prečo by som to potreboval?',
        otazkaVi: 'Có con rồi, về già con nó lo, cần gì phải mua cái này?',
        zdroj: 'metodika tejto analýzy; § 86 českého zákona o distribúcii poistenia',
      },
      vietnam: {
        odpoved: 'Či zmluva po presťahovaní pokračuje, či platí mimo ČR a ako sa platí a vypláca do zahraničia, určujú poistné podmienky — preto sa pred podpisom opýtame poisťovne písomne a odpoveď si odložíte. Po odsťahovaní sa menia aj dane (nerezident mimo EÚ odpočet neuplatní). Český dôchodok sa dá vyplácať aj do Vietnamu, podmienky overí ČSSZ.',
        otazka: 'Čo bude so zmluvou, keď sa celá rodina vráti do Vietnamu?',
        otazkaVi: 'Sau này cả nhà về Việt Nam thì hợp đồng thế nào? Có đóng tiếp được không, tiền có chuyển về Việt Nam được không?',
        zdroj: '§ 2789 českého Občianskeho zákonníka; § 84 českého zákona o distribúcii poistenia; § 15 českého zákona o daniach z príjmov; ČSSZ (česká sociálna poisťovňa)',
      },
      vratiSe: {
        odpoved: 'Celé nie. Časť, ktorá platí ochranu, je cena za to, že rodina bola celý čas krytá, a nevracia sa — rovnako ako poistenie auta. Peniaze na starobu vznikajú len z investičnej časti, po nákladoch a bez záruky výnosu.',
        otazka: 'Keď sa nič nestane, vráti sa mi, čo som zaplatil?',
        otazkaVi: 'Nếu không có chuyện gì thì tiền đóng bảo hiểm có được trả lại không?',
        zdroj: '§ 86 českého zákona o distribúcii poistenia',
      },
      vybrat: {
        odpoved: 'Z investičnej časti sa spravidla dá urobiť mimoriadny výber; minimálny zostatok, poplatok a lehotu určujú podmienky. Pri ukončení celej zmluvy vzniká nárok na odkupné (po zaplatení aspoň za dva roky, ak ho zmluva nevylučuje) a poisťovňa ho vyplatí do troch mesiacov. Na rýchle peniaze preto patrí rezerva na účte vedľa zmluvy.',
        otazka: 'Keď budem nutne potrebovať peniaze, môžem si ich vybrať? Za ako dlho ich mám?',
        otazkaVi: 'Lúc cần tiền gấp thì có rút ra được không? Bao lâu thì nhận được tiền?',
        zdroj: '§ 2842 českého Občianskeho zákonníka; § 86 českého zákona o distribúcii poistenia; KID (nariadenie PRIIPs)',
      },
      vyluky: {
        odpoved: 'Každé riziko má v podmienkach svoju definíciu a výluky — ukážem ich pred podpisom. Trvalé následky a denné odškodné kryjú len úraz; invalidita, závažné ochorenia a pracovná neschopnosť podľa podmienok aj chorobu. Strata práce alebo zatvorenie obchodu poistnou udalosťou spravidla nie je.',
        otazka: 'Kedy poisťovňa nezaplatí? Platí to aj na chorobu, alebo len na úraz?',
        otazkaVi: 'Trường hợp nào thì bảo hiểm không trả? Ốm có được trả không hay chỉ tai nạn?',
        zdroj: '§ 84 českého zákona o distribúcii poistenia; § 2837 českého Občianskeho zákonníka; poistné podmienky',
      },
      vynos: {
        odpoved: '5, 7 a 9 % sú modelové sadzby na ilustráciu, nie sľub. Investícia môže aj strácať a riziko nesie klient — KID preto ukazuje aj nepriaznivý a stresový scenár. Dlhšia doba kolísanie zmierni, ale neodstráni, preto graf vždy ukazuje aj to, koľko ste celkovo zaplatili.',
        otazka: 'Prečo to zarobí toľko? Je tých 7 % istých?',
        otazkaVi: 'Sao lãi được nhiều thế? Có chắc được 7 % một năm không?',
        zdroj: '§ 86 českého zákona o distribúcii poistenia; KID (nariadenie PRIIPs)',
      },
      zavazneOnem: {
        odpoved: 'Vyplatí jednorazovú sumu, keď lekár potvrdí diagnózu zo zoznamu v podmienkach; zoznam, definície aj štádiá sa medzi poisťovňami líšia. Peniaze sa dajú použiť na hocičo — výpadok príjmu, starostlivosť, cesty na liečbu. V našej analýze je predvolená suma jeden rok čistého príjmu (voliteľne dva alebo tri).',
        otazka: 'Čo je poistenie závažných ochorení? Zaplatí, keď dostanem rakovinu?',
        otazkaVi: 'Bảo hiểm bệnh hiểm nghèo là gì? Bị ung thư thì có được trả không?',
        zdroj: '§ 84 českého zákona o distribúcii poistenia; poistné podmienky; metodika tejto analýzy',
      },
      zdravotniCizinec: {
        odpoved: 'Komerčné zdravotné poistenie hradí liečenie, ale nenahradí príjem, keď nemôžete pracovať, a nič nedá rodine pri úmrtí alebo invalidite. Do verejného zdravotného poistenia v ČR patria hlavne ľudia s trvalým pobytom alebo zamestnanci českého zamestnávateľa. Slovo „bảo hiểm“ znamená oboje, preto vždy poviem, o ktorom hovoríme.',
        otazka: 'Mám komerčné zdravotné poistenie pre cudzincov. To nestačí?',
        otazkaVi: 'Tôi có bảo hiểm y tế thương mại cho người nước ngoài rồi, thế chưa đủ à?',
        zdroj: '§ 2 českého zákona o verejnom zdravotnom poistení',
      },
      zvlast: {
        odpoved: 'Dá sa to aj tak: rizikové životné poistenie len na ochranu a investícia zvlášť. Rozhoduje, čo vás po všetkých nákladoch vyjde lepšie a čo budete naozaj dodržiavať — obe cesty môžem spočítať vedľa seba z KID a sadzobníkov. Rozhodnutie je vaše a zapíšem ho do záznamu z jednania.',
        otazka: 'Prečo si nekúpiť len lacné rizikové poistenie a investovať zvlášť sám?',
        otazkaVi: 'Sao không mua bảo hiểm rủi ro cho rẻ, còn tiền thì tự đầu tư riêng?',
        zdroj: '§ 78, 79 českého zákona o distribúcii poistenia; KID (nariadenie PRIIPs)',
      },
    },
    ui: {
      chybaVypoctu: 'Výpočet sa nepodaril. Skontrolujte zadané údaje.',
      hotovo: 'Hotovo',
      metodika: 'Metodika výpočtu z {verze}.',
      vymazat: 'Vymazať',
    },
    varovani: {
      balicekNadVolne: 'Balíček {pct} % sa do rozpočtu nezmestí, chýba {chybi} mesačne.',
      detiSamostatne: 'Deti od {vek} rokov sa nepočítajú: {pocet}.',
      duchodNadBalicek: 'Na dôchodok by bolo treba odkladať {odkladat} mesačne, viac ako celý balíček {balicek}.',
      ochranaNadBalicek: 'Ochrana stojí viac ako balíček, na investíciu nezostáva nič.',
      poVekuOdchodu: 'Je v dôchodkovom veku alebo nad ním.',
      splatkaDopocitana: 'Splátka dopočítaná ({splatka} pri {sazbaPct} % ročne). Presnú opíšte zo zmluvy.',
      vydajeNadPrijmy: 'Výdavky a splátky prevyšujú príjmy o {chybi}.',
      vynosMimoScenare: 'Výnos {vynos} % nie je jeden zo scenárov 5 / 7 / 9 %.',
    },
    vypadek: {
      bez: 'Bez poistenia',
      bezZdroje: 'Táto časť nemá žiadny zdroj.',
      chybiCastka: 'chýba {castka} mesačne',
      chybiJednorazove: 'Mesačne nič nechýba, ale na ciele by chýbalo {castka}.',
      chybiMesicne: 'Každý mesiac chýba',
      cip: {
        infarkt: 'Infarkt',
        ledviny: 'Zlyhanie obličiek',
        mrtvice: 'Mozgová príhoda',
        ochrnuti: 'Ochrnutie',
        rakovina: 'Rakovina',
        roztrousena: 'Roztrúsená skleróza',
        srdce: 'Operácia srdca',
        uraz: 'Vážny úraz',
      },
      cipyAria: 'Príklady chorôb a udalostí',
      cipyPoznamka: 'Príklady. Čo presne kryje zmluva, určujú poistné podmienky.',
      jakSpocitano: 'Ako sme k sume dospeli',
      kdoAria: 'Čí príjem vypadne',
      krokChybi: 'Čo chýba = poistná suma',
      krokPotreba: 'Čo rodina potrebuje (z vašich cieľov)',
      krokStat: 'Čo dá štát',
      krytoCastka: 'kryté {castka} mesačne',
      legendaChybi: 'chýba, bez zdroja',
      legendaKryto: 'kryje poistenie',
      legendaPartner: 'ďalej nesie {kdo}',
      nadpis: 'Keby jeden príjem vypadol',
      nesePartner: '{kdo} ďalej nesie {pct} % cieľov svojím príjmom.',
      nicNechybi: 'Príjem druhého z vás by túto situáciu pokryl.',
      nicNechybiSam: 'Z cieľov, ktoré ste zadali, by nič nezostalo bez zdroja.',
      pojistnaCastka: 'Poistná suma',
      prazdno: 'Vypočítame, keď budú zadané veky, príjmy a výdavky rodiny.',
      radek: {
        bydleni: 'Splátka bývania',
        deti: 'Deti do 23 rokov',
        duchod: 'Odkladanie na dôchodok',
        zivot: 'Bežný život rodiny',
      },
      s: 'S poistením',
      sZdrojem: 'Diera je zavretá, ciele rodiny zostanú.',
      udalost: {
        invalidita: 'Nemôže pracovať',
        smrt: 'Úmrtie',
      },
      udalostAria: 'Čo sa stane',
      uvod: 'Choroba alebo úraz môže prísť nečakane. Čo by sa stalo s cieľmi rodiny a čo ju podrží.',
      veta: {
        invalidita: {
          bo: 'Keby otec dlhodobo nemohol pracovať, jeho príjem sa zastaví.',
          me: 'Keby mama dlhodobo nemohla pracovať, jej príjem sa zastaví.',
        },
        smrt: {
          bo: 'Keby tu otec nebol, jeho príjem rodine chýba natrvalo.',
          me: 'Keby tu mama nebola, jej príjem rodine chýba natrvalo.',
        },
      },
    },
    zaver: {
      nadpis: 'Dve cesty',
      nestane: 'Keď sa nič nestane — máte peniaze na starobu a nemusíte sa spoliehať na deti.',
      nestanePuvod: 'Vzniká len z investičnej časti: {investice} mesačne počas {roky}, celkom {zaplaceno}. Výnos nie je istý.',
      nestaneVek: 'v {vek} rokoch · model {vynos} %',
      stane: 'Keby sa niečo stalo — celá rodina je chránená.',
      stanePuvod: 'Platí sa z balíčka {balicek}: {ochrana} mesačne ide na ochranu. To je cena krytia a nevracia sa.',
      staneRiziko: {
        invalidita: '{kdo} · invalidita',
        smrt: '{kdo} · úmrtie',
      },
    },
  },
  /* BLOK:vnRodina END */
  /* BLOK:kalkLista START — generuje scratchpad/slovnik.py, ručně needitovat */
  kalkLista: {
    cekani: {
      aria: 'Hneď {hned}, pri odklade {pozdeji}, cena čakania {cena}. Stĺpec za každých 5 rokov, vrstva za každý blok vkladov.',
      blok: 'Vklady {od}.–{do}. rok',
      budeMit: 'O {roky} bude mať',
      hned: 'Hneď',
      horizont: 'Horizont',
      mesicne: 'Mesačne',
      otazkaHned: 'Keď začne hneď, o {roky} bude mať',
      otazkaPozde: 'Keď začne o {roky} neskôr, príde o',
      pracuji: 'Peniaze, ktoré pracujú',
      vetaHned: 'Každých 5 rokov vkladov je jedna vrstva — spodná pracuje najdlhšie.',
      vetaPozde: 'Na toľko by narástli vklady z prvých {roky} — pracujú najdlhšie.',
      vlozi: 'Vloží',
      vynos: 'Výnos ročne',
      zacne: 'Začne až o',
      ztrata: 'Strata čakaním',
    },
    dopl: {
      aria: 'Dlh {dluh} klesá, portfólio po dani rastie. Pretnú sa za {doba}, keď zostáva splatiť {castka}. Hraničný výnos {hranice}.',
      ariaNikdy: 'Dlh {dluh} klesá, portfólio po dani ho za {roky} nedobehne.',
      bublinaMim: 'Dlh s mimoriadnymi splátkami',
      chybiDo: 'Do splatenia chýba',
      hranice: 'Hraničný výnos',
      hraniceNad: 'nad 30 %',
      hraniceZnacka: 'hranica {pct}',
      investice: 'Investícia',
      investiceMes: 'Investícia mesačne',
      jistina: 'Zostáva splatiť',
      konecSplatnosti: 'koniec splatnosti',
      lzeDoplatit: 'dá sa splatiť',
      mimBezDluhu: 'Mimoriadne splátky: bez dlhu za',
      mimoradne: 'Mimoriadne splátky',
      nadInflaci: 'Nad infláciou',
      nastejno: 'Rovnako',
      nelze: 'So zadanými hodnotami sa nedá počítať — skontrolujte sadzbu a splatnosť.',
      nesplati: 'Pri tejto splátke sa hypotéka nesplatí ani za 80 rokov.',
      nevyslo: 'Za {roky} portfólio na splatenie nestačí — po predaji a dani chýba {castka}.',
      nominalne: 'Nominálne',
      nominalnePct: 'nominálne {pct}',
      otazka: 'Pri výnose {vynos} by investícia {castka} mesačne splatila hypotéku za',
      otazkaRealne: 'Pri výnose {vynos} nad infláciou by investícia {castka} mesačne splatila hypotéku za',
      poDani: 'po dani a poplatkoch',
      podleVynosu: 'Podľa výnosu',
      poznamka: 'Výnos investície nie je zaručený, splátka hypotéky áno. Daň z predaja podľa práva platného dnes.',
      poznamkaSk: 'Výnos investície nie je zaručený, splátka hypotéky áno. Daň z predaja investície nie je započítaná (pred daňou) — slovenské pravidlá appka zatiaľ nepočíta.',
      propad: 'Prepad 35 %',
      radaDluh: 'Zostávajúci dlh',
      radaMim: 'Mimoriadne splátky',
      radaPortfolio: 'Portfólio po dani',
      realne: 'reálne {pct}',
      rezim: 'Výnos zadaný',
      riziko: 'Riziko',
      sazba: 'Sadzba hypotéky',
      slRozdil: 'Portfólio − dlh',
      srovnatZa: 'Porovnať za',
      tabulkaPopis: 'Sumy v {mena} na konci roka · portfólio po dani a poplatkoch (spolu {naklady})',
      ter: 'Ročný poplatok (TER)',
      trh: 'Trh v roku porovnania',
      trhNic: 'Trh nedá nič',
      vetaChybi: 'dlžíte {dluh}, portfólio po dani {portfolio}, do splatenia chýba {chybi}.',
      vetaDnes: 'dlžíte {dluh}, investícia začína od nuly.',
      vetaSplaceno: 'hypotéka splatená, portfólio po dani {portfolio}.',
      vetaZbylo: 'dlžíte {dluh}, portfólio po dani {portfolio} — po splatení by zostalo {zbylo}.',
      vicNez: 'viac ako {roky}',
      vstupni: 'Vstupný poplatok',
      vyhodnejsi: 'Výhodnejšie za {roky}',
      vyhravaInvestice: 'vyhráva investícia',
      vyhravaSplaceni: 'vyhráva splácanie',
      vynos: 'Výnos ročne',
      vynosPodUrokem: 'Výnos {vynos} neprekoná úrok hypotéky {sazba} — oplatí sa splácať.',
      zbyloBy: 'Po splatení by zostalo',
      zbyvaLet: 'Zostáva rokov',
    },
    historie: {
      aria: 'Skutočný vývoj od {od} do {do}: vložené {vlozeno}, dnes {hodnota}.',
      dynamicky: 'Dynamické',
      hodnota: 'Hodnota',
      jednorazove: 'Jednorazovo',
      konzervativni: 'Konzervatívne',
      mesicne: 'Mesačne',
      otazka: 'Keby začal v roku {rok}, dnes by mal',
      otazkaObecna: 'Koľko by dnes mal',
      portfolio: 'Portfólio',
      roky: 'Koľko rokov späť',
      veta: 'Skutočný vývoj trhov {od}–{do}. Minulosť nezaručuje budúcnosť.',
      vklad: 'vklad',
      vlozeno: 'Vložené',
      vlozil: 'Vložil',
      vydelal: 'Zarobilo',
      vyvazeny: 'Vyvážené',
      zdroj: 'Zdroj dát: SBBI/Ibbotson (USA)',
    },
    hypo: {
      aria: 'Istina {uver} klesne za {roky} na nulu; na úrokoch zaplatíte spolu {urok}.',
      bezJinychUveru: 'bez iných úverov',
      bezPrijmu: 'príjem nezadaný',
      bezUveru: 'Vlastné zdroje pokryjú celú cenu — úver nie je potrebný.',
      bezVeku: 'vek nezadaný',
      bezZavazku: 'záväzky nezadané',
      bublinaJistina: 'Istina na konci roka',
      bublinaUroky: 'Úroky zaplatené spolu',
      celkem: 'Spolu zaplatíte',
      cena: 'Cena nehnuteľnosti',
      doporuceniNad: 'nad odporúčaním ČNB {limit}',
      doporuceniV: 'v rámci odporúčania ČNB {limit}',
      dstiCo: 'Splátky k čistému príjmu, odporúčanie ČNB',
      dstiCoBez: 'Splátky k čistému príjmu',
      dtiCo: 'Dlhy k ročnému príjmu, odporúčanie ČNB',
      dtiCoBez: 'Dlhy k ročnému príjmu',
      dtiCoNbs: 'Všetky úvery k ročnému čistému príjmu, záväzný limit NBS',
      jineNevyplneno: 'Nevyplnené',
      jineUvery: 'Iné úvery klienta',
      jineZadne: 'Žiadne',
      ltvCo: 'Úver k cene nehnuteľnosti, záväzný limit {regulator}',
      ltvNad: 'nad limitom {limit}',
      ltvV: 'v limite {limit}',
      minVlastni: 'min. {castka} (LTV {limit})',
      minVlastniRok: 'min. {castka} (LTV {limit} pri kúpe v roku {rok})',
      nbsLimit: 'limit NBS {limit}',
      nbsLimitNejvys: 'limit NBS najviac {limit}',
      nbsMaxUver: 'max. úver {castka}',
      nbsMaxUverNejvys: 'max. úver najviac {castka}',
      nbsNad: 'nad limitom NBS {limit}',
      nbsV: 'v limite NBS {limit}',
      otazka: 'Mesačná splátka',
      poznamkaCz: 'LTV je záväzný limit ČNB, DSTI a DTI sú len odporúčania ČNB.',
      poznamkaSk: 'LTV je záväzný limit NBS.',
      poznamkaSkNbs: 'LTV a DTI sú záväzné limity NBS.',
      radaJistina: 'Istina',
      radaUroky: 'Zaplatené úroky',
      sazba: 'Sadzba',
      slUmor: 'Úmor',
      slUrok: 'Zaplatený úrok',
      splatkaNevyplnena: 'splátka úveru nevyplnená',
      splatkyNadPrijem: 'Splátky prevyšujú čistý príjem o {castka} mesačne.',
      splatnost: 'Splatnosť',
      ukazatele: 'Ukazovatele úveru',
      ukazateleCnb: 'Ukazovatele ČNB',
      vetaDnes: 'dlžíte {jistina}, splátka {splatka} mesačne.',
      vetaRoku: 'dlžíte {jistina}, na úrokoch zaplatené {uroky}.',
      vlastni: 'Vlastné zdroje',
      zTohoJistina: 'Z toho istina',
      zTohoUrok: 'Z toho úrok',
      zustatekNevyplnen: 'zostatok úveru nevyplnený',
    },
    jakoVPlanu: 'ako v pláne',
    kostra: {
      celkem: 'Spolu',
      dnes: 'Dnes',
      grafOvladani: 'Šípkami vyberiete rok, Home a End skočia na začiatok a koniec.',
      grafRole: 'interaktívny graf',
      rok: 'Rok {n}',
      sloupecRok: 'Rok',
      tabulka: 'Tabuľka po rokoch',
      tabulkaPopis: 'Sumy v {mena}, stav na konci roka',
      zaRoky: 'Za {roky}',
    },
    letFew: '{n} roky',
    letMany: '{n} rokov',
    letOne: '{n} rok',
    mesFew: '{n} mesiace',
    mesMany: '{n} mesiacov',
    mesOne: '{n} mesiac',
    mesicne: 'mesačne',
    modelova: 'modelová hodnota',
    nezadano: 'nezadané',
    paticka: 'Orientačný výpočet, nie ponuka ani garancia. Nič sa neukladá do analýzy.',
    prebytek: 'voľné CF {castka}',
    prumerTrhu: 'priemer trhu',
    refi: {
      aria: 'Spolu zaplatí dnes {dnes}, po refinancovaní {nove}.',
      dnes: 'Dnes',
      jistina: 'Zostáva doplatiť',
      naklady: 'Náklady prevodu',
      nakladyPopisek: '+ {castka} náklady prevodu',
      nakladySerie: 'Náklady prevodu',
      novaSazba: 'Nová sadzba',
      nove: 'Po prevode',
      otazka: 'Po refinancovaní ušetrí',
      otazkaHorsi: 'Nová sadzba nie je nižšia — splátka stúpne o',
      splatkaDnes: 'Splátka dnes',
      splatkaNova: 'Nová splátka',
      staraSazba: 'Sadzba dnes',
      veta: 'Za {roky} ušetrí spolu {castka}; náklady sa vrátia za {mesice}.',
      vetaBezNakladu: 'Za {roky} ušetrí spolu {castka}.',
      vetaHorsi: 'Za {roky} zaplatí navyše {castka}.',
      zbyvaLet: 'Zostáva',
    },
    renta: {
      aria: 'Kapitál {kapital} na rentu {renta} mesačne. Za {roky} sa vyplatí {vyplaceno}, na konci zostane {zbude}.',
      bublinaKapital: 'Kapitál na konci roka',
      bublinaVyplaceno: 'Vyplatené spolu',
      cerpani: 'Čerpať',
      cerpaniNavzdy: 'Čerpanie navždy',
      cerpaniRoky: 'Čerpanie {roky}',
      navzdy: 'Navždy',
      otazka: 'Na rentu {castka} mesačne potrebuje',
      poznamka: 'Výnos nad infláciou, renta je v dnešných peniazoch. Výnos nie je zaručený.',
      renta: 'Renta mesačne',
      slKapital: 'Kapitál',
      slVyplaceno: 'Vyplatené spolu',
      vetaDnes: 'kapitál {kapital}, renta {renta} mesačne.',
      vetaNavzdy: 'Renta ide len z výnosu — kapitál zostane celý.',
      vetaRoku: 'kapitál {kapital}, vyplatené spolu {vyplaceno}.',
      vetaRoky: 'Za {roky} sa kapitál vyčerpá na nulu.',
      vynos: 'Výnos nad infláciou',
      vyplaceno: 'Vyplatené za {roky}',
      vyplacenoRada: 'Vyplatené renty',
      zbude: 'Na konci zostane',
      zustatek: 'Kapitál',
    },
    splac: {
      aria: 'Zostatok dlhu v čase: pôvodne do roku {puvodni}, s mimoriadnou splátkou do roku {novy}.',
      driv: 'Bez dlhu skôr o',
      mimoradna: 'Mimoriadna splátka',
      nad25: 'Nad 25 % istiny ročne môže banka účtovať poplatok.',
      nove: 'S mimoriadnou splátkou',
      otazka: 'Mimoriadnou splátkou ušetrí na úrokoch',
      puvodne: 'Pôvodne',
      rezim: 'Po mimoriadnej splátke',
      snizit: 'Znížiť splátku',
      splatkaZustava: 'Splátka zostáva',
      veta: 'Dlh zmizne v roku {novy} namiesto {puvodni}.',
      vetaDoplaceno: 'Mimoriadna splátka pokryje celý dlh.',
      vetaSnizit: 'Splátka klesne o {castka} mesačne až do konca.',
      zkratit: 'Skrátiť dobu',
    },
    tab: {
      cekani: 'Cena čakania',
      doplaceni: 'Hypotéka s investíciou',
      historie: 'Historická',
      hypoteka: 'Hypotéka',
      refinanc: 'Refinancovanie',
      renta: 'Renta',
      splaceni: 'Splatiť skôr',
    },
    upravit: '{popisek}: {hodnota}. Upraviť presne',
    vratitVychozi: 'Vrátiť predvolené hodnoty',
    zAnalyzy: 'z analýzy',
    zmensitKlavesa: 'Zmenšiť (kláves Z)',
    zvetsit: 'Zväčšiť kalkulačku',
    zvetsitKlavesa: 'Zväčšiť (kláves Z)',
  },
  /* BLOK:kalkLista END */
  /* BLOK:brifink START — generuje scratchpad/slovnik.py, ručně needitovat */
  brifink: {
    poTerminu: 'Po termíne ({datum})',
  },
  /* BLOK:brifink END */
  /* BLOK:planVek START — generuje scratchpad/slovnik.py, ručně needitovat */
  planVek: {
    doplnte: 'Doplňte vek klienta',
    proc: 'Bez dátumu narodenia sa nedá overiť výnimka pre mladých do 36 rokov, preto sa akontácia 10 % neponúka.',
  },
  /* BLOK:planVek END */
  /* BLOK:pojisteniPlan START — generuje scratchpad/slovnik.py, ručně needitovat */
  pojisteniPlan: {
    castCeny: 'zatiaľ len časť ceny',
    cenaCelkemNadpis: 'Poistné spolu',
    cenaCelkemPopis: 'Plán počíta len s cenou z ponuky poisťovne.',
    cenaChybiDeti: 'Cena detskej zmluvy chýba — plán odpočítava len dospelých.',
    cenaChybiOsoba: 'Cena pri {jmeno} chýba — plán odpočítava len zadanú časť.',
    cenaDeti: 'Cena detskej zmluvy',
    cenaDoplnte: 'Doplňte cenu z poisťovne',
    cenaOdPojistovny: 'Cena z ponuky poisťovne',
    chybiCena: 'chýba cena',
    detiZavazneNadStropem: 'Nad upisovacím limitom {strop} — overte v poisťovni.',
    jakProgrese: 'Ako funguje progresia',
    kalkCenyVarianta: 'Ceny pre variant {varianta} — každý variant má vlastnú ponuku.',
    mesicneProCilePoPojistnem: 'Mesačne na ciele (po poistnom)',
    naCile: 'Na ciele',
    nulaZdrojeKryji: 'Suma 0 = zdroje rodiny (príjem partnera, majetok) túto potrebu pokryjú.',
    orientacne: 'orientačne ≈ {castka} — plán s tým nepočíta',
    platbaNezadana: 'platba nezadaná',
    pojistneZmena: 'Poistné — zmena',
    pouzitProVsechny: 'Použiť pre všetky varianty',
    prebytekPoPojistnem: 'Prebytok po poistnom',
    prezBezCenyPozn: 'Sumy sú návrh krytia, nie ponuka poisťovne. Cenu aj rozsah plnenia vrátane výluk určí poisťovňa v zmluve a poistných podmienkach.',
    prezCenaPozn: 'Cena z ponuky, ktorú zadal poradca — konečnú cenu potvrdí poisťovňa v zmluve, keď posúdi zdravotný stav. Rozsah plnenia a výluky určujú poistné podmienky.',
    prezZavazneProc: 'jednorazová výplata na liečbu — dovolí prestať pracovať a liečiť sa',
    rozpocetPojistne: 'Poistné: dnes {stara} → nové {nova} ({rozdil})',
    rozpocetPojistneNove: 'Poistné nové {nova} — je v povinných výdavkoch',
    rucne: 'ručne',
    rusiSe: 'ruší sa',
    skrytProgresi: 'Skryť progresiu',
    staraZustava: 'stará zmluva zostáva',
    stareBezCeny: 'Rozdiel sa spočíta, keď zadáte cenu novej zmluvy.',
    stareBezKrytiZivota: 'Neodpočítava sa — nová zmluva tejto osobe nedáva krytie smrti ani invalidity, stará preto zostáva.',
    stareBezNahrady: 'Chýba cena — neodpočítava sa, túto osobu nová zmluva zatiaľ nekryje.',
    stareIdd: 'Starú zmluvu rušte až po prijatí novej, k výročiu, a dôvod zapíšte do záznamu zo stretnutia.',
    stareMajetekBezCeny: 'Uvoľní sa po zadaní ceny novej zmluvy.',
    stareMajetekBezNahrady: 'Žiadna nová zmluva ju nenahrádza — v pláne sa platí ďalej.',
    stareNadpis: 'Existujúce zmluvy',
    stareNespoctenoPartner: 'Neodpočítava sa — zabezpečenie partnera plán nespočítal (chýba dátum narodenia), zmluva preto zostáva.',
    stareNeznama: 'Doplňte platbu existujúcej zmluvy {nazev} — zatiaľ sa odpočítava celá nová cena.',
    stareNic: 'Poistné nové {nova} — žiadna existujúca zmluva sa neruší, odpočíta sa celé.',
    stareRozdil: 'Poistné: dnes {stara} → nové {nova} · odpočíta sa len rozdiel {rozdil}',
    tnuAria: 'Výplata trvalých následkov zo sumy {castka}: pri {pct} % poškodenia sa vyplatí {vyplata}, pri 100 % najviac {max}.',
    tnuOrientacne: 'Orientačne — pásma aj násobky sa v poisťovniach líšia, presnú tabuľku plnenia má poisťovňa.',
    tnuPasmo: 'pásmo ×{n}',
    tnuPoskozeni: 'Poškodenie {pct} %',
    tnuPri: 'pri {pct} %',
    tnuVolby: 'Poistná suma trvalých následkov',
    tnuVyplati: 'vyplatí sa',
    tnuVysvetleni: 'V našom modeli sa každé pásmo násobí zvlášť: do 20 % ×1, 20–40 % ×2, 40–60 % ×3, nad 60 % ×4. Pri 100 % je to najviac {max}× sumy.',
    vetaNad: 'Poistné navyše {rozdil} je viac ako mesačný prebytok {prebytek} — na ciele nezostáva nič.',
    vetaNove: 'Poistné {nova} · na ciele {naCile}',
    vetaZmena: 'Poistné: dnes {stara} → nové {nova} ({rozdil}) · na ciele {naCile}',
    vydajeNezbytne: 'nevyhnutné výdavky',
    vydajeObvykle: 'obvyklé výdavky',
    vydajeSplatkyPojistne: 'Výdavky + splátky + poistné',
    vydajeZObvyklych: 'Nevyhnutné výdavky nie sú zadané — variant {varianta} počíta s 90 % obvyklých.',
    zadanaCast: 'zadaná časť',
    zaverOchranaPovinne: 'ochrana {nova} — v povinných výdavkoch',
    zaverOchranaZmenaPovinne: 'ochrana dnes {stara} → novo {nova} — v povinných výdavkoch',
    zaverZVolnehoCf: 'Čo to stojí z voľného cash flow',
    zoVolby: 'Koľko rokov čistého príjmu',
    zustava: 'zostáva',
  },
  /* BLOK:pojisteniPlan END */
  /* BLOK:minimumSmrti START — generuje scratchpad/slovnik.py, ručně needitovat */
  minimumSmrti: {
    ariaHodnotaNaklad: '{castka} mesačne',
    ariaNaklad: 'Mesačný náklad na dieťa {jmeno}',
    ariaPruh: 'Minimum {castka}: {casti}',
    ariaVek: 'Do koľkých rokov rodina živí dieťa {jmeno}',
    bezPrijmu: 'bez príjmu',
    bezPrijmuText: 'Bez príjmu — poistka na smrť doplatí aspoň dlhy rodiny.',
    dluhy: 'dlhy',
    doVekuFew: '{n} roky',
    doVekuMany: '{n} rokov',
    doVekuOne: '{n} rok',
    kalkVeta: 'Minimum {castka} = dlhy {dluhy} + 1 rok príjmu rodiny {prijem} + deti {deti}',
    kalkVetaBezDeti: 'Minimum {castka} = dlhy {dluhy} + 1 rok príjmu rodiny {prijem}',
    kalkVetaSablona: 'Minimum {castka} = dlhy {dluhy} + 1 rok príjmu rodiny {prijem} + deti {deti} — pri deťoch odhad podľa šablóny ({naklad} mesačne na dieťa do {vek} rokov), nie údaj z analýzy',
    klientSrovnani: 'Pre prípad smrti vychádza {smrt}, o {rozdil} viac než na invaliditu. Je to minimum, pod ktoré krytie smrti nejde: dlhy, rok príjmu rodiny a deti do samostatnosti.',
    klientSrovnaniBezDeti: 'Pre prípad smrti vychádza {smrt}, o {rozdil} viac než na invaliditu. Je to minimum, pod ktoré krytie smrti nejde: dlhy a rok príjmu rodiny.',
    klientSrovnaniSmrtVyssi: 'Pre prípad smrti vychádza {smrt}, o {rozdil} viac než na invaliditu. Obe sumy majú na zmluve svoje miesto — každá kryje inú situáciu.',
    letFew: '{n} roky',
    letMany: '{n} rokov',
    letOne: '{n} rok',
    metodou: 'Metódou vychádza {castka} — platí minimum:',
    nakladChybi: 'náklad na dieťa chýba — doplňte ho do výdavkov (kategória Deti)',
    nakladDite: 'Náklad na dieťa / mes.',
    nakladHint: 'prázdne = šablóna {castka}',
    nakladHintBez: 'doplňte — šablóna pre túto krajinu nie je',
    podMinimem: 'Pod minimom {castka} (dlhy + 1 rok príjmu rodiny + deti) — zadané ručne, vedome.',
    podMinimemBezPrijmu: 'Pod minimom {castka} (doplatenie dlhov) — zadané ručne, vedome.',
    posuvnikNaklad: 'Mesačne',
    posuvnikVek: 'Do veku',
    pozn: 'Minimum: dlhy + 1 rok príjmu rodiny + deti do samostatnosti',
    poznBezPrijmu: 'Minimum: doplatenie dlhov (bez príjmu)',
    prezProc: 'Najmenej toľko: dlhy {dluhy} + 1 rok príjmu rodiny {prijem} + deti do samostatnosti {deti}.',
    prezProcBezDeti: 'Najmenej toľko: dlhy {dluhy} + 1 rok príjmu rodiny {prijem}.',
    prezProcBezPrijmu: 'Najmenej toľko: doplatenie dlhov {dluhy}.',
    prezProcSablona: 'Najmenej toľko: dlhy {dluhy} + 1 rok príjmu rodiny {prijem} + deti do samostatnosti {deti} — pri deťoch odhad podľa šablóny ({naklad} mesačne na dieťa do {vek} rokov), nie údaj z analýzy.',
    prijemRok: '1 rok príjmu rodiny',
    radekDite: '{jmeno}, {vek}: {naklad} × {roky} =',
    radekDiteBezVeku: '{jmeno}, vek nezadaný: {naklad} × {roky} =',
    radekDluhy: 'Doplatiť dlhy',
    radekPrijem: '1 rok príjmu rodiny: {mes} × 12 =',
    sablona: 'šablóna {castka} mesačne na dieťa',
    stavMetoda: 'Metódou vychádza viac ({castka}) — platí vyššia suma.',
    stavMinimum: 'Metódou vychádza {castka} — platí minimum.',
    stitek: 'minimum',
    titul: 'Minimum krytia smrti',
    vekDeti: 'Vek detí (roky)',
    vekDitete: '{n}. dieťa',
    vekFew: '{n} roky',
    vekHint: 'prázdne = od narodenia',
    vekMany: '{n} rokov',
    vekNeznamy: 'vek dieťaťa nezadaný — počítané od narodenia',
    vekOne: '{n} rok',
    vetaBezPrijmu: 'Minimum {castka} = doplatenie dlhov — bez príjmu sa rok príjmu ani deti nepočítajú',
    vratit: 'Vrátiť',
    vratitAria: 'Vrátiť {jmeno} na hodnotu z analýzy',
    vystupMetodika: 'Pri smrti platí minimum, keď kapitálová metóda vyjde nižšie.',
    zCeho: 'Z čoho sa skladá minimum',
    zCehoSkryt: 'Skryť zloženie minima',
    zadano: '{castka} mesačne na dieťa',
    zdrojAnalyza: 'z analýzy',
    zdrojSablona: 'šablóna',
    zdrojUpraveno: 'upravené',
  },
  /* BLOK:minimumSmrti END */
  /* BLOK:analyzaCisla START — generuje scratchpad/slovnik.py, ručně needitovat */
  analyzaCisla: {
    auto: {
      chybiCil: 'V cieľoch chýba obmena auta. Vaše auto má dnes hodnotu {castka} — k nej sa o pár rokov budete vracať.',
      maCil: 'Cieľ na auto máte. Držte ho okolo {castka} — v tejto cenovej hladine jazdíte dnes.',
      nadpis: 'Obmena auta',
    },
    bydleni: {
      bezStropu: 'Cieľ na bývanie {cil} je {nasobek}× váš ročný príjem.',
      limitNbs: 'Na bývanie potrebujete úver {uver}. Limit NBS pre všetky vaše úvery je {limit} ({max}× ročný čistý príjem).',
      limitNbsSDluhy: 'Na bývanie potrebujete úver {uver}. Limit NBS pre všetky vaše úvery je {limit} ({max}× ročný čistý príjem), po ostatných úveroch ({dluhy}) zostáva {strop}.',
      limitNbsVek: 'Podľa veku môže byť limit nižší.',
      nadpis: 'Cena bývania',
      strop: 'Cieľ na bývanie {cil} je {nasobek}× váš ročný príjem. Strop je {max}×, teda {strop}.',
    },
    jednotky: {
      mil: 'mil.',
    },
    odkladani: {
      chybi: 'Do minima {min} % chýba {chybi} mesačne.',
      dnes: 'Dnes ide bokom {pct} % príjmu.',
      dohodnuto: 'S odsúhlasenými {castka} mesačne pôjde bokom {pct} % príjmu.',
      dohodnutoVklady: 'S odsúhlasenými {castka} mesačne a pravidelnými vkladmi {vklady} pôjde bokom {pct} % príjmu.',
      ideal: 'To je ideál {ideal} %. Pri {rychle} % sa ciele plnia veľmi rýchlo.',
      minimum: 'Minimum {min} % je splnené, ideál je {ideal} %.',
      nadCilem: 'To je {rychle} % a viac — ciele sa plnia veľmi rýchlo.',
      nadpis: 'Koľko ide bokom',
      schodek: 'Výdavky a splátky sú vyššie ako príjmy, bokom teraz nejde nič.',
    },
    panel: {
      cerpani: 'čerpanie',
      kProjednani: '{n} na prejednanie',
      kapital: 'Potrebný kapitál',
      nadpis: 'Čo z čísel vyplýva',
      orientacni: 'orientačné',
      orientacniTitle: 'Odhad, nie garantovaná hodnota',
      vseOk: 'všetko v poriadku',
    },
    renta: {
      bezHypoteky: 'Hypotéku doplatíte do roku {rok}, v rente ju nepočítame.',
      bezSplatek: 'Bez splátok, ktoré do renty doplatíte.',
      bezSplatekISporeni: 'Bez splátok, ktoré do renty doplatíte, a bez dnešného sporenia.',
      bezSporeni: 'Bez dnešného sporenia.',
      chybiCil: 'V cieľoch chýba renta. Dnes miniete {vydaje} mesačne — toľko by renta mala uživiť.',
      chybiCilSplatky: 'V cieľoch chýba renta. Dnes miniete {vydaje} a splácate {splatky} mesačne — renta by mala uživiť {potreba}.',
      doplnUrokHypoteky: 'Pri hypotéke doplňte úrok — potom spočítame, či skončí pred rentou.',
      doplnUrokUveru: 'Pri úvere doplňte úrok — potom spočítame, či skončí pred rentou.',
      doplnZustatekHypoteky: 'Pri hypotéke doplňte zostatok a úrok — potom spočítame, či skončí pred rentou.',
      doplnZustatekUveru: 'Pri úvere doplňte zostatok a úrok — potom spočítame, či skončí pred rentou.',
      nadpis: 'Cieľ renty vs. výdavky',
      nesedi: 'Cieľ renty je {zadano}, ale dnes miniete {vydaje} mesačne. Chýba {rozdil}.',
      nesediSplatky: 'Cieľ renty je {zadano}, ale výdavky so splátkami sú {potreba} mesačne. Chýba {rozdil}.',
      odvozena: 'Cieľ renty nie je zadaný — počítame s dnešnými výdavkami a splátkami, bez splátok, ktoré do renty doplatíte, a bez dnešného sporenia.',
      sedi: 'Cieľ renty {zadano} pokryje dnešné výdavky {vydaje}.',
      sediSplatky: 'Cieľ renty {zadano} pokryje dnešné výdavky so splátkami {potreba}.',
    },
    rezerva: {
      doplnit: 'Doplníme nevyhnutné výdavky a vypočítame z nich rezervu.',
      nadpis: 'Likvidná rezerva',
      poRuce: 'Poruke máte {likvidni}, teda na {mesicu} mesiaca.',
      poRuceBezMesicu: 'Poruke máte {likvidni}.',
      pravidlo: 'Rezerva ({m}× nevyhnutné výdavky a splátky) je {potreba}.',
      vlastniCil: 'Váš cieľ rezervy je {cil}.',
      vlastniCilPravidlo: 'Podľa pravidla {m}× nevyhnutné výdavky a splátky by to bolo {potreba}.',
    },
    stav: {
      chybi: 'Na riešenie',
      info: 'Pre informáciu',
      ok: 'Splnené',
      pozor: 'Nad limitom',
    },
    zivotni: {
      nadpis: 'Životné poistenie',
      platba: 'Za ochranu príjmu platíte {castka} mesačne.',
      platbaPodil: 'Za ochranu príjmu platíte {castka} mesačne, teda {podil} % príjmu.',
    },
  },
  /* BLOK:analyzaCisla END */
  /* BLOK:analyzaStranka START — generuje scratchpad/slovnik.py, ručně needitovat */
  analyzaStranka: {
    cesta: {
      orientacniKlient: 'Orientačný model, nie garancia.',
    },
    coBudeLabel: 'Body, ktoré budú nasledovať',
    detiFew: '{n} deti',
    detiMany: '{n} detí',
    detiOne: '{n} dieťa',
    firmaNema: 'Klient nemá firmu ani podnikanie',
    jmenoKlienta: 'Meno (Klient {n})',
    kompletnostChybi: 'Pre presný plán chýba: {seznam}.',
    mostek: '„Ak vám finančný plán splní **tieto ciele**, bude to pre vás správne riešenie?“',
    napoveda: {
      auto: 'Sporí sa na rozdiel: cena ďalšieho auta mínus to, čo utŕžite za súčasné. Keď budete mať viac, cieľ upravíme.',
      bydleni: '{prijem} čistého × 12 × {nasobek} = {castka} (strop ČNB). Reálne — z dnešného bývania na podobné, nie palác.',
      bydleniBezRegulatora: 'Cena bývania má zodpovedať čistému príjmu domácnosti. Reálne — z dnešného bývania na podobné, nie palác.',
      bydleniChybi: 'Férová cena bývania ≈ {nasobek}× ročný čistý príjem. Na výpočet stropu chýbajú príjmy.',
      bydleniNad: 'Nad odporúčaním ČNB ({strop}) — hypotéka nemusí vyjsť.',
      bydleniNadNbs: 'Úver {uver} je nad limitom NBS ({strop}) — banka ho dá len výnimočne.',
      bydleniNadNbsVycerpano: 'Na nový úver {uver} z limitu NBS nič nezostáva — banka ho dá len výnimočne.',
      bydleniNadNbsZbyva: 'Úver {uver} je viac, než z limitu NBS zostáva ({strop}) — banka ho dá len výnimočne.',
      bydleniNbs: 'Limit NBS: všetky úvery spolu najviac {max}× ročný čistý príjem = {limit}.',
      bydleniNbsBezDluhu: 'Počítané bez ostatných úverov.',
      bydleniNbsChybiPrijem: 'Limit NBS sa počíta len z preukázateľného a ostatného príjmu klientov — doplňte ich.',
      bydleniNbsDluhyChybi: 'Limit NBS platí pre všetky úvery spolu — doplňte zostatky ostatných úverov.',
      bydleniNbsPravidlo: 'Limit NBS: všetky úvery spolu najviac {max}× ročný čistý príjem.',
      bydleniNbsSDluhy: 'Limit NBS: všetky úvery spolu najviac {max}× ročný čistý príjem = {limit}. Po odpočítaní ostatných úverov ({dluhy}) zostáva na nový úver {strop}.',
      bydleniNbsVek: 'Od 41 rokov je limit nižší, ak úver končí po 65. roku veku — doplňte dátum narodenia.',
      bydleniNbsVycerpano: 'Ostatné úvery ({dluhy}) už vyčerpali celý limit NBS ({max}× ročný príjem).',
      bydleniOrientacni: 'Férová cena bývania ≈ {nasobek} × 12 × {prijem} = {castka}.',
      bydleniPravidlo: 'Férová cena bývania ≈ {nasobek}× ročný čistý príjem.',
      doporucit: 'Odporučiť {castka}',
      naHistorii: 'Na histórii',
      naHistoriiTitul: 'Ukázať na reálnych dátach 1928–2025',
      orientacniPrijem: 'Orientačne čistý príjem domácnosti',
      ostatni: 'Čo – kedy – koľko, v dnešných cenách.',
      renta: '{vydaje} výdavky + {splatky} splátky = {castka} mesačne. Renta musí uživiť ten istý život, aký žijete dnes — nie len to nutné.',
      rentaBezHypoteky: '{vydaje} výdavky + {splatky} splátky = {castka} mesačne — hypotéku doplatíte do roku {rok}, v rente nie je. Renta musí uživiť ten istý život, aký žijete dnes.',
      rentaBezHypotekyBezSplatek: '{vydaje} výdavky = {castka} mesačne — hypotéku doplatíte do roku {rok}, v rente nie je. Renta musí uživiť ten istý život, aký žijete dnes.',
      rentaBezSplatek: '{vydaje} výdavky = {castka} mesačne. Renta musí uživiť ten istý život, aký žijete dnes — nie len to nutné.',
      rentaChybi: 'Renta = celé dnešné výdavky vrátane splátok a životného štýlu. Na výpočet chýbajú výdavky.',
      rentaNizka: 'Výdavky so splátkami sú len {pct} % príjmu — vo výdavkoch asi niečo chýba.',
      rentaVysoka: 'Výdavky so splátkami sú {pct} % príjmu — prevyšujú príjem.',
      rezerva: '({nezbytne} nevyhnutné výdavky + {splatky} splátky) × {mesicu} = {castka}. Pásmo {min}–{castka} podľa toho, aký istý máte príjem.',
      rezervaBezSplatek: '{nezbytne} nevyhnutné výdavky × {mesicu} = {castka}. Pásmo {min}–{castka} podľa toho, aký istý máte príjem.',
      rezervaChybi: 'Rezerva = 3–6× nevyhnutné výdavky + splátky. Na výpočet chýbajú nevyhnutné výdavky.',
      vzdelani: '{mesicne} mesačne × {mesicu} mesiacov × {let} = {castka}. Štúdium v ČR {od}–{do}, v zahraničí zhruba dvaapolkrát toľko.',
      vzdelaniDeti: '{mesicne} mesačne × {mesicu} mesiacov × {let} × {deti} = {castka}. Štúdium v ČR {od}–{do}, v zahraničí zhruba dvaapolkrát toľko.',
      vzdelaniJednoDite: '{mesicne} mesačne × {mesicu} mesiacov × {let} = {castka} na jedno dieťa. Štúdium v ČR {od}–{do}, v zahraničí zhruba dvaapolkrát toľko.',
      vzdelaniJinaMena: 'Štúdium detí: mesačné náklady × mesiace v roku × roky štúdia. Štúdium v zahraničí vychádza zhruba dvaapolkrát drahšie.',
    },
    penzijko: {
      dpsDip: '(DPS {dps} + DIP {dip})',
      jenDip: '(DIP — od prvej koruny)',
      jenDps: '(vklad nad {hranice} mesačne)',
      nadLimit: 'nad ročný strop {limit}: {castka} sa neuplatní',
      odpocet: 'Daňovo odpočítateľné',
      statni: 'Štátny príspevok (DPS)',
      zaMesic: '{castka}/mes',
      zaRok: '{castka}/rok',
    },
    prebytekSouhlas: '„Súhlasíte, že {castka} mesačne môžeme použiť pre vaše ciele?“',
    skript: {
      cas: 'Po telefóne sme sa dohodli, že budeme mať **45 minút**. U mňa sa nič nezmenilo — len chcem overiť, že aj vy počítate so 45 minútami.',
      cile: '„Pozrime sa na strategické ciele v štruktúre **ČO – KEDY – KOĽKO**. Čo vás napadá ako prvé?“ Ak klient nespomenie, overte **bývanie**, **vzdelanie detí** a **finančnú nezávislosť**.',
      ocekavani: '„Čo očakávate od dnešného stretnutia?“ → zopakujte klientove slová a dodajte: „Mojím cieľom je overiť, **čo už robíte dobre**, **kde možno prichádzate o peniaze** a **čo môžete robiť lepšie**.“',
      penize: '„Začnem netradičnou otázkou: **Čím sú pre vás peniaze dôležité?**“ → zopakujte slovo („sloboda… čo znamená pre vás?“) a dopýtajte sa: „Čo ďalšie vás napadne?“',
      pojistky: '„Aké máte aktuálne **poistné zmluvy** — životné, úrazové, majetkové, auto? Pri každej ma zaujíma poisťovňa, číslo zmluvy, mesačná platba a výročie.“ Po uložení sa zmluvy objavia v priečinku klienta a dá sa z nich rovno generovať výpoveď.',
      prijmy: '„Ďalším veľmi dôležitým zdrojom pre naplnenie vašich cieľov sú **vaše príjmy**. Koľko máte mesačne zo zamestnania?“ (bonusy = priemer za 2–3 roky)',
      rizika: '„V rámci finančného plánu sa pozrieme aj na vaše **zaistenie**. Prejdeme, čo máte dnes — **čo kryje a čo nie**. Overíme, či sa dá **ušetriť** alebo poistiť múdrejšie. A ukážem vám, ako bude zaistenie vyzerať v **celom pláne**: rodina, ciele, rezerva.“',
      vydaje: '„Koľko si myslíte, že ste schopní mesačne **ušetriť**?“ — výdavky nepitvajte do detailu. Kontrola: výdavky ≈ požadovaná renta; príjmy − výdavky = voľné cash flow.',
      zavazky: '„Dôležitou informáciou pre naplnenie cieľov sú **záväzky**. Prvými sú hypotekárne úvery — úvery na bývanie, potom ďalšie.“',
      zaver: '„Napadá vás niečo dôležité, na čo som sa zabudol spýtať? {veta}“',
      zdroje: '„**Ďalším zdrojom** pre naplnenie vašich cieľov sú **peniaze, ktoré už máte**: stavebné sporenie, dôchodkové sporenie, investície, účty a majetok. Prejdeme ich spolu — začneme stavebným sporením. Využívate ho?“',
    },
    smazatDite: 'Zmazať dieťa',
  },
  /* BLOK:analyzaStranka END */
  /* BLOK:kinoMetodika START — generuje scratchpad/slovnik.py, ručně needitovat */
  kinoMetodika: {
    APPROVED: 'Z dát klienta',
    CANDIDATE: 'Čaká na schválenie metodiky',
    PROVISIONAL: 'Pracovné tvrdenie — bez doloženého zdroja',
  },
  /* BLOK:kinoMetodika END */
  /* BLOK:analyzaPrijmy START — generuje scratchpad/slovnik.py, ručně needitovat */
  analyzaPrijmy: {
    bonusy: 'Bonusy / 13. plat (ročne)',
    chybiJmeno: 'chýba meno',
    domacnost: 'Spoločné pre domácnosť',
    forma: 'Forma príjmu',
    jinaForma: 'zadané skôr — patrí k inej forme, presuňte alebo zmažte',
    klient: 'Klient {n}',
    osobaCelkem: 'Príjem osoby za mesiac',
    pasivni: 'Pasívne príjmy (nájmy…)',
    pole: {
      davky: 'Dôchodok, rodičovský príspevok, dávky',
      mzdaFirma: 'Čistá mzda z vlastnej firmy',
      ostatniJiny: 'Dohody, výživné a ostatné',
      osvcOstatni: 'Podnikanie (SZČO) a ostatné',
      podilyFirma: 'Podiely na zisku a ostatné',
      podnikani: 'Čistý príjem z podnikania',
      vedlejsiOsvc: 'Vedľajšie príjmy (mzda, dôchodok, rodičovský príspevok)',
      vedlejsiZam: 'Vedľajšie príjmy (dohody, výživné, živnosť)',
      zamestnani: 'Čistý príjem zo zamestnania',
    },
    poleKlient: '{pole} — klient {n}',
    prace: 'Čo robí za prácu',
    pracePh: 'napr. vodič, účtovníčka, vlastná reštaurácia',
    pridatDruhou: 'Druhá osoba',
    pridatVedlejsi: 'Vedľajší príjem',
  },
  /* BLOK:analyzaPrijmy END */
  /* BLOK:prebytekModel START — generuje scratchpad/slovnik.py, ručně needitovat */
  prebytekModel: {
    mesicneProCile: 'Mesačne na ciele',
    neodsouhlaseno: 'zatiaľ neodsúhlasené klientom',
    planNespocita: 'Bez príjmov plán riešenie nevypočíta — doplňte príjmy alebo odsúhlasenú sumu.',
    planPocita: 'Plán zatiaľ počíta s {castka}',
    pravidloNula: 'Splátky úverov spotrebujú celý príjem, takže ani 20 % príjmu nemá plán z čoho vziať. Doplňte v analýze výdavky alebo sumu, ktorú ste si s klientom odsúhlasili.',
    zdrojDopocet: 'model: príjmy − výdavky − splátky',
    zdrojPravidlo: 'model: 20 % čistého príjmu',
  },
  /* BLOK:prebytekModel END */
  /* BLOK:vysvetleniInfo START — generuje scratchpad/slovnik.py, ručně needitovat */
  vysvetleniInfo: {
    aria: 'Vysvetlenie: {nazev}',
    cipVyberteOsobu: 'vyberte osobu pri poistke',
    jakCistPredAPo: 'Ako čítať porovnanie',
    jakSeCastkyPocitaji: 'Ako sa sumy počítajú',
    rucniKratce: 'Ceny a sumy prepíšete ceruzkou',
  },
  /* BLOK:vysvetleniInfo END */
  /* BLOK:cilDeti START — generuje scratchpad/slovnik.py, ručně needitovat */
  cilDeti: {
    doAnalyzy: 'Doplniť v analýze',
    pridat: 'Pridať dieťa',
    upozorneni: 'Máte cieľ pre deti, ale žiadne dieťa nie je zapísané — doplňte ho (meno, narodenie).',
  },
  /* BLOK:cilDeti END */
  /* BLOK:cilHned START — generuje scratchpad/slovnik.py, ručně needitovat */
  cilHned: {
    badgeNavrh: 'návrh',
    bezMesicniInvestice: 'bez mesačnej investície',
    bezMesicniInvesticeVelke: 'Bez mesačnej investície',
    brzdaChybi: 'Zvyšok {chybi} dnešné zdroje nepokryjú — vybrať ďalší zdroj, posunúť termín alebo dosporiť z prebytku.',
    coSTim: 'Čo s tým:',
    dalsiZdroj: 'ďalší zdroj doplňte v analýze (účty, termínovaný vklad, stavebné sporenie)',
    doMesKDispozici: 'Do ~{mesicu} mes. k dispozícii:',
    dosporeni: 'Dosporenie z prebytku',
    dosporitNabidka: 'dosporiť {castka} mesačne počas {mesicu} mes.',
    hnedKDispozici: 'Hneď k dispozícii:',
    jakBezMesicni: 'Riešenie: zatiaľ bez mesačnej investície.',
    jakDosporit: 'Riešenie: {jedn} jednorazovo zo zdrojov a {prav} mesačne počas {mesicu} mes.',
    jakDosporitBezZdroju: 'Riešenie: {prav} mesačne počas {mesicu} mes.',
    krytoJenZeZdroju: 'cieľ „hneď“ sa kryje len z peňazí, ktoré klient má.',
    mesicu: 'mes.',
    nulaRespektovana: 'Bez mesačnej investície — rozhodnutie poradcu, návrh sa nevracia.',
    odebratZdroj: 'Nebrať tento zdroj na tento cieľ',
    poDobu: 'počas',
    poMesicich: 'Po {mesicu} mes. dosporenia:',
    pocetMesicu: 'Počet mesiacov',
    posunoutNaRok: 'posunúť termín na 1 rok',
    povinnaRezerva: 'Povinná likvidná rezerva',
    prebytekNestaci: 'na dosporenie nie je voľný prebytok',
    pridatZdroj: 'Pridať zdroj:',
    rozdelovnikHned: 'Cieľ „hneď“ sa kryje len zo zdrojov — dosporenie z prebytku sa volí v karte cieľa v Návrhu riešenia.',
    terminSankce: 'predčasný výber môže stáť sankciu',
    vychaziDoMes: '— zo zdrojov do ~{mesicu} mes.',
    vychaziHned: '— hneď zo zdrojov.',
    vychaziSDosporenim: '— zo zdrojov a z dosporenia.',
    vysledekChybi: 'Hneď k dispozícii {konec} — chýba {chybi} ({pct} % cieľa).',
    vysledekChybiDoMes: 'Do ~{doMes} mes. k dispozícii {konec} — chýba {chybi} ({pct} % cieľa).',
    vysledekDosporitChybi: 'Hneď {hned}, po {mesicu} mes. dosporenia {konec} — chýba {chybi} ({pct} % cieľa).',
    vysledekDosporitChybiDoMes: 'Do ~{doMes} mes. {hned}, po {mesicu} mes. dosporenia {konec} — chýba {chybi} ({pct} % cieľa).',
    vysledekDosporitOk: 'Hneď {hned}, po {mesicu} mes. dosporenia {konec} — cieľ pokrytý na {pct} %.',
    vysledekDosporitOkDoMes: 'Do ~{doMes} mes. {hned}, po {mesicu} mes. dosporenia {konec} — cieľ pokrytý na {pct} %.',
    vysledekOk: 'Hneď k dispozícii {konec} — cieľ pokrytý na {pct} %.',
    vysledekOkDoMes: 'Do ~{doMes} mes. k dispozícii {konec} — cieľ pokrytý na {pct} %.',
    zVasichPenez: 'z vašich peňazí',
    zadneZdroje: 'Žiadne — klient nemá okamžite dostupné peniaze.',
    zdrojTermin: 'Termínovaný vklad',
  },
  /* BLOK:cilHned END */
  /* BLOK:zdrojNazev START — generuje scratchpad/slovnik.py, ručně needitovat */
  zdrojNazev: {
    bezny: 'bežný účet',
    fondy: 'fondy a investičné životné poistenie',
    fondyRezerva: 'doplní sa z fondov',
    fondyUzel: 'Fondy a investičné životné poistenie',
    fondyZbytek: 'zvyšok po doplnení rezervy',
    hotovost: 'hotovosť',
    penzijko: 'dôchodkové sporenie (dostupné od {vek} rokov)',
    sporici: 'sporiaci účet',
    stavebko: 'stavebné sporenie',
    stavebkoZruseni: 'zrušenie trvá ~{mesicu} mes.',
    termin: 'termínovaný vklad',
  },
  /* BLOK:zdrojNazev END */
  /* BLOK:navrhC9 START — generuje scratchpad/slovnik.py, ručně needitovat */
  navrhC9: {
    krokyUvodBezPlanu: 'Čo urobiť, v tomto poradí:',
  },
  /* BLOK:navrhC9 END */
  /* BLOK:metodikaPlanu START — generuje scratchpad/slovnik.py, ručně needitovat */
  metodikaPlanu: {
    bezZmeny: 'U tohto klienta sa čísla nezmenia.',
    coJeJinak: 'Čo je v novej metodike inak:',
    coSeZmeni: 'Po prepočte sa u tohto klienta zmení:',
    coSeZmenilo: 'Prepočtom sa u tohto klienta zmenilo:',
    dalsiCile: 'Ďalšie ciele:',
    dalsiZmeny: 'Ďalšie zmeny a čo je v novej metodike inak',
    mesicne: 'mesačne',
    prepocitano: 'Prepočítané podľa novej metodiky.',
    prepocitat: 'Prepočítať podľa novej metodiky',
    pruhStary: 'Plán je vypočítaný podľa metodiky pred {datum}.',
    vraceno: 'Plán opäť počíta podľa metodiky pred {datum}.',
    vratit: 'Vrátiť pôvodný výpočet',
    vratitTitulek: 'Vrátiť sa dá, kým neodídete z Návrhu riešenia.',
    zmenaAkontaceSK: 'Slovensko: akontácia podľa NBS — pri kúpe do konca roka 2026 istých 80 % LTV, od roku 2027 stačí 10 % len pri prvom bývaní: každému žiadateľovi najviac 35 rokov (druhý klient bez dátumu narodenia podmienku nesplní), žiadny byt ani dom na bývanie ani na prenájom a žiadna hypotéka v záväzkoch.',
    zmenaAkontaceVek: 'Akontácia 10 % (výnimka pre mladých) sa posudzuje podľa veku v roku kúpy (dnešný vek + roky do cieľa), nie podľa dnešného veku.',
    zmenaCilBezTerminu: 'Cieľ bez termínu nedostane peniaze z účtov ani mesačnú sumu — výstupy napíšu „doplňte termín“ a peniaze zostanú cieľom s termínom.',
    zmenaCilHned: 'Cieľ „hneď“ (0 rokov) sa kryje len z peňazí, ktoré klient má — mesačnú investíciu systém sám nepridá, len ju ponúkne.',
    zmenaDosporeniStupne: 'Po dosporení rezervy za zvolený počet mesiacov dostanú ďalšie ciele uvoľnené peniaze od konca dosporenia — stupňovito, nie najmenšiu sumu na celú dobu. Navýšenie aj rok, od kedy platí, sa tlačí do Plného plánu a na 1 stranu.',
    zmenaFondyDoRenty: 'Podielové fondy, akcie a životné poistenie s hodnotou (odkupné), ktoré klient už má, idú do prvej renty — len raz, aj keď sú renty dve — a do jej začiatku rastú podľa profilu renty. Poradca ich môže v toku peňazí poslať na iný cieľ. Predtým ich plán nepriradil k žiadnemu cieľu.',
    zmenaFondyDoRezervy: 'Keď klientovi chýba rezerva a má podielové fondy, ETF alebo akcie, plán z nich najprv doplní chýbajúcu časť rezervy (len tú, nikdy viac) a až zvyšok fondov ide do renty. Investičné životné poistenie do rezervy nejde — odkupné je až po výpovedi zmluvy. Predtým išli všetky fondy do renty a rezerva čakala na dosporenie z prebytku.',
    zmenaHrubaZCiste: 'Nemocenské (pracovná neschopnosť) sa počíta z hrubej mzdy dopočítanej z čistej podľa daní a poistného 2026 (po pásmach), nie z čistej × 1,39. Zárobkovo činný človek mladší ako 22 rokov má na invalidný dôchodok nárok.',
    zmenaInvaliditaBezPrijmu: 'Rodič bez príjmu má krytie invalidity len na o 20 % vyššie výdavky domácnosti mínus invalidný dôchodok, ak naň má nárok — rovnako ako prvá aj druhá osoba.',
    zmenaInvaliditaNikdoNevydelava: 'Keď v domácnosti nikto nezarába, krytie invalidity sa nepočíta a plán napíše „bez príjmu – krytie invalidity nepočítame, doplňte príjem“.',
    zmenaInvaliditaNulaTisk: 'Rodič bez príjmu, ktorému invalidný dôchodok pokryje o 20 % vyššie výdavky domácnosti, má v Plnom pláne aj na 1 strane pri invalidite 0 Kč s dôvodom (predtým „—“).',
    zmenaInvalidniDuchod: 'Invalidný dôchodok od štátu: pri osobe s príjmom priemer (v Česku 13 000 Kč mesačne), poradca ho na karte prepíše — nie výpočet zo mzdy. Bez nároku 0, bez príjmu zákonné minimum.',
    zmenaMajetekMzda: 'Zodpovednosť zamestnanca sa tlačí s limitom len z hrubej mzdy, ktorú poradca zadal alebo potvrdil — odhad z čistej mzdy zostáva poradcovi na obrazovke a v pláne stojí „limit po doplnení mzdy“. Cena poistenia majetku po zmene poistnej sumy do súčtu ani do tlače nejde, kým ju poradca znova nepotvrdí.',
    zmenaMajetekNahrada: 'Existujúce poistenie majetku (domácnosť, nehnuteľnosť, zodpovednosť) sa v pláne uvoľní, až keď má nová majetková zmluva cenu od poradcu — potom plán počíta výmenu celú: starú platbu uvoľní a cenu novej odpočíta. Predtým sa zrušenie počítalo ako uvoľnené peniaze spolu so životnou zmluvou, aj keď cena novej zmluvy chýbala.',
    zmenaMajetekSmlouvy: 'Poistenie majetku sa v pláne tlačí po zmluvách a len s cenou z ponuky poisťovne; orientačný odhad zostáva len poradcovi na obrazovke.',
    zmenaMiraOdkladani: 'Miera odkladania v Návrhu, v rozpočte plánu aj v prezentácii je rovnaké číslo ako v analýze: odsúhlasená suma (bez nej voľné peniaze z príjmov a výdavkov) plus pravidelné vklady na sporenie a investície, delené čistým príjmom. Predtým len prebytok po poistnom delený príjmom, bez vkladov.',
    zmenaOchranaNadPrebytek: 'Keď je ochrana drahšia ako prebytok, chýbajúca suma sa ukáže v grafe „Cashflow v čase“, v nápise o schodku, v rozpočte plánu, v Priebežnom prehľade, v prezentácii aj v Zhrnutí. Predtým sa poistné orezalo na výšku prebytku a chýbajúce peniaze sa stratili.',
    zmenaPartnerBezNarozeni: 'Partner bez dátumu narodenia: jeho zabezpečenie plán nespočíta (smrť, invalidita, choroba, úraz ani cenu) a výstupy napíšu „nespočítané — chýba dátum narodenia“. Jeho súčasné zmluvy plán neruší. Predtým sa krytie partnera počítalo aj bez dátumu narodenia.',
    zmenaDveCesty: 'Graf „Bez plánu a s plánom“ porovnáva tie isté peniaze plánu investované a na sporiacom účte, s pásmom horšieho a lepšieho scenára a čiarou po poplatkoch; plán so schodkom graf nekreslí. Predtým graf investoval celý majetok bez výberov na ciele.',
    zmenaAlokaceFichtner: 'Rozloženie peňazí cieľa (akcie, dlhopisy, hotovosť) sa riadi tabuľkou podľa rizikového profilu a počtu rokov do cieľa, nie plynulým odpredajom akcií. Posledný rok pred cieľom drží 97 % v hotovosti a 3 % v dlhopisoch (pri dynamickom profile 71 % a 29 %). Renta má pred čerpaním podiel akcií podľa profilu a rokov do začiatku čerpania (vyvážený profil 15 a viac rokov 88 %), predtým sa blížila k 50 % akcií. Mesačné sumy cieľov sa preto posunú: pri konzervatívnom a vyváženom profile krátke ciele mierne zdražejú, renta pri vyváženom a dynamickom profile vyjde lacnejšie.',
    zmenaPenzijkoDoRenty: 'Doplnkové dôchodkové sporenie sa neruší: keď renta začína skôr ako jeho výplata (62 rokov), renta do výplaty ide z ostatných peňazí a od výplaty sa zvýši o sporenie (4 % ročne z jeho hodnoty). Predtým sa sporenie vyplatené po začiatku renty do renty nepočítalo vôbec.',
    zmenaPojistneMajetku: 'Cena nového poistenia majetku (domácnosť, nehnuteľnosť, zodpovednosť) od poradcu patrí medzi povinné platby a odpočíta sa z prebytku celá, rovnako ako životné poistenie. Zrušená stará majetková zmluva sa naďalej vracia ako úspora. Predtým sa odpočítaval len rozdiel pri výmene za zrušenú zmluvu.',
    zmenaNizsiVarianty: 'Varianty „Uskromniť sa“ a „Riešim len cenu“ znižujú aj pracovnú neschopnosť a závažné ochorenia: denná dávka kryje len nevyhnutné výdavky a splátky (namiesto celého príjmu), závažné ochorenia klesnú rovnakým pomerom ako invalidita. Predtým zostávali ako pri variante „Pre náročných“.',
    zmenaPenzijkoJednou: 'Penzijné sporenie a jednorazový príjem bez určeného cieľa dostane len prvá renta v poradí — dve renty si už tú istú korunu nerozdelia dvakrát.',
    zmenaPotrebaRenty: 'Renta bez zadaného cieľa sa počíta ako v analýze: dnešné výdavky bez vlastných vkladov na sporenie plus splátky úverov, ktoré pobežia aj v rente. Hypotéka doplatená pred rentou (podľa dátumu konca, inak odhadom z istiny, úroku a splátky) sa nepočíta, ostatné úvery zostávajú. Predtým renta = celé dnešné výdavky bez splátok.',
    zmenaProfilCile: 'Vlastný rizikový profil cieľa platí aj vo výpočte — karta cieľa aj všetky výstupy ukazujú pri cieli rovnaké percento.',
    zmenaRenta13: 'Starý výpočet posiela rente peniaze až od 13. mesiaca — prvý rok berie celý prebytok dorovnanie rezervy.',
    zmenaRentaNavyseni: 'Navýšenie renty z peňazí uvoľnených po splnení skorších cieľov sa tlačí do Plného plánu a na 1 stranu aj s rokom, od kedy platí — ako pri ostatných cieľoch.',
    zmenaRezervaJednoCislo: 'Rezerva má v celom pláne jedno číslo: cieľ presne podľa vzorca z analýzy (bez zaokrúhlenia po 10 000) a čo klient má, koľko chýba a na koľko percent je naplnená, počíta jedna funkcia — aj so stavebným sporením, ktoré príde do ~4 mesiacov.',
    zmenaRucniCastka: 'Ručne zadaná mesačná suma pri cieli platí aj vo výpočte — tlačí sa do Plného plánu, na 1 stranu, do Zhrnutia aj prezentácie a ďalšie ciele dostanú zvyšok.',
    zmenaRucniNula: 'Zmazaná mesačná suma pri cieli platí aj vo výpočte — uvoľnené peniaze dostanú ďalšie ciele.',
    zmenaRustMzdySchodek: 'Keď rodina dnes minie viac, ako zarobí, rast mzdy najprv pokryje tento schodok — ciele a splátka úveru dostanú až to, čo zostane. Predtým išiel celý rast mzdy na ciele.',
    zmenaSkoreZajisteni: 'Skóre finančného zdravia nepočíta prázdne riadky majetkových rizík ako zadané zabezpečenie — bez zadanej sumy sa táto zložka skóre nepočíta (predtým 20 bodov za prázdnu šablónu).',
    zmenaSmrtBezMinima: 'Krytie smrti vo veľkej analýze len kapitálovou metódou, bez minima (minimum len v Analýze pre Vietnamcov).',
    zmenaSpatneDluhy: 'Krok „Zbaviť sa zlých dlhov“ počíta len úvery v záložke Osobné úvery — spotrebiteľské úvery, kreditky, kontokorenty, revolving, osobný lízing a staršie riadky bez zvoleného druhu. Hypotéka ani úvery v záložke Firemné úvery medzi zlé dlhy nepatria.',
    zmenaSplatkaUveru: 'Po čerpaní úveru sa splátka odpočíta z peňazí pre ostatné ciele a rentu (pri bývaní sa pripočíta nájom z rozpisu výdavkov, ktorý kúpou odpadne). Keď splátka prekročí rozpočet, plán napíše, odkedy a koľko chýba.',
    zmenaSrovnaniStejnyZaklad: 'Graf „bez plánu a s plánom“ v prezentácii začína obe krivky z rovnakého finančného majetku; nezapojený majetok rastie rovnako ako zapojený a inflácia je 2,5 % z metodiky (predtým zelená začínala len z peňazí pridelených cieľom a červená počítala 2,7 %).',
    zmenaUverSpotrebitelsky: 'Auto a ďalšie ciele na úver mimo bývania počítajú splátku spotrebiteľského úveru alebo úveru zo stavebného sporenia (splatnosť najviac 12 rokov, orientačná sadzba), nie hypotéky na 30 rokov.',
    zmenaZajisteniVzdy: 'Zabezpečenie príjmu plán rieši vždy — skoršie „Nie“ klienta z analýzy už poistné z prebytku nevyradí.',
    zmenaZamestnavatel: 'Príspevok zamestnávateľa sa počíta do odkladania aj do príjmu: miera odkladania = (odsúhlasená suma alebo voľné peniaze + vlastné vklady + príspevok zamestnávateľa) delené (čistý príjem + príspevok zamestnávateľa). Predtým len do odkladania, takže miera vyšla o kúsok vyššia.',
    zmenaZdrojeHned: 'Rezerva aj cieľ s horizontom „hneď“ (0 rokov) berú bežný účet, sporiaci účet, hotovosť, termínovaný vklad a stavebné sporenie (v tomto poradí).',
  },
  /* BLOK:metodikaPlanu END */
  /* BLOK:prahyOdkladani START — generuje scratchpad/slovnik.py, ručně needitovat */
  prahyOdkladani: {
    flagPodMinimem: 'Odkladá ~{pct} % príjmov — minimum je {min} %, ideál {ideal} %',
    hladina: {
      ideal: 'ideál',
      minimum: 'minimum',
      pod: 'pod minimom',
      rychle: 'rýchlo k cieľom',
    },
    novyCrm: {
      chybiDoMinima: 'Do minima {min} % chýba {castka} mesačne',
      minimumDoIdealu: 'Minimum {min} % splnené · do ideálu {ideal} % chýba {castka}',
    },
    plan: {
      cileIdeal: 'CIELE — ideál {ideal} %',
      pravidlo503020: 'Pravidlo 50/30/20: ~50 % nevyhnutné výdavky, 30 % životný štýl, 20 % bokom na ciele a rentu. Minimum je {min} %, pri {rychle} % sa ciele plnia veľmi rýchlo. Detailný rozpis výdavkov riešime na servisnej schôdzke.',
    },
    rozpocet: {
      ideal: '✓ ideál {ideal} %',
      minimum: '✓ minimum {min} % · ideál {ideal} %',
      nezname: 'príjem nepoznáme · minimum {min} %',
      pod: '▲ pod minimom {min} %',
      rychle: '✓ {rychle} % a viac — ciele sa plnia rýchlo',
      vcVkladu: 'vrát. vkladov {castka}',
    },
  },
  /* BLOK:prahyOdkladani END */
  /* BLOK:rozpisPanel START — generuje scratchpad/slovnik.py, ručně needitovat */
  rozpisPanel: {
    hotovo: 'Hotovo',
    kicker: 'Detailný rozpis · položka po položke',
    prijmy: {
      nadpis: 'Príjmy domácnosti',
    },
    vydaje: {
      nadpis: 'Výdavky rodiny',
    },
    zavrit: 'Zavrieť',
  },
  /* BLOK:rozpisPanel END */
  /* BLOK:planCil START — generuje scratchpad/slovnik.py, ručně needitovat */
  /* BLOK:rustMzdyEfekt START — generuje scratchpad/slovnik.py, ručně needitovat */
  rustMzdyEfekt: {
    klikNedosahne: 'Po kliknutí na „{tlacitko}“ sa renta nezmení — peniaze z krokov berie iný cieľ alebo prídu až po začiatku renty.',
    klikUver: 'Po kliknutí na „{tlacitko}“ sa renta nezmení — rast mzdy zhltne splátka úveru: od r. {rok} na ňu aj s rastom mzdy chýba {chybi} mesačne.',
    konec: '{horizont}: {bez} → {ted}',
    krokRocne: 'Krok = +{pct} % príjmu raz za {obdobi} (≈ {rocne} % ročne).',
    nepocitaBezMesicni: 'Renta je bez mesačnej investície — kroky rastu mzdy sa do nej nezapočítavajú.',
    nepocitaBezTerminu: 'Renta nemá termín — do rozdelenia peňazí sa nezapočítava, ani s rastom mzdy.',
    nepocitaHned: 'Renta s termínom hneď sa nezhodnocuje — rast mzdy ju nezmení.',
    nepocitaNedosahne: 'Rast mzdy, ktorý je teraz v pláne, na túto rentu nedosiahne — peniaze z neho berie iný cieľ alebo prídu až po začiatku renty.',
    nepocitaRezim: 'Renta má zvolený režim riešenia — kroky rastu mzdy sa do nej nezapočítavajú. Aby sa započítali, kliknite pri rente na „späť na pôvodný návrh“.',
    nepocitaSplneno: 'Renta vychádza už bez rastu mzdy ({bez} %).',
    nepocitaUver: 'Rast mzdy, ktorý je teraz v pláne, do renty nedorazí — zhltne ho splátka úveru: od r. {rok} na ňu aj s rastom mzdy chýba {chybi} mesačne.',
    poHorizontu: 'Kroky od r. {roky} sú až od začiatku renty — do nej sa nezapočítavajú.',
    poKliku: 'Po kliknutí na „{tlacitko}“: renta z {pred} % na {po} %',
    poKlikuBezZmeny: 'Po kliknutí na „{tlacitko}“ sa renta nezmení.',
    radekNepocita: 'v pláne ({n} krokov), do renty sa však nezapočítavajú',
    toastNepocita: 'Predvyplnených {pocet} krokov rastu mzdy — renta sa tým nezmení, prečo, píše karta renty pri riadku Rast mzdy.',
    toastPredvyplneno: 'Predvyplnených {pocet} krokov rastu mzdy — renta {pred} % → {po} %.',
    toastPredvyplnenoBezRenty: 'Predvyplnených {pocet} krokov rastu mzdy — uprav podľa klienta.',
    toastPredvyplnenoVice: 'Predvyplnených {pocet} krokov rastu mzdy — {zmeny}.',
    toastUzVPlanu: 'Kroky rastu mzdy už v pláne sú a zodpovedajú nastaveniu — nič sa nemení. Renta s nimi počíta: {ted} % (bez nich {bez} %).',
    toastUzVPlanuBezCisel: 'Kroky rastu mzdy už v pláne sú a zodpovedajú nastaveniu — nič sa nemení.',
    toastUzVPlanuNepocita: 'Kroky rastu mzdy už v pláne sú — nič sa nemení. Do renty sa však nezapočítavajú, prečo, píše karta renty pri riadku Rast mzdy.',
    toastUzVPlanuVice: 'Kroky rastu mzdy už v pláne sú a zodpovedajú nastaveniu — nič sa nemení. Bez nich → s nimi: {renty}.',
    vPlanu: 'Rast mzdy v pláne zvyšuje rentu z {bez} % na {ted} %',
  },
  /* BLOK:rustMzdyEfekt END */
  planCil: {
    akontaceDo2026: 'Pri kúpe v roku {rok} platí na Slovensku istých 80 % úveru (20 % vlastných zdrojov) — vek ani prvé bývanie nerozhodujú.',
    akontaceK2BezVeku: 'Druhý klient nemá dátum narodenia — 10 % musí splniť každý žiadateľ, preto počítame 20 %. Doplňte dátum narodenia v analýze.',
    akontaceNemovitost: 'Klient má v analýze byt alebo dom (na bývanie aj na prenájom) alebo spláca hypotéku — 10 % stačí na Slovensku od roku 2027 len pri prvom bývaní, preto 20 %.',
    doplnenoAutomaticky: 'doplnené automaticky',
    jakJednZatim: 'Riešenie: {jedn} jednorazovo, mesačne zatiaľ nič navyše.',
    jakZatimNic: 'Riešenie: mesačne zatiaľ nič navyše.',
    krokNavyseni: 'Od {mesic}. mesiaca (r. {rok}) navýšiť o {o} na {celkem} mesačne.',
    krokRadek: 'od r. {rok} +{o}',
    krokZacatek: 'Od {mesic}. mesiaca (r. {rok}) posielať {celkem} mesačne.',
    nbsAkontace2027: 'NBS: pri kúpe do konca roka 2026 istých 80 % (20 % vlastných zdrojov), 90 % len v kvóte banky. Od roku 2027 stačí 10 % len pri prvom bývaní do 35 rokov bez inej nehnuteľnosti na bývanie ani na prenájom. 100 % financovanie je rozhodnutie poradcu — 10 % ceny kryje úver zo stavebného sporenia. Splátka sa v cashflow prejaví až od čerpania úveru',
    profilMimoVypocet: 'Výpočet aj tlač zatiaľ počítajú s profilom plánu — vlastný profil cieľa sa prejaví po prepočte podľa novej metodiky.',
    rucniMimoVypocet: 'Výpočet aj tlač zatiaľ počítajú s {castka} — ručná suma sa prejaví po prepočte podľa novej metodiky.',
    varianta100: '100 % financovanie',
    variantaAkontace: 'Akontácia {pct} %',
    vekVRoceKoupe: 'V roku kúpy ({rok}) bude klientovi {vek} rokov — podľa toho sa posudzuje akontácia 10 %.',
    vekVRoceKoupeK2: 'V roku kúpy ({rok}) bude klientovi {vek} rokov a druhému klientovi {vek2} rokov — 10 % stačí len vtedy, keď majú obaja najviac 35 rokov.',
    vyrazenBezTerminu: 'Bez termínu sa cieľ do rozdelenia peňazí nepočíta — doplňte termín.',
  },
  /* BLOK:planCil END */
  /* BLOK:kinoOdkladani START — generuje scratchpad/slovnik.py, ručně needitovat */
  kinoOdkladani: {
    a1: {
      aria: 'Jednotlivé výdavky nerozoberáme, strážime len sumu bokom',
      kicker: 'Výdavky',
      radek1: 'Výdavky do detailu nerozoberáme.',
      radek2: 'Strážime jedno číslo: koľko ide bokom.',
      stranou: 'Bokom',
      stranouPopis: 'jediné číslo, ktoré strážime',
      tahak: '„Nebudeme počítať každý cent. Stačí mi jedno číslo — koľko vám každý mesiac zostane bokom.“',
      titulek: 'Nejde o každý cent',
      velkePopis: 'Čistý príjem domácnosti',
    },
    a2: {
      aria: 'Tri hladiny odkladania',
      dnes: 'Dnes odkladáte {pct} %.',
      dnesDohoda: 'S odsúhlasenou sumou ide bokom {pct} %.',
      kicker: 'Koľko bokom',
      radek: 'Pri {rychle} % sa ciele plnia veľmi rýchlo.',
      tahak: '„Desať percent je minimum. Dvadsať je ideál. Tridsať — a ciele sa plnia veľmi rýchlo.“',
      titulek: '{min} % minimum, {ideal} % ideál',
      velkePopis: '{pct} % z {prijem}',
    },
    a3: {
      aria: 'Pri {pct} % ({castka} mesačne) narastie za 30 rokov modelovo {fv}, z toho vložené {vlozeno}.',
      kicker: 'Vaše číslo',
      nejistota: 'Modelácia podľa profilu plánu ({profil}), v dnešných peniazoch, bez poplatkov a daní. Výnos nie je istý — môže byť vyšší aj nižší.',
      radekCas: 'Zvyšok robí čas — modelácia, nie sľub.',
      radekNula: 'Bez odkladania nenarastie nič.',
      radekVlozite: 'Vložíte {castka}.',
      tahak: '„Toto je modelácia, nie sľub. Ale ukazuje, čo urobí čas a pravidelnosť.“',
      titulek: 'Koľko z toho narastie',
      velkePopis: 'za 30 rokov · modelácia',
      vlozeno: 'vložené',
      vynos: 'výnos',
    },
    a4: {
      aria: 'Pri {pct} %: {popis}.',
      cilBezNazvu: 'Cieľ',
      cilRenta: 'Renta',
      cilRezerva: 'Rezerva',
      dalsiCile: '+ ďalšie ciele: {n}, z toho k termínu {splneno}',
      dnes: 'dnes',
      hned: 'hneď',
      kTerminu: 'k termínu len {pct} %',
      kTerminuSplneno: 'k termínu',
      kicker: 'Vaše ciele',
      nejistota: 'Rovnaký výpočet ako Návrh riešenia: výnos podľa profilu plánu, poradie cieľov podľa plánu. Modelácia, nie sľub.',
      radekHladina: '{pct} % → {n} z {celkem} cieľov k termínu',
      radekHladinaVse: '{pct} % → všetky ciele k termínu ✓',
      rezervaZUspor: 'z úspor teraz {pct} %',
      tahak: '„Pozrite sa, ako sa s percentom posúva, kedy máte rezervu, bývanie aj rentu.“',
      titulek: 'Čo sa splní a kedy',
      velke: '{n} z {celkem}',
      velkePopis: 'cieľov splníte k termínu',
    },
    a5: {
      aria: 'Z výplaty {prijem} ide deň po výplate {stranou} bokom, {zivot} zostáva na život.',
      denPo: 'deň po výplate',
      kicker: 'Začnite',
      naZivot: 'Na život',
      radek: 'Čo zostane, minete s pokojom.',
      stranou: 'Bokom',
      tahak: '„Najlepšie to funguje automaticky — trvalý príkaz deň po výplate a ďalej to neriešite.“',
      titulek: 'Najprv sebe, potom účtom',
      velkePopis: 'trvalým príkazom deň po výplate',
      vyplata: 'Výplata',
    },
    doplnPrijmy: 'Doplňte príjmy a spočítame to',
    jezdec: {
      aria: 'Koľko percent príjmu odkladať',
      dnes: 'dnes',
      mesicne: 'mesačne',
      odkladate: 'Odkladáte',
      valuetext: '{pct} %, {castka} mesačne',
    },
    nazev: 'Výdavky a odkladanie',
    prezTlacitko: 'Spustiť kino: Výdavky a odkladanie',
    prijmy: {
      a2Tahak: '„Osvedčené pravidlo: polovica na nevyhnutnosti, tretina na život a pätina bokom na budúcnosť. Minimum je desatina.“',
      a3BezVydaju: 'Doplňte výdavky a spočítame, koľko reálne odkladáte.',
      a3Ideal: 'Teraz odkladáte ~{pct} % — to je ideál. ✓',
      a3Minimum: 'Teraz odkladáte ~{pct} % — minimum máte, do ideálu {ideal} % chýba {chybi} mesačne.',
      a3Pod: 'Teraz odkladáte ~{pct} % — do minima {min} % chýba {chybi} mesačne.',
      a3Rychle: 'Teraz odkladáte ~{pct} % — ciele sa splnia veľmi rýchlo. ✓',
      a3Tahak: '„Výdavky rozpíšeme do detailu až na servisnom stretnutí. Teraz je kľúčové jediné — aby išlo bokom aspoň desať percent, ideálne dvadsať.“',
      a3VelkePopis: 'Ideálne toľko mesačne bokom',
      a6Radek3: 'Minimum je {min} %, ideál {ideal} % — hlavne začať.',
    },
    profil: {
      dynamicky: 'dynamický',
      konzervativni: 'konzervatívny',
      vychozi: '{profil}, predvolený',
      vyvazeny: 'vyvážený',
    },
    rokyFew: '{n} roky',
    rokyMany: '{n} rokov',
    rokyOne: '{n} rok',
    tlacitko: 'Kino odkladanie',
    tlacitkoTitle: 'Prehrať kino: Výdavky a odkladanie',
    utraty: {
      bydleni: 'Bývanie',
      deti: 'Deti',
      doprava: 'Doprava',
      dovolena: 'Dovolenka',
      energie: 'Energie',
      jidlo: 'Jedlo',
      obleceni: 'Oblečenie',
      restaurace: 'Reštaurácie',
    },
    zaRokyFew: 'za {n} roky',
    zaRokyMany: 'za {n} rokov',
    zaRokyOne: 'za {n} rok',
  },
  /* BLOK:kinoOdkladani END */
  /* BLOK:vodopad START — generuje scratchpad/slovnik.py, ručně needitovat */
  vodopad: {
    coKdyby: {
      naBudoucnost: 'Na budúcnosť',
      presah: 'O {castka} viac, než zostáva — muselo by sa ubrať z výdavkov na život.',
      prijmu: 'príjmu',
      startDnes: 'dnes',
      startDohoda: 'dohoda',
      tlacitko: 'Čo keby išlo na budúcnosť viac',
      valuetext: '{pct} % príjmu, {castka} mesačne',
      zVolnych: 'Z voľných peňazí',
      zbyva: 'Zostáva voľne',
      zpetDnes: 'Späť na dnešok',
      zpetDohoda: 'Späť na dohodu',
    },
    grafSelhal: 'Graf sa nepodarilo vykresliť — čísla sú v prehľade.',
    klikRadek: 'Klik na riadok = položky',
    klikSloupec: 'Klik na stĺpec = položky',
    majetek: {
      celkem: '= Majetok spolu',
      celkemPod: 'súčet oboch',
      ciste: '= Čisté imanie',
      cistePod: 'patrí rodine',
      cisteZapPod: 'dlh prevyšuje majetok',
      dedictvi: 'Dedičstvo',
      fin: '+ Finančný',
      finPod: 'sporenie, investície, účty',
      kat: {
        dedictvi: 'Dedičstvo',
        firma: 'Firma / podnikanie',
        kzp: 'Kapitálové životné poistenie',
        nemovitosti: 'Nehnuteľnosť',
        opf: 'Fondy a ETF',
        penzijko: 'Dôchodkové sporenie',
        stavebko: 'Stavebné sporenie',
        ucty: 'Účet',
        zavazkyB: 'Úver na bývanie',
        zavazkyO: 'Úver',
      },
      nadpis: 'Súhrn majetku',
      nefin: 'Nefinančný',
      nepocita: 'zatiaľ sa nepočíta',
      podily: '{rodina} % majetku patrí rodine, {banka} % banke.',
      pointa: 'Po odpočítaní dlhov vám z majetku zostáva {castka}.',
      pointaBezJistiny: 'Pri dlhoch chýba zostatok istiny — o koľko znižujú majetok, zatiaľ nevieme.',
      pointaBezZavazku: 'Majetok spolu {castka} — záväzky zatiaľ nie sú zadané.',
      pointaPrazdne: 'Majetok ani záväzky zatiaľ nie sú zadané.',
      pointaZaporne: 'Dlhy prevyšujú majetok o {castka}.',
      zavazky: '− Záväzky',
      zavazkyPod: 'zostatky istín úverov',
    },
    navic: 'Položky dávajú o {castka} viac ako stĺpec',
    nerozepsano: 'Bez rozpisu po položkách',
    penize: {
      bonusy: 'Bonusy (mesačne)',
      chybiPrijmy: 'Doplňte príjmy — bez nich sa voľné peniaze netvrdia.',
      chybiVydaje: 'Doplňte výdavky — bez nich sa voľné peniaze netvrdia.',
      dilNaBudoucnost: 'na budúcnosť {castka}',
      dilPrebytek: 'prebytok {castka}',
      dilZbyva: 'zostáva {castka}',
      hrdina: 'Voľné peniaze',
      hrdinaSchodek: 'Schodok',
      jdeVam: 'ide vám',
      jenUkazka: 'Len ukážka — do plánu sa neprepisuje.',
      kazdyMesic: 'každý mesiac',
      kicker: 'Príjmy a výdavky · mesačne',
      klient: 'Klient {n}',
      mesicne: 'mesačne',
      nadVolneCastka: 'nad voľné {castka}',
      nezadano: 'nezadané',
      nezbytne: '− Nevyhnutné výdavky',
      nezbytnePod: 'bývanie, jedlo, doprava',
      nezbytnePrehled: 'Nevyhnutné výdavky',
      odkladDnes: 'Bokom dnes ide {castka} = {pct} % príjmu (vklady {vklady} + voľné peniaze {volne}).',
      odkladDohoda: 'Bokom ide {castka} = {pct} % príjmu (vklady {vklady} + odsúhlasená suma {dohoda}).',
      ostatni: '− Ostatné výdavky',
      ostatniPod: 'voľný čas, dovolenka, sporenie',
      ostatniPrehled: 'Ostatné výdavky',
      pasivni: 'Pasívne príjmy',
      pointa: 'Z {prijmy} príjmu vám po výdavkoch a splátkach zostáva {volne}.',
      pointaSchodek: 'Výdavky a splátky sú o {castka} vyššie ako príjmy.',
      pokryto: 'Vklady, ktoré už bežia ({castka}), cieľ pokryjú — z voľných peňazí nič navyše.',
      posuvnikNeni: 'Teraz nie je z čoho odkladať: mesačne chýba {castka}. Najprv vyrovnať výdavky.',
      prehrat: 'Prehrať znova',
      prijmy: 'Príjmy',
      prijmyPod: 'čisté, za domácnosť',
      prijmyPrehled: 'Príjmy',
      schodek: '= Schodok',
      schodekPod: 'chýba každý mesiac',
      schodekPrehled: 'Schodok',
      splatky: '− Splátky',
      splatkyPod: 'úvery',
      splatkyPrehled: 'Splátky',
      sporeni: 'Sporenie, ktoré už beží',
      sporeniNesedi: 'sporenie nesedí',
      sporeniProuzek: 'z toho sporenie {castka}',
      stranouDnes: 'bokom dnes ide {pct} % príjmu',
      stranouDohoda: 's odsúhlasenou sumou ide bokom {pct} % príjmu',
      volne: '= Voľné peniaze',
      volnePod: 'zostáva vám',
      volnePrehled: 'Voľné peniaze',
      vydaje: '− Výdavky',
      vydajePod: 'nevyhnutné zatiaľ nezadané',
      vydajePrehled: 'Výdavky',
      zivotniStyl: 'Životný štýl',
    },
    prehled: 'Prehľad',
    rozkliknuto: 'Rozkliknuté',
    sedi: 'Súčet položiek sedí: {castka}',
    stovka: {
      kopieChyba: 'Vetu sa nepodarilo skopírovať.',
      kopirovano: 'Skopírované',
      kopirovat: 'Kopírovať',
      mesicne: '{castka} mesačne',
      nadpis: 'Zo 100 {sym} príjmu',
      nazev: {
        budoucnost: 'Budúcnosť',
        povinne: 'Povinné',
        vydaje: 'Výdavky a splátky',
        zbyva: 'Zostáva',
        zivot: 'Život',
      },
      nesedi: {
        dohoda: 'Odsúhlasená suma {castka} je o {nad} vyššia ako voľné peniaze, a to je viac, než zostáva na život. Skontrolujte dohodu.',
        sporeniOstatni: 'Sporenie {castka} mesačne je vyššie ako ostatné výdavky {ostatni}. Skontrolujte, či je sporenie zapísané vo výdavkoch.',
        sporeniVydaje: 'Sporenie {castka} mesačne je vyššie ako výdavky {ostatni}. Skontrolujte, či je sporenie zapísané vo výdavkoch.',
        titul: 'Stovku zatiaľ nejde rozdeliť.',
        ukazka: 'Toľko na budúcnosť nejde — nestačili by ani všetky výdavky na život.',
      },
      podNadPrijem: '{pct} nad príjem',
      podNadVolne: '{pct} nad voľné peniaze',
      podPrijem: 'príjem',
      podZbyva: 'zostáva {pct}',
      pravidlo: 'Pravidlo: povinné 50–60 · budúcnosť aspoň 20 · zvyšok na život',
      schodekPozn: '{pct} nad príjem · mesačne chýba {castka}',
      slozeni: {
        nadVolne: 'nad voľné {castka}',
        nezbytne: 'nevyhnutné {castka}',
        nic: 'zatiaľ nič',
        prebytek: 'prebytok {castka}',
        schodek: 'sporenie sa teraz platí z dlhu alebo z úspor',
        splatky: 'splátky {castka}',
        sporeni: 'sporenie {castka}',
        volne: 'voľné peniaze {castka} (zatiaľ bez dohody)',
        vydajeBez: 'výdavky bez sporenia {castka}',
        zVolnych: 'z voľných peňazí {castka}',
        zamestnavatel: 'od zamestnávateľa {castka}',
        zivot: 'ostatné výdavky bez sporenia',
        zivotSchodek: 'ostatné výdavky vr. sporenia {castka}',
      },
      stav: {
        bezDohodyLatka: '{latka}, ak sa odloží všetko voľné',
        bezDohodyPod: 'pod 10 aj so všetkým voľným',
        idealSplneno: 'aspoň 20 splnené',
        latkaIdeal: 'aspoň 20',
        latkaMinimum: 'minimum 10',
        minimumSplneno: 'minimum 10 splnené · do 20 chýba {castka}',
        nadVolneLatka: '{latka} len keď sa zo života uberie {castka}',
        nadVolnePod: 'pod 10 aj s ubratím zo života',
        neniZCeho: 'teraz nie je z čoho',
        nezbytneNezadane: 'nevyhnutné nezadané',
        pod: 'pod 10 · do 10 chýba {castka}',
        povinneNad: 'nad odporúčaných 60 o {n}',
        povinnePod: 'pod 50',
        povinneV: 'v odporúčaných 50–60',
        zivotMene: 'o {castka} menej ako dnes',
      },
      ukazka: 'ukážka',
      veta: {
        bezDohody: '{zac} a zvyšných {b} môžete odložiť na budúcnosť.',
        bud: '{zac}, {b} odložíte na svoju budúcnosť.',
        budZbyvaFew: '{zac}, {b} odložíte na svoju budúcnosť a {zb} vám zatiaľ zostávajú.',
        budZbyvaMany: '{zac}, {b} odložíte na svoju budúcnosť a {zb} vám zatiaľ zostáva.',
        budZbyvaOne: '{zac}, {b} odložíte na svoju budúcnosť a {zb} vám zatiaľ zostáva.',
        domluvime: 'Koľko z voľných peňazí naozaj odložíte, sa teraz dohodneme.',
        konecDobre: 'oboje máte, takže ste na tom dobre.',
        konecDobreBez: 'aspoň 20 na budúcnosť máte, takže ste na tom dobre.',
        konecMinimum: 'minimum 10 máte, do ideálnych 20 chýba {castka} mesačne.',
        konecMinimumZbytek: 'minimum 10 máte a do ideálnych 20 chýba {castka} mesačne, tie zo zvyšku pokryjete.',
        konecNadVolne: '{latka} tým splníte, len budete na život dávať o {castka} mesačne menej ako dnes.',
        konecNadVolnePod: 'aj tak ste pod 10 a na život budete dávať o {castka} mesačne menej ako dnes.',
        konecPod: 'teraz ste pod 10, tak poďme nájsť {castka} mesačne.',
        konecPodZbytek: 'teraz ste pod 10, chýba {castka} mesačne, a tie zo zvyšku pokryjete.',
        konecPovinnePod: 'povinné máte dokonca pod 50 a budúcnosť nad 20, takže ste na tom dobre.',
        pravidlo: 'Odporúčam 50 až 60 na povinné a aspoň 20 na budúcnosť, zvyšok na život',
        pravidloNad: 'Odporúčam najviac 60 na povinné a aspoň 20 na budúcnosť, zvyšok na život — povinné teraz berú viac, preto na budúcnosť zostáva len {b}.',
        schodek: 'Z každých 100 {sym}, ktoré zarobíte, dnes miniete {celkem} — každý mesiac chýba {castka}, takže najprv spolu upravíme výdavky.',
        zac: 'Z každých 100 {sym}, ktoré zarobíte, ide {povinne} na to, čo platiť musíte, {zivot} na život',
        zacBez: 'Z každých 100 {sym}, ktoré zarobíte, ide {vydaje} na výdavky a splátky',
      },
      vetaTitul: 'Veta pre klienta',
      zbyvaPozn: '{castka} mesačne, zatiaľ nerozdelené',
      znackaBudoucnost: 'budúcnosť 20+',
      znackaPovinne: 'povinné 50–60',
    },
    zadnePolozky: 'Položky zatiaľ nie sú rozpísané.',
    zpetAria: 'Späť na prehľad',
  },
  /* BLOK:vodopad END */
  /* BLOK:majetekSmlouvy START — generuje scratchpad/slovnik.py, ručně needitovat */
  majetekSmlouvy: {
    bezMzdaPozn: 'V analýze nie je príjem zo zamestnania. Mzdu zadajte, len keď má zamestnávateľa.',
    castkaSeZmenila: 'poistná suma sa zmenila — overte cenu',
    cenaNecitelna: 'Cenu zapíšte ako číslo, napríklad 8,90.',
    cenaPlati: 'Cena platí',
    cenaPoNabidce: 'cena po ponuke poisťovne',
    cenaSmlouvy: 'Cena zmluvy',
    cenaZNabidky: 'Cena z ponuky',
    chybiCenaFew: 'chýba cena pri {n} zmluvách',
    chybiCenaMany: 'chýba cena pri {n} zmluvách',
    chybiCenaOne: 'chýba cena pri {n} zmluve',
    cipLimit: 'limit {limit}',
    cipNenabizet: 'neponúkať',
    cipPripojisteni: 'pripoistenie',
    coKryje_domacnost: 'Veci doma.',
    coKryje_dum: 'Dom — samotnú stavbu.',
    coKryje_dumDomacnost: 'Dom a veci vnútri.',
    coKryje_dumOdpovednost: 'Dom a škodu, ktorú nechtiac spôsobíte iným.',
    coKryje_majetek: 'Veci doma a škodu, ktorú nechtiac spôsobíte iným.',
    coKryje_majetekDum: 'Dom, veci vnútri a škodu, ktorú nechtiac spôsobíte iným.',
    coKryje_odpovednost: 'Škodu, ktorú nechtiac spôsobíte iným.',
    coKryje_podnik: 'Firmu, zásoby, vybavenie a škody zákazníkom.',
    coKryje_pravni: 'Právnika a súd, keď dôjde na spor.',
    coKryje_zam: 'Škodu, ktorú z nedbanlivosti spôsobíte v práci.',
    doplnteCenu: 'Doplňte cenu z poisťovne',
    infoMajetek: 'Jedna zmluva, jedna cena z ponuky poisťovne.',
    infoVlastni: 'Samostatná zmluva — položka je dojednaná zvlášť (iná poisťovňa alebo iný produkt), preto má vlastnú cenu.',
    infoZamJedna: 'Jedna, alebo dve zmluvy? Podľa ponuky poisťovne: jedno číslo zmluvy a jedna cena = jedna zmluva. Dve ceny = každý svoju. Limit má každý zvlášť podľa svojej hrubej mzdy.',
    kazdaSvouCenu: 'každá má svoju cenu',
    kinoBezCenFew: 'bez {n} zmlúv, cena príde z ponuky',
    kinoBezCenMany: 'bez {n} zmlúv, cena príde z ponuky',
    kinoBezCenOne: 'bez {n} zmluvy, cena príde z ponuky',
    kinoBezKraceni: 'Na plnú hodnotu — bez krátenia',
    kinoBlok: '1 blok = hrubá mzda {mzda}',
    kinoBlokyAria: '{nasobek} krát hrubá mzda {mzda} je najmenej {limit}',
    kinoCelkem: 'Spolu',
    kinoCenuDoplnime: 'cenu doplníme z ponuky',
    kinoChybiHodnota: 'Sumy doplníme, keď bude známa hodnota — zatiaľ v percentách škody.',
    kinoCyklista: 'Na bicykli nechtiac zrazíte iného cyklistu',
    kinoDalsi: 'Ďalej',
    kinoHotovo: 'Hotovo',
    kinoJezdecPct: '{pct} percent hodnoty',
    kinoJezdecText: '{castka}, {pct} percent hodnoty',
    kinoKraceni: 'Poisťovňa kráti na {pct} % každej škody',
    kinoKrok: 'Vysvetlenie pre klienta · {i} z {n}',
    kinoMisto_doma: 'doma',
    kinoMisto_firma: 'vo firme',
    kinoMisto_prace: 'v práci',
    kinoMisto_spor: 'pri spore',
    kinoNazev_odpovednost: 'Prečo zodpovednosť s vysokým limitom',
    kinoNazev_plna: 'Prečo poistiť na plnú hodnotu',
    kinoNazev_prace: 'Zodpovednosť v práci',
    kinoNazev_shrnuti: 'Čo dojednáme',
    kinoNazev_smlouvy: 'Čo kryje ktorá zmluva',
    kinoOdpPozn: 'Ilustrácia bez súm. Vytopený sused alebo rozbitý tovar v obchode sem patrí tiež. Autom? To kryje povinné zmluvné poistenie, nie táto zmluva.',
    kinoOdpVeta: 'Škodu na zdraví platí ten, kto ju spôsobil. Nejde o jednu faktúru — niektoré položky sa platia roky.',
    kinoOsa1: '1 rok',
    kinoOsa10: '10 rokov',
    kinoOsa20: '20 rokov +',
    kinoOsaAria: 'Ilustrácia bez súm: liečenie a bolesť sa platia hneď, starostlivosť aj roky, strata na zárobku každý mesiac aj desiatky rokov.',
    kinoOsaBolest: 'Bolesť a sťaženie spoločenského uplatnenia',
    kinoOsaLecba: 'Náklady liečenia',
    kinoOsaNehoda: 'nehoda',
    kinoOsaPece: 'Starostlivosť o zraneného',
    kinoOsaVydelek: 'Strata na zárobku — každý mesiac',
    kinoOsobaMzda: '{jmeno} · {mzda}',
    kinoOsobaPodnika: '{jmeno} · podniká, netýka sa',
    kinoPlnaDum: 'Postaviť dom znova by stálo {castka}',
    kinoPlnaDumBez: 'Dom · cenu postavenia znova doplníme',
    kinoPlnaVeta: 'Keď je poistná suma nižšia, než by stálo zaobstaranie znova, poisťovňa kráti každú škodu v rovnakom pomere — aj tú malú.',
    kinoPlnaVybaveni: 'Zaobstarať vybavenie znova by stálo {castka}',
    kinoPlnaVybaveniBez: 'Vybavenie · hodnotu doplníme',
    kinoPlnaVyska: 'plná výška = celá hodnota',
    kinoPojistenoCastka: '{castka} ({pct} %)',
    kinoPojistenoNa: 'Poistené na',
    kinoPojistenoPct: '{pct} % hodnoty',
    kinoPojistovna: 'Poisťovňa',
    kinoPoznPodpojisteni: 'Ilustrácia podľa všeobecného pravidla podpoistenia, bez spoluúčasti. Konkrétna zmluva môže byť dojednaná inak.',
    kinoPoznPodpojisteniCZ: 'Ilustrácia podľa všeobecného pravidla podpoistenia (§ 2854 českého občianskeho zákonníka), bez spoluúčasti. Konkrétna zmluva môže byť dojednaná inak.',
    kinoPraceKde: '{jmeno} · hrubá mzda {mzda}',
    kinoPraceSmlouva: 'Na to je zmluva s limitom {nasobek}× mzdy. Rozsah a výluky určí poisťovňa.',
    kinoPraceVeta: 'Z nedbanlivosti poškodí stroj alebo zariadenie, s ktorým pracuje. Zamestnávateľ smie chcieť náhradu. Pri nedbanlivosti ju zákon obmedzuje na {nasobek}-násobok priemerného mesačného zárobku.',
    kinoPraceVyjimky: 'Strop neplatí pri škode spôsobenej úmyselne, pod vplyvom alkoholu alebo návykových látok, ani pri schodku a strate zverených vecí — tam sa hradí celá škoda. Predpis: {predpis}.',
    kinoProtoLimit: 'Preto limit v miliónoch:',
    kinoShrnPozn: 'Sumy sú návrh krytia, nie ponuka. Cenu, rozsah plnenia a výluky určí poisťovňa v zmluve.',
    kinoSkoda: 'Škoda',
    kinoStropNejmene: 'Zákonný strop z nedbanlivosti najmenej',
    kinoStropPozn: '— počíta sa z priemerného zárobku, s prémiami vychádza viac.',
    kinoTeckaAria: 'Krok {i}: {nazev}',
    kinoVetaJedna: '{mista} to rieši jedna zmluva s jednou cenou.',
    kinoVetaKazde: '{mista} — každé rieši iná zmluva. Každá má svoju cenu.',
    kinoVetaVicFew: '{mista} — {n} zmluvy, každá má svoju cenu.',
    kinoVetaVicMany: '{mista} — {n} zmlúv, každá má svoju cenu.',
    kinoVetaVicOne: '{mista} — {n} zmluva, každá má svoju cenu.',
    kinoVetaZadna: 'Zatiaľ sme nevybrali žiadnu zmluvu.',
    kinoZavrit: 'Zavrieť vysvetlenie',
    kinoZeSveho: 'Zo svojho',
    kinoZpet: 'Späť',
    kratceOdpovednost: 'Zodpovednosť',
    kratcePodnik: 'Firma a prevádzka',
    kratceVybaveni: 'Vybavenie',
    krytiNemovitostChybi: 'nehnuteľnosť — hodnota po doplnení',
    krytiPolozka: '{nazev} {castka}',
    krytiZam: 'limit {limit}',
    krytiZamChybi: 'limit po doplnení mzdy',
    krytiZamChybiOsoba: '{jmeno} — limit po doplnení mzdy',
    krytiZamOsoba: '{jmeno} — limit {limit}',
    limitDoplnte: 'doplňte mzdu',
    limitNetyka: 'netýka sa',
    mzdaOdZamestnavatele: 'Mzda od zamestnávateľa — {jmeno}',
    mzdaOsoby: 'Hrubá mzda — {jmeno}',
    mzdaPlati: 'Mzda platí',
    mzdaPlatiAria: 'Hrubá mzda {jmeno} {mzda} platí',
    nabidnoutV: 'Ponúknuť',
    nabizetV: 'Ponúkať',
    nazevDomacnost: 'Domácnosť',
    nazevDomacnostOdpovednost: 'Domácnosť a zodpovednosť',
    nazevMajetek: 'Majetok',
    nazevMajetekDomacnost: 'Majetok a domácnosť',
    nazevNemovitost: 'Nehnuteľnosť',
    nazevNemovitostOdpovednost: 'Nehnuteľnosť a zodpovednosť',
    nazevOdpovednost: 'Občianska zodpovednosť',
    nazevPodnik: 'Podnikateľské poistenie',
    nazevPravni: 'Právna ochrana',
    nazevVlastni: '{polozky} — zvlášť',
    nazevZam: 'Zodpovednosť zamestnanca — {jmeno}',
    nazevZamDva: 'Zodpovednosť zamestnanca — {jmeno1} a {jmeno2}',
    nenabizetV: 'Neponúkať',
    neresitV: 'Neriešiť',
    netykaSe: 'netýka sa',
    nezadanoPlaceholder: 'nezadané',
    obsahSeZmenil: 'obsah sa zmenil — overte cenu',
    orientacne: 'orientačne ≈ {cena}, nie ponuka',
    osvcMzdaPozn: 'Príjem v analýze je z podnikania. Mzdu zadajte, len keď má aj zamestnávateľa.',
    overitCenuFew: 'overiť cenu pri {n} zmluvách',
    overitCenuMany: 'overiť cenu pri {n} zmluvách',
    overitCenuOne: 'overiť cenu pri {n} zmluve',
    podepiseFew: 'Klient podpíše {n} zmluvy',
    podepiseMany: 'Klient podpíše {n} zmlúv',
    podepiseOne: 'Klient podpíše {n} zmluvu',
    podnikNeresit: 'Firmu, zásoby a vybavenie poistka domácnosti nekryje.',
    podtitulJedna: 'Jedna zmluva · jedna cena',
    podtitulNenabizime: 'Neponúkame',
    podtitulNeresime: 'Neriešime',
    podtitulNetyka: '{jmeno} podniká — nemá zamestnávateľa.',
    podtitulNetykaBez: '{jmeno} nemá v analýze príjem zo zamestnania.',
    podtitulPrazdna: 'Zatiaľ nič na krytie — doplňte položky',
    podtitulSamostatna: 'Samostatná zmluva',
    podtitulZam: 'Limit {nasobek}× hrubej mzdy · jedna cena',
    pojistneCelkem: 'Poistné spolu',
    popisekCastka: 'Poistná suma',
    popisekLimit: 'Limit',
    popisekVybaveni: 'Hodnota vybavenia',
    popisekZasoby: 'Hodnota zásob',
    pravniNabidka: 'Právna ochrana: ponúknuť, alebo neponúkať',
    pravniPripojisteni: 'Pripoistenie k zmluve Majetok',
    pravniSamostatna: 'Samostatná zmluva',
    pravniUmisteni: 'Ako je právna ochrana dojednaná',
    prepinacAria: '{nazev}: ponúkať, alebo neriešiť',
    presunAria: '{nazev}: patrí do zmluvy',
    presunNova: '+ Nová samostatná zmluva',
    presunPopisek: 'Dojednané inak? Patrí do zmluvy',
    prezSmlouvyFew: '{n} zmluvy',
    prezSmlouvyMany: '{n} zmlúv',
    prezSmlouvyOne: '{n} zmluva',
    prezSouhrnBezCen: '{smlouvy} · ceny po ponuke',
    prezSouhrnCast: '{smlouvy} · {cena} + ďalšie ceny po ponuke',
    prezSouhrnCena: '{smlouvy} · {cena}',
    proc_majetek: 'Jedna škoda na nehnuteľnosti alebo spôsobená iným stiahne celý plán ku dnu.',
    proc_podnik: 'Poistka domácnosti podnikanie nekryje.',
    proc_pravni: 'Spor o peniaze alebo prácu stojí právnika a súd.',
    proc_vlastni: 'Dojednané zvlášť — vlastná zmluva a vlastná cena.',
    proc_zam: 'Škodu z nedbanlivosti v práci môže zamestnávateľ chcieť od zamestnanca; zákonný strop neplatí vždy.',
    radekSmlouvy: '{nazev} ({kryti}) — {cena}',
    radekSmlouvyBezKryti: '{nazev} — {cena}',
    regul: 'Do súčtu ide len cena z ponuky. Sumy sú návrh krytia, nie ponuka — cenu, rozsah plnenia a výluky určí poisťovňa v zmluve.',
    resitV: 'Riešiť',
    smlouvaAria: 'Zmluva {cislo}: {nazev}',
    staraMetodika: 'Plán má staršiu metodiku: do tlače ide postaru jeden riadok — orientačne {cena}. Zmluvy, ceny a „Neriešiť“ odtiaľto sa do tlače prepíšu až po „{prepocitat}“.',
    staraMetodikaBezTisku: 'Plán má staršiu metodiku: poistenie majetku sa do tlače nedostane. Zmluvy a ceny odtiaľto sa prepíšu až po „{prepocitat}“.',
    stavChybiHodnota: 'chýba hodnota',
    stavChybiMzda: 'chýba hrubá mzda',
    stavNeresit: 'neriešiť',
    stavNetyka: 'netýka sa — podniká',
    stavNetykaBez: 'netýka sa — bez zamestnania',
    stavNevlastni: 'nevlastní',
    stavNezadano: 'nezadané',
    stavOdhadMzdy: 'odhad z čistej — overte',
    ukolSmlouvyFew: 'Dojednať majetkové poistenie — {n} zmluvy:',
    ukolSmlouvyMany: 'Dojednať majetkové poistenie — {n} zmlúv:',
    ukolSmlouvyOne: 'Dojednať majetkové poistenie — {n} zmluva:',
    ulozit: 'Uložiť',
    upravitCenu: 'Upraviť cenu: {nazev}',
    vetaSjednat: 'Dojednať {nazev} ({kryti}) — {cena}',
    vetaSjednatBezKryti: 'Dojednať {nazev} — {cena}',
    vsechnyCeny: 'všetky ceny z ponúk',
    vysvetlitKlientovi: 'Vysvetliť klientovi',
    zNabidky: 'z ponuky',
    zadatMzdu: 'Má aj zamestnanie? Zadať mzdu',
    zadnaKPodpisu: 'Zatiaľ žiadna zmluva na podpis',
    zamJakPoznat: 'Ako spoznať jednu, alebo dve zmluvy',
    zamJakText: 'Pozrite sa do ponuky poisťovne: jedno číslo zmluvy a jedna cena = jedna zmluva pre oboch. Dve ceny = každý svoju. Limit má každý zvlášť podľa svojej hrubej mzdy.',
    zamKazdy: 'Každý svoju zmluvu',
    zamSkupina: 'Zodpovednosť zamestnanca',
    zamSpolecna: 'Jedna zmluva pre oboch',
  },
  /* BLOK:majetekSmlouvy END */
  /* BLOK:duchodInvalidni START — generuje scratchpad/slovnik.py, ručně needitovat */
  duchodInvalidni: {
    ano: 'Áno',
    bezPrijmuB: 'Rodič bez príjmu: o 20 % vyššie výdavky ({narust}) mínus invalidný dôchodok ({duchod}).',
    bezPrijmuDomacnosti: 'Bez príjmu – krytie invalidity nepočítame, doplňte príjem.',
    narok: 'Nárok na invalidný dôchodok',
    narokPozn: 'Nad 28 rokov 5 rokov poistenia z posledných 10. Starostlivosť o dieťa sa počíta len vo verejnom zdravotnom poistení. „Neviem“ = počíta sa bez nároku.',
    ne: 'Nie',
    nevim: 'Neviem',
    odStatu: 'Invalidný dôchodok od štátu {castka}',
    odStatuLabel: 'Invalidný dôchodok od štátu',
    stitek: {
      bezNaroku: 'bez nároku: menej ako 5 rokov poistenia z 10',
      bezNarokuPoradce: 'bez nároku',
      chybiNarozeni: 'doplňte dátum narodenia',
      minimum: 'zákonné minimum',
      osvcMinimalni: 'SZČO z minimálnych preddavkov',
      overitNarok: 'overiť výpis ČSSZ',
      prumer: 'priemer',
    },
  },
  /* BLOK:duchodInvalidni END */
  /* BLOK:kinoCile START — generuje scratchpad/slovnik.py, ručně needitovat */
  kinoCile: {
    bydleni: {
      a1: {
        kicker: 'Nájom vs. vlastné',
        l1: 'Nájom: nižší vstupný náklad, ľahšie sťahovanie, opravy rieši majiteľ — majetok si ale nebudujete.',
        l2: 'Hypotéka: potrebná akontácia a dlhodobý záväzok, časť splátky však umoruje istinu — nehnuteľnosť postupne vlastníte.',
        l3: 'Rozhoduje flexibilita, mesačné cashflow a to, či chcete budovať majetok.',
        nar: '„Nájom nie je vyhodený — platíte za bývanie a za flexibilitu. Rozdiel je v tom, že pri hypotéke časť splátky umoruje istinu, takže postupne budujete majetok. Poďme sa pozrieť na čísla aj na predpoklady modelu.“',
        title: 'Nájom a hypotéka: v čom sa líšia',
      },
      a5: {
        big: 'Čo si začneme odkladať',
        nar: '„Poďme rozbehnúť plán už dnes — nech kľúče držíte vy, nie nájomná zmluva.“',
        title: 'Domov má svoj plán',
        titleVek: 'Domov za {roky} rokov, vo vašich {vek}',
      },
      cnb: {
        bigCena: 'Reálna cena bývania',
        bigNad: '{nasobek}× ročný príjem — nad odporúčaním',
        bigOk: '{nasobek}× ročný príjem — v pásme odporúčania',
        kicker: 'Zdravá hranica ceny',
        lBezCeny1: 'Doplňte REÁLNU cenu nehnuteľnosti — inak plán nebude sedieť.',
        lBezCeny2: 'Z dnešného bývania na podobné, nie palác.',
        lBezPrijmu: 'Doplňte príjmy a skontrolujeme pomer ceny k príjmu.',
        lCena: 'Cena nehnuteľnosti: {cena} (reálna, nech plán sedí).',
        lCenaHola: 'Cena nehnuteľnosti: {cena}.',
        lNad: 'To je {nasobek}× váš ročný príjem — nad zdravou hranicou!',
        lOk: 'To je {nasobek}× váš ročný príjem — v poriadku.',
        nar: '„Zdravá cena je zhruba do deviatich ročných príjmov. Musíme počítať s reálnou cenou, inak celý plán nesedí.“',
        title: 'Zdravá cena ≈ 9× ročný príjem',
      },
      nbs: {
        bigNad: 'Úver nad limitom NBS',
        bigOk: 'Úver v limite NBS',
        bigUver: 'Potrebný úver',
        kicker: 'Limit NBS',
        lLimit: 'Limit pre všetky vaše úvery: {limit}.',
        lLimitNejvys: 'Limit pre všetky vaše úvery: najviac {limit}.',
        lUver: 'Potrebný úver: {uver}.',
        lUverNad: 'Potrebný úver: {uver} — nad limitom NBS!',
        lUverOk: 'Potrebný úver: {uver} — v poriadku.',
        lVek: 'Podľa veku môže byť limit nižší.',
        lZbyva: 'Po ostatných úveroch zostáva: {strop}.',
        nar: '„Na Slovensku stráži NBS všetky vaše úvery spolu — najviac osemnásobok ročného čistého príjmu, od 41 rokov menej. Poďme sa pozrieť, kam sa zmestíte.“',
        title: 'Všetky úvery ≤ {max}× ročný príjem',
      },
      paka: {
        bigHotove: 'Cena celkom',
        bigUver: 'Potrebná akontácia ({pct})',
        kicker: 'Páka hypotéky',
        lAkontace: 'Akontácia {pct}: {castka}.',
        lHotove: 'Hotovo = celá suma teraz.',
        lSHypotekou: 'S hypotékou stačí ~{pct} akontácie a zvyšok peňazí investujete.',
        lZbytek: 'Zvyšok dofinancuje hypotéka — vaše peniaze pracujú inde.',
        narHotove: '„Zvážime hotovo verzus hypotéka. Páka vie byť váš priateľ.“',
        narUver: '„S hypotékou nepotrebujete celú sumu — len akontáciu. Zvyšok peňazí môže ďalej rásť.“',
        titleHotove: 'Hotovo, alebo s pákou?',
        titleUver: 'Investujete len {pct} akontácie',
      },
    },
    ostatni: {
      a1: {
        big: 'Poďme to rozpočítať',
        kicker: 'Váš cieľ',
        l1: 'Každý veľký sen potrebuje plán a číslo.',
        l2: 'Pomenujeme, koľko a kedy.',
        nar: '„Každý cieľ si zaslúži jasné číslo a termín. Poďme na to.“',
        title: 'Váš sen',
      },
      a2: {
        big: 'Cieľová suma',
        kicker: 'Koľko a kedy',
        lHorizont: 'Horizont {roky} rokov.',
        lHorizontVek: 'Horizont {roky} rokov — vo vašich {vek}.',
        nar: '„Tu je číslo a termín. Z toho už vieme spočítať mesačné odkladanie.“',
        titleRoky: '{castka} za {roky} rokov',
      },
      a3: {
        big: 'Cieľ na dosah',
        kicker: 'Tri páky',
        l1: 'Čím skôr začnete, tým menej musíte odkladať.',
        l2: 'Pravidelnosť porazí jednorazové pokusy.',
        nar: '„Fungujú tri páky: čas, pravidelnosť a výnos. Všetky vieme zapnúť.“',
        title: 'Čas × pravidelnosť × výnos',
      },
      a4: {
        big: 'Váš cieľ',
        l1: 'Naplánujeme mesačné odkladanie hneď.',
        l2: 'Malý krok dnes = veľký cieľ zajtra.',
        nar: '„Sen bez plánu je len prianie. Poďme z neho urobiť plán.“',
        title: 'Z plánu sa stane realita',
      },
    },
    renta: {
      a1: {
        big: 'Koľko je „dosť“ podľa VAŠICH výdavkov?',
        kicker: 'Vrchol plánu',
        l1: 'Deň, keď je práca voľba, nie povinnosť.',
        l2: 'Renta musí utiahnuť celý váš životný štýl — nadosmrti a nad infláciou.',
        nar: '„Cieľová méta: deň, keď nemusíte pracovať pre peniaze. Renta musí pokryť celý váš dnešný život, nie sa uskromňovať.“',
        title: 'Finančná nezávislosť',
      },
      a2: {
        big: 'Renta, ktorú potrebujete (dnešné ceny)',
        kicker: 'Váš životný štýl',
        lBez1: 'Renta musí pokryť vaše CELKOVÉ mesačné výdavky (životný štýl).',
        lBez2: 'Doplňte výdavky v analýze, nech suma sedí.',
        lRenta: 'Renta zadaná v cieli: {renta}.',
        lVydaje: 'Vaše celkové mesačné výdavky podľa analýzy: {vydaje}.',
        nar: '„Toto sú vaše dnešné výdavky z analýzy a renta, ktorú ste si pri cieli zadali. Od týchto dvoch čísel sa odvíja všetko ďalšie.“',
        title: 'Vaše dnešné mesačné výdavky',
      },
      a3: {
        big: 'Potrebný kapitál (v dnešných cenách)',
        kicker: 'Pravidlo 4 %',
        l2: '4 % je reálny výnos NAD infláciou — istina zostáva, čerpáte navždy.',
        lRocne: '{renta}/mes = {rocne} ročne.',
        nar: '„Bezpečne možno ročne čerpať ~4 % majetku nad infláciou navždy. Z vašich výdavkov spočítame potrebný kapitál.“',
        title: 'Renta × 12 ÷ 4 % = kapitál',
      },
      a4: {
        big: 'Cieľový kapitál pre slobodu',
        l1: 'Pravidelná investícia + čas = snehová guľa, renta nadosmrti.',
        lCil: 'Cieľ za {roky} rokov.',
        lCilVek: 'Cieľ za {roky} rokov, vo vašich {vek}.',
        lKazdy: 'Každý mesiac odkladu je mesiac slobody navyše.',
        nar: '„Nezávislosť sa nekupuje peniazmi naraz, ale časom a pravidelnosťou. Snehová guľa zloženého úročenia urobí zvyšok.“',
        title: 'Sloboda sa kupuje časom',
      },
    },
    rezerva: {
      a1: {
        big: 'Mesiace pokoja, ktoré teraz máte?',
        kicker: 'Čo keby…',
        l1: 'Auto, výpoveď, choroba, pokazená chladnička.',
        l2: 'Bez rezervy prichádza dlh — kreditka, pôžička, stres.',
        nar: '„Predstavte si, že zajtra vypadne príjem. Ako dlho ustojíte bežný život bez zmeny?“',
        title: 'Čo ak zajtra prídete o príjem?',
      },
      a2: {
        big: 'Čechov nemá rezervu ani na mesiac',
        kicker: 'Realita v ČR',
        l1: '14 % nemá žiadnu rezervu.',
        l2: 'Takmer tretina nemá bokom ani jeden mesačný príjem.',
        l3: 'Zdroj: STEM/MARK pre Home Credit, 2024.',
        nar: '„Nie ste v tom sami — ale práve preto je rezerva prvý krok. 14 % ľudí nemá vôbec nič, tretina neprežije mesiac.“',
        title: 'Takmer tretina Čechov nevydrží ani mesiac',
      },
      a3: {
        bigCil: 'Cieľová rezerva',
        bigMes: '= {mes} mesiacov pokoja',
        kicker: 'Pravidlo',
        lBez1: '3–6 mesiacov výdavkov bokom = pokoj za chrbtom.',
        lBez2: 'Doplňte nevyhnutné výdavky a spočítame mesiace presne.',
        lCil: 'Cieľ {cil} = {mes} mesiacov pokoja za chrbtom.',
        lNez: 'Vaše nevyhnutné výdavky: {nez}/mes.',
        nar: '„Cieľom sú 3 až 6 mesiacov nevyhnutných výdavkov. U vás to vychádza na túto sumu.“',
        title: 'Rezerva = 3–6× nevyhnutné výdavky',
      },
      a4: {
        big: 'Váš štít proti smole',
        lDnes: 'Termín: dnes — rezerva sa rieši ako prvá.',
        lTermin: 'Termín: za {roky} rokov.',
        nar: '„Nemusíte to mať hneď. Začneme po troškách — dôležité je začať. Rezerva je základ, na ktorom stojí celý plán.“',
        title: 'Vankúš sa stavia po troškách',
      },
    },
    spolecne: {
      cenaZadani: 'Cena podľa zadania: {castka}.',
      cilovaCastka: 'Cieľová suma podľa zadania: {castka}.',
      dejstvi: 'Dejstvo {n}',
      hotovo: 'Hotovo ✓',
      modelNajmu: 'Model: nájom 0,35 % ceny mesačne s rastom 3 % ročne; pri hypotéke rovnomerné umorovanie ceny bez úrokov a nákladov na údržbu. Skutočnosť sa líši podľa lokality, sadzby a stavu nehnuteľnosti.',
      osaDnes: 'DNES',
      osaVek: 'vo veku {vek}',
      osaZa: 'za {n} r.',
      pauza: 'Pauza',
      termin: 'Termín: za {roky} rokov.',
      terminNeni: 'Termín zatiaľ nie je stanovený.',
      terminVek: 'Termín: za {roky} rokov, vo vašich {vek}.',
      zacniDnes: 'Začnite dnes',
    },
    vzdelani: {
      a1: {
        big: 'Koľko bude štúdium stáť?',
        kicker: 'Najväčší dar',
        l1: 'Diplom, jazyky, zahraničie, rozbeh kariéry.',
        l2: 'To najlepšie, čo deťom môžete dať — a stojí to peniaze.',
        nar: '„Najlepšia investícia je do vlastných detí. Poďme sa pozrieť, čo ich čaká.“',
        title: 'Vzdelanie = štart do života',
      },
      a2: {
        big: 'Váš cieľ pre {deti}',
        kicker: 'Cena vzdelania',
        l1: 'Štúdium v ČR ≈ 300–600 tis. (bývanie, strava, materiály).',
        l2: 'Zahraničná univerzita ≈ 1–3 mil. Kč.',
        nar: '„Domáce štúdium vyjde na státisíce, zahraničné pokojne na milióny. Dobré to vedieť dopredu.“',
        title: 'ČR státisíce, zahraničie milióny',
      },
      a3: {
        big: 'Cieľová suma',
        bigRoky: 'Stihnete za {roky} rokov',
        kicker: 'Čas beží',
        nar: '„Čas hrá pre vás. Začať načas znamená odkladať výrazne menej.“',
        title: 'Čas je váš spojenec',
        titleRoky: 'Potreba za {roky} rokov',
      },
      a4: {
        big: 'Budúcnosť detí',
        l1: 'Pravidelné investície od dneška = pokoj, keď príde čas.',
        l2: 'Naplánujeme mesačné odkladanie na vzdelanie.',
        nar: '„Pár stoviek mesačne dnes = otvorené dvere pre vaše deti zajtra.“',
        title: 'Malá suma, veľký diplom',
      },
      deti: 'deti',
      dite: 'dieťa',
    },
    zdroj: {
      akontaceCZ: 'ČNB, opatrenie všeobecnej povahy č. I/2021 (LTV: mladší ako 36 rokov 90 %, inak 80 %), overené {datum}',
      akontaceSK: 'NBS, opatrenie č. 10/2016 § 7 a § 9d (LTV: do konca roka 2026 istých 80 %, od 2027 prvé bývanie do 35 rokov 90 %), overené {datum}',
      cnb: 'ČNB — odporúčanie k úverovým ukazovateľom',
      ctyriProcenta: 'Pravidlo bezpečného čerpania 4 % (Trinity study)',
      klient: 'Údaje z analýzy klienta',
      najemModel: 'Modelové porovnanie nájmu a hypotéky (predpoklady pri grafe)',
      nbs: 'NBS — opatrenie č. 10/2016 § 8a (limit DTI)',
      rezervaPravidlo: 'Interná metodika — likvidná rezerva 3–6× nevyhnutné výdavky',
      stem: 'STEM/MARK pre Home Credit',
    },
  },
  /* BLOK:kinoCile END */
  /* BLOK:invaliditaVysvetleni START — generuje scratchpad/slovnik.py, ručně needitovat */
  invaliditaVysvetleni: {
    aria: 'Po invalidite potrebujete {potreba}, príde {prijde}, chýba {chybi}.',
    ariaPrebyva: 'Po invalidite potrebujete {potreba}, príde {prijde}, zostane {prebyva}.',
    bezVydaju: 'Krytie invalidity sa nedá vypočítať — v analýze chýbajú výdavky.',
    chybiInfo: '{castka} × 12 × {roky} = {soucet} v dnešných cenách. Počítame, že vyplatené peniaze budú uložené s modelovým výnosom 4 % nad infláciu (model, nie záruka). Preto dnes stačí {kapital}.',
    chybiVeta: 'chýba {castka} každý mesiac · {roky}',
    cilBezHorizontu: 'cieľ {nazev} bez horizontu, nezapočítaný',
    duchod: 'invalidný dôchodok od štátu',
    duchodSablona: 'invalidný dôchodok (šablóna krajiny)',
    jenUkazka: 'Len ukážka — do plánu sa nič nezapisuje.',
    krok1: 'Výdavky po invalidite',
    krok1B: 'O koľko vzrastú výdavky domácnosti',
    krok1BPod: '+20 % z {vydaje}',
    krok1Pod: 'liečba, starostlivosť, úpravy bývania',
    krok2: 'Čo rodine príde',
    krok2B: 'Čo dá štát',
    krok3: 'Čo chýba — až do renty ({roky})',
    krok3B: 'Čo chýba — na {roky}',
    krok4: 'Limit invalidity',
    krok4BPod: 'dlhy, ciele a rentu kryje invalidita živiteľa',
    krok4Pod: 'čo chýba + dlhy + ciele + renta − čo už máte',
    model: 'Orientačný model, nie záruka: počíta s výnosom 4 % nad infláciu, pri nižšom výnose vychádza limit vyšší. Invalidný dôchodok je pre plnú invaliditu, pri čiastočnej je nižší. Plnenie určujú poistné podmienky.',
    nepotreba: 'Rodine by zostal dostatočný príjem — krytie invalidity nie je nutné.',
    nicNechybi: 'Príjmy pokryjú výdavky rodiny presne.',
    odvozenaRenta: 'odvodené: renta = dnešné výdavky',
    odvozenaRentaPotreba: 'odvodené: renta = dnešné výdavky a splátky bez sporenia a splátok doplatených do renty',
    odvozeneRoky: 'odvodené: horizont renty {roky} podľa šablóny',
    orezano: 'Príjmy a majetok rodine vystačia — krytie invalidity nie je nutné.',
    partner: '{jmeno} ďalej zarába',
    pasivniAria: 'Pasívny príjem {castka}, limit invalidity {limit}',
    pasivniTitul: 'Keby ste dnes mali pasívny príjem',
    pasivniVeta: 'Poistenie je cena za to, že zatiaľ nemáme pasívny príjem.',
    prahMezera: 'pokryje medzeru',
    prahNula: 'poistka nie je potrebná',
    prebyvaVeta: 'Príjmy rodine vystačia a zostane {castka} — o to je limit nižší.',
    rada: {
      chybi: 'chýba',
      dnes: 'dnes',
      duchod: 'invalidný dôchodok',
      narust: '+20 % po invalidite',
      partner: 'príjem partnera',
      pasivni: 'pasívny príjem',
    },
    radekChybi: 'Čo chýba až do renty',
    radekCile: 'Zainvestovať na ciele (dnešná hodnota)',
    radekDluhy: 'Doplatiť dlhy',
    radekMajetek: 'Čo už máte na účtoch',
    radekPrebytek: 'Čo rodine z príjmov zostane navyše — až do renty ({roky})',
    radekRenta: 'Zainvestovať na rentu (dnešná hodnota)',
    radekRentaPod: '{castka} v dnešných cenách o {roky}, čerpanie 4 %',
    rucne: 'Na karte je ručne {rucni}, vypočítané {spocitano}.',
    skryt: 'Skryť výpočet',
    titul: 'Ako vzniká suma invalidity',
    toggle: 'Ako sa počíta invalidita',
    vysledek: 'Limit invalidity',
    zaokrouhleni: 'Riadky sú zaokrúhlené, ich súčet sa môže nepatrne líšiť.',
  },
  /* BLOK:invaliditaVysvetleni END */
  /* BLOK:staraZtrata START — generuje scratchpad/slovnik.py, ručně needitovat */
  staraZtrata: {
    invalidita: 'Stará zmluva má invaliditu {castka}, nová ju nemá.',
    jine: 'Stará zmluva má {riziko} {castka}, nová ho nemá.',
    smrt: 'Stará zmluva má krytie smrti {castka}, nová ho nemá.',
  },
  /* BLOK:staraZtrata END */
  /* BLOK:schodPoSchodu START — generuje scratchpad/slovnik.py, ručně needitovat */
  schodPoSchodu: {
    bezDat: 'Z tejto analýzy sa zatiaľ nedá nič vypočítať.',
    bezPrijmu: 'Bez príjmov a výdavkov sa poradie vypočítať nedá. Doplňte ich v analýze.',
    e: {
      doporucene: 'Odporúčané poradie',
      hlasDoporucene: 'Vrátené odporúčané poradie.',
      hlasPosun: '{nazev} je teraz na {n}. mieste.',
      nadpis: 'Čo je pre vás najdôležitejšie?',
      niz: '{nazev} nižšie',
      podnadpis: 'Hore je to, čo chcete mať najskôr.',
      renta: 'Renta · dostane, čo zostane',
      rovne: 'Všetko je pre mňa rovnako dôležité',
      seznam: 'Poradie cieľov',
      tahnout: 'Presunúť: {nazev}',
      ulozit: 'Uložiť poradie',
      vys: '{nazev} vyššie',
      zaklad: 'Základ: rezerva a zabezpečenie príjmu · vždy prvé',
      zakladRezerva: 'Základ: rezerva · vždy prvá',
      zakladZajisteni: 'Základ: zabezpečenie príjmu · vždy prvé',
      zrusit: 'Zrušiť',
    },
    k: {
      cilCast: '{nazev}: do roku {rok} nasporené {pct}, chýba {chybi}.',
      cilHotovo: '{nazev}: do roku {rok} splnené, včas.',
      cileFew: '{vcas} z {celkem} cieľov včas',
      cileMany: '{vcas} z {celkem} cieľov včas',
      cileOne: '{vcas} z {celkem} cieľa včas',
      dalsiCast: 'Ďalšie ciele ({n}): k termínom nasporené {pct}, chýba {chybi}.',
      dalsiHotovo: 'Ďalšie ciele ({n}): k termínom splnené.',
      nezadaneFew: '{n} ciele nemajú sumu alebo termín.',
      nezadaneMany: '{n} cieľov nemá sumu alebo termín.',
      nezadaneOne: '{n} cieľ nemá sumu alebo termín.',
      renta: 'Renta od roku {rok}: modelovo pripravené {pct} (pesimisticky {pes}), chýba {chybi}.',
      rentaHotovo: 'Renta od roku {rok}: modelovo pripravené {pct} (pesimisticky {pes}).',
      shrnuti: 'Pri {castka} mesačne: {cile}, renta {renta}.',
      shrnutiBezRenty: 'Pri {castka} mesačne: {cile}.',
      shrnutiJenRenta: 'Pri {castka} mesačne: renta {renta}.',
      srovnani: 'Pri {castka} mesačne: {cile} (predtým {vcasDrive}), renta {renta} namiesto {rentaDrive}.',
      srovnaniBezRenty: 'Pri {castka} mesačne: {cile} (predtým {vcasDrive}).',
      srovnaniJenRenta: 'Pri {castka} mesačne: renta {renta} namiesto {rentaDrive}.',
      uvod: 'Odkladáte {castka} mesačne. Koľko bude k termínom, ktoré chcete?',
      zajisteni: 'Zabezpečenie príjmu dohodneme po stretnutí.',
      zaklad: 'Najprv základ.',
      zakladCast: 'Najprv základ: rezerva do roku {rok} na {pct}, chýba {chybi}.',
      zakladHotovo: 'Najprv základ: rezerva doplnená do roku {rok}.',
      zakladMa: 'Najprv základ: rezervu máte už dnes.',
    },
    nadpis: 'Krok za krokom',
    neodsouhlaseno: 'zatiaľ neodsúhlasené klientom',
    o: {
      dal: 'Ďalší krok',
      dalsi: 'Ďalšie',
      krok: 'Krok {n}: {nazev}',
      kroky: 'Kroky prehrávania',
      otazka: 'Poradie',
      pauza: 'Pauza',
      pokracovat: 'Pokračovať',
      prehrat: 'Prehrať',
      preskocit: 'Preskočiť',
      uvod: 'Štart',
      zaklad: 'Základ',
      znovu: 'Znova',
      zpet: 'Krok späť',
    },
    odkladani: 'Odkladanie mesačne',
    p: {
      bezPojistneho: 'Cena poistenia zatiaľ nie je zadaná, z prebytku sa nič neodpočítava.',
      dnes: '„Dnes“ = čo dnes pravidelne odkladáte (sporenie, dôchodkové sporenie, fondy).',
      model: 'Modelovo, nie garancia. Rovnaký výpočet ako Návrh riešenia: cieľ dostáva peniaze len do svojho termínu a ukáže sa, koľko bude k termínu. Pesimisticky = horšie výnosy.',
      pojistne: 'Prebytok po poistnom = voľný prebytok mínus cena poistenia od poradcu.',
    },
    precerpano: 'Ručné sumy pri cieľoch: prečerpané o {castka} — počítame len s {dostupne} mesačne.',
    prehravac: 'prehrávač',
    q: {
      ano: 'Áno',
      nemeniCisla: 'Čísla vyššie počíta Návrh riešenia podľa termínov. Poradie klienta je zapísané, výpočet zatiaľ nemení.',
      otazka: 'Súhlasíte s týmto poradím?',
      popis: 'Základ → {cile} → renta',
      popisBezCilu: 'Základ → renta',
      popisBezRenty: 'Základ → {cile}',
      popisRovne: 'Základ, potom všetko rovnako dôležité: {cile}, zvyšok na rentu',
      popisRovneBezRenty: 'Základ, potom všetko rovnako dôležité: {cile}',
      potvrzeno: 'Poradie potvrdené {datum}',
      upraveno: 'Poradie klienta zapísané {datum}',
      upravit: 'Upraviť',
      zmenit: 'Zmeniť',
    },
    s: {
      bezUdaju: 'bez údajov',
      castkaNezadana: 'suma nezadaná',
      chybi: 'chýba {castka}',
      cil: 'cieľ',
      cileFew: '{n} ciele',
      cileMany: '{n} cieľov',
      cileOne: '{n} cieľ',
      dalsiFew: '{n} ďalšie',
      dalsiMany: '{n} ďalších',
      dalsiOne: '{n} ďalší',
      doplneno: 'doplnené',
      doplnit: 'doplňte',
      drive: 'predtým {pct}',
      kRoku: 'k {rok}',
      maDnes: 'máte už dnes',
      mesicne: '{castka}/mes.',
      nepocitaSe: 'nepočíta sa',
      pesimisticky: 'pesimisticky {pct}',
      poSchuzce: 'po stretnutí',
      pojisteni: 'Poistenie',
      potreba: 'potrebné',
      pripraveno: 'pripravené',
      renta: 'Renta',
      rezerva: 'Rezerva',
      sjednat: 'dohodnúť',
      ted: 'teraz',
      terminNezadan: 'termín nezadaný',
      vcas: 'včas',
    },
    schodyAria: 'Schody cieľov. {shrnuti}',
    stitek: 'Modelovo',
    tlacitko: 'Prehrať',
    tlacitkoPopis: 'krok za krokom',
    tlacitkoTitul: 'Krátka animácia: koľko bude k termínom podľa poradia cieľov',
    vekFew: '{n} roky',
    vekMany: '{n} rokov',
    vekOne: '{n} rok',
    volbaDnes: 'Dnes {castka}',
    volbaPlan: 'Prebytok {castka}',
    volbaPlanPoPojistnem: 'Prebytok po poistnom {castka}',
    zavrit: 'Zavrieť prehrávanie',
  },
  /* BLOK:schodPoSchodu END */
  /* BLOK:smlouvaEditor START — generuje scratchpad/slovnik.py, ručně needitovat */
  smlouvaEditor: {
    celkova: 'Celková suma ({mena})',
    chybaPoli: 'Server údaje neprijal — skontrolujte vyplnené polia.',
    chybaServeru: {
      jenPojistne: 'Výpoveď sa dá vygenerovať len pre poistné zmluvy',
      klientNenalezen: 'Klient sa nenašiel',
      neplatneId: 'Neplatný odkaz — obnov stránku a skús to znova.',
      smlouvaNenalezena: 'Zmluva sa nenašla',
    },
    cislo: 'Číslo zmluvy',
    fixace: 'Koniec fixácie',
    hodnota: 'Aktuálna hodnota ({mena})',
    instituce: 'Banka / poisťovňa',
    mazaniSelhalo: 'Zmazanie zlyhalo',
    mesicni: 'Mesačná suma ({mena})',
    nadpisEditace: 'Úprava zmluvy',
    nadpisNova: 'Nová zmluva',
    napr: 'napr. {x}',
    nasporeno: 'Nasporené ({mena})',
    poznamky: 'Poznámky',
    poznamkyNapr: 'Čo je dôležité k tejto zmluve…',
    pridano: 'Zmluva pridaná',
    pridat: 'Pridať zmluvu',
    sazba: 'Úroková sadzba (%)',
    smazano: 'Zmluva zmazaná',
    smazat: 'Zmazať',
    smazatPotvrzeni: 'Naozaj zmazať túto zmluvu? Zmažú sa aj naviazané úlohy v diári.',
    stav: 'Stav',
    stavActive: 'Aktívna',
    stavCancelled: 'Zrušená',
    stavExpired: 'Skončila',
    typChybi: 'Vyber typ zmluvy',
    typSmlouvy: 'Typ zmluvy *',
    typy: {
      hypoteka: 'Hypotéka',
      investice: 'Investícia',
      jine: 'Iné',
      penzijko: 'Dôchodkové sporenie',
      pojisteni_auta: 'Poistenie auta',
      pojisteni_majetek: 'Poistenie majetku',
      pojisteni_odpovednost: 'Poistenie zodpovednosti',
      pojisteni_ostatni: 'Ostatné poistenie (právna ochrana, cestovné…)',
      pojisteni_zivot: 'Životné poistenie',
      stavebni: 'Stavebné sporenie',
      uver: 'Úver',
      zdravotni: 'Zdravotné',
    },
    ukladaniSelhalo: 'Ukladanie zlyhalo',
    ulozeno: 'Zmluva uložená',
    ulozenoJakoJine: 'Uložené ako „Iné“ — tento druh zmluvy server zatiaľ nepozná.',
    ulozitZmeny: 'Uložiť zmeny',
    vyber: '— Vyber —',
    vyroci: 'Výročie zmluvy',
    zacatek: 'Začiatok zmluvy',
    zavrit: 'Zavrieť',
    zbyva: 'Zostáva splatiť ({mena})',
    zrusit: 'Zrušiť',
  },
  /* BLOK:smlouvaEditor END */
  /* BLOK:cilHistorie START — generuje scratchpad/slovnik.py, ručně needitovat */
  cilHistorie: {
    cilCastka: 'cieľ {castka}',
    hero: '{roky}-ročných období histórie (1946–2026) by cieľ [[vyšiel]]',
    heroPozn: '{ok} z {n} kĺzavých okien. Všetko reálne, po odpočítaní dobovej inflácie.',
    jednotka: {
      milion: 'M',
      tisic: 'tis.',
    },
    legenda: {
      median: 'medián',
      nejhorsi: 'najhoršie okno',
      nejlepsi: 'najlepšie okno',
      projekce: 'projekcia ({varianta})',
    },
    nadpis: 'Historická kalkulačka — keby takto investoval v minulosti',
    tip: {
      median: 'Medián',
      nejhorsi: 'Najhoršie okno',
      nejlepsi: 'Najlepšie okno',
      projekce: 'Projekcia',
    },
    tipRok: 'Rok {rok} · +{n} r.',
  },
  /* BLOK:cilHistorie END */
  /* BLOK:smlouvaKarta START — generuje scratchpad/slovnik.py, ručně needitovat */
  smlouvaKarta: {
    aktualniHodnota: 'Aktuálna hodnota',
    bezCisla: 'číslo nevyplnené',
    celkem: 'Celkom',
    cislo: 'č. {cislo}',
    druh: {
      hypoteka: 'Hypotéka',
      investice: 'Investícia',
      jine: 'Iné',
      penzijko: 'Dôchodkové sporenie',
      pojisteni_auta: 'Poistenie auta',
      pojisteni_majetek: 'Poistenie majetku',
      pojisteni_odpovednost: 'Poistenie zodpovednosti',
      pojisteni_ostatni: 'Ostatné poistenie',
      pojisteni_zivot: 'Životné poistenie',
      stavebni: 'Stavebné sporenie',
      uver: 'Úver',
      zdravotni: 'Zdravotné',
    },
    fixaceDo: 'Fixácia do',
    generuji: 'Generujem…',
    kratce: {
      hypoteka: 'Hypotéka',
      investice: 'Investícia',
      jine: 'Iné',
      penzijko: 'Dôchodok',
      pojisteni_auta: 'Poist. auta',
      pojisteni_majetek: 'Poist. majetku',
      pojisteni_odpovednost: 'Zodpovednosť',
      pojisteni_ostatni: 'Ostatné poist.',
      pojisteni_zivot: 'Životné poist.',
      stavebni: 'Stavebné',
      uver: 'Úver',
      zdravotni: 'Zdravotné',
    },
    mesicne: 'Mesačne',
    nasporeno: 'Nasporené',
    okno: {
      datumMinulo: 'Dátum ukončenia {datum} už uplynul — v liste ho oprav na koniec aktuálneho poistného obdobia.',
      jazyk: {
        cs: 'čeština',
        sk: 'slovenčina',
      },
      jazykDopisu: 'Text výpovede je v jazyku poisťovne ({jazyk}).',
      kopirovat: 'Kopírovať text',
      lhutySK: 'Výpoveď ku koncu poistného obdobia najneskôr 6 týždňov vopred (§ 800 ods. 1). Do 2 mesiacov od uzavretia len ak to zmluva dovoľuje, s 8-dennou lehotou (§ 800 ods. 2).',
      sablona: 'Šablóna — pred podpisom over údaje, lehoty a adresu poisťovne v poistnej zmluve a podmienkach.',
      staryServer: 'Server zatiaľ vrátil český vzor. Slovenské znenie bude po aktualizácii servera — dovtedy text pred odoslaním uprav.',
      tisk: 'Vytlačiť / uložiť PDF',
      titulek: 'Výpoveď — {pojistovna} / {klient}',
      zaklad: 'Právny základ: {zaklad}',
      zavrit: 'Zavrieť',
      zkopirovano: 'Skopírované do schránky',
    },
    pocetFew: '{n} zmluvy',
    pocetMany: '{n} zmlúv',
    pocetOne: '{n} zmluva',
    poznamkaZAnalyzy: 'Z analýzy — zmluva pred analýzou',
    prazdnoNadpis: 'Žiadne zmluvy',
    prazdnoText: 'Pridaj prvú zmluvu klienta — hypotéku, poistenie, investíciu…',
    predAnalyzou: 'pred analýzou',
    predAnalyzouTitle: 'Zmluva prenesená z finančnej analýzy — klient ju mal uzavretú pred analýzou',
    prehled: {
      fixaceLet: 'fix. {n} r.',
      mesicne: '{castka} / mes.',
      smlouvy: 'Zmluvy',
      smlouvyPocet: 'Zmluvy ({n})',
      zadneSmlouvyZatim: 'Zatiaľ žiadne zmluvy — pridaj ich v záložke Zmluvy.',
      zobrazitDalsi: '+ Zobraziť ďalších {n}',
    },
    pridat: 'Pridať zmluvu',
    toastChyba: 'Výpoveď sa nepodarilo vygenerovať',
    toastHotovo: 'Výpoveď vygenerovaná — vytlač ju alebo ulož ako PDF',
    toastPopup: 'Prehliadač zablokoval okno — povoľ vyskakovacie okná.',
    toastStaryServer: 'Server zatiaľ vie len český vzor — pred odoslaním text uprav podľa slovenského práva.',
    upravit: 'Upraviť zmluvu',
    vypoved: 'Výpoveď do poisťovne',
    vypovedTitle: 'Vygeneruje vzor výpovede do poisťovne podľa {zakon} — vytlačíš alebo uložíš ako PDF',
    vyroci: 'Výročie',
    zAnalyzy: 'Z analýzy: {popis}',
    zacatek: 'Začiatok',
    zakon: {
      CZ: '§ 2807 českého OZ',
      SK: '§ 800 Občianskeho zákonníka',
    },
    zbyvaSplatit: 'Zostáva splatiť',
  },
  /* BLOK:smlouvaKarta END */
  /* BLOK:navrhDavky START — generuje scratchpad/slovnik.py, ručně needitovat */
  navrhDavky: {
    invalidniMes: 'Invalidný dôchodok (mes.)',
    starobniMes: 'Starobný dôchodok (mes.)',
  },
  /* BLOK:navrhDavky END */
  /* BLOK:variantaVynosu START — generuje scratchpad/slovnik.py, ručně needitovat */
  variantaVynosu: {
    optimisticky: 'Optimisticky',
    pesimisticky: 'Pesimisticky',
    realisticky: 'Realisticky',
  },
  /* BLOK:variantaVynosu END */
  /* BLOK:penze2 START — generuje scratchpad/slovnik.py, ručně needitovat */
  penze2: {
    chyby: {
      bezData: 'Dátum narodenia: vyplňte ho, alebo zapnite ručné zadanie rokov sporenia.',
      cele: '{pole}: zadajte celé číslo.',
      cislo: '{pole}: zadajte číslo.',
      datum: 'Dátum narodenia: nesmie byť v budúcnosti ani neplatné.',
      nadpis: 'Opravte zvýraznené polia. Výsledky zatiaľ zodpovedajú poslednému platnému zadaniu.',
      prazdne: '{pole}: vyplňte hodnotu.',
      rozsah: '{pole}: zadajte hodnotu od {min} do {max}.',
      vPenzi: 'Klient už je vo veku odchodu do dôchodku. Zapnite ručné zadanie rokov sporenia.',
    },
    f: {
      bezDat: 'Pre tento výber nie sú v období žiadne dáta.',
      dataDo: 'dáta len do {rok}',
      dataOd: 'dáta od {rok}',
      grafAria: 'Čiarový graf vývoja 100 Kč vo fondoch za {obdobi}. Najvyššie {fond}: {hodnota}',
      grafNadpis: 'Vývoj 100 Kč, {obdobi}',
      grafPopis: 'Index 100 = hodnota na konci roka {rok}',
      historie: 'História',
      kontext: 'Ostatné vybrané fondy sivo v pozadí',
      maxZvyr: 'Zvýrazniť sa dá najviac {max} fondov. Najprv niektorý odznačte.',
      mimoVyber: 'mimo výberu',
      nic: 'Zrušiť výber',
      o10: '10 rokov',
      o3: '3 roky',
      o5: '5 rokov',
      oVse: 'Všetko',
      obdobi: 'Obdobie',
      pocet: 'Fondy: {n} · zvýraznené {z} z {max}',
      prumery: 'Priemer stratégie (čiarkovane)',
      slAkce: 'Akcia',
      slCelkem: 'Za obdobie spolu',
      slFond: 'Fond / priemer',
      slPa: 'Výnos p. a.',
      slRust: 'Rast 1 Kč',
      slStrategie: 'Stratégia',
      slVolatilita: 'Volatilita',
      spolecnost: 'Penzijná spoločnosť',
      strategie: 'Stratégia',
      tabulka: 'Fondy',
      tabulkaInfo: 'Zvýrazniť môžete až 5 fondov zaškrtnutím. Hviezdička = fond nemá dáta za celé obdobie; jeho výnos p. a. sa počíta od vzniku a čiara začína v roku vzniku.',
      uvod: 'Ako rástlo 100 Kč vo fondoch penzijných spoločností. Ročné výnosy po poplatkoch (APS ČR, banky.cz).',
      vse: 'Vybrať všetko',
      vsechnySpolecnosti: 'všetky spoločnosti',
      vyber: 'Výber fondov',
      vyberteAspon: 'Vyberte aspoň jednu stratégiu a jednu penzijnú spoločnosť.',
      vysvetlivky: 'Ako čítať tabuľku',
      vysvetlivkyInfo: 'Výnos p. a. = priemerné ročné zhodnotenie za obdobie (geometrický priemer). Za obdobie spolu = o koľko percent vzrástla hodnota. Volatilita = smerodajná odchýlka ročných výnosov. Transformované fondy (staré penzijné pripoistenie) nemajú záporný výsledok, pretože ho zo zákona hradí penzijná spoločnosť.',
      vznik: 'vznik {datum}, prvý rok len sčasti',
      zadnyZvyr: 'Žiadny fond nie je zvýraznený. Zaškrtnite ho v tabuľke.',
      zrusitZvyr: 'Zrušiť zvýraznenie: {fond}',
    },
    h: {
      chybaCastka: '{pole}: zadajte číslo 0 alebo väčšie, napr. 1 000.',
      chybaObdobi: 'Začiatok sporenia musí byť skôr ako koniec.',
      chybaRok: '{fond}: pre rok {rok} nie sú výnosy. Dáta má od roku {od}.',
      danVyber: 'Daň pri jednorazovom výbere (orientačne)',
      danVyberInfo: 'Pri jednorazovom výbere sa z výnosu a príspevkov zamestnávateľa odvádza 15 % daň. Pri rente na 10 a viac rokov sa daň neplatí.',
      dipFond: 'Do čoho DIP investuje',
      dipInfo: 'DIP existuje od roku 2024. Pre staršie roky ide o simuláciu rovnakých vkladov do zvoleného fondu bez štátneho príspevku. Daňová úspora (odpočet do 48 000 Kč ročne, 15 %) sa počíta až od roku 2024.',
      dipPozn: 'Pri DIP štát neprispieva.',
      dipPoznInfo: 'Pri výbere po 60. roku veku a 10 rokoch trvania sa výnos nezdaňuje.',
      doMesice: 'Do mesiaca',
      doRoku: 'Do roku',
      drive: 'predtým {nazev}',
      duchod: 'Klient poberá starobný dôchodok',
      fond: 'Fond alebo priemer',
      grafAria: 'Vývoj hodnoty účtu {od}–{do}: najvyššie {fond} {castka}, vlastné vklady {vklady}',
      grafNadpis: 'Hodnota účtu na konci roka',
      grafNadpisMesic: 'Hodnota účtu na konci roka (posledný rok k vybranému mesiacu)',
      kpiNasporeno: 'Nasporené',
      kpiNove: 'Nové penzijko',
      kpiRozdil: 'Rozdiel',
      kpiStare: 'Staré penzijko',
      kpiStat: 'Štát spolu',
      kpiUsporaDip: 'Daňová úspora spolu',
      kpiVDip: 'Nasporené v DIP',
      kpiVklady: 'Vlastné vklady',
      kpiZhod: 'Zhodnotenie vlastných peňazí',
      mesicuStat: '{mesicu}, štát {stat}',
      nove: 'Nové penzijko (fond alebo priemer)',
      noveOd2013: 'Nové penzijko existuje od roku 2013.',
      od: 'od {rok}',
      odMesice: 'Od mesiaca',
      odRoku: 'Od roku',
      pohled: {
        cmp: 'Staré vs. nové penzijko',
        dip: 'DIP',
        fund: 'Konkrétny fond',
        str: 'Porovnanie stratégií',
      },
      pohledy: 'Pohľad',
      pole: {
        emp: 'Príspevok zamestnávateľa mesačne',
        lump: 'Jednorazový vklad na začiatku',
        own: 'Vlastný vklad mesačne',
      },
      pravidlaInfo: 'Od 7/2024 bez štátneho príspevku. Štátny príspevok: 2000–2012 max. 150 Kč (stupnica orientačná), 2013–6/2024 max. 230 Kč (od 1 000 Kč), od 7/2024 20 % z vkladu, max. 340 Kč. Daňová úspora sa počíta od roku 2013, sadzba 15 %.',
      skupinaNove: 'Nové penzijko – {spolecnost}',
      skupinaPrumery: 'Priemery',
      skupinaStare: 'Staré penzijko',
      slHodnota: '{fond} – hodnota',
      slVynos: '{fond} – výnos',
      slozeni: 'Z čoho sa skladá',
      stare: 'Staré penzijko (transformovaný fond)',
      statSub: 'príspevky {stat} + daňová úspora {uspora}',
      tfZkratka: 'TF',
      transformovany: 'transformovaný fond',
      usporaDipSub: 'odpočet do 48 000 Kč ročne, od roku 2024',
      usporaObdobi: 'Daňová úspora z odpočtov za celé obdobie',
      vProspechNoveho: 'v prospech nového penzijka',
      vProspechStareho: 'v prospech starého penzijka',
      vlastniVklady: 'Vlastné vklady',
      vynosFondu: 'výnos fondu {pct} ročne',
      zadani: 'Zadanie',
      zdroje: 'Zdroje: APS ČR, banky.cz. Výnosy po poplatkoch.',
      zdrojeInfo: 'APS ČR (účastnícke fondy 2017–2025, transformované fondy 2013–2025, penzijné fondy 1995–2012), banky.cz (účastnícke fondy 2013–2016). Vklady na začiatku mesiaca, ročný výnos rozložený rovnomerne do mesiacov, štátny príspevok v tom istom mesiaci. Minulé výnosy nie sú zárukou budúcich. Nejde o ponuku ani investičné odporúčanie.',
      ztrata: 'Strata',
    },
    m: {
      dalsi: 'Existujúca zmluva a ďalšie predpoklady',
      danZVynosu: 'Započítať daň z výnosu penzijka',
      danZVynosuInfo: '15 % z výnosu (a príspevkov zamestnávateľa) pri jednorazovom výbere z penzijka. Pri rente na 10 a viac rokov sa neplatí. DIP po splnení podmienok bez dane.',
      danZVynosuOdectena: 'Daň z výnosu (už odpočítaná)',
      danZam: 'Zdaniť aj príspevky zamestnávateľa do penzijka',
      danZamInfo: 'Pri jednorazovom výbere sa 15 % zdaňuje výnos aj príspevky zamestnávateľa do penzijka (tak počíta zadanie kalkulačky). Na DIP sa nevzťahuje.',
      dip: 'DIP',
      dip2: 'DIP 2',
      dipKratce: 'DIP',
      doMaxima: 'do maxima chýba {castka}',
      dodaneni: 'Dodanenie odpočtov pri nesplnení podmienok',
      duchod: 'Klient má priznaný starobný dôchodok',
      duchodInfo: 'Od 7/2024 poberateľ starobného dôchodku štátny príspevok nedostáva.',
      duchodceNe: 'dôchodca: príspevok nepatrí',
      grafAria: 'Skladaný stĺpcový graf nasporenej sumy po rokoch, v roku {rok} spolu {castka}',
      grafNadpis: 'Nasporené na konci každého roka',
      jednotkaLet: 'rokov',
      jednotkaMesicu: 'mesiacov',
      jizInfo: 'Započíta sa do podmienky minimálnej doby sporenia. Zostatok existujúcej zmluvy zadajte ako jednorazový vklad alebo prevod.',
      kategorie: {
        dite: 'Dieťa',
        dospely: 'Dospelý',
        senior: 'Senior',
      },
      klient: 'Klient',
      kpiNasporeno: 'Spolu nasporené na dôchodku',
      kpiNavic: 'Získam navyše',
      kpiRenta: 'Mesačná renta',
      kpiVynos: 'Výnos p. a.**',
      letFew: '{n} roky',
      letMany: '{n} rokov',
      letOne: '{n} rok',
      maxVyuzito: 'maximum {castka} využité',
      mesicuFew: '{n} mesiace',
      mesicuMany: '{n} mesiacov',
      mesicuOne: '{n} mesiac',
      naKonci: 'na konci sporenia',
      nadVklady: 'nad vlastné vklady {castka}',
      narozeni: 'Dátum narodenia',
      nelze: 'nedá sa',
      nesplneno: 'Nesplnené',
      odStatu: 'Od štátu spolu ročne',
      odchod: 'Odchod do dôchodku',
      odebratDip2: 'Odobrať druhú stratégiu DIP',
      odpocty: 'Klient využije daňové odpočty',
      odpoctyInfo: 'Z vlastných vkladov do penzijka nad 1 700 Kč mesačne a z DIP, spolu max. 48 000 Kč ročne. Úspora = odpočet × 15 %; do nasporenej sumy sa nepripočítava.',
      odpoctyNe: 'odpočty nie sú započítané',
      penzeVRoce: 'Dôchodok v roku',
      penzijko: 'Penzijko (DPS)',
      penzijkoKratce: 'Penzijko',
      plnaPodpora: 'Plná podpora: {a} mesačne do penzijka na štátny príspevok a ďalších {b} mesačne do penzijka alebo DIP na daňový odpočet.',
      poDani: 'po dani z výnosu {castka}',
      pocatek: 'Jednorazový vklad alebo prevod',
      pocatekInfo: 'Zostatok existujúcej zmluvy alebo jednorazový vklad. Do Výnosu* sa počíta ako vlastné peniaze vložené na začiatku.',
      podminky: 'Podmienky a dane',
      podpora: 'Využitie štátnej podpory',
      podporaInfo: 'Štátny príspevok: 20 % z vlastného vkladu od 500 Kč, max. 340 Kč mesačne (pri vklade 1 700 Kč). Daňová úspora: 15 % z odpočtu, max. 7 200 Kč ročne. Maximum od štátu je 11 280 Kč ročne.',
      pole: {
        dip2Vlastni: 'DIP 2 – vlastné vklady',
        dip2Vynos: 'DIP 2 – výnos',
        dip2Zam: 'DIP 2 – zamestnávateľ',
        dipVlastni: 'DIP – vlastné vklady',
        dipVynos: 'DIP – výnos',
        dipZam: 'DIP – zamestnávateľ',
        dpsPocatek: 'Penzijko – jednorazový vklad',
        dpsVlastni: 'Penzijko – vlastné vklady',
        dpsVynos: 'Penzijko – výnos',
        dpsZam: 'Penzijko – zamestnávateľ',
        jizMesicu: 'Na existujúcej zmluve už sporené',
        narozeni: 'Dátum narodenia',
        rentaLet: 'Počet rokov na dôchodku',
        rentaVynos: 'Zhodnotenie na dôchodku',
        roky: 'Roky sporenia',
      },
      pravidlo: 'Pravidlo 60 rokov + 120 (60) mesiacov',
      pravidloAno: 'Splnené',
      pravidloAuto: 'Vyhodnotiť z veku a doby sporenia',
      pravidloDetail: 'vek pri výbere {vek}, sporenie {mesicu} (minimum {min} mesiacov)',
      pravidloInfo: 'Výplata bez vrátenia podpory: vek 60 rokov a doba sporenia aspoň 120 mesiacov (zmluvy do 2023: 60 mesiacov). Pri nesplnení kalkulačka orientačne vráti štátne príspevky, zdaní výnos a dodaní odpočty za posledných 10 rokov.',
      pravidloNe: 'Nesplnené (predčasný výber)',
      pravidloPredpoklad: 'vek nie je zadaný, počíta sa so splnením',
      pravidloRucne: 'zadané ručne (minimum {min} mesiacov)',
      predpoklady: 'Modelový výpočet, nie garancia.',
      predpokladyInfo: 'Predpoklad výnosu po poplatkoch počas celej doby sporenia, mesačné úročenie (ročný výnos / 12), vklady na začiatku mesiaca. Renta je anuita s výplatou na začiatku mesiaca. Pravidlá štátnej podpory platné od 1. 7. 2024 bez zmeny počas celej doby. Daňová úspora sa do nasporenej sumy nepripočítava. Minulé výnosy nie sú zárukou budúcich a nejde o investičné odporúčanie.',
      pridatDip2: 'Pridať druhú stratégiu DIP',
      priklad: 'Príklad',
      produkty: 'Výsledky podľa produktu',
      produktyInfo: 'Výnos* = ročné zhodnotenie vlastných vkladov vrátane štátneho príspevku. Výnos** = navyše vrátane príspevku zamestnávateľa. V riadkoch produktov je počítaný zo sumy pred daňou, v riadku Spolu zo sumy po dani.',
      renta: 'Renta na dôchodku',
      rentaBezZhod: '{roky}, bez ďalšieho zhodnotenia',
      rentaInfo: 'Renta je anuita s výplatou na začiatku mesiaca. Pri 0 % sa nasporená suma len rozdelí na rovnaké mesačné výplaty.',
      rentaSeZhod: '{roky}, zhodnotenie {pct} ročne',
      rokyDoPenze: 'Roky do dôchodku',
      rokyRucne: 'Zadať roky sporenia ručne',
      rokyRucneInfo: 'Keď dátum narodenia nepoznáte alebo chce klient sporiť inak dlho než do 60 / 65 rokov.',
      slozeni: 'Z čoho sa skladá nasporená suma',
      smlouva2024: 'Zmluva uzavretá po 1. 1. 2024',
      smlouva2024Info: 'Zmluva uzavretá od 1. 1. 2024 potrebuje na výplatu bez sankcie aspoň 120 mesiacov sporenia, staršia zmluva 60 mesiacov.',
      splneno: 'Splnené',
      statMes: 'Štátny príspevok mesačne',
      strategie: 'Stratégia',
      strategieInfo: 'Predvoľba doplní výnos podľa priemeru fondov danej stratégie za {od}–{do} (po poplatkoch). Len pomôcka k zadaniu, nie predpoveď.',
      usporaCelkem: 'Daňová úspora za celú dobu (vracia sa na dani, na účte nie je)',
      usporaRok: 'Daňová úspora ročne',
      v60: 'v 60 rokoch',
      v65: 'v 65 rokoch',
      vRoce: 'v roku {rok}',
      vek: 'Vek',
      vklady: 'Vklady mesačne a výnos',
      vkladyInfo: 'Mesačné vklady do penzijka (DPS) a DIP. Výnos je predpoklad po poplatkoch, úročí sa mesačne (ročný výnos / 12), vklady na začiatku mesiaca.',
      vlastni: 'Vlastné vklady',
      vlastniVynos: 'Vlastný výnos',
      vlastniZadani: 'Vlastné zadanie',
      vynos: 'Výnos ročne',
      vyuzitoAria: 'Využité {pct} % maxima',
      vzorPokrocily: 'Príklad: penzijko + DIP',
      vzorZakladni: 'Príklad: 1 000 Kč do penzijka',
      zMaxima: 'z max. {castka} · {pct}',
      zamestnavatel: 'Zamestnávateľ',
      zhodVlastnich: 'zhodnotenie vlastných peňazí',
    },
    prumer: {
      dynamicky: 'Priemer dynamických fondov',
      jina: 'Priemer',
      konzervativni: 'Priemer konzervatívnych fondov',
      transformovany: 'Priemer transformovaných fondov',
      vyvazeny: 'Priemer vyvážených fondov',
    },
    prumerKratce: {
      dynamicky: 'Ø dynamické',
      jina: 'Ø',
      konzervativni: 'Ø konzervatívne',
      transformovany: 'Ø transformované',
      vyvazeny: 'Ø vyvážené',
    },
    r: {
      coPocitat: 'Čo počítať',
      dan: 'Odpočítať 15 % daň z výnosu',
      dostavat: 'Koľko budem dostávať',
      f: {
        castka: 'Nasporené na začiatku dôchodku',
        let: 'Roky čerpania',
        letS: 'Roky sporenia',
        pocatek: 'Už nasporené',
        renta: 'Požadovaná mesačná renta',
        vynos: 'Zhodnotenie na dôchodku',
        vynosS: 'Zhodnotenie pri sporení',
        zam: 'Zamestnávateľ mesačne',
      },
      grafCerpani: 'Zostatok počas čerpania',
      grafCerpaniAria: 'Plošný graf zostatku počas {roky} čerpania renty {renta} mesačne',
      grafSporeni: 'Sporenie a čerpanie renty',
      grafSporeniAria: 'Plošný graf: sporenie {sporeni} na {castka}, potom {roky} čerpania renty {renta}',
      kpiNasporeno: 'Nasporené pri tomto vklade',
      kpiPotreba: 'Potrebná suma na dôchodku',
      kpiRenta: 'Mesačná renta',
      kpiSporit: 'Mesačne sporiť',
      kpiStatZam: 'Štát a zamestnávateľ mesačne',
      kpiVyplaceno: 'Vyplatené spolu',
      kpiZUroku: 'Z toho výnos na dôchodku',
      kpiZtrata: 'Strata na dôchodku',
      letRenty: '{roky} renty',
      letRentyPo: '{roky} renty po {renta}',
      nadCastku: 'nad nasporenú sumu {castka}',
      nelze: {
        nedosazitelne: 'Pri zadanom zhodnotení sa nedá dosiahnuť. Skúste dlhšiu dobu sporenia alebo vyššie zhodnotenie.',
        nulovaDoba: 'Doba sporenia je 0 mesiacov. Skúste dlhšiu dobu sporenia.',
      },
      nelzeSpocitat: 'nedá sa spočítať',
      nicKPrevzeti: 'Modelácia zatiaľ nemá platný výsledok.',
      odchod: 'Odchod do dôchodku {rok}',
      osaRokPenze: 'Os: rok dôchodku (0 = začiatok dôchodku)',
      pokryto: 'Na požadovanú rentu stačia už zadané úspory a príspevky zamestnávateľa. Vlastný mesačný vklad nie je potrebný.',
      pozn: 'Modelový výpočet, nie garancia.',
      poznDostavatInfo: 'Renta je anuita s výplatou na začiatku mesiaca: mesačná sadzba = ročné zhodnotenie / 12, na konci doby čerpania je zostatok nulový. Pri 0 % sa suma len rozdelí na rovnaké výplaty. Inflácia a dane z výplat sa neuvažujú.',
      poznSporitInfo: 'Mesačný vklad je najmenšia celá suma v Kč, pri ktorej nasporená suma pokryje požadovanú rentu. Sporenie: mesačné úročenie (ročný výnos / 12), vklady na začiatku mesiaca, štátny príspevok podľa pravidiel od 7/2024. Renta je anuita s výplatou na začiatku mesiaca. Inflácia sa neuvažuje.',
      prevzato: 'Prevzaté z modelácie.',
      prevzit: 'Prevziať z modelácie',
      rentaMes: 'renta {renta} mesačne',
      rokRenty: '{n}. rok renty',
      rokSporeni: '{n}. rok sporenia',
      slCelkem: 'Vyplatené spolu',
      slFaze: 'Fáza',
      slRokPenze: 'Rok dôchodku',
      slVklady: 'Vklady za rok',
      slVyplaty: 'Výplaty za rok',
      slZaRok: 'Vyplatené za rok',
      slZustatek: 'Zostatok na konci roka',
      sporit: 'Koľko sporiť',
      staciUspory: 'stačia už zadané úspory a príspevky',
      stat: 'Sporiť v penzijku so štátnym príspevkom',
      statInfo: '20 % z vlastného vkladu od 500 Kč, max. 340 Kč mesačne.',
      statZamSub: 'štát {stat}, zamestnávateľ {zam}',
      uvod: 'Koľko bude klient dostávať z nasporenej sumy, alebo koľko musí sporiť na požadovanú rentu.',
      vyplatFew: '{n} mesačné výplaty',
      vyplatMany: '{n} mesačných výplat',
      vyplatOne: '{n} mesačná výplata',
      zaokrouhleno: 'vlastný vklad, zaokrúhlené nahor',
      zustatek: 'Zostatok',
    },
    sdileni: {
      doba: 'Doba sporenia',
      mesicne: '{castka} mesačne',
      uvod: 'Dobrý deň, posielam modeláciu penzijka a DIP — koľko mesačne a čo z toho môže byť na dôchodku. Pozrite sa a prípadne sa ozvite.',
      veta1: 'Dôchodok je beh na dlhú trať: čím skôr sa začne, tým viac pracuje zložené úročenie.',
      veta2: 'Ide o modelový výpočet s predpokladaným výnosom, nie o garanciu. Skutočný výsledok sa bude líšiť.',
    },
    sl: {
      celkem: 'Spolu',
      danPriVyberu: 'Daň pri výbere',
      danZVynosu: 'Daň z výnosu',
      nasporeno: 'Nasporené',
      predDani: 'Nasporené pred daňou',
      produkt: 'Produkt',
      rok: 'Rok',
      vek: 'Vek',
      vynos1: 'Výnos*',
      vynos2: 'Výnos**',
      vynosFondu: 'Výnos fondu',
    },
    slozky: {
      stat: 'Štát',
      vlastni: 'Vlastné vklady',
      zamestnavatel: 'Zamestnávateľ',
      zhodnoceni: 'Zhodnotenie',
      zhodnoceniPoDani: 'Zhodnotenie po dani',
    },
    stranka: {
      nadpis: 'Penzijko a DIP',
      paticka1: 'Modelácia, nie garancia. Minulé výnosy nezaručujú budúce. Nejde o investičné odporúčanie.',
      paticka2: 'Výnosy fondov sú po poplatkoch (APS ČR, banky.cz). Pravidlá štátnej podpory platné od 1. 7. 2024, stav k októbru 2026. Výpočet nie je návrhom na uzavretie zmluvy.',
      podnadpis: 'Modelácia do budúcnosti, história fondov, porovnanie fondov a plán renty.',
      poslat: 'Poslať klientovi',
      skVeta: 'Kalkulačka počíta české penzijko (DPS) a DIP podľa pravidiel ČR, sumy sú v Kč.',
      stitek: 'Penzijná kalkulačka',
      tisk: 'Tlač / PDF',
      zalozky: {
        fondy: 'Porovnanie fondov',
        historie: 'Historická',
        modelace: 'Modelácia DPS + DIP',
        renta: 'Plán renty',
      },
      zalozkyAria: 'Penzijné kalkulačky',
    },
    strategieNazev: {
      dynamicky: 'Dynamická',
      jina: 'Iná',
      konzervativni: 'Konzervatívna',
      transformovany: 'Transformované fondy',
      vyvazeny: 'Vyvážená',
    },
    tabulkaPoLetech: 'Tabuľka po rokoch',
    upozorneni: {
      duchodceBezStatu: 'Poberateľ starobného dôchodku štátny príspevok nedostáva (od 7/2024).',
      pravidloNesplneno: 'Pravidlo 60 rokov + {min} mesiacov nie je splnené: štátne príspevky sa vracajú, výnos a príspevky zamestnávateľa sa zdaňujú 15 %, odpočty sa dodaňujú (orientačný výpočet).',
      zamNadLimit: 'Príspevok zamestnávateľa {rocne} ročne je nad oslobodeným limitom {limit} (DPS + DIP + životné poistenie spolu).',
    },
  },
  /* BLOK:penze2 END */
  /* BLOK:vydajePravidlo START — generuje scratchpad/slovnik.py, ručně needitovat */
  vydajePravidlo: {
    tip: 'Výdavky sú vyplnené z pravidla ({pct} %) — je to odhad z príjmu, nie čísla od klienta. Pokojne ich prepíšte.',
    tipNazev: 'Výdavky z pravidla',
  },
  /* BLOK:vydajePravidlo END */
  /* BLOK:rozpisKategorii START — generuje scratchpad/slovnik.py, ručně needitovat */
  rozpisKategorii: {
    planPocita: 'plán teraz počíta s týmto číslom',
    pouzit: 'Použiť ako bežné výdavky',
    prepis: 'Rozpis po kategóriách ({castka}) sa tým prepíše súčtami z detailu — plán inak počíta s vyšším z oboch čísel.',
    radek: 'Z rozpisu po kategóriách',
    sedi: 'sedí s bežnými výdavkami',
    smazano: 'Rozpis po kategóriách zmazaný',
    smazat: 'Zmazať rozpis',
    vratit: 'Vrátiť',
  },
  /* BLOK:rozpisKategorii END */
  /* BLOK:smrtVysvetleni START — generuje scratchpad/slovnik.py, ručně needitovat */
  smrtVysvetleni: {
    aria: 'Po úmrtí rodina potrebuje {potreba}, príde {prijde}, chýba {chybi}.',
    ariaPrebyva: 'Po úmrtí rodina potrebuje {potreba}, príde {prijde}, zostane {prebyva}.',
    bezVydaju: 'Krytie smrti sa nedá vypočítať — v analýze chýbajú výdavky.',
    chybiInfo: '{castka} × 12 × {roky} = {soucet} v dnešných cenách. Počítame, že vyplatené peniaze budú uložené s modelovým výnosom 4 % nad infláciu (model, nie záruka). Preto dnes stačí {kapital}.',
    chybiVeta: 'chýba {castka} každý mesiac · {roky}',
    cilBezHorizontu: 'cieľ {nazev} bez horizontu, nezapočítaný',
    duchod: 'vdovský a sirotský dôchodok od štátu',
    duchodBezDeti: 'vdovský dôchodok od štátu',
    duchodSablona: 'pozostalostný dôchodok (šablóna krajiny)',
    jenUkazka: 'Len ukážka — do plánu sa nič nezapisuje.',
    krok1: 'Výdavky rodiny po úmrtí',
    krok1Pod: 'o {pct} % menej ako dnes ({vydaje})',
    krok2: 'Čo rodine príde',
    krok3: 'Čo chýba — na {roky}',
    krok4: 'Limit pre prípad smrti',
    krok4Metoda: 'Kapitálová metóda',
    krok4Pod: 'čo chýba + dlhy + ciele − čo už máte',
    krok5Minimum: 'Staršia metodika: najmenej dlhy + ročný príjem + deti do samostatnosti',
    krok5MinimumBezPrijmu: 'Staršia metodika: najmenej splatenie dlhov',
    mezisoucet: 'kapitálovou metódou',
    minimumDite: '{jmeno} do {vek} rokov',
    minimumDiteBezJmena: 'dieťa',
    minimumPrijem: 'Ročný príjem rodiny',
    minimumVeta: 'Vyšlo viac ako kapitálovou metódou, preto platí toto.',
    model: 'Orientačný model, nie záruka: počíta s výnosom 4 % nad infláciu, pri nižšom výnose vychádza limit vyšší. Vdovský a sirotský dôchodok je orientačná šablóna, skutočnú výšku určí štát. Renta (finančná nezávislosť) sa do smrti nezapočítava — po úmrtí ju už nikto nečerpá; spoločné ciele zostávajú. Plnenie určujú poistné podmienky.',
    nepotreba: 'Rodine by zostal dostatočný príjem — krytie smrti nie je nutné.',
    nicNechybi: 'Príjmy pokryjú výdavky rodiny presne.',
    odvozeneRoky: 'odvodené: horizont {roky} podľa šablóny',
    orezano: 'Príjmy a majetok rodine vystačia — krytie smrti nie je nutné.',
    partner: '{jmeno} ďalej zarába',
    pasivniAria: 'Pasívny príjem {castka}, limit pre prípad smrti {limit}',
    pasivniTitul: 'Keby ste dnes mali pasívny príjem',
    pasivniVeta: 'Poistenie je cena za to, že zatiaľ nemáme pasívny príjem.',
    poPrepoctu: 'Po prepočte podľa novej metodiky platí kapitálová metóda ({castka}).',
    prahMezera: 'pokryje medzeru',
    prahNula: 'poistka nie je potrebná',
    prebyvaVeta: 'Príjmy rodine vystačia a zostane {castka} — o to je limit nižší.',
    rada: {
      chybi: 'chýba',
      dnes: 'výdavky po úmrtí',
      duchod: 'dôchodok od štátu',
      partner: 'príjem partnera',
      pasivni: 'pasívny príjem',
    },
    radekChybi: 'Čo chýba na {roky}',
    radekCile: 'Zainvestovať na ciele (dnešná hodnota)',
    radekDluhy: 'Doplatiť dlhy',
    radekMajetek: 'Čo už máte na účtoch',
    radekPrebytek: 'Čo rodine z príjmov zostane navyše — za {roky}',
    rucne: 'Na karte je ručne {rucni}, vypočítané {spocitano}.',
    skryt: 'Skryť výpočet',
    staraMetodika: 'Staršia metodika — platí minimum.',
    titul: 'Ako vzniká suma pre prípad smrti',
    toggle: 'Ako sa počíta smrť',
    vysledek: 'Limit pre prípad smrti',
    zaokrouhleni: 'Riadky sú zaokrúhlené, ich súčet sa môže nepatrne líšiť.',
  },
  /* BLOK:smrtVysvetleni END */
  /* BLOK:poradiRizik START — generuje scratchpad/slovnik.py, ručně needitovat */
  poradiRizik: {
    invaliditaSmrt: 'invalidita / smrť',
  },
  /* BLOK:poradiRizik END */
  /* BLOK:splatkaUveru START — generuje scratchpad/slovnik.py, ručně needitovat */
  splatkaUveru: {
    infoNazev: 'Z čoho sa suma skladá',
    rozpad: 'Od r. {rok}: splátka úveru {uver}/mes. + ciele zadané ručne nad rozpočet {rucni}/mes.',
    rozpadOchrana: 'Od r. {rok}: splátka úveru {uver}/mes. + ochrana nad prebytok {ochrana}/mes.',
    rozpadOchranaRucni: 'Od r. {rok}: splátka úveru {uver}/mes. + ochrana nad prebytok {ochrana}/mes. + ciele zadané ručne nad rozpočet {rucni}/mes.',
    schodek: 'Od r. {rok} chýba {castka}/mes. — splátka je vyššia, ako dovoľuje rozpočet.',
    schodekNejvic: 'Najviac chýba {castka}/mes. od r. {rok}.',
  },
  /* BLOK:splatkaUveru END */
  /* BLOK:kartaCile START — generuje scratchpad/slovnik.py, ručně needitovat */
  kartaCile: {
    akontace: 'Akontácia',
    bezUveru: 'Celú sumu zaplatíte z vlastných peňazí — úver netreba.',
    cashflowBezNajmu: 'Od r. {rok} splátka {splatka} počas {roky}.',
    cashflowDvaUvery: 'Od r. {rok} splátka {splatka} — z toho stavebné sporenie {stavebko} len {rokyStavebko}, hypotéka {roky}.',
    cashflowGraf: 'cashflow v čase',
    cashflowKlesne: 'Od r. {rok} splátka {splatka}, nájom {najem} odpadne — prebytok klesne o {zmena}.',
    cashflowSNajmem: 'Od r. {rok} splátka {splatka}, nájom {najem} odpadne — prebytok {zmena}.',
    cashflowStoupne: 'Od r. {rok} splátka {splatka}, nájom {najem} odpadne — prebytok stúpne o {zmena}.',
    celkem: 'spolu',
    celkemZaplatite: 'Celkom zaplatíte',
    celyText: 'celý text',
    cerpani: 'čerpanie',
    cilCara: 'cieľ {castka}',
    cnbKratce: 'do 36 rokov stačí 10 % vlastných zdrojov, inak 20 %',
    detailInvestice: 'Detail investície',
    detailInvesticePod: 'rozloženie v čase, história',
    dofDopadProdej: 'Vlastné zdroje sa znížia o {snizeni} — na nasporenie zostáva {zbyva}.',
    dofDopadZastava: 'Banka posudzuje úver k obom nehnuteľnostiam: až {uver} ({ltv} % z {zaklad}) → vlastné zdroje {vlastni}. Súhlas záložcu, odhad aj bonitu overiť v banke.',
    dofHodnotaZastavy: 'hodnota zálohu',
    dofJiny: 'iný majetok',
    dofNe: 'nie',
    dofOdebrat: 'odobrať',
    dofPouzitZastavu: 'použiť ako záloh',
    dofPouzitoU: 'použité pri cieli {cil}',
    dofProdej: 'predaj nehnuteľnosti',
    dofStaraMetodika: 'Plán je spočítaný podľa staršej metodiky — dofinancovanie sa prejaví po prepočte podľa novej metodiky.',
    dofStitekOcekavane: 'očakávané',
    dofStitekOverteDruh: 'overte druh',
    dofStitekStehovani: 'len pri sťahovaní',
    dofStitekZatizeni: 'overte zaťaženie (hypotéka {castka})',
    dofStitekZatizeniBez: 'overte zaťaženie hypotékou',
    dofVynos: 'výnos z predaja',
    dofZAnalyzy: 'V analýze zvolené ako záloh: {nazev} · {hodnota}',
    dofZadnaZastava: 'V analýze nie je nehnuteľnosť — hodnotu zadajte ručne.',
    dofZadnyJiny: 'V analýze nie je nič na predaj — sumu zadajte ručne.',
    dofZadnyProdej: 'V analýze nie je nehnuteľnosť na predaj — sumu zadajte ručne.',
    dofZastava: 'záložné právo na nehnuteľnosť (vlastnú alebo rodičov)',
    dofZbyde: 'Z predaja zostane {castka}.',
    dofZrusenoChybi: '„{nazev}“ už v analýze nie je — uložená voľba sa nepočíta.',
    dofZrusenoJiny: '„{nazev}“ je nehnuteľnosť — patrí k predaju alebo záložnému právu. Uložená voľba sa nepočíta.',
    dofZrusenoPouzito: '„{nazev}“ je už započítané pri cieli {cil} — jedna položka len raz. Uložená voľba sa nepočíta.',
    dofZrusenoProdej: '„{nazev}“ nie je v analýze nehnuteľnosť — uložený predaj sa nepočíta.',
    dofZrusenoUver: 'Záloh pri spotrebiteľskom úvere nejde — uložená voľba sa nepočíta.',
    dofZrusenoZastava: '„{nazev}“ nemožno založiť — záloh len pri nehnuteľnosti. Uložená voľba sa nepočíta.',
    doporuceno: 'odporúčané',
    grafAriaModel: 'Vložíte {vlozeno}, o {roky} modelovo {hodnota}, výnos {vynos} — modelácia, nie záruka.',
    hotove: 'v hotovosti',
    hotovePct: 'v hotovosti {pct} %',
    hypoVychozi: 'Prázdne pole = predvolených {sazba} % na {roky} rokov, nie ponuka banky.',
    hypotekaVyse: 'Hypotéka',
    hypotekaZaRoky: 'Hypotéka za {roky}',
    jednorazoveDnes: 'Jednorazovo dnes',
    jenHypotekaAria: 'Graf ukazuje len hypotéku, bez úveru zo stavebného sporenia.',
    kolikHotove: 'Koľko zaplatíte v hotovosti',
    kombinace: 'Vaše voľné peniaze + zvyšok mesačne',
    kombinacePod: '{jedn} jednorazovo z vašich peňazí, zvyšok {mes} mesačne',
    kombinacePodNestaci: '{jedn} jednorazovo z vašich peňazí, zvyšok {mes} mesačne — viac, než prebytok na cieľ dáva',
    krok1: 'Nasporiť',
    krok1Hotove: 'Nasporiť, čo zaplatíte v hotovosti',
    krok1Rezerva: 'Naplniť rezervu',
    rezervaBezVydaju: 'Rezervu nejde vypočítať — v analýze chýbajú výdavky.',
    krok1Vlastni: 'Nasporiť vlastné zdroje',
    krok2Hypo: 'Požičať si hypotékou',
    krok2Uver: 'Požičať si úverom',
    krok3: 'Dofinancovať z majetku',
    krytoZeZdroju: 'Pokryté z vašich peňazí — nič navyše netreba.',
    mesNestaci: 'prebytok na to dáva {prideleno} — chýba {chybi}',
    mesNestaciKroky: 'v pláne odteraz {prideleno}, potom viac — pozri postupne',
    mesPakVic: 'dnes, potom viac — pozri postupne',
    modelovaHodnota: 'Modelová hodnota',
    modelove: 'modelovo',
    nadPrebytek: 'viac, ako je voľný prebytok',
    nbsKratce: '20 % vlastných zdrojov, 10 % len výnimočne',
    neboMesicne: 'alebo mesačne',
    neboMesicneRenta: 'alebo mesačne',
    nejistota: 'Modelácia ({scenar}) v dnešných cenách, nie záruka — skutočný výnos sa bude líšiť.',
    nicSporit: 'Nie je čo sporiť.',
    nicSporitUver: 'Nie je čo sporiť — celú cenu rieši úver a majetok (krok 2 a 3).',
    obaUvery: 'Oba úvery spolu',
    obojiUlozene: 'Jednorazovo aj mesačne (uložené v pláne)',
    odRoku: 'od {rok}',
    odTed: 'odteraz',
    osaJednorazove: 'jednorazovo — {zdroj}',
    osaJednorazovePoCili: 'jednorazovo — {zdroj} · až po termíne cieľa, nepočíta sa',
    osaJednorazovePoRente: 'jednorazovo — {zdroj} · až po začiatku renty, nepočíta sa',
    osaMzdaNedorazi: '{rust} — do renty sa nedostane',
    osaMzdaPoCili: '{rust} — až po termíne cieľa, nepočíta sa',
    osaMzdaPoRente: '{rust} — až po začiatku renty, nepočíta sa',
    osaMzdaSplatka: '{rust} — celý ho spotrebuje splátka úveru, do renty sa nedostane',
    osaRustMzdy: 'rast mzdy',
    osaRustMzdyPozde: '{rust} od {rok} — dovtedy ho spotrebuje splátka úveru',
    osaRustMzdyPozdeObecne: '{rust} od {rok}',
    osaRustMzdySablona: 'rast mzdy (odhad)',
    osaUverSplacen: 'splatí sa úver na {cil}',
    osaUvolneno: 'uvoľnené peniaze z prebytku',
    osaZCile: 'uvoľní sa z cieľa {cil} (nasporené)',
    osaZaklad: 'pravidelná investícia',
    osaZakladMzda: 'z toho +{castka} vďaka rastu mzdy od {rok}',
    pasmo: 'horší až lepší scenár',
    pasmoBublina: 'Horší – lepší scenár',
    pasmoSouhrn: 'horší až lepší scenár {od} – {do}',
    pctZ: '{pct} % z {cena}',
    plneniZa: 'Plnenie cieľa {kdy} ({scenar})',
    plusStavebko: '+ úver zo stavebného sporenia {castka} na {roky} rokov = {splatka}{mes} (vlastná sadzba)',
    poporade: 'Postupne',
    proVsechnyCile: 'Pre všetky ciele:',
    pujcite: 'Požičiate si',
    puvodniNavrh: 'späť na pôvodný návrh',
    realne: 'reálne',
    resiSeUveremHotove: 'Sporí sa len to, čo zaplatíte v hotovosti, zvyšok rieši úver — splátka nastupuje od čerpania.',
    rezimBezSchodu: 'Zvolená cesta počíta rovnú platbu — navýšenie z pôvodného návrhu',
    rokSplaceni: '{n}. rok splácania',
    rustBez: 'bez rastu',
    rustBezRustu: 'Plán s rastom vkladu nepočíta — a nastavenie žiadny nepredpisuje.',
    rustChybi: 'Rast mzdy sa zatiaľ NEPOČÍTA — v pláne nie sú žiadne kroky. Kliknite na Započítať rast mzdy.',
    rustLisi: 'Kroky rastu mzdy v pláne sa od nastavenia LÍŠIA — plán počíta z nich. Zosúlaďte ich tlačidlom Započítať rast mzdy.',
    rustLisiKratce: 'v pláne sú iné kroky',
    rustLisiZahod: 'Plán počíta z krokov rastu mzdy, ale z nastavenia žiadny rast nevyjde — zahoďte ich, nech plán zodpovedá nastaveniu.',
    rustMzdy: 'Rast mzdy',
    rustNepocita: 'zatiaľ sa nepočíta',
    rustPopis: '{pct} {baze} každých {krok} rokov',
    rustRealne: 'reálne, nad infláciou — plán počíta v dnešných cenách a infláciu nepripočítava.',
    rustRucniPolozka: '+{castka} od {rok}',
    rustSablonaNeRucniAno: 'šablóna zatiaľ nie · v pláne je ručný {rucni}',
    rustSedi: 'S týmto tempom plán počíta — kroky rastu mzdy v pláne zodpovedajú nastaveniu.',
    rustVPlanu: 'v pláne ({n} krokov)',
    rustVPlanuPo: 'v pláne: {n} do renty, {po} až po jej začiatku',
    schodyAria: 'Mesačný vklad rastie z {od} na {do}.',
    seZastavou: 'so záložným právom',
    sjednotit: 'zjednotiť s plánom',
    skrytGraf: 'skryť graf',
    splatkaMesicne: 'Splátka mesačne',
    splatkaRozpis: 'hypotéka {hypo} + stavebné sporenie {stavebko} ({roky})',
    spotrVychozi: 'Prázdne pole = orientačných {sazba} % na {roky} rokov (najviac {max} rokov) — overiť v banke.',
    srovnatRust: 'Zosúladiť s nastavením',
    stavebkoZaRoky: 'Úver zo stavebného sporenia {castka} za {roky}',
    upravit: 'upraviť',
    upravitRucne: 'upraviť sumy ručne',
    uverSpotrebitelsky: 'spotrebiteľský úver',
    uverStavebko: 'úver zo stavebného sporenia',
    uzMate: 'Už máte',
    vPlanuNestaci: 'v pláne — nestačí',
    vRoce: 'v r. {rok}',
    vetaRoku: 'vložené {vlozeno} · hodnota {hodnota} · výnos {vynos}',
    vlastniProfil: 'vlastný profil: {profil}',
    vlastniZdroje: 'vlastné zdroje',
    vlozeno: 'Vložené',
    vlozite: 'Vložíte',
    volitelne: 'voliteľné',
    volnychJen: 'voľných máte {volne}',
    vybrano: 'vybrané',
    vynos: 'výnos',
    zPrebytku: 'z mesačného prebytku',
    zTohoHotove: 'z toho v hotovosti',
    zVolnych: 'z voľných peňazí (máte {volne})',
    zahoditKrokyTitul: 'Zmaže z plánu kroky rastu mzdy zo šablóny — plán potom počíta bez nich, presne ako je nastavené.',
    zapocitatRust: 'Započítať rast mzdy',
  },
  /* BLOK:kartaCile END */
  /* BLOK:klientEmail START — generuje scratchpad/slovnik.py, ručně needitovat */
  klientEmail: {
    chybaAdresa: 'Skontroluj e-mailovú adresu klienta.',
    chybaPredmet: 'Doplň predmet.',
    chybaTelo: 'Doplň text správy.',
    crmBezEmailu: 'U klienta v CRM nie je e-mail — doplň ho ručne.',
    dalsiOdkaz: 'Vytvoriť ďalší odkaz',
    introFixace: 'Dobrý deň, posielam modeláciu fixácie hypotéky. Kľúčové je to druhé číslo — splátka po skončení fixácie. Keby niečo, ozvite sa.',
    introHistoricka: 'Dobrý deň, posielam sľúbenú modeláciu historického vývoja investície. Pozrite sa na čísla — a keby niečo, ozvite sa.',
    introModelace: 'Dobrý deň, posielam sľúbenú modeláciu. Pozrite sa a prípadne sa ozvite.',
    klientNepovinne: 'Klient (nepovinné)',
    komu: 'Komu',
    kopirovaniChyba: 'Kopírovanie sa nepodarilo.',
    kopirovat: 'Kopírovať',
    modelaceVPdf: 'Modelácia v PDF',
    nadpis: 'Poslať klientovi',
    najdiKlienta: 'Nájdi klienta podľa mena…',
    neniEmail: 'Toto nevyzerá ako e-mailová adresa.',
    nepropojeny: 'E-mail v aplikácii zatiaľ nie je pripojený. Otvorím tvoj poštový program s predvyplnenou správou — odoslanie potvrdíš tam. (Pripojiť sa dá v Nastaveniach.)',
    neznamyTransport: 'Nepodarilo sa zistiť, či je e-mail v aplikácii pripojený. Otvorím tvoj poštový program s predvyplnenou správou — odoslanie potvrdíš tam.',
    odejdeGmail: 'Odíde z tvojho Gmailu.',
    odejdeGmailAdresa: 'Odíde z tvojho Gmailu {email}.',
    odejdeSmtp: 'Odíde z tvojho firemného e-mailu.',
    odejdeSmtpAdresa: 'Odíde z tvojho firemného e-mailu {email}.',
    odesilam: 'Odosielam…',
    odeslanToast: 'E-mail odoslaný klientovi.',
    odeslanoKlientovi: 'Odoslané klientovi.',
    odeslatChyba: 'E-mail sa nepodarilo odoslať.',
    odeslatNa: 'Odoslať na {adresa}',
    odkazChyba: 'Odkaz sa teraz nepodarilo vytvoriť. Skúste to prosím znova.',
    otevrete: 'Otvorte si ju tu:',
    otevrit: 'Otvoriť',
    otevritPostu: 'Otvoriť poštový program',
    ozveteSe: 'Keby čokoľvek nesedelo alebo vás niečo napadlo, ozvite sa — v pokoji to spolu prejdeme.',
    pdfChyba: 'PDF sa nepodarilo vytvoriť.',
    pdfStazenoToast: 'PDF stiahnuté — prilož ho k e-mailu.',
    pdfVeStazenych: 'PDF je stiahnuté v tvojich Súboroch na stiahnutie.',
    popis: 'Vyber klienta, pridaj úvodnú správu a vytvor odkaz na túto modeláciu.',
    popisHotovo: 'Odkaz je pripravený — pošli ho klientovi.',
    poslatEmailem: 'Poslať e-mailom',
    postaOtevrena: 'Správa sa otvorila v tvojom poštovom programe. Aplikácia ju NEODOSLALA — odošli ju tam.',
    pozdrav: 'Dobrý deň,',
    pozdravJmeno: 'Dobrý deň, {osloveni},',
    predmet: 'Predmet',
    predmetVychozi: 'Modelácia pre vás',
    priloha: 'V prílohe posielam to isté v PDF.',
    prilohyNeumi: 'E-mail z aplikácie zatiaľ nevie prílohy. PDF sa stiahne k tebe — prilož ho ručne, alebo klientovi stačí odkaz na modeláciu, ktorý je v texte vyššie.',
    sPozdravem: 'S pozdravom',
    schuzka: 'Dohodnúť stretnutie',
    spojitSe: 'Spojiť sa',
    stahnoutPdf: 'Stiahnuť PDF',
    textPrecti: 'Text — prečítaj si ho, než odošleš',
    titulFixace: 'Fixácia hypotéky — čo sa stane po nej',
    titulHistoricka: 'Historický vývoj investície',
    titulHypoteka: 'Hypotekárna modelácia',
    titulInvestice: 'Investičná modelácia',
    uvodVychozi: 'posielam modeláciu, ktorú sme si prechádzali.',
    uvodniPh: 'Dobrý deň, posielam sľúbenú modeláciu…',
    uvodniZprava: 'Úvodná správa',
    vytvarim: 'Vytváram…',
    vytvarimOdkaz: 'Vytváram odkaz…',
    vytvoritOdkaz: 'Vytvoriť odkaz',
    whatsapp: 'Napísať na WhatsApp',
    zavolejte: 'Alebo mi rovno zavolajte: {tel}',
    zjistuji: 'Zisťujem, kadiaľ e-mail odíde…',
    zkopirovano: 'Skopírované',
  },
  /* BLOK:klientEmail END */
  /* BLOK:pdfVystup START — generuje scratchpad/slovnik.py, ručně needitovat */
  pdfVystup: {
    ctaVychozi: 'Dohodnite si stretnutie',
    dalsiKrok: 'Ďalší krok',
    disclaimer: 'Modelácia je orientačná a vychádza z historických dát. Minulé výnosy nie sú zárukou budúcich. Investície na kapitálových trhoch nesú riziko straty časti alebo celej investovanej sumy.',
    financniPoradenstvi: 'Finančné poradenstvo',
    inv: {
      hero: 'Očakávaná hodnota',
      projekce: 'Projekcia po rokoch',
      scenare: 'Scenáre na konci obdobia',
      thOcekavany: 'Očakávaný',
      thOptimisticky: 'Optimistický',
      thPesimisticky: 'Pesimistický',
      thRok: 'Rok',
      thVklady: 'Vklady',
      titul: 'Investičná modelácia',
    },
    jakTomuRozumet: 'Ako tomu rozumieť',
    modelace: 'Modelácia',
    modelaceDisclaimer: 'Nezáväzná orientačná modelácia. Konkrétne podmienky a ceny upresníme spoločne.',
    platnaDo: 'Platná do',
    pripravenoPro: 'Pripravené pre',
    qrAlt: 'QR kód',
    qrNavod: 'Naskenujte QR kód fotoaparátom mobilu — otvorí sa odkaz na spojenie s poradcom.',
    rozpis: 'Detailný rozpis',
    souhrn: 'Súhrn',
    vstupy: 'Vstupné parametre',
    vypracoval: 'Vypracoval',
  },
  /* BLOK:pdfVystup END */
  /* BLOK:zivotkoPdf START — generuje scratchpad/slovnik.py, ručně needitovat */
  zivotkoPdf: {
    cenaChybi: 'Konkrétnu cenu doplní poradca podľa vybranej poisťovne — v tomto dokumente preto žiadna nie je.',
    cenaDen: 'Rozpočítané na deň to robí {den}.',
    cenaHlava: 'Na jedného člena rodiny {hlava} denne.',
    cenaPct: 'To je {pct} % príjmu rodiny.',
    cenaStoji: 'Celá táto ochrana stojí {cena} mesačne.',
    cilMesicne: '{nazev} {castka}/mes',
    cilVychozi: 'cieľ',
    disclaimer: 'Orientačné odporúčané krytie podľa metodiky beplan. Konkrétne poistné a podmienky podľa vybranej poisťovne. Poradca má posledné slovo.',
    heroLabel: 'Koľko rodina potrebuje, keby živiteľ zomrel',
    heroLabelInvalidita: 'Koľko rodina potrebuje, keby živiteľ nemohol pracovať',
    inCena: 'Cena krytia / mes',
    inNezbytne: 'Nevyhnutné výdavky / mes',
    inOsob: 'Osôb v rodine',
    inPrijem: 'Príjem rodiny / mes',
    inVarianta: 'Variant krytia',
    inZajistitNa: 'Zabezpečiť na',
    metodika: 'Metodika {verze}.',
    naDen: '{castka}/deň',
    nar1: 'Dnes má rodina {prijem} mesačne. Predstavte si, že o časť z toho príde.',
    nar2: 'Keď príjem klesne o 5 % ({p5} mesačne), nahnevá to — ale ustojíte to. Pri poklese o 25 % ({p25}) sa to dá zvládnuť, len sa uťahujú opasky. Pokles o 50 % ({p50}) už rozpočet nedopne. A pokles o 100 % ({p100}) je koniec plánov, nie iba utiahnutý opasok.',
    nar3: 'Práve tieto dva ťažké konce rebríka návrh rieši: {inval} pre prípad invalidity, {smrt} pre prípad smrti a {pn} za každý deň choroby alebo úrazu. Spočítané na {roky} dopredu, z vašich vlastných čísel — nie z tabuľky priemerného Slováka.',
    nar4: 'K tomu {tnu} na trvalé následky úrazu (čím vážnejší, tým vyššia výplata) a {zav} pri vážnej chorobe — rakovina, infarkt, mŕtvica. To sú peniaze na liečbu a na čas, nie na účty.',
    nar5: 'Ochrana rieši, čo sa stane, keď sa niečo pokazí. Ciele rodiny riešia, čo sa stane, keď všetko vyjde: {cile}. Dokopy {suma} mesačne.',
    narrativeTitle: 'Prečo práve toľko',
    rokyFew: '{n} roky',
    rokyMany: '{n} rokov',
    rokyOne: '{n} rok',
    sumInval: 'Keby nemohol pracovať (invalidita)',
    sumPn: 'Krátka choroba / úraz (PN)',
    sumSmrt: 'Keby sa nevrátil (smrť)',
    summaryTitle: 'Čo sa stane, keď…',
    tableTitle: 'Krytie po osobách',
    thInvalidita: 'Invalidita',
    thOsoba: 'Osoba',
    thPn: 'PN/deň',
    thSmrt: 'Smrť',
    thTrvale: 'Trvalé následky',
    thVazna: 'Vážna choroba',
    titul: 'Návrh ochrany rodiny',
    vic10: 'V tabuľke je prvých 5 a posledných 5 osôb z celkovo {n} — súhrnné čísla hore sú za celú rodinu.',
  },
  /* BLOK:zivotkoPdf END */
  /* BLOK:vzhledKontrola START — generuje scratchpad/slovnik.py, ručně needitovat */
  vzhledKontrola: {
    ariaHistVyvoj: 'Vývoj hodnoty investície {od}–{do}: vložené {vlozeno}, hodnota {hodnota}, sporiaci účet {sporeni}',
    ariaRozlozeni: 'Rozloženie portfólia',
    smazatCil: 'Odobrať cieľ',
    smazatOsobu: 'Odobrať osobu',
    snizit: 'Znížiť',
    zrusitVyber: 'Zrušiť výber obdobia',
    zvysit: 'Zvýšiť',
  },
  /* BLOK:vzhledKontrola END */
  /* BLOK:odkladaniZam START — generuje scratchpad/slovnik.py, ručně needitovat */
  odkladaniZam: {
    kino: {
      a5Zam: '+ {castka} pošle zamestnávateľ rovno na doplnkové dôchodkové sporenie',
      prijem503020: 'Čistý mesačný príjem vrátane príspevku zamestnávateľa',
      tokAria: 'Z výplaty {prijem} a príspevku zamestnávateľa {zam} ide {stranou} bokom, {zivot} zostáva na život.',
      vyplataPlus: '+ príspevok zamestnávateľa {castka}',
    },
    novyCrmOdklada: 'Odkladá {pct} % príjmov vrátane príspevku zamestnávateľa · ideál 20 % = {castka}',
    pochvala: 'Odkladáte {pct} % príjmov vrátane príspevku zamestnávateľa ({castka})',
    vc: 'vrátane príspevku zamestnávateľa',
    vodopad: {
      nejvys: 'Najviac ide bokom {castka} = {pct} % príjmu vrátane príspevku zamestnávateľa',
      odkladDnes: 'Bokom dnes ide {castka} = {pct} % príjmu vrátane príspevku zamestnávateľa (vlastné vklady {vklady} + príspevok zamestnávateľa {zam} + voľné peniaze {volne}).',
      odkladDohoda: 'Bokom ide {castka} = {pct} % príjmu vrátane príspevku zamestnávateľa (vlastné vklady {vklady} + príspevok zamestnávateľa {zam} + odsúhlasená suma {dohoda}).',
      posuvnikPct: '{pct} % príjmu vrátane príspevku zamestnávateľa =',
      posuvnikPrazdny: '{pct} % príjmu vrátane príspevku zamestnávateľa = —',
      stranouDnes: 'bokom dnes ide {pct} % príjmu vrátane príspevku zamestnávateľa',
      stranouDohoda: 's odsúhlasenou sumou ide bokom {pct} % príjmu vrátane príspevku zamestnávateľa',
      uzBezi: 'Už beží {castka} (vklady na sporenie {vklady} + príspevok zamestnávateľa {zam})',
    },
    zaklad: 'z {zaklad} vrátane príspevku zamestnávateľa {zam}',
  },
  /* BLOK:odkladaniZam END */
  /* BLOK:fixaceVystup START — generuje scratchpad/slovnik.py, ručně needitovat */
  fixaceVystup: {
    disclaimer: 'História sadzieb vychádza z mesačnej štatistiky ČNB (nové úvery na bývanie podľa dĺžky fixácie, 2006–2026). Sadzba po skončení fixácie je MODELOVANÁ hodnota, nie predpoveď — skutočnú sadzbu určí trh a banka v čase refixácie.',
    dlouha: 'Dlouhá fixácia',
    fixaceZa: '{roky} za {sazba}',
    hero: 'Splátka po {po} pri sadzbe {sazba}',
    kratka: 'Krátka fixácia',
    nar1: 'Graf ukazuje, ako sa bude vaša splátka vyvíjať počas celej doby splatnosti — nielen v prvých rokoch fixácie. Krátka fixácia má dnes nižšiu splátku, ale po skončení fixácie sa splátka prepočíta podľa sadzby, ktorá bude platiť vtedy. Tú dnes nikto nepozná.',
    nar2: 'Červená čiara v grafe je váš rozpočet. Ak ju splátka po refixácii prekročí, znamená to problém — a to je presne to riziko, ktoré nižšia dnešná splátka skrýva.',
    nar3: 'História sadzieb v nástroji je reálna mesačná štatistika Českej národnej banky. Nie je to predpoveď: je to doklad o tom, ako často a ako silno sa sadzby v Česku pohybovali.',
    pdfChyba: 'PDF sa nepodarilo vygenerovať',
    poLetechFew: '{n} rokoch',
    poLetechMany: '{n} rokoch',
    poLetechOne: '{n} roku',
    rokyFew: '{n} roky',
    rokyMany: '{n} rokov',
    rokyOne: '{n} rok',
    sazbaPo: 'Sadzba po refixácii (modelovaná)',
    sazbaUnese: 'Sadzba, ktorú rozpočet ešte unesie',
    splatkaDlouha: 'Splátka pri fixácii na {roky}',
    splatkaPo: 'Splátka po {po} pri {sazba}',
    splatkaTed: 'Splátka teraz (krátka fixácia)',
    splatnost: 'Splatnosť',
    unese: 'Na splátku unesie',
    unesePct: '{castka} ({pct} % príjmu)',
    vyse: 'Výška hypotéky',
  },
  /* BLOK:fixaceVystup END */
  /* BLOK:kinoPrijmy START — generuje scratchpad/slovnik.py, ručně needitovat */
  kinoPrijmy: {
    a1BigDoplnte: 'Doplňte príjmy a rozdelíme ich',
    a1BigPrijem: 'Váš čistý mesačný príjem',
    a1Kicker: 'Kde miznú peniaze',
    a1L1: 'Väčšina ľudí netuší, koľko a kam minie.',
    a1L2: 'Bez systému zostane na konci mesiaca nula.',
    a1Nar: '„Poďme sa pozrieť, ako vaše peniaze rozdeliť, aby z nich niečo zostalo aj na sny.“',
    a1Title: 'Kam každý mesiac utečú peniaze?',
    a2Big: 'Jednoduchý systém, ktorý funguje',
    a2Kicker: 'Pravidlo',
    a2L1: '50 % nevyhnutné výdavky — bývanie, jedlo, energie, splátky.',
    a2L2: '30 % životný štýl — radosti, koníčky, reštaurácie.',
    a2L3: '20 % bokom na ciele — rezerva, investície, renta.',
    a2Title: 'Pravidlo 50 / 30 / 20',
    a3Kicker: 'Koľko u VÁS',
    a3L2: '20 % = {castka} na dlhodobé ciele.',
    a3Title: '20 % je váš motor nezávislosti',
    a6Big: 'Vaša cesta k slobode',
    a6Kicker: 'Začnite dnes',
    a6L1: 'Z tých 20 % sa časom stane vaša renta.',
    a6L2: 'Pravidelnosť + čas = peniaze začnú pracovať za vás.',
    a6Nar: '„Tých 20 % dnes je vaša finančná nezávislosť zajtra. Poďme to rozbehnúť.“',
    a6Title: '20 % pravidelne = finančná nezávislosť',
    dejstviAria: 'Dejstvo {n}',
    nazev: 'Príjmy a výdavky',
  },
  /* BLOK:kinoPrijmy END */
  /* BLOK:kinoRizika START — generuje scratchpad/slovnik.py, ručně needitovat */
  kinoRizika: {
    a1: {
      aria: 'Cesta k vašim cieľom: {cile}.',
      ariaBezCilu: 'Cesta k cieľom, ktoré si ešte doplníme.',
      ariaDalsi: 'Cesta k vašim cieľom: {cile} a {n} ďalších.',
      cile: '{cile}.',
      cileADalsi: '{cile} a ďalšie.',
      dalsiCilFew: 'a {n} ďalšie ciele',
      dalsiCilMany: 'a {n} ďalších cieľov',
      dalsiCilOne: 'a {n} ďalší cieľ',
      kicker: 'Váš plán',
      radekBezCilu: 'Ciele si spolu doplníme.',
      radekKrok: 'Krok za krokom, ako sme si povedali.',
      rezie: 'Nechajte klienta chvíľu pozerať.',
      tahak: '„Toto je váš plán: {cile}. Krok za krokom.“',
      tahakBezCilu: '„Než začneme plánovať, povedzte mi, čo chcete dosiahnuť.“',
      tahakDalsi: '„Toto je váš plán: {cile} a ďalšie. Krok za krokom.“',
      tahakHned: '{cil} hneď',
      tahakVRoce: '{cil} v roku {rok}',
      titulek: 'Toto je váš plán',
      titulekBezCilu: 'Plán staviame na vašich cieľoch',
    },
    a1Big: 'Čo môže plán ohroziť?',
    a1Kicker: 'Najprv zaistiť',
    a1L1: 'Plán musí stáť na pevných základoch — na ochrane.',
    a1L2: 'Jeden výpadok vie zboriť všetky ciele naraz.',
    a1Nar: '„Než začneme stavať sny, musíme zaistiť základ. Inak jedna nehoda zmetie celý plán.“',
    a1Title: 'Najprv zaistíme, potom budujeme',
    a2: {
      aria: 'Nad cestou k cieľom sú tri mraky: výpadok príjmu (choroba, úraz, invalidita, úmrtie) — najväčší, strata majetku (požiar, voda, krádež) a zodpovednosť za škodu inému.',
      invalidita: 'Invalidita',
      kicker: 'Riziká',
      kradez: 'Krádež',
      majetek: 'Strata majetku',
      nejvetsi: 'Najväčšie',
      nemoc: 'Choroba',
      pozar: 'Požiar',
      radek1: 'Rizík je veľa.',
      radek2: 'Hlavné sú tri: príjem, majetok a zodpovednosť.',
      rezie: 'Nehodnoťte a nestrašte.',
      skodaJinemu: 'Škoda inému',
      tahak: '„Plán počíta s tým, že všetko pôjde podľa predstáv. Život však občas prinesie mrak. Rizík je veľa — hlavné sú tri: príjem, majetok a zodpovednosť.“',
      titulek: 'Čo môže plán ohroziť?',
      umrti: 'Úmrtie',
      uraz: 'Úraz',
      voda: 'Voda',
    },
    a2BezDeti: 'Váš príjem živí celú domácnosť.',
    a2BezHypo: 'Bez príjmu sa zastaví všetko ostatné.',
    a2Big: 'Príjem = motor celého plánu',
    a2DetiFew: 'Máte {n} deti — rodina stojí na vašom príjme.',
    a2DetiMany: 'Máte {n} detí — rodina stojí na vašom príjme.',
    a2DetiOne: 'Máte {n} dieťa — rodina stojí na vašom príjme.',
    a2Hypo: 'Hypotéku je nutné ufinancovať aj pri výpadku.',
    a2Kicker: 'Riziko č. 1',
    a2L2: 'Invalidita, dlhodobá choroba, úmrtie — poistenie príjmu.',
    a2Nar: '„Najväčšie riziko nie je trh — je to strata schopnosti zarábať. To riešime ako prvé.“',
    a3: {
      ariaBezPrijmu: 'Plán stojí na príjme, ktorý zatiaľ nepoznáme.',
      ariaDopad: 'Keď {jmeno} dlho nemôže pracovať: {dopad} ({pozn}).',
      ariaMensiDil: '{jmeno} nesie menší diel.',
      ariaNese: 'Nesie ho {jmeno}.',
      ariaNevime: 'Keď {jmeno} dlho nemôže pracovať, koľko zostane na ciele, spočítame nabudúce aj s dávkami od štátu.',
      ariaVetsiDil: '{jmeno} nesie väčší diel.',
      ariaZaklad: 'Plán stojí na príjme {castka} mesačne.',
      bezDavek: 'bez dávok od štátu',
      jede: 'Plán pôjde ďalej',
      kicker: 'Najväčšie riziko',
      klient1: 'Klient 1',
      klient2: 'Klient 2',
      mene: 'Na ciele zostane menej',
      nemuze: '{jmeno} dlho nemôže pracovať',
      nevime: 'Čo zostane, spočítame nabudúce',
      nevimePozn: 'aj s dávkami od štátu',
      nezbyde: 'Na ciele nezostane',
      obaPracuji: 'Obaja pracujú',
      pasivni: 'Pasívny príjem',
      pracuje: '{jmeno} pracuje',
      prijemDoplnime: 'Príjem doplníme',
      radek: 'Celý plán stojí na vašom príjme.',
      radekBezPrijmu1: 'Celý plán stojí na príjme.',
      radekBezPrijmu2: 'Príjmy zatiaľ chýbajú — doplníme ich.',
      rezie: 'Ťuknite na tlačidlá pod obrázkom. Krytie dnes nepočítajte.',
      skupinaAria: 'Čo keby',
      tahakBezPrijmu: '„Celý plán stojí na príjme. Doplníme ho a nabudúce si ukážeme, čo ho drží.“',
      tahakJede: '„Celý plán stojí na vašom príjme. Keď {jmeno} dlho nemôže pracovať, plán pôjde ďalej. Časť by nahradil štát — koľko, si spočítame nabudúce.“',
      tahakMene: '„Celý plán stojí na vašom príjme. Keď {jmeno} dlho nemôže pracovať, na ciele zostane menej. Časť by nahradil štát — koľko, si spočítame nabudúce.“',
      tahakNevime: '„Celý plán stojí na vašom príjme. Keď {jmeno} dlho nemôže pracovať, príjem klesne. Koľko zostane na ciele a koľko nahradí štát, si spočítame nabudúce.“',
      tahakNezbyde: '„Celý plán stojí na vašom príjme. Keď {jmeno} dlho nemôže pracovať, na ciele nezostane. Časť by nahradil štát — koľko, si spočítame nabudúce.“',
      vasPlan: 'VÁŠ PLÁN',
      velkePopis: 'mesačne nesie celý plán',
      vychoziBezPrijmu: 'Bez príjmov nevieme, čo plán nesie',
      vychoziJede: 'Príjem beží, plán ide',
      vychoziMene: 'Na ciele teraz zostáva menej, preberieme v pláne',
      vychoziNezbyva: 'Na ciele teraz nezostáva, preberieme v pláne',
    },
    a3Auto: 'Auto → PZP + havarijné.',
    a3Big: 'Kompletný štít rodiny',
    a3Domacnost: 'Domácnosť a vybavenie — poistenie majetku.',
    a3Firma: 'Firma → firemné poistenie a prerušenie prevádzky.',
    a3Kicker: 'Majetok & zodpovednosť',
    a3L2: 'Zodpovednosť (aj voči zamestnávateľovi), právna ochrana.',
    a3Nar: '„Okrem príjmu strážime majetok, zodpovednosť, auto, právnu ochranu a u podnikateľov aj firmu.“',
    a3Nemovitost: 'Nehnuteľnosť + domácnosť — poistenie majetku.',
    a3Title: 'Čo všetko chránime',
    a4: {
      aria: 'Vaše ciele pod čiarkovaným štítom: zaistenie doplníme na ďalšom stretnutí.',
      coKryje: 'Čo to kryje a čo nie',
      coMate: 'Čo máte',
      domluveno: '(dohodnuté)',
      jakZapadne: 'Ako to zapadne do plánu',
      kicker: 'Nabudúce',
      naDalsiSchuzce: 'Na ďalšom stretnutí',
      pojistneSmlouvy: 'poistné zmluvy',
      radek: 'Dnes nič neriešime.',
      rezie: 'Potom v Závere zaškrtnite podklad Poistné zmluvy.',
      rezieHotovo: 'Podklad Poistné zmluvy je už v Závere zaškrtnutý.',
      sSebou: 'So sebou:',
      tahak: '„V rámci finančného plánu sa pozrieme aj na vaše zaistenie — čo máte dnes, čo kryje a čo nie. Overíme, či sa dá ušetriť alebo poistiť múdrejšie, a ukážeme, ako to zapadne do celého plánu.“',
      titulek: 'Na ďalšom stretnutí si ich prejdeme',
    },
    a4Big: 'Zaistenie = pokoj pre celý plán',
    a4Kicker: 'Záver',
    a4L1: 'Prejdeme každé krytie — nech rodina nikdy nestojí na vode.',
    a4L2: 'Až dobre zaistený plán má zmysel stavať.',
    a4L3: 'Je to nudné, ale je to úplný základ.',
    a4Nar: '„Toto je možno najdôležitejšia časť. Poďme spoločne prejsť, čo máte pokryté a kde sú diery.“',
    a4Title: 'Na toto sa spoločne pozrieme',
    cil: {
      auto: 'Auto',
      bydleni: 'Bývanie',
      cil: 'Cieľ',
      deti: 'Deti',
      dnes: 'dnes',
      investice: 'Investície',
      podnikani: 'Podnikanie',
      rekonstrukce: 'Rekonštrukcia',
      renta: 'Renta',
      rezerva: 'Rezerva',
    },
    iAuto: 'Auto (PZP + hav.)',
    iDomacnost: 'Domácnosť',
    iFirma: 'Firma / prevádzka',
    iInvalidita: 'Invalidita / choroba',
    iNemovitost: 'Nehnuteľnosť',
    iOdpovednost: 'Zodpovednosť',
    iPravni: 'Právna ochrana',
    iUmrti: 'Úmrtie (rodina)',
    iVypadek: 'Výpadok príjmu',
    iZamestnani: 'Zamestnanie',
    nazev: 'Zaistenie rizík',
  },
  /* BLOK:kinoRizika END */
  /* BLOK:histKalk START — generuje scratchpad/slovnik.py, ručně needitovat */
  histKalk: {
    alokacePomery: 'Alokácia · pomery',
    bezPoplatku: 'Bez poplatkov. Zadaj ich, nech klient vidí, koľko z jeho peňazí odíde na náklady.',
    bezpecnaRenta: 'Bezpečná mesačná renta',
    brzdaBez: 'Bez brzdy',
    brzdaCil: 'Na cieľ',
    brzdaNadpis: 'Brzda (postupné znižovanie rizika)',
    brzdaPopisBez: 'Alokácia konštantná celý čas.',
    brzdaPopisCil: 'Posledných ~10 rokov presun do hotovosti (jednorazový cieľ).',
    brzdaPopisRenta: 'Mierne znižovanie rizika, drží viac akcií (renta).',
    brzdaRenta: 'Na rentu',
    cilovaCastka: 'Cieľová suma za daný horizont',
    disclaimer: 'Modelácia vychádza z reálnych historických dát 1926–2026. Minulé výnosy nie sú zárukou budúcich. Investícia nesie riziko straty.',
    doba: 'Doba',
    dobaInvestice: 'Doba investície',
    dobaVyplaty: 'Doba výplaty (rokov)',
    hodnotaDnes: 'Hodnota dnes',
    hodnotaRealne: 'Hodnota reálne',
    jednorazove: 'Jednorazovo',
    jednorazovyVklad: 'Jednorazový vklad',
    koncova: 'Konečná hodnota portfólia',
    krize: {
      k1929: 'Krach 1929',
      k1973: 'Ropná kríza',
      k1987: 'Čierny pondelok',
      k2000: 'Dot-com',
      k2008: 'Finančná kríza',
      k2011: 'Dlhová kríza',
      k2020: 'Covid',
      k2022: 'Ukrajina',
    },
    krizeKonec: 'V týchto dátach sa trh zakaždým vrátil.',
    krizeVetaFew: 'Investícia za ten čas prešla {n} krízami — a napriek tomu skončila na {castka}.',
    krizeVetaMany: 'Investícia za ten čas prešla {n} krízami — a napriek tomu skončila na {castka}.',
    krizeVetaOne: 'Investícia za ten čas prešla {n} krízou — a napriek tomu skončila na {castka}.',
    legInvestice: 'Investícia',
    legSporici: 'Sporiaci účet',
    legVlozeno: 'Vložené',
    letZkratka: 'rokov',
    mesicne: 'Mesačne',
    mesicneHodnota: '{castka}/mes',
    modCil: 'Cieľ',
    modRenta: 'Renta',
    nar1: 'Graf ukazuje, ako by sa vaše peniaze vyvíjali na reálnych historických dátach trhov, nie na sľuboch. V priebehu rokov prišli krízy aj prepady — a hodnota napriek tomu v dlhom období rástla. Najdôležitejšie je začať a vydržať.',
    nar2: 'Minulé výnosy nie sú zárukou tých budúcich. Trhy krátkodobo kolíšu a hodnota investície môže aj klesnúť. Modelácia slúži na pochopenie princípu, nie ako prísľub konkrétneho výnosu.',
    nar3: 'Najväčším spojencom je čas — vďaka zloženému úročeniu pracuje každý ďalší rok vo váš prospech. Preto sa oplatí začať čo najskôr, pokojne aj s menšou sumou.',
    nastroje: 'Nástroje',
    navicVeta: 'Oproti sporiacemu účtu (peňažný trh) {castka} navyše — toľko stála „istota“ hotovosti.',
    nejhorsim: 'najhoršom',
    nom: 'nom.',
    nominalne: 'nominálne',
    obdobi: 'Obdobie',
    obdobiDvojtecka: 'Obdobie:',
    pdfChyba: 'PDF sa nepodarilo vygenerovať',
    poplatky: 'Poplatky',
    poplatkyCelkem: 'Poplatky spolu vás pripravia o {castka} — vrátane výnosu, ktorý tie peniaze už nezarobili.',
    portfolio: 'Portfólio',
    portfolioMix: 'Portfóliový mix',
    potrebujeteMesicne: 'Potrebujete mesačne',
    pouzit: 'Použiť do výpočtu',
    pravidelneMesicne: 'Pravidelne mesačne',
    preset: {
      dynamicky: 'Dynamický',
      konzervativni: 'Konzervatívny',
      moderni: 'Moderný',
      vyvazeny: 'Vyvážený',
      zlaty: 'So zlatom',
    },
    priJednorazovem: 'Pri jednorazovom vklade {castka} a alokácii {alokace}.',
    prubeznyPct: 'Priebežný % (ročne)',
    real: 'reál.',
    realne: 'reálne',
    realneOd: 'reálne až od 8/1946 (skoršia inflácia v dátach chýba)',
    rentaMaloHistorie: 'Pre túto alokáciu nie je dosť histórie na otestovanie celej doby výplaty ({roky}) — skráť dobu alebo uber mladé triedy (BTC, REIT, MSCI).',
    rentaVydrzi: 'Z nasporených {castka} by vám to vydržalo {roky} aj v {nejhorsim} historickom období (inak viac).',
    rokyFew: '{n} roky',
    rokyMany: '{n} rokov',
    rokyOne: '{n} rok',
    souhrnReal: 'Modelácia na reálnej histórii (8/1946–2026, {n} období, po inflácii):',
    sporiciByDal: 'Sporiaci účet by dal',
    staciJednorazovy: '0 {mena} (stačí jednorazový)',
    titul: 'Historická kalkulačka',
    trida: {
      akcie: 'Akcie',
      btc: 'Bitcoin',
      dluhopisy: 'Dlhopisy',
      em: 'Rozvíjajúce sa trhy',
      msci: 'MSCI World',
      ndx: 'NASDAQ-100',
      pt: 'Peňažný trh',
      reit: 'Nehnuteľnosti',
      zlato: 'Zlato',
    },
    typ: 'Typ:',
    vlozenoCelkem: 'Vložené spolu',
    vstupniPct: 'Vstupný %',
    vstupniPoplatek: 'Vstupný poplatok: {castka} z vložených {vlozeno}.',
    vynosPa: 'Výnos p.a.',
    vyvojNadpis: 'Vývoj hodnoty investície',
    zdrojDat1: 'Dáta: SBBI/Ibbotson US mesačne 1926–2026 (Akcie = S&P 500 vr. dividend, Dlhopisy = US dlhodobé štátne, Peňažný trh = T-Bills, Inflácia = US CPI). Zlato = LBMA od 1968 · MSCI World od 1985 (vr. odhadu dividend 2 % p.a.) · Nehnuteľnosti = REIT index od 2004 · Bitcoin od 2010.',
    zdrojDat2: 'Výnos p.a. = vnútorné výnosové percento tokov. Minulé výnosy nezaručujú budúce.',
    zhodnoceni: 'Zhodnotenie',
    zkraceno: 'skrátené na {roky} (mladá trieda aktív)',
  },
  /* BLOK:histKalk END */
  /* BLOK:alokaceGraf START — generuje scratchpad/slovnik.py, ručně needitovat */
  alokaceGraf: {
    celkem: 'Celkovo',
    faze: {
      drzeni: 'Držíme. Trh kolíše, plán nie.',
      hotovost: 'Peniaze sú v hotovosti. Žiadne trhové riziko.',
      odprodej: 'Odpredávame akcie a kupujeme dlhopisy — blíži sa cieľ.',
      start: 'Nakupujeme — peniaze idú do akcií.',
    },
    mesicuFew: '{n} mesiace',
    mesicuMany: '{n} mesiacov',
    mesicuOne: '{n} mesiac',
    nadpis: 'Kam peniaze tečú v čase',
    pauza: 'Pauza',
    prehrat: 'Prehrať',
    rok: '{n}. rok',
    zpetNaCelek: 'Späť na celok',
  },
  /* BLOK:alokaceGraf END */
  /* BLOK:fondyRenta START — generuje scratchpad/slovnik.py, ručně needitovat */
  fondyRenta: {
    mimo: ' (ostatné účty a fondy, ktoré nedostal žiadny cieľ) — celý finančný majetok ',
    prehled: 'Fondy → renta',
    prehledRezerva: 'Fondy → rezerva',
    prerozdeluje: 'Plán jednorazovo prerozdeľuje likvidné účty, stavebné sporenie, dôchodkové sporenie a fondy. Mimo zostáva ',
    rozpocetDoRenty: ' sú fondy a investičné životné poistenie, ktoré klient už má — plán ich počíta do renty.',
    rozpocetKCilum: ' sú fondy a investičné životné poistenie, ktoré klient už má — plán ich priradil k cieľom podľa toku peňazí.',
    rozpocetRezervaRenta: ' sú fondy a investičné životné poistenie, ktoré klient už má — plán z nich najprv doplní rezervu ({rezerva}), zvyšok počíta do renty.',
  },
  /* BLOK:fondyRenta END */
  /* BLOK:kinoZavazky START — generuje scratchpad/slovnik.py, ručně needitovat */
  kinoZavazky: {
    a0: {
      radek: 'V analýze nie je žiadny úver.',
      tahak: '„Žiadny úver nesplácate. Peniaze, ktoré by išli banke, môžu pracovať pre vás.“',
      titulek: 'Dlhy nemáte',
    },
    a1: {
      ariaChybi: '{nazev}: {stav}.',
      ariaDluzite: 'Dlžíte {castka}.',
      ariaUroky: 'Na úrokoch ešte zaplatíte {castka}.',
      ariaUrokyCast: 'Na úrokoch ešte zaplatíte {castka} pri úveroch so známym úrokom.',
      ariaUver: '{nazev}: dlh {dluh}, úroky {uroky}, splatené v roku {rok}.',
      dluh: 'dlh',
      dluhNeklesa: 'Dlh neklesá',
      dluhZnamy: 'dlh so známym úrokom',
      doplnteSplatku: 'Doplňte splátku',
      doplnteUrok: 'Doplňte úrok',
      doplnteZustatek: 'Doplňte zostatok',
      kicker: 'Vaše dlhy',
      popisNespocitame: 'úroky zatiaľ nespočítame',
      popisNikdy: 'splátka nepokryje ani úrok',
      radekChybi: '{nazev}: {stav}, v súčte chýba.',
      radekChybiBez: '{nazev}: {stav}.',
      radekDluzite: 'Dlžíte {castka}.',
      radekNaSto: 'Ku každým {sto} dlhu pridáte banke {kolik}.',
      subDluh: 'dlh {castka}',
      tahak: '„Dlh nestojí len to, čo ste si požičali. Toto je, koľko k tomu ešte zaplatíte banke.“',
      tahakDoplnte: '„Pozrieme sa do zmluvy na úrok. Potom hneď uvidíte, koľko k dlhu zaplatíte banke.“',
      tip: 'Zapíšte úrok zo zmluvy. Kino potom spočíta úroky a koniec splácania.',
      titulek: 'Koľko vás stoja dlhy',
      urokyBance: 'úroky banke',
      velkePopis: 'ešte zaplatíte banke na úrokoch',
    },
    a2: {
      ariaDobry: 'Dobrý dlh na bývanie {castka}.',
      ariaDobrySazba: 'Dobrý dlh na bývanie {castka} za {sazba}.',
      ariaJenBydleni: 'Len dlh na bývanie {castka}.',
      ariaPolozka: '{nazev} {sazba} ročne',
      ariaPolozkaBez: '{nazev}, úrok nezapísaný',
      ariaSpatny: 'Zlý dlh {castka}: {seznam}.',
      ariaZadny: 'Zlé dlhy nemáte.',
      bydlite: 'Bývate v ňom · nehnuteľnosť {castka}',
      dobry: 'Dobrý dlh',
      dobryProc: 'bývanie',
      firemni: 'Firemný úver',
      firemniProc: 'podnikanie · do kroku nepatrí',
      kicker: 'Dobrý a zlý dlh',
      radekChybiUrok: 'Pri zlých dlhoch chýba úrok.',
      radekHypo: 'Hypotéka {sazba}.',
      radekJenBydleni: 'Máte len dlh na bývanie.',
      radekNetyka: 'Krok „Zbaviť sa zlých dlhov“ sa vás netýka.',
      radekPrvni: 'Zlé dlhy sa splácajú prvé.',
      radekSazba: '{druh} stojí {sazba} ročne.',
      radekZadnaSpotreba: 'Žiadny úver na spotrebu.',
      spatny: 'Zlý dlh',
      spatnyProc: 'spotreba',
      spatnyZadnyProc: 'spotrebák, kreditka, kontokorent',
      tahak: '„Drahé úvery a kreditky zmažeme prvé. Úrok platíte isto, výnos investícií istý nie je.“',
      tahakZadny: '„Hypotéka je dlh, v ktorom bývate. Spotrebák ani kreditku nemáte, to je dobrá správa.“',
      titulek: 'Nie každý dlh je rovnaký',
      titulekZadny: 'Zlé dlhy nemáte',
      velkePopis: 'zlý dlh · {druhy}',
      velkePopisZadny: 'zlý dlh',
      zadny: 'Žiadny',
    },
    a3: {
      ariaBez: 'Bez peňazí navyše: zlé dlhy splatené za {za}, úroky {urok}.',
      ariaNavic: 'S {castka} navyše mesačne: bez zlých dlhov za {za} namiesto {puvodne}, na úrokoch ušetríte {usetreno}.',
      ariaNesplati: 'Ani s {castka} navyše mesačne sa zlé dlhy nesplatia.',
      jezdecAria: 'Koľko poslať navyše na zlé dlhy mesačne',
      kicker: 'Čo keby',
      mesZkr: '{n} mes.',
      navicMesicne: 'Navyše mesačne',
      navicNejdrivSem: 'navyše najprv sem',
      nic: 'Nič',
      nikdy: 'nikdy',
      nikdyPopis: 'splátka nepokryje úrok · dlh rastie',
      popisPosunte: 'posuňte, koľko pošlete navyše',
      popisRoste: 'ani s toľko navyše dlh neklesá',
      popisSplaceno: 'splatené za {za}',
      popisUsetrite: 'ušetríte na úrokoch',
      pozn: 'Počítané zo splátky a úroku v zmluve. Splátka splateného úveru sa uvoľní pre vás, navyše potom ide na ďalší dlh.',
      radekDnes: 'Dnes bez zlých dlhov za {za}.',
      radekDriv: 'O {kolik} skôr.',
      radekNejdrazsi: 'Navyše ide najprv na najdrahší dlh.',
      radekNikdy: '{nazev}: splátka nepokryje ani úrok.',
      radekZa: 'Bez zlých dlhov za {za} namiesto {puvodne}.',
      rychlaVolba: 'Rýchla voľba',
      tahak: '„Každé euro navyše ide na najdrahší dlh. Čo nezaplatíte banke, zostane vám.“',
      titulek: 'Splatiť zlé dlhy skôr',
      valuetext: '{castka} mesačne',
      velkeRoste: 'Stále rastie',
      velkeZastavi: 'Dlh sa zastaví',
      volne: 'Voľné {castka}',
      zCilu: '{castka} z toho by išlo z peňazí na ciele, kým sa dlhy splatia.',
    },
    a4: {
      aria: 'Po konci fixácie pri sadzbe {sazba} bude splátka {po} namiesto {pred}.',
      dnes: 'Dnes · {sazba}',
      jakoDnes: 'ako dnes',
      jezdecAria: 'Sadzba hypotéky po konci fixácie',
      kicker: 'Hypotéka',
      oDvaBody: 'o 2 body viac',
      po: 'Po fixácii · {sazba}',
      pozn: 'Sadzbu po fixácii dnes nikto nepozná. Doba splácania zostáva, mení sa splátka.',
      poznTrh: 'Priemer trhu dnes: Swiss Life Hypoindex {obdobi}.',
      prumerTrhu: 'priemer trhu dnes',
      radekSplatka: 'Splátka sa prepočíta: {pred} → {po}.',
      radekZustatek: 'Na konci fixácie zostane {castka} dlhu.',
      sazbaPoFixaci: 'Sadzba po fixácii',
      tahak: '„Fixácia raz skončí. Teraz vieme, čo urobí splátka, keď sadzba pôjde hore.“',
      titulek: 'Koniec fixácie: {kdy}',
      velkePopis: 'splátka mesačne pri sadzbe {sazba}',
    },
    a5: {
      ariaDnes: 'Na ciele dnes {castka} mesačne.',
      ariaOd: 'Od roku {rok} {castka}.',
      ariaRenta: 'Renta od roku {rok}.',
      dnes: 'dnes',
      kicker: 'Po splatení',
      naCile: 'na ciele mesačne',
      navicNaDluhy: '{castka} navyše na dlhy',
      poRenteFew: 'Hypotéka dobehne {n} roky po začiatku renty.',
      poRenteMany: 'Hypotéka dobehne {n} rokov po začiatku renty.',
      poRenteOne: 'Hypotéka dobehne {n} rok po začiatku renty.',
      popisDoplnte: 'bez nich nevieme, kedy dlhy dobehnú',
      poznModel: 'Dnes na ciele {castka} mesačne z voľných peňazí, zatiaľ neodsúhlasené. Uvoľnené splátky sú zo zmlúv. Ostatné príjmy a výdavky počítame ako dnes.',
      poznOdsouhlaseno: 'Dnes na ciele {castka} mesačne, ako je odsúhlasené v analýze. Uvoľnené splátky sú zo zmlúv. Ostatné príjmy a výdavky počítame ako dnes.',
      predRentouFew: 'Dobehne {n} roky pred rentou.',
      predRentouMany: 'Dobehne {n} rokov pred rentou.',
      predRentouOne: 'Dobehne {n} rok pred rentou.',
      radekHypo: 'V roku {rok} dobehne hypotéka. Ďalších {castka}.',
      radekUsetreno: 'Ušetrené úroky {castka} zostanú vám.',
      splaceno: '{nazev}: splatené',
      startRenty: 'začiatok renty',
      tahak: '„Až dlhy dobehnú, tieto peniaze budú pracovať pre vás.“',
      tip: 'Zapíšte koniec splácania hypotéky zo zmluvy.',
      titulek: 'Peniaze, ktoré sa uvoľnia',
      velkeDoplnte: 'Doplňte splátky',
      velkePopis: 'mesačne navyše na ciele · od roku {rok}',
    },
    mesiceFew: '{n} mesiace',
    mesiceMany: '{n} mesiacov',
    mesiceOne: '{n} mesiac',
    nazev: 'Záväzky',
    prezTlacitko: 'Spustiť kino: Koľko vás stoja dlhy',
    splacenoVRoce: 'splatené v roku {rok}',
    stav: {
      bezJistiny: 'zostatok nezapísaný',
      bezSplatky: 'splátka nezapísaná',
      bezUroku: 'úrok nezapísaný',
      nikdy: 'splátka nepokryje ani úrok',
    },
    tlacitko: 'Kino záväzkov',
    uver: 'Úver',
  },
  /* BLOK:kinoZavazky END */
  /* BLOK:rizikoVysvetleni START — generuje scratchpad/slovnik.py, ručně needitovat */
  rizikoVysvetleni: {
    dite: {
      potreba: 'celá potreba',
      sablonaKrok: 'Vzor pre detskú zmluvu',
      sablonaTitul: 'Šablóna: prečo táto suma',
      sablonaToggle: 'Prečo táto suma',
      sablonaVeta: 'Vzor z praxe poradcu, nie výpočet z čísel klienta — prepíšete ho ceruzkou podľa ponuky poisťovne.',
      strop: 'Strop poistiteľnosti',
      stropPod: 'detské zmluvy upíšu rádovo do {strop}, zvyšok {zbytek} patrí do rezervy',
      trvaleTitul: 'Ako vzniká poistná suma dieťaťa',
      trvaleToggle: 'Ako sa počíta poistná suma dieťaťa',
      vypadekPod: '{kdo}: {prijem} na {roky}, dnešná hodnota s výnosom 4 % nad infláciu',
      zavazneKrok1: 'Ročný príjem opatrujúceho rodiča',
      zavazneKrok1Pod: '{kdo}: {prijem} × 12',
      zavazneStropPod: 'detské zmluvy kryjú rádovo do {strop}, zvyšok {zbytek} patrí do rezervy',
    },
    odskodne: {
      krok1: 'Výpadok, ktorý nič nekryje',
      krok1PodOdZacatku: 'rezerva nepokryje ani mesiac: {prijem} − nemocenské {stat}',
      krok1PodRezerva: 'prvé mesiace drží rezerva, potom platí pracovná neschopnosť — odškodné by krylo to isté',
      krok1PodVypnuto: 'odškodné je vypnuté',
      krok2: 'Strop: dávky najviac do čistého príjmu',
      krok2Pod: '{prijem} − nemocenské {stat} − pracovná neschopnosť {pn}',
      model: 'Odškodné kryje dni, keď pracovná neschopnosť ešte neplatí a rezerva nestačí. Dávky spolu nesmú byť vyššie ako čistý príjem — to žiadna poisťovňa neupíše.',
      titul: 'Ako vzniká denné odškodné',
      toggle: 'Ako sa počíta denné odškodné',
      vysledek: 'Limit denného odškodného',
      vysledekPod: 'menšie z oboch čísel, zaokrúhlené na desiatky',
    },
    pn: {
      krok1: 'Čistý príjem',
      krok1Vydaje: 'Podiel nevyhnutných výdavkov',
      krok1VydajeSplatky: 'Podiel nevyhnutných výdavkov a splátok',
      krok2: 'Čo dá štát',
      krok3: 'Výpadok príjmu',
      krok3Pod: '{prijem} − {stat}',
      krok4: 'Denná dávka',
      krok4Pod: '{vypadek} ÷ {dni} dní',
      krok5: 'Odkedy poistka platí',
      krok5Hodnota: 'od {mesic}. mesiaca',
      krok5Info: 'Čakacia doba = koľko celých mesiacov utiahne rezerva, najviac 3. Dlhšia čakacia doba = lacnejšia poistka.',
      krok5Pod: 'rezerva {rezerva} = {nasobek}× nevyhnutné výdavky ({vydaje}) — dovtedy drží ona',
      krok5PodNula: 'rezerva {rezerva} nepokryje ani jeden mesiac nevyhnutných výdavkov ({vydaje})',
      model: 'Orientačný model, nie garancia: nemocenské podľa pravidiel roku 2026, skutočnú výšku určí štát. Čakaciu dobu a plnenie určujú poistné podmienky.',
      odDneOsvc: 'vypláca sa od {den}. dňa',
      odDneZam: 'vypláca sa od {den}. dňa, dovtedy platí náhradu príjmu zamestnávateľ',
      omezeno: 'najviac do výšky čistého príjmu',
      predpoklad: 'počítame s povinným nemocenským poistením',
      sazbaInfo: 'Počítame 60 % — sadzbu prvých 30 dní. Od 31. dňa štát platí 66 %, od 61. dňa 72 %, model je teda opatrný.',
      statBez: 'Bez nemocenského poistenia — nemocenské sa nevypláca.',
      statOsvc: 'SZČO bez nemocenského poistenia — nemocenské sa nevypláca.',
      statRozpad: 'hrubá mzda ≈ {hruba} → denný základ {dvz} → po redukcii {rdvz} → {sazba} % = {den} × 30 dní',
      statRozpadSK: 'hrubá mzda ≈ {hruba} → denný vymeriavací základ {dvz} → {sazba} % = {den} × 30 dní',
      strop: 'strop: najviac {strop} — z denného základu nad {hranice} sa nepočíta nič',
      stropSK: 'strop: denný vymeriavací základ najviac {hranice}',
      titul: 'Ako vzniká denná dávka',
      toggle: 'Ako sa počíta pracovná neschopnosť',
      varianty: 'Rovnaké vo všetkých variantoch krytia — krátky výpadok sa neuskromňuje.',
      vysledek: 'Limit pracovnej neschopnosti',
    },
    rucne: 'Na karte je ručne {rucni}, vypočítané {spocitano}.',
    skryt: 'Skryť výpočet',
    zaokrouhleni: 'Riadky sú zaokrúhlené, ich súčet sa môže nepatrne líšiť.',
    zavazne: {
      krok1: 'Ročný čistý príjem',
      krok1Pod: '{prijem} × 12',
      krok2: 'Na koľko rokov',
      krok2Hodnota: '× {roky}',
      krok2Pod: 'voľba 1 / 2 / 3 roky pod riadkom',
      titul: 'Ako vzniká suma závažných chorôb',
      toggle: 'Ako sa počítajú závažné choroby',
      vysledek: 'Limit závažných chorôb',
    },
  },
  /* BLOK:rizikoVysvetleni END */
  /* BLOK:fondKategorie START — generuje scratchpad/slovnik.py, ručně needitovat */
  fondKategorie: {
    'akcie-em': 'Akcie – rozvíjajúce sa trhy',
    'akcie-eu': 'Akcie – Európa',
    'akcie-svet': 'Akcie – svet',
    'akcie-tech': 'Akcie – technológie',
    'akcie-usa': 'Akcie – USA',
    dluhopisy: 'Dlhopisy',
    fond: 'Fond',
    fondA: 'Fond A',
    fondB: 'Fond B',
    krypto: 'Krypto (ETP)',
    nemovitosti: 'Realitné fondy',
    penizni: 'Peňažné / konzervatívne',
    smisene: 'Zmiešané',
    zlato: 'Zlato / komodity',
  },
  /* BLOK:fondKategorie END */
  /* BLOK:kino503020 START — generuje scratchpad/slovnik.py, ručně needitovat */
  kino503020: {
    a1: {
      aria: 'Pravidlo 50/30/20: z príjmu {prijem} ide bokom {stranou}, na život {styl}, na nevyhnutné vrátane splátok {nezbytne}.',
      bezPrijmu: 'Bez príjmu pravidlo nerozdelíme.',
      kat: {
        bonusy: 'bonusy',
        pasivni: 'pasívny príjem',
      },
      kicker: 'Pravidlo',
      osoba: 'Osoba {n}',
      prijem: 'čistý príjem',
      prijemDomacnosti: 'čistý príjem domácnosti',
      radek1: 'Polovica na nevyhnutné.',
      radek2: 'Necelá tretina na život.',
      radek3: 'Pätina bokom.',
      splatkyNadRozpocet: 'Splátky dnes zaberú viac, než pravidlo nechá na výdavky.',
      tahak: '„Osvedčené pravidlo: z {prijem} polovica na nevyhnutnosti, necelá tretina na život a pätina bokom na budúcnosť. Minimum je desatina.“',
      titulek: '50 / 30 / 20',
      zamestnavatel: 'zamestnávateľ {castka}',
    },
    a2: {
      aria: 'Dnes ide bokom {pct} % ({stranou}). {radek} {dily}.',
      ariaPravidlo: 'Pravidlo: bokom 20 %, na život 30 %, nevyhnutné a splátky 50 %.',
      ariaSchodek: 'Dnes mesačne chýba {chybi}: výdavky a splátky presahujú príjem. Bokom nejde nič, vklady do sporenia sú vo výdavkoch.',
      bezVydaju: 'Doplňte výdavky a spočítame, koľko reálne odkladáte.',
      bezVydajuVizual: 'Bez výdavkov percento netvrdíme.',
      dohodaNad: 'Dohoda je o {castka} vyššia než voľné peniaze.',
      kicker: 'Vy dnes',
      nesoulad: 'Vklady sú vyššie než výdavky, skontrolujte rozpis výdavkov.',
      poznVklady: 'vr. vkladov do sporenia',
      poznZam: 'vr. {castka} od zamestnávateľa',
      pravidlo: 'Pravidlo',
      prepinacAria: 'Čo ukázať',
      radekIdeal: 'To je ideál. ✓',
      radekMinimum: 'Minimum máte. Do ideálu chýba {chybi}.',
      radekPod: 'Do minima chýba {chybi} mesačne.',
      radekRychle: 'Ciele sa plnia veľmi rýchlo. ✓',
      radekSchodek: 'Než začneme odkladať, treba tento rozdiel zavrieť.',
      tahakBezVydaju: '„Než povieme percento, doplníme spolu výdavky.“',
      tahakCastVolne: 'Z toho {zbyva} máte vo voľných peniazoch, zvyšok by sme hľadali vo výdavkoch.',
      tahakIdeal: '„Bokom dávate {pct} % príjmu. To je ideál. Teraz ide o to, kam tie peniaze pošleme.“',
      tahakMinimum: 'Bokom dávate {pct} % príjmu. Minimum máte, do ideálu chýba {chybi}.',
      tahakPod: 'Bokom dávate {pct} % príjmu. Do minima chýba {chybi}.',
      tahakRychle: '„Bokom dávate {pct} % príjmu. Ciele sa tak plnia veľmi rýchlo. Postrážme, nech vám zostáva aj na život.“',
      tahakSchodek: '„Dnes mesačne chýba {chybi}. Než začneme odkladať, musíme tento rozdiel zavrieť.“',
      tahakVolne: 'Tie máte vo voľných peniazoch, škrtať nemusíte.',
      tahakVydaje: 'Voľné peniaze na to dnes nie sú, budeme ich hľadať vo výdavkoch.',
      titulek: 'Kde ste dnes',
      velkeBezVydaju: 'výdavky nie sú zadané',
      velkePopis: 'príjmu ide bokom · {castka}',
      velkeSchodek: 'mesačne chýba',
      vyDnes: 'Vy dnes',
      zbyvaPred: 'Voľne zostáva',
    },
    a3: {
      aria: 'Pri {pct} % ide bokom {stranou}, voľne zostáva {zbyva}. Nevyhnutné a splátky sa nemenia.',
      ariaStyl: 'Pri {pct} % ide bokom {stranou}, z toho {styl} zo životného štýlu. Nevyhnutné a splátky sa nemenia.',
      kicker: 'Čo keby',
      pct: {
        necelych: 'necelých {pct} %',
        pres: 'cez {pct} %',
        presne: '{pct} %',
      },
      pokryto: 'Pokryjú to vklady, ktoré už bežia ({vklady}).',
      radekSchodek: 'Pri schodku najprv výdavky, potom percentá.',
      staci: 'Stačia voľné peniaze.',
      tahak: '„Skúste si to sami. Z vkladov a voľných peňazí ide najviac {max} mesačne, to je {pct}. Nad to by sme už brali z vášho života.“',
      tahakSchodek: '„Odkladať z dlhu nedáva zmysel. Najprv nájdeme tých {chybi}, potom sa vrátime k percentám.“',
      titulek: 'Kde na to vziať',
      velkePopis: 'mesačne bokom',
      velkeSchodek: 'nie je z čoho odkladať',
      zbyva: 'Zostáva {castka}.',
      zeStylu: 'Zo životného štýlu ubrať {castka} mesačne.',
    },
    a4: {
      ariaBezCile: 'Renta v cieľoch zatiaľ nie je.',
      ariaChybi: 'Do renty, ktorá rodinu uživí, chýba {chybi} mesačne.',
      ariaPotreba: 'Rodina potrebuje {potreba} mesačne.',
      ariaSedi: 'Renta v cieľoch {zadano} rodinu uživí.',
      ariaSplatky: 'Z toho {nazev} {splatky} ({proc}).',
      bezSporeni: 'Bez dnešného sporenia {castka}, v rente už nesporíte.',
      bezUveru: 'Bez úverov doplatených pred rentou.',
      bezUveruRok: 'Bez úverov doplatených do roku {rok}.',
      chybiMesicne: 'chýba {chybi} mesačne',
      kapital: 'Na rentu {potreba} v dnešných cenách treba kapitál zhruba',
      kicker: 'Rentier',
      potrebuje: 'Rodina potrebuje',
      pravni: 'Modelácia podľa sadzby čerpania zhruba {sazba} ročne ({profil} profil). Nie je to výnos ani záruka, skutočnosť sa môže líšiť.',
      radekPotreba: 'Rodina potrebuje {potreba} mesačne.',
      radekSoucet: 'Výdavky {vydaje} + {nazev} {splatky} = {potreba} mesačne.',
      splatky: 'splátky',
      splatkyBezi: 'bežia aj v rente',
      splatkyNeznamyKonec: 'koniec sa nedá spočítať, doplňte úrok',
      tahak: '„Rentier nie je ten, kto veľa zarába. Je to ten, komu majetok platí účty namiesto neho.“',
      tahakUrok: '(Doplňte pri úvere úrok alebo zostatok, appka potom spočíta, či skončí pred rentou.)',
      titulek: 'Koľko musí renta uniesť?',
      vCilech: 'Renta v cieľoch',
      vCilechJe: 'V cieľoch je {zadano}.',
      vCilechNeni: 'V cieľoch renta zatiaľ nie je.',
      velkeBezCile: 'mesačne by renta mala byť',
      velkeChybi: 'mesačne chýba do renty, ktorá rodinu uživí',
      velkeSedi: 'renta v cieľoch rodinu uživí ✓',
      zTohoSplatky: 'z toho {nazev}',
    },
    ctverecek: '1 štvorček = 1 % príjmu ({castka} mesačne)',
    dil: {
      nad: 'Z toho nad príjem',
      nezbytne: 'Nevyhnutné',
      nezbytneVse: 'Nevyhnutné vr. splátok',
      splatky: 'Splátky',
      stranou: 'Bokom',
      styl: 'Životný štýl',
      volne: 'Zostáva voľne',
      vydaje: 'Výdavky (bez rozpisu)',
      zVkladu: 'Z vkladov a voľných peňazí',
      zestylu: 'Zo životného štýlu',
    },
    doplnPrijmy: 'Doplňte príjmy',
    nazev: 'Príjmy · 50/30/20',
    prah: {
      ideal: '{pct} % ideál',
      minimum: '{pct} % minimum',
      rychle: '{pct} % rýchlo',
    },
    prahPrijem: 'príjem',
    profil: {
      dynamicky: 'dynamický',
      konzervativni: 'konzervatívny',
      vyvazeny: 'vyvážený',
    },
    uvozovky: '„{text}“',
  },
  /* BLOK:kino503020 END */
  /* BLOK:portfolioKarta START — generuje scratchpad/slovnik.py, ručně needitovat */
  portfolioKarta: {
    investice: 'Investície',
    odhadBj: '* odhad z podpísaných BJ',
    penze: 'Dôchodok',
    pojisteni: 'Poistenie',
    proviceYtd: 'Provízie YTD',
    rezerva: 'Rezerva',
    rocniVynos: 'Ročný výnos',
    titul: 'Portfólio klienta',
    zadnyProdukt: 'Žiadny investičný produkt',
  },
  /* BLOK:portfolioKarta END */
  /* BLOK:kinoZdroje START — generuje scratchpad/slovnik.py, ručně needitovat */
  kinoZdroje: {
    a1: {
      ariaFin: 'Finančný majetok {castka}.',
      ariaKapsa: '{nazev} {castka}, {kdy}.',
      ariaNefin: '{nazev} {castka}: do cieľov sa nepočíta.',
      ariaPrazdna: '{nazev}: nič nezapísané.',
      doplnte: 'Doplňte majetok',
      kicker: 'Vaše peniaze',
      nefinPopis: 'do cieľov sa nepočíta',
      nemovitost: 'Nehnuteľnosť',
      nevime: 'Zatiaľ nevieme, kde peniaze ležia.',
      podil: '{pct} % leží {misto}.',
      polovina: 'Polovica leží {misto}.',
      radek2: 'Nie všetko je poruke rovnako rýchlo.',
      tahak: '„Než začneme sporiť nové peniaze, pozrime sa, čo už máte. Býva to viac, než si ľudia myslia.“',
      titulek: 'Peniaze, ktoré už máte',
      velkePopis: 'finančný majetok',
      vse: 'Všetko leží {misto}.',
    },
    a2: {
      ariaZisk: 'Za 10 rokov kúpi {castka} na účte toľko, čo dnes {za}; úrok je nad infláciou {inflace}.',
      ariaZtrata: 'Za 10 rokov kúpi {castka} na účte len toľko, čo dnes {za}, pri inflácii {inflace} ročne.',
      bezUroku: 'Účet bez úroku.',
      dnes: 'dnes {castka}',
      kicker: 'Inflácia',
      pilulkyAria: 'Aká inflácia',
      radekZisk: '{castka} za 10 rokov kúpi to, čo dnes {za}.',
      radekZtrata: '{castka} za 10 rokov kúpi len to, čo dnes {za}.',
      tahak: '„Inflácia je tichý zlodej. Číslo na výpise nezmizne, ale kúpite si zaň čoraz menej.“',
      titulek: 'Na účte peniaze ticho strácajú',
      titulekStaci: 'Úrok inflácii zatiaľ stačí',
      urok: 'Úrok na účte {urok}.',
      urokNezadan: 'Úrok pri účte nie je zapísaný, počítame 0 %.',
      velkePopis: 'kúpna sila za 10 rokov · inflácia {inflace}',
      volba: {
        cil: {
          cnb: 'cieľ ČNB',
          ecb: 'cieľ ECB',
        },
        historie: 'ako {od}–{do}',
        plan: 'predpoklad plánu',
      },
      zdrojCZK: 'Plán počíta s {plan} (predpoklad). ČSÚ: {rok} {posledni}, priemer 2016–2025 {prumer}. Cieľ ČNB 2 %.',
      zdrojEUR: 'Plán počíta s {plan} (predpoklad). Cieľ ECB 2 %.',
      zdrojJiny: 'Plán počíta s infláciou {plan} (predpoklad).',
    },
    a3: {
      ariaNic: 'Nič nepracuje.',
      ariaPodRezervou: '{rezerva}: na účte {ucet}, chýba {chybi}.',
      ariaSrovnani: 'Výhľad {roky}: keď {x} zostane na účte, kúpi ako dnes {ucet}. Keď pracuje podľa profilu plánu, je to modelovo {model}, v horšom scenári {horsi}, v lepšom {lepsi}. Výnos nie je zaručený.',
      chybi: 'chýba {castka}',
      dlouhyCil: 'dlhý cieľ (renta)',
      jenNad: 'Len nad rezervu',
      jezdecAria: 'Koľko peňazí z účtu by mohlo pracovať',
      kicker: 'Čo keby',
      model: 'Model: {roky} ako cieľ {cil}, profil {profil}, v dnešných peniazoch, bez poplatkov a daní. Výnos nie je zaručený, čiarka nad pruhom = horší a lepší scenár plánu. Účet: úrok {urok}, inflácia {inflace}.',
      naUctu: 'na účte {castka}',
      nadRezervu: 'nad rezervu {castka}',
      nic: 'Nič',
      pasmo: 'horší scenár {horsi} · lepší {lepsi}',
      pracuje: 'Pracuje',
      pracujeModel: 'Pracuje · model',
      radekJenNad: 'Nad ňou je len {castka}.',
      radekKlesla: 'Rezerva by klesla na {castka}.',
      radekNaUctu: 'Na účte je {castka}.',
      radekNad: 'Nad ňou je {castka}.',
      radekRezerva: 'Rezerva je {castka}.',
      radekRezervaNa: 'Rezerva na {n} mes. je {castka}.',
      radekRezervaZustava: 'Rezerva {castka} zostáva na účte.',
      rezerva: 'rezerva · {castka}',
      rezervaNa: 'rezerva na {n} mes. · {castka}',
      sniInflace: 'zje inflácia',
      tahak: '„Rezervu necháme na účte, na tú nesiahame. Peniaze nad ňou môžu pracovať.“',
      titulek: 'Rezerva zostane, zvyšok môže pracovať',
      titulekPodRezervou: 'Najprv celá rezerva',
      titulekRezerva: 'Časť rezervy by pracovala',
      urokNad: 'z úroku nad infláciou',
      valuetextRezerva: '{x}, z toho {rezerva} z rezervy',
      varovani: '{castka} by išlo z rezervy. Tá by potom nebola celá.',
      velkeChybiRezerva: 'chýba do rezervy',
      velkeNic: 'nič nepracuje',
      velkePasmo: 'horší scenár {horsi} · lepší {lepsi}',
      velkePopis: '{roky} navyše · model, výnos nie je zaručený',
      velkeZRezervy: 'by chýbalo v rezerve',
      vlozenoVynos: 'vložené {x} + modelový výnos {vynos}',
      zUctu: 'z účtu',
      zustaneNaUctu: 'Zostane na účte',
    },
    a4: {
      ariaBez: 'Bez peňazí, ktoré máte: {popis}.',
      ariaS: 'S peniazmi, ktoré máte: {popis}.',
      bezNich: 'Bez nich',
      cil: 'Cieľ',
      dnesPct: 'dnes {pct} %',
      hotovaDoMes: 'hotová do {n} mes.',
      hotovaHned: 'hotová hneď',
      hotovaZaMes: 'hotová o {n} mes.',
      kTerminu: 'k termínu',
      kTerminuPct: 'k termínu {pct} %',
      kicker: 'Vaše ciele',
      mesicne: '{castka}/mes.',
      nepriradeno: {
        investice: 'Investície',
        stavebko: 'Zvyšok stavebného sporenia',
        ucty: 'Zvyšok na účtoch',
      },
      nepriradenoPopis: 'plán ich zatiaľ k žiadnemu cieľu nepriradí',
      plusOdkladani: '+ odkladanie',
      plusVynos: '+ výnos (model)',
      poMesicne: 'po {castka} mesačne',
      pozn: 'Rovnaký výpočet ako Návrh riešenia, v dnešných peniazoch. Výnos je model, nie sľub.',
      radekBez: '{cil} by k termínu malo {bez} % namiesto {s} %.',
      radekS: '{cil} k termínu {s} % namiesto {bez} %.',
      radekStejne: 'Bez nich by plán vyšiel rovnako.',
      renta: 'Renta',
      rezerva: 'Rezerva',
      sPenezi: 'S peniazmi, ktoré máte',
      segmentAria: 'Porovnanie',
      tahak: '„Ďalším zdrojom na naplnenie vašich cieľov sú peniaze, ktoré už máte.“',
      titulek: 'Ďalší zdroj pre vaše ciele',
      vVeku: 'v {vek} rokoch',
      vVekuPoStartu: 'v {vek} rokoch · po štarte renty',
      velkeNic: 'Zatiaľ nič',
      velkeNicPopis: 'do termínu cieľov z majetku nič nedorazí',
      velkePopis: 'plán priradí k cieľom do ich termínu',
      vetaRezervaBez: 'Bez nich by sa rezerva sporila {n} mes.',
      vetaRezervaDoMes: 'Rezerva je hotová do {n} mes.',
      vetaRezervaHned: 'Rezerva je hotová hneď.',
      vetaRezervaPct: 'Rezerva je dnes na {pct} %.',
      vetaRezervaZa: 'Rezerva bude hotová o {n} mes.',
      vlastniZdroje: 'vlastné zdroje {castka}',
      zaMes: 'o {n} mes.',
      zatimNic: 'zatiaľ nič',
      zdrojPenzijko: 'dôchodkové sporenie',
    },
    kapsa: {
      investice: 'Investície',
      nezapsano: 'nič nezapísané',
      penzijko: 'Dôchodkové sporenie',
      stavebko: 'Stavebné sporenie',
      ucty: {
        bezny: 'Bežný účet',
        hotovost: 'Hotovosť',
        sporici: 'Sporiaci účet',
        ucty: 'Účty',
      },
    },
    kdy: {
      castHned: 'časť hneď',
      hned: 'hneď',
      investice: 'o pár dní',
      penzijko: 'v {vek} rokoch',
      stavebko: 'do {n} mes.',
    },
    misto: {
      investice: 'v investíciách',
      penzijko: 'v dôchodkovom sporení',
      stavebko: 'v stavebnom sporení',
      ucty: {
        bezny: 'na bežnom účte',
        hotovost: 'v hotovosti',
        sporici: 'na sporiacom účte',
        ucty: 'na účtoch',
      },
    },
    nazev: 'Zdroje',
    osa: {
      dnes: 'dnes',
      zaRokyFew: 'o {n} roky',
      zaRokyMany: 'o {n} rokov',
      zaRokyOne: 'o {n} rok',
    },
    prezTlacitko: 'Spustiť kino: Peniaze, ktoré už máte',
    rokyFew: '{n} roky',
    rokyMany: '{n} rokov',
    rokyOne: '{n} rok',
    tlacitko: 'Kino Zdroje',
    tlacitkoTitle: 'Prehrať kino: Peniaze, ktoré už máte',
    zaRokyFew: 'za {n} roky',
    zaRokyMany: 'za {n} rokov',
    zaRokyOne: 'za {n} rok',
  },
  /* BLOK:kinoZdroje END */
  /* BLOK:predAPo START — generuje scratchpad/slovnik.py, ručně needitovat */
  predAPo: {
    cena: 'Cena',
    hlavicka: {
      dnes: 'Dnes',
      kryti: 'Krytie ×',
      nove: 'Nové',
    },
    infoDalsiRizika: 'Limity všetkých rizík (invalidita, smrť, práceneschopnosť, závažné ochorenia, trvalé následky, odškodné) doplníte v analýze po osobách: Poistné zmluvy → Riziká v zmluvách.',
    infoNema: '„nemá“ = žiadna zapísaná zmluva toto riziko nekryje. „nezadané“ = zmluva je, ale limit pri nej chýba.',
    infoRozsah: 'Pri domácnosti bez vybranej osoby násobok krytia neukazujeme — porovnávala by sa zmluva jedného človeka s novým krytím oboch.',
    mene: 'menej',
    nema: 'nemá',
    spolecna: 'vr. spoločnej zmluvy',
    spolecnaU: 'spoločná zmluva · platba pri {kdo}',
    stitekNove: 'nové',
    ztrata: 'strata',
  },
  /* BLOK:predAPo END */
  /* BLOK:podkladyKlienta START — generuje scratchpad/slovnik.py, ručně needitovat */
  podkladyKlienta: {
    dny: {
      '0': 'v nedeľu',
      '1': 'v pondelok',
      '2': 'v utorok',
      '3': 'v stredu',
      '4': 'vo štvrtok',
      '5': 'v piatok',
      '6': 'v sobotu',
    },
    dok: {
      leasing: 'lízingová zmluva',
      naSchuzce: 'vyplníme spolu na stretnutí',
      pojistna: 'poistná zmluva',
      portfolio: 'výpis z portfólia',
      smlouvaVypis: 'zmluva a posledný výpis',
      triMesice: 'za posledné 3 mesiace',
      uverova: 'úverová zmluva a výpis zostatku',
      vypis: 'posledný výpis',
      vypisUctu: 'výpis z účtu',
      zustatek: 'aktuálny zostatok',
    },
    nazev: {
      akcie: 'Akcie',
      cennosti: 'Poistenie cenností',
      cizimena: 'Účet v cudzej mene',
      danove: 'Daňové priznanie za rok {rok}',
      dip: 'Dlhodobý investičný produkt (DIP)',
      dluhopisy: 'Dlhopisy',
      dps: 'Doplnkové dôchodkové sporenie (III. pilier)',
      fondy: 'Fondy / ETF',
      investice: 'Investície',
      krypto: 'Kryptomeny',
      kzp: 'Kapitálové životné poistenie',
      pojistka: 'Poistná zmluva',
      pripojisteni: 'Penzijné pripoistenie',
      sporici: 'Sporiaci účet',
      stavebko: 'Stavebné sporenie',
      terminovany: 'Termínovaný vklad',
      uver: 'Úver',
      vypisy: 'Výpisy z bežného účtu',
    },
    platno: {
      emailem: 'Zoznam vám pošlem aj e-mailom',
      idealne: 'Ideálne pred stretnutím',
      kicker: 'Záver',
      papiry: 'Papiere môžete priniesť aj na stretnutie',
      pod: 'Stačí sken alebo fotka z telefónu.',
      posleteNa: 'Pošlite na',
      prazdne: 'Zatiaľ nič — doplníme na ďalšom stretnutí.',
      titul: 'Čo od vás budem potrebovať',
      zpravou: 'Zoznam vám pošlem aj správou',
    },
    pocetSmluvFew: '{n} zmluvy',
    pocetSmluvMany: '{n} zmlúv',
    pocetSmluvOne: '{n} zmluva',
    ui: {
      bezEmailu: '{kdo} nemá e-mail.',
      bezKontaktu: 'bez kontaktu',
      bezTelefonu: '{kdo} nemá telefón.',
      chybaRada: 'Skúste to znova alebo správu otvorte vo svojom poštovom programe.',
      chybaTitul: 'Odoslanie sa nepodarilo — nič neodišlo',
      chybiMujEmail: 'V správe chýba váš e-mail, klient by nevedel, kam skeny poslať.',
      cisloVarovani: 'vyzerá to na číslo zmluvy — do správy ho radšej nepíšte',
      detailEmail: 'Odoslané {kdy} e-mailom · {komu}',
      detailMailto: 'Otvorené v poštovom programe {kdy} · {komu} · odošlete tam',
      detailWa: 'Otvorené vo WhatsAppe {kdy} · {komu} · odošlete tam',
      dokumentFew: 'dokumenty',
      dokumentMany: 'dokumentov',
      dokumentOne: 'dokument',
      doplnitEmail: 'Doplniť e-mail v Úvode',
      doplnitNastaveni: 'Doplniť verejný e-mail v Nastaveniach',
      doplnitTelefon: 'Doplniť telefón v Úvode',
      emailUctu: 'V správe je e-mail prepojeného účtu',
      instituceChybi: 'inštitúcia nevyplnená',
      jazyk: 'Jazyk správy',
      jen: 'len {kanal}',
      kanalEmail: 'e-mail',
      kanalEmailSpatny: 'e-mail v zlom tvare',
      kanalTelefon: 'telefón',
      kdyCas: '{den} o {cas}',
      klient: 'Klient',
      komu: 'Komu poslať',
      kopirovaniChyba: 'Kopírovanie sa nepodarilo — označte text a skopírujte ho ručne.',
      kopirovat: 'Kopírovať',
      neodeslano: 'Zatiaľ neodoslané',
      nicVybrano: 'Nič nie je vybrané — správa sa neodošle',
      odebrat: 'Odobrať: {nazev}',
      odesilam: 'Odosielam…',
      odeslanoEmail: 'Odoslané {den} e-mailom',
      odeslanoToast: 'E-mail odišiel klientovi.',
      odeslatChyba: 'Odoslanie zlyhalo.',
      opravitEmail: 'Opraviť e-mail v Úvode',
      otevritPostu: 'Otvoriť v poštovom programe',
      plusDotaznik: '+ dotazník na stretnutie',
      pocetPred: 'Do správy pôjde',
      pod: 'Zostavené zo Zdrojov, Záväzkov a majetku v analýze',
      podleMajetku: 'podľa majetku: {nazev}',
      polozkaMajetku: 'položka majetku',
      poslatEmail: 'Poslať e-mailom',
      poslatWa: 'Poslať cez WhatsApp',
      pozdeji: 'dodá neskôr',
      poznGmail: 'Odíde z vášho Gmailu {email}',
      poznGmailBez: 'Odíde z vášho Gmailu',
      poznMailto: 'Otvorí váš poštový program — odošlete tam',
      poznSmtp: 'Odíde z vášho firemného e-mailu {email}',
      poznSmtpBez: 'Odíde z vášho firemného e-mailu',
      poznWa: 'Otvorí WhatsApp s hotovým textom — odošlete tam',
      poznZjistuji: 'Zisťujem, kadiaľ e-mail odíde…',
      predanoWa: 'Odovzdané do WhatsAppu {den}',
      predmet: 'Predmet',
      pridat: 'Pridať',
      pridatLabel: 'Vlastná položka',
      pridatPh: 'napr. kúpna zmluva k bytu',
      pripravenoEmail: 'Pripravené v e-maile {den}',
      rozbalit: 'Zobraziť celú správu',
      sbalit: 'Zbaliť správu',
      skupina: {
        dalsi: 'Ďalšie',
        pojisteni: 'Poistenie',
        sporeni: 'Sporenie a investície',
        uvery: 'Úvery',
      },
      spatnyEmail: '{kdo} má e-mail v zlom tvare ({email}).',
      terminAnalyza: 'Termín zapísaný v analýze: {kdy}',
      terminDiar: 'Termín z diára: {kdy}',
      terminProbehl: 'Termín v analýze ({kdy}) už prebehol — v správe nie je',
      terminZadny: 'V diári nie je ďalšie stretnutie — termín v správe nie je',
      titul: 'Čo má dodať klient',
      vlastni: 'vlastná položka',
      waBezEmailu: 'Bez vášho e-mailu by klient poslal skeny do WhatsAppu.',
      zkopirovano: 'Text správy je skopírovaný.',
      zkusitZnovu: 'Skúsiť znova',
      zmena: 'Od odoslania sa správa zmenila — pošlite ju znova.',
      znovuEmail: 'Poslať znova e-mailom',
      znovuWa: 'Poslať znova cez WhatsApp',
      zpravaPod: 'Klient pošle skeny na váš e-mail',
      zpravaTitul: 'Správa pre klienta',
    },
    viceFew: '{n} zmluvy: {dok} ku každej',
    viceMany: '{n} zmlúv: {dok} ku každej',
    viceOne: '{n} zmluva: {dok}',
    zprava: {
      dotaznik: 'Investičný dotazník vyplníme spolu na stretnutí.',
      fotka: 'Stačí fotka z telefónu, hlavne nech je čitateľná.',
      kamEmail: 'Pošlite ich prosím na môj e-mail {email}, keď budete mať chvíľku.',
      kamEmailTermin: 'Pošlite ich prosím na môj e-mail {email}, ideálne pred naším ďalším stretnutím {den}',
      kamOdpoved: 'Pošlite ich prosím odpoveďou na tento e-mail, keď budete mať chvíľku.',
      kamOdpovedTermin: 'Pošlite ich prosím odpoveďou na tento e-mail, ideálne pred naším ďalším stretnutím {den}',
      nevadi: 'Keď niečo nenájdete, nevadí — prejdeme to spolu. Papiere môžete priniesť aj na stretnutie.',
      pozdrav: 'Dobrý deň,',
      pozdravJmeno: 'Dobrý deň, {osloveni},',
      predmet: 'Podklady na prípravu návrhu',
      predmetTermin: 'Podklady k nášmu ďalšiemu stretnutiu',
      uvod: 'ďakujem za naše stretnutie. Na prípravu návrhu mi prosím pošlite skeny alebo fotky týchto dokumentov:',
    },
  },
  /* BLOK:podkladyKlienta END */
  /* BLOK:vykonTymu START — generuje scratchpad/slovnik.py, ručně needitovat */
  vykonTymu: {
    aktivita: {
      aria: '{metrika} za posledných {tydnu} týždňov: odškrtnuté spolu {soucet}, týždenný cieľ {cil}, pod cieľom {pod} z {ukoncenych} ukončených týždňov.',
      ariaBezCile: '{metrika} za posledných {tydnu} týždňov: odškrtnuté spolu {soucet}, týždenný cieľ nie je nastavený.',
      ariaCast: '{metrika} za posledných {tydnu} týždňov: odškrtnuté spolu {soucet}. Týždenný cieľ má len {s} z {celkem} ľudí, plnenie tímu preto nehodnotíme.',
      ariaNovyCil: '{metrika} za posledných {tydnu} týždňov: odškrtnuté spolu {soucet}, týždenný cieľ {cil}, zatiaľ žiadny ukončený týždeň s cieľom.',
      cil: 'cieľ {n}',
      cilCast: 'cieľ má len {s} z {celkem} ľudí, tímový cieľ nekreslíme',
      cilDrive: 'predtým cieľ {n}',
      hovory: 'Hovory',
      nadpis: 'Aktivita po týždňoch',
      neodskrtnuto: 'Neodškrtnuté v diári, do stĺpca ani cieľa sa nepočítajú: {n}',
      prazdno: 'Za posledných {tydnu} týždňov nie je pri klientoch odškrtnutý žiadny hovor ani stretnutie.',
      probiha: 'prebieha',
      radekZalohy: '{datum}: {n}',
      schuzky: 'Stretnutia',
      typNeznamy: 'Bez typu, nezapočítané: {n}',
    },
    bezJmena: 'Bez mena',
    cil: {
      chyba: 'Cieľ sa nepodarilo uložiť.',
      hodnoty: 'Hovorov týždenne: {hovory} · stretnutí týždenne: {schuzky}',
      hovory: 'Hovorov týždenne',
      jenPrimy: 'Cieľ nastavuje priamy manažér.',
      nadpis: 'Týždenný cieľ aktivít',
      nastavil: 'Nastavil {jmeno}, {datum}',
      neplatny: 'Zadaj celé číslo od 0 do 200.',
      prazdne: 'Prázdne pole znamená bez cieľa.',
      schuzky: 'Stretnutí týždenne',
      ukladam: 'Ukladám…',
      ulozeno: 'Týždenný cieľ uložený.',
      ulozit: 'Uložiť cieľ',
      zpet: 'Späť',
      zrusit: 'Zrušiť cieľ',
      zrusitPotvrdit: 'Naozaj zrušiť týždenný cieľ?',
    },
    detail: {
      chyba: 'Výkon poradcu sa nepodarilo načítať.',
      hlubsi: 'Klientov a obchody otvorí jeho priamy manažér.',
      koucink: 'Koučing',
      nacitam: 'Načítavam výkon poradcu…',
      nadpis: 'Výkon: {jmeno}',
      pipelineObchody: 'Klienti a obchody',
      zavrit: 'Zavrieť',
    },
    drobecky: {
      aria: 'Poschodia tímu',
      ja: 'Ja',
      zpet: 'Späť na môj tím',
    },
    faze: {
      a1: 'Predstavenie',
      a2: 'Analýza',
      p1: 'Finančný plán',
      p2: 'Prezentácia',
      volani: 'Volanie',
    },
    informace: {
      odpojeni: 'Odpojiť ťa môže len manažér — v Mojom tíme ťa odoberie. Sám sa odpojiť nedá.',
      potvrzeno: 'Tvoj manažér aj manažéri nad ním vidia tvojich klientov, pipeline, ciele a výkon (hovory a stretnutia s klientmi po týždňoch). Súkromné položky v diári nikdy, celý diár len s tvojím súhlasom. Manažér ti môže nastaviť týždenný cieľ hovorov a stretnutí.',
      pozvat: 'Zadaj jeho email. Vytvorí sa pozvánka, ktorú musí sám prijať v Nastaveniach — až potom uvidíš jeho klientov, obchody, ciele a výkon (hovory a stretnutia s klientmi po týždňoch). Celý diár len s jeho súhlasom, súkromné položky nikdy. E-mail neposielame, odkaz mu pošli sám.',
      prijeti: 'Prijatím uvidí tvoj manažér aj manažéri nad ním tvojich klientov, pipeline, ciele a výkon: koľko hovorov a stretnutí s klientmi máš týždenne a kedy si bol s klientom naposledy v kontakte. Súkromné položky v diári nikdy, celý diár len s tvojím súhlasom.',
      rozumim: 'Rozumiem',
      vzdy: 'Bez ohľadu na túto voľbu vidí manažér výkon: koľko hovorov a stretnutí s klientmi máš týždenne a kedy si bol s klientom naposledy v kontakte. Bez názvov, časov a miest. Súkromné položky nikdy.',
      zvonecek: 'Tvoj manažér aj manažéri nad ním vidia tvojich klientov, pipeline, ciele a výkon: koľko hovorov a stretnutí s klientmi máš týždenne a kedy si bol s klientom naposledy v kontakte. Súkromné položky v diári nikdy, celý diár len s tvojím súhlasom.',
      zvonecekNadpis: 'Čo vidí tvoj manažér',
    },
    kontrola: {
      dniBezFew: '{n} dni bez zapísanej aktivity',
      dniBezMany: '{n} dní bez zapísanej aktivity',
      dniBezOne: '{n} deň bez zapísanej aktivity',
      krokAno: 'Naplánovaný',
      krokNe: 'Chýba',
      krokPoTerminu: 'Po termíne',
      mene: 'Zobraziť menej',
      nadpis: 'Na kontrolu',
      nicZaOkno: 'Nič za posledných {dni} dní',
      nicZapsano: 'Nič zapísané',
      oriznuto: 'Ukazujeme {zobrazeno} z {celkem}.',
      popis: 'Klienti v aktivite, pri ktorých {prah} a viac dní nie je zapísaná žiadna aktivita.',
      prazdno: 'Nikto nečaká dlhšie ako {prah} dní.',
      sloupecFaze: 'Fáza',
      sloupecKlient: 'Klient',
      sloupecKrok: 'Ďalší krok',
      sloupecPoradce: 'Poradca',
      sloupecPosledni: 'Posledná zapísaná aktivita',
      sloupecVeFazi: 'Vo fáze',
      veFaziFew: '{n} dni',
      veFaziMany: '{n} dní',
      veFaziNevime: 'sledujeme od {datum}',
      veFaziOne: '{n} deň',
      vice: 'Zobraziť všetkých {n}',
    },
    kpi: {
      bezKroku: 'Bez ďalšieho kroku',
      bezKrokuPod: 'klienti v aktivite bez naplánovanej aktivity',
      pipelineBj: 'Pipeline BJ',
      pipelineBjPod: 'Predstavenie až Prezentácia',
      schuzkyTyden: 'Stretnutia tento týždeň',
      schuzkyTydenPod: 's klientmi, odškrtnuté v diári',
      vAktivite: 'Klienti v aktivite',
      vAktivitePod: 'Volanie až Prezentácia',
    },
    nadpis: 'Výkon tímu',
    pipeline: {
      aria: 'Pipeline po poradcoch: najviac klientov v aktivite má {jmeno} ({pocet}).',
      detail: 'Detail',
      klientuFew: '{n} klienti',
      klientuMany: '{n} klientov',
      klientuOne: '{n} klient',
      nadpis: 'Pipeline po poradcoch',
      prazdny: 'Žiadny klient v aktivite',
      radekAria: '{jmeno}: klienti v aktivite {pocet}, pipeline {bj} BJ. {rozpad}',
      segment: '{faze} {pocet}',
      tym: 'Tím · {pocet}',
    },
    poznamka: {
      kratce: 'Len zapísané pracovné aktivity.',
      cyklus: 'V tíme je kruh vzťahov, každého ukazujeme len raz.',
      faze: 'Od {datum} sledujeme prechody medzi fázami.',
      hloubka: 'Tím je hlbší ako 5 poschodí, hlbšie poschodia nezobrazujeme.',
      oriznuto: 'Dát je viac, než dokážeme naraz spočítať, čísla sú spodný odhad.',
      patra: 'Čísla hore sú za celý tím vrátane poschodí pod ním, riadky poradcov za ich vlastných klientov.',
      zdroj: 'Počítame len pracovné aktivity zapísané pri klientovi v diári a v časovej osi klienta. Hovory, stretnutia a plnenie cieľa len odškrtnuté ako hotové. Súkromné položky nikdy. Čo poradca nezapísal, nevidíme, a to ešte neznamená, že nepracuje.',
    },
    stav: {
      bezCile: 'Cieľ nenastavený',
      chyba: 'Hlboko pod cieľom',
      minulyChyba: 'Minulý týždeň: hlboko pod cieľom',
      minulyOk: 'Minulý týždeň: cieľ splnený',
      minulyPozor: 'Minulý týždeň: pod cieľom',
      ok: 'Plní týždenný cieľ',
      pozor: 'Pod cieľom',
    },
    stavy: {
      bezPristupu: 'K tomuto tímu už nemáš prístup.',
      chyba: 'Výkon tímu sa nepodarilo načítať.',
      nacitam: 'Načítavam výkon tímu…',
      nedostupne: 'Výkon tímu sa zapne po aktualizácii servera.',
      prazdnyTym: 'Priamo pod Vami zatiaľ nikto nie je — rebríček nižšie ukazuje celú sieť.',
      vrcholy: 'Tímy v systéme',
      vrcholyPopis: 'Vyber tím, ktorý chceš zobraziť.',
      znovu: 'Skúsiť znova',
    },
    zebricek: {
      jenObsazenost: 'Diár zdieľa len obsadenosť — stretnutia u klientov z neho nespoznáme.',
    },
  },
  /* BLOK:vykonTymu END */
  /* BLOK:pruvodce START — generuje scratchpad/slovnik.py, ručně needitovat */
  pruvodce: {
    akce: {
      domluvitTermin: 'Dohodnúť termín',
      jeToSpravne: 'Je to správne',
      kinoRizik: 'Pustiť Kino rizík',
      nemaMajetek: 'Bez majetku',
      nemaZavazky: 'Bez záväzkov a poistiek',
      opraveno: 'Opravené na {hodnota}',
      opravit: 'Opraviť na {hodnota}',
      oznaceno: 'Označené ako správne',
      prejit: 'Prejsť',
      prejitNezbytne: 'Prejsť na nevyhnutné',
      prejitObvykle: 'Prejsť na obvyklé',
      prejitPrijmy: 'Prejsť na príjmy',
      prejitVydaje: 'Prejsť na výdavky',
      prohodit: 'Prehodiť',
      prohozeno: 'Prehodené',
      vratit: 'Vrátiť',
    },
    brana: {
      dalsi: 'a ďalšie {n}',
      duvod: {
        dalsiSchuzka: 'Doplníme na ďalšom stretnutí',
        jiny: 'Iný dôvod',
        nechce: 'Na želanie klienta bez údaja',
        podklady: 'Klient dodá podklady',
      },
      min: {
        cil: 'Cieľ so sumou a termínom',
        osoby: 'Osoby a dátumy narodenia',
        prijmy: 'Príjmy',
        vydaje: 'Výdavky',
      },
      minimum: 'Povinné minimum',
      minimumSplneno: 'Povinné minimum splnené',
      nadpis: 'Pripravené na plán?',
      planOrientacni: 'Plán je orientačný — chýba:',
      podezrele: 'Podozrivé čísla',
      pokracovat: 'Pokračovať do plánu',
      poradiNezapsano: 'Súhlas s poradím cieľov: nezapísaný',
      poradiZapsano: 'Súhlas s poradím cieľov: zapísaný {datum}',
      pozdeji: 'Chýba, ale dá sa pokračovať',
      poznamka: 'Poznámka (nepovinné)',
      proc: 'Prečo pokračujete? (nepovinné)',
      slozka: 'Pre zložku klienta: {n}',
      zaznamy: 'Záznamy zo stretnutia',
      zbyvaFew: 'Chýbajú {n} veci — plán sa vypočíta, ale čísla budú orientačné. Doplňte ich, keď budete môcť.',
      zbyvaMany: 'Chýba {n} vecí — plán sa vypočíta, ale čísla budú orientačné. Doplňte ich, keď budete môcť.',
      zbyvaOne: 'Chýba {n} vec — plán sa vypočíta, ale čísla budú orientačné. Doplňte ju, keď budete môcť.',
      zbyvaSeznamFew: 'Ešte {n} veci: {seznam}',
      zbyvaSeznamMany: 'Ešte {n} vecí: {seznam}',
      zbyvaSeznamOne: 'Ešte {n} vec: {seznam}',
      zpet: 'Späť do analýzy',
    },
    chybi: {
      castka: 'suma',
      cil: '{nazev}: {co}',
      cilBezNazvu: 'Cieľ bez názvu',
      diteKCili: 'Cieľ pre deti, ale žiadne dieťa',
      dodaPozdeji: '{smlouva}: klient dodá',
      doplnRizika: 'Doplňte riziká: {smlouva}',
      jmenoK1: 'Meno a priezvisko klienta',
      komuPatri: 'Komu patria riziká: {smlouva}',
      narozeniDite: 'Dátum narodenia dieťaťa {jmeno}',
      narozeniK1: 'Dátum narodenia klienta',
      narozeniPartner: 'Dátum narodenia partnera — bez neho poistenie partnera nespočítame',
      nezbytne: 'Nevyhnutné výdavky',
      prazdneDite: 'Prázdny riadok dieťaťa',
      prijemBezOsoby: 'Príjem 2. osoby bez osoby',
      smlouva: 'Zmluva',
      termin: 'termín',
      titul: 'Chýba:',
    },
    jednotka: {
      letFew: '{n} roky',
      letMany: '{n} rokov',
      letOne: '{n} rok',
    },
    kontrola: {
      V1: {
        hlaska: 'Výdavky {V} sú viac ako 5× príjmy {P}.',
        hlaskaBezOpravy: 'Výdavky {V} sú viac ako 5× príjmy {P}. Sedia obe čísla?',
        kratce: 'Výdavky vysoko nad príjmami',
        otazka: 'Koľko vás stojí bežný mesiac, bez splátok?',
      },
      V10: {
        hlaska: 'Dátum narodenia {datum} je v budúcnosti.',
        kratce: 'Narodenie v budúcnosti',
        otazka: 'Môžete mi zopakovať dátum narodenia?',
      },
      V11: {
        hlaska: 'Vychádza vek {n}. Sedí rok narodenia?',
        kratce: 'Vek nesedí',
        otazka: 'Môžete mi zopakovať dátum narodenia?',
      },
      V12: {
        hlaska: 'Dátum narodenia dieťaťa {datum} nesedí k rodičom.',
        kratce: 'Dieťa staršie ako rodič',
        otazka: 'Aký je dátum narodenia dieťaťa?',
      },
      V13: {
        hlaska: 'Z príjmov zostáva {Z}, odkladáte {X}. Sedia výdavky?',
        kratce: 'Nevysvetlený zvyšok',
        otazka: 'Kam idú peniaze, ktoré zostanú?',
      },
      V14: {
        hlaska: 'Výdavky {V} sú viac ako 2,5× príjmy {P}. Sedia obe čísla?',
        kratce: 'Výdavky nad príjmami',
        otazka: 'Koľko vás stojí bežný mesiac, bez splátok?',
      },
      V15: {
        hlaska: 'Výdavky {V} sú len {x} % príjmov {P}. Sedia výdavky?',
        kratce: 'Výdavky hlboko pod príjmami',
        otazka: 'Koľko vás stojí bežný mesiac, bez splátok?',
      },
      V2: {
        hlaska: 'Nevyhnutné výdavky {N} sú vyššie ako obvyklé {V}.',
        hlaskaBezOpravy: 'Nevyhnutné výdavky {N} sú vyššie ako obvyklé {V}. Sedia obe čísla?',
        hlaskaObvykle: 'Obvyklé výdavky {V} sú nižšie ako nevyhnutné {N}.',
        kratce: 'Nevyhnutné výdavky nad obvyklými',
        otazka: 'Koľko by ste mesačne nutne potrebovali, keby ste museli šetriť?',
      },
      V3: {
        hlaska: 'Príjem {X} je viac ako 10× výdavky {V}.',
        hlaskaBezOpravy: 'Príjem {X} je viac ako 10× výdavky {V}. Nie je to za rok? Mesačne {mesicne}.',
        hlaskaNejiste: 'Príjem {X} je viac ako 10× výdavky {V}. Sedia obe čísla?',
        kratce: 'Príjem asi za rok',
        otazka: 'Je to čistý príjem za mesiac, alebo za rok?',
      },
      V4: {
        hlaska: 'Odsúhlasený prebytok {X} je vyšší ako príjmy {P}.',
        hlaskaBezOpravy: 'Odsúhlasený prebytok {X} je vyšší ako príjmy {P}. Sedí prebytok?',
        kratce: 'Prebytok nad príjmami',
        otazka: 'Koľko môžete mesačne odkladať bez toho, aby vás to obmedzilo?',
      },
      V5: {
        hlaska: 'Termín {roky} rokov vyzerá ako letopočet.',
        hlaskaBezOpravy: 'Termín {roky} rokov vyzerá ako letopočet. Za koľko rokov to je?',
        kratce: 'Termín zapísaný ako rok',
        otazka: 'Za koľko rokov to chcete mať?',
      },
      V6: {
        hlaska: 'Renta {X} mesačne je viac ako 20× príjem. Nie je to celková suma?',
        kratce: 'Renta vyzerá ako kapitál',
        otazka: 'Koľko by ste chceli mesačne dostávať?',
      },
      V7: {
        hlaska: 'Úrok {u} % vyzerá ako desatinné číslo.',
        hlaskaBezOpravy: 'Úrok {u} % je nezvyčajne nízky. Sedí?',
        kratce: 'Úrok ako desatinné číslo',
        otazka: 'Aký úrok máte v zmluve?',
      },
      V8: {
        hlaska: 'Úrok {u} % pri úvere na bývanie je nezvyčajne vysoký.',
        hlaskaBezOpravy: 'Úrok {u} % pri úvere na bývanie je nezvyčajne vysoký. Sedí?',
        kratce: 'Vysoký úrok pri bývaní',
        otazka: 'Aký úrok máte v zmluve?',
      },
      V9: {
        hlaska: 'Splátka {s} je viac ako 20× zostatok {j}.',
        hlaskaBezOpravy: 'Splátka {s} je viac ako 20× zostatok {j}. Nie sú prehodené?',
        kratce: 'Splátka a zostatok prehodené',
        otazka: 'Koľko vám zostáva doplatiť a koľko platíte mesačne?',
      },
    },
    kratce: {
      bezNazvu: 'Bez názvu',
      cislo: 'číslo zmluvy',
      instituce: 'inštitúcia',
      investiceUdaje: '{nazev}: {co}',
      menaDatum: '{nazev}: dátum kurzu {mena}',
      menaKurz: '{nazev}: kurz {mena}',
      menaStary: '{nazev}: starý kurz {mena}',
      nemovitostPojisteni: '{nazev}: poistenie nehnuteľnosti',
      obe: 'inštitúcia a číslo zmluvy',
      obecne: 'Doplniť údaj',
      vozidloPojistka: '{nazev}: povinné zmluvné poistenie',
      vozidloVyroci: '{nazev}: výročie poistenia',
      zavazekCisla: '{nazev}: zostatok a splátka',
    },
    krok: {
      cile: 'Ciele',
      hodnoty: 'Očakávania a hodnoty',
      majetek: 'Majetok',
      predstaveni: 'Čas',
      prijmy: 'Príjmy a výdavky',
      rizika: 'Riziká',
      rodina: 'Rodina',
      zavazky: 'Záväzky',
      zaver: 'Záver',
    },
    nav: 'Kroky analýzy',
    otazka: {
      prepinac: 'Otázky pre klienta',
      skryt: 'Skryť otázky',
      titul: 'Otázka pre klienta',
      zobrazit: 'Zobraziť otázky',
    },
    otevrit: 'Zobraziť kroky analýzy',
    souhrn: '{hotovo} z {celkem} hotovo',
    stav: {
      chybiFew: 'chýba {n}',
      chybiMany: 'chýba {n}',
      chybiOne: 'chýba {n}',
      hotovo: 'hotovo',
      keKontroleFew: '{n} na kontrolu',
      keKontroleMany: '{n} na kontrolu',
      keKontroleOne: '{n} na kontrolu',
      nezacato: 'nezačaté',
    },
    zde: 'ste tu',
  },
  /* BLOK:pruvodce END */
  /* VÝSTUP PLÁNU PRO KLIENTA (25. 10. 2026, N1) — viz cs.js */
  planVystup: {
    financniPlan: 'Finančný plán',
    obsah: 'Obsah',
    upozorneniNadpis: 'Dôležité upozornenia',
    upozorneni1: 'Tento finančný plán analyzuje Vaše úspory a investície, upresňuje Vaše finančné ciele a navrhuje cestu k ich dosiahnutiu s ohľadom na Vašu toleranciu k riziku.',
    upozorneni2: 'Všetky odporúčania vychádzajú z údajov, ktoré ste nám poskytli. Kalkulácie výkonnosti investícií slúžia len na ilustráciu — minulá výkonnosť nezaručuje budúcu.',
    upozorneni3: 'Plán je zostavený z údajov známych k dátumu vytvorenia a je potrebné ho pravidelne aktualizovať, najmä keď sa zmenia okolnosti, za ktorých vznikol.',
    upozorneni4: 'Konečné rozhodnutie o realizácii odporúčaní je vždy len Vaše. Transakcie môžu mať daňové dôsledky — odporúčame ich prebrať s daňovým poradcom.',
    bezZmenNadpis: 'Splnenie Vašich cieľov, ak nič nezmeníte',
    bezZmenPopis: 'Na koľko percent dnes pokryjú Vaše ciele peniaze, ktoré už máte — bez nových vkladov. Cieľ má byť na 100 %.',
    bezZmenCoUkazuje: 'Graf ukazuje: 1. ako máte naplnenú likvidnú rezervu na neočakávané situácie, 2. na koľko percent zafinancujete strategické ciele, ktoré sa obstarávajú za peniaze, 3. na koľko percent dosiahnete požadovanú životnú úroveň od okamihu, keď chcete byť finančne nezávislí.',
    vychazimeNadpis: 'V pláne vychádzame z nasledujúcich informácií',
    vychazimePopis: 'Rovnako ako v iných oblastiach života je aj v osobných financiách dôležité vedieť prečo. Preto najprv Vaše hodnoty a veľké strategické ciele — len s nimi dáva každý krok plánu zmysel.',
    cileNadpis: 'Vaše strategické ciele, ktoré sa obstarávajú za peniaze',
    popisCile: 'Popis cieľa',
    majetek: 'Majetok',
    hodnota: 'Hodnota',
    cisteJmeni: 'Čisté imanie (majetok − dlhy)',
    rozpisNadpis: 'Detailný rozpis príjmov a výdavkov',
    prijmy: 'Príjmy',
    vydaje: 'Výdavky',
    rocniCastka: 'Ročná suma',
    mesicniPrumer: 'Mesačný priemer',
    procentoZCelku: 'Percento z celku',
    procentoZPrijmu: 'Percento z príjmov',
    cistyPrijem: 'Čistý príjem — {jmeno}',
    ostatniPrijem: 'Ostatné príjmy — {jmeno}',
    pasivniPrijem: 'Pasívne príjmy (nájom, výnosy)',
    bonusy: 'Bonusy a odmeny (ročne ÷ 12)',
    vydajeCelkem: 'Výdavky a splátky spolu',
    prebytekDeficit: 'Prebytok / deficit',
    mesicne: 'mesačne',
    zajisteniNadpis: 'Poistenie — zabezpečenie potrieb v prípade nečakanej udalosti',
    investiceNadpis: 'Investície — v spojení so zabezpečením osobných cieľov',
    alokaceSouhrn: 'Alokácia portfólia — súhrn',
    tridaAktiv: 'Trieda aktív',
    aktualne: 'Aktuálne',
    zmena: 'Zmena',
    doporuceno: 'Odporúčané',
    celkem: 'Spolu',
    nezarazeno: 'Nezaradené (dôchodkové, poistné a alternatívne produkty)',
    nezarazenoPozn: 'Percentá troch tried sa počítajú len z peňažného trhu, dlhopisov a akcií. Nezaradené produkty plán rieši pri jednotlivých cieľoch podľa toho, kedy sú peniaze dostupné.',
    alokaceDleCilu: 'Alokácia podľa cieľov',
    alokaceDleCiluPopis: 'Strategické rozloženie prostriedkov priradených jednotlivým cieľom podľa ich horizontu. Súčet riadkov je rozloženie celého plánu; nezohľadňuje likviditu produktov ani ich momentálne ocenenie na trhu.',
    penezniTrh: 'Peňažný trh',
    penezniTrhKratce: 'Peňažný',
    dluhopisy: 'Dlhopisy',
    akcie: 'Akcie',
    zdrojeCilu: 'Z čoho sa ciele platia',
    zdrojeCiluPopis: 'Ktoré účty a produkty plán priraďuje ktorému cieľu a koľko sa naň mesačne odkladá. Jednorazový vklad = peniaze, ktoré treba na cieľ ešte len vložiť.',
    dumNadpis: 'Váš plán na jednom obrázku',
    dumPopis: 'Základy (rezerva a zabezpečenie) nesú poschodia s vašimi cieľmi zoradenými podľa termínu, hore je finančná nezávislosť. Zelená = koľko z cieľa plán po realizácii pokryje.',
    dumAria: 'Dom plánu: {pointa}.',
    dumZaklady: 'Základy',
    dumRezerva: 'Rezerva {castka}',
    dumRezervaRadek: 'Rezerva',
    dumRenta: 'renta {castka}',
    dumVlastniZdroje: 'z toho vlastné zdroje {castka}',
    dumZajisteniVse: 'zabezpečenie podľa návrhu: kryté',
    dumZajisteniChybi: 'zabezpečenie chýba: {seznam}',
    dumZajisteniChybiVeta: 'Zabezpečenie podľa návrhu zatiaľ nekryje: {seznam}.',
    dumZdrojMajetek: 'Majetok · jednorazovo',
    dumZdrojPrebytek: 'Prebytok · mesačne',
    dumZbyva: 'zostáva {castka}',
    dumPrecerpano: 'prečerpané o {castka}',
    dumLegMate: 'máte / splnené',
    dumLegChybi: 'chýba',
    dumLegNezname: 'nedá sa vypočítať',
    dumLegTok: 'tok peňazí z majetku a prebytku',
    dumLegVyska: 'výška poschodia podľa sumy, vyššie = neskôr',
    dumHotoveNadpis: 'Čo je hotové',
    dumHotove: 'Po realizácii plán pokryje celé: {seznam}.',
    dumHotoveNic: 'Zatiaľ plán nepokryje celý žiadny cieľ.',
    dumVolne: 'Voľných zostáva {castka}.',
    dumChybiNadpis: 'Čo chýba',
    dumChybi: 'Plán zatiaľ nepokryje celé: {seznam}.',
    dumChybiNic: 'Nič, plán po realizácii pokryje všetky ciele.',
    dumNezname: 'Nedá sa vypočítať: {seznam}.',
    dumKrokNadpis: 'Ďalší krok',
    dumKrokRealizace: 'Zrealizovať plán: z dnešného majetku {jednorazove} jednorazovo a z prebytku {mesicne} na ciele.',
    dumKrokCil: 'Potom pri cieli {nazev} ({pct}) upraviť sumu, termín alebo mesačný vklad, aby ho plán pokryl celý.',
    dumKrokPrecerpano: 'Plán berie viac peňazí, než je k dispozícii (prečerpané o {castka}). Znížte niektorý cieľ alebo posuňte termín.',
    dumCil: 'Cieľ',
    dumKdy: 'Kedy',
    dumCastka: 'Suma',
    dumJednorazove: 'Jednorazovo',
    dumMesicne: 'Mesačne',
    dumSplneno: 'Splnené',
    tokyJednorazove: 'Tok peňazí: jednorazovo z majetku',
    tokyMesicne: 'Tok peňazí: mesačne z prebytku',
    tokyAria: '{druh}: {seznam}.',
    pravidelneMesicne: 'pravidelná investícia',
    pritok: 'budúci prítok',
    diverzifikace: 'Diverzifikácia',
    diverzifikacePopis: 'Čím z viacerých uhlov pohľadu je portfólio rozložené (meny, správcovia, emitenti), tým lepšie je chránené pred jedným zlyhaním. Metodika: najviac 5 % majetku u jedného korporátneho emitenta.',
    menyChip: 'Meny: {pocet} ({meny}) · domáca mena {pct} %',
    spravciChip: 'Inštitúcie a správcovia: {pocet} · najväčší {nazev} {pct} %',
    emitentChip: 'Nad {limit} % u jedného emitenta: {polozky}',
    zrealizujeteNadpis: 'Splnenie Vašich cieľov, ak naše odporúčania zrealizujete',
    zrealizujetePopis: 'Vľavo stav dnes, vpravo po realizácii plánu. Cieľ má byť na 100 %.',
    vyvojNadpis: 'Analýza majetku a cash flow rok po roku',
    vyvojPopis: 'Portfólio na finančnú nezávislosť podľa plánu: koľko bude spolu vložené a akú hodnotu bude mať (v dnešných cenách, podľa očakávaného výnosu zvolenej alokácie).',
    rok: 'Rok',
    vlozenoCelkem: 'Vložené spolu',
    hodnotaPortfolia: 'Hodnota portfólia',
    podilCile: 'Podiel z cieľa',
    vyvojPozn: 'Výsledky sú orientačné a nemožno ich považovať za prísľub budúcnosti.',
    vypisNadpis: 'Výpis majetku',
    vypisPopis: 'štruktúra majetku k dátumu plánu — podľa tried aktív, mien a inštitúcií',
    majetekCelkem: 'Majetok spolu',
    financniAktiva: 'Finančné aktíva',
    nefinancniMajetek: 'Nefinančný majetok',
    dluhy: 'Dlhy',
    podleTrid: 'Podľa tried aktív',
    podleMen: 'Podľa mien',
    podleInstituci: 'Podľa inštitúcií a správcov (finančné aktíva)',
    pokracovani: 'pokračovanie',
    ostatni: 'ostatné',
    krytoZdroji: 'kryté zdrojmi',
    neuvedeno: 'inštitúcia neuvedená',
    nezapocteno: 'Nezapočítané — chýba platný kurz: {polozky}',
    polozky: 'Položky',
    polozka: 'Položka',
    instituce: 'Inštitúcia',
    cilovaAlokace: 'Cieľová alokácia × súčasná (finančné aktíva)',
    rozdil: 'Rozdiel',
    tridaPenezni: 'Peňažný trh (účty, sporenie)',
    tridaDluhopisy: 'Dlhopisy',
    tridaAkcie: 'Akcie',
    tridaAlternativni: 'Alternatívne a ostatné investície',
    tridaPenzijni: 'Dôchodkové produkty',
    tridaPojisteni: 'Životné poistenie s hodnotou',
    tridaNemovitosti: 'Nehnuteľnosti, auto, cennosti',
    tridaFirma: 'Firma / podnikanie',
    vytvoreno: 'Vytvorené',
    strana: 'Strana',
  },
  /* BLOK:navrhV2 START — Návrh řešení v 9 krocích (15. 10. 2026). Zdroj: lib/navrh/texty/*.js,
     shodu hlídá lib/navrh/__tests__/slovnikNavrhV2.test.js — needitovat ručně, upravit text v lib/navrh/texty. */
  navrhV2: {
    dilna: {
      titul: 'Dielňa',
      podtitul: 'pracovný stôl poradcu · klient ju nevidí',
      sekce: {
        pripraveno: 'Pripravené pre klienta?',
        penize: 'Rozdelenie peňazí',
        penizePod: 'predtým Tabuľka / Zhrnutie',
        texty: 'Texty pre klienta',
        textyPod: 'návrh systému, kým nenapíšete vlastný',
        produkty: 'Alokácia, poplatky a produkty',
        nastaveni: 'Nastavenie výpočtu a metodika',
        poznamka: 'Poznámka a dávky',
      },
      znacka: {
        chyba: 'chyba',
        pozor: 'pozor',
        info: 'chýba podklad',
      },
      pripraveno: {
        vecOne: '{n} vec',
        vecFew: '{n} veci',
        vecMany: '{n} vecí',
        nicNeblokujeKratce: 'nič neblokuje',
        blokujeKratce: 'blokuje prezentáciu',
        vsePripraveno: 'všetko pripravené',
        blokujeNadpis: 'Blokuje prezentáciu',
        chybiNadpis: 'Chýba, ale dá sa pokračovať',
        tiskNadpis: 'Pre tlačený plán',
        nicNeblokuje: 'Nič neblokuje — príjmy aj plán sú spočítané podľa aktuálnej metodiky',
        nicNeblokujePostaru: 'Nič neblokuje — príjmy sú zadané, plán je zatiaľ spočítaný postaru',
        nicNechybi: 'Nič nechýba.',
        prejit: 'Prejsť',
        doplnitVAnalyze: 'Doplniť v analýze',
        otevrit: 'Otvoriť',
      },
      polozka: {
        prijemPrijmy: 'Chýbajú príjmy — bez nich plán nespočíta',
        prijemNula: 'Prebytok je nula — plán nemá čo rozdeliť',
        cenaOchrany: 'Cena ochrany pre variantu {varianta} chýba — krok 8 aj Pred a po sú zatiaľ bez ceny',
        cenaOchranyCast: 'Cena ochrany pre variantu {varianta} je zadaná len pri časti osôb',
        majetekOne: 'Majetok a zodpovednosť: {n} zmluva čaká na cenu poisťovne',
        majetekFew: 'Majetok a zodpovednosť: {n} zmluvy čakajú na cenu poisťovne',
        majetekMany: 'Majetok a zodpovednosť: {n} zmlúv čaká na cenu poisťovne',
        majetekOverit: 'Majetok a zodpovednosť: obsah zmluvy sa od zadania ceny zmenil — overte cenu (zmlúv: {n})',
        uverDnes: 'Úver dnes ({nazev}): chýba {co}',
        coUrok: 'úrok',
        coKonec: 'koniec splácania',
        coOba: 'úrok a koniec splácania',
        bydleni: '{nazev}: financovanie {pct} % je zatiaľ len návrh systému — vyberte ho s klientom',
        bydleniBezPct: '{nazev}: financovanie je zatiaľ len návrh systému — vyberte ho s klientom',
        schodek: 'Schodok po čerpaní úverov: {kroky} mesačne',
        schodekKrok: 'od {rok} {castka}',
        partner: '{jmeno}: chýba dátum narodenia — zabezpečenie sa nespočíta',
        staryPlan: 'Plán je spočítaný postaru (metodika {datum}) — prepočet je v Nastavení výpočtu',
        nadPrebytek: 'Plán chce z prebytku {plan}, prebytok je {prebytek} — mesačne chýba {chybi}. Upravte sumy v Rozdelení peňazí',
        rezervaDosporit: 'Rezerva bude s plánom len na {pct} % — z prebytku sa dá dosporiť {castkaMes} mesačne počas {mesicu} mes. (krok 4)',
        rezerva: 'Rezerva bude s plánom len na {pct} % — na dosporenie nie je voľný prebytok',
        cilBezCastky: 'Cieľ „{nazev}“ nemá sumu — plán ho nepočíta',
        cilBezTerminu: 'Cieľ „{nazev}“ nemá termín — plán naň nesporí',
        cilBezObojiho: 'Cieľ „{nazev}“ nemá sumu ani termín — plán ho nepočíta',
        zivotPod20: 'Na voľné výdavky zostane len {pct} % príjmu ({castka} mesačne) — odporúčame 20 až 30 %. Klient to uvidí v kroku 8',
      },
      tisk: {
        produkty: 'Produkty',
        coKdyProc: 'Čo / Kedy / Prečo',
        poznamka: 'Poznámka k návrhu',
        starobni: 'Starobný dôchodok',
        navrhSystemu: 'návrh systému',
        upraveno: 'upravené poradcom',
        zadnyRadek: 'žiadny riadok',
        prazdna: 'prázdna',
        vyplnena: 'vyplnená',
        nezadano: 'nezadaný — do tlače sa nepíše',
        rucne: 'zadaný ručne',
        radkuOne: '{n} riadok',
        radkuFew: '{n} riadky',
        radkuMany: '{n} riadkov',
      },
      penize: {
        prebytek: 'Prebytok',
        naPlan: 'Na plán dnes',
        zbyva: 'Zostáva trvalo',
        presuny: 'Presuny z úspor',
        drziSplatka: 'dnes {castka}, potom ho drží splátka',
        odkud: 'Odkiaľ peniaze idú',
        kam: 'Kam',
        podlePlanu: 'podľa plánu',
        rozdelenoRucne: 'rozdelené ručne po sumách',
        zatimNikam: 'zatiaľ nikam',
        vLetech: 'v {vek} rokoch',
        zadneZdroje: 'Klient nemá úspory, ktoré by sa dali prideliť.',
        rust: 'Rast mzdy a prítoky',
        pritokyCile: 'Jednorazové prítoky k cieľom',
        tabulka: 'Tabuľka A4 naležato',
        tabulkaNeulozeno: 'Návrh sa nepodarilo uložiť — tabuľka by ukázala starú verziu.',
        prehled: 'Rozdelenie po cieľoch',
        sloupec: {
          cil: 'Cieľ',
          kdy: 'Kedy',
          kolik: 'Koľko',
          jednorazove: 'Jednorazovo',
          mesicne: 'Mesačne',
          dosazeno: 'Dosiahnuté',
        },
        plusKroky: '+ navýšenie v čase',
        rucne: 'Upraviť rozdelenie ručne',
        rucnePod: 'jednorazovo a mesačne po cieľoch, odkiaľ peniaze idú',
      },
      texty: {
        cile: 'Texty k cieľom',
        coKdyProc: 'Čo / Kedy / Prečo pre tlačený plán',
        co: 'Čo',
        kdy: 'Kedy',
        proc: 'Prečo',
        coPlaceholder: 'Čo odporúčame',
        pridatRadek: 'Pridať riadok',
        smazatRadek: 'Zmazať riadok',
        pojistky: 'Riešenie pri poistkách',
      },
      produkty: {
        alokace: 'Alokácia',
        alokaceZProfilu: 'Alokácia z profilu {profil}',
        alokaceRucne: 'Alokácia upravená ručne',
        akcie: 'Akcie',
        dluhopisy: 'Dlhopisy',
        hotovost: 'Hotovosť',
        upravitAlokaci: 'Upraviť alokáciu',
        hotovo: 'Hotovo',
        soucet: 'Súčet {pct} %',
        soucetSpatne: 'Súčet {pct} % — má byť 100 %',
        zpetNaProfil: 'Späť na profil',
        vstupni: 'Vstupný poplatok % ({min}–{max})',
        sprava: 'Správa % ročne ({min}–{max})',
        nezadano: 'nezadané',
        spravaVychozi: 'Prázdne pole = v grafoch predvolená správa {pct} %.',
        titul: 'Produkty',
        nazev: 'Názov produktu',
        castka: 'Suma',
        akce: 'Akcia',
        koupit: 'Kúpiť',
        prodat: 'Predať',
        ponechat: 'Ponechať',
        navysit: 'Navýšiť',
        pridat: 'Pridať produkt',
        smazat: 'Zmazať produkt',
        zadnyRadek: 'Zatiaľ žiadny riadok.',
        sjednat: 'Dojednať → Zmluva',
        sjednatPopis: 'Klient súhlasí? Produkty sa predvyplnia do zmluvy.',
      },
      nastaveni: {
        profil: 'Profil',
        scenar: 'Scenár',
        metodikaAktualni: 'Metodika {datum} — aktuálna, nič na prepočet.',
        metodikaBezZmen: 'Metodika {datum} — pri tomto klientovi nová metodika nič nemení.',
      },
      poznamka: {
        placeholder: 'Poznámka k riešeniu — vytlačí sa v plnom pláne',
        davky: 'Sociálne dávky pre tlačený plán',
        odhad: 'odhad z príjmu',
        rucne: 'zadané ručne',
        zpetNaOdhad: 'Späť na odhad',
        starobniNezadano: 'Starobný dôchodok: nezadaný — tlačený plán ho neuvedie.',
      },
    },
    kroky14: {
      krok1: {
        nadpis: 'Prečo to robíme',
        citace: '„{text}“',
        analyza: '{jmena}, analýza {datum}',
        spojka: 'a',
        cileAria: 'Vaše ciele',
        mesicneOd: '{castka} mesačne · od {rok}',
        vDnesnichCenach: 'v dnešných cenách',
        renta: 'Finančná nezávislosť',
        uverem: 'úverom',
        castkaNezadana: 'suma nezadaná',
        bezTerminu: 'bez termínu',
      },
      krok2: {
        nadpis: 'Kde ste dnes',
        majetek: 'Majetok',
        naUctech: 'Na účtoch',
        sporeni: 'Sporenie a investície',
        nemovitosti: 'Nehnuteľnosti',
        celkem: 'Spolu',
        dluhy: 'dlhy {castka}',
        bezDluhu: 'bez dlhov',
        ze100: 'Z každých 100 {sym} príjmu',
        dnes: 'Dnes',
        sPrebytkem: 'S prebytkom',
        prebytek: 'Prebytok {castka} mesačne',
        odsouhlaseny: 'odsúhlasený',
        nadVolne: '{castka} z neho uberieme z výdavkov na život (Život {a} → {b})',
        dobre: 'Čo robíte dobre',
        odklad: 'Odkladáte {pct} % príjmu ({castka}) · s prebytkom {pctPo} %',
        odkladJen: 'Odkladáte {pct} % príjmu ({castka})',
        rezerva: 'Rezerva je z {pct} % hotová',
        rezervaHotova: 'Rezervu máte hotovú',
        most: 'Keď {jmeno} nemôže pracovať, chýba rodine {castka} mesačne',
        mostJeden: 'Pri invalidite chýba {castka} mesačne',
        mostAkce: 'Zabezpečenie',
        detail: 'Zloženie majetku a úvery',
        budouci: 'Budúci majetok: {nazev}',
        uvery: 'Úvery dnes',
        zbyva: 'zostáva {castka}',
        splatka: 'splátka {castka}',
        hypoChybi: 'Pri hypotéke chýba úrok a koniec splácania — modelácia sa ukáže po doplnení.',
      },
      krok3: {
        nadpis: 'Zabezpečenie príjmu',
        rucniOne: '{n} ručná úprava',
        rucniFew: '{n} ručné úpravy',
        rucniMany: '{n} ručných úprav',
        vratitVse: 'Vrátiť všetko',
        invalidita: 'Najhoršie riziko je invalidita',
        dnes: 'Dnes',
        nemuze: '{jmeno} nemôže pracovať',
        nemuzeJeden: 'Keď nemôžete pracovať',
        duchod: 'invalidný dôchodok',
        potreba: 'potreba {castka}',
        chybi: 'Chýba {castka} mesačne',
        nicNechybi: 'Príjmy pokryjú potrebu, nič nechýba',
        prumer: 'invalidný dôchodok {castka} je priemer',
        aria: 'Dnes prichádza {dnes}. Keď {jmeno} nemôže pracovať, príde {prijde} a potreba je {potreba} mesačne.',
        ariaJeden: 'Dnes prichádza {dnes}. Keď nemôžete pracovať, príde {prijde} a potreba je {potreba} mesačne.',
        pojistka: 'Máte už nejakú poistku?',
        platba: '{castka} mesačne',
        platbaNezadana: 'platba nezadaná',
        predApo: 'Pred a po',
        veta: 'Keď {jmeno} príde o zdravie, rodina dostane {nove} namiesto {dnes}.',
        vetaJeden: 'Keď prídete o zdravie, dostanete {nove} namiesto {dnes}.',
        vetaNema: 'Keď {jmeno} príde o zdravie, rodina dostane {nove}. Dnes nič.',
        vetaNemaJeden: 'Keď prídete o zdravie, dostanete {nove}. Dnes nič.',
        vetaBez: 'Keď {jmeno} príde o zdravie, rodina dostane {nove}.',
        vetaBezJeden: 'Keď prídete o zdravie, dostanete {nove}.',
        dovetek: 'Novo = na začiatku, s rokmi klesá.',
        vetaCena: 'Platíte {dnes} mesačne, novo {nove}.',
        vetaCenaJen: 'Novo budete platiť {nove} mesačne.',
        dalsiRizika: 'Ďalšie riziká · {n}',
        pojistne: 'poistné {dnes} → {nove}',
        pojistneNove: 'poistné {nove}',
        rizikOne: '{n} riziko',
        rizikFew: '{n} riziká',
        rizikMany: '{n} rizík',
        dnesNezadano: 'dnes nezadané',
        jakSePocita: 'Ako sa počíta',
        nespocteno: '{jmeno}: nespočítané — chýba dátum narodenia',
        doplnit: 'Doplniť v analýze',
        varianty: 'Aké veľké krytie chcete?',
        invaliditaKoho: 'Invalidita · {jmeno}',
        invaliditaSloupec: 'Invalidita',
        variantaSloupec: 'Varianta',
        cena: 'Cena',
        cenaNezadana: 'cena zatiaľ nezadaná',
        mesicne: '{castka} mesačne',
        zvoleno: 'zvolené',
        ulozeno: 'Uložené: {nazev}',
        vratit: 'Vrátiť',
        coZnamenaji: 'Čo varianty znamenajú',
        majetek: 'Majetok a zodpovednosť',
        bezSmluvMajetku: 'Žiadna zmluva na majetok',
        vysvetlitMajetek: 'Vysvetliť majetok',
        upravitKryti: 'Upraviť sumy a voľby krytia',
      },
      krok4: {
        nadpis: 'Rezerva',
        cil: 'Cieľ {castka}',
        zakladOne: '{n} mesiac nevyhnutných výdavkov a splátok ({castka})',
        zakladFew: '{n} mesiace nevyhnutných výdavkov a splátok ({castka})',
        zakladMany: '{n} mesiacov nevyhnutných výdavkov a splátok ({castka})',
        mate: 'Máte',
        chybi: 'Chýba',
        zFondu: 'Doplníme z fondov',
        zaOne: 'o {n} mesiac',
        zaFew: 'o {n} mesiace',
        zaMany: 'o {n} mesiacov',
        kde: 'Na sporiacom účte alebo vo fonde peňažného trhu, nie v akciách.',
        hotova: 'Rezerva je hotová',
        aria: 'Rezerva dnes {dnes} %, s plánom {po} %',
        dnesPct: 'dnes {pct} %',
        poPct: 's plánom {pct} %',
        dosporitNabidka: 'Dosporiť {castka} mesačne počas {mesicu} mes.',
        dosporeni: 'Dosporíme z prebytku {castka} mesačne počas {mesicu} mes.',
        dosporitZrusit: 'Zrušiť dosporenie',
      },
      nezadano: 'nezadané',
    },
    kroky56: {
      k5: {
        nadpis: 'Vaše ciele',
        cipyAria: 'Vaše ciele v poradí rokov',
        uverem: 'úverom',
        renta: 'Renta',
        profilRadek: 'Profil: {profil} · {scenar} · s brzdou pred cieľom',
        zmenitVDilne: 'Zmeniť v Dielni',
        zadneCile: 'Okrem rezervy a renty nie sú v pláne ďalšie ciele.',
      },
      profil: {
        dynamicky: 'Dynamický',
        vyvazeny: 'Vyvážený',
        konzervativni: 'Konzervatívny',
      },
      karta: {
        castkaRok: '{castka} · {rok}',
        vek: '{jmeno} vo veku {vek} rokov',
        plneni: 'dnes {dnes} % → s plánom {po} %',
        sPlanem: 's plánom {po} %',
        mesicne: 'Mesačne',
        jednorazove: 'Jednorazovo',
        splatkaOd: 'Splátka od {rok}',
        bezPenez: 'Zatiaľ bez peňazí',
        chybi: 'chýba {castka}',
        modelove: 'Modelovo v {rok}',
        cil: 'Cieľ',
        splneno: 'splnené',
        chybiNadpis: 'Chýba',
        upravitCil: 'Upraviť sumu a rok cieľa',
        castkaPole: 'Suma cieľa',
        rokPole: 'Rok cieľa',
        pouzit: 'Použiť',
        zrusit: 'Zrušiť',
        vratit: 'Vrátiť hodnoty z analýzy',
        upraveno: 'upravené',
        detail: 'Detail',
        glideNadpis: 'Ako sa mení zloženie',
        prvni: 'Prvý rok',
        polovina: 'V polovici',
        posledni: 'Posledný rok',
        slozeni: 'akcie {akcie} % · dlhopisy {dluhopisy} % · hotovosť {cash} %',
        jakInvestovat: 'Ako investovať',
        jakInvestovatText: 'Podľa plánu, profil {profil}: pred cieľom sa akcie postupne predávajú, posledný rok je všetko v hotovosti.',
      },
      duvod: {
        splatka: 'Od {rok} zhltne celý prebytok splátka úveru „{popis}“ — mesačne sem nezostáva.',
        drivejsi: 'Prebytok dnes berú skoršie ciele.',
        bezTerminu: 'Cieľ zatiaľ nemá termín — plán naň nesporí.',
        jine: 'Plán sem zatiaľ nič nedáva.',
      },
      fin: {
        krok1: 'Ako kúpu zafinancujete',
        jakZaplatit: 'Ako zaplatíte',
        zaplatitSporenim: 'Nasporiť celé',
        zaplatitUverem: 'Úverom',
        krok2: 'Nasporiť vlastné zdroje',
        uver: 'Úver',
        hypoteka: 'Hypotéka',
        uverem100: '100 % úverom',
        hotove: 'V hotovosti',
        hotovePct: '{pct} %',
        produkt: 'Druh úveru',
        spotrebitelsky: 'Spotrebiteľský',
        stavebko: 'Zo stavebného sporenia',
        splatnost: 'Splatnosť',
        urokRocne: 'Úrok ročne',
        volba: 'Voľba',
        vlastniZdroje: 'Vlastné zdroje',
        mesicneDoKoupe: 'Mesačne do kúpy',
        splatka: 'Splátka',
        a10: '10 % vlastných',
        a20: '20 % vlastných',
        a30: '30 % vlastných',
        a100: '100 % zo stavebného sporenia',
        zastava: '100 % so záložným právom na nehnuteľnosť',
        duvodVek: 'len do 36 rokov · {jmeno} bude mať v roku {rok} {vek} rokov',
        duvodVekNbs: 'len prvé bývanie do 35 rokov · {jmeno} bude mať v roku {rok} {vek} rokov',
        duvodDo2026: 'pri kúpe do konca roka 2026 len 20 % vlastných zdrojov',
        duvodNemovitost: 'len prvé bývanie bez inej nehnuteľnosti',
        duvodK2: 'chýba dátum narodenia druhého žiadateľa',
        duvodVekNeznamy: 'chýba dátum narodenia',
        duvodNelze: 'túto voľbu plán nevie spočítať',
        a100Rozpis: 'hypotéka {hypo} + stavebné sporenie {stavebko}',
        zastavaRadek: 'záložné právo: {nazev} {castka}',
        zatizeni: 'overte zaťaženie — na nehnuteľnosti je hypotéka',
        hypoInfo: 'Hypotéka {sazba} % na {roky}',
        dalsiMoznosti: 'Ďalšie možnosti financovania',
        klientVolba: '{volba} · {uver} na {roky}',
        sporitVysledek: 'Modelovo za {roky} {hodnota} z {cil}',
        bezVlastnich: 'Vlastné zdroje nie sú potrebné — celú cenu pokryje úver.',
        schodek: 'Od {rok} chýba v rozpočte {castka} mesačne.',
      },
      k6: {
        nadpis: 'Renta',
        nazev: 'Finančná nezávislosť',
        podnadpis: '{castka} mesačne v dnešných cenách · od {rok}',
        kapital: 'Potrebný kapitál',
        kapitalPozn: 'čerpanie 4 % ročne, nekonečná renta',
        planDava: 'Plán dáva modelovo',
        pasmo: '{od} – {do}',
        pasmoPozn: 'horší až lepší scenár',
        poPoplatcichCastka: 'po poplatkoch {castka}',
        poPoplatcichPct: 'po poplatkoch {pct} %',
        dnes: 'dnes',
        zdrojRadek: '{popis} · {kdy}',
        zdrojVek: '{rok}, v {vek}',
        mesicneOdDneska: 'Mesačne odo dneška',
        mesicnePopo: 'Mesačne {kroky}',
        mesicneOd: 'Mesačne od {rok}',
        az: 'až {castka}',
        zdrojeDoRenty: 'Stavebné sporenie a dôchodkové sporenie do renty',
        ano: 'áno',
        ne: 'nie',
        doCeho: 'Do čoho investujeme',
        rentier: 'Rentiérske portfólio: akcie {akcie} % · dlhopisy {dluhopisy} % · hotovosť {cash} %. Drží sa aj pri čerpaní renty.',
        bezRenty: 'Renta zatiaľ v analýze zadaná nie je.',
      },
      graf: {
        vlozeno: 'Vložené',
        modelove: 'Modelovo',
        poPoplatcich: 'Po poplatkoch',
        pasmo: 'horší až lepší scenár',
        pasmoBublina: 'Horší – lepší scenár',
        cil: 'Cieľ {castka}',
        kapital: 'Kapitál {castka}',
        aria: '{nazev}: modelovo {hodnota} v roku {rok} z {cil}, v horšom scenári {od}, v lepšom {do}, po poplatkoch {po}. Modelácia, nie záruka.',
        vetaRoku: 'Vložené {vlozeno} · modelovo {hodnota} · po poplatkoch {po}',
        dnes: 'dnes',
      },
      letOne: '{n} rok',
      letFew: '{n} roky',
      letMany: '{n} rokov',
    },
    kroky79: {
      k7: {
        sPlanem: 'S plánom',
        naUctu: 'Na sporiacom účte',
        poPoplatcich: 'po poplatkoch',
        pasmo: 'horší až lepší scenár',
        pasmoBublina: 'Horší – lepší scenár',
        veta: 'Rovnaké peniaze, rovnaké ciele: o {roky} modelovo {sPlanem} s plánom (v horšom scenári {horsi}), {naUctu} na sporiacom účte.',
        vetaSPoplatky: 'Rovnaké peniaze, rovnaké ciele: o {roky} modelovo {sPlanem} s plánom pred poplatkami ({poPoplatcich} po poplatkoch, v horšom scenári {horsi}), {naUctu} na sporiacom účte.',
        vetaUcet: 'Na sporiacom účte = tie isté peniaze v rovnaký deň, sadzba sporiaceho účtu {sazba} % ročne nad infláciu (v dnešných cenách).',
        chybiNaUctu: 'Na sporiacom účte by v roku {rok} na „{cil}“ chýbalo {castka}.',
        vetaRoku: 'S plánom {sPlanem} · na sporiacom účte {naUctu}',
        aria: 'O {roky} modelovo {sPlanem} s plánom pred poplatkami, {poPoplatcich} po poplatkoch, v horšom scenári {horsi}, na sporiacom účte {naUctu}. Model, nie garancia.',
        dnes: 'dnes',
        schodek: 'Plánu po čerpaní úverov chýba {seznam} mesačne — najprv to vyriešime (krok 8).',
        schodekPrez: 'Plánu po čerpaní úverov chýba {seznam} mesačne — najprv to vyriešime.',
        postaru: 'Spočítané postaru — porovnanie sa ukáže po prepočte.',
        prepocitat: 'Prepočítať',
        bezCilu: 'Plán zatiaľ neposiela peniaze do žiadneho cieľa — nie je čo porovnať.',
        odklad: 'Čo stojí odklad',
        odkladUvod: 'Koľko mesačne treba na rentu {renta}:',
        odkladDnes: 'keď začnete dnes',
        odkladZa: 'keď začnete o {roky}',
        mesicneCastka: '{castka} mesačne',
      },
      k8: {
        mesicne: 'Mesačne',
        mesicneRozpad: 'ochrana {ochrana} (dnes {dnes}) · investície {investice}',
        mesicneBezCeny: 'investície {investice} · ochrana zatiaľ bez ceny',
        mesicneBezNove: 'investície {investice} · bez novej ochrany',
        bezNoveOchrany: 'bez novej ochrany',
        vicNezDnes: 'o {castka} viac ako dnes',
        orientacne: 'orientačne {castka} · odhad aplikácie, neodpočítava sa',
        jednorazove: 'Nové peniaze jednorazovo',
        presunyUvod: 'Presunieme z vašich úspor:',
        presun: '{odkud} → {kam}',
        vRoce: 'v roku {rok}',
        zaMesicu: 'o {n} mes.',
        odkud: {
          ucty: 'účty a stavebné sporenie',
          fondy: 'fondy',
          penzijko: 'dôchodkové sporenie',
          pritok: 'budúci príjem',
          dopocet: 'vklad navyše',
        },
        kam: {
          rezerva: 'rezerva',
          renta: 'renta',
        },
        vetaPrebytek: 'Z prebytku {prebytek} ide na plán {plan}, zostáva {zbyva}.',
        vetaPrebytekDrzi: 'Z prebytku {prebytek} ide na plán {plan}.',
        vetaNadPrebytek: 'Plán chce z prebytku {plan}, prebytok je {prebytek} — mesačne chýba {chybi}.',
        vetaDrzi: 'Zvyšných {castka} plán na ciele nepoužije: od roku {rok} ich zhltne splátka úveru „{uver}“.',
        schodek: 'Po čerpaní úverov chýba {seznam} mesačne.',
        schodekPolozka: 'od roku {rok} {castka}',
        stovka: 'Na voľné výdavky (mimo povinných) vám zostane {pct} % príjmu ({castka} mesačne) — odporúčame 20 až 30 %.',
        ochranaOsob: 'Ochrana osôb',
        cenaOsoby: '{jmeno} · mesačne',
        cenaDeti: 'Deti · mesačne',
        cenaPh: 'cena od poisťovne',
        pojistne: 'Poistné: dnes {dnes} → {nove}',
        pojistneRozdil: '({rozdil})',
        cenaNezadana: 'cena zatiaľ nezadaná',
        majetek: 'Majetok a zodpovednosť',
        smlouvyOne: '{n} zmluva',
        smlouvyFew: '{n} zmluvy',
        smlouvyMany: '{n} zmlúv',
        investice: 'Investície',
        poplatky: 'vstupný poplatok {vstupni} % · správa {sprava} % ročne',
        poplatkyNezadane: 'vstupný poplatok a správa: nezadané',
        mesicneCastka: '{castka} mesačne',
        rozdeleni: 'Rozdelenie prebytku',
        zUspor: 'Jednorazovo z úspor',
        zPrebytku: 'Mesačne z prebytku {prebytek}',
        ochranaRozdil: 'ochrana (rozdiel oproti dnešku)',
        zbyvaDnes: 'zostáva dnes',
        udalostSplatka: 'od roku {rok} · splátka úveru „{popis}“',
        udalostDoplaceno: 'v roku {rok} · splatené „{popis}“',
        udalostRenta: 'od roku {rok} · renta navyše',
        uvolniSe: 'uvoľní sa',
        cashflow: 'Cash flow v čase',
        cashflowAria: 'Graf cash flow plánu: dnes zostáva {dnes} mesačne, v najhoršom roku {nejhorsi}.',
        zmenitVDilne: 'Upraviť v Dielni',
      },
      k9: {
        tri: {
          zajistit: 'Zabezpečiť príjem a majetok',
          rezervaDluhy: 'Rezerva a drahé dlhy',
          investovat: 'Investovať',
        },
        ochrana: '{varianta} · {cena} mesačne',
        ochranaBezCeny: '{varianta} · cena zatiaľ nezadaná',
        ochranaBezNove: '{varianta} · bez novej ochrany',
        majetek: 'majetok {smlouvy}',
        majetekCena: 'majetok {smlouvy} · {cena} mesačne',
        rezerva: 'Rezerva {castka}',
        rezervaHotovo: 'Rezerva {castka} · hotovo',
        dluhy: 'splatiť úver {castka}',
        investice: '{castka} mesačne na ciele',
        investiceSchodek: 'Zatiaľ {castka} mesačne · od roku {rok} chýba {chybi}',
        chybiPodklad: 'chýba podklad',
        smysl: 'Dáva vám to zmysel?',
        citace: 'Na začiatku ste povedali: „{hodnoty}“',
        domluveno: 'Dohodnuté',
        ja: 'Ja (poradca)',
        vy: 'Vy',
        vyJmena: 'Vy ({jmena})',
        a: 'a',
      },
      doma: {
        tlacitko: 'Premyslíme si to doma',
        ukladam: 'Ukladám…',
        neulozeno: 'Plán sa nepodarilo uložiť. Skúste to prosím znova.',
        titul: 'Váš finančný plán',
        intro: 'Dobrý deň, posielam plán, ktorý sme spolu prešli. V pokoji si ho doma prejdite a dajte mi vedieť.',
      },
      snimek: {
        hero: 'Plán mesačne',
        heroBezCeny: 'Investície mesačne (ochrana zatiaľ bez ceny)',
        poPoplatcich: 'Po poplatkoch o {roky}',
        pro: 'Pre',
        prebytek: 'Prebytok',
        naPlan: 'Z prebytku na plán',
        presuny: 'Presuny z úspor',
        ochrana: 'Ochrana · {varianta}',
        investice: 'Investície mesačne',
        sPlanem: 'S plánom o {roky}',
        naUctu: 'Na sporiacom účte',
        garance: 'Model z vašich čísel, nie garancia.',
      },
    },
    ramec: {
      analyza: 'Analýza',
      zpetNaAnalyzu: 'Späť na analýzu',
      navrhDatum: 'Návrh riešenia · {datum}',
      klient: 'Klient',
      spojka: 'a',
      pasek: {
        popis: 'Mesačne',
        prebytek: 'Prebytok',
        plan: 'plán',
        splatky: 'splátky',
        zbyva: 'zostáva',
        chybi: 'chýba',
      },
      pohled: {
        skupina: 'Pohľad',
        dilna: 'Dielňa',
        plan: 'Plán',
        klient: 'Pre klienta',
      },
      kDoplneni: 'Na doplnenie: {n}',
      ulozeni: {
        neulozeno: 'Neuložené',
        uklada: 'Ukladám…',
        ulozeno: 'Uložené {cas}',
        chyba: 'Neuložené',
        offline: 'Offline',
        zkusitZnovu: 'Skúsiť znova',
        chybaText: 'Zmeny sa nepodarilo uložiť.',
      },
      prezentovat: 'Prezentovať',
      prezentovatBlokuje: 'Prezentovať zatiaľ nejde: {duvod}',
      zpetDoUprav: 'Späť do úprav',
      dalsiKrok: 'Ďalší krok',
      krokZ: 'Krok {n} z {z}',
      krokyPlanu: 'Kroky plánu',
      znacka: {
        chyba: 'chyba',
        pozor: 'pozor',
        info: 'chýba podklad',
      },
      nacitani: 'Načítavam návrh…',
      chybaNacteni: 'Návrh sa nepodarilo načítať.',
      bezPrijmu: {
        kroky: 'Kroky 3–9',
        veta: 'Bez príjmov plán nevypočíta — doplňte príjmy v analýze.',
        vetaNula: 'Prebytok je nulový alebo záporný — plán nemá z čoho platiť. Upravte výdavky alebo prebytok v analýze.',
        akce: 'Prejsť na príjmy',
      },
      dialogChybi: {
        nadpis: 'Klient uvidí, čo ešte chýba',
        dalsi: 'Ďalšie v Dielni: {n}',
        doplnit: 'Doplniť',
        prezentovat: 'Prezentovať aj tak',
        zrusit: 'Späť',
      },
      staryPlan: {
        veta: 'Vypočítané po starom ({datum})',
        vetaBezData: 'Vypočítané po starom',
        prepocitat: 'Prepočítať',
        coSeZmeni: 'Čo sa zmení',
      },
      offline: 'Offline · zmeny sa uložia po pripojení.',
      prezentace: {
        oblast: 'Prezentácia plánu',
        krokZ: 'krok {n} z {z}',
        cilZ: 'cieľ {n} z {z}',
        dalsi: 'Ďalej',
        predchozi: 'Späť',
        konec: 'Ukončiť prezentáciu',
        dokoncit: 'Dokončiť',
      },
      uvod: {
        nadpis: 'Váš finančný plán',
        veta: 'Prejdeme ho spolu krok za krokom.',
      },
      dveZpravy: {
        nadpis: 'Mám pre vás dve správy',
        dobraCile: 'Prvá je dobrá: [[vaše ciele sa podarí naplniť.]]',
        dobraPlan: 'Dobrá správa: [[máte plán.]]',
        lepsiCesta: 'Tá ešte lepšia: idete k nim [[bezpečnejšou cestou]].',
        lepsiDrive: 'Tá ešte lepšia: na rentu môžete prejsť [[už o {za}]] — o {o} skôr.',
        rentaNa: 'Renta je zatiaľ na [[{pct} %]] — a presne vidíme, čo s tým urobiť.',
        rentaNezadana: 'Cieľ renty zatiaľ nie je zadaný.',
      },
      dialogStary: {
        nadpis: 'Plán je vypočítaný po starom ({datum})',
        nadpisBezData: 'Plán je vypočítaný po starom',
        text: 'Starý výpočet zostáva, kým ho neprepočítate. Krok 7 sa v prezentácii ukáže až po prepočte.',
        postaru: 'Prezentovať po starom',
        prepocitat: 'Prepočítať a prezentovať',
        zrusit: 'Späť',
      },
    },
    kroky: {
      proc: 'Prečo',
      dnes: 'Kde ste dnes',
      zajisteni: 'Zabezpečenie',
      rezerva: 'Rezerva',
      cile: 'Ciele',
      renta: 'Renta',
      dveCesty: 'Dve cesty',
      kolik: 'Koľko to stojí',
      triKroky: 'Tri kroky',
    },
    zaklad: {
      krokCislo: 'Krok {n}',
      stitek: {
        nezadano: 'nezadané',
        navrh: 'návrh',
        postaru: 'vypočítané postaru',
        odhad: 'odhad',
        poplatky: 'poplatky nezadané',
      },
      model: {
        veta: 'Modelovo · {scenar} · v dnešných cenách · pred poplatkami',
        cara: 'bodkovaná čiara',
        scenar: {
          realisticky: 'realistický scenár',
          pesimisticky: 'pesimistický scenár',
          optimisticky: 'optimistický scenár',
        },
        garance: 'Model z vašich čísel, nie garancia.',
      },
      poplatky: {
        vychozi: 'po predvolenom poplatku za správu {sprava} %',
        zadane: 'po poplatkoch: vstupný {vstupni} %, správa {sprava} %',
        legenda: '{cara} = {popis}',
        legendaCastka: '{cara} = {popis}: {castka}',
      },
      nacitani: 'Načítavam čísla plánu…',
    },
  },
  /* BLOK:navrhV2 END */
  trychtyrBuilder: {
    title: "Lievik od A do Z",
    info: "Sedem krokov podľa metodiky Konverzky: magnet → stránka → ďakovačka → hovor → mini-webinár → e-maily → reklama a meranie. Šablóny vyplníš sám, nič negeneruje AI; ukladá sa na server pre teba.",
    krokN: "Krok {n}", hotovo: "Hotovo", rozpracovano: "Rozpracované", nezacato: "Nezačaté", postup: "Postup", hotovychKroku: "{h} z {n} hotovo",
    ulozit: "Uložiť", ukladam: "Ukladám…", ulozeno: "Uložené {cas}", ulozenoBezCasu: "Uložené", neulozeno: "Neuložené", ulozeniSelhalo: "Uloženie zlyhalo", zkusitZnovu: "Skúsiť znova",
    mistniKopie: "Server nedostupný — pracuješ s miestnou kópiou z tohto prehliadača. Uloženie skúsim znova.",
    nacitam: "Načítavam…", povinne: "povinné", vyber: "— vyber —",
    vlozitSablonu: "Vložiť šablónu", pouzitNavrh: "Použiť návrh do prázdnych polí", dosaditTitulek: "Dosadiť do titulku", pravidlaTitulku: "Pravidlá titulku",
    mojeOdkazy: "Moje odkazy na zdieľanie", nahledBezSlugu: "Zatiaľ len náhľad — pre ostrý odkaz si nastav odkaz vizitky v", nastaveni: "Nastavenia",
    otevrit: "Otvoriť", kopirovat: "Kopírovať", zkopirovano: "Skopírované", kopieSelhala: "Kopírovanie zlyhalo", tisk: "Tlač / PDF", tiskSelhal: "Tlač sa nepodarilo otvoriť",
    zasady: "6 zásad obchodného systému", krokyHovoru: "9 krokov hovoru", beaty: "Scenár beat po beate (poradie je záväzné)",
    emailyOblouk: "Oteplovací oblúk — 6 dní + doručenie", emailyNoBooking: "Keď si po dopyte nerezervuje termín", emailySekvence: "E-mailová sekvencia",
    den: "Deň", cil: "Cieľ", predmet: "Predmet", nahledRadek: "Náhľadový riadok", telo: "Text", ctaTlacitko: "Text odkazu (CTA)", testPraveRuky: "Test pravej ruky", kopirovatSekvenci: "Kopírovať celú sekvenciu",
    uhly: "Reklamné uhly — reklama predáva preklik", kanaly: "Kanály a nastavenie", navodMereni: "Meranie krok za krokom", otevritNastaveni: "Nastavenie webu → Meranie", idNastaveno: "ID nastavené", idChybi: "ID chýba", format: "formát",
    checklist: "Kontrola pred spustením", predchozi: "Predchádzajúci", dalsi: "Ďalší krok",
  },
};

export default sk;
